(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./": [
		1529,
		529
	],
	"./alamo": [
		9523,
		523
	],
	"./alamo.tsx": [
		9523,
		523
	],
	"./avis": [
		4885,
		885
	],
	"./avis.tsx": [
		4885,
		885
	],
	"./bm": [
		6646
	],
	"./bm.tsx": [
		6646
	],
	"./bmInverted": [
		1228,
		228
	],
	"./bmInverted.tsx": [
		1228,
		228
	],
	"./budget": [
		9119,
		119
	],
	"./budget.tsx": [
		9119,
		119
	],
	"./cg": [
		670
	],
	"./cg.tsx": [
		670
	],
	"./cgInverted": [
		3593,
		593
	],
	"./cgInverted.tsx": [
		3593,
		593
	],
	"./enterprise": [
		874,
		874
	],
	"./enterprise.tsx": [
		874,
		874
	],
	"./europcar": [
		6266,
		266
	],
	"./europcar.tsx": [
		6266,
		266
	],
	"./floyt": [
		5356
	],
	"./floyt.tsx": [
		5356
	],
	"./hertz": [
		666,
		666
	],
	"./hertz.tsx": [
		666,
		666
	],
	"./index": [
		1529,
		529
	],
	"./index.ts": [
		1529,
		529
	],
	"./rentalcars": [
		3743,
		743
	],
	"./rentalcars.tsx": [
		3743,
		743
	],
	"./topdeal": [
		7761,
		761
	],
	"./topdeal.tsx": [
		7761,
		761
	],
	"./trustpilot": [
		649,
		649
	],
	"./trustpilot.tsx": [
		649,
		649
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 634;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 2589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


var marks_1 = __importDefault(marks);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

/**
 * Returns the text value of a rich text document.
 *
 * NB: This can be applied to non text node of a structured text document,
 * hence the flexible typing.
 */
function documentToPlainTextString(rootNode, blockDivisor) {
    if (blockDivisor === void 0) { blockDivisor = ' '; }
    if (!rootNode || !rootNode.content) {
        /**
         * Handles edge cases, such as when the value is not set in the CMA or the
         * field has not been properly validated, e.g. because of a user extension.
         * Note that we are nevertheless strictly type-casting `rootNode` as
         * Block | Inline. Valid rich text documents (and their branch block nodes)
         * should never lack a Node[] `content` property.
         */
        return '';
    }
    /**
     * Algorithm notes: We only want to apply spacing when a node is part of a
     * sequence. This is tricky because nodes can often be deeply nested within
     * non-semantic content arrays. For example, to get the text value of an
     * unordered list, we have to traverse like so:
     *
     * {
     *   nodeType: BLOCKS.UL_LIST,
     *   data: {},
     *   content: [
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'List ', marks: [] },
     *           { nodeType: 'text', data: {}, value: 'item', marks: [{ type: 'bold' }] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.HR,
     *         data: {},
     *         content: [],
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data:
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Yet another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *   }]
     * }
     *
     * We want there to be a space between 'List item' and 'Another list item' (to
     * denote a visual line break, which conventionally appears between non-text
     * node sequences) but not a redundant space between 'List ' and 'item'.
     * Moreover, we want just a _singular_ space between 'Another list item' and
     * 'Yet another list item' - the non-semantic HR between the two nodes should
     * not denote an additional space.
     */
    return rootNode.content.reduce(function (acc, node, i) {
        var nodeTextValue;
        if (dist_1.isText(node)) {
            nodeTextValue = node.value;
        }
        else if (dist_1.isBlock(node) || dist_1.isInline(node)) {
            nodeTextValue = documentToPlainTextString(node, blockDivisor);
            if (!nodeTextValue.length) {
                return acc;
            }
        }
        var nextNode = rootNode.content[i + 1];
        var isNextNodeBlock = nextNode && dist_1.isBlock(nextNode);
        var divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}

exports.a = documentToPlainTextString;
//# sourceMappingURL=rich-text-plain-text-renderer.es5.js.map


/***/ }),

/***/ 204:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(2784);
var React__default = _interopDefault(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


var marks_1 = __importDefault(marks);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

function appendKeyToValidElement(element, key) {
    if (React.isValidElement(element) && element.key === null) {
        return React.cloneElement(element, { key: key });
    }
    return element;
}

function nodeListToReactComponents(nodes, options) {
    return nodes.map(function (node, index) {
        return appendKeyToValidElement(nodeToReactComponent(node, options), index);
    });
}
function nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText;
    if (dist_1.isText(node)) {
        return node.marks.reduce(function (value, mark) {
            if (!renderMark[mark.type]) {
                return value;
            }
            return renderMark[mark.type](value);
        }, renderText ? renderText(node.value) : node.value);
    }
    else {
        var children = nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) {
            return React__default.createElement(React__default.Fragment, null, children);
        }
        return renderNode[node.nodeType](node, children);
    }
}

var _a, _b;
var defaultNodeRenderers = (_a = {},
    _a[dist_5.DOCUMENT] = function (node, children) { return children; },
    _a[dist_5.PARAGRAPH] = function (node, children) { return React__default.createElement("p", null, children); },
    _a[dist_5.HEADING_1] = function (node, children) { return React__default.createElement("h1", null, children); },
    _a[dist_5.HEADING_2] = function (node, children) { return React__default.createElement("h2", null, children); },
    _a[dist_5.HEADING_3] = function (node, children) { return React__default.createElement("h3", null, children); },
    _a[dist_5.HEADING_4] = function (node, children) { return React__default.createElement("h4", null, children); },
    _a[dist_5.HEADING_5] = function (node, children) { return React__default.createElement("h5", null, children); },
    _a[dist_5.HEADING_6] = function (node, children) { return React__default.createElement("h6", null, children); },
    _a[dist_5.EMBEDDED_ENTRY] = function (node, children) { return React__default.createElement("div", null, children); },
    _a[dist_5.UL_LIST] = function (node, children) { return React__default.createElement("ul", null, children); },
    _a[dist_5.OL_LIST] = function (node, children) { return React__default.createElement("ol", null, children); },
    _a[dist_5.LIST_ITEM] = function (node, children) { return React__default.createElement("li", null, children); },
    _a[dist_5.QUOTE] = function (node, children) { return React__default.createElement("blockquote", null, children); },
    _a[dist_5.HR] = function () { return React__default.createElement("hr", null); },
    _a[dist_5.TABLE] = function (node, children) { return (React__default.createElement("table", null,
        React__default.createElement("tbody", null, children))); },
    _a[dist_5.TABLE_ROW] = function (node, children) { return React__default.createElement("tr", null, children); },
    _a[dist_5.TABLE_HEADER_CELL] = function (node, children) { return React__default.createElement("th", null, children); },
    _a[dist_5.TABLE_CELL] = function (node, children) { return React__default.createElement("td", null, children); },
    _a[dist_4.ASSET_HYPERLINK] = function (node) { return defaultInline(dist_4.ASSET_HYPERLINK, node); },
    _a[dist_4.ENTRY_HYPERLINK] = function (node) { return defaultInline(dist_4.ENTRY_HYPERLINK, node); },
    _a[dist_4.EMBEDDED_ENTRY] = function (node) { return defaultInline(dist_4.EMBEDDED_ENTRY, node); },
    _a[dist_4.HYPERLINK] = function (node, children) { return React__default.createElement("a", { href: node.data.uri }, children); },
    _a);
var defaultMarkRenderers = (_b = {},
    _b[dist_3.BOLD] = function (text) { return React__default.createElement("b", null, text); },
    _b[dist_3.ITALIC] = function (text) { return React__default.createElement("i", null, text); },
    _b[dist_3.UNDERLINE] = function (text) { return React__default.createElement("u", null, text); },
    _b[dist_3.CODE] = function (text) { return React__default.createElement("code", null, text); },
    _b[dist_3.SUPERSCRIPT] = function (text) { return React__default.createElement("sup", null, text); },
    _b[dist_3.SUBSCRIPT] = function (text) { return React__default.createElement("sub", null, text); },
    _b);
function defaultInline(type, node) {
    return (React__default.createElement("span", { key: node.data.target.sys.id },
        "type: ",
        node.nodeType,
        " id: ",
        node.data.target.sys.id));
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */
function documentToReactComponents(richTextDocument, options) {
    if (options === void 0) { options = {}; }
    if (!richTextDocument) {
        return null;
    }
    return nodeToReactComponent(richTextDocument, {
        renderNode: __assign(__assign({}, defaultNodeRenderers), options.renderNode),
        renderMark: __assign(__assign({}, defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
    });
}

exports.h = documentToReactComponents;
//# sourceMappingURL=rich-text-react-renderer.es5.js.map


/***/ }),

/***/ 121:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));
//# sourceMappingURL=blocks.js.map

/***/ }),

/***/ 2233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var blocks_1 = __webpack_require__(121);
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks_1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks_1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports["default"] = EMPTY_DOCUMENT;
//# sourceMappingURL=emptyDocument.js.map

/***/ }),

/***/ 9186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isText = exports.isBlock = exports.isInline = void 0;
var blocks_1 = __webpack_require__(121);
var inlines_1 = __webpack_require__(3802);
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines_1.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks_1.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 2562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
var blocks_1 = __webpack_require__(121);
Object.defineProperty(exports, "BLOCKS", ({ enumerable: true, get: function () { return blocks_1.BLOCKS; } }));
var inlines_1 = __webpack_require__(3802);
Object.defineProperty(exports, "INLINES", ({ enumerable: true, get: function () { return inlines_1.INLINES; } }));
var marks_1 = __webpack_require__(5931);
Object.defineProperty(exports, "MARKS", ({ enumerable: true, get: function () { return __importDefault(marks_1).default; } }));
__exportStar(__webpack_require__(7904), exports);
__exportStar(__webpack_require__(4335), exports);
__exportStar(__webpack_require__(5972), exports);
var emptyDocument_1 = __webpack_require__(2233);
Object.defineProperty(exports, "EMPTY_DOCUMENT", ({ enumerable: true, get: function () { return __importDefault(emptyDocument_1).default; } }));
var helpers = __importStar(__webpack_require__(9186));
exports.helpers = helpers;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3802:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));
//# sourceMappingURL=inlines.js.map

/***/ }),

/***/ 5931:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports["default"] = MARKS;
//# sourceMappingURL=marks.js.map

/***/ }),

/***/ 5972:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=nodeTypes.js.map

/***/ }),

/***/ 7904:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
var blocks_1 = __webpack_require__(121);
var inlines_1 = __webpack_require__(3802);
var marks_1 = __importDefault(__webpack_require__(5931));
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks_1.BLOCKS.TABLE,
    blocks_1.BLOCKS.TABLE_ROW,
    blocks_1.BLOCKS.TABLE_CELL,
    blocks_1.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks_1.BLOCKS.HR, blocks_1.BLOCKS.EMBEDDED_ENTRY, blocks_1.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks_1.BLOCKS.OL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.UL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks_1.BLOCKS.QUOTE] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE] = [blocks_1.BLOCKS.TABLE_ROW],
    _a[blocks_1.BLOCKS.TABLE_ROW] = [blocks_1.BLOCKS.TABLE_CELL, blocks_1.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks_1.BLOCKS.TABLE_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks_1.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks_1.BLOCKS.DOCUMENT,
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.LIST_ITEM,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    inlines_1.INLINES.HYPERLINK,
    inlines_1.INLINES.ENTRY_HYPERLINK,
    inlines_1.INLINES.ASSET_HYPERLINK,
    inlines_1.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];
//# sourceMappingURL=schemaConstraints.js.map

/***/ }),

/***/ 4335:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 2107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 9003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ murmur2; }
/* harmony export */ });
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}




/***/ }),

/***/ 6894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 7216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Emotion$1; },
  "T": function() { return /* binding */ ThemeContext; },
  "a": function() { return /* binding */ ThemeProvider; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ hasOwn; },
  "i": function() { return /* binding */ isBrowser; },
  "u": function() { return /* binding */ useTheme; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// UNUSED EXPORTS: C, _, b

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(2107);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};



// EXTERNAL MODULE: ../../node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(2792);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var emotion_serialize_browser_esm = __webpack_require__(6426);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(3036);
;// CONCATENATED MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js










var isBrowser = "object" !== 'undefined';
var hasOwn = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */react.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = (0,react.useContext)(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = (0,emotion_cache_browser_esm/* default */.Z)({
          key: 'css'
        });
        return /*#__PURE__*/react.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */react.createContext({});

if (false) {}

var useTheme = function useTheme() {
  return react.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = react.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/react.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwn.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(registeredStyles, undefined, react.useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react.createElement(WrappedComponent, newProps));
});

if (false) {}

var Emotion$1 = Emotion;




/***/ }),

/***/ 8165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement, jsx */
/* harmony import */ var _emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7216);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2792);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3036);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6426);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2107);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3463);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);












var pkg = {
	name: "@emotion/react",
	version: "11.11.4",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.3",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.2",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwn.call(props, 'css')) {
    // $FlowFixMe
    return React.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return React.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)([styles], undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));

  if (!_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.i) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 2903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ jsxs; },
/* harmony export */   "HY": function() { return /* binding */ Fragment; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7216);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2107);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3463);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6426);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3036);












var Fragment = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment;
function jsx(type, props, key) {
  if (!_dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}
function jsxs(type, props, key) {
  if (!_dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(_dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_43c6fea0_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}




/***/ }),

/***/ 6426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ serializeStyles; }
/* harmony export */ });
/* harmony import */ var _emotion_hash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9003);
/* harmony import */ var _emotion_unitless__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9409);
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6894);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (_emotion_unitless__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,_emotion_hash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 3036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 8730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newStyled; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(6894);
;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js + 1 modules
var emotion_element_43c6fea0_browser_esm = __webpack_require__(7216);
// EXTERNAL MODULE: ../../node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(2792);
// EXTERNAL MODULE: ../../node_modules/@emotion/hash/dist/emotion-hash.esm.js
var emotion_hash_esm = __webpack_require__(9003);
// EXTERNAL MODULE: ../../node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var emotion_unitless_esm = __webpack_require__(9409);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,emotion_hash_esm/* default */.Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react.useLayoutEffect;



;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var emotion_styled_base_browser_esm_ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_43c6fea0_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_43c6fea0_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});




/***/ }),

/***/ 9409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ unitlessKeys; }
/* harmony export */ });
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};




/***/ }),

/***/ 2792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 569:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Airport.tsx
var SvgAirport = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M22.22 1.83c.46.46.58 1.06.52 1.62a4.45 4.45 0 0 1-.57 1.6 14.3 14.3 0 0 1-2.37 3.03l-1.58 1.57.04.1 3.36 10.76c.14.44.02.92-.3 1.25l-.7.7c-.6.6-1.6.44-1.98-.3L15.2 15.6l-1.46-1.47a35.97 35.97 0 0 1-3.03 2.55c.22.08.4.27.46.51l.62 2.5c.1.42-.02.87-.33 1.18l-.43.43c-.54.54-1.44.47-1.88-.16l-1.4-1.95a.75.75 0 0 1-.13-.49c-.53.26-.87.43-1.16.53-.37.12-.65.12-.98.12h-.03a.75.75 0 0 1-.75-.75v-.03c0-.33 0-.6.12-.98.1-.28.27-.63.53-1.16a.75.75 0 0 1-.5-.13l-1.94-1.4a1.24 1.24 0 0 1-.16-1.88l.44-.43c.3-.31.75-.44 1.17-.33l2.5.62a.8.8 0 0 1 .52.46l.15-.2c.8-1.05 1.69-2.1 2.39-2.83l-.48-.5c-.32-.34-.59-.62-1.03-1C6.68 7.3 3.55 5.96 2.1 5.4a1.25 1.25 0 0 1-.43-2.05l.62-.63c.32-.32.8-.44 1.24-.3l10.78 3.36.09.04 1.57-1.58A14.3 14.3 0 0 1 19 1.88c.51-.28 1.06-.5 1.6-.56.56-.06 1.15.05 1.62.51Zm-5.19 9.01-2.23 2.23 1.5 1.5c.08.08.15.18.21.3l3.3 6.28.34-.34-3.12-9.97Zm-11.07 4.5.66-.98a.72.72 0 0 1-.13-.02l-2.35-.59-.1.11 1.69 1.21c.1.08.18.17.23.27Zm2.75 2.75c.1.05.2.13.26.23l1.22 1.7.1-.11-.58-2.35a.83.83 0 0 1-.02-.13l-.98.66ZM3.24 3.9 3 4.15c1.57.63 4.59 1.95 6.4 3.52a15.86 15.86 0 0 1 1.58 1.58l2.22-2.23L3.24 3.9Zm3.2 13.7.74-.36c.63-.31 1.7-1.05 2.82-1.91 1.11-.85 2.2-1.78 2.86-2.44L18.74 7a12.6 12.6 0 0 0 2.12-2.67c.23-.44.35-.8.38-1.05.03-.25-.03-.34-.08-.4-.06-.05-.15-.11-.4-.08a3 3 0 0 0-1.05.38 12.9 12.9 0 0 0-2.68 2.12l-5.87 5.88a32.2 32.2 0 0 0-2.44 2.86c-.86 1.12-1.6 2.2-1.91 2.81l-.37.75Z" }));
var Airport_default = SvgAirport;

module.exports = Airport_default;


/***/ }),

/***/ 1143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/ArrowDown.tsx
var SvgArrowDown = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M3.47 7.47a.75.75 0 0 1 1.06 0L12 14.94l7.47-7.47a.75.75 0 1 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-8-8a.75.75 0 0 1 0-1.06Z" }));
var ArrowDown_default = SvgArrowDown;

module.exports = ArrowDown_default;


/***/ }),

/***/ 4327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/ArrowLast.tsx
var SvgArrowLast = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M16.53 3.47a.75.75 0 0 1 0 1.06L9.06 12l7.47 7.47a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06l8-8a.75.75 0 0 1 1.06 0Z" }));
var ArrowLast_default = SvgArrowLast;

module.exports = ArrowLast_default;


/***/ }),

/***/ 5403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/ArrowNext.tsx
var SvgArrowNext = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.47 20.53a.75.75 0 0 1 0-1.06L14.94 12 7.47 4.53a.75.75 0 0 1 1.06-1.06l8 8a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06 0Z" }));
var ArrowNext_default = SvgArrowNext;

module.exports = ArrowNext_default;


/***/ }),

/***/ 1025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/ArrowUp.tsx
var SvgArrowUp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M20.53 16.53a.75.75 0 0 1-1.06 0L12 9.06l-7.47 7.47a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 0l8 8a.75.75 0 0 1 0 1.06Z" }));
var ArrowUp_default = SvgArrowUp;

module.exports = ArrowUp_default;


/***/ }),

/***/ 5241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Calendar.tsx
var SvgCalendar = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8 2.25a.75.75 0 0 1 .75.75v1.25h6.5V3a.75.75 0 0 1 1.5 0v1.25c.58.002 1.068.01 1.482.043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v6.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H7.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2V9.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.414-.033.902-.04 1.482-.043V3A.75.75 0 0 1 8 2.25Zm-.75 3.5c-.57.002-1.003.01-1.36.038-.453.037-.714.107-.911.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v.45h16.5V9.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207a18.26 18.26 0 0 0-1.359-.037V7a.75.75 0 0 1-1.5 0V5.75h-6.5V7a.75.75 0 0 1-1.5 0V5.75Zm13 6H3.75v4.45c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h8.4c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909v-4.45Z" }));
var Calendar_default = SvgCalendar;

module.exports = Calendar_default;


/***/ }),

/***/ 2690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Cancel24H.tsx
var SvgCancel24H = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 2.75A9.25 9.25 0 0 0 2.75 12a.75.75 0 0 1-1.5 0C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12c0 5.519-4.158 10.065-9.512 10.68a.75.75 0 1 1-.171-1.49A9.252 9.252 0 0 0 12 2.75Zm-1.194 3.56a.75.75 0 0 1 .918.531l1.433 5.348 3.928.804a.75.75 0 0 1-.301 1.47l-4.381-.897a.75.75 0 0 1-.575-.541l-1.553-5.796a.75.75 0 0 1 .53-.918ZM.076 21.092V22h4.906v-1.342H3.578c-.161 0-.351.011-.571.033-.22.014-.417.032-.593.054.38-.39.74-.783 1.076-1.18.336-.403.61-.803.823-1.2.22-.404.33-.797.33-1.18 0-.44-.1-.822-.297-1.146a1.945 1.945 0 0 0-.801-.769C3.2 15.09 2.799 15 2.338 15c-.498 0-.926.094-1.284.281A3.9 3.9 0 0 0 0 16.093l.878.854a3.47 3.47 0 0 1 .56-.486 1.15 1.15 0 0 1 .68-.217c.3 0 .538.09.713.27.183.174.275.43.275.769 0 .324-.128.678-.384 1.06-.256.375-.615.79-1.076 1.244-.453.448-.977.949-1.57 1.504Zm8.62-1.947H7.224l.922-1.493a29.163 29.163 0 0 0 .57-1.158h.044c-.007.216-.022.473-.044.768a16.19 16.19 0 0 0-.022.768v1.115Zm0 1.212V22h1.503v-1.645H11v-1.211h-.801V15.13H8.223l-2.546 4.133v1.092h3.018Z" }));
var Cancel24H_default = SvgCancel24H;

module.exports = Cancel24H_default;


/***/ }),

/***/ 1691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Checked.tsx
var SvgChecked = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm4.28 8.78a.75.75 0 1 0-1.06-1.06l-4.47 4.47-1.47-1.47a.75.75 0 0 0-1.06 1.06l1.823 1.824a1 1 0 0 0 1.414 0l4.823-4.824Z" }));
var Checked_default = SvgChecked;

module.exports = Checked_default;


/***/ }),

/***/ 8484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/CityStation.tsx
var SvgCityStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2 6.12a2 2 0 0 1 .95-1.7l4.5-2.77a2 2 0 0 1 2.1 0l4.5 2.76a2 2 0 0 1 .95 1.7v1.14h3.5c.69 0 1.25.56 1.25 1.25v1.75h1.75c.69 0 1.25.56 1.25 1.25v11h.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5H2V6.12Zm16.25 2.63H15v1.5h3.25v-1.5ZM13.5 22.5V6.12a.5.5 0 0 0-.24-.43l-4.5-2.77a.5.5 0 0 0-.52 0L3.74 5.7a.5.5 0 0 0-.24.43V22.5H7v-4c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v4h3.5ZM5 8.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2Zm0 5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2ZM9.5 8h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Zm0 5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Zm5.5-1.25V22.5h6.25V11.75H15ZM16.7 17h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5Zm-.5-3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1Z" }));
var CityStation_default = SvgCityStation;

module.exports = CityStation_default;


/***/ }),

/***/ 2530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Close.tsx
var SvgClose = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.813 5.813a.75.75 0 0 1 1.06 0L12 10.939l5.127-5.126a.75.75 0 0 1 1.06 1.06L13.061 12l5.126 5.127a.75.75 0 0 1-1.06 1.06L12 13.061l-5.127 5.126a.75.75 0 1 1-1.06-1.06L10.939 12 5.813 6.873a.75.75 0 0 1 0-1.06Z" }));
var Close_default = SvgClose;

module.exports = Close_default;


/***/ }),

/***/ 1257:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Comment.tsx
var SvgComment = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.768 2.25h8.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v5.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H9.684c-.654 0-.877.003-1.084.046-.199.04-.39.108-.571.2-.188.096-.364.233-.875.642l-2.409 1.926c-.188.15-.367.294-.522.396-.15.1-.402.25-.722.25-.38 0-.74-.173-.978-.47-.2-.25-.24-.542-.256-.72a7.815 7.815 0 0 1-.017-.655V7.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043ZM5.89 3.788c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v12.639l.081-.064 2.386-1.909.056-.045c.433-.347.733-.587 1.073-.76.301-.154.621-.267.952-.334.375-.077.759-.077 1.313-.077h6.59c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.056.038-1.909V7.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207-.462-.037-1.057-.038-1.909-.038H7.8c-.852 0-1.447 0-1.91.038ZM6.25 8.5A.75.75 0 0 1 7 7.75h5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z" }));
var Comment_default = SvgComment;

module.exports = Comment_default;


/***/ }),

/***/ 6637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/FloytCut.tsx
var SvgFloytCut = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M19.84 7.87c.18 0 .34.1.41.27 2.21 6-1.38 12.22-8.4 12.22H0v-3.41h11.77c5.16 0 6.57-5.28 4.19-8.62a.28.28 0 0 1 .21-.46h3.67ZM4.3 15.5a.45.45 0 0 1-.41-.27c-2.2-6 1.39-12.22 8.41-12.22L23.7 3h.3v3.42H12.38c-5.16 0-6.57 5.27-4.2 8.61.16.19.03.46-.2.46H4.3Z" }));
var FloytCut_default = SvgFloytCut;

module.exports = FloytCut_default;


/***/ }),

/***/ 8852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Help.tsx
var SvgHelp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25a10.75 10.75 0 1 0 0 21.5 10.75 10.75 0 0 0 0-21.5Zm-1.8 6.96c-.35.44-.5.94-.5 1.18a.75.75 0 0 1-1.5 0c0-.64.3-1.46.83-2.12A3.28 3.28 0 0 1 11.62 6a4 4 0 0 1 2.92 1.04c.66.66.94 1.53.94 2.35a3.2 3.2 0 0 1-1 2.41c-.26.25-.54.47-.78.66h-.01c-.26.2-.47.37-.66.55a2.3 2.3 0 0 0-.6.78c-.05.16-.06.33-.06.8a.75.75 0 0 1-1.5 0v-.06c0-.4 0-.82.15-1.25.17-.47.49-.87.96-1.33.25-.26.54-.47.78-.66l.01-.01c.26-.2.47-.36.65-.55.33-.32.56-.7.56-1.34 0-.5-.17-.95-.5-1.28-.33-.33-.9-.61-1.86-.61-.62 0-1.08.3-1.42.71Zm2.32 8.76c0 .49-.4.88-.9.88a.89.89 0 0 1-.88-.88.89.89 0 0 1 1.78 0Z" }));
var Help_default = SvgHelp;

module.exports = Help_default;


/***/ }),

/***/ 8364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Hide.tsx
var SvgHide = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.53 2.47a.75.75 0 0 0-1.06 1.06l16.5 16.5a.75.75 0 1 0 1.06-1.06L5.53 2.47Zm5.357 3.357A8.11 8.11 0 0 1 12 5.75c2.365 0 4.349 1.026 5.906 2.305 1.559 1.28 2.646 2.782 3.195 3.637.075.117.107.168.128.208a.165.165 0 0 1 .018.043l.001.01a.54.54 0 0 1 0 .094l-.001.01a.165.165 0 0 1-.018.043c-.021.04-.053.091-.128.208-.28.436-.703 1.045-1.261 1.71a.75.75 0 0 0 1.148.964 18.244 18.244 0 0 0 1.375-1.864l.023-.035c.12-.187.254-.395.323-.69a1.89 1.89 0 0 0 0-.787c-.069-.294-.203-.502-.323-.69l-.023-.034c-.595-.927-1.78-2.57-3.505-3.986C17.131 5.476 14.821 4.25 12 4.25a9.61 9.61 0 0 0-1.319.09.75.75 0 0 0 .206 1.487ZM6.455 7.769a.75.75 0 1 0-.91-1.193C3.6 8.06 2.275 9.886 1.637 10.882l-.023.035c-.12.187-.254.395-.323.69-.055.236-.055.55 0 .787.069.294.203.502.323.69l.023.034c.594.927 1.78 2.57 3.505 3.986C6.869 18.524 9.179 19.75 12 19.75c1.915 0 3.598-.566 5.02-1.375a.75.75 0 0 0-.74-1.304c-1.242.705-2.671 1.179-4.28 1.179-2.365 0-4.349-1.026-5.906-2.305-1.559-1.28-2.646-2.782-3.195-3.637a3.298 3.298 0 0 1-.128-.208.165.165 0 0 1-.018-.043l-.001-.01a.508.508 0 0 1 .001-.104.166.166 0 0 1 .018-.043c.021-.04.053-.091.128-.208.591-.922 1.805-2.588 3.556-3.923Zm3.6 3.033a.75.75 0 1 0-1.261-.812A3.702 3.702 0 0 0 8.203 12c0 2.082 1.71 3.75 3.797 3.75.676 0 1.313-.175 1.865-.483a.75.75 0 0 0-.73-1.31A2.32 2.32 0 0 1 12 14.25c-1.28 0-2.297-1.018-2.297-2.25 0-.441.128-.851.352-1.198Z" }));
var Hide_default = SvgHide;

module.exports = Hide_default;


/***/ }),

/***/ 1647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Info.tsx
var SvgInfo = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12A9.25 9.25 0 0 1 12 2.75 9.25 9.25 0 0 1 21.25 12 9.25 9.25 0 0 1 12 21.25 9.25 9.25 0 0 1 2.75 12ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm.05 7.4a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9Zm-1.95 1.5a.75.75 0 0 1 .75-.75h1.35a.75.75 0 0 1 .694.465.751.751 0 0 1 .106.385v5.55h.85a.75.75 0 0 1 0 1.5h-3.1a.75.75 0 0 1 0-1.5h.75v-4.9h-.65a.75.75 0 0 1-.75-.75Z" }));
var Info_default = SvgInfo;

module.exports = Info_default;


/***/ }),

/***/ 4556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Like.tsx
var SvgLike = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.02 9.17c.6-.4 1.18-.88 1.45-1.15.45-.46.77-.88.97-1.34.2-.45.31-.97.31-1.63V2.41c0-.5.35-1.15 1.1-1.16a6.2 6.2 0 0 1 2.49.63 3.34 3.34 0 0 1 1.47 1.68c.3.65.44 1.38.44 1.99 0 .85-.24 1.53-.47 2.1l-.1.27c-.14.32-.25.6-.32.88H21c.74 0 1.43.36 1.9.84.49.49.85 1.17.85 1.91 0 2.36-.52 4.57-1.17 6.32a11.35 11.35 0 0 1-2.05 3.71c-.43.44-1.12.62-1.73.71-.65.1-1.41.14-2.17.14-.77 0-1.57-.04-2.29-.07h-.21c-.64-.03-1.2-.06-1.63-.06a8.6 8.6 0 0 1-4.03-1.15A2.25 2.25 0 0 1 6.5 22.3h-4c-1.24 0-2.25-1-2.25-2.25v-9c0-1.24 1-2.25 2.25-2.25h4c.71 0 1.35.33 1.76.85.22-.12.48-.29.76-.48Zm4.23-6.39v2.27a5.36 5.36 0 0 1-1.72 4.04 13.57 13.57 0 0 1-2.78 2v8.5l.14.08a7.45 7.45 0 0 0 3.61 1.13c.47 0 1.06.03 1.69.05l.22.01c.72.04 1.48.07 2.21.07.74 0 1.41-.04 1.95-.12.58-.1.83-.22.9-.29.39-.39 1.09-1.52 1.7-3.17a17 17 0 0 0 1.08-5.8c0-.26-.14-.57-.4-.84-.28-.27-.6-.41-.85-.41h-5c-.66 0-1.32-.56-1.2-1.36.09-.61.31-1.16.5-1.62l.09-.22a4 4 0 0 0 .36-1.55c0-.4-.1-.91-.31-1.38-.21-.48-.5-.8-.78-.95a5.09 5.09 0 0 0-1.41-.44ZM6.5 10.3h-4a.75.75 0 0 0-.75.75v9c0 .41.34.75.75.75h4c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-.75-.75ZM5 19.55a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" }));
var Like_default = SvgLike;

module.exports = Like_default;


/***/ }),

/***/ 4715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Locked.tsx
var SvgLocked = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.25 7.556C6.25 4.149 8.752 1.25 12 1.25s5.75 2.9 5.75 6.306v1.589c.35.065.675.17.982.343a3.937 3.937 0 0 1 1.623 1.797c.216.473.308.985.352 1.582.043.583.043 1.306.043 2.215v1.615c0 .908 0 1.63-.043 2.214-.044.596-.136 1.109-.352 1.582a3.937 3.937 0 0 1-1.623 1.796c-.451.256-.94.362-1.494.412-.534.049-1.193.049-2.003.049h-6.47c-.81 0-1.469 0-2.003-.049-.554-.05-1.043-.156-1.493-.412a3.937 3.937 0 0 1-1.624-1.796c-.216-.473-.308-.986-.352-1.582-.043-.583-.043-1.306-.043-2.215v-1.615c0-.908 0-1.63.043-2.214.044-.597.136-1.11.352-1.582A3.936 3.936 0 0 1 5.27 9.488c.306-.173.63-.278.981-.343v-1.59Zm1.5 1.476c.309-.004.646-.004 1.015-.004h6.47c.369 0 .706 0 1.015.004V7.556c0-2.73-1.975-4.806-4.25-4.806S7.75 4.825 7.75 7.556v1.476Zm-.853 1.538c-.447.04-.699.116-.89.224a2.437 2.437 0 0 0-.998 1.116c-.11.24-.182.551-.22 1.067-.039.522-.039 1.19-.039 2.134v1.556c0 .944 0 1.612.039 2.134.038.515.11.826.22 1.066.226.494.58.88.999 1.117.19.108.442.183.89.224.458.041 1.048.042 1.902.042h6.4c.854 0 1.444 0 1.903-.042.447-.04.698-.116.89-.224.418-.237.772-.623.998-1.117.11-.24.182-.55.22-1.066.039-.522.039-1.19.039-2.134V15.11c0-.945 0-1.612-.039-2.134-.038-.516-.11-.826-.22-1.067a2.437 2.437 0 0 0-.998-1.116c-.191-.108-.443-.183-.89-.224-.459-.042-1.05-.042-1.903-.042H8.8c-.854 0-1.444 0-1.903.042Zm6.072 6.18a2 2 0 1 0-1.938 0c-.02.08-.031.164-.031.25v1a1 1 0 1 0 2 0v-1c0-.086-.01-.17-.031-.25Z" }));
var Locked_default = SvgLocked;

module.exports = Locked_default;


/***/ }),

/***/ 3844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/MapView.tsx
var SvgMapView = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.646 1.339A.75.75 0 0 0 1.25 2v16c0 .284.16.544.415.67l6 3a.75.75 0 0 0 .63.02l6.657-2.854 6.676 3.815A.75.75 0 0 0 22.75 22V6a.75.75 0 0 0-.455-.69l-7-3a.75.75 0 0 0-.59 0L8.078 5.15 2.416 1.377a.75.75 0 0 0-.77-.037ZM8.75 6.495l5.5-2.358v13.369l-5.5 2.357V6.495Zm-1.5 13.291-4.5-2.25V3.402l4.5 3v13.386Zm8.5-2.221V4.137l5.5 2.358v14.213l-5.5-3.143Z" }));
var MapView_default = SvgMapView;

module.exports = MapView_default;


/***/ }),

/***/ 608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Menu.tsx
var SvgMenu = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.25 7c0-.41.34-.75.75-.75h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 7Zm0 5c0-.41.34-.75.75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM3 16.25h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5Z" }));
var Menu_default = SvgMenu;

module.exports = Menu_default;


/***/ }),

/***/ 4689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Phone.tsx
var SvgPhone = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m5.198 2.539-.09.048-.126.076-.12.083-.126.099-.142.124-.17.16-.466.46-.46.463-.246.256a3.495 3.495 0 0 0-.534.713c-.28.5-.47 1.227-.468 1.8 0 .24.016.419.063.653l.06.257.085.32.054.191c.966 3.404 2.434 6.162 4.655 8.384 2.154 2.153 5.006 3.766 8.122 4.723l.634.185.372.1.182.043.164.03.084.012c.149.02.296.03.454.031.573.002 1.3-.188 1.8-.468.12-.067.232-.14.344-.224l.129-.1.128-.108.227-.21.452-.446.44-.442.235-.243a3.37 3.37 0 0 0 .434-.539l.093-.168a2.685 2.685 0 0 0 0-2.423l-.076-.14a2.05 2.05 0 0 0-.04-.066l-.092-.132-.114-.143-.148-.166-.306-.317-.775-.774-.21-.197-.111-.092-.165-.117a2.685 2.685 0 0 0-2.927 0 2.566 2.566 0 0 0-.35.277l-.22.212-.366.36a.275.275 0 0 1-.143.037l-.049-.007-.138-.063a13.376 13.376 0 0 1-3.674-2.608A13.392 13.392 0 0 1 9.151 9.17l-.267-.544a.275.275 0 0 1 .012-.148l.02-.04.358-.362c.25-.255.379-.4.491-.574a2.685 2.685 0 0 0 0-2.927l-.075-.109-.083-.106-.105-.12-.23-.24-.878-.872-.17-.16-.142-.124-.126-.1-.12-.082-.181-.107-.034-.017a2.685 2.685 0 0 0-2.423 0Zm1.617 1.283.153.069.072.046.085.065.175.157.38.372.585.586.164.175.058.072c.008.01.014.02.02.03.256.393.256.899 0 1.292l-.023.034-.074.088-.12.129-.435.44-.044.047-.114.142a1.761 1.761 0 0 0-.253 1.48l.029.09.036.092.088.19a14.876 14.876 0 0 0 2.9 4.085 14.893 14.893 0 0 0 3.678 2.697l.547.27.143.057.09.029a1.77 1.77 0 0 0 1.335-.16l.165-.108.122-.1.105-.1.383-.38.127-.118.088-.073a1.185 1.185 0 0 1 1.205-.093l.122.07.055.039.114.1.282.275.706.71.133.142.096.11.067.084.045.07.017.032c.17.336.17.733 0 1.07l-.049.081-.034.047-.096.115-.14.153-.197.202-.805.802-.188.176-.142.12-.044.033a1.69 1.69 0 0 1-.183.12 2.535 2.535 0 0 1-1.06.275 1.85 1.85 0 0 1-.254-.017l-.11-.018-.124-.027-.266-.07-.262-.073c-3.065-.87-5.871-2.411-7.94-4.48-1.922-1.922-3.235-4.306-4.134-7.261l-.183-.629-.069-.253-.046-.192-.028-.15-.014-.13-.004-.134c0-.313.122-.786.276-1.06l.035-.06.081-.12.106-.131.067-.076.167-.178.224-.228.632-.63.22-.211.151-.133.11-.08.056-.031c.294-.15.635-.168.94-.056Z" }));
var Phone_default = SvgPhone;

module.exports = Phone_default;


/***/ }),

/***/ 133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Search.tsx
var SvgSearch = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M10 3.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5ZM2.25 10a7.75 7.75 0 1 1 13.735 4.924l5.545 5.546a.75.75 0 1 1-1.06 1.06l-5.546-5.545A7.75 7.75 0 0 1 2.25 10Z" }));
var Search_default = SvgSearch;

module.exports = Search_default;


/***/ }),

/***/ 7849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Show.tsx
var SvgShow = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.094 8.055c-1.559 1.28-2.646 2.782-3.195 3.637a3.305 3.305 0 0 0-.128.208.166.166 0 0 0-.018.043l-.001.01a.508.508 0 0 0 .001.104c.003.011.006.02.018.043.021.04.053.091.128.208.549.855 1.636 2.357 3.195 3.637C7.651 17.225 9.635 18.25 12 18.25c2.365 0 4.349-1.026 5.906-2.305 1.559-1.28 2.646-2.782 3.195-3.637.075-.117.107-.168.128-.208a.165.165 0 0 0 .018-.043l.001-.01a.54.54 0 0 0 0-.094l-.001-.01a.165.165 0 0 0-.018-.043 3.243 3.243 0 0 0-.128-.208c-.549-.855-1.636-2.357-3.195-3.637C16.349 6.775 14.365 5.75 12 5.75c-2.365 0-4.349 1.026-5.906 2.305Zm-.952-1.16C6.869 5.478 9.179 4.25 12 4.25c2.821 0 5.131 1.227 6.858 2.646 1.725 1.417 2.91 3.059 3.505 3.986l.023.035c.12.187.254.395.323.69.055.236.055.55 0 .787-.069.294-.203.502-.323.69l-.023.034c-.595.927-1.78 2.57-3.505 3.986-1.727 1.42-4.037 2.646-6.858 2.646-2.821 0-5.131-1.227-6.858-2.646-1.725-1.417-2.91-3.059-3.505-3.986l-.023-.035c-.12-.187-.254-.395-.323-.69a1.893 1.893 0 0 1 0-.787c.069-.294.203-.502.323-.69l.023-.034c.594-.927 1.78-2.57 3.505-3.986ZM12 9.75c-1.28 0-2.297 1.018-2.297 2.25S10.72 14.25 12 14.25c1.28 0 2.297-1.018 2.297-2.25S13.28 9.75 12 9.75ZM8.203 12c0-2.082 1.71-3.75 3.797-3.75 2.086 0 3.797 1.668 3.797 3.75s-1.71 3.75-3.797 3.75c-2.086 0-3.797-1.668-3.797-3.75Z" }));
var Show_default = SvgShow;

module.exports = Show_default;


/***/ }),

/***/ 8068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/StarEmpty.tsx
var SvgStarEmpty = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.462 2.001a1.25 1.25 0 0 1 1.076 0c.284.136.447.374.54.526.096.156.195.357.299.568l2.2 4.456.011.024.026.004 4.92.719c.233.034.455.066.633.109.173.042.45.123.666.352.26.273.381.65.332 1.023-.041.312-.218.54-.333.676-.119.139-.28.295-.448.46l-3.56 3.466-.018.018.004.026.84 4.896c.04.232.078.453.092.635.014.178.023.467-.128.744-.18.33-.5.563-.87.632-.31.057-.582-.04-.746-.108-.169-.07-.368-.175-.576-.284l-4.399-2.313-.023-.013-.023.013-4.399 2.313c-.208.11-.407.214-.576.284-.164.068-.436.165-.746.108a1.25 1.25 0 0 1-.87-.633c-.15-.276-.142-.565-.128-.743.014-.181.052-.403.092-.635l.84-4.896.004-.026a5.183 5.183 0 0 1-.019-.018l-3.538-3.446a7.593 7.593 0 0 1-.469-.48c-.115-.135-.292-.364-.333-.676a1.25 1.25 0 0 1 .332-1.023c.216-.229.493-.31.666-.352.178-.043.4-.075.632-.11l.03-.003 4.89-.715.027-.004.011-.024 2.2-4.456a7.62 7.62 0 0 1 .299-.568c.093-.152.256-.39.54-.526ZM12 3.695a87.2 87.2 0 0 0-.045.09L9.77 8.215l-.015.03c-.05.102-.132.27-.26.41a1.25 1.25 0 0 1-.389.282c-.172.08-.357.106-.47.121l-.032.005-4.891.715-.1.014.072.071 3.538 3.446.023.023c.082.079.218.21.31.375.079.141.13.296.149.457a1.653 1.653 0 0 1-.036.518l-.835 4.867-.017.1.09-.047 4.373-2.3.028-.015c.1-.054.267-.142.452-.179.16-.03.323-.03.482 0 .186.037.351.125.452.179l.029.015 4.372 2.3.09.047-.017-.1-.835-4.867a1.655 1.655 0 0 1-.036-.517c.02-.162.07-.317.15-.458.091-.166.227-.296.309-.375l.023-.023 3.538-3.446.073-.07-.1-.015-4.892-.715a6.223 6.223 0 0 0-.032-.005 1.649 1.649 0 0 1-.47-.121 1.25 1.25 0 0 1-.389-.283 1.654 1.654 0 0 1-.26-.41l-.014-.029-2.187-4.43-.045-.09Z" }));
var StarEmpty_default = SvgStarEmpty;

module.exports = StarEmpty_default;


/***/ }),

/***/ 667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/StationMarker.tsx
var SvgStationMarker = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.75 10c0-2.07.605-3.89 1.671-5.179C8.475 3.547 10.013 2.75 12 2.75c1.987 0 3.525.797 4.579 2.071C17.645 6.11 18.25 7.931 18.25 10c0 3.888-2.516 7.143-6.25 10.935C8.266 17.143 5.75 13.888 5.75 10ZM12 1.25c-2.431 0-4.394.994-5.735 2.615C4.936 5.472 4.25 7.651 4.25 10c0 4.768 3.244 8.554 7.22 12.53a.75.75 0 0 0 1.06 0c3.976-3.976 7.22-7.763 7.22-12.53 0-2.349-.686-4.528-2.015-6.135C16.394 2.244 14.43 1.25 12 1.25Zm0 12.25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm2-3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }));
var StationMarker_default = SvgStationMarker;

module.exports = StationMarker_default;


/***/ }),

/***/ 6006:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Tipp.tsx
var SvgTipp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 .22c.43 0 .78.35.78.78v2a.78.78 0 0 1-1.56 0V1c0-.43.35-.78.78-.78Zm3.25 18.61a.94.94 0 0 1-.55.17H9.3a.94.94 0 0 1-.55-.17C6.63 17.33 5 14.61 5 12a7 7 0 1 1 14 0c0 2.6-1.63 5.33-3.75 6.83ZM12 6.5A5.5 5.5 0 0 0 6.5 12c0 1.99 1.25 4.21 2.97 5.5h5.06c1.72-1.29 2.97-3.52 2.97-5.5A5.5 5.5 0 0 0 12 6.5ZM9.5 20h5c.28 0 .5.22.5.5V22a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1.5c0-.28.22-.5.5-.5Zm1 1.5v.5c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-.5h-3ZM1 11.22h2a.78.78 0 1 1 0 1.56H1a.78.78 0 0 1 0-1.56Zm20 0h2a.78.78 0 1 1 0 1.56h-2a.78.78 0 0 1 0-1.56ZM2.55 2.55c.3-.3.8-.3 1.1 0l2.47 2.48a.78.78 0 1 1-1.1 1.1L2.56 3.64c-.3-.3-.3-.8 0-1.1Zm16.42 15.32 2.48 2.48a.78.78 0 0 1-1.1 1.1l-2.47-2.48a.77.77 0 1 1 1.1-1.1ZM2.55 21.45c-.3-.3-.3-.8 0-1.1l2.48-2.48a.77.77 0 1 1 1.1 1.1l-2.48 2.48c-.3.3-.8.3-1.1 0ZM17.88 5.03l2.47-2.48a.77.77 0 1 1 1.1 1.1l-2.48 2.47a.78.78 0 0 1-1.1-1.1Z" }));
var Tipp_default = SvgTipp;

module.exports = Tipp_default;


/***/ }),

/***/ 2534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/TrainStation.tsx
var SvgTrainStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.1 1.73c.42-.22.9-.38 1.37-.38h7.06a3 3 0 0 1 1.37.38c.42.22.84.52 1.22.85a6.23 6.23 0 0 1 1.72 2.35 55.94 55.94 0 0 1 1.7 6.42c.13.7.24 1.34.24 1.76v.07c0 1.28 0 3.25-1.09 4.77a4.5 4.5 0 0 1-1.42 1.18c-.52.3-1.12.57-1.78.8l2.99 2.5a.75.75 0 0 1-.96 1.15l-3.6-3a.76.76 0 0 1-.13-.14c-1.2.29-2.5.46-3.74.46-1.27 0-2.6-.18-3.83-.47a.76.76 0 0 1-.14.15l-3.6 3a.75.75 0 0 1-.96-1.16l3-2.5a11.2 11.2 0 0 1-1.77-.79 4.46 4.46 0 0 1-1.44-1.18c-1.09-1.52-1.09-3.5-1.09-4.77v-.07c0-.42.1-1.07.25-1.76a54.9 54.9 0 0 1 1.7-6.42c.28-.83.97-1.7 1.71-2.35.38-.33.8-.63 1.22-.85Zm1.37 1.12c-.15 0-.38.05-.68.2-.3.16-.61.38-.92.66a4.78 4.78 0 0 0-1.3 1.72 54.84 54.84 0 0 0-1.84 7.45l.52.68a8.23 8.23 0 0 0 .8.9c.23.2.45.4.79.57.4.22.98.41 1.88.41a.75.75 0 0 1 0 1.5 5.37 5.37 0 0 1-2.59-.58 5.67 5.67 0 0 1-1.11-.82l-.12-.1-.01-.01-.02-.02c.1.6.3 1.17.66 1.66.14.2.45.47.96.76.5.28 1.13.55 1.84.79 1.44.47 3.15.78 4.72.78 1.56 0 3.25-.31 4.66-.78a10 10 0 0 0 1.81-.79c.5-.29.8-.55.95-.76a4.1 4.1 0 0 0 .66-1.66l-.02.02h-.01l-.12.11c-.23.2-.6.54-1.11.82-.63.33-1.46.58-2.6.58a.75.75 0 1 1 0-1.5c.9 0 1.49-.2 1.89-.4.34-.19.56-.39.79-.59l.16-.14c.14-.13.38-.42.64-.75l.52-.68c-.03-.28-.1-.7-.2-1.24a51.8 51.8 0 0 0-.54-2.32 54.17 54.17 0 0 0-1.1-3.89 4.78 4.78 0 0 0-1.3-1.73 4.8 4.8 0 0 0-.92-.64 1.6 1.6 0 0 0-.68-.21H8.47Zm-.54 2.08a14.56 14.56 0 0 1 8.14 0c.5.15.86.55 1.02 1.04l1.2 3.7a.93.93 0 0 1-1.03 1.19 37.56 37.56 0 0 0-5.26-.58c-1.5 0-3.77.33-5.26.58a.93.93 0 0 1-1.03-1.2l1.2-3.7c.16-.48.52-.88 1.02-1.03Zm8.64 4.3-.9-2.8a.22.22 0 0 0-.04-.07 13.1 13.1 0 0 0-7.26 0l-.03.08-.91 2.79C8.85 9 10.67 8.78 12 8.78s3.15.23 4.57.45Z" }));
var TrainStation_default = SvgTrainStation;

module.exports = TrainStation_default;


/***/ }),

/***/ 6828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/User.tsx
var SvgUser = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.8 1.25a5.75 5.75 0 1 1 0 11.5 5.75 5.75 0 0 1 0-11.5ZM7.55 7a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 0 0-8.5 0Zm-1.36 4.65c.31.3.34.8.06 1.12a9 9 0 0 0-2.33 5.78c0 .64.85 1.23 2.31 1.66l.32.1.35.08.35.08c.07 0 .13.02.2.03l.38.08.4.06.42.06.43.05.22.03.46.04.47.03.48.03.25.01.5.02h1.07l.33-.01.39-.03.2-.02c.43-.03.8.29.83.73a.78.78 0 0 1-.7.85l-.44.03c-.35.03-.65.04-.9.04h-.83l-.54-.02-.52-.03-1.02-.07-.48-.05c-.4-.05-.8-.1-1.16-.16l-.44-.08c-3-.57-4.85-1.74-4.85-3.54 0-2.46 1.01-4.86 2.72-6.84a.74.74 0 0 1 1.07-.06Zm12.7.07c1.7 2 2.71 4.36 2.71 6.78 0 1.26-1.28 2.21-3.74 3.16a.75.75 0 0 1-.98-.47.8.8 0 0 1 .45-1.02l.2-.07.37-.15.34-.15.45-.22.27-.14.12-.06.22-.13.2-.13c.39-.26.58-.48.58-.61 0-2-.86-4.01-2.33-5.75a.82.82 0 0 1 .06-1.11.74.74 0 0 1 1.08.07Z" }));
var User_default = SvgUser;

module.exports = User_default;


/***/ }),

/***/ 7551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Warning.tsx
var SvgWarning = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.363 3.549 1.35 16.963l-.028.047c-.198.33-.396.663-.534.951-.14.294-.337.776-.275 1.353a2.438 2.438 0 0 0 1.023 1.732c.46.324.962.397 1.288.425.322.03.713.03 1.11.029h16.133c.396 0 .787 0 1.109-.029.326-.028.828-.101 1.288-.425.567-.4.947-1.027 1.023-1.732.062-.577-.135-1.059-.276-1.353-.137-.288-.336-.62-.533-.95l-.028-.048-8.014-13.414-.028-.047c-.197-.33-.395-.66-.583-.919-.196-.267-.518-.656-1.037-.88a2.503 2.503 0 0 0-1.979 0c-.518.224-.84.613-1.036.88-.189.259-.386.59-.583.919l-.028.047ZM2.637 17.732l8.014-13.414c.443-.741.664-1.112.953-1.237.252-.108.54-.108.792 0 .289.125.51.496.953 1.237l8.014 13.414c.444.744.667 1.116.634 1.422a.939.939 0 0 1-.396.666c-.256.18-.7.18-1.587.18H3.986c-.887 0-1.33 0-1.587-.18a.939.939 0 0 1-.396-.666c-.033-.306.19-.678.634-1.422ZM11.25 9a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-1.5 0V9ZM11 17a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z" }));
var Warning_default = SvgWarning;

module.exports = Warning_default;


/***/ }),

/***/ 3785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/World.tsx
var SvgWorld = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1 11.75A10.8 10.8 0 0 1 11.75 1 10.8 10.8 0 0 1 22.5 11.75 10.8 10.8 0 0 1 11.75 22.5 10.8 10.8 0 0 1 1 11.75Zm14 5.03c-2.16.24-4.34.24-6.5 0 .23 1.26.55 2.5.96 3.73.02.07.04.14.04.21 1.48.37 3.02.37 4.5 0 0-.07.02-.14.04-.2.4-1.23.73-2.48.96-3.74ZM2.78 9.5a9.26 9.26 0 0 0 0 4.5c.07 0 .14.02.21.04 1.23.41 2.47.73 3.73.96a29.19 29.19 0 0 1 0-6.5c-1.27.24-2.52.56-3.74.96a.65.65 0 0 1-.2.04Zm.72 6.27c0 .05 0 .1-.02.14A9.29 9.29 0 0 0 7.6 20l.14-.01c-.34-1.13-.6-2.28-.8-3.44-1.15-.2-2.3-.45-3.43-.79l-.01.01Zm16.6-8.01a9.29 9.29 0 0 0-4.36-4.36c.35 1.17.62 2.34.82 3.54 1.2.2 2.38.47 3.54.82Zm-3.32.74c.24 2.16.24 4.34 0 6.5a28.9 28.9 0 0 0 3.74-.96.76.76 0 0 1 .2-.04 9.26 9.26 0 0 0 0-4.5.78.78 0 0 1-.21-.04 27.23 27.23 0 0 0-3.73-.96Zm-1.04 11.6a9.3 9.3 0 0 0 4.28-4.19c-.02-.04-.02-.09-.02-.14a29.5 29.5 0 0 1-3.44.79c-.2 1.19-.47 2.37-.82 3.54ZM6.93 6.94c.2-1.16.45-2.3.79-3.44-.05 0-.1 0-.14-.02A9.3 9.3 0 0 0 3.4 7.76c1.17-.35 2.35-.62 3.54-.82h-.01Zm8.32 1.32c-2.33-.3-4.67-.3-7 0a28.1 28.1 0 0 0 0 6.98c2.33.3 4.67.3 7 0a28.1 28.1 0 0 0 0-6.98Zm-3.5-5.76c-.78 0-1.53.1-2.25.28a29.72 29.72 0 0 0-1 3.94c2.16-.24 4.34-.24 6.5 0-.23-1.26-.55-2.5-.96-3.73a.75.75 0 0 1-.04-.21 9.28 9.28 0 0 0-2.25-.28Z" }));
var World_default = SvgWorld;

module.exports = World_default;


/***/ }),

/***/ 7294:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/AddDriver.tsx
var SvgAddDriver = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.15 7a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0Zm4.25-5.75a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5ZM7.324 11.584a.75.75 0 0 1-.208 1.04c-1.346.898-2.437 2.553-2.79 3.613-.49 1.469-.45 2.224-.168 2.693.297.492 1.018.937 2.638 1.342 1.919.48 3.923.674 6.344.48a.75.75 0 1 1 .12 1.496c-2.58.206-4.747 0-6.828-.52-1.643-.411-2.922-.968-3.558-2.023-.651-1.078-.48-2.415.028-3.942.447-1.34 1.728-3.285 3.382-4.387a.75.75 0 0 1 1.04.208ZM14.25 17a.75.75 0 0 1 .75-.75h2.25V14a.75.75 0 0 1 1.5 0v2.25H21a.75.75 0 0 1 0 1.5h-2.25V20a.75.75 0 0 1-1.5 0v-2.25H15a.75.75 0 0 1-.75-.75Z" }));
var AddDriver_default = SvgAddDriver;
var SvgAddToCalendar = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.75 3a.75.75 0 0 0-1.5 0v1.25c-.58.002-1.068.01-1.481.043-.547.045-1.027.14-1.471.366a3.75 3.75 0 0 0-1.64 1.639c-.226.444-.32.924-.365 1.47-.043.531-.043 1.187-.043 2v6.464c0 .813 0 1.469.043 2 .045.546.14 1.026.366 1.47a3.75 3.75 0 0 0 1.639 1.64c.444.226.924.32 1.47.365.531.043 1.187.043 2 .043H13a.75.75 0 0 0 0-1.5H7.8c-.852 0-1.447 0-1.91-.038-.453-.038-.714-.107-.911-.207a2.25 2.25 0 0 1-.984-.983c-.1-.198-.17-.459-.207-.913-.037-.462-.038-1.057-.038-1.909v-4.45h16.5V13a.75.75 0 0 0 1.5 0V9.768c0-.813 0-1.469-.043-2-.045-.546-.14-1.026-.366-1.47a3.75 3.75 0 0 0-1.639-1.64c-.444-.226-.924-.32-1.47-.365a19.705 19.705 0 0 0-1.482-.043V3a.75.75 0 0 0-1.5 0v1.25h-6.5V3ZM5.89 5.788c.357-.029.79-.036 1.36-.037V7a.75.75 0 0 0 1.5 0V5.75h6.5V7a.75.75 0 0 0 1.5 0V5.75c.57.002 1.003.01 1.36.038.453.037.714.107.912.207.423.216.767.56.983.984.1.197.17.458.207.912.037.462.038 1.057.038 1.909v.45H3.75V9.8c0-.852 0-1.447.038-1.91.037-.453.107-.714.207-.911a2.25 2.25 0 0 1 .984-.984c.197-.1.458-.17.912-.207ZM16 18.25a.75.75 0 0 0 0 1.5h2.25V22a.75.75 0 0 0 1.5 0v-2.25H22a.75.75 0 0 0 0-1.5h-2.25V16a.75.75 0 0 0-1.5 0v2.25H16Z" }));
var AddToCalendar_default = SvgAddToCalendar;
var SvgAdd = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm-4.243 10a.75.75 0 0 0 0 1.5h3.493v3.493a.75.75 0 0 0 1.5 0V12.75h3.493a.75.75 0 0 0 0-1.5H12.75V7.757a.75.75 0 0 0-1.5 0v3.493H7.757Z" }));
var Add_default = SvgAdd;
var SvgAirConditioning = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.25 12a10.75 10.75 0 1 1 21.5 0 10.75 10.75 0 0 1-21.5 0ZM12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM5.25 14.89l1.84-5.87h1.59l1.84 5.87h-1.4l-.37-1.4H6.96l-.36 1.4H5.25Zm2.12-2.97-.14.54h1.25l-.13-.54c-.09-.3-.17-.6-.25-.94l-.23-.95h-.04a186.53 186.53 0 0 1-.46 1.89Zm9.2 3.08c-.38 0-.73-.07-1.06-.2a2.57 2.57 0 0 1-1.45-1.5 3.65 3.65 0 0 1-.22-1.3 3.18 3.18 0 0 1 .82-2.28 2.77 2.77 0 0 1 1.94-.81 2.65 2.65 0 0 1 1.78.77l-.7.85a2.83 2.83 0 0 0-.48-.34 1.25 1.25 0 0 0-1.13 0c-.17.09-.33.2-.46.37-.12.16-.23.36-.3.6-.08.23-.11.5-.11.79 0 .6.13 1.07.39 1.41.25.33.6.5 1.03.5.24 0 .45-.06.64-.16.2-.1.36-.24.5-.4l.7.83c-.49.58-1.12.87-1.9.87Zm-5.99 1.33 1.8-7.83h.87l-1.8 7.83h-.87Z" }));
var AirConditioning_default = SvgAirConditioning;
var SvgAirport = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M22.22 1.83c.46.46.58 1.06.52 1.62a4.45 4.45 0 0 1-.57 1.6 14.3 14.3 0 0 1-2.37 3.03l-1.58 1.57.04.1 3.36 10.76c.14.44.02.92-.3 1.25l-.7.7c-.6.6-1.6.44-1.98-.3L15.2 15.6l-1.46-1.47a35.97 35.97 0 0 1-3.03 2.55c.22.08.4.27.46.51l.62 2.5c.1.42-.02.87-.33 1.18l-.43.43c-.54.54-1.44.47-1.88-.16l-1.4-1.95a.75.75 0 0 1-.13-.49c-.53.26-.87.43-1.16.53-.37.12-.65.12-.98.12h-.03a.75.75 0 0 1-.75-.75v-.03c0-.33 0-.6.12-.98.1-.28.27-.63.53-1.16a.75.75 0 0 1-.5-.13l-1.94-1.4a1.24 1.24 0 0 1-.16-1.88l.44-.43c.3-.31.75-.44 1.17-.33l2.5.62a.8.8 0 0 1 .52.46l.15-.2c.8-1.05 1.69-2.1 2.39-2.83l-.48-.5c-.32-.34-.59-.62-1.03-1C6.68 7.3 3.55 5.96 2.1 5.4a1.25 1.25 0 0 1-.43-2.05l.62-.63c.32-.32.8-.44 1.24-.3l10.78 3.36.09.04 1.57-1.58A14.3 14.3 0 0 1 19 1.88c.51-.28 1.06-.5 1.6-.56.56-.06 1.15.05 1.62.51Zm-5.19 9.01-2.23 2.23 1.5 1.5c.08.08.15.18.21.3l3.3 6.28.34-.34-3.12-9.97Zm-11.07 4.5.66-.98a.72.72 0 0 1-.13-.02l-2.35-.59-.1.11 1.69 1.21c.1.08.18.17.23.27Zm2.75 2.75c.1.05.2.13.26.23l1.22 1.7.1-.11-.58-2.35a.83.83 0 0 1-.02-.13l-.98.66ZM3.24 3.9 3 4.15c1.57.63 4.59 1.95 6.4 3.52a15.86 15.86 0 0 1 1.58 1.58l2.22-2.23L3.24 3.9Zm3.2 13.7.74-.36c.63-.31 1.7-1.05 2.82-1.91 1.11-.85 2.2-1.78 2.86-2.44L18.74 7a12.6 12.6 0 0 0 2.12-2.67c.23-.44.35-.8.38-1.05.03-.25-.03-.34-.08-.4-.06-.05-.15-.11-.4-.08a3 3 0 0 0-1.05.38 12.9 12.9 0 0 0-2.68 2.12l-5.87 5.88a32.2 32.2 0 0 0-2.44 2.86c-.86 1.12-1.6 2.2-1.91 2.81l-.37.75Z" }));
var Airport_default = SvgAirport;
var SvgAndroid = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4.376 8.337C3.616 8.337 3 8.952 3 9.71v6.416a1.376 1.376 0 0 0 2.753 0V9.71c0-.759-.616-1.374-1.377-1.374Zm15.6 0c-.76 0-1.377.615-1.377 1.374v6.416a1.376 1.376 0 0 0 2.753 0V9.71c0-.759-.616-1.374-1.376-1.374Zm-2.753 0H7.129a.459.459 0 0 0-.459.458v7.332c0 1.088.767 2.027 1.836 2.245v3.253a1.376 1.376 0 0 0 2.752 0v-3.207h1.836v3.207a1.376 1.376 0 0 0 2.753 0v-3.253a2.292 2.292 0 0 0 1.835-2.245V8.795a.459.459 0 0 0-.459-.458Zm-1.23-7.208a.46.46 0 0 1 .637.659l-1.118 1.116a4.835 4.835 0 0 1 2.17 4.058.459.459 0 0 1-.459.458H7.129a.459.459 0 0 1-.459-.458 4.835 4.835 0 0 1 2.17-4.058L7.724 1.787a.458.458 0 0 1 .649-.648l1.303 1.302a6.287 6.287 0 0 1 5.003 0l1.303-1.301a.521.521 0 0 1 .012-.011ZM9.883 4.67a.459.459 0 1 0-.001.917.459.459 0 0 0 0-.917Zm4.587 0a.459.459 0 1 0 0 .917.459.459 0 0 0 0-.917Z" }));
var Android_default = SvgAndroid;
var SvgArrowBack = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.53 3.47a.75.75 0 0 1 0 1.06l-6.72 6.72H20a.75.75 0 0 1 0 1.5H5.81l6.72 6.72a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06l8-8a.75.75 0 0 1 1.06 0Z" }));
var ArrowBack_default = SvgArrowBack;
var SvgArrowDown = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M3.47 7.47a.75.75 0 0 1 1.06 0L12 14.94l7.47-7.47a.75.75 0 1 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-8-8a.75.75 0 0 1 0-1.06Z" }));
var ArrowDown_default = SvgArrowDown;
var SvgArrowForward = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.47 3.47a.75.75 0 0 0 0 1.06l6.72 6.72H4a.75.75 0 0 0 0 1.5h14.19l-6.72 6.72a.75.75 0 1 0 1.06 1.06l8-8a.75.75 0 0 0 0-1.06l-8-8a.75.75 0 0 0-1.06 0Z" }));
var ArrowForward_default = SvgArrowForward;
var SvgArrowLast = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M16.53 3.47a.75.75 0 0 1 0 1.06L9.06 12l7.47 7.47a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06l8-8a.75.75 0 0 1 1.06 0Z" }));
var ArrowLast_default = SvgArrowLast;
var SvgArrowNext = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.47 20.53a.75.75 0 0 1 0-1.06L14.94 12 7.47 4.53a.75.75 0 0 1 1.06-1.06l8 8a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06 0Z" }));
var ArrowNext_default = SvgArrowNext;
var SvgArrowUp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M20.53 16.53a.75.75 0 0 1-1.06 0L12 9.06l-7.47 7.47a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 0l8 8a.75.75 0 0 1 0 1.06Z" }));
var ArrowUp_default = SvgArrowUp;
var SvgAutomatic = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9 2.25c.41 0 .75.34.75.75v4h2.75a2.5 2.5 0 1 1 0 5H9.75v9a.75.75 0 0 1-1.5 0v-9H5.5a2.5 2.5 0 1 1 0-5h2.75V3c0-.41.34-.75.75-.75ZM4.5 9.5a1 1 0 0 0 1 1h7a1 1 0 0 0 0-2h-7a1 1 0 0 0-1 1ZM15 4.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75ZM17.75 9h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5ZM15 14.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm.75 4.25h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5Z" }));
var Automatic_default = SvgAutomatic;
var SvgBabySeat = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m2.97 12.33 4.53.17-3.3-6.25A2.26 2.26 0 0 1 8.14 4v.02l3.92 7.55 5.78-7.68c.77-1.01 2.22-1.37 3.27-.58.39.3.64.68.77 1.1.09.05.17.12.23.21l.01.02.04.05a14.27 14.27 0 0 1 .47.79c.24.44.57 1.14.57 1.78a83.15 83.15 0 0 1 .05 1.98c0 .4-.01.83-.06 1.21-.04.38-.13.78-.3 1.12a152.55 152.55 0 0 1-4.35 7.63 16.98 16.98 0 0 1-.9 1.29l-.19.16a.84.84 0 0 1-.48.16H5.13c-.42 0-.76-.23-1-.44a4.73 4.73 0 0 1-.72-.89 22.1 22.1 0 0 1-1.54-2.96 2.25 2.25 0 0 1 1.07-4.2h.03Zm5.8 2.96-.74-1.48-5.07.02a.73.73 0 0 0-.71.74c0 .42.33.74.7.74l5.83-.02ZM6.84 4.74a.76.76 0 0 0-1.31.78v.01l4.3 8.51c.4-.36.9-.62 1.46-.7l-4.45-8.6Zm6.96 9.53 6.47-8.56c.35-.47.23-.99-.05-1.2-.28-.21-.81-.19-1.17.28l-6.12 8.13a.77.77 0 0 1-.1.11l.35.68v.03c.24.15.45.33.62.53Zm-2.09.54a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm9.8-8.25a1.6 1.6 0 0 1-.04.05l-6.83 9.04a.76.76 0 0 1-.19.18l.01.23a2.75 2.75 0 0 1-5.4.73l-5.4.02c.39.8.72 1.4 1 1.84a3.32 3.32 0 0 0 .56.66h11.46l.03-.04.58-.87a153.95 153.95 0 0 0 4.28-7.5c.05-.1.1-.3.14-.62.04-.3.05-.66.05-1.03a26.91 26.91 0 0 0-.03-1.23l-.02-.76c0-.16-.08-.41-.2-.7Z" }));
var BabySeat_default = SvgBabySeat;
var SvgBmLogoOld = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M16.553 5.361c.27-.054.521 0 .758.163l.244.15 4.83 3.375c.718.516.765 1.113.359 1.724l-1.672 2.39-.15.216a993.319 993.319 0 0 0-1.572 2.25c-.217.326-.542.536-.847.577L3.9 18.786c-.075.014-.136.02-.217.02-.25 0-.501-.053-.704-.196-.265-.19-.42-.475-.481-.808l-1.477-8.4c-.054-.34 0-.652.183-.917.19-.265.474-.442.806-.503l4.423-.794-.047.088s-.203.394-.257.706l-.007.034-.034.007-2.412.414-1.571.286c-.115.013-.217.081-.312.19-.068.095-.088.197-.068.36l1.464 8.4c.013.115.08.217.19.312.094.068.162.088.358.068l14.584-2.58c.116-.02.21-.068.258-.136.034-.04 3.482-5.005 3.482-5.005a.479.479 0 0 0 .081-.36.431.431 0 0 0-.183-.292l-4.511-3.158-.481-.34c-.102-.067-.197-.094-.278-.08l-2.547.454-.305.055-.06-.102a1.52 1.52 0 0 0-.15-.238c-.054-.088-.101-.136-.156-.204-.02-.027-.04-.047-.067-.081l-.055-.061 2.277-.394.928-.17Zm-8.908 6.574c.684.427.914 1.534.894 2.43.007.435-.027 1.909-.894 2.432a1.21 1.21 0 0 1-.583.156c-.244 0-.494-.081-.752-.238-.589-.34-.968-1.25-.968-2.315v-.075c.02-.862.278-1.922.968-2.316.481-.285.922-.312 1.335-.074Zm-.556.55c-.101 0-.237.027-.433.136-.366.224-.617.95-.617 1.758s.258 1.535.624 1.76c.345.196.535.121.603.094l.013-.007c.332-.197.562-.977.542-1.853.02-.883-.21-1.664-.542-1.854 0 0-.007 0-.013-.007-.034 0-.089-.027-.177-.027Zm4.681-7.097c.264.13.535.326.786.557.264.265.48.537.65.808.305.469.563 1.026.78 1.67.514-.42 1.076-.57 1.632-.44 1.93.448 2.885 4.06 2.892 4.094l.068.238-.197.136c-.128.101-.799.543-1.456.692l-.047.014-.129-.68.047-.013c.305-.074.664-.265.976-.448-.467-1.406-1.348-3.11-2.317-3.368-.44-.122-.9.081-1.409.631l-.44.483-.156-.639c-.372-1.541-1.118-2.696-2.039-3.158-.67-.353-1.409-.353-2.249 0-1.795.72-2.032 2.92-2.032 4.985v.502l-.46-.156c-.637-.224-1.132-.156-1.464.197-.684.686-.752 2.465-.352 3.538l.014.048-.664.237-.014-.047c-.494-1.324-.413-3.361.481-4.278.244-.258.793-.666 1.748-.496.02-.876.095-1.901.42-2.859a5.62 5.62 0 0 1 .345-.788 3.36 3.36 0 0 1 1.687-1.541c1.07-.435 2.019-.408 2.9.081Zm2.872 4.74c1.348.774 2.08 3.117 1.626 4.23-.176.408-.474.633-.894.673.007.007 0 .007-.007.007-.122 0-.305-.007-.48-.082-1.37-.726-2.162-3.13-1.688-4.27.136-.313.353-.517.65-.619 0 0 .143-.04.204-.04a.925.925 0 0 1 .59.101ZM13.16 13.7l.237.659-.04.014c-.908.346-2.609.618-3.821.618a7.64 7.64 0 0 1-.42-.014h-.048l.041-.7h.047c1.118.062 3.008-.21 3.956-.563l.048-.014Zm.907-3.001a.366.366 0 0 0-.23.23l-.007.014c-.06.13-.088.299-.088.584.02 1.012.637 2.397 1.497 2.791.21.082.366-.095.407-.23.054-.136.081-.313.081-.598-.02-.74-.366-1.664-.84-2.248l-.004-.004-.01-.01c-.02-.027-.087-.088-.101-.101l-.115-.116c-.38-.38-.59-.312-.59-.312Z" }));
var BmLogoOld_default = SvgBmLogoOld;
var SvgBorder = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M14.53.47c.3.3.3.77 0 1.06l-9.81 9.81c.18.35.28.74.28 1.16v9a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-9a2.5 2.5 0 0 1 3.66-2.22L13.47.47c.3-.3.77-.3 1.06 0ZM3.6 20.6v-8.1a1.1 1.1 0 0 0-2.2 0v8.1h2.2ZM8.83 7.77c.28-.41.75-.66 1.25-.66h9.24c.5 0 .97.25 1.25.66l3.38 4.88v4.6c0 .56-.32 1.07-.8 1.33L23 20.36a1.52 1.52 0 0 1-1.52 1.39h-1.37c-.84 0-1.52-.68-1.52-1.52v-1.01c-1.32.12-2.71.21-3.89.21-1.18 0-2.57-.1-3.89-.21v1c0 .85-.68 1.53-1.52 1.53H7.92c-.8 0-1.45-.6-1.52-1.39l-.16-1.78a1.52 1.52 0 0 1-.79-1.34v-4.59l3.38-4.88ZM7.78 18.88l.12 1.35c0 .01 0 .02.02.02H9.3l.01-.01v-1.18l-1.53-.18Zm14.67-5.3h-.18l-2.17-.14c-1.73-.1-3.84-.19-5.4-.19a101.63 101.63 0 0 0-7.59.32l-.16.01v.87c.07 0 .14.01.2.03l1.55.38a.75.75 0 0 1-.36 1.46l-1.39-.35v1.28l.01.01a67 67 0 0 0 7.74.67 67 67 0 0 0 7.74-.67l.01-.02v-1.27l-1.39.35a.75.75 0 0 1-.36-1.46l1.55-.38a.76.76 0 0 1 .2-.03v-.86Zm-11.61 2.03c0-.41.33-.75.75-.75h6.22a.75.75 0 1 1 0 1.5H11.6a.75.75 0 0 1-.75-.75Zm-.76-7-.02.01-2.36 3.41 1.46-.09c1.71-.1 3.86-.2 5.54-.19a113.17 113.17 0 0 1 7 .29l-2.36-3.42h-9.26Zm10 10.45v1.17l.01.01h.01v.01h1.38c.01 0 .02 0 .02-.02l.12-1.35-1.53.18Z" }));
var Border_default = SvgBorder;
var SvgCalendar = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8 2.25a.75.75 0 0 1 .75.75v1.25h6.5V3a.75.75 0 0 1 1.5 0v1.25c.58.002 1.068.01 1.482.043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v6.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H7.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2V9.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.414-.033.902-.04 1.482-.043V3A.75.75 0 0 1 8 2.25Zm-.75 3.5c-.57.002-1.003.01-1.36.038-.453.037-.714.107-.911.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v.45h16.5V9.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207a18.26 18.26 0 0 0-1.359-.037V7a.75.75 0 0 1-1.5 0V5.75h-6.5V7a.75.75 0 0 1-1.5 0V5.75Zm13 6H3.75v4.45c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h8.4c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909v-4.45Z" }));
var Calendar_default = SvgCalendar;
var SvgCancel24H = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 2.75A9.25 9.25 0 0 0 2.75 12a.75.75 0 0 1-1.5 0C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12c0 5.519-4.158 10.065-9.512 10.68a.75.75 0 1 1-.171-1.49A9.252 9.252 0 0 0 12 2.75Zm-1.194 3.56a.75.75 0 0 1 .918.531l1.433 5.348 3.928.804a.75.75 0 0 1-.301 1.47l-4.381-.897a.75.75 0 0 1-.575-.541l-1.553-5.796a.75.75 0 0 1 .53-.918ZM.076 21.092V22h4.906v-1.342H3.578c-.161 0-.351.011-.571.033-.22.014-.417.032-.593.054.38-.39.74-.783 1.076-1.18.336-.403.61-.803.823-1.2.22-.404.33-.797.33-1.18 0-.44-.1-.822-.297-1.146a1.945 1.945 0 0 0-.801-.769C3.2 15.09 2.799 15 2.338 15c-.498 0-.926.094-1.284.281A3.9 3.9 0 0 0 0 16.093l.878.854a3.47 3.47 0 0 1 .56-.486 1.15 1.15 0 0 1 .68-.217c.3 0 .538.09.713.27.183.174.275.43.275.769 0 .324-.128.678-.384 1.06-.256.375-.615.79-1.076 1.244-.453.448-.977.949-1.57 1.504Zm8.62-1.947H7.224l.922-1.493a29.163 29.163 0 0 0 .57-1.158h.044c-.007.216-.022.473-.044.768a16.19 16.19 0 0 0-.022.768v1.115Zm0 1.212V22h1.503v-1.645H11v-1.211h-.801V15.13H8.223l-2.546 4.133v1.092h3.018Z" }));
var Cancel24H_default = SvgCancel24H;
var SvgCancel = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25ZM8.47 8.47a.75.75 0 0 1 1.06 0L12 10.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L13.06 12l2.47 2.47a.75.75 0 1 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 0-1.06Z" }));
var Cancel_default = SvgCancel;
var SvgCarTypeL = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 .25c2.56 0 5.91.2 7.39.3.8.06 1.44.64 1.6 1.42l.7 3.67c.08.16.14.33.17.52l.22 1.44A1 1 0 0 1 24 8v3.5a1 1 0 0 1-.58.9c.2.3.33.65.33 1.03v5.7c0 .7-.41 1.32-1.02 1.6l-.18 1.48a1.76 1.76 0 0 1-1.74 1.54H19c-.97 0-1.75-.78-1.75-1.75v-.55c-1.77.17-3.66.3-5.25.3-1.6 0-3.48-.13-5.25-.3V22c0 .97-.78 1.75-1.75 1.75H3.2c-.9 0-1.64-.66-1.75-1.54l-.18-1.48a1.74 1.74 0 0 1-1.02-1.6v-5.7c0-.38.12-.74.33-1.02A1 1 0 0 1 0 11.5V8a1 1 0 0 1 1.92-.4l.22-1.45c.03-.18.09-.36.17-.52L3 1.96c.16-.77.8-1.35 1.6-1.4C6.04.45 9.32.23 12 .24ZM2.94 22.03c.02.13.13.22.25.22H5c.14 0 .25-.11.25-.25v-.7c-.9-.1-1.74-.2-2.43-.3l.12 1.03Zm18.24-1.02-2.43.29v.7c0 .14.11.25.25.25h1.8c.13 0 .24-.1.26-.22l.12-1.02ZM12 12.75c-3.3 0-8.04.3-10.03.43a.24.24 0 0 0-.22.25v1.1a1 1 0 0 1 .5 0l2 .5a1 1 0 0 1-.5 1.94l-2-.5v2.67c0 .12.09.22.2.24 1.07.15 2.99.4 5.05.59A1 1 0 0 1 8 19h8a1 1 0 0 1 1 .97c2.06-.2 3.98-.45 5.05-.6.11 0 .2-.1.2-.23v-2.67l-2 .5a1 1 0 0 1-.5-1.94l2-.5a1 1 0 0 1 .5 0v-1.1c0-.13-.1-.24-.23-.24A190.1 190.1 0 0 0 12 12.75ZM8 15.5h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2Zm12.29-9.27a.22.22 0 0 0-.13-.05c-1.6-.14-5.34-.42-8.16-.43-2.95 0-6.6.29-8.16.43a.22.22 0 0 0-.12.04.74.74 0 0 1-.1.2l-.8 5.2c2.3-.15 6.28-.38 9.18-.37 2.8 0 6.84.23 9.18.38l-.8-5.2a.74.74 0 0 1-.1-.2Zm-.31-1.57-.47-2.4a.24.24 0 0 0-.22-.2c-1.48-.1-4.78-.3-7.3-.31-2.6 0-5.83.2-7.28.3-.1 0-.2.09-.22.2l-.46 2.4c1.7-.14 5.14-.4 7.97-.4 2.72 0 6.23.27 7.98.4Z" }));
var CarTypeL_default = SvgCarTypeL;
var SvgCarTypeM = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.02 3.25h11.96c.57 0 1.1.28 1.43.75l4.34 6.27v5.87c0 .7-.4 1.3-1.02 1.58l-.21 2.43c-.08.9-.84 1.6-1.74 1.6H19c-.97 0-1.75-.78-1.75-1.75v-1.55c-1.77.17-3.66.3-5.25.3-1.6 0-3.48-.13-5.25-.3V20c0 .97-.78 1.75-1.75 1.75H3.22c-.9 0-1.66-.7-1.74-1.6l-.21-2.42a1.76 1.76 0 0 1-1.02-1.6v-5.86L4.58 4c.33-.47.87-.75 1.44-.75ZM2.98 20.02c0 .13.11.23.24.23H5c.14 0 .25-.11.25-.25v-1.7c-.92-.1-1.76-.2-2.45-.3l.18 2.02Zm18.83-8.85L19 11a145.4 145.4 0 0 0-7-.25c-2.13 0-4.86.12-7.07.24a234.42 234.42 0 0 0-3.18.2v1.34a1 1 0 0 1 .5 0l2 .5a1 1 0 0 1-.5 1.94l-2-.5v1.67c0 .12.09.22.2.24 1.94.26 6.72.87 10.05.87 3.33 0 8.1-.6 10.05-.87.11-.02.2-.12.2-.24v-1.67l-2 .5a1 1 0 0 1-.5-1.94l2-.5a1 1 0 0 1 .5 0V11.2l-.44-.03ZM7.75 13.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM21.2 18c-.69.1-1.53.2-2.45.3V20c0 .14.11.25.25.25h1.78c.13 0 .23-.1.25-.23L21.2 18ZM5.82 4.86 2.5 9.64c.64-.04 1.44-.1 2.34-.14 2.21-.13 4.98-.26 7.15-.25a146.64 146.64 0 0 1 9.5.4l-3.32-4.8a.25.25 0 0 0-.2-.1H6.02a.25.25 0 0 0-.2.1Z" }));
var CarTypeM_default = SvgCarTypeM;
var SvgCarTypeS = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.08 5.76C6.48 4.42 8.7 3.75 12 3.75s5.52.67 6.92 2a6.3 6.3 0 0 1 1.8 4.3A.98.98 0 0 1 21 10h1.5a1 1 0 0 1 0 2h-.62a2 2 0 0 1 .12.7v3.7c0 .35-.1.69-.26.98v.2l-.21 2.1c-.1.9-.84 1.57-1.74 1.57H18c-.97 0-1.75-.78-1.75-1.75v-.69a50.33 50.33 0 0 1-8.5 0v.69c0 .97-.78 1.75-1.75 1.75H4.21c-.9 0-1.65-.68-1.74-1.57l-.22-2.1.01-.2A1.96 1.96 0 0 1 2 16.4v-3.7a2 2 0 0 1 .12-.7H1.5a1 1 0 0 1 0-2H3c.1 0 .2.01.28.04a6.3 6.3 0 0 1 1.8-4.28ZM3.96 19.53c.01.12.12.22.25.22H6c.14 0 .25-.11.25-.25v-.83a73.3 73.3 0 0 1-2.41-.33l.12 1.19Zm16.2-1.2a52 52 0 0 1-2.41.34v.83c0 .14.11.25.25.25h1.79c.13 0 .23-.1.25-.22l.12-1.2ZM6.11 6.85c-.9.87-1.3 2.1-1.35 3.76 2.09-.28 4.98-.6 7.24-.6s5.15.32 7.24.6c-.05-1.65-.44-2.9-1.35-3.76-1-.94-2.76-1.59-5.89-1.59s-4.9.65-5.89 1.6ZM20.5 16.4v-3.7a.46.46 0 0 0-.39-.47c-2.06-.3-5.55-.73-8.11-.73-2.56 0-6.05.43-8.12.73a.46.46 0 0 0-.38.46v3.7c0 .25.16.4.32.42 1.73.3 4.76.69 8.18.69s6.45-.4 8.18-.69c.16-.02.32-.17.32-.41Zm-1-1.9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM9.75 14h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" }));
var CarTypeS_default = SvgCarTypeS;
var SvgChecked = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm4.28 8.78a.75.75 0 1 0-1.06-1.06l-4.47 4.47-1.47-1.47a.75.75 0 0 0-1.06 1.06l1.823 1.824a1 1 0 0 0 1.414 0l4.823-4.824Z" }));
var Checked_default = SvgChecked;
var SvgChildSeat01 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M21.75 20.02v.02A2.75 2.75 0 0 1 19 22.79H4.64a2.75 2.75 0 0 1-2.74-2.53v-.07l-.08-.95-.2-2.28-.32-3.74c-.06-.69.28-1.3.82-1.65l-.08-.35A211.59 211.59 0 0 1 1 6.66C.86 6 .75 5.34.75 5v-.11c-.02-.3-.05-1 .1-1.66.1-.4.28-.85.61-1.23.34-.39.82-.66 1.44-.74A84.4 84.4 0 0 1 10 .75c2.31 0 3.75 1.9 3.75 3.75a3.8 3.8 0 0 1-.65 2.33 4.12 4.12 0 0 1-2.42 1.4c-1.06.26-1.69.46-2 1.1 0 0-.02.02-.02.05l-.02.16c0 .14.02.32.06.55.08.46.26 1.02.48 1.63.38 1.03.88 2.12 1.28 3l.11.23c3.1-.73 5.1-1.03 6.43-1.03 2.45 0 3.91.3 4.8 1.16.83.8.95 1.8.95 2.29 0 .64-.09 1.2-.3 1.7-.18.38-.41.69-.7.95ZM9.31 16.8c.27.11.53.2.8.27 1.71.48 4.13.87 7.19 1.16a101 101 0 0 0 3.73.26h.03l.01-.03c.1-.25.18-.58.18-1.1 0-.29-.07-.8-.5-1.2-.4-.4-1.29-.74-3.75-.74-1.35 0-3.67.37-7.69 1.39Zm-5.94 3.05.03.29c.05.65.6 1.15 1.24 1.15H19c.69 0 1.25-.56 1.25-1.25v-.1c-.75-.04-1.85-.1-3.1-.22a44.3 44.3 0 0 1-7.45-1.2c-1.1-.31-2.17-.84-3.18-1.57-.8-.58-1.56-1.28-2.27-2.1h-.02v-.03L2.8 13v.1l.31 3.73.2 2.28.06.74Zm.84-2.43a1 1 0 0 1 1.4-.17l2 1.55a1 1 0 1 1-1.22 1.58l-2-1.55a1 1 0 0 1-.18-1.4ZM3.1 2.74a.77.77 0 0 0-.51.25 1.3 1.3 0 0 0-.27.58c-.1.43-.09.85-.08 1.18l.01.25c0 .16.07.64.22 1.37a83.26 83.26 0 0 0 1.02 4.5l.17.69.04.16 1.7 2.16c.63.73 1.3 1.35 2 1.85l.02.02 1.67-.44c-.4-.87-.92-2-1.31-3.07-.24-.65-.45-1.3-.56-1.88-.1-.53-.15-1.18.1-1.7.66-1.3 1.98-1.63 2.9-1.87l.1-.02c.9-.23 1.35-.53 1.58-.85.23-.3.35-.74.35-1.42 0-1.14-.88-2.25-2.25-2.25-1.46 0-5.43.3-6.9.5Z" }));
var ChildSeat01_default = SvgChildSeat01;
var SvgChildSeat02 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.17 15.15v-.05L1.26 3.3a1.9 1.9 0 0 1 1.8-2.04h.08l8.03-.01c1.95 0 3.48 1.4 3.48 3.25 0 1.15-.62 2.1-1.74 2.75-.5.3-1 .5-1.49.62l-.24.05-2.72.28-.19 2.94c.96-.18 1.94-.3 2.86-.32h.6c1.33.02 2.25.98 2.24 2.15 0 .55-.22 1.06-.6 1.45-.43.42-1 .63-1.64.64-.97 0-2.76.28-3.43.53l-.1.04.01.02c.03.1.1.2.18.31l.07.08c.76.73.97.78 1.82.37l.37-.19.7-.38 1.47-.81.44-.24a7.67 7.67 0 0 1 3.93-.84c1.9 0 3.9 1.1 4.82 2.22.56.7.87 1.5.87 2.32a4.3 4.3 0 0 1-1.26 3.2 3.65 3.65 0 0 1-2.48 1.06H3.85a.99.99 0 0 1-.99-.88l-.58-5.42a4.61 4.61 0 0 1-.1-1.3Zm4.57-3.65L7 7.67c.05-.46.4-.82.85-.91l.13-.02 2.96-.3a4.2 4.2 0 0 0 1.21-.48c.69-.4 1-.88 1-1.46 0-.95-.75-1.68-1.82-1.75H3.18c-.24.02-.4.18-.43.35v.07l.75 9.67a11.9 11.9 0 0 1 3.24-1.34Zm4.42.82c-2.89.08-6.48 1.19-7.21 2.08-.33.4-.35 1.14-.2 1.8l.55 5.05h14.84c.42 0 .9-.19 1.29-.51l.14-.13c.5-.48.81-1.17.81-2.12 0-.47-.18-.94-.53-1.37a5.39 5.39 0 0 0-3.66-1.67c-1.55 0-2.18.17-3.29.7l-.05.02-2.04 1.14-.64.33-.12.07-.32.15c-1.36.59-2.19.34-3.3-.74a2.22 2.22 0 0 1-.73-1.75c.05-.41.27-.75.63-.97.73-.45 3.04-.83 4.38-.84.27 0 .47-.08.6-.2.1-.1.16-.25.16-.4 0-.35-.27-.63-.75-.64h-.56Z" }));
var ChildSeat02_default = SvgChildSeat02;
var SvgCityStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2 6.12a2 2 0 0 1 .95-1.7l4.5-2.77a2 2 0 0 1 2.1 0l4.5 2.76a2 2 0 0 1 .95 1.7v1.14h3.5c.69 0 1.25.56 1.25 1.25v1.75h1.75c.69 0 1.25.56 1.25 1.25v11h.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5H2V6.12Zm16.25 2.63H15v1.5h3.25v-1.5ZM13.5 22.5V6.12a.5.5 0 0 0-.24-.43l-4.5-2.77a.5.5 0 0 0-.52 0L3.74 5.7a.5.5 0 0 0-.24.43V22.5H7v-4c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v4h3.5ZM5 8.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2Zm0 5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2ZM9.5 8h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Zm0 5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Zm5.5-1.25V22.5h6.25V11.75H15ZM16.7 17h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5Zm-.5-3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1Z" }));
var CityStation_default = SvgCityStation;
var SvgClose = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.813 5.813a.75.75 0 0 1 1.06 0L12 10.939l5.127-5.126a.75.75 0 0 1 1.06 1.06L13.061 12l5.126 5.127a.75.75 0 0 1-1.06 1.06L12 13.061l-5.127 5.126a.75.75 0 1 1-1.06-1.06L10.939 12 5.813 6.873a.75.75 0 0 1 0-1.06Z" }));
var Close_default = SvgClose;
var SvgComment = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.768 2.25h8.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v5.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H9.684c-.654 0-.877.003-1.084.046-.199.04-.39.108-.571.2-.188.096-.364.233-.875.642l-2.409 1.926c-.188.15-.367.294-.522.396-.15.1-.402.25-.722.25-.38 0-.74-.173-.978-.47-.2-.25-.24-.542-.256-.72a7.815 7.815 0 0 1-.017-.655V7.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043ZM5.89 3.788c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v12.639l.081-.064 2.386-1.909.056-.045c.433-.347.733-.587 1.073-.76.301-.154.621-.267.952-.334.375-.077.759-.077 1.313-.077h6.59c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.056.038-1.909V7.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207-.462-.037-1.057-.038-1.909-.038H7.8c-.852 0-1.447 0-1.91.038ZM6.25 8.5A.75.75 0 0 1 7 7.75h5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z" }));
var Comment_default = SvgComment;
var SvgCompare = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.625 9.611H6.26v1.974l-3.673-3.53 3.674-3.528V6.5h7.006v3.11zM1.012 8.434l5.249 5.042.003.002.079.076.394.379c.333.32.888.083.888-.379v-2.579h5.955c.58 0 1.05-.47 1.05-1.049v-3.74c0-.58-.47-1.049-1.05-1.049H7.625V2.558a.525.525 0 0 0-.888-.378l-.394.378-.08.076-.002.003-5.249 5.04a.525.525 0 0 0 0 .757zm15.066 6.016h1.364v-1.974l3.673 3.53-3.673 3.528V17.56h-7.006v-3.11zm6.612 1.177-5.248-5.041-.004-.003-.078-.076-.394-.378a.525.525 0 0 0-.888.378v2.579h-5.956c-.58 0-1.05.47-1.05 1.05v3.74c0 .579.47 1.048 1.05 1.048h5.956v2.579c0 .463.554.699.888.379l.394-.379.078-.075.004-.003 5.248-5.041a.525.525 0 0 0 0-.757z" }));
var Compare_default = SvgCompare;
var SvgContact = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4.55 8a7.46 7.46 0 0 1 14.9 0h.29a2.76 2.76 0 0 1 2.76 2.76v3.87a2.76 2.76 0 0 1-2.76 2.76h-.28v2.46a3.04 3.04 0 0 1-2.54 3l-4.78.8a.83.83 0 0 1-.28-1.64l4.79-.8a1.38 1.38 0 0 0 1.15-1.36v-2.49a1.1 1.1 0 0 1-.83-1.07V9.11c0-.51.35-.94.82-1.07a5.8 5.8 0 0 0-11.58 0c.47.13.82.56.82 1.07v7.18c0 .61-.5 1.1-1.1 1.1H4.25a2.76 2.76 0 0 1-2.76-2.76v-3.87A2.76 2.76 0 0 1 4.26 8h.3Zm.82 1.66h-1.1c-.62 0-1.11.5-1.11 1.1v3.87c0 .61.5 1.1 1.1 1.1h1.1V9.67Zm13.26 0v6.08h1.1c.62 0 1.11-.5 1.11-1.1v-3.88c0-.6-.5-1.1-1.1-1.1h-1.1Z" }));
var Contact_default = SvgContact;
var SvgCopy = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M14.387 2.552A1.937 1.937 0 0 0 13.03 2H9.081C7.668 2 6.522 3.125 6.522 4.514v12.568c0 1.388 1.146 2.513 2.56 2.513h8.957c1.413 0 2.56-1.125 2.56-2.513v-7.65a1.87 1.87 0 0 0-.563-1.332l-5.649-5.548Zm-5.306.705h3.644V7.64c.018 1.034.875 1.866 1.93 1.866h4.664v7.575c0 .694-.573 1.256-1.28 1.256H9.081c-.706 0-1.28-.562-1.28-1.256V4.514c0-.695.574-1.257 1.28-1.257Zm4.93 4.353V3.96l4.36 4.282h-3.73a.638.638 0 0 1-.63-.632Zm-8.72-2.384a.645.645 0 1 0-1.291 0v12.023A4.75 4.75 0 0 0 8.75 22h8.916a.645.645 0 1 0 0-1.29H8.75a3.46 3.46 0 0 1-3.46-3.46V5.226Z" }));
var Copy_default = SvgCopy;
var SvgCouple = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M10.1 4c0 1.646-1.354 3-3 3s-3-1.354-3-3 1.354-3 3-3 3 1.354 3 3zM8.9 4c0-.987-.813-1.8-1.8-1.8S5.3 3.013 5.3 4s.813 1.8 1.8 1.8S8.9 4.987 8.9 4zM4.1 7.4h6a2.59 2.59 0 0 1 1.796.72 2.589 2.589 0 0 1 1.795-.72h6c1.426 0 2.6 1.174 2.6 2.6v4.5a2.11 2.11 0 0 1-2.1 2.1.596.596 0 0 1-.4-.153V21a2.11 2.11 0 0 1-2.1 2.1h-2a2.1 2.1 0 0 1-2.1-2.1V10.5c0-.329.271-.6.6-.6s.6.271.6.6V21c0 .494.406.9.9.9h2c.494 0 .9-.406.9-.9V10.5c0-.329.271-.6.6-.6s.6.271.6.6v5.053a.596.596 0 0 1 .4-.153c.494 0 .9-.406.9-.9V10c0-.768-.632-1.4-1.4-1.4h-6c-.462 0-.872.224-1.127.57.088.26.136.54.136.83v4.5a2.11 2.11 0 0 1-2.1 2.1.596.596 0 0 1-.4-.153V21a2.11 2.11 0 0 1-2.1 2.1h-2A2.1 2.1 0 0 1 4 21v-4.553a.596.596 0 0 1-.4.153 2.1 2.1 0 0 1-2.1-2.1V10c0-1.426 1.174-2.6 2.6-2.6zM4 10.5c0-.329.271-.6.6-.6s.6.271.6.6V21c0 .494.406.9.9.9h2c.494 0 .9-.406.9-.9V10.5c0-.329.271-.6.6-.6s.6.271.6.6v5.053a.596.596 0 0 1 .4-.153c.494 0 .9-.406.9-.9V10c0-.768-.632-1.4-1.4-1.4h-6c-.768 0-1.4.632-1.4 1.4v4.5c0 .494.406.9.9.9.148 0 .29.054.4.153zM19.691 4c0 1.646-1.354 3-3 3s-3-1.354-3-3 1.354-3 3-3 3 1.354 3 3zm-1.2 0c0-.987-.813-1.8-1.8-1.8s-1.8.813-1.8 1.8.813 1.8 1.8 1.8 1.8-.813 1.8-1.8z" }));
var Couple_default = SvgCouple;
var SvgDamage = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m15.58 3.74 3.91.69c.57.1 1.05.47 1.29 1l3.17 6.89-.6 5.69c-.1.85-.8 1.51-1.66 1.55l-.06.61c-.08.9-.84 1.58-1.74 1.58h-1.93c-.94 0-1.71-.74-1.75-1.69l-.03-.8a57.95 57.95 0 0 1-5.27-.6 49.38 49.38 0 0 1-4.74-1.14l-.27 1.64a1.75 1.75 0 0 1-1.97 1.44l-1.64-.23a1.75 1.75 0 0 1-1.5-1.8l.12-2.77a1.74 1.74 0 0 1-.77-1.65L.8 8.28l5.37-5.43c.4-.41.98-.6 1.55-.5l7.85 1.39h.01Zm-2.71 2.8L14.2 7.8l-2.48 1.35.85.14a147.56 147.56 0 0 1 9.28 2.04l-2.44-5.3a.25.25 0 0 0-.18-.14l-3.68-.64-2.68 1.28Zm4.82 12.83.02.64c0 .13.12.24.25.24h1.93c.13 0 .24-.1.25-.23l.05-.51-2.5-.14Zm-15.3-3.01-.1 2.27c0 .13.09.24.21.26l1.64.23c.13.02.26-.07.28-.2l.3-1.83c-.87-.26-1.67-.52-2.33-.73ZM22.36 13a254.07 254.07 0 0 0-3.2-.77c-2.19-.51-4.86-1.1-6.86-1.46-2.1-.38-4.8-.73-7-.99a269.63 269.63 0 0 0-3.12-.35l-.15 1.3c.12.02.24.04.36.1l1.88.84a1 1 0 1 1-.82 1.82l-1.64-.73-.18 1.55c-.01.12.06.22.16.25 1.73.6 6.1 2.03 9.39 2.6 3.28.59 8.35.82 10.43.9.12 0 .23-.1.24-.22l.18-1.7a1 1 0 0 1-.29.07l-2.05.14a1 1 0 1 1-.14-2l2.05-.14a1 1 0 0 1 .62.16l.14-1.37Zm-15.59.35a.75.75 0 0 1 .87-.61l8.37 1.47a.75.75 0 1 1-.26 1.48l-8.37-1.48a.75.75 0 0 1-.6-.87Zm2.49-4.58 2.42-1.3-1.42-1.36 2.75-1.31-5.55-.98a.25.25 0 0 0-.22.07l-4.1 4.14a257.4 257.4 0 0 1 6.12.74Z" }));
var Damage_default = SvgDamage;
var SvgDelete = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8 2.75C8 1.78 8.78 1 9.75 1h4c.97 0 1.75.78 1.75 1.75V4h2.75c1.24 0 2.25 1 2.25 2.25V7.5a1 1 0 0 1-1 1h-.05l-.85 11.91a2.25 2.25 0 0 1-2.25 2.09h-9.2a2.25 2.25 0 0 1-2.25-2.09L4.05 8.5H4a1 1 0 0 1-1-1V6.25C3 5.01 4 4 5.25 4H8V2.75Zm9.95 5.75H5.54l.85 11.8c.03.4.35.7.75.7h9.2c.4 0 .72-.3.75-.7l.85-11.8Zm-2.12 1c.41.05.71.42.67.83l-1 9a.75.75 0 1 1-1.5-.16l1-9a.77.77 0 0 1 .83-.67Zm-4.08 0c.41 0 .75.34.75.75v9a.75.75 0 0 1-1.5 0v-9c0-.41.34-.75.75-.75Zm-3.25.67 1 9a.75.75 0 1 1-1.5.16l-1-9a.75.75 0 1 1 1.5-.16ZM14 2.75a.25.25 0 0 0-.25-.25h-4a.25.25 0 0 0-.25.25V4H14V2.75ZM4.5 7H19v-.75a.75.75 0 0 0-.75-.75h-13a.75.75 0 0 0-.75.75V7Z" }));
var Delete_default = SvgDelete;
var SvgDimensions = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.6 2.25h12a1.25 1.25 0 0 1 1.15 1.16l.01.37v11.61c0 .2 0 .4-.05.6-.04.18-.11.35-.2.51-.12.18-.27.33-.4.46l-.04.04L17 21.06l-.04.04c-.25.3-.59.51-.97.6-.2.05-.4.05-.6.05H3.4a1.25 1.25 0 0 1-1.15-1.16l-.01-.37V8.61c0-.2 0-.4.05-.6.04-.18.11-.35.2-.51.12-.18.27-.33.4-.46L2.94 7l4.1-4.1c.25-.3.58-.51.96-.6.2-.05.4-.05.6-.05ZM20.25 4.8l-3.5 3.5v10.89l3.43-3.43.03-.04.04-.08V4.8Zm-5 3.95H3.75v11.5h11.5V8.75Zm3.95-5H8.36a.24.24 0 0 0-.08.04l-.04.03-3.43 3.43H15.7l3.5-3.5Z" }));
var Dimensions_default = SvgDimensions;
var SvgDocument = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M13.63 1.35c.38.1.75.25 1.09.45.38.24.7.55 1.16 1.02l.06.06 3.18 3.18.06.06c.47.46.78.78 1.02 1.16.2.34.35.7.45 1.09.1.43.1.88.1 1.53v7.33c0 .81 0 1.47-.04 2a3.85 3.85 0 0 1-.37 1.47c-.36.7-.93 1.28-1.64 1.64-.44.23-.92.32-1.47.37-.53.04-1.18.04-2 .04H8.77c-.81 0-1.47 0-2-.04a3.84 3.84 0 0 1-1.47-.37 3.74 3.74 0 0 1-1.64-1.64 3.84 3.84 0 0 1-.37-1.47c-.04-.53-.04-1.18-.04-2V6.77c0-.81 0-1.47.04-2 .05-.55.14-1.03.37-1.47.36-.7.93-1.28 1.64-1.64.44-.23.92-.32 1.47-.37.53-.04 1.19-.04 2-.04h3.33c.65 0 1.1 0 1.53.1Zm5.18 6.56a10.5 10.5 0 0 0-.75-.79l-3.18-3.18a5.9 5.9 0 0 0-.95-.86 2.18 2.18 0 0 0-.35-.18v5h5.23Zm-6.73-5.16H8.8c-.85 0-1.45 0-1.9.04-.46.03-.72.1-.92.2-.43.22-.77.56-.99.99-.1.2-.17.46-.2.91-.04.46-.04 1.06-.04 1.91v10.4c0 .85 0 1.45.04 1.9.03.46.1.72.2.92.22.42.56.77.99.98.2.1.46.17.91.21.46.04 1.06.04 1.91.04h6.4c.85 0 1.45 0 1.9-.04.46-.04.72-.1.92-.2.42-.22.77-.57.98-.99.1-.2.17-.46.21-.91.04-.46.04-1.06.04-1.91V9.41h-5.92c-.7 0-1.25-.56-1.25-1.25V2.75ZM7.75 16.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM7 13.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z" }));
var Document_default = SvgDocument;
var SvgDoors = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.25 3c0-.966.784-1.75 1.75-1.75h9.874c.448 0 .879.172 1.204.48l8.126 7.706c.349.33.546.79.546 1.27v3.664c0 .795-.528 1.466-1.246 1.705-.502.167-1.205.427-1.902.767-.706.344-1.359.748-1.799 1.188-.927.927-1.664 2.576-2.039 3.552a1.807 1.807 0 0 1-1.677 1.168H3A1.75 1.75 0 0 1 1.25 21V3ZM3 2.75a.25.25 0 0 0-.25.25v18c0 .138.112.25.25.25h11.087a.308.308 0 0 0 .277-.206c.375-.977 1.204-2.9 2.378-4.074.612-.612 1.436-1.103 2.203-1.477a17.436 17.436 0 0 1 2.085-.841.308.308 0 0 0 .22-.282v-3.664a.25.25 0 0 0-.078-.182L13.046 2.82a.25.25 0 0 0-.172-.069H3ZM6.5 6.5V12h10.961l-5.323-5.5H6.5ZM6 5h6.35a1 1 0 0 1 .719.305l6.29 6.5c.614.634.165 1.695-.718 1.695H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm-.25 10.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" }));
var Doors_default = SvgDoors;
var SvgDownload = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 2.25a.75.75 0 0 1 .75.75v10.19l3.72-3.72a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 1 1 1.06-1.06l3.72 3.72V3a.75.75 0 0 1 .75-.75Zm-9 13a.75.75 0 0 1 .75.75v.2c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h8.4c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909V16a.75.75 0 0 1 1.5 0v.232c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H7.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2V16a.75.75 0 0 1 .75-.75Z" }));
var Download_default = SvgDownload;
var SvgDrivingLicence = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4 5h16c1.097 0 2 .903 2 2v10c0 1.097-.903 2-2 2H4c-1.097 0-2-.903-2-2V7c0-1.097.903-2 2-2zm16 1.3H4c-.384 0-.7.316-.7.7v10c0 .384.316.7.7.7h16c.384 0 .7-.316.7-.7V7c0-.384-.316-.7-.7-.7zm-8 2.05h6.5c.357 0 .65.293.65.65s-.293.65-.65.65H12c-.357 0-.65-.293-.65-.65s.293-.65.65-.65zM11.35 12c0-.357.293-.65.65-.65h6.5c.357 0 .65.293.65.65s-.293.65-.65.65H12a.653.653 0 0 1-.65-.65zm-2.544.132A3.153 3.153 0 0 1 10.65 15c0 .357-.293.65-.65.65s-.65-.293-.65-.65c0-1.015-.835-1.85-1.85-1.85s-1.85.835-1.85 1.85c0 .357-.293.65-.65.65s-.65-.293-.65-.65c0-1.233.723-2.357 1.845-2.868A2.503 2.503 0 0 1 5.001 10c0-1.372 1.128-2.5 2.5-2.5 1.371 0 2.5 1.128 2.5 2.5 0 .869-.454 1.678-1.195 2.132zM8.7 10c0-.658-.542-1.2-1.2-1.2s-1.2.542-1.2 1.2.542 1.2 1.2 1.2 1.2-.542 1.2-1.2zm3.3 4.35h6.5c.357 0 .65.293.65.65s-.293.65-.65.65H12c-.357 0-.65-.293-.65-.65s.293-.65.65-.65z" }));
var DrivingLicence_default = SvgDrivingLicence;
var SvgEdit = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M16.57 3.13 18 1.7a2 2 0 0 1 2.83 0l1.41 1.42a2 2 0 0 1 0 2.82l-1.41 1.42-.36.35-8.95 8.96a1 1 0 0 1-.57.28l-3.3.47a1 1 0 0 1-1.13-1.13l.47-3.3a1 1 0 0 1 .28-.56l8.96-8.96.36-.35Zm4.6 1.76a.5.5 0 0 0 0-.7l-1.41-1.42a.5.5 0 0 0-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06Zm-4.24 0-8.49 8.49-.35 2.47 2.47-.35 8.49-8.48-2.12-2.13ZM6.73 3.36h5.22a.75.75 0 1 1 0 1.5H6.77c-.85 0-1.44 0-1.9.04-.45.03-.7.1-.9.2-.42.22-.76.56-.98.98-.1.2-.17.45-.2.9-.04.46-.04 1.05-.04 1.9v8.35c0 .85 0 1.44.04 1.9.03.45.1.7.2.9.22.42.56.76.98.98.2.1.45.16.9.2.46.04 1.05.04 1.9.04h8.35c.85 0 1.44 0 1.9-.04.45-.04.7-.1.9-.2.42-.22.76-.56.98-.98.1-.2.17-.45.2-.9.04-.46.04-1.05.04-1.9v-5.18a.75.75 0 0 1 1.5 0v5.21c0 .8 0 1.46-.04 1.99a3.82 3.82 0 0 1-.37 1.46c-.35.7-.92 1.27-1.63 1.63-.44.23-.92.32-1.46.37-.53.04-1.18.04-1.99.04H6.74c-.8 0-1.46 0-1.99-.04a3.82 3.82 0 0 1-1.46-.37 3.73 3.73 0 0 1-1.63-1.63 3.82 3.82 0 0 1-.37-1.46c-.04-.53-.04-1.18-.04-1.99V8.85c0-.81 0-1.46.04-1.99.05-.54.14-1.02.37-1.46a3.8 3.8 0 0 1 1.63-1.64c.44-.22.92-.31 1.46-.36.53-.04 1.18-.04 1.99-.04Z" }));
var Edit_default = SvgEdit;
var SvgElectroHybrid = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m13.352 4.607.707-.707L16.7 1.26a1 1 0 1 1 1.414 1.414l-2.64 2.641-.708.707-1.414-1.414Zm3.961 3.962.707-.707 2.642-2.641a1 1 0 1 1 1.414 1.414l-2.641 2.64-.707.708-1.415-1.414Zm-6.536-3.134L9.17 7.04a4.5 4.5 0 0 0 0 6.364l.758.758a4.5 4.5 0 0 0 6.364 0l1.606-1.606a.5.5 0 0 0 0-.707l-6.415-6.415a.5.5 0 0 0-.707 0Zm-1.754 9.938-4.094 4.094c-.661.661-.522 1.366-.15 1.755a1 1 0 0 0 .722.322c.263.002.617-.106 1.008-.497.623-.623 1.21-1.133 2.536-2.143.629-.48 1.313-.672 1.966-.603.643.068 1.2.384 1.595.82.789.87 1.004 2.33-.076 3.41a.75.75 0 1 1-1.06-1.061c.42-.421.37-.961.025-1.341a1.015 1.015 0 0 0-.642-.336c-.234-.025-.542.032-.898.304-1.298.989-1.827 1.453-2.385 2.01-.629.63-1.354.94-2.076.938a2.504 2.504 0 0 1-1.8-.787c-.918-.962-1.08-2.598.174-3.852l4.094-4.094A6 6 0 0 1 8.11 5.98l1.606-1.606a2 2 0 0 1 2.828 0l6.415 6.415a2 2 0 0 1 0 2.829l-1.605 1.606a6 6 0 0 1-8.331.149Z" }));
var ElectroHybrid_default = SvgElectroHybrid;
var SvgEmail = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4.5 5.25h15c1.24 0 2.25 1 2.25 2.25v10c0 1.24-1 2.25-2.25 2.25h-15c-1.24 0-2.25-1-2.25-2.25v-10c0-1.24 1-2.25 2.25-2.25Zm-.75 2.97v9.28l.01.15 4.78-5.2-4.79-4.23Zm15.5 10.03-4.63-5.06-1.46 1.29c-.66.58-1.66.58-2.32 0l-1.18-1.05-4.41 4.82h14Zm1-1.13v-8.9l-4.5 3.98 4.5 4.92ZM4.36 6.76l7.48 6.6c.09.08.23.08.33 0l7.47-6.6a.76.76 0 0 0-.14-.01h-15l-.14.01Z" }));
var Email_default = SvgEmail;
var SvgFacebook = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M22 12.06C22 6.505 17.523 2 12 2S2 6.504 2 12.06c0 5.023 3.656 9.185 8.437 9.94v-7.03H7.9v-2.91h2.538V9.844c0-2.521 1.493-3.915 3.778-3.915 1.093 0 2.238.197 2.238.197v2.476h-1.262c-1.242 0-1.628.776-1.628 1.572v1.887h2.773l-.443 2.908h-2.33V22c4.78-.755 8.436-4.917 8.436-9.94Z" }));
var Facebook_default = SvgFacebook;
var SvgFerry = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11 0h2c.28 0 .5.22.5.5v2.75H18c.97 0 1.75.78 1.75 1.75v7.57l1.8 1.03c.8.47 1.1 1.49.68 2.32l-2.25 4.35a3.7 3.7 0 0 1 2.82.66l.64.46a.75.75 0 0 1-.88 1.22l-.64-.47a2.2 2.2 0 0 0-2.9.28 3.7 3.7 0 0 1-5.17.23l-.26-.24a2.2 2.2 0 0 0-3.03.1 3.7 3.7 0 0 1-5.16.07l-.2-.2a2.5 2.5 0 0 0-3.18-.2l-.58.43a.75.75 0 0 1-.88-1.22l.58-.41A3.99 3.99 0 0 1 4 20.25l-2.24-4.33a1.75 1.75 0 0 1 .69-2.32l1.79-1.03V5c0-.97.78-1.75 1.75-1.75h4.5V.5c0-.28.22-.5.5-.5Zm1.12 9.94a.25.25 0 0 0-.24 0L3.2 14.9a.25.25 0 0 0-.1.33l3.07 5.93.05.14.2.19c.87.82 2.24.8 3.08-.05a3.7 3.7 0 0 1 1.55-.93.76.76 0 0 1-.05-.26v-6.5a.75.75 0 0 1 1.5 0v6.5l-.01.12a3.7 3.7 0 0 1 2.1.92l.26.24a2.2 2.2 0 0 0 2.9.02c0-.13.02-.27.08-.4l3.06-5.92a.25.25 0 0 0-.1-.33l-8.67-4.97ZM18.25 5a.25.25 0 0 0-.25-.25H6a.25.25 0 0 0-.25.25v6.72l5.38-3.09c.54-.3 1.2-.3 1.74 0l5.38 3.08V5ZM8.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM17 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }));
var Ferry_default = SvgFerry;
var SvgFilter = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.35 7.5H2.3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h19.5a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1h-.01l-6.15 5.27a.25.25 0 0 0-.09.19v6.36c0 .72-.44 1.36-1.1 1.63l-3 1.2a1.75 1.75 0 0 1-2.4-1.63v-7.54a.25.25 0 0 0-.1-.2L2.36 7.5Zm2.4 0 5.14 4.11c.42.34.66.84.66 1.37v7.54c0 .18.18.3.34.24l3-1.2c.1-.04.16-.13.16-.24v-6.36c0-.51.22-1 .61-1.33l4.82-4.13H4.75ZM2.8 5.94l.08.06h18.35l.07-.06V3.5H2.8v2.44Z" }));
var Filter_default = SvgFilter;
var SvgFloytCut = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M19.84 7.87c.18 0 .34.1.41.27 2.21 6-1.38 12.22-8.4 12.22H0v-3.41h11.77c5.16 0 6.57-5.28 4.19-8.62a.28.28 0 0 1 .21-.46h3.67ZM4.3 15.5a.45.45 0 0 1-.41-.27c-2.2-6 1.39-12.22 8.41-12.22L23.7 3h.3v3.42H12.38c-5.16 0-6.57 5.27-4.2 8.61.16.19.03.46-.2.46H4.3Z" }));
var FloytCut_default = SvgFloytCut;
var SvgFloytFull = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.695 14.534a.324.324 0 0 1-.295-.193c-1.571-4.26.982-8.69 5.983-8.69l8.04-.004h1.362a1.215 1.215 0 0 1 0 2.432h-9.35c-3.672 0-4.676 3.752-2.981 6.128a.2.2 0 0 1-.154.327H6.695Zm11.045-5.42c.127 0 .241.075.294.192 1.571 4.26-.982 8.69-5.983 8.69L4.003 18H2.546a1.215 1.215 0 0 1 0-2.432h9.453c3.672 0 4.676-3.752 2.981-6.128a.2.2 0 0 1 .154-.327h2.606Z" }));
var FloytFull_default = SvgFloytFull;
var SvgFourWheelDrive = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.5 1h2C5.33 1 6 1.67 6 2.5V4h3.44a2.75 2.75 0 0 1 5.12 0H18V2.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 18 7.5V6h-3.44c-.3.8-.98 1.41-1.81 1.65v8.7c.92.26 1.64.98 1.9 1.9H18V16.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-1.75h-3.35a2.75 2.75 0 0 1-5.21.25H6v1.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 21.5v-5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5V18h3.44c.3-.8.98-1.41 1.81-1.65v-8.7A2.75 2.75 0 0 1 9.44 6H6v1.5C6 8.33 5.33 9 4.5 9h-2A1.5 1.5 0 0 1 1 7.5v-5C1 1.67 1.67 1 2.5 1Z" }));
var FourWheelDrive_default = SvgFourWheelDrive;
var SvgFrontWheelDrive = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6 6v1.5C6 8.33 5.33 9 4.5 9h-2A1.5 1.5 0 0 1 1 7.5v-5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5V4h3.44a2.75 2.75 0 0 1 5.12 0H18V2.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 18 7.5V6h-3.44c-.3.8-.98 1.41-1.81 1.65v8.7c.92.26 1.64.98 1.9 1.9H18V16.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-1.75h-3.35a2.75 2.75 0 0 1-5.21.25H6v1.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 21.5v-5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5V18h3.44c.3-.8.98-1.41 1.81-1.65v-8.7A2.75 2.75 0 0 1 9.44 6H6Zm6 11.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm9.5-1.25h-2v5h2v-5Zm-17 0h-2v5h2v-5ZM12 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z" }));
var FrontWheelDrive_default = SvgFrontWheelDrive;
var SvgFuelLevel = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m17.65 7.62.04.08.13.23a51.66 51.66 0 0 1 1.86 3.51c.5 1.05 1.02 2.2 1.4 3.3.38 1.08.67 2.17.67 3.06 0 2.7-2.1 4.95-4.75 4.95a4.85 4.85 0 0 1-4.75-4.95c0-.89.29-1.98.67-3.06.39-1.1.9-2.25 1.4-3.3a57.05 57.05 0 0 1 1.86-3.51l.13-.23.04-.07v-.01a.75.75 0 0 1 1.3 0Zm-1.97 4.47a31.4 31.4 0 0 0-1.35 3.15 8.48 8.48 0 0 0-.58 2.56A3.35 3.35 0 0 0 17 21.25a3.35 3.35 0 0 0 3.25-3.45c0-.62-.21-1.51-.58-2.56a32.5 32.5 0 0 0-1.35-3.15c-.47-.99-.95-1.9-1.32-2.56-.37.67-.85 1.57-1.32 2.56ZM5.35 1.25h4.72a.75.75 0 0 1 .72.97L9.63 6.05h2.62c.17 0 .35 0 .5.02.14.01.44.06.68.3.24.26.33.59.32.9-.02.26-.13.46-.2.6l-.31.4v.01L7.37 20.33a.75.75 0 0 1-1.42-.4l.86-8.18h-3.2l-.4-.01a1.05 1.05 0 0 1-.57-.24 1.17 1.17 0 0 1-.34-1.26l.14-.38v-.01l1.7-7.6.01-.08a1.12 1.12 0 0 1 .06-.16V2c.04-.08.1-.23.2-.36a1.07 1.07 0 0 1 .91-.39h.02Zm-1.43 8.92-.02.08h3.75a.75.75 0 0 1 .74.83l-.5 4.76 4-8.21.03-.08h-3.3a.75.75 0 0 1-.72-.97l1.16-3.83h-3.5l-1.64 7.42Z" }));
var FuelLevel_default = SvgFuelLevel;
var SvgFuel = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5 22V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v1.2l.06-.02c.6-.19 1.28-.15 2.1.17a3.51 3.51 0 0 1 1.88 4.55v.01l-.02.01L19 18.87V22a2 2 0 0 1-.06.5h4.31a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h4.31A2 2 0 0 1 5 22ZM21.65 9.32a2.01 2.01 0 0 0-1.05-2.58c-.56-.22-.89-.2-1.09-.13a1.6 1.6 0 0 0-.51.3v8.3l2.65-5.89ZM17 3.5H7a.5.5 0 0 0-.5.5v18c0 .28.22.5.5.5h10a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5ZM8 7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7Zm1.5 4.5h5v-4h-5v4Z" }));
var Fuel_default = SvgFuel;
var SvgGas = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 22.75c-2.431 0-4.394-.994-5.735-2.615C4.936 18.528 4.25 16.349 4.25 14c0-4.564 2.97-8.218 6.681-11.988.474-.481 1.217-.586 1.805-.255s.884 1.021.718 1.675c-.138.548-.392 1.189-.62 1.762a7.064 7.064 0 0 1-.08.202c-.265.676-.514 1.33-.675 1.966-.334 1.316-.178 2.02.381 2.486.371.31.756.364 1.358.13.676-.264 1.425-.843 2.121-1.539a1.5 1.5 0 0 1 2.416.418c.657 1.385 1.395 3.349 1.395 5.143 0 2.35-.686 4.528-2.015 6.135C16.394 21.756 14.43 22.75 12 22.75zm-3.514-2.571A4.126 4.126 0 0 1 8.25 18.8c0-1.623.722-2.977 1.396-3.894.341-.464.681-.831.936-1.084.131-.13.268-.254.408-.374l.028-.023.008-.007.003-.002.002-.002A.749.749 0 0 1 12.25 14v.045l.002.134c.003.16.007.32.013.48.015.396.046.903.104 1.373.022.185.052.369.089.551.606-.372 1.325-.459 1.975-.167.842.379 1.317 1.279 1.317 2.384 0 .482-.083.947-.236 1.379a5.734 5.734 0 0 0 1.065-1C17.645 17.89 18.25 16.07 18.25 14c0-.953-.266-2.02-.629-3.018A17.024 17.024 0 0 0 17 9.5c-.357.358-.755.715-1.177 1.032-1.349 1.013-2.952 1.611-4.323.468-1.347-1.122-1.242-2.764-.782-4.349.202-.694.472-1.376.718-2 .236-.597.451-1.14.564-1.586a49.776 49.776 0 0 0-2.625 2.848C7.135 8.579 5.75 11.115 5.75 14c0 2.069.605 3.89 1.671 5.179.313.378.668.714 1.065 1zM12 21.25c1.198 0 2.25-1.05 2.25-2.45 0-.695-.275-.945-.433-1.016-.164-.074-.464-.076-.787.246-.202.203-.582.466-1.066.328-.414-.118-.621-.464-.713-.648-.204-.408-.308-.993-.37-1.492a13.213 13.213 0 0 1-.044-.4c-.569.78-1.087 1.816-1.087 2.982 0 1.4 1.052 2.45 2.25 2.45z" }));
var Gas_default = SvgGas;
var SvgGps = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.894 4.009C8.17 4.884 7.75 6.133 7.75 7.57c0 2.631 1.668 4.864 4.25 7.505 2.582-2.642 4.25-4.874 4.25-7.505 0-1.438-.42-2.687-1.145-3.562-.712-.86-1.75-1.402-3.105-1.402-1.356 0-2.394.541-3.106 1.402ZM7.74 3.053c.999-1.208 2.461-1.946 4.26-1.946 1.8 0 3.263.738 4.262 1.946.987 1.193 1.489 2.8 1.489 4.518 0 3.506-2.386 6.269-5.22 9.102a.75.75 0 0 1-1.06 0c-2.834-2.833-5.22-5.596-5.22-9.102 0-1.717.502-3.325 1.489-4.518ZM14.8 7.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-2.75 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-6.794 7.415a.75.75 0 0 1 .671-.415H8a.75.75 0 0 0 0-1.5H5.927a2.25 2.25 0 0 0-2.012 1.244l-1.862 3.723a1.75 1.75 0 0 0 1.565 2.533h16.764a1.75 1.75 0 0 0 1.565-2.533l-1.862-3.723a2.25 2.25 0 0 0-2.012-1.244H16a.75.75 0 0 0 0 1.5h2.073a.75.75 0 0 1 .67.415l1.863 3.723a.25.25 0 0 1-.224.362H3.618a.25.25 0 0 1-.224-.362l1.862-3.723Z" }));
var Gps_default = SvgGps;
var SvgGroup = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.1 7.457a2.741 2.741 0 0 1-2.677-2.728c0-1.478 1.2-2.701 2.677-2.729h.052a2.741 2.741 0 0 1 2.729 2.729 2.742 2.742 0 0 1-2.729 2.729l-.052-.001zm0-1.091c.898 0 1.637-.739 1.637-1.637 0-.899-.739-1.638-1.637-1.638s-1.637.739-1.637 1.638c0 .898.739 1.637 1.637 1.637zM8.081 8.204c.384-.25.832-.384 1.29-.383h5.458c.476 0 .919.14 1.29.383h5.122a2.16 2.16 0 0 1 2.15 2.15v3.723c0 .959-.777 1.737-1.737 1.737a.496.496 0 0 1-.33-.126v3.765c0 .96-.778 1.738-1.738 1.738h-1.654c-.96 0-1.737-.778-1.737-1.738v-3.496c-.28.152-.593.232-.912.231a.546.546 0 0 1-.363-.138v4.14c0 1.048-.862 1.91-1.91 1.91h-1.82a1.919 1.919 0 0 1-1.91-1.91v-4.14a.546.546 0 0 1-.363.138c-.33 0-.64-.083-.912-.23v3.495c0 .96-.777 1.738-1.737 1.738H4.614c-.96 0-1.737-.778-1.737-1.738v-3.765a.498.498 0 0 1-.331.126c-.96 0-1.737-.778-1.737-1.737v-3.723a2.16 2.16 0 0 1 2.15-2.15zm1.2 7.032V10.64a.549.549 0 0 1 .545-.523c.291 0 .534.233.546.523v9.55c.001.449.37.818.819.819h1.819a.823.823 0 0 0 .818-.819v-9.55c0-.3.246-.546.546-.546s.546.246.546.546v4.596c.1-.09.229-.14.363-.14a.823.823 0 0 0 .819-.818v-4.093c0-.703-.57-1.273-1.273-1.273H9.372c-.704 0-1.274.57-1.274 1.273v4.093c.001.449.37.818.819.819.14 0 .267.052.364.139zm7.912-5.05v4.092c0 .049-.001.099-.005.148v5.028c0 .408.336.744.744.744h1.655a.748.748 0 0 0 .744-.744v-8.687a.5.5 0 0 1 .496-.497.5.5 0 0 1 .497.497v4.18a.498.498 0 0 1 .331-.126.748.748 0 0 0 .744-.744v-3.723c0-.639-.518-1.158-1.158-1.158h-4.264c.139.301.216.636.216.99zm-9.97-.99H2.96c-.64 0-1.158.519-1.158 1.158v3.723c0 .41.333.744.744.744.127 0 .243.048.33.126v-4.18c0-.272.224-.496.496-.496.273 0 .497.224.497.496v8.686c0 .412.334.745.745.745h1.655a.748.748 0 0 0 .744-.744v-5.027a1.855 1.855 0 0 1-.006-.149v-4.092c0-.354.077-.689.216-.99zm11.536-1.323c-1.362 0-2.482-1.12-2.482-2.482s1.12-2.482 2.482-2.482 2.482 1.12 2.482 2.482-1.12 2.482-2.482 2.482zm0-.993c.817 0 1.489-.672 1.489-1.489s-.672-1.489-1.489-1.489-1.489.672-1.489 1.489.672 1.489 1.489 1.489zM2.96 5.39a2.493 2.493 0 0 1 2.481-2.432A2.493 2.493 0 0 1 7.923 5.39v.05a2.494 2.494 0 0 1-2.482 2.482A2.495 2.495 0 0 1 2.959 5.44l.001-.05zm.992 0c0 .817.672 1.489 1.489 1.489S6.93 6.207 6.93 5.39s-.672-1.489-1.489-1.489-1.489.672-1.489 1.489z" }));
var Group_default = SvgGroup;
var SvgHeart = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.5 8.496c.242 3.284 1.907 6.175 3.907 8.391 1.893 2.1 4.016 3.517 5.346 4.062 1.368-.547 3.493-1.965 5.376-4.064 1.986-2.214 3.63-5.102 3.87-8.389-.013-2.79-2.187-4.996-4.809-4.996-.641 0-1.332.355-2.05.941-.552.451-1.039.967-1.479 1.434-.128.135-.252.267-.372.391a.75.75 0 0 1-1.078 0c-.124-.128-.25-.263-.382-.402-.437-.464-.918-.975-1.466-1.423C8.647 3.855 7.957 3.5 7.31 3.5c-2.622 0-4.796 2.205-4.81 4.996ZM1 8.522C1 4.944 3.8 2 7.31 2c1.173 0 2.203.626 3.002 1.28.536.438 1.03.943 1.438 1.374.41-.43.905-.936 1.442-1.375.8-.653 1.83-1.279 2.998-1.279 3.51 0 6.31 2.944 6.31 6.522 0 .018 0 .036-.002.053-.265 3.734-2.119 6.934-4.252 9.312-2.124 2.367-4.601 4.004-6.252 4.572a.75.75 0 0 1-.493-.002c-1.598-.563-4.073-2.198-6.208-4.565-2.144-2.377-4.025-5.58-4.291-9.317A.75.75 0 0 1 1 8.522Z" }));
var Heart_default = SvgHeart;
var SvgHelp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25a10.75 10.75 0 1 0 0 21.5 10.75 10.75 0 0 0 0-21.5Zm-1.8 6.96c-.35.44-.5.94-.5 1.18a.75.75 0 0 1-1.5 0c0-.64.3-1.46.83-2.12A3.28 3.28 0 0 1 11.62 6a4 4 0 0 1 2.92 1.04c.66.66.94 1.53.94 2.35a3.2 3.2 0 0 1-1 2.41c-.26.25-.54.47-.78.66h-.01c-.26.2-.47.37-.66.55a2.3 2.3 0 0 0-.6.78c-.05.16-.06.33-.06.8a.75.75 0 0 1-1.5 0v-.06c0-.4 0-.82.15-1.25.17-.47.49-.87.96-1.33.25-.26.54-.47.78-.66l.01-.01c.26-.2.47-.36.65-.55.33-.32.56-.7.56-1.34 0-.5-.17-.95-.5-1.28-.33-.33-.9-.61-1.86-.61-.62 0-1.08.3-1.42.71Zm2.32 8.76c0 .49-.4.88-.9.88a.89.89 0 0 1-.88-.88.89.89 0 0 1 1.78 0Z" }));
var Help_default = SvgHelp;
var SvgHide = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.53 2.47a.75.75 0 0 0-1.06 1.06l16.5 16.5a.75.75 0 1 0 1.06-1.06L5.53 2.47Zm5.357 3.357A8.11 8.11 0 0 1 12 5.75c2.365 0 4.349 1.026 5.906 2.305 1.559 1.28 2.646 2.782 3.195 3.637.075.117.107.168.128.208a.165.165 0 0 1 .018.043l.001.01a.54.54 0 0 1 0 .094l-.001.01a.165.165 0 0 1-.018.043c-.021.04-.053.091-.128.208-.28.436-.703 1.045-1.261 1.71a.75.75 0 0 0 1.148.964 18.244 18.244 0 0 0 1.375-1.864l.023-.035c.12-.187.254-.395.323-.69a1.89 1.89 0 0 0 0-.787c-.069-.294-.203-.502-.323-.69l-.023-.034c-.595-.927-1.78-2.57-3.505-3.986C17.131 5.476 14.821 4.25 12 4.25a9.61 9.61 0 0 0-1.319.09.75.75 0 0 0 .206 1.487ZM6.455 7.769a.75.75 0 1 0-.91-1.193C3.6 8.06 2.275 9.886 1.637 10.882l-.023.035c-.12.187-.254.395-.323.69-.055.236-.055.55 0 .787.069.294.203.502.323.69l.023.034c.594.927 1.78 2.57 3.505 3.986C6.869 18.524 9.179 19.75 12 19.75c1.915 0 3.598-.566 5.02-1.375a.75.75 0 0 0-.74-1.304c-1.242.705-2.671 1.179-4.28 1.179-2.365 0-4.349-1.026-5.906-2.305-1.559-1.28-2.646-2.782-3.195-3.637a3.298 3.298 0 0 1-.128-.208.165.165 0 0 1-.018-.043l-.001-.01a.508.508 0 0 1 .001-.104.166.166 0 0 1 .018-.043c.021-.04.053-.091.128-.208.591-.922 1.805-2.588 3.556-3.923Zm3.6 3.033a.75.75 0 1 0-1.261-.812A3.702 3.702 0 0 0 8.203 12c0 2.082 1.71 3.75 3.797 3.75.676 0 1.313-.175 1.865-.483a.75.75 0 0 0-.73-1.31A2.32 2.32 0 0 1 12 14.25c-1.28 0-2.297-1.018-2.297-2.25 0-.441.128-.851.352-1.198Z" }));
var Hide_default = SvgHide;
var SvgHotel = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.55 2v1.25h1V2a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0V4.75h-1V6a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 1.5 0Zm-5.8 4v16.5H9V20a3 3 0 1 1 6 0v2.5h3.25V6c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 0 1 0-1.5H17A2.75 2.75 0 0 1 19.75 6v3.25h.05A2.75 2.75 0 0 1 22.55 12v10.5h.7a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h.7V12A2.75 2.75 0 0 1 4.2 9.25h.05V6A2.75 2.75 0 0 1 7 3.25h1.5a.75.75 0 0 1 0 1.5H7c-.69 0-1.25.56-1.25 1.25Zm14 16.5h1.3V12c0-.69-.56-1.25-1.25-1.25h-.05V22.5ZM13.5 20a1.5 1.5 0 0 0-3 0v2.5h3V20Zm-9.25 2.5V10.75H4.2c-.69 0-1.25.56-1.25 1.25v10.5h1.3ZM7 8.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2Zm4.5-.5h1c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Zm3.5.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2ZM7.5 13h1c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Zm3.5.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2Zm4.5-.5h1c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Z" }));
var Hotel_default = SvgHotel;
var SvgInfo = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12A9.25 9.25 0 0 1 12 2.75 9.25 9.25 0 0 1 21.25 12 9.25 9.25 0 0 1 12 21.25 9.25 9.25 0 0 1 2.75 12ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm.05 7.4a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9Zm-1.95 1.5a.75.75 0 0 1 .75-.75h1.35a.75.75 0 0 1 .694.465.751.751 0 0 1 .106.385v5.55h.85a.75.75 0 0 1 0 1.5h-3.1a.75.75 0 0 1 0-1.5h.75v-4.9h-.65a.75.75 0 0 1-.75-.75Z" }));
var Info_default = SvgInfo;
var SvgInstagram = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 3c2.44 0 2.75.01 3.71.05.96.05 1.61.2 2.19.42.6.23 1.14.58 1.59 1.04.46.45.81 1 1.04 1.6.22.57.37 1.22.42 2.18.04.96.05 1.27.05 3.71s-.01 2.75-.05 3.71a6.9 6.9 0 0 1-.42 2.19c-.23.6-.58 1.14-1.04 1.59-.45.46-1 .81-1.6 1.04a6.6 6.6 0 0 1-2.18.42c-.96.04-1.27.05-3.71.05s-2.75-.01-3.71-.05a6.63 6.63 0 0 1-2.19-.42 4.42 4.42 0 0 1-1.59-1.04 4.4 4.4 0 0 1-1.04-1.6 6.6 6.6 0 0 1-.42-2.18C3.01 14.75 3 14.45 3 12c0-2.44.01-2.75.05-3.71.05-.96.2-1.61.42-2.19.23-.6.58-1.14 1.04-1.59.45-.46 1-.81 1.6-1.04a6.6 6.6 0 0 1 2.18-.42C9.25 3.01 9.56 3 12 3Zm0 1.62c-2.4 0-2.69.01-3.64.05-.87.04-1.35.2-1.67.31-.39.15-.74.38-1.03.68-.32.31-.51.61-.68 1.03-.12.32-.27.8-.3 1.67-.05.95-.06 1.24-.06 3.64 0 2.4.01 2.69.05 3.64.04.87.2 1.35.31 1.67.15.39.38.74.68 1.03.29.3.64.53 1.03.68.32.12.8.27 1.67.3.95.05 1.24.06 3.64.06 2.4 0 2.69-.01 3.64-.05a4.99 4.99 0 0 0 1.67-.31c.39-.15.74-.38 1.03-.68.3-.29.53-.64.68-1.03.12-.32.27-.8.3-1.67.05-.95.06-1.24.06-3.64 0-2.4-.01-2.69-.05-3.64a4.99 4.99 0 0 0-.31-1.67 2.79 2.79 0 0 0-.68-1.03 2.79 2.79 0 0 0-1.03-.68c-.32-.12-.8-.27-1.67-.3-.95-.05-1.24-.06-3.64-.06Zm0 2.75a4.62 4.62 0 1 1 0 9.25 4.62 4.62 0 0 1 0-9.25ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm5.97-7.71a1.1 1.1 0 1 1-2.18 0 1.1 1.1 0 0 1 2.18 0Z" }));
var Instagram_default = SvgInstagram;
var SvgIos = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M15.727 6.667c1.364 0 2.808.745 3.835 2.03-3.368 1.853-2.822 6.68.58 7.973-.467 1.04-.692 1.505-1.295 2.427-.842 1.286-2.027 2.889-3.498 2.9-1.306.014-1.642-.853-3.415-.843-1.772.009-2.14.858-3.45.846-1.47-.013-2.593-1.46-3.435-2.745C2.697 15.66 2.45 11.44 3.9 9.195 4.933 7.601 6.56 6.67 8.09 6.67c1.556 0 2.536.857 3.825.857 1.251 0 2.012-.86 3.812-.86ZM15.34 2c.178 1.22-.313 2.415-.962 3.26-.695.907-1.893 1.608-3.052 1.572-.211-1.169.331-2.37.99-3.18.723-.893 1.963-1.578 3.024-1.652Z" }));
var Ios_default = SvgIos;
var SvgKm = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m18.442 9.5-.011-.011-.027-.03-.1-.115a25.56 25.56 0 0 1-1.413-1.785 14.196 14.196 0 0 1-1.09-1.736C15.51 5.255 15.25 4.602 15.25 4c0-2.057 1.693-3.75 3.75-3.75S22.75 1.943 22.75 4c0 .602-.26 1.255-.552 1.823a14.196 14.196 0 0 1-1.09 1.736 25.546 25.546 0 0 1-1.412 1.785l-.1.114-.027.031-.008.008-.003.003a.747.747 0 0 1-1.116 0zM19 1.75A2.261 2.261 0 0 0 16.75 4c0 .227.116.612.386 1.137.257.5.609 1.04.973 1.546.316.44.633.843.891 1.158.258-.315.575-.718.891-1.158.361-.492.686-1.008.973-1.546.27-.525.386-.91.386-1.137A2.261 2.261 0 0 0 19 1.75zM4.442 23.5l-.011-.011-.027-.03a25.62 25.62 0 0 1-1.513-1.9 14.318 14.318 0 0 1-1.09-1.736C1.51 19.255 1.25 18.602 1.25 18c0-2.057 1.693-3.75 3.75-3.75S8.75 15.943 8.75 18c0 .602-.26 1.255-.552 1.823a14.318 14.318 0 0 1-1.09 1.736 25.593 25.593 0 0 1-1.512 1.9l-.027.03-.008.008-.003.003a.747.747 0 0 1-1.116 0zM5 15.75A2.261 2.261 0 0 0 2.75 18c0 .227.116.612.386 1.137.257.5.609 1.04.973 1.546.316.44.633.843.891 1.158.258-.315.575-.718.891-1.158.361-.491.686-1.008.973-1.546.27-.525.386-.91.386-1.137A2.261 2.261 0 0 0 5 15.75zm.935-10.016c-.457.343-.685.744-.685 1.266 0 .244.102.493.393.774.305.293.78.582 1.425.866 1.248.55 2.916.99 4.682 1.455l.191.05c1.795.475 3.68.98 5.113 1.657 1.378.65 2.696 1.625 2.696 3.198 0 1.121-.492 2.002-1.226 2.66-.714.64-1.656 1.071-2.614 1.369-1.918.595-4.13.721-5.41.721-.411 0-.75-.339-.75-.75s.339-.75.75-.75c1.22 0 3.258-.124 4.965-.654.855-.265 1.569-.615 2.058-1.053.469-.42.727-.914.727-1.543 0-.599-.494-1.21-1.836-1.842-1.285-.606-3.025-1.079-4.855-1.562l-.252-.066c-1.712-.452-3.484-.919-4.843-1.517-.715-.314-1.373-.689-1.861-1.159C4.102 8.371 3.75 7.756 3.75 7c0-1.078.522-1.894 1.284-2.465.735-.552 1.7-.888 2.688-1.094 1.98-.414 4.317-.358 5.86-.186.389.03.693.358.693.748a.754.754 0 0 1-.858.742c-1.456-.161-3.62-.205-5.389.164-.888.186-1.61.462-2.093.825z" }));
var Km_default = SvgKm;
var SvgLike = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.02 9.17c.6-.4 1.18-.88 1.45-1.15.45-.46.77-.88.97-1.34.2-.45.31-.97.31-1.63V2.41c0-.5.35-1.15 1.1-1.16a6.2 6.2 0 0 1 2.49.63 3.34 3.34 0 0 1 1.47 1.68c.3.65.44 1.38.44 1.99 0 .85-.24 1.53-.47 2.1l-.1.27c-.14.32-.25.6-.32.88H21c.74 0 1.43.36 1.9.84.49.49.85 1.17.85 1.91 0 2.36-.52 4.57-1.17 6.32a11.35 11.35 0 0 1-2.05 3.71c-.43.44-1.12.62-1.73.71-.65.1-1.41.14-2.17.14-.77 0-1.57-.04-2.29-.07h-.21c-.64-.03-1.2-.06-1.63-.06a8.6 8.6 0 0 1-4.03-1.15A2.25 2.25 0 0 1 6.5 22.3h-4c-1.24 0-2.25-1-2.25-2.25v-9c0-1.24 1-2.25 2.25-2.25h4c.71 0 1.35.33 1.76.85.22-.12.48-.29.76-.48Zm4.23-6.39v2.27a5.36 5.36 0 0 1-1.72 4.04 13.57 13.57 0 0 1-2.78 2v8.5l.14.08a7.45 7.45 0 0 0 3.61 1.13c.47 0 1.06.03 1.69.05l.22.01c.72.04 1.48.07 2.21.07.74 0 1.41-.04 1.95-.12.58-.1.83-.22.9-.29.39-.39 1.09-1.52 1.7-3.17a17 17 0 0 0 1.08-5.8c0-.26-.14-.57-.4-.84-.28-.27-.6-.41-.85-.41h-5c-.66 0-1.32-.56-1.2-1.36.09-.61.31-1.16.5-1.62l.09-.22a4 4 0 0 0 .36-1.55c0-.4-.1-.91-.31-1.38-.21-.48-.5-.8-.78-.95a5.09 5.09 0 0 0-1.41-.44ZM6.5 10.3h-4a.75.75 0 0 0-.75.75v9c0 .41.34.75.75.75h4c.41 0 .75-.34.75-.75v-9a.75.75 0 0 0-.75-.75ZM5 19.55a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" }));
var Like_default = SvgLike;
var SvgLocateMe = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m20.045 3.955-15.8 6.166 6.322 2.458.024.01c.083.031.228.087.357.179.11.078.206.174.284.284.092.129.148.274.18.357l.009.024 2.458 6.322 6.166-15.8Zm.107-1.634c.166-.048.463-.122.775-.018.364.121.649.406.77.77.104.312.03.61-.018.775a8.002 8.002 0 0 1-.225.622l-6.19 15.862c-.099.254-.19.489-.279.668-.079.159-.234.451-.545.613a1.218 1.218 0 0 1-1.124 0c-.31-.163-.466-.455-.544-.614a9.504 9.504 0 0 1-.279-.669l-2.47-6.353-6.353-2.47a9.041 9.041 0 0 1-.67-.279c-.159-.078-.451-.233-.613-.544a1.218 1.218 0 0 1 0-1.124c.16-.31.453-.466.612-.545.18-.089.414-.18.668-.28l15.862-6.19c.227-.088.443-.172.622-.224Z" }));
var LocateMe_default = SvgLocateMe;
var SvgLocation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.75 1a.75.75 0 0 0-1.5 0v1.278a9.752 9.752 0 0 0-8.972 8.972H1a.75.75 0 0 0 0 1.5h1.278a9.752 9.752 0 0 0 8.972 8.972V23a.75.75 0 0 0 1.5 0v-1.278a9.752 9.752 0 0 0 8.972-8.972H23a.75.75 0 0 0 0-1.5h-1.278a9.752 9.752 0 0 0-8.972-8.972V1ZM3.784 11.25a8.252 8.252 0 0 1 7.466-7.466V5a.75.75 0 0 0 1.5 0V3.784a8.252 8.252 0 0 1 7.466 7.466H19a.75.75 0 0 0 0 1.5h1.216a8.252 8.252 0 0 1-7.466 7.466V19a.75.75 0 0 0-1.5 0v1.216a8.252 8.252 0 0 1-7.466-7.466H5a.75.75 0 0 0 0-1.5H3.784ZM12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm2-3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }));
var Location_default = SvgLocation;
var SvgLocked = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.25 7.556C6.25 4.149 8.752 1.25 12 1.25s5.75 2.9 5.75 6.306v1.589c.35.065.675.17.982.343a3.937 3.937 0 0 1 1.623 1.797c.216.473.308.985.352 1.582.043.583.043 1.306.043 2.215v1.615c0 .908 0 1.63-.043 2.214-.044.596-.136 1.109-.352 1.582a3.937 3.937 0 0 1-1.623 1.796c-.451.256-.94.362-1.494.412-.534.049-1.193.049-2.003.049h-6.47c-.81 0-1.469 0-2.003-.049-.554-.05-1.043-.156-1.493-.412a3.937 3.937 0 0 1-1.624-1.796c-.216-.473-.308-.986-.352-1.582-.043-.583-.043-1.306-.043-2.215v-1.615c0-.908 0-1.63.043-2.214.044-.597.136-1.11.352-1.582A3.936 3.936 0 0 1 5.27 9.488c.306-.173.63-.278.981-.343v-1.59Zm1.5 1.476c.309-.004.646-.004 1.015-.004h6.47c.369 0 .706 0 1.015.004V7.556c0-2.73-1.975-4.806-4.25-4.806S7.75 4.825 7.75 7.556v1.476Zm-.853 1.538c-.447.04-.699.116-.89.224a2.437 2.437 0 0 0-.998 1.116c-.11.24-.182.551-.22 1.067-.039.522-.039 1.19-.039 2.134v1.556c0 .944 0 1.612.039 2.134.038.515.11.826.22 1.066.226.494.58.88.999 1.117.19.108.442.183.89.224.458.041 1.048.042 1.902.042h6.4c.854 0 1.444 0 1.903-.042.447-.04.698-.116.89-.224.418-.237.772-.623.998-1.117.11-.24.182-.55.22-1.066.039-.522.039-1.19.039-2.134V15.11c0-.945 0-1.612-.039-2.134-.038-.516-.11-.826-.22-1.067a2.437 2.437 0 0 0-.998-1.116c-.191-.108-.443-.183-.89-.224-.459-.042-1.05-.042-1.903-.042H8.8c-.854 0-1.444 0-1.903.042Zm6.072 6.18a2 2 0 1 0-1.938 0c-.02.08-.031.164-.031.25v1a1 1 0 1 0 2 0v-1c0-.086-.01-.17-.031-.25Z" }));
var Locked_default = SvgLocked;
var SvgLuggage = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.35 3.25c0-.911.739-1.65 1.65-1.65h2c.911 0 1.65.739 1.65 1.65v1H18c1.097 0 2 .903 2 2v7c0 .265-.052.518-.145.75h.645c1.097 0 2 .903 2 2v4c0 1.097-.903 2-2 2h-17c-1.097 0-2-.903-2-2v-4c0-1.097.903-2 2-2h.645A2.006 2.006 0 0 1 4 13.25v-7c0-1.097.903-2 2-2h3.35zM18 5.55H6c-.384 0-.7.316-.7.7v7c0 .384.316.7.7.7h12c.384 0 .7-.316.7-.7v-7c0-.384-.316-.7-.7-.7zm-4.65-2.3A.352.352 0 0 0 13 2.9h-2a.352.352 0 0 0-.35.35v1h2.7zM10.65 19c0 .192.158.35.35.35h2c.192 0 .35-.158.35-.35v-.5h-2.7zm4-.5v.5c0 .905-.745 1.65-1.65 1.65h-2A1.65 1.65 0 0 1 9.35 19v-.5H2.8V20c0 .384.316.7.7.7h17c.384 0 .7-.316.7-.7v-1.5zM3.5 15.3c-.384 0-.7.316-.7.7v1.5h18.4V16c0-.384-.316-.7-.7-.7z" }));
var Luggage_default = SvgLuggage;
var SvgMapView = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.646 1.339A.75.75 0 0 0 1.25 2v16c0 .284.16.544.415.67l6 3a.75.75 0 0 0 .63.02l6.657-2.854 6.676 3.815A.75.75 0 0 0 22.75 22V6a.75.75 0 0 0-.455-.69l-7-3a.75.75 0 0 0-.59 0L8.078 5.15 2.416 1.377a.75.75 0 0 0-.77-.037ZM8.75 6.495l5.5-2.358v13.369l-5.5 2.357V6.495Zm-1.5 13.291-4.5-2.25V3.402l4.5 3v13.386Zm8.5-2.221V4.137l5.5 2.358v14.213l-5.5-3.143Z" }));
var MapView_default = SvgMapView;
var SvgMenu = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.25 7c0-.41.34-.75.75-.75h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 7Zm0 5c0-.41.34-.75.75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM3 16.25h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5Z" }));
var Menu_default = SvgMenu;
var SvgMessenger = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.11 22.11a9.93 9.93 0 0 1-5.26-1.5L3.3 21.95a.89.89 0 0 1-1.14-1.15l1.34-3.58a10.01 10.01 0 1 1 18.6-5.1c0 5.5-4.49 9.99-10 9.99Zm-5.16-3.38a.8.8 0 0 1 .5.16 8.23 8.23 0 1 0 4.65-15 8.23 8.23 0 0 0-6.86 12.74c.16.24.2.54.1.8l-.82 2.16 2.12-.8a.9.9 0 0 1 .31-.06Zm.83-4.1a.73.73 0 0 1-.53-1.24l3.64-3.81a.74.74 0 0 1 1.04-.02l1.39 1.34 2.54-1.3a.73.73 0 0 1 .88 1.15l-3.33 3.64a.74.74 0 0 1-1.04.04l-1.49-1.4-2.75 1.5a.73.73 0 0 1-.35.1Z" }));
var Messenger_default = SvgMessenger;
var SvgMoney = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25ZM4.42 14.18c.16.147.353.22.58.22l1.26.008c.059.202.125.4.2.592.36.88.847 1.633 1.46 2.26a6.364 6.364 0 0 0 2.12 1.44 6.74 6.74 0 0 0 2.58.5c.427 0 .847-.047 1.26-.14a6.75 6.75 0 0 0 1.18-.38 6.55 6.55 0 0 0 1.02-.56.663.663 0 0 0 .38-.5c.053-.24-.007-.467-.18-.68a.691.691 0 0 0-.48-.28.935.935 0 0 0-.56.1 4.273 4.273 0 0 1-2.62.86c-.933 0-1.787-.22-2.56-.66-.773-.453-1.387-1.1-1.84-1.94a5.286 5.286 0 0 1-.273-.602l3.453.022c.227 0 .42-.073.58-.22a.704.704 0 0 0 .24-.54.726.726 0 0 0-.24-.56.828.828 0 0 0-.58-.22l-3.814-.024a8.053 8.053 0 0 1-.036-1.28l3.85.024c.227 0 .42-.073.58-.22a.704.704 0 0 0 .24-.54.726.726 0 0 0-.24-.56.828.828 0 0 0-.58-.22l-3.593-.023c.102-.337.233-.656.393-.957a4.878 4.878 0 0 1 1.82-1.96c.773-.48 1.64-.72 2.6-.72.493 0 .96.08 1.4.24.453.147.867.353 1.24.62.187.093.373.133.56.12a.596.596 0 0 0 .46-.28c.16-.2.22-.42.18-.66a.721.721 0 0 0-.4-.54 5.57 5.57 0 0 0-1.62-.8 5.966 5.966 0 0 0-1.82-.28c-.947 0-1.827.18-2.64.54a6.68 6.68 0 0 0-2.14 1.5 6.871 6.871 0 0 0-1.4 2.26 7.148 7.148 0 0 0-.28.907L5 10.04a.828.828 0 0 0-.58.22.726.726 0 0 0-.24.56c0 .213.08.393.24.54.16.147.353.22.58.22l.949.006a9.829 9.829 0 0 0 .028 1.28L5 12.86a.828.828 0 0 0-.58.22.726.726 0 0 0-.24.56c0 .213.08.393.24.54Z" }));
var Money_default = SvgMoney;
var SvgNext = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm-.53 7.28a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H8a.75.75 0 0 1 0-1.5h6.19l-2.72-2.72Z" }));
var Next_default = SvgNext;
var SvgNoInternet = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4.53 2.47a.75.75 0 0 0-1.06 1.06l16.5 16.5a.75.75 0 1 0 1.06-1.06L4.53 2.47ZM12 5.75c-.544 0-1.081.028-1.61.084a.75.75 0 1 1-.156-1.492c.58-.06 1.17-.092 1.766-.092 4.36 0 8.333 1.667 11.313 4.398A.75.75 0 1 1 22.3 9.754 15.192 15.192 0 0 0 12 5.75Zm-6.6.651a.75.75 0 0 1-.327 1.01A15.287 15.287 0 0 0 1.7 9.753.75.75 0 0 1 .687 8.648 16.787 16.787 0 0 1 4.39 6.074a.75.75 0 0 1 1.009.327Zm8.161 3.683a.75.75 0 0 1 .89-.578 11.716 11.716 0 0 1 5.313 2.674.75.75 0 0 1-.992 1.126 10.216 10.216 0 0 0-4.633-2.333.75.75 0 0 1-.578-.889Zm-4.6.315a.75.75 0 0 1-.45.96 10.244 10.244 0 0 0-3.283 1.947.75.75 0 0 1-.992-1.126A11.742 11.742 0 0 1 8 9.95a.75.75 0 0 1 .96.45ZM12 15.75c-1.24 0-2.378.429-3.276 1.147a.75.75 0 1 1-.937-1.171 6.725 6.725 0 0 1 5.152-1.411.75.75 0 0 1-.207 1.486A5.304 5.304 0 0 0 12 15.75ZM11 20a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z" }));
var NoInternet_default = SvgNoInternet;
var SvgNoSuitcase = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5zm1.768-15.13v-.753a.643.643 0 0 0-.64-.639h-2.257a.643.643 0 0 0-.64.64v.752zm-7.794 8.802 8.725-7.824H5.981a.526.526 0 0 0-.526.527v6.77a.53.53 0 0 0 .519.527zm10.974-7.824-8.727 7.824h9.797a.53.53 0 0 0 .527-.527V8.874a.527.527 0 0 0-.527-.526zM15.79 7.37l2.264-2.03a9 9 0 0 0-6.059-2.345c-4.938 0-9 4.062-9 9 0 1.904.604 3.761 1.726 5.3l.435-.39a1.506 1.506 0 0 1-.68-1.26V8.874c0-.831.674-1.504 1.504-1.504h3.274v-.753c0-.893.724-1.617 1.617-1.617h2.256c.894 0 1.618.724 1.618 1.617v.753zm2.248 0c.822.012 1.484.68 1.484 1.505v6.77c0 .831-.674 1.505-1.505 1.505H7.13l-1.428 1.28A9.005 9.005 0 0 0 12 21.001c4.937 0 9-4.063 9-9.001a8.968 8.968 0 0 0-1.923-5.561z" }));
var NoSuitcase_default = SvgNoSuitcase;
var SvgPause = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.5 6A.75.75 0 0 0 8 6v12a.75.75 0 0 0 1.5 0V6Zm6 0A.75.75 0 0 0 14 6v12a.75.75 0 0 0 1.5 0V6Z" }));
var Pause_default = SvgPause;
var SvgPhone = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m5.198 2.539-.09.048-.126.076-.12.083-.126.099-.142.124-.17.16-.466.46-.46.463-.246.256a3.495 3.495 0 0 0-.534.713c-.28.5-.47 1.227-.468 1.8 0 .24.016.419.063.653l.06.257.085.32.054.191c.966 3.404 2.434 6.162 4.655 8.384 2.154 2.153 5.006 3.766 8.122 4.723l.634.185.372.1.182.043.164.03.084.012c.149.02.296.03.454.031.573.002 1.3-.188 1.8-.468.12-.067.232-.14.344-.224l.129-.1.128-.108.227-.21.452-.446.44-.442.235-.243a3.37 3.37 0 0 0 .434-.539l.093-.168a2.685 2.685 0 0 0 0-2.423l-.076-.14a2.05 2.05 0 0 0-.04-.066l-.092-.132-.114-.143-.148-.166-.306-.317-.775-.774-.21-.197-.111-.092-.165-.117a2.685 2.685 0 0 0-2.927 0 2.566 2.566 0 0 0-.35.277l-.22.212-.366.36a.275.275 0 0 1-.143.037l-.049-.007-.138-.063a13.376 13.376 0 0 1-3.674-2.608A13.392 13.392 0 0 1 9.151 9.17l-.267-.544a.275.275 0 0 1 .012-.148l.02-.04.358-.362c.25-.255.379-.4.491-.574a2.685 2.685 0 0 0 0-2.927l-.075-.109-.083-.106-.105-.12-.23-.24-.878-.872-.17-.16-.142-.124-.126-.1-.12-.082-.181-.107-.034-.017a2.685 2.685 0 0 0-2.423 0Zm1.617 1.283.153.069.072.046.085.065.175.157.38.372.585.586.164.175.058.072c.008.01.014.02.02.03.256.393.256.899 0 1.292l-.023.034-.074.088-.12.129-.435.44-.044.047-.114.142a1.761 1.761 0 0 0-.253 1.48l.029.09.036.092.088.19a14.876 14.876 0 0 0 2.9 4.085 14.893 14.893 0 0 0 3.678 2.697l.547.27.143.057.09.029a1.77 1.77 0 0 0 1.335-.16l.165-.108.122-.1.105-.1.383-.38.127-.118.088-.073a1.185 1.185 0 0 1 1.205-.093l.122.07.055.039.114.1.282.275.706.71.133.142.096.11.067.084.045.07.017.032c.17.336.17.733 0 1.07l-.049.081-.034.047-.096.115-.14.153-.197.202-.805.802-.188.176-.142.12-.044.033a1.69 1.69 0 0 1-.183.12 2.535 2.535 0 0 1-1.06.275 1.85 1.85 0 0 1-.254-.017l-.11-.018-.124-.027-.266-.07-.262-.073c-3.065-.87-5.871-2.411-7.94-4.48-1.922-1.922-3.235-4.306-4.134-7.261l-.183-.629-.069-.253-.046-.192-.028-.15-.014-.13-.004-.134c0-.313.122-.786.276-1.06l.035-.06.081-.12.106-.131.067-.076.167-.178.224-.228.632-.63.22-.211.151-.133.11-.08.056-.031c.294-.15.635-.168.94-.056Z" }));
var Phone_default = SvgPhone;
var SvgPickupReturn = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.689 3c2.035 0 3.678.832 4.801 2.188 1.113 1.346 1.687 3.17 1.687 5.137 0 3.991-2.716 7.161-6.044 10.49a.63.63 0 0 1-.888 0C3.916 17.486 1.2 14.316 1.2 10.325c0-1.965.575-3.791 1.687-5.135C4.01 3.832 5.653 3 7.689 3zm-5.233 7.326c0 3.255 2.107 5.98 5.233 9.155 3.126-3.175 5.233-5.901 5.233-9.155 0-1.733-.507-3.257-1.4-4.336-.883-1.067-2.17-1.734-3.833-1.734-1.664 0-2.951.667-3.834 1.734-.893 1.079-1.399 2.603-1.399 4.336zm5.232 2.93c-1.607 0-2.93-1.323-2.93-2.93s1.323-2.93 2.93-2.93 2.93 1.323 2.93 2.93-1.323 2.93-2.93 2.93zm1.675-2.93c0-.919-.756-1.675-1.675-1.675-.918 0-1.674.756-1.674 1.675S6.77 12 7.688 12c.919 0 1.675-.755 1.675-1.674zm13.15 7.024-3.259 3.259a.641.641 0 0 1-1.082-.461.64.64 0 0 1 .178-.442l2.169-2.169h-5.68c-.351 0-.639-.288-.639-.639s.288-.639.639-.639h5.68l-2.169-2.168a.637.637 0 0 1-.197-.461.64.64 0 0 1 1.1-.443l3.26 3.259a.64.64 0 0 1 0 .904zm-8.126-9.796a.64.64 0 0 1 0-.904l3.26-3.26a.64.64 0 1 1 .903.904l-2.169 2.169h5.68c.351 0 .639.288.639.639s-.288.639-.639.639h-5.68l2.17 2.168a.64.64 0 0 1-.904.904z" }));
var PickupReturn_default = SvgPickupReturn;
var SvgPickupStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M16.47 3.53a.752.752 0 0 1-.201-.511c0-.412.338-.75.75-.75.189 0 .372.072.511.201l4 4a.753.753 0 0 1 0 1.06l-4 4a.752.752 0 0 1-.549.239.754.754 0 0 1-.75-.75c0-.208.087-.407.239-.549l2.72-2.72H8c-.411 0-.75-.339-.75-.75s.339-.75.75-.75h11.19zM7.53 20.47a.752.752 0 0 1 .239.549c0 .411-.339.75-.75.75a.752.752 0 0 1-.549-.239l-4-4a.753.753 0 0 1 0-1.06l4-4a.752.752 0 0 1 .511-.201c.412 0 .75.338.75.75a.752.752 0 0 1-.201.511l-2.72 2.72H16c.411 0 .75.339.75.75s-.339.75-.75.75H4.81z" }));
var PickupStation_default = SvgPickupStation;
var SvgPickup = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.488 3h.002c2.034 0 3.677.832 4.799 2.188 1.113 1.346 1.688 3.17 1.688 5.137 0 3.991-2.715 7.161-6.045 10.49a.63.63 0 0 1-.888 0C3.716 17.486 1 14.316 1 10.325c0-1.965.573-3.791 1.688-5.135C3.81 3.832 5.453 3 7.488 3zm-5.232 7.326c0 3.255 2.106 5.98 5.232 9.155 3.126-3.175 5.233-5.901 5.233-9.155 0-1.733-.506-3.257-1.399-4.336-.883-1.067-2.17-1.734-3.834-1.734-1.663 0-2.951.667-3.833 1.734-.893 1.079-1.399 2.603-1.399 4.336zm5.232 2.93c-1.607 0-2.93-1.323-2.93-2.93s1.323-2.93 2.93-2.93 2.93 1.323 2.93 2.93-1.323 2.93-2.93 2.93zm1.675-2.93c0-.919-.756-1.675-1.675-1.675s-1.675.756-1.675 1.675.756 1.675 1.675 1.675 1.675-.756 1.675-1.675zm13.65 1.12c.25.25.25.654 0 .904l-4.26 4.26a.64.64 0 1 1-.903-.904l3.169-3.169h-5.68c-.351 0-.639-.288-.639-.639s.288-.639.639-.639h5.68L17.65 8.091a.64.64 0 0 1 .904-.904z" }));
var Pickup_default = SvgPickup;
var SvgPinterest = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.996 2A9.99 9.99 0 0 0 2 11.996a10 10 0 0 0 6.351 9.313c-.09-.79-.164-2.008.033-2.871.181-.782 1.168-4.97 1.168-4.97s-.296-.6-.296-1.48c0-1.39.806-2.427 1.81-2.427.856 0 1.267.641 1.267 1.406 0 .856-.543 2.14-.83 3.332-.24.996.501 1.81 1.48 1.81 1.777 0 3.143-1.875 3.143-4.574 0-2.394-1.72-4.064-4.18-4.064-2.846 0-4.516 2.13-4.516 4.336 0 .855.329 1.777.74 2.279.083.098.09.189.066.287-.074.313-.247.996-.28 1.136-.04.18-.148.222-.337.131-1.234-.592-2.007-2.418-2.007-3.883 0-3.15 2.287-6.047 6.606-6.047 3.464 0 6.162 2.469 6.162 5.776 0 3.447-2.172 6.22-5.183 6.22-1.012 0-1.966-.527-2.287-1.152l-.625 2.377c-.223.872-.831 1.958-1.243 2.625.938.288 1.925.444 2.962.444C17.524 22 22 17.524 22 12.004 21.992 6.476 17.516 2 11.996 2Z" }));
var Pinterest_default = SvgPinterest;
var SvgPlay = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.508 6.882v10.236L16.382 12 8.508 6.882Zm-1.5-.46a1.25 1.25 0 0 1 1.931-1.049l8.583 5.579a1.25 1.25 0 0 1 0 2.096l-8.583 5.579a1.25 1.25 0 0 1-1.931-1.049V6.421Z" }));
var Play_default = SvgPlay;
var SvgRearWheelDrive = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6 4h3.44a2.75 2.75 0 0 1 5.12 0H18V2.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 18 7.5V6h-3.44c-.3.8-.98 1.41-1.81 1.65v8.7c.92.26 1.64.98 1.9 1.9H18V16.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-1.75h-3.35a2.75 2.75 0 0 1-5.21.25H6v1.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 1 21.5v-5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5V18h3.44c.3-.8.98-1.41 1.81-1.65v-8.7A2.75 2.75 0 0 1 9.44 6H6v1.5C6 8.33 5.33 9 4.5 9h-2A1.5 1.5 0 0 1 1 7.5v-5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5V4Zm15.5-1.5h-2v5h2v-5ZM12 17.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0-14a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM4.5 2.5h-2v5h2v-5Z" }));
var RearWheelDrive_default = SvgRearWheelDrive;
var SvgReload = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.21 3.3a.75.75 0 0 1 .918-.531l2.732.732a.75.75 0 0 1 .53.919l-.732 2.732a.75.75 0 0 1-1.448-.389l.287-1.07a7.75 7.75 0 0 0 3.69 14.015.75.75 0 1 1-.16 1.492 9.238 9.238 0 0 1-7.038-4.575A9.25 9.25 0 0 1 6.642 4.46l-.902-.241a.75.75 0 0 1-.53-.919Zm6.937.167a.75.75 0 0 1 .825-.666 9.238 9.238 0 0 1 7.039 4.574 9.253 9.253 0 0 1-2.652 12.166l.901.241a.75.75 0 0 1-.388 1.45l-2.732-.733a.75.75 0 0 1-.53-.918l.732-2.732a.75.75 0 0 1 1.449.388l-.288 1.071a7.75 7.75 0 0 0-3.69-14.016.75.75 0 0 1-.666-.825Z" }));
var Reload_default = SvgReload;
var SvgRequested = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm-.274 5.562a.75.75 0 0 0-1.452.376l1.347 5.207a1.75 1.75 0 0 0 1.314 1.27l3.902.867a.75.75 0 1 0 .326-1.464L13.26 12.2a.25.25 0 0 1-.188-.182l-1.347-5.207Z" }));
var Requested_default = SvgRequested;
var SvgReturn = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.488 3h.002c2.034 0 3.677.832 4.799 2.188 1.113 1.346 1.688 3.17 1.688 5.137 0 3.991-2.715 7.161-6.045 10.49a.63.63 0 0 1-.888 0C3.716 17.486 1 14.316 1 10.325c0-1.965.573-3.791 1.688-5.135C3.81 3.832 5.453 3 7.488 3zm-5.232 7.326c0 3.255 2.106 5.98 5.232 9.155 3.126-3.175 5.233-5.901 5.233-9.155 0-1.733-.506-3.257-1.399-4.336-.883-1.067-2.17-1.734-3.834-1.734-1.663 0-2.951.667-3.833 1.734-.893 1.079-1.399 2.603-1.399 4.336zm5.232 2.93c-1.607 0-2.93-1.323-2.93-2.93s1.323-2.93 2.93-2.93 2.93 1.323 2.93 2.93-1.323 2.93-2.93 2.93zm1.675-2.93c0-.919-.756-1.675-1.675-1.675s-1.675.756-1.675 1.675.756 1.675 1.675 1.675 1.675-.756 1.675-1.675zm5.524 1.12 4.259-4.259a.64.64 0 0 1 .904.904l-3.169 3.168h5.68c.351 0 .639.288.639.639s-.288.639-.639.639h-5.68l3.169 3.169c.126.12.197.287.197.461a.64.64 0 0 1-1.1.443l-4.26-4.26a.64.64 0 0 1 0-.904z" }));
var Return_default = SvgReturn;
var SvgRoofBox = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11 7.25c2.73 0 6.1.28 8.25 1.04 1.35.49 2.77 1.67 3.76 2.6a1.62 1.62 0 0 1 .24 2.12c0 .08-.02.17-.05.25l-1.25 3.35a1.75 1.75 0 0 1-1.64 1.14H4.6c-.65 0-1.26-.38-1.56-.97l-1.57-3.15c-.71-.27-1.2-1-1.12-1.8l.08-.8v-.05l-.1-1.04A1.7 1.7 0 0 1 1.7 8.08c1.52-.3 4.9-.83 9.3-.83Zm-9.01 2.3c-.1.02-.17.1-.16.24l.1 1.04c.02.11.02.23 0 .34l-.07.8c-.02.15.1.28.24.28h19.72c.07 0 .11-.02.14-.04a.17.17 0 0 0 .06-.07.12.12 0 0 0 .01-.07 10.78 10.78 0 0 0-3.28-2.36c-1.89-.68-5.06-.96-7.75-.96-4.28 0-7.56.53-9.01.8Zm19.43 4.2H3.22l1.17 2.36c.05.09.13.14.23.14H20.3c.1 0 .2-.06.23-.16l.88-2.34Z" }));
var RoofBox_default = SvgRoofBox;
var SvgRoofRack = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.75 7.75v.5h10.5v-.5a.75.75 0 0 1 1.5 0v.5h1.75a3.5 3.5 0 1 1 0 7h-1.75v2a.75.75 0 0 1-1.5 0v-2H6.75v2a.75.75 0 0 1-1.5 0v-2H3.5a3.5 3.5 0 1 1 0-7h1.75v-.5a.75.75 0 0 1 1.5 0Zm0 2v4h4.5v-4h-4.5Zm12 4h1.75a2 2 0 1 0 0-4h-1.75v4Zm-1.5-4h-4.5v4h4.5v-4Zm-12 0H3.5a2 2 0 1 0 0 4h1.75v-4Z" }));
var RoofRack_default = SvgRoofRack;
var SvgSearch = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M10 3.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5ZM2.25 10a7.75 7.75 0 1 1 13.735 4.924l5.545 5.546a.75.75 0 1 1-1.06 1.06l-5.546-5.545A7.75 7.75 0 0 1 2.25 10Z" }));
var Search_default = SvgSearch;
var SvgSeatExtension = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m11.738 5.818-.308-.003-.299.005c-3.282.086-7.28 1.33-8.346 2.636-.423.519-.604 1.17-.619 1.887a4.61 4.61 0 0 0 .11 1.112l.588 5.417a.99.99 0 0 0 .987.878h15.292c.876 0 1.791-.4 2.476-1.067.775-.754 1.262-1.817 1.262-3.194 0-.824-.306-1.627-.871-2.316-.916-1.117-2.925-2.221-4.823-2.221-1.791 0-2.634.22-3.931.842l-.436.233-1.466.817-.7.38-.377.19c-.852.407-1.057.354-1.813-.376l-.07-.075a1.03 1.03 0 0 1-.18-.311l-.006-.024.091-.036c.674-.248 2.457-.524 3.427-.532.643-.005 1.218-.223 1.639-.64.388-.385.604-.903.607-1.454.007-1.167-.912-2.122-2.234-2.148Zm-.58 1.502.273-.005.286.003c.489.01.757.288.755.64a.557.557 0 0 1-.164.398c-.128.127-.326.202-.594.204-1.34.01-3.656.39-4.388.84a1.287 1.287 0 0 0-.62.975c-.068.594.231 1.274.716 1.742 1.12 1.082 1.952 1.333 3.306.74l.32-.15.125-.063.637-.338 2.038-1.131.056-.028c1.107-.531 1.735-.695 3.283-.695 1.411 0 3.014.88 3.663 1.672.352.429.53.9.53 1.365 0 .955-.311 1.637-.806 2.118l-.143.129c-.393.325-.87.514-1.288.514H4.304l-.552-5.046c-.148-.663-.133-1.398.195-1.8.731-.896 4.324-2.002 7.212-2.084Z" }));
var SeatExtension_default = SvgSeatExtension;
var SvgSeats = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4.76 17.91c-.4-1.2-.98-2.7-1.53-4.1L3 13.25a80.9 80.9 0 0 1-1.17-3.1 3.68 3.68 0 0 1 0-2.11C2 7.49 2.3 6.9 2.8 6.5a2 2 0 0 1-.28-1.65l.51-1.93A2 2 0 0 1 6.9 3.97L6.38 5.9l-.08.25c.37.2.7.5.92.93.17.34.28.77.36 1.17.09.41.15.87.21 1.3.07.45.13.87.2 1.23.08.38.15.64.23.8.2.4.46.82.74 1.27l.48.8c.22.36.42.74.58 1.1.15.36.28.76.28 1.16 0 .53-.15 1-.36 1.39a99.5 99.5 0 0 1 4.41-.93c2.1-.4 4.12-.7 5.2-.7a2.6 2.6 0 0 1 2.21 1.13 3 3 0 0 1 .54 1.61c0 .35-.14 1.43-.47 2.43-.17.5-.4 1.05-.74 1.48-.33.43-.84.84-1.54.84H10.5l-.6-.04-.38-.03a5.14 5.14 0 0 1-.85-.12c-.5-.13-.92-.37-1.38-.78a2.5 2.5 0 0 1-2.52-4.28ZM4.5 7.38c-.21.04-.43.11-.61.2-.25.13-.48.43-.61.88a2.2 2.2 0 0 0-.02 1.22c.22.63.65 1.74 1.15 3.02l.22.57c.54 1.4 1.13 2.92 1.55 4.15h.07c.5 0 .96.14 1.35.39l.07-.07c.24-.24.5-.49.72-.79.26-.36.41-.7.41-1.04 0-.1-.04-.28-.16-.57a8.97 8.97 0 0 0-.5-.94l-.4-.68c-.3-.5-.63-1.02-.86-1.47a4.79 4.79 0 0 1-.36-1.17c-.08-.41-.15-.87-.2-1.3H6.3a15.1 15.1 0 0 0-.2-1.23 3.39 3.39 0 0 0-.23-.8c-.1-.2-.32-.36-.72-.4-.1-.01-.2-.02-.3-.01a2.2 2.2 0 0 1-.36.04Zm.12-1.53a.5.5 0 0 0 .31-.34l.52-1.93a.5.5 0 1 0-.97-.26l-.51 1.93a.5.5 0 0 0 .42.63l.23-.03ZM8.4 21.18c.25.2.43.29.62.33.15.04.33.06.6.08l.32.03.63.04h8.97c.05 0 .17-.02.35-.26.19-.24.36-.6.5-1.03.3-.88.4-1.8.4-1.96 0-.1-.06-.45-.27-.76a1.1 1.1 0 0 0-.98-.48c-.92 0-2.8.27-4.92.67a91.55 91.55 0 0 0-6 1.32 2.5 2.5 0 0 1-.22 2.02Zm-2.16-.26a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }));
var Seats_default = SvgSeats;
var SvgSettings = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M13.515 23h-3.03c-.62 0-1.153-.463-1.24-1.076l-.212-1.493a9.076 9.076 0 0 1-.9-.373l-1.186.892a1.26 1.26 0 0 1-1.638-.116L3.166 18.69a1.258 1.258 0 0 1-.116-1.638l.892-1.186a8.845 8.845 0 0 1-.373-.9l-1.493-.211A1.259 1.259 0 0 1 1 13.516v-3.031c0-.62.463-1.153 1.076-1.24l1.493-.212a8.94 8.94 0 0 1 .372-.899L3.05 6.947a1.259 1.259 0 0 1 .116-1.638l2.143-2.143a1.259 1.259 0 0 1 1.638-.116l1.187.892a8.95 8.95 0 0 1 .899-.373l.212-1.493A1.259 1.259 0 0 1 10.485 1h3.03c.62 0 1.153.463 1.24 1.076l.212 1.493c.306.108.608.232.9.372l1.186-.891a1.259 1.259 0 0 1 1.638.116l2.143 2.143a1.26 1.26 0 0 1 .116 1.638l-.892 1.187c.14.29.265.592.372.898l1.494.212A1.26 1.26 0 0 1 23 10.484v3.031c0 .62-.463 1.153-1.076 1.24l-1.493.212a9.076 9.076 0 0 1-.373.899l.892 1.187a1.26 1.26 0 0 1-.116 1.638l-2.143 2.143a1.259 1.259 0 0 1-1.638.116l-1.187-.892c-.291.14-.593.265-.898.373l-.213 1.493A1.259 1.259 0 0 1 13.515 23zm-2.91-1.392h2.79l.207-1.457c.066-.47.389-.857.84-1.01.301-.104.598-.226.882-.366.43-.21.931-.164 1.31.12l1.158.87 1.972-1.972-.87-1.158a1.251 1.251 0 0 1-.12-1.31c.14-.284.263-.581.366-.882a1.252 1.252 0 0 1 1.01-.84l1.458-.208v-2.789l-1.458-.207a1.25 1.25 0 0 1-1.01-.84 7.58 7.58 0 0 0-.366-.883c-.21-.429-.164-.93.12-1.31l.87-1.158-1.972-1.972-1.158.87c-.38.285-.881.33-1.31.12a7.422 7.422 0 0 0-.882-.365 1.251 1.251 0 0 1-.84-1.01l-.208-1.459h-2.789l-.207 1.458c-.067.47-.389.857-.84 1.01a7.55 7.55 0 0 0-.883.366c-.428.21-.93.165-1.31-.12l-1.157-.87-1.973 1.972.87 1.159c.285.379.33.88.12 1.31-.14.284-.263.58-.365.881a1.25 1.25 0 0 1-1.01.84l-1.459.208v2.79l1.458.206c.47.067.857.39 1.01.84.104.301.226.598.366.883.21.429.165.93-.12 1.31l-.87 1.158 1.973 1.972 1.158-.87c.379-.285.88-.33 1.31-.12.284.14.58.263.881.365.452.154.774.542.84 1.011l.208 1.458zm1.401-4.293a5.332 5.332 0 0 1-3.762-1.558A5.333 5.333 0 0 1 6.69 11.75a5.295 5.295 0 0 1 1.554-3.506 5.295 5.295 0 0 1 3.507-1.554 5.33 5.33 0 0 1 4.005 1.553 5.333 5.333 0 0 1 1.553 4.005 5.294 5.294 0 0 1-1.554 3.507 5.294 5.294 0 0 1-3.749 1.559zm-.003-9.238c-.062 0-.125.001-.187.004-2.003.092-3.643 1.732-3.735 3.734a3.884 3.884 0 0 0 1.147 2.958 3.886 3.886 0 0 0 2.957 1.146c2.002-.092 3.643-1.732 3.735-3.734a3.883 3.883 0 0 0-1.146-2.958 3.88 3.88 0 0 0-2.77-1.15z" }));
var Settings_default = SvgSettings;
var SvgShareAndroid = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m15.2 7.5-5.65 3.3a3.75 3.75 0 0 1 0 2.4l5.66 3.3a3.74 3.74 0 0 1 6.54 2.5 3.75 3.75 0 1 1-7.3-1.2L8.8 14.5a3.74 3.74 0 1 1 0-5l5.65-3.3a3.75 3.75 0 1 1 .76 1.3ZM18 2.75a2.25 2.25 0 0 0-1.97 3.34l.03.04.02.05A2.25 2.25 0 1 0 18 2.75ZM7.92 10.82a2.25 2.25 0 1 0 .02 2.31l.03-.04a2.24 2.24 0 0 0 0-2.18l-.03-.04-.02-.05ZM16 17.96a2.24 2.24 0 0 0 2 3.29 2.25 2.25 0 1 0-2-3.29Z" }));
var ShareAndroid_default = SvgShareAndroid;
var SvgShareIos = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.53 6.53a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72V15a.75.75 0 0 1-1.5 0V3.81L8.53 6.53ZM4.75 11c0-.69.56-1.25 1.25-1.25h2a.75.75 0 0 0 0-1.5H6A2.75 2.75 0 0 0 3.25 11v8.5A2.75 2.75 0 0 0 6 22.25h12a2.75 2.75 0 0 0 2.75-2.75V11A2.75 2.75 0 0 0 18 8.25h-2a.75.75 0 0 0 0 1.5h2c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V11Z" }));
var ShareIos_default = SvgShareIos;
var SvgShow = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M6.094 8.055c-1.559 1.28-2.646 2.782-3.195 3.637a3.305 3.305 0 0 0-.128.208.166.166 0 0 0-.018.043l-.001.01a.508.508 0 0 0 .001.104c.003.011.006.02.018.043.021.04.053.091.128.208.549.855 1.636 2.357 3.195 3.637C7.651 17.225 9.635 18.25 12 18.25c2.365 0 4.349-1.026 5.906-2.305 1.559-1.28 2.646-2.782 3.195-3.637.075-.117.107-.168.128-.208a.165.165 0 0 0 .018-.043l.001-.01a.54.54 0 0 0 0-.094l-.001-.01a.165.165 0 0 0-.018-.043 3.243 3.243 0 0 0-.128-.208c-.549-.855-1.636-2.357-3.195-3.637C16.349 6.775 14.365 5.75 12 5.75c-2.365 0-4.349 1.026-5.906 2.305Zm-.952-1.16C6.869 5.478 9.179 4.25 12 4.25c2.821 0 5.131 1.227 6.858 2.646 1.725 1.417 2.91 3.059 3.505 3.986l.023.035c.12.187.254.395.323.69.055.236.055.55 0 .787-.069.294-.203.502-.323.69l-.023.034c-.595.927-1.78 2.57-3.505 3.986-1.727 1.42-4.037 2.646-6.858 2.646-2.821 0-5.131-1.227-6.858-2.646-1.725-1.417-2.91-3.059-3.505-3.986l-.023-.035c-.12-.187-.254-.395-.323-.69a1.893 1.893 0 0 1 0-.787c.069-.294.203-.502.323-.69l.023-.034c.594-.927 1.78-2.57 3.505-3.986ZM12 9.75c-1.28 0-2.297 1.018-2.297 2.25S10.72 14.25 12 14.25c1.28 0 2.297-1.018 2.297-2.25S13.28 9.75 12 9.75ZM8.203 12c0-2.082 1.71-3.75 3.797-3.75 2.086 0 3.797 1.668 3.797 3.75s-1.71 3.75-3.797 3.75c-2.086 0-3.797-1.668-3.797-3.75Z" }));
var Show_default = SvgShow;
var SvgShuttleBus = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.77 1.25h8.46c.81 0 1.47 0 2 .04.55.05 1.03.14 1.47.37.7.36 1.28.93 1.64 1.64.23.44.32.92.37 1.47a12.28 12.28 0 0 1 .03.83l.01 1.17v7.46c0 .82 0 1.47-.04 2a3.84 3.84 0 0 1-.37 1.47c-.35.7-.9 1.26-1.59 1.62v2.27c-.02.13-.05.3-.14.48a1.25 1.25 0 0 1-1.02.67l-.37.01h-2.31c-.13-.02-.3-.05-.48-.14a1.25 1.25 0 0 1-.67-1.02l-.01-.37v-1.47h-5.5v1.84c-.02.13-.05.3-.14.48a1.25 1.25 0 0 1-1.02.67l-.37.01H5.41c-.13-.02-.3-.05-.48-.14a1.25 1.25 0 0 1-.67-1.02l-.01-.37v-1.9a3.75 3.75 0 0 1-1.6-1.62 3.85 3.85 0 0 1-.36-1.47c-.04-.53-.04-1.19-.04-2V6.77a60.6 60.6 0 0 1 .04-2c.05-.55.14-1.03.37-1.47.36-.7.93-1.28 1.64-1.64.44-.23.92-.32 1.47-.37.53-.04 1.18-.04 2-.04Zm-.02 18.5c-.8 0-1.45 0-1.98-.04h-.02v1.54h2v-1.5Zm8.5 0v1.5h2v-1.54h-.02c-.53.04-1.18.04-1.98.04ZM3.75 6.25v5h16.5v-5H3.75Zm16.5 6.5H3.75v1.45c0 .85 0 1.45.04 1.9.03.46.1.72.2.92.22.42.56.77.99.98.2.1.46.17.91.21.46.04 1.06.04 1.91.04h8.4c.85 0 1.45 0 1.9-.04.46-.04.72-.1.92-.2.42-.22.77-.57.98-.99.1-.2.17-.46.21-.91.04-.46.04-1.06.04-1.91v-1.45ZM10 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.5 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.7-12.25c-.04-.37-.1-.6-.2-.77a2.25 2.25 0 0 0-.98-.98c-.2-.1-.46-.17-.91-.21-.46-.04-1.06-.04-1.91-.04H7.8c-.85 0-1.45 0-1.9.04-.46.04-.72.1-.92.2-.43.22-.77.56-.99.99-.09.18-.15.4-.19.77h16.4Z" }));
var ShuttleBus_default = SvgShuttleBus;
var SvgSingle = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.1 7c-1.646 0-3-1.354-3-3s1.354-3 3-3 3 1.354 3 3-1.354 3-3 3zm0-1.2c.987 0 1.8-.813 1.8-1.8s-.813-1.8-1.8-1.8-1.8.813-1.8 1.8.813 1.8 1.8 1.8zM6.5 10c0-1.426 1.174-2.6 2.6-2.6h6c1.426 0 2.6 1.174 2.6 2.6v4.5a2.11 2.11 0 0 1-2.1 2.1.596.596 0 0 1-.4-.153V21a2.11 2.11 0 0 1-2.1 2.1h-2A2.11 2.11 0 0 1 9 21v-4.553a.596.596 0 0 1-.4.153 2.11 2.11 0 0 1-2.1-2.1zM9 15.553V10.5c0-.329.271-.6.6-.6s.6.271.6.6V21c0 .494.406.9.9.9h2c.494 0 .9-.406.9-.9V10.5c0-.329.271-.6.6-.6s.6.271.6.6v5.053a.596.596 0 0 1 .4-.153c.494 0 .9-.406.9-.9V10c0-.768-.632-1.4-1.4-1.4h-6c-.768 0-1.4.632-1.4 1.4v4.5c0 .494.406.9.9.9.154 0 .294.058.4.153z" }));
var Single_default = SvgSingle;
var SvgSkiCarrier = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2 9.25h3V7a1 1 0 0 1 2 0v2.25h7V7a1 1 0 0 1 2 0v2.25h2.67c.18 0 .43-.09.76-.33.32-.23.65-.55.94-.9a10.7 10.7 0 0 0 .91-1.28l.05-.09.02-.02a.75.75 0 0 1 1.3.74v.01l-.02.03-.07.1a10.55 10.55 0 0 1-1.04 1.47c-.34.4-.75.83-1.2 1.16-.46.32-1.02.61-1.65.61H16v1.5h2.67c.63 0 1.2.29 1.64.61.46.33.87.76 1.2 1.16a12 12 0 0 1 1.12 1.57l.02.04a.75.75 0 0 1-1.3.74l-.02-.02-.05-.09a11.45 11.45 0 0 0-.91-1.28 5.5 5.5 0 0 0-.94-.9c-.32-.24-.58-.33-.76-.33H16V16a1 1 0 0 1-2 0v-2.25H7V16a1 1 0 0 1-2 0v-2.25H2a.75.75 0 0 1 0-1.5h3v-1.5H2a.75.75 0 0 1 0-1.5Zm12 3v-1.5H7v1.5h7Z" }));
var SkiCarrier_default = SvgSkiCarrier;
var SvgSms = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.64 21.2a.67.67 0 0 1-.47-.2l-2.06-2.06h-.8a2.2 2.2 0 0 1-2.2-2.2V7.5c0-1.21.99-2.2 2.2-2.2h15.6c1.21 0 2.2.99 2.2 2.2v9.23a2.2 2.2 0 0 1-2.2 2.2h-9.74L8.11 21c-.13.13-.3.2-.47.2ZM4.32 6.64c-.48 0-.88.4-.88.87v9.23c0 .48.4.87.88.87h1.07c.17 0 .34.07.47.2l1.78 1.78 1.79-1.78c.12-.13.29-.2.47-.2h10c.49 0 .88-.4.88-.87V7.5c0-.48-.4-.87-.88-.87H4.32Zm12.7 8.43c-.33 0-.63-.04-.89-.12a2.17 2.17 0 0 1-.75-.43.55.55 0 0 1-.14-.18.43.43 0 0 1-.05-.2c0-.1.04-.2.11-.27a.39.39 0 0 1 .3-.13.4.4 0 0 1 .24.08 1.67 1.67 0 0 0 1.65.36.99.99 0 0 0 .35-.2c.09-.1.13-.2.13-.32a.53.53 0 0 0-.13-.36.92.92 0 0 0-.38-.25c-.17-.07-.4-.12-.66-.16a2.9 2.9 0 0 1-.66-.16c-.2-.08-.36-.18-.49-.3a1.21 1.21 0 0 1-.28-.42c-.07-.16-.1-.34-.1-.54a1.3 1.3 0 0 1 .87-1.27 2.45 2.45 0 0 1 2.36.32c.13.1.2.22.2.36 0 .1-.04.2-.12.28a.37.37 0 0 1-.28.13.3.3 0 0 1-.19-.06 2.2 2.2 0 0 0-1.1-.4c-.2 0-.36.03-.5.08a.7.7 0 0 0-.31.21c-.07.1-.1.2-.1.31 0 .14.03.26.11.35.09.09.2.16.36.22.15.05.34.1.55.14.28.05.53.1.74.18.21.07.4.16.53.27.14.1.25.25.32.42.07.16.1.36.1.6 0 .3-.08.56-.25.78-.17.22-.4.39-.67.5a2.2 2.2 0 0 1-.88.18Zm-6.51-3.38v2.88c0 .12-.04.23-.11.31a.39.39 0 0 1-.3.12.38.38 0 0 1-.29-.12.45.45 0 0 1-.1-.3v-4.06c0-.12.03-.22.12-.3.09-.09.2-.13.31-.13.07 0 .14.02.2.06.08.03.14.08.17.13l1.53 2.35 1.57-2.35a.4.4 0 0 1 .34-.19c.11 0 .21.04.3.12a.4.4 0 0 1 .13.31v4.05c0 .12-.04.23-.11.31a.43.43 0 0 1-.32.12.45.45 0 0 1-.32-.12.43.43 0 0 1-.12-.3v-2.82l-1.16 1.76a.5.5 0 0 1-.16.13.31.31 0 0 1-.18.05.33.33 0 0 1-.2-.05.6.6 0 0 1-.15-.13l-1.15-1.83ZM7.1 15.07c-.33 0-.62-.04-.88-.12a2.17 2.17 0 0 1-.75-.43.55.55 0 0 1-.14-.18.43.43 0 0 1-.05-.2c0-.1.04-.2.11-.27a.39.39 0 0 1 .3-.13c.09 0 .16.03.23.08a1.67 1.67 0 0 0 1.65.36.99.99 0 0 0 .36-.2c.09-.1.13-.2.13-.32a.53.53 0 0 0-.13-.36.92.92 0 0 0-.38-.25c-.17-.07-.4-.12-.66-.16a2.9 2.9 0 0 1-.66-.16c-.2-.08-.36-.18-.49-.3a1.21 1.21 0 0 1-.28-.42c-.07-.16-.1-.34-.1-.54a1.3 1.3 0 0 1 .87-1.27 2.45 2.45 0 0 1 2.36.32c.13.1.2.22.2.36 0 .1-.04.2-.12.28a.37.37 0 0 1-.28.13.3.3 0 0 1-.2-.06 2.2 2.2 0 0 0-1.1-.4c-.18 0-.35.03-.5.08a.7.7 0 0 0-.3.21c-.07.1-.1.2-.1.31 0 .14.03.26.11.35.09.09.2.16.36.22.15.05.34.1.55.14.28.05.53.1.74.18.21.07.39.16.53.27.14.1.24.25.31.42.07.16.1.36.1.6 0 .3-.07.56-.24.78-.17.22-.4.39-.67.5a2.2 2.2 0 0 1-.88.18Z" }));
var Sms_default = SvgSms;
var SvgSnowChains = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 23a11 11 0 1 1 0-22 11 11 0 0 1 0 22ZM3.82 7.17a2.5 2.5 0 0 0 3.35-3.35 9.55 9.55 0 0 0-3.35 3.35Zm3.35 13.01a2.5 2.5 0 0 0-3.35-3.35 9.55 9.55 0 0 0 3.35 3.35ZM9.63 2.8a2.5 2.5 0 0 0 4.74 0 9.5 9.5 0 0 0-4.74 0ZM2.8 14.37a2.5 2.5 0 0 0 0-4.74 9.5 9.5 0 0 0 0 4.74Zm18.4 0a9.5 9.5 0 0 0 0-4.74 2.5 2.5 0 0 0 0 4.74Zm-1.74-5.46a3.99 3.99 0 0 1-4.37-4.37 3.99 3.99 0 0 1-6.18 0 3.99 3.99 0 0 1-4.37 4.37 3.99 3.99 0 0 1 0 6.18 3.99 3.99 0 0 1 4.37 4.37 4 4 0 0 1 6.18 0 3.99 3.99 0 0 1 4.37-4.37 3.99 3.99 0 0 1 0-6.18ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm8.18 2.33a2.5 2.5 0 0 0-3.35 3.35 9.55 9.55 0 0 0 3.35-3.35Zm-5.81 4.37a2.5 2.5 0 0 0-4.74 0 9.5 9.5 0 0 0 4.74 0Zm2.46-17.38a2.5 2.5 0 0 0 3.35 3.35 9.55 9.55 0 0 0-3.35-3.35Z" }));
var SnowChains_default = SvgSnowChains;
var SvgSorting = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M3.53 7.53a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L7.75 4.81V16a.75.75 0 0 1-1.5 0V4.81L3.53 7.53Zm16.94 8.94a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V8a.75.75 0 0 1 1.5 0v11.19l2.72-2.72Z" }));
var Sorting_default = SvgSorting;
var SvgStarEmpty = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.462 2.001a1.25 1.25 0 0 1 1.076 0c.284.136.447.374.54.526.096.156.195.357.299.568l2.2 4.456.011.024.026.004 4.92.719c.233.034.455.066.633.109.173.042.45.123.666.352.26.273.381.65.332 1.023-.041.312-.218.54-.333.676-.119.139-.28.295-.448.46l-3.56 3.466-.018.018.004.026.84 4.896c.04.232.078.453.092.635.014.178.023.467-.128.744-.18.33-.5.563-.87.632-.31.057-.582-.04-.746-.108-.169-.07-.368-.175-.576-.284l-4.399-2.313-.023-.013-.023.013-4.399 2.313c-.208.11-.407.214-.576.284-.164.068-.436.165-.746.108a1.25 1.25 0 0 1-.87-.633c-.15-.276-.142-.565-.128-.743.014-.181.052-.403.092-.635l.84-4.896.004-.026a5.183 5.183 0 0 1-.019-.018l-3.538-3.446a7.593 7.593 0 0 1-.469-.48c-.115-.135-.292-.364-.333-.676a1.25 1.25 0 0 1 .332-1.023c.216-.229.493-.31.666-.352.178-.043.4-.075.632-.11l.03-.003 4.89-.715.027-.004.011-.024 2.2-4.456a7.62 7.62 0 0 1 .299-.568c.093-.152.256-.39.54-.526ZM12 3.695a87.2 87.2 0 0 0-.045.09L9.77 8.215l-.015.03c-.05.102-.132.27-.26.41a1.25 1.25 0 0 1-.389.282c-.172.08-.357.106-.47.121l-.032.005-4.891.715-.1.014.072.071 3.538 3.446.023.023c.082.079.218.21.31.375.079.141.13.296.149.457a1.653 1.653 0 0 1-.036.518l-.835 4.867-.017.1.09-.047 4.373-2.3.028-.015c.1-.054.267-.142.452-.179.16-.03.323-.03.482 0 .186.037.351.125.452.179l.029.015 4.372 2.3.09.047-.017-.1-.835-4.867a1.655 1.655 0 0 1-.036-.517c.02-.162.07-.317.15-.458.091-.166.227-.296.309-.375l.023-.023 3.538-3.446.073-.07-.1-.015-4.892-.715a6.223 6.223 0 0 0-.032-.005 1.649 1.649 0 0 1-.47-.121 1.25 1.25 0 0 1-.389-.283 1.654 1.654 0 0 1-.26-.41l-.014-.029-2.187-4.43-.045-.09Z" }));
var StarEmpty_default = SvgStarEmpty;
var SvgStarFull = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.462 2.001a1.25 1.25 0 0 1 1.076 0c.284.136.447.374.54.526.096.156.195.357.299.568l2.2 4.456.011.024.026.004 4.92.719c.233.034.455.066.633.109.173.042.45.123.666.352.26.273.381.65.332 1.023-.041.312-.218.54-.333.676-.119.139-.28.295-.448.46l-3.56 3.466-.018.018.004.026.84 4.896c.04.232.078.453.092.635.014.178.023.467-.128.744-.18.33-.5.563-.87.632-.31.057-.582-.04-.746-.108a7.57 7.57 0 0 1-.576-.284l-4.399-2.313-.023-.013-.023.013-4.399 2.313a7.58 7.58 0 0 1-.576.284c-.164.068-.436.165-.746.108a1.25 1.25 0 0 1-.87-.633c-.15-.276-.142-.565-.128-.743.014-.181.052-.403.092-.635l.84-4.896.004-.026-.019-.018-3.538-3.446-.02-.02a7.621 7.621 0 0 1-.449-.46c-.115-.135-.292-.364-.333-.676a1.25 1.25 0 0 1 .332-1.023c.216-.229.493-.31.666-.352.178-.043.4-.075.632-.11l.03-.003 4.89-.715.027-.004.011-.024 2.2-4.456c.104-.21.204-.412.299-.568.093-.152.256-.39.54-.526Z" }));
var StarFull_default = SvgStarFull;
var SvgStarHalf = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.53 2c.29.14.45.38.54.53.1.15.2.35.3.56l.02.03 2.18 4.43.01.02h.03l4.9.72h.02c.23.04.46.07.63.12.18.04.45.12.67.35.26.27.38.65.33 1.02a1.4 1.4 0 0 1-.33.68c-.12.14-.28.3-.45.46l-.02.02-3.54 3.44-.02.02v.03l.84 4.87v.02c.05.24.08.46.1.64.01.18.02.47-.13.74-.18.33-.5.57-.87.64-.31.05-.58-.04-.75-.11a7.53 7.53 0 0 1-.57-.29l-.03-.01-4.37-2.3-.02-.01-4.4 2.31-.03.01c-.2.11-.4.22-.57.29a1.3 1.3 0 0 1-.75.1c-.37-.06-.69-.3-.87-.63a1.32 1.32 0 0 1-.13-.74l.1-.64v-.02l.84-4.87v-.03l-.02-.02-3.54-3.44-.02-.02c-.17-.17-.33-.32-.45-.46a1.3 1.3 0 0 1-.33-.68c-.05-.37.07-.75.33-1.02.22-.23.5-.31.67-.35.18-.05.4-.08.63-.11h.03l4.9-.72h.02l2.2-4.46V3.1l.3-.56c.1-.15.26-.4.55-.53.34-.16.73-.16 1.07 0ZM12 17.1c.08 0 .16 0 .24.02.18.04.35.12.45.18l.03.01 4.37 2.3.09.05-.02-.1-.83-4.87v-.03a1.23 1.23 0 0 1 .12-.94c.08-.17.22-.3.3-.38l.02-.02 3.54-3.45.07-.07-.1-.01-4.89-.72h-.03c-.11-.02-.3-.04-.47-.12a1.24 1.24 0 0 1-.39-.29c-.13-.13-.2-.3-.26-.4l-.01-.03-2.19-4.43-.04-.1v13.4Z" }));
var StarHalf_default = SvgStarHalf;
var SvgStationMarker = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.75 10c0-2.07.605-3.89 1.671-5.179C8.475 3.547 10.013 2.75 12 2.75c1.987 0 3.525.797 4.579 2.071C17.645 6.11 18.25 7.931 18.25 10c0 3.888-2.516 7.143-6.25 10.935C8.266 17.143 5.75 13.888 5.75 10ZM12 1.25c-2.431 0-4.394.994-5.735 2.615C4.936 5.472 4.25 7.651 4.25 10c0 4.768 3.244 8.554 7.22 12.53a.75.75 0 0 0 1.06 0c3.976-3.976 7.22-7.763 7.22-12.53 0-2.349-.686-4.528-2.015-6.135C16.394 2.244 14.43 1.25 12 1.25Zm0 12.25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm2-3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }));
var StationMarker_default = SvgStationMarker;
var SvgSubstract = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm-4.243 10a.75.75 0 0 0 0 1.5h8.486a.75.75 0 0 0 0-1.5H7.757Z" }));
var Substract_default = SvgSubstract;
var SvgSuitcase = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M10.5 4h3a2.16 2.16 0 0 1 2.15 2.15v1H20c1.097 0 2 .903 2 2v9c0 1.097-.903 2-2 2H4c-1.097 0-2-.903-2-2v-9c0-1.097.903-2 2-2h4.35v-1A2.16 2.16 0 0 1 10.5 4ZM4 8.45c-.384 0-.7.316-.7.7v9c0 .384.316.7.7.7h16c.384 0 .7-.316.7-.7v-9c0-.384-.316-.7-.7-.7H4Zm10.35-1.3v-1a.854.854 0 0 0-.85-.85h-3a.854.854 0 0 0-.85.85v1h4.7Z" }));
var Suitcase_default = SvgSuitcase;
var SvgSupport = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.768 2.25h8.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366.706.359 1.28.933 1.64 1.639.226.444.32.924.365 1.47.043.531.043 1.187.043 2v5.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.749 3.749 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H9.684c-.654 0-.877.004-1.084.046-.199.04-.39.108-.571.2-.188.096-.364.233-.875.641l-2.409 1.927c-.188.15-.367.294-.522.396-.15.1-.402.25-.722.25-.38 0-.74-.173-.978-.47-.2-.25-.24-.542-.256-.72a7.956 7.956 0 0 1-.017-.655V7.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.749 3.749 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043ZM5.89 3.788c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v12.639l.081-.065 2.386-1.908.056-.045c.433-.347.733-.587 1.073-.76.301-.154.621-.267.952-.334.375-.077.759-.077 1.313-.077h6.59c.852 0 1.447 0 1.91-.038.453-.038.714-.107.911-.207a2.25 2.25 0 0 0 .984-.984c.1-.197.17-.458.207-.912.037-.462.038-1.057.038-1.909V7.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.984-.984c-.197-.1-.458-.17-.912-.207-.462-.037-1.057-.038-1.909-.038H7.8c-.852 0-1.447 0-1.91.038Zm4.794 7.515c0-.258.075-.471.225-.64a.712.712 0 0 1 .57-.267c.361 0 .688-.06.979-.178.291-.13.52-.332.688-.61.177-.277.265-.644.265-1.1a1.741 1.741 0 0 0-.225-.892 1.56 1.56 0 0 0-.596-.61 1.605 1.605 0 0 0-.847-.222c-.247 0-.481.05-.702.148-.212.1-.406.233-.582.402a1.332 1.332 0 0 1-.517.312c-.194.06-.392.005-.595-.164a.898.898 0 0 1-.345-.639.904.904 0 0 1 .252-.684 3.33 3.33 0 0 1 1.112-.847c.429-.207.9-.314 1.377-.312a2.943 2.943 0 0 1 1.642.476c.494.307.9.737 1.178 1.248.291.526.437 1.12.437 1.784 0 .496-.066.937-.199 1.323a2.901 2.901 0 0 1-.569.981c-.238.268-.52.486-.847.654a3.9 3.9 0 0 1-1.046.342l-.053.03c-.009.01-.013.025-.013.044v.55a.985.985 0 0 1-.226.655.73.73 0 0 1-.569.252.732.732 0 0 1-.57-.252.983.983 0 0 1-.224-.655v-1.129ZM11.412 16c-.256 0-.455-.074-.596-.223-.132-.159-.198-.382-.198-.669v-.253c0-.287.066-.505.198-.654.141-.158.34-.238.596-.238h.172c.256 0 .45.08.583.238.14.149.211.367.211.654v.253c0 .287-.07.51-.211.669-.133.149-.327.223-.583.223h-.172Z" }));
var Support_default = SvgSupport;
var SvgTerminal = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7 0a1 1 0 0 1 1 1v2h4.88a1 1 0 0 1 .99 1.12l-.93 8a1 1 0 0 1-1 .88h-1.19v1.27l.25-.02h9c.97 0 1.75.78 1.75 1.75v6.5h1.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h2.5V13h-1.2a1 1 0 0 1-.99-.88l-.93-8a1 1 0 0 1 1-1.12H6V1a1 1 0 0 1 1-1ZM1.68 4.5l.82 7h9l.82-7H1.69Zm3.07 3h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Zm4.5 5.5h-4.5v9.5h4.5V13Zm1.5 3v6.25h9.5V16a.25.25 0 0 0-.25-.25h-9a.25.25 0 0 0-.25.25ZM12 18.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1Zm4.5-.5h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5Z" }));
var Terminal_default = SvgTerminal;
var SvgTime = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0zM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25zm-.274 5.562a.75.75 0 0 0-1.452.376l1.347 5.207a1.75 1.75 0 0 0 1.314 1.27l3.902.867a.75.75 0 1 0 .326-1.464L13.26 12.2a.25.25 0 0 1-.188-.182z" }));
var Time_default = SvgTime;
var SvgTipp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 .22c.43 0 .78.35.78.78v2a.78.78 0 0 1-1.56 0V1c0-.43.35-.78.78-.78Zm3.25 18.61a.94.94 0 0 1-.55.17H9.3a.94.94 0 0 1-.55-.17C6.63 17.33 5 14.61 5 12a7 7 0 1 1 14 0c0 2.6-1.63 5.33-3.75 6.83ZM12 6.5A5.5 5.5 0 0 0 6.5 12c0 1.99 1.25 4.21 2.97 5.5h5.06c1.72-1.29 2.97-3.52 2.97-5.5A5.5 5.5 0 0 0 12 6.5ZM9.5 20h5c.28 0 .5.22.5.5V22a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1.5c0-.28.22-.5.5-.5Zm1 1.5v.5c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-.5h-3ZM1 11.22h2a.78.78 0 1 1 0 1.56H1a.78.78 0 0 1 0-1.56Zm20 0h2a.78.78 0 1 1 0 1.56h-2a.78.78 0 0 1 0-1.56ZM2.55 2.55c.3-.3.8-.3 1.1 0l2.47 2.48a.78.78 0 1 1-1.1 1.1L2.56 3.64c-.3-.3-.3-.8 0-1.1Zm16.42 15.32 2.48 2.48a.78.78 0 0 1-1.1 1.1l-2.47-2.48a.77.77 0 1 1 1.1-1.1ZM2.55 21.45c-.3-.3-.3-.8 0-1.1l2.48-2.48a.77.77 0 1 1 1.1 1.1l-2.48 2.48c-.3.3-.8.3-1.1 0ZM17.88 5.03l2.47-2.48a.77.77 0 1 1 1.1 1.1l-2.48 2.47a.78.78 0 0 1-1.1-1.1Z" }));
var Tipp_default = SvgTipp;
var SvgTrainStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.1 1.73c.42-.22.9-.38 1.37-.38h7.06a3 3 0 0 1 1.37.38c.42.22.84.52 1.22.85a6.23 6.23 0 0 1 1.72 2.35 55.94 55.94 0 0 1 1.7 6.42c.13.7.24 1.34.24 1.76v.07c0 1.28 0 3.25-1.09 4.77a4.5 4.5 0 0 1-1.42 1.18c-.52.3-1.12.57-1.78.8l2.99 2.5a.75.75 0 0 1-.96 1.15l-3.6-3a.76.76 0 0 1-.13-.14c-1.2.29-2.5.46-3.74.46-1.27 0-2.6-.18-3.83-.47a.76.76 0 0 1-.14.15l-3.6 3a.75.75 0 0 1-.96-1.16l3-2.5a11.2 11.2 0 0 1-1.77-.79 4.46 4.46 0 0 1-1.44-1.18c-1.09-1.52-1.09-3.5-1.09-4.77v-.07c0-.42.1-1.07.25-1.76a54.9 54.9 0 0 1 1.7-6.42c.28-.83.97-1.7 1.71-2.35.38-.33.8-.63 1.22-.85Zm1.37 1.12c-.15 0-.38.05-.68.2-.3.16-.61.38-.92.66a4.78 4.78 0 0 0-1.3 1.72 54.84 54.84 0 0 0-1.84 7.45l.52.68a8.23 8.23 0 0 0 .8.9c.23.2.45.4.79.57.4.22.98.41 1.88.41a.75.75 0 0 1 0 1.5 5.37 5.37 0 0 1-2.59-.58 5.67 5.67 0 0 1-1.11-.82l-.12-.1-.01-.01-.02-.02c.1.6.3 1.17.66 1.66.14.2.45.47.96.76.5.28 1.13.55 1.84.79 1.44.47 3.15.78 4.72.78 1.56 0 3.25-.31 4.66-.78a10 10 0 0 0 1.81-.79c.5-.29.8-.55.95-.76a4.1 4.1 0 0 0 .66-1.66l-.02.02h-.01l-.12.11c-.23.2-.6.54-1.11.82-.63.33-1.46.58-2.6.58a.75.75 0 1 1 0-1.5c.9 0 1.49-.2 1.89-.4.34-.19.56-.39.79-.59l.16-.14c.14-.13.38-.42.64-.75l.52-.68c-.03-.28-.1-.7-.2-1.24a51.8 51.8 0 0 0-.54-2.32 54.17 54.17 0 0 0-1.1-3.89 4.78 4.78 0 0 0-1.3-1.73 4.8 4.8 0 0 0-.92-.64 1.6 1.6 0 0 0-.68-.21H8.47Zm-.54 2.08a14.56 14.56 0 0 1 8.14 0c.5.15.86.55 1.02 1.04l1.2 3.7a.93.93 0 0 1-1.03 1.19 37.56 37.56 0 0 0-5.26-.58c-1.5 0-3.77.33-5.26.58a.93.93 0 0 1-1.03-1.2l1.2-3.7c.16-.48.52-.88 1.02-1.03Zm8.64 4.3-.9-2.8a.22.22 0 0 0-.04-.07 13.1 13.1 0 0 0-7.26 0l-.03.08-.91 2.79C8.85 9 10.67 8.78 12 8.78s3.15.23 4.57.45Z" }));
var TrainStation_default = SvgTrainStation;
var SvgTransmission = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M4 1.25a2.75 2.75 0 0 1 .5 5.46v4.79H11V6.56a2.75 2.75 0 1 1 1.5.15v4.79H19V6.75c0-.06 0-.12.02-.18a2.75 2.75 0 1 1 1.48.13v5.55c0 .41-.34.75-.75.75H12.5v4.3a2.75 2.75 0 1 1-1.5.14V13H4.5v4.3a2.75 2.75 0 1 1-1.5.14V6.56a2.75 2.75 0 0 1 1-5.31Zm16 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-8 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM2.75 20a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm8 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm-8-16a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm17.52 13a4 4 0 0 1 1.22.17c.36.11.65.3.87.57.22.28.33.65.33 1.13 0 .44-.1.8-.3 1.1-.2.28-.48.49-.82.63L23 23h-1.6l-1.2-2.16h-.78V23H18v-6h2.27Zm-.12 2.76c.38 0 .66-.07.85-.22.2-.15.3-.38.3-.67 0-.3-.1-.5-.3-.62-.2-.12-.47-.17-.85-.17h-.73v1.68h.73Z" }));
var Transmission_default = SvgTransmission;
var SvgUnlocked = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M17.75 7.556c0-3.407-2.502-6.306-5.75-6.306-1.463 0-2.614.264-3.489.797-.892.544-1.426 1.326-1.723 2.216a.75.75 0 1 0 1.424.474c.203-.61.538-1.078 1.08-1.41.56-.34 1.41-.577 2.708-.577 2.275 0 4.25 2.075 4.25 4.806v1.476a70.634 70.634 0 0 0-1.015-.004h-6.47c-.81 0-1.469 0-2.003.048-.554.05-1.043.157-1.493.412a3.936 3.936 0 0 0-1.624 1.797c-.216.473-.308.985-.352 1.582-.043.583-.043 1.306-.043 2.215v1.615c0 .908 0 1.63.043 2.214.044.596.136 1.109.352 1.582.35.76.913 1.394 1.624 1.796.45.256.94.362 1.493.412.534.049 1.193.049 2.003.049h6.47c.81 0 1.469 0 2.003-.049.554-.05 1.043-.156 1.494-.412a3.937 3.937 0 0 0 1.623-1.796c.216-.473.308-.986.352-1.582.043-.583.043-1.306.043-2.215v-1.615c0-.908 0-1.63-.043-2.214-.044-.597-.136-1.11-.352-1.582a3.937 3.937 0 0 0-1.623-1.797 3.108 3.108 0 0 0-.982-.343v-1.59Zm-.647 3.014c.447.04.698.116.89.224.418.236.772.623.998 1.116.11.24.182.551.22 1.067.039.522.039 1.19.039 2.134v1.556c0 .944 0 1.612-.039 2.134-.038.515-.11.826-.22 1.066-.226.494-.58.88-.998 1.117-.191.108-.443.183-.89.224-.459.041-1.05.042-1.903.042H8.8c-.854 0-1.444 0-1.903-.042-.447-.04-.699-.116-.89-.224a2.438 2.438 0 0 1-.998-1.117c-.11-.24-.182-.55-.22-1.066-.039-.522-.039-1.19-.039-2.134V15.11c0-.945 0-1.612.039-2.134.038-.516.11-.826.22-1.067.226-.493.58-.88.999-1.116.19-.108.442-.183.89-.224.458-.042 1.048-.042 1.902-.042h6.4c.854 0 1.444 0 1.903.042Zm-4.134 6.18a2 2 0 1 0-1.938 0c-.02.08-.031.164-.031.25v1a1 1 0 1 0 2 0v-1c0-.086-.01-.17-.031-.25Z" }));
var Unlocked_default = SvgUnlocked;
var SvgUpload = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.47 2.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1-1.06 1.06l-3.72-3.72V15a.75.75 0 0 1-1.5 0V4.81L7.53 8.53a.75.75 0 0 1-1.06-1.06l5-5ZM3 15.25a.75.75 0 0 1 .75.75v.2c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h8.4c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909V16a.75.75 0 0 1 1.5 0v.232c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H7.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2V16a.75.75 0 0 1 .75-.75Z" }));
var Upload_default = SvgUpload;
var SvgUser = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.8 1.25a5.75 5.75 0 1 1 0 11.5 5.75 5.75 0 0 1 0-11.5ZM7.55 7a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 0 0-8.5 0Zm-1.36 4.65c.31.3.34.8.06 1.12a9 9 0 0 0-2.33 5.78c0 .64.85 1.23 2.31 1.66l.32.1.35.08.35.08c.07 0 .13.02.2.03l.38.08.4.06.42.06.43.05.22.03.46.04.47.03.48.03.25.01.5.02h1.07l.33-.01.39-.03.2-.02c.43-.03.8.29.83.73a.78.78 0 0 1-.7.85l-.44.03c-.35.03-.65.04-.9.04h-.83l-.54-.02-.52-.03-1.02-.07-.48-.05c-.4-.05-.8-.1-1.16-.16l-.44-.08c-3-.57-4.85-1.74-4.85-3.54 0-2.46 1.01-4.86 2.72-6.84a.74.74 0 0 1 1.07-.06Zm12.7.07c1.7 2 2.71 4.36 2.71 6.78 0 1.26-1.28 2.21-3.74 3.16a.75.75 0 0 1-.98-.47.8.8 0 0 1 .45-1.02l.2-.07.37-.15.34-.15.45-.22.27-.14.12-.06.22-.13.2-.13c.39-.26.58-.48.58-.61 0-2-.86-4.01-2.33-5.75a.82.82 0 0 1 .06-1.11.74.74 0 0 1 1.08.07Z" }));
var User_default = SvgUser;
var SvgWarning = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.363 3.549 1.35 16.963l-.028.047c-.198.33-.396.663-.534.951-.14.294-.337.776-.275 1.353a2.438 2.438 0 0 0 1.023 1.732c.46.324.962.397 1.288.425.322.03.713.03 1.11.029h16.133c.396 0 .787 0 1.109-.029.326-.028.828-.101 1.288-.425.567-.4.947-1.027 1.023-1.732.062-.577-.135-1.059-.276-1.353-.137-.288-.336-.62-.533-.95l-.028-.048-8.014-13.414-.028-.047c-.197-.33-.395-.66-.583-.919-.196-.267-.518-.656-1.037-.88a2.503 2.503 0 0 0-1.979 0c-.518.224-.84.613-1.036.88-.189.259-.386.59-.583.919l-.028.047ZM2.637 17.732l8.014-13.414c.443-.741.664-1.112.953-1.237.252-.108.54-.108.792 0 .289.125.51.496.953 1.237l8.014 13.414c.444.744.667 1.116.634 1.422a.939.939 0 0 1-.396.666c-.256.18-.7.18-1.587.18H3.986c-.887 0-1.33 0-1.587-.18a.939.939 0 0 1-.396-.666c-.033-.306.19-.678.634-1.422ZM11.25 9a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-1.5 0V9ZM11 17a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z" }));
var Warning_default = SvgWarning;
var SvgWeight = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12 .25A3.75 3.75 0 0 1 14.25 7h4.92a1 1 0 0 1 .98.82l2.63 14A1 1 0 0 1 21.8 23H2.2a1 1 0 0 1-.98-1.18l2.63-14A1 1 0 0 1 4.83 7h4.92A3.74 3.74 0 0 1 12 .25ZM5.25 8.5l-2.44 13h18.38l-2.44-13H5.25Zm9.78 9.5a3.2 3.2 0 0 1-1.49-.34c-.44-.22-.8-.55-1.05-1a3.21 3.21 0 0 1-.39-1.62c0-.64.13-1.19.4-1.64.26-.45.62-.8 1.06-1.04a2.97 2.97 0 0 1 2.58-.13c.3.15.56.33.76.52l-.7.84a2.59 2.59 0 0 0-.5-.33 1.4 1.4 0 0 0-.64-.13c-.46 0-.84.16-1.13.5a2 2 0 0 0-.44 1.36c0 .6.14 1.05.42 1.39.28.33.7.5 1.26.5.12 0 .24-.02.35-.05a.73.73 0 0 0 .29-.13v-1h-1v-1.06H17v2.66a3.06 3.06 0 0 1-1.97.7ZM7 17.9v-5.8h1.35v2.38h.04l1.78-2.37h1.48l-1.8 2.3 2.13 3.48h-1.47l-1.46-2.44-.7.89v1.55H7ZM9.75 4a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z" }));
var Weight_default = SvgWeight;
var SvgWhatsapp = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.08 11.91a9.95 9.95 0 0 1 17-7 9.83 9.83 0 0 1 2.92 7 9.98 9.98 0 0 1-14.72 8.7L2 22.01l1.41-5.13a9.85 9.85 0 0 1-1.33-4.96Zm3.15 4.7-.84 3.04 3.13-.82.3.18a8.27 8.27 0 0 0 12.5-7.09 8.24 8.24 0 0 0-8.27-8.24 8.27 8.27 0 0 0-7.02 12.61l.2.32Zm4.2-8.91c.22.48.7 1.7.75 1.81.06.13.1.27.02.43-.08.17-.12.27-.24.41-.12.14-.26.32-.37.43-.12.12-.25.25-.1.5.14.24.63 1.04 1.36 1.7.93.83 1.72 1.08 1.96 1.2.25.13.4.1.53-.05a14 14 0 0 0 .78-.96c.16-.25.32-.2.55-.13.22.09 1.43.68 1.67.8.25.12.4.18.47.29.06.1.06.59-.14 1.16s-1.2 1.12-1.66 1.16c-.44.04-.86.2-2.93-.61-2.49-.98-4.06-3.53-4.18-3.7-.12-.16-1-1.32-1-2.52s.63-1.8.86-2.05a.9.9 0 0 1 .65-.3h.47c.17.01.37.02.55.43Z" }));
var Whatsapp_default = SvgWhatsapp;
var SvgWifi = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.7 9.754A15.192 15.192 0 0 1 12 5.75c3.97 0 7.586 1.517 10.3 4.004a.75.75 0 0 0 1.013-1.106A16.692 16.692 0 0 0 12 4.25 16.69 16.69 0 0 0 .687 8.648.75.75 0 1 0 1.7 9.754Zm3.528 3.552A10.208 10.208 0 0 1 12 10.75c2.597 0 4.966.964 6.772 2.556a.75.75 0 0 0 .992-1.126A11.708 11.708 0 0 0 12 9.25a11.708 11.708 0 0 0-7.764 2.93.75.75 0 1 0 .992 1.126Zm3.496 3.591A5.225 5.225 0 0 1 12 15.75c1.222 0 2.344.416 3.236 1.115a.75.75 0 0 0 .925-1.18A6.724 6.724 0 0 0 12 14.25a6.725 6.725 0 0 0-4.213 1.476.75.75 0 0 0 .937 1.171ZM12 19a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z" }));
var Wifi_default = SvgWifi;
var SvgWinterTires = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0Zm-1.5 0a10.5 10.5 0 1 0-21 0 10.5 10.5 0 0 0 21 0Zm-9.72-8v1.88l.93-.83a.75.75 0 0 1 1 1.12L12.77 7.9l-.02.86.14.03c.62.17 1.15.5 1.56.94l.76-.43.52-2.54a.75.75 0 0 1 1.47.3l-.25 1.23 1.64-.94a.75.75 0 0 1 .75 1.3l-1.64.94 1.19.4a.75.75 0 1 1-.48 1.42l-2.45-.82-.76.44a3.3 3.3 0 0 1 0 1.97l.75.41 2.47-.82a.75.75 0 1 1 .47 1.43l-1.19.39 1.64.94a.75.75 0 0 1-.75 1.3l-1.64-.94.25 1.22a.75.75 0 1 1-1.47.3l-.52-2.51-.78-.43c-.44.46-1 .79-1.62.94l-.02.89 1.92 1.7a.75.75 0 1 1-1 1.13l-.93-.83V20a.75.75 0 1 1-1.5 0v-1.9l-.94.84a.75.75 0 0 1-1-1.12l1.94-1.73.03-.86c-.05 0-.1-.02-.14-.03a3.3 3.3 0 0 1-1.57-.94l-.76.43-.52 2.54a.75.75 0 1 1-1.47-.3l.25-1.23-1.63.94a.75.75 0 0 1-.75-1.3l1.63-.94-1.18-.4a.75.75 0 1 1 .47-1.42l2.45.82.76-.44a3.31 3.31 0 0 1 0-1.97l-.75-.41-2.46.82a.75.75 0 1 1-.47-1.43l1.18-.39-1.63-.94a.75.75 0 1 1 .75-1.3l1.63.94-.25-1.22a.75.75 0 0 1 1.47-.3l.52 2.51.78.43c.44-.46 1-.79 1.63-.94l.02-.89-1.93-1.7a.75.75 0 0 1 1-1.13l.94.83V4a.75.75 0 0 1 1.5 0Zm.8 8.42a1.61 1.61 0 1 0-3.1-.84 1.61 1.61 0 0 0 3.1.84Z" }));
var WinterTires_default = SvgWinterTires;
var SvgWorld = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1 11.75A10.8 10.8 0 0 1 11.75 1 10.8 10.8 0 0 1 22.5 11.75 10.8 10.8 0 0 1 11.75 22.5 10.8 10.8 0 0 1 1 11.75Zm14 5.03c-2.16.24-4.34.24-6.5 0 .23 1.26.55 2.5.96 3.73.02.07.04.14.04.21 1.48.37 3.02.37 4.5 0 0-.07.02-.14.04-.2.4-1.23.73-2.48.96-3.74ZM2.78 9.5a9.26 9.26 0 0 0 0 4.5c.07 0 .14.02.21.04 1.23.41 2.47.73 3.73.96a29.19 29.19 0 0 1 0-6.5c-1.27.24-2.52.56-3.74.96a.65.65 0 0 1-.2.04Zm.72 6.27c0 .05 0 .1-.02.14A9.29 9.29 0 0 0 7.6 20l.14-.01c-.34-1.13-.6-2.28-.8-3.44-1.15-.2-2.3-.45-3.43-.79l-.01.01Zm16.6-8.01a9.29 9.29 0 0 0-4.36-4.36c.35 1.17.62 2.34.82 3.54 1.2.2 2.38.47 3.54.82Zm-3.32.74c.24 2.16.24 4.34 0 6.5a28.9 28.9 0 0 0 3.74-.96.76.76 0 0 1 .2-.04 9.26 9.26 0 0 0 0-4.5.78.78 0 0 1-.21-.04 27.23 27.23 0 0 0-3.73-.96Zm-1.04 11.6a9.3 9.3 0 0 0 4.28-4.19c-.02-.04-.02-.09-.02-.14a29.5 29.5 0 0 1-3.44.79c-.2 1.19-.47 2.37-.82 3.54ZM6.93 6.94c.2-1.16.45-2.3.79-3.44-.05 0-.1 0-.14-.02A9.3 9.3 0 0 0 3.4 7.76c1.17-.35 2.35-.62 3.54-.82h-.01Zm8.32 1.32c-2.33-.3-4.67-.3-7 0a28.1 28.1 0 0 0 0 6.98c2.33.3 4.67.3 7 0a28.1 28.1 0 0 0 0-6.98Zm-3.5-5.76c-.78 0-1.53.1-2.25.28a29.72 29.72 0 0 0-1 3.94c2.16-.24 4.34-.24 6.5 0-.23-1.26-.55-2.5-.96-3.73a.75.75 0 0 1-.04-.21 9.28 9.28 0 0 0-2.25-.28Z" }));
var World_default = SvgWorld;

exports.Add = Add_default;
exports.AddDriver = AddDriver_default;
exports.AddToCalendar = AddToCalendar_default;
exports.AirConditioning = AirConditioning_default;
exports.Airport = Airport_default;
exports.Android = Android_default;
exports.ArrowBack = ArrowBack_default;
exports.ArrowDown = ArrowDown_default;
exports.ArrowForward = ArrowForward_default;
exports.ArrowLast = ArrowLast_default;
exports.ArrowNext = ArrowNext_default;
exports.ArrowUp = ArrowUp_default;
exports.Automatic = Automatic_default;
exports.BabySeat = BabySeat_default;
exports.BmLogoOld = BmLogoOld_default;
exports.Border = Border_default;
exports.Calendar = Calendar_default;
exports.Cancel = Cancel_default;
exports.Cancel24H = Cancel24H_default;
exports.CarTypeL = CarTypeL_default;
exports.CarTypeM = CarTypeM_default;
exports.CarTypeS = CarTypeS_default;
exports.Checked = Checked_default;
exports.ChildSeat01 = ChildSeat01_default;
exports.ChildSeat02 = ChildSeat02_default;
exports.CityStation = CityStation_default;
exports.Close = Close_default;
exports.Comment = Comment_default;
exports.Compare = Compare_default;
exports.Contact = Contact_default;
exports.Copy = Copy_default;
exports.Couple = Couple_default;
exports.Damage = Damage_default;
exports.Delete = Delete_default;
exports.Dimensions = Dimensions_default;
exports.Document = Document_default;
exports.Doors = Doors_default;
exports.Download = Download_default;
exports.DrivingLicence = DrivingLicence_default;
exports.Edit = Edit_default;
exports.ElectroHybrid = ElectroHybrid_default;
exports.Email = Email_default;
exports.Facebook = Facebook_default;
exports.Ferry = Ferry_default;
exports.Filter = Filter_default;
exports.FloytCut = FloytCut_default;
exports.FloytFull = FloytFull_default;
exports.FourWheelDrive = FourWheelDrive_default;
exports.FrontWheelDrive = FrontWheelDrive_default;
exports.Fuel = Fuel_default;
exports.FuelLevel = FuelLevel_default;
exports.Gas = Gas_default;
exports.Gps = Gps_default;
exports.Group = Group_default;
exports.Heart = Heart_default;
exports.Help = Help_default;
exports.Hide = Hide_default;
exports.Hotel = Hotel_default;
exports.Info = Info_default;
exports.Instagram = Instagram_default;
exports.Ios = Ios_default;
exports.Km = Km_default;
exports.Like = Like_default;
exports.LocateMe = LocateMe_default;
exports.Location = Location_default;
exports.Locked = Locked_default;
exports.Luggage = Luggage_default;
exports.MapView = MapView_default;
exports.Menu = Menu_default;
exports.Messenger = Messenger_default;
exports.Money = Money_default;
exports.Next = Next_default;
exports.NoInternet = NoInternet_default;
exports.NoSuitcase = NoSuitcase_default;
exports.Pause = Pause_default;
exports.Phone = Phone_default;
exports.Pickup = Pickup_default;
exports.PickupReturn = PickupReturn_default;
exports.PickupStation = PickupStation_default;
exports.Pinterest = Pinterest_default;
exports.Play = Play_default;
exports.RearWheelDrive = RearWheelDrive_default;
exports.Reload = Reload_default;
exports.Requested = Requested_default;
exports.Return = Return_default;
exports.RoofBox = RoofBox_default;
exports.RoofRack = RoofRack_default;
exports.Search = Search_default;
exports.SeatExtension = SeatExtension_default;
exports.Seats = Seats_default;
exports.Settings = Settings_default;
exports.ShareAndroid = ShareAndroid_default;
exports.ShareIos = ShareIos_default;
exports.Show = Show_default;
exports.ShuttleBus = ShuttleBus_default;
exports.Single = Single_default;
exports.SkiCarrier = SkiCarrier_default;
exports.Sms = Sms_default;
exports.SnowChains = SnowChains_default;
exports.Sorting = Sorting_default;
exports.StarEmpty = StarEmpty_default;
exports.StarFull = StarFull_default;
exports.StarHalf = StarHalf_default;
exports.StationMarker = StationMarker_default;
exports.Substract = Substract_default;
exports.Suitcase = Suitcase_default;
exports.Support = Support_default;
exports.Terminal = Terminal_default;
exports.Time = Time_default;
exports.Tipp = Tipp_default;
exports.TrainStation = TrainStation_default;
exports.Transmission = Transmission_default;
exports.Unlocked = Unlocked_default;
exports.Upload = Upload_default;
exports.User = User_default;
exports.Warning = Warning_default;
exports.Weight = Weight_default;
exports.Whatsapp = Whatsapp_default;
exports.Wifi = Wifi_default;
exports.WinterTires = WinterTires_default;
exports.World = World_default;


/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2784);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/pictograms/car-types/Compact.tsx
var SvgCompact = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M37.989 22.75a.751.751 0 0 1 .023-1.5l.079.001h.221c.187-.001.44-.004.708-.014.269-.01.544-.027.777-.054.095-.01.178-.022.247-.035l.005-.022c.04-.196.061-.488.053-.846-.016-.717-.143-1.531-.314-2.043-.23-.692-1.149-1.567-2.525-2.026-.717-.238-1.685-.481-2.695-.733l-.023-.006c-.983-.246-2.005-.501-2.782-.761a.65.65 0 0 1-.098-.04 88.085 88.085 0 0 0-5.201-2.353 42.532 42.532 0 0 0-2.991-1.12c-.924-.297-1.604-.448-1.973-.448H13c-2.309 0-4.17.924-5.165 1.421-.394.197-1.07.749-1.708 1.324-.305.274-.58.534-.779.725l-.191.185-.02.063c-.045.144-.106.34-.166.55-.06.212-.118.431-.161.621-.046.209-.06.326-.06.361a.752.752 0 0 1-.219.53l-.034.035c-.024.025-.06.062-.102.108-.086.093-.199.22-.309.358a3.277 3.277 0 0 0-.279.396.876.876 0 0 0-.057.116v2.346c.052.048.148.121.308.212.372.212.94.441 1.679.687a.75.75 0 1 1-.474 1.423c-.761-.253-1.443-.52-1.946-.806a2.905 2.905 0 0 1-.685-.514c-.19-.203-.382-.504-.382-.891v-2.5c0-.332.15-.634.255-.817.121-.212.272-.418.409-.589a8.47 8.47 0 0 1 .364-.423c.018-.123.043-.246.068-.357.051-.231.118-.482.183-.708a20.73 20.73 0 0 1 .236-.773l.023-.07a.747.747 0 0 1 .182-.293l.025-.025.067-.067.246-.239c.207-.199.495-.471.815-.759.612-.55 1.436-1.248 2.042-1.551l.015-.008C8.192 10.315 10.323 9.25 13 9.25h8.5c.631 0 1.513.224 2.433.52.948.306 2.031.72 3.103 1.161a89.455 89.455 0 0 1 5.251 2.374c.711.233 1.658.471 2.645.717l.023.006c.983.246 2.005.501 2.782.76 1.624.542 3.039 1.667 3.474 2.975.23.688.372 1.658.391 2.484.009.413-.012.831-.084 1.182a2.076 2.076 0 0 1-.183.54 1.118 1.118 0 0 1-.54.52c-.246.106-.568.155-.828.185-.286.032-.603.051-.891.062-.289.011-.56.014-.758.015h-.238l-.085-.001h-.006ZM14 21.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.5 0a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001Zm24 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.5 0a2 2 0 1 0-3.999-.001A2 2 0 0 0 35 21.5Zm-19.5-.3h12.6c.387 0 .7.336.7.75s-.313.75-.7.75H15.5c-.387 0-.7-.336-.7-.75s.313-.75.7-.75Zm-4.737-9.661a.749.749 0 0 1 .948.474c.386 1.155 1.344 1.79 2.721 2.135 1.388.347 3.032.352 4.548.352l.203-.011-.419-2.092a.75.75 0 0 1 1.471-.294l.462 2.307 7.763-.409a.75.75 0 1 1 .079 1.498l-9.5.5A.508.508 0 0 1 19 16h-.045c-1.471 0-3.297 0-4.887-.397-1.624-.406-3.165-1.271-3.78-3.116a.75.75 0 0 1 .475-.948Z" }));
var Compact_default = SvgCompact;
var SvgConvertible = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.05 21.25a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm18.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-12.3-8.34c.06-.41.43-.7.84-.65 1.5.18 2.74.59 3.8 1.23a9.35 9.35 0 0 1 2.48 2.26c1.98.03 4.4.25 6.32.74 3.13.82 5.24 2.38 5.84 2.98.86.86.98 2 .95 2.85a8.9 8.9 0 0 1-.14 1.15l-.04.2c0 .07-.02.13-.03.2a1.9 1.9 0 0 0-.02.13c0 .41-.34.75-.75.75h-2a.75.75 0 0 1 0-1.5h1.36v-.04c.05-.29.1-.61.12-.95.03-.7-.1-1.31-.51-1.73-.4-.4-2.29-1.84-5.16-2.58a27.4 27.4 0 0 0-6.31-.7.75.75 0 0 1-.6-.3 8.17 8.17 0 0 0-2.29-2.18 7.9 7.9 0 0 0-3.2-1.03.75.75 0 0 1-.65-.83Zm-9.11 3.83a21.34 21.34 0 0 1-.96.49c-2.09.52-3.16.52-5.17.52h-.62c-.03.4-.14.78-.26 1.06a7.6 7.6 0 0 1-.38.8v2.8l.47.1a22.19 22.19 0 0 0 1.27.24.75.75 0 0 1 .01 1.5c-.2 0-.49-.05-.74-.1a23.82 23.82 0 0 1-1.62-.34l-.23-.06-.07-.02h-.02a.75.75 0 0 1-.57-.73v-3.5c0-.2.08-.38.1-.43v-.01l.13-.26.01-.02c.09-.16.17-.34.25-.53.17-.42.19-.72.09-.92a.75.75 0 0 1 .67-1.08H5c1.96 0 2.88 0 4.74-.46l.68-.37.04-.02c.3-.17.63-.35.95-.5a5.02 5.02 0 0 1 2.09-.65c.22 0 .43.1.58.27a42.44 42.44 0 0 1 1.4 1.8 24.57 24.57 0 0 0 2 .02l-.2-.62a.75.75 0 1 1 1.43-.45l.34 1.06c1.45-.02 2.97-.05 3.93-.08a.75.75 0 0 1 .04 1.5 252.15 252.15 0 0 1-6.99.08 17.3 17.3 0 0 1-1.09-.06.8.8 0 0 1-.41-.18.78.78 0 0 1-.24-.36 43.73 43.73 0 0 0-1.1-1.44c-.3.07-.66.22-1.1.44l-.9.48-.05.03ZM14.75 22c0-.41.34-.75.75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z" }));
var Convertible_default = SvgConvertible;
var SvgMedium = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M3.47 12.47a.75.75 0 0 1 .53-.22h2.83a52.57 52.57 0 0 1 7.93-2.9c.26-.05.52-.1.74-.1h6c.82 0 1.78.21 2.77.52 1 .3 2.06.72 3.08 1.17 1.72.74 3.37 1.57 4.44 2.11l.5.26c.72.23 1.56.47 2.42.72.87.25 1.76.5 2.53.76.77.26 1.76.64 2.58 1.03.41.2.8.4 1.1.6.15.1.3.2.43.32.1.1.28.28.36.52.28.83.1 1.78-.09 2.44l-.21.75-.06.18-.08.3-.02.08c0 .41-.34.74-.75.74H39a.75.75 0 0 1 0-1.5h.9l.02-.06.06-.2a18 18 0 0 0 .2-.67c.15-.6.22-1.13.13-1.5l-.2-.14a8.36 8.36 0 0 0-.93-.5c-.76-.36-1.7-.73-2.42-.97a64 64 0 0 0-2.47-.74c-.87-.25-1.76-.5-2.53-.76a.65.65 0 0 1-.1-.04l-.56-.28a80.52 80.52 0 0 0-4.34-2.08c-1-.43-2.01-.82-2.94-1.1a8.45 8.45 0 0 0-2.32-.46h-6a14.47 14.47 0 0 0-1.26.3 49.07 49.07 0 0 0-6.9 2.62.75.75 0 0 1-.34.08H4.32a6.12 6.12 0 0 0-.51.68.88.88 0 0 0-.06.11v1.43L3 16h.75c0 .2-.08.39-.22.53l-.78.78c0 .59.01.94.05 1.2.02.13.05.22.1.3a13.27 13.27 0 0 1 2.93 1.02.75.75 0 1 1-.67 1.34 11.67 11.67 0 0 0-2.75-.92.75.75 0 0 1-.44-.22 2.21 2.21 0 0 1-.65-1.28c-.07-.44-.07-1-.07-1.68V17c0-.2.08-.39.22-.53l.78-.78V14.5c0-.33.15-.63.25-.82a4.7 4.7 0 0 1 .8-1.02l.12-.14.03-.03.02-.02Zm11.28 9.03c0-.41.34-.75.75-.75H29a.75.75 0 0 1 0 1.5H15.5a.75.75 0 0 1-.75-.75Zm-4.25 3a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm27-2a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM36 21a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-24.67-8.34a.75.75 0 0 1 1-.33c2.6 1.3 4.8 1.41 7.06 1.42l-.59-1.47a.75.75 0 1 1 1.4-.56l.8 2.03h7.5a.75.75 0 0 1 0 1.5h-8.53c-2.5 0-5.15 0-8.3-1.58a.75.75 0 0 1-.34-1Z" }));
var Medium_default = SvgMedium;
var SvgPremium = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M37.6 13.26h.05l.11.02a31.15 31.15 0 0 1 1.59.3c.44.1.9.21 1.28.34.19.07.38.15.55.24.08.05.17.11.26.2.09.08.2.2.27.4a41.71 41.71 0 0 1 .93 4.3c.06.38.11.74.11.94 0 .37-.27.69-.64.74l-3 .44a.75.75 0 1 1-.22-1.48l2.28-.34-.01-.07a44.3 44.3 0 0 0-.81-3.87 10.56 10.56 0 0 0-1.32-.38 26.77 26.77 0 0 0-1.5-.28l-.1-.01h-.03l-.04-.01-.12-.02a60.5 60.5 0 0 0-2-.22 38.1 38.1 0 0 0-3.24-.25.76.76 0 0 1-.25-.04.74.74 0 0 1-.25.04H12a.75.75 0 0 1-.53-1.28l2-2a.75.75 0 1 1 1.06 1.06l-.72.72h15.76c-.6-.4-1.26-.82-1.96-1.23a19.6 19.6 0 0 0-2.5-1.26A6 6 0 0 0 23 9.75H13a4.26 4.26 0 0 0-.7.31c-.41.23-.9.56-1.43.93-.44.3-.92.66-1.38 1-.59.44-1.15.85-1.57 1.13a.75.75 0 0 1-.34.13l-4.45.44-.4 1.96a.76.76 0 0 1-.1.27l-.8 1.19.42 1.19.14.4c.09.24.17.46.22.65l.42.08.43.08c.56.11 1.14.21 1.58.24a.75.75 0 0 1-.08 1.5 14.47 14.47 0 0 1-2.32-.37l-.73-.14a.75.75 0 0 1-.66-.71V20l-.05-.17a15.65 15.65 0 0 0-.36-1.02c-.16-.46-.36-1-.55-1.58a.75.75 0 0 1 .09-.66l.91-1.37.48-2.36a.75.75 0 0 1 .66-.6l4.8-.48c.39-.26.83-.59 1.31-.94l1.47-1.07a15.37 15.37 0 0 1 2.25-1.35c.22-.08.48-.16.74-.16h10c.84 0 1.77.26 2.66.62.9.36 1.84.85 2.71 1.36 1.33.77 2.58 1.64 3.41 2.21l.45.31c.82.02 2.09.14 3.16.25l1.55.18.48.05.13.02h.04ZM29 21.19l-14 .06a.75.75 0 0 1 0-1.5l14-.06a.75.75 0 0 1 0 1.5ZM10 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm27.5-2a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM36 21a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z" }));
var Premium_default = SvgPremium;
var SvgSmall = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M12.61 8.8c-.58 0-1.2.37-1.44.85-.18.36-.38.94-.57 1.58l-.26.91-.03.09c-.07.25-.13.5-.2.69-.09.31-.13.85-.14 1.44v1.31c0 .16-.03.3-.06.41l-.13.34c-.06.16-.15.35-.24.54l-.1.23c-.26.57-.56 1.26-.75 2.04a.75.75 0 0 1-1.48-.18c0-.06 0-.12.02-.18.23-.89.55-1.75.96-2.57.11-.21.2-.43.28-.66v-1.31c-.01-.85.12-1.7.4-2.51l.03-.09.27-.93c.2-.64.41-1.33.66-1.82a3.2 3.2 0 0 1 2.78-1.68h9.32c.45.01.9.1 1.31.26.46.15.96.37 1.48.62a38.4 38.4 0 0 1 3.3 1.88 108.2 108.2 0 0 1 4.9 3.29 5.47 5.47 0 0 1 2.42 3.35c.17.52.28.94.35 1.24.07.29.1.53.1.69 0 .41-.34.75-.75.75a.75.75 0 0 1-.75-.75c-.1-.5-.22-.98-.38-1.45a5.67 5.67 0 0 0-.65-1.47c-.25-.38-.6-.74-1.17-1.11l-.77-.54c-.96-.66-2.48-1.72-4.1-2.73a35.82 35.82 0 0 0-3.16-1.8c-.42-.21-.85-.4-1.3-.55-.26-.1-.54-.16-.83-.18h-9.32Zm2.82.64c.34.24.42.7.18 1.04a2.07 2.07 0 0 0-.3 1.63c.13.5.4.69.7.69l2.1-.02-.35-2.1a.74.74 0 0 1 .74-.88c.37 0 .68.27.74.63l.4 2.33c2.88-.03 6.74-.05 8.9.04.4.02.71.35.71.75 0 .41-.34.75-.75.75h-.03c-2.27-.1-6.5-.06-9.46-.03l-3 .03c-1.22 0-1.9-.91-2.15-1.83-.22-.9-.07-2 .53-2.85a.75.75 0 0 1 1.04-.18Zm.24 12.57c0-.41.34-.75.75-.75H27c.41 0 .75.34.75.75s-.34.75-.75.75H16.42a.75.75 0 0 1-.75-.75Zm-3.9 2.54a3.4 3.4 0 0 1-3.38-3.38 3.4 3.4 0 0 1 3.38-3.39 3.4 3.4 0 0 1 3.39 3.38 3.4 3.4 0 0 1-3.39 3.39Zm0-1.5a1.9 1.9 0 0 0 1.89-1.89 1.9 1.9 0 0 0-1.89-1.88 1.9 1.9 0 0 0-1.88 1.88 1.9 1.9 0 0 0 1.88 1.89Zm22.84-1.88a3.4 3.4 0 0 1-3.38 3.38 3.4 3.4 0 0 1-3.39-3.38 3.4 3.4 0 0 1 3.39-3.38 3.4 3.4 0 0 1 3.38 3.38Zm-1.5 0a1.9 1.9 0 0 0-1.88-1.89 1.9 1.9 0 0 0-1.89 1.89 1.9 1.9 0 0 0 1.89 1.89 1.9 1.9 0 0 0 1.88-1.89Z" }));
var Small_default = SvgSmall;
var SvgSport = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.26 21.71a.75.75 0 0 1-.51-.71l-.02-.15a21 21 0 0 0-.22-1.52l-.03-.17-.14-.94-.06-.41a2.56 2.56 0 0 1-.03-.31.8.8 0 0 1 .14-.45l.12-.14.2-.19.5-.4h.02c.4-.33.91-.73 1.4-1.16.48-.44.88-.87 1.1-1.24.23-.39.15-.5.15-.5l-.01-.01-1.45-.17a.75.75 0 1 1 .16-1.49l4.46.5h.3a64.4 64.4 0 0 1 4.92-1.96 25 25 0 0 1 3.83-.72c1.44-.19 2.85-.32 3.41-.32.85 0 1.8.27 2.72.64.94.38 1.92.88 2.85 1.4.92.52 1.8 1.07 2.55 1.53.67.4 1.2.73 1.56.93 1.95.01 3 .19 4.93.5l.01.01c1.51.25 2.56.5 3.39.83.85.35 1.43.79 2.02 1.38a5.16 5.16 0 0 1 1.27 1.8c.24.69.21 1.38-.13 2.06a.75.75 0 0 1-.28.31l-.22.13a.75.75 0 0 1-.17 1.48h-2.49a.76.76 0 0 1-.61-.3.74.74 0 0 1-.15-.52.76.76 0 0 1 .38-.58l2.28-1.37c.08-.24.06-.46-.02-.7a3.94 3.94 0 0 0-.92-1.25 4.2 4.2 0 0 0-1.53-1.05 14.8 14.8 0 0 0-3.06-.74 24.76 24.76 0 0 0-4.88-.49.75.75 0 0 1-.33-.08c-.43-.21-1.07-.6-1.77-1.04l-.06-.04c-.75-.46-1.61-.99-2.5-1.49-.9-.5-1.82-.97-2.67-1.31a6.25 6.25 0 0 0-2.17-.54c-.44 0-1.78.12-3.22.3a24.1 24.1 0 0 0-3.54.66 61.1 61.1 0 0 0-4.92 1.97.71.71 0 0 1-.32.07H6.38c-.06.35-.2.67-.36.93a7.48 7.48 0 0 1-1.4 1.6c-.51.47-1.07.9-1.47 1.21l-.36.29.03.21c.04.27.1.6.14.94l.03.17.17 1.14.03.2a16.68 16.68 0 0 0 .95.25c.2.05.33.06.36.06a.75.75 0 0 1 0 1.5c-.21 0-.47-.05-.69-.1a12.04 12.04 0 0 1-1.48-.42l-.05-.01h-.02Zm12.24-.96h14a.75.75 0 0 1 0 1.5h-14a.75.75 0 0 1 0-1.5Zm1.92-7.13-1.5 1 1.05.07c1.3.06 2.78.06 4.03.06 1.26 0 2.48 0 3.52-.06.52-.03.97-.08 1.35-.14.38-.07.64-.14.8-.22a.75.75 0 1 1 .66 1.34c-.34.17-.77.28-1.21.36-.45.07-.97.12-1.51.16-1.09.06-2.36.06-3.6.06H20c-1.24 0-2.76 0-4.09-.06a22.2 22.2 0 0 1-1.84-.16 4.75 4.75 0 0 1-1.4-.36.75.75 0 0 1-.08-1.3l3-2a.75.75 0 1 1 .84 1.25ZM9.5 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM37 21a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z" }));
var Sport_default = SvgSport;
var SvgStation = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M13.57 12.67a.75.75 0 0 1 1.46-.34v.04c.02.02.02.06.03.1a36.33 36.33 0 0 0 .35 1.3c.08.23.24.54.41.83l.09.15h4.29a4.29 4.29 0 0 1-.21-.52 17.38 17.38 0 0 1-.38-1.41l-.03-.11-.01-.04a.75.75 0 0 1 1.46-.34v.04l.03.1a36.33 36.33 0 0 0 .35 1.3c.08.23.24.54.41.83l.09.15h3.59c1.02 0 1.46-.03 1.68-.08l.12-.04.17-.16a.75.75 0 1 1 1.06 1.06l-.01.02c-.1.08-.22.21-.38.32-.18.12-.38.2-.62.26-.43.1-1.04.12-2.02.12H12.94c-1.2 0-2.25 0-3.06-.14-.84-.13-1.64-.45-2.05-1.28a.75.75 0 0 1 0-.67l1-2a.75.75 0 1 1 1.34.67L9.4 14.4c.14.1.37.17.73.23.68.12 1.6.12 2.88.12h1.2a4.13 4.13 0 0 1-.21-.52 18.17 18.17 0 0 1-.38-1.41l-.03-.11-.01-.04ZM8.5 11.25c-.33 0-.55.1-.73.24-.2.17-.4.44-.6.85a.77.77 0 0 1-.2.25l-2.18 1.74.04.4c.03.39.03.9-.1 1.45-.12.48-.38 1.17-.59 1.73l-.02.06a30.21 30.21 0 0 0-.32.9c.17.2.45.4.82.57.47.2.99.31 1.38.31a.75.75 0 0 1 0 1.5 5.1 5.1 0 0 1-2-.44 3.34 3.34 0 0 1-1.67-1.47.75.75 0 0 1-.08-.34c0-.15.04-.3.06-.38l.1-.34.3-.83c.23-.62.46-1.23.56-1.63.09-.34.09-.67.06-.97a8.36 8.36 0 0 0-.04-.41v-.03a3.32 3.32 0 0 1-.04-.41c0-.23.1-.44.28-.59l2.38-1.9c.23-.43.51-.85.9-1.17a2.57 2.57 0 0 1 1.69-.59c.48 0 3.83-.12 7.22-.25h.09c3.33-.13 6.68-.25 7.19-.25 1.6 0 3.35.7 4.83 1.46 1.44.74 2.72 1.6 3.49 2.1l.1.07c.26.17.77.36 1.53.57.72.2 1.58.38 2.46.57h.01c.87.18 1.76.38 2.53.58.74.2 1.48.45 1.97.78.47.31.73.84.89 1.3.17.5.27 1.04.33 1.55.11.95.11 1.88.11 2.2v.07c0 .32-.2.6-.51.71l-1.5.5a.75.75 0 0 1-.48-1.42l.99-.33c0-.4-.03-.97-.1-1.54-.06-.47-.14-.9-.26-1.25-.13-.37-.25-.51-.3-.55a5.92 5.92 0 0 0-1.54-.57c-.72-.2-1.58-.38-2.46-.57h-.01c-.87-.19-1.76-.38-2.53-.58a7.15 7.15 0 0 1-1.97-.78l-.09-.06a34.2 34.2 0 0 0-3.34-2.02c-1.44-.74-2.93-1.29-4.15-1.29-.48 0-3.83.12-7.22.25h-.09c-3.33.13-6.68.25-7.19.25Zm20 9.5a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1 0-1.5h12.5ZM11 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm26.5-2a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM36 21a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z" }));
var Station_default = SvgStation;
var SvgSuv = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M34.59 11.96h.04a6.78 6.78 0 0 0 .41.06c.27.05.65.12 1.08.23.83.2 1.94.55 2.8 1.13.57.38.77.93.82 1.42.03.23.03.46.03.66l-.01.21v.12c.08.07.18.14.33.23l.08.06a4 4 0 0 1 .61.47c.17.16.47.48.47.95v3a.75.75 0 0 1-1.5 0v-2.87a3.48 3.48 0 0 0-.42-.3l-.07-.06a4.2 4.2 0 0 1-.8-.66 1.03 1.03 0 0 1-.21-.61 11.6 11.6 0 0 1 .02-.58c0-.18 0-.32-.02-.44-.02-.22-.08-.3-.17-.36a7.74 7.74 0 0 0-2.32-.92c-.39-.1-.73-.16-.97-.2l-.28-.04-.08-.01-.14-.01-.45-.02a317.44 317.44 0 0 0-4.34-.17c-.45 0-.78-.29-.94-.46-.2-.2-.4-.47-.57-.73l-.56-.89v-.02l-.63-.99c-.44-.67-.9-1.3-1.4-1.74-.5-.45-.95-.67-1.4-.67H7.5c-.1 0-.12.02-.13.03A.63.63 0 0 0 7.2 8a5.5 5.5 0 0 0-.22.57c-.08.2-.17.46-.29.7l-1.45 4.84c0 .39 0 1.3-.06 2.22-.04.5-.08 1.03-.16 1.47a4.5 4.5 0 0 1-.3.96 14.7 14.7 0 0 0-.01 1.55l.17-.01c.3-.02.7-.05 1.11-.05a.75.75 0 0 1 0 1.5c-.35 0-.68.02-.98.04l-.29.02c-.18.01-.37.02-.54 0-.08 0-.19 0-.3-.04a.95.95 0 0 1-.42-.24.75.75 0 0 1-.22-.53v-.18l-.01-.08a20.26 20.26 0 0 1 .01-2.3c.02-.16.08-.3.18-.43l.02-.06c.04-.1.07-.23.1-.41.06-.36.1-.82.14-1.3.06-.97.06-1.95.06-2.24 0-.07.01-.15.03-.22l.31-1.03H3.06a7.6 7.6 0 0 0-.31 1.75V18a.75.75 0 0 1-1.5 0v-3.5c0-.93.37-2.23.54-2.74.1-.3.39-.51.71-.51h2.04l.74-2.47a5.88 5.88 0 0 0 .3-.73l.01-.03c.08-.21.17-.46.28-.7.12-.23.3-.51.58-.73.3-.22.65-.34 1.05-.34H24c.96 0 1.77.47 2.4 1.05.65.59 1.2 1.34 1.66 2.04.23.35.45.7.64 1.03l.54.86c.16.24.3.41.39.5l.01.02a104.89 104.89 0 0 1 4.27.17l.46.02.17.01h.05Zm-28.75 6.2.01-.04.05-.08.15-.28c.13-.22.32-.53.53-.84.22-.3.47-.64.75-.9.14-.13.3-.27.48-.37.18-.1.41-.2.69-.2H13c.4 0 .75.17 1.03.36.28.19.54.44.79.71.5.55.99 1.25 1.43 1.92l.64.98.04.07.5.77c.13.21.25.38.34.49H30a.75.75 0 0 1 0 1.5H17.5a.94.94 0 0 1-.6-.24c-.1-.08-.18-.17-.25-.26a8.85 8.85 0 0 1-.48-.66l-.5-.8-.05-.06-.62-.97c-.43-.65-.88-1.27-1.29-1.73-.2-.22-.38-.38-.53-.48a.53.53 0 0 0-.18-.1H8.55l-.2.15a10.3 10.3 0 0 0-1.2 1.73v.02a.75.75 0 0 1-1.32-.7ZM19.5 8.74c.41 0 .75.34.75.75v2.75h6.25a.75.75 0 0 1 0 1.5h-19a.75.75 0 0 1 0-1.5h11.25V9.5c0-.41.34-.75.75-.75ZM35 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-20.5-2a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM13 21a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm17.5-4.35c.5-.5 1.19-1.2 2.5-1.2h3.5a.75.75 0 0 1 0 1.5H33c-.67 0-.98.29-1.47.78a20.67 20.67 0 0 0-1.4 1.88.75.75 0 1 1-1.25-.83l.74-1.06c.28-.38.6-.8.85-1.05l.02-.02Z" }));
var Suv_default = SvgSuv;
var SvgTransporter = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M2.43 21.5Zm1.08-9.25-.02 1.5h-.24c0 .82-.06 3-.5 4.84v1.1l.04.04.02.02.04.04.03.03.04.04.04.04.03.03.03.03.04.03.05.05.03.04.02.02.03.03.03.03.03.03.04.04.04.04.03.02.03.04.1-6.58-.08 6.6.02.02.04.04.03.03.03.03a.75.75 0 1 1-1.06 1.06l-.03-.03-.04-.04-.03-.03-.03-.03-.03-.03-.04-.04-.04-.04-.03-.03-.04-.04-.04-.03-.03-.04-.04-.04-.04-.03-.01-.02-.04-.04-.03-.03-.03-.03-.02-.02-.04-.04-.04-.04-.04-.03-.03-.04-.03-.03-.03-.03-.03-.03-.04-.04-.04-.04-.04-.04-.05-.05a.75.75 0 0 1-.22-.53v-1.5c0-.06 0-.12.02-.18a22.22 22.22 0 0 0 .5-4.97l1.5-7.5a.73.73 0 0 1 .06-.18c.27-.54.7-1.12 1.22-1.57.5-.44 1.19-.85 1.95-.85H27c1.01 0 1.95.65 2.74 1.4.82.76 1.62 1.77 2.36 2.78.44.6.88 1.25 1.29 1.84l.73 1.05c.3.41.57.77.8 1.05.24.29.4.45.5.5.3.2.73.4 1.27.61l.8.3h.03l.88.33a9.7 9.7 0 0 1 1.65.8c.48.31.96.74 1.16 1.35.24.7.36 1.93.44 2.95.07 1.05.1 2.02.1 2.29a.75.75 0 0 1-1.5 0c0-.23-.02-1.16-.1-2.18-.07-1.06-.2-2.09-.36-2.58-.05-.14-.2-.34-.56-.57a7.89 7.89 0 0 0-1.38-.66l-.84-.31-.04-.02-.82-.3a8.25 8.25 0 0 1-1.57-.76 4.2 4.2 0 0 1-.82-.8c-.26-.32-.56-.7-.86-1.14l-.77-1.1c-.3-.43-.6-.88-.93-1.33h-7.5c-.02.52.01 1.1.1 1.62a2.72 2.72 0 0 0 .29.88l.32.04.58.1.08.02 1.7.29c1.43.22 3.3.47 5.26.55a.75.75 0 1 1-.06 1.5 48.04 48.04 0 0 1-5.44-.57c-.68-.11-1.27-.21-1.72-.3h-.08l-.55-.1a5.7 5.7 0 0 0-.17-.03H24c-.64 0-1.04-.44-1.25-.82a4.16 4.16 0 0 1-.43-1.3 10 10 0 0 1-.06-2.72.75.75 0 0 1 .74-.66h7.07a14.6 14.6 0 0 0-1.36-1.52c-.74-.7-1.31-.98-1.71-.98H6.5c-.24 0-.58.14-.96.48-.35.3-.64.68-.83 1.02l-1.2 6Zm-.01 1.5.02-1.5H15.5a.75.75 0 0 1 0 1.5h-12Zm11 6.5h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1 0-1.5ZM8.5 25a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm31-2.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM38 21a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z" }));
var Transporter_default = SvgTransporter;
var SvgUpper = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M.9 20.74A.75.75 0 0 1 .26 20v-3c0-.06 0-.12.02-.18l.48-1.91V13.5c0-.37.27-.69.64-.74l3.33-.48c.42-.29.97-.7 1.58-1.17l1.44-1.09c.6-.44 1.2-.86 1.72-1.18.26-.15.52-.3.76-.4.22-.1.5-.19.78-.19h11c.85 0 1.74.26 2.6.62.86.37 1.73.86 2.54 1.37.82.51 1.58 1.06 2.23 1.53l.56.4c.34.25.62.46.86.62a89.43 89.43 0 0 1 6.71 1.44l.17.04h.01a.8.8 0 0 1 .13.05l.03.01.07.03.27.13a22.72 22.72 0 0 1 1.74.95l.4.3c.1.08.25.23.35.43a18.6 18.6 0 0 1 1.02 2.52l.02.05v.02c.03.08.04.16.04.24 0 .21-.05.47-.1.69a11.81 11.81 0 0 1-.41 1.48l-.02.05v.02c-.11.3-.4.51-.72.51h-2a.75.75 0 0 1 0-1.5h1.45a41.52 41.52 0 0 0 .24-.89l.05-.26-.03-.1a25.98 25.98 0 0 0-.86-2.12l-.02-.01-.23-.18a22.2 22.2 0 0 0-1.81-.97h-.04l-.1-.04-.5-.12-1.7-.4c-1.36-.3-3.1-.67-4.57-.92a.75.75 0 0 1-.3-.12 697.38 697.38 0 0 1-1.59-1.14c-.64-.46-1.37-.98-2.15-1.47-.77-.49-1.57-.94-2.33-1.26a5.4 5.4 0 0 0-2.01-.5h-11l-.2.07a5.1 5.1 0 0 0-.57.3c-.46.28-1.02.67-1.6 1.1l-1.36 1.03c-.72.55-1.4 1.06-1.86 1.37-.1.07-.2.1-.31.12l-2.86.41V15a.8.8 0 0 1-.02.18l-.48 1.91v2.39l.05.02.39.21.23.13c.43.23.8.4 1.12.41a.75.75 0 0 1-.08 1.5 4.38 4.38 0 0 1-1.75-.59L1.42 21a8.79 8.79 0 0 0-.5-.25H.9ZM9 13.5l-.24.71a.75.75 0 1 1 .48-1.42h.02l.09.03a9.86 9.86 0 0 0 1.03.25l1.48-2.46a.75.75 0 0 1 1.28.78l-1.17 1.95c1.52.21 3.68.41 6.53.41h.14l-.38-2.64a.75.75 0 0 1 1.48-.22l.41 2.86h7.34c.42 0 .76.34.76.75s-.34.75-.76.75H18.5c-3.29 0-5.7-.25-7.3-.5a23.45 23.45 0 0 1-2.27-.49l-.12-.03-.03-.01h-.02L9 13.5Zm3 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm23 3.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM28 21.75l-14 .06a.75.75 0 1 1 0-1.5l14-.06a.75.75 0 0 1 0 1.5Z" }));
var Upper_default = SvgUpper;
var SvgVan = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 43 28", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "m4.2 9.28-1.45 4.83v6.14l.03.05c.06.09.12.16.19.23a.7.7 0 0 0 .53.22.75.75 0 0 1 0 1.5 2.2 2.2 0 0 1-1.6-.66 3.31 3.31 0 0 1-.35-.44l-.06-.08-.03-.05-.01-.01a.75.75 0 0 1-.2-.51V14c0-.07.01-.15.03-.22l1.5-5A5.33 5.33 0 0 1 4.05 7.1c.5-.44 1.19-.85 1.95-.85h20.5c.88 0 1.73.3 2.5.73.79.43 1.54 1 2.23 1.57.6.5 1.17 1.04 1.67 1.5l.2.2c.57.53 1 .92 1.32 1.13.33.22.82.48 1.42.79l.38.2c.49.24 1.01.5 1.52.79.63.35 1.27.73 1.79 1.13.49.39.98.88 1.18 1.47.24.7.36 1.93.44 2.95.07 1.05.1 2.02.1 2.29 0 .41-.34.75-.75.75h-2a.75.75 0 0 1 0-1.5h1.23a30 30 0 0 0-.08-1.43c-.07-1.06-.2-2.09-.36-2.58-.05-.16-.25-.42-.69-.77a12.2 12.2 0 0 0-1.59-1l-1.46-.77-.4-.2c-.58-.3-1.15-.6-1.57-.88-.43-.29-.96-.77-1.5-1.27l-.21-.2a39.7 39.7 0 0 0-1.61-1.45 12.3 12.3 0 0 0-1.97-1.4 3.86 3.86 0 0 0-1.79-.55H6c-.24 0-.58.14-.96.48-.36.3-.66.7-.84 1.05Zm18.3-1.03c.41 0 .75.34.75.75 0 .77 0 1.44.11 1.98.1.53.28.75.47.85.12.06.43.13 1.01.19.55.05 1.25.08 2.05.1l1.87.04c1.19.02 2.49.04 3.77.1a.75.75 0 1 1-.06 1.49c-1.27-.05-2.52-.07-3.7-.09l-1.91-.04c-.82-.02-1.56-.05-2.17-.1a4.7 4.7 0 0 1-1.53-.35c-.8-.4-1.13-1.18-1.27-1.9-.14-.7-.14-1.5-.14-2.23V9c0-.41.34-.75.75-.75ZM13.25 21.5c0-.41.34-.75.75-.75h14a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1-.75-.75ZM4.47 10.97c.3-.3.77-.3 1.06 0 .35.35.8.55 1.52.66.75.12 1.68.12 2.95.12h1.75V9a.75.75 0 0 1 1.5 0v2.75h7.25a.75.75 0 0 1 0 1.5H9.95c-1.2 0-2.26 0-3.13-.13-.9-.14-1.7-.44-2.35-1.09a.75.75 0 0 1 0-1.06ZM8.5 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM37 21a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z" }));
var Van_default = SvgVan;

exports.Compact = Compact_default;
exports.Convertible = Convertible_default;
exports.Medium = Medium_default;
exports.Premium = Premium_default;
exports.Small = Small_default;
exports.Sport = Sport_default;
exports.Station = Station_default;
exports.Suv = Suv_default;
exports.Transporter = Transporter_default;
exports.Upper = Upper_default;
exports.Van = Van_default;


/***/ }),

/***/ 195:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 5766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 8834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(5766)
var ieee754 = __webpack_require__(2333)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 3421:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 3463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(8570);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 2333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 9412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(5484);

/** @type ValidatorResult */
var ValidatorResult = helpers.ValidatorResult;
/** @type SchemaError */
var SchemaError = helpers.SchemaError;

var attribute = {};

attribute.ignoreProperties = {
  // informative properties
  'id': true,
  'default': true,
  'description': true,
  'title': true,
  // arguments to other properties
  'additionalItems': true,
  'then': true,
  'else': true,
  // special-handled properties
  '$schema': true,
  '$ref': true,
  'extends': true,
};

/**
 * @name validators
 */
var validators = attribute.validators = {};

/**
 * Validates whether the instance if of a certain type
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */
validators.type = function validateType (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  var types = Array.isArray(schema.type) ? schema.type : [schema.type];
  if (!types.some(this.testType.bind(this, instance, schema, options, ctx))) {
    var list = types.map(function (v) {
      if(!v) return;
      var id = v.$id || v.id;
      return id ? ('<' + id + '>') : (v+'');
    });
    result.addError({
      name: 'type',
      argument: list,
      message: "is not of a type(s) " + list,
    });
  }
  return result;
};

function testSchemaNoThrow(instance, options, ctx, callback, schema){
  var throwError = options.throwError;
  var throwAll = options.throwAll;
  options.throwError = false;
  options.throwAll = false;
  var res = this.validateSchema(instance, schema, options, ctx);
  options.throwError = throwError;
  options.throwAll = throwAll;

  if (!res.valid && callback instanceof Function) {
    callback(res);
  }
  return res.valid;
}

/**
 * Validates whether the instance matches some of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */
validators.anyOf = function validateAnyOf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  var inner = new ValidatorResult(instance, schema, options, ctx);
  if (!Array.isArray(schema.anyOf)){
    throw new SchemaError("anyOf must be an array");
  }
  if (!schema.anyOf.some(
    testSchemaNoThrow.bind(
      this, instance, options, ctx, function(res){inner.importErrors(res);}
    ))) {
    var list = schema.anyOf.map(function (v, i) {
      var id = v.$id || v.id;
      if(id) return '<' + id + '>';
      return(v.title && JSON.stringify(v.title)) || (v['$ref'] && ('<' + v['$ref'] + '>')) || '[subschema '+i+']';
    });
    if (options.nestedErrors) {
      result.importErrors(inner);
    }
    result.addError({
      name: 'anyOf',
      argument: list,
      message: "is not any of " + list.join(','),
    });
  }
  return result;
};

/**
 * Validates whether the instance matches every given schema
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */
validators.allOf = function validateAllOf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  if (!Array.isArray(schema.allOf)){
    throw new SchemaError("allOf must be an array");
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  var self = this;
  schema.allOf.forEach(function(v, i){
    var valid = self.validateSchema(instance, v, options, ctx);
    if(!valid.valid){
      var id = v.$id || v.id;
      var msg = id || (v.title && JSON.stringify(v.title)) || (v['$ref'] && ('<' + v['$ref'] + '>')) || '[subschema '+i+']';
      result.addError({
        name: 'allOf',
        argument: { id: msg, length: valid.errors.length, valid: valid },
        message: 'does not match allOf schema ' + msg + ' with ' + valid.errors.length + ' error[s]:',
      });
      result.importErrors(valid);
    }
  });
  return result;
};

/**
 * Validates whether the instance matches exactly one of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */
validators.oneOf = function validateOneOf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  if (!Array.isArray(schema.oneOf)){
    throw new SchemaError("oneOf must be an array");
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  var inner = new ValidatorResult(instance, schema, options, ctx);
  var count = schema.oneOf.filter(
    testSchemaNoThrow.bind(
      this, instance, options, ctx, function(res) {inner.importErrors(res);}
    ) ).length;
  var list = schema.oneOf.map(function (v, i) {
    var id = v.$id || v.id;
    return id || (v.title && JSON.stringify(v.title)) || (v['$ref'] && ('<' + v['$ref'] + '>')) || '[subschema '+i+']';
  });
  if (count!==1) {
    if (options.nestedErrors) {
      result.importErrors(inner);
    }
    result.addError({
      name: 'oneOf',
      argument: list,
      message: "is not exactly one from " + list.join(','),
    });
  }
  return result;
};

/**
 * Validates "then" or "else" depending on the result of validating "if"
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */
validators.if = function validateIf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) return null;
  if (!helpers.isSchema(schema.if)) throw new Error('Expected "if" keyword to be a schema');
  var ifValid = testSchemaNoThrow.call(this, instance, options, ctx, null, schema.if);
  var result = new ValidatorResult(instance, schema, options, ctx);
  var res;
  if(ifValid){
    if (schema.then === undefined) return;
    if (!helpers.isSchema(schema.then)) throw new Error('Expected "then" keyword to be a schema');
    res = this.validateSchema(instance, schema.then, options, ctx.makeChild(schema.then));
    result.importErrors(res);
  }else{
    if (schema.else === undefined) return;
    if (!helpers.isSchema(schema.else)) throw new Error('Expected "else" keyword to be a schema');
    res = this.validateSchema(instance, schema.else, options, ctx.makeChild(schema.else));
    result.importErrors(res);
  }
  return result;
};

function getEnumerableProperty(object, key){
  // Determine if `key` shows up in `for(var key in object)`
  // First test Object.hasOwnProperty.call as an optimization: that guarantees it does
  if(Object.hasOwnProperty.call(object, key)) return object[key];
  // Test `key in object` as an optimization; false means it won't
  if(!(key in object)) return;
  while( (object = Object.getPrototypeOf(object)) ){
    if(Object.propertyIsEnumerable.call(object, key)) return object[key];
  }
}

/**
 * Validates propertyNames
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.propertyNames = function validatePropertyNames (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var subschema = schema.propertyNames!==undefined ? schema.propertyNames : {};
  if(!helpers.isSchema(subschema)) throw new SchemaError('Expected "propertyNames" to be a schema (object or boolean)');

  for (var property in instance) {
    if(getEnumerableProperty(instance, property) !== undefined){
      var res = this.validateSchema(property, subschema, options, ctx.makeChild(subschema));
      result.importErrors(res);
    }
  }

  return result;
};

/**
 * Validates properties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.properties = function validateProperties (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var properties = schema.properties || {};
  for (var property in properties) {
    var subschema = properties[property];
    if(subschema===undefined){
      continue;
    }else if(subschema===null){
      throw new SchemaError('Unexpected null, expected schema in "properties"');
    }
    if (typeof options.preValidateProperty == 'function') {
      options.preValidateProperty(instance, property, subschema, options, ctx);
    }
    var prop = getEnumerableProperty(instance, property);
    var res = this.validateSchema(prop, subschema, options, ctx.makeChild(subschema, property));
    if(res.instance !== result.instance[property]) result.instance[property] = res.instance;
    result.importErrors(res);
  }
  return result;
};

/**
 * Test a specific property within in instance against the additionalProperties schema attribute
 * This ignores properties with definitions in the properties schema attribute, but no other attributes.
 * If too many more types of property-existence tests pop up they may need their own class of tests (like `type` has)
 * @private
 * @return {boolean}
 */
function testAdditionalProperty (instance, schema, options, ctx, property, result) {
  if(!this.types.object(instance)) return;
  if (schema.properties && schema.properties[property] !== undefined) {
    return;
  }
  if (schema.additionalProperties === false) {
    result.addError({
      name: 'additionalProperties',
      argument: property,
      message: "is not allowed to have the additional property " + JSON.stringify(property),
    });
  } else {
    var additionalProperties = schema.additionalProperties || {};

    if (typeof options.preValidateProperty == 'function') {
      options.preValidateProperty(instance, property, additionalProperties, options, ctx);
    }

    var res = this.validateSchema(instance[property], additionalProperties, options, ctx.makeChild(additionalProperties, property));
    if(res.instance !== result.instance[property]) result.instance[property] = res.instance;
    result.importErrors(res);
  }
}

/**
 * Validates patternProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.patternProperties = function validatePatternProperties (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var patternProperties = schema.patternProperties || {};

  for (var property in instance) {
    var test = true;
    for (var pattern in patternProperties) {
      var subschema = patternProperties[pattern];
      if(subschema===undefined){
        continue;
      }else if(subschema===null){
        throw new SchemaError('Unexpected null, expected schema in "patternProperties"');
      }
      try {
        var regexp = new RegExp(pattern, 'u');
      } catch(_e) {
        // In the event the stricter handling causes an error, fall back on the forgiving handling
        // DEPRECATED
        regexp = new RegExp(pattern);
      }
      if (!regexp.test(property)) {
        continue;
      }
      test = false;

      if (typeof options.preValidateProperty == 'function') {
        options.preValidateProperty(instance, property, subschema, options, ctx);
      }

      var res = this.validateSchema(instance[property], subschema, options, ctx.makeChild(subschema, property));
      if(res.instance !== result.instance[property]) result.instance[property] = res.instance;
      result.importErrors(res);
    }
    if (test) {
      testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
    }
  }

  return result;
};

/**
 * Validates additionalProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.additionalProperties = function validateAdditionalProperties (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  // if patternProperties is defined then we'll test when that one is called instead
  if (schema.patternProperties) {
    return null;
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  for (var property in instance) {
    testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
  }
  return result;
};

/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minProperties = function validateMinProperties (instance, schema, options, ctx) {
  if (!this.types.object(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var keys = Object.keys(instance);
  if (!(keys.length >= schema.minProperties)) {
    result.addError({
      name: 'minProperties',
      argument: schema.minProperties,
      message: "does not meet minimum property length of " + schema.minProperties,
    });
  }
  return result;
};

/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maxProperties = function validateMaxProperties (instance, schema, options, ctx) {
  if (!this.types.object(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var keys = Object.keys(instance);
  if (!(keys.length <= schema.maxProperties)) {
    result.addError({
      name: 'maxProperties',
      argument: schema.maxProperties,
      message: "does not meet maximum property length of " + schema.maxProperties,
    });
  }
  return result;
};

/**
 * Validates items when instance is an array
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.items = function validateItems (instance, schema, options, ctx) {
  var self = this;
  if (!this.types.array(instance)) return;
  if (schema.items===undefined) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  instance.every(function (value, i) {
    if(Array.isArray(schema.items)){
      var items =  schema.items[i]===undefined ? schema.additionalItems : schema.items[i];
    }else{
      var items = schema.items;
    }
    if (items === undefined) {
      return true;
    }
    if (items === false) {
      result.addError({
        name: 'items',
        message: "additionalItems not permitted",
      });
      return false;
    }
    var res = self.validateSchema(value, items, options, ctx.makeChild(items, i));
    if(res.instance !== result.instance[i]) result.instance[i] = res.instance;
    result.importErrors(res);
    return true;
  });
  return result;
};

/**
 * Validates the "contains" keyword
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.contains = function validateContains (instance, schema, options, ctx) {
  var self = this;
  if (!this.types.array(instance)) return;
  if (schema.contains===undefined) return;
  if (!helpers.isSchema(schema.contains)) throw new Error('Expected "contains" keyword to be a schema');
  var result = new ValidatorResult(instance, schema, options, ctx);
  var count = instance.some(function (value, i) {
    var res = self.validateSchema(value, schema.contains, options, ctx.makeChild(schema.contains, i));
    return res.errors.length===0;
  });
  if(count===false){
    result.addError({
      name: 'contains',
      argument: schema.contains,
      message: "must contain an item matching given schema",
    });
  }
  return result;
};

/**
 * Validates minimum and exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minimum = function validateMinimum (instance, schema, options, ctx) {
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (schema.exclusiveMinimum && schema.exclusiveMinimum === true) {
    if(!(instance > schema.minimum)){
      result.addError({
        name: 'minimum',
        argument: schema.minimum,
        message: "must be greater than " + schema.minimum,
      });
    }
  } else {
    if(!(instance >= schema.minimum)){
      result.addError({
        name: 'minimum',
        argument: schema.minimum,
        message: "must be greater than or equal to " + schema.minimum,
      });
    }
  }
  return result;
};

/**
 * Validates maximum and exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maximum = function validateMaximum (instance, schema, options, ctx) {
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (schema.exclusiveMaximum && schema.exclusiveMaximum === true) {
    if(!(instance < schema.maximum)){
      result.addError({
        name: 'maximum',
        argument: schema.maximum,
        message: "must be less than " + schema.maximum,
      });
    }
  } else {
    if(!(instance <= schema.maximum)){
      result.addError({
        name: 'maximum',
        argument: schema.maximum,
        message: "must be less than or equal to " + schema.maximum,
      });
    }
  }
  return result;
};

/**
 * Validates the number form of exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.exclusiveMinimum = function validateExclusiveMinimum (instance, schema, options, ctx) {
  // Support the boolean form of exclusiveMinimum, which is handled by the "minimum" keyword.
  if(typeof schema.exclusiveMinimum === 'boolean') return;
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var valid = instance > schema.exclusiveMinimum;
  if (!valid) {
    result.addError({
      name: 'exclusiveMinimum',
      argument: schema.exclusiveMinimum,
      message: "must be strictly greater than " + schema.exclusiveMinimum,
    });
  }
  return result;
};

/**
 * Validates the number form of exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.exclusiveMaximum = function validateExclusiveMaximum (instance, schema, options, ctx) {
  // Support the boolean form of exclusiveMaximum, which is handled by the "maximum" keyword.
  if(typeof schema.exclusiveMaximum === 'boolean') return;
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var valid = instance < schema.exclusiveMaximum;
  if (!valid) {
    result.addError({
      name: 'exclusiveMaximum',
      argument: schema.exclusiveMaximum,
      message: "must be strictly less than " + schema.exclusiveMaximum,
    });
  }
  return result;
};

/**
 * Perform validation for multipleOf and divisibleBy, which are essentially the same.
 * @param instance
 * @param schema
 * @param validationType
 * @param errorMessage
 * @returns {String|null}
 */
var validateMultipleOfOrDivisbleBy = function validateMultipleOfOrDivisbleBy (instance, schema, options, ctx, validationType, errorMessage) {
  if (!this.types.number(instance)) return;

  var validationArgument = schema[validationType];
  if (validationArgument == 0) {
    throw new SchemaError(validationType + " cannot be zero");
  }

  var result = new ValidatorResult(instance, schema, options, ctx);

  var instanceDecimals = helpers.getDecimalPlaces(instance);
  var divisorDecimals = helpers.getDecimalPlaces(validationArgument);

  var maxDecimals = Math.max(instanceDecimals , divisorDecimals);
  var multiplier = Math.pow(10, maxDecimals);

  if (Math.round(instance * multiplier) % Math.round(validationArgument * multiplier) !== 0) {
    result.addError({
      name: validationType,
      argument:  validationArgument,
      message: errorMessage + JSON.stringify(validationArgument),
    });
  }

  return result;
};

/**
 * Validates divisibleBy when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.multipleOf = function validateMultipleOf (instance, schema, options, ctx) {
  return validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "multipleOf", "is not a multiple of (divisible by) ");
};

/**
 * Validates multipleOf when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.divisibleBy = function validateDivisibleBy (instance, schema, options, ctx) {
  return validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "divisibleBy", "is not divisible by (multiple of) ");
};

/**
 * Validates whether the instance value is present.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.required = function validateRequired (instance, schema, options, ctx) {
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (instance === undefined && schema.required === true) {
    // A boolean form is implemented for reverse-compatibility with schemas written against older drafts
    result.addError({
      name: 'required',
      message: "is required",
    });
  } else if (this.types.object(instance) && Array.isArray(schema.required)) {
    schema.required.forEach(function(n){
      if(getEnumerableProperty(instance, n)===undefined){
        result.addError({
          name: 'required',
          argument: n,
          message: "requires property " + JSON.stringify(n),
        });
      }
    });
  }
  return result;
};

/**
 * Validates whether the instance value matches the regular expression, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.pattern = function validatePattern (instance, schema, options, ctx) {
  if (!this.types.string(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var pattern = schema.pattern;
  try {
    var regexp = new RegExp(pattern, 'u');
  } catch(_e) {
    // In the event the stricter handling causes an error, fall back on the forgiving handling
    // DEPRECATED
    regexp = new RegExp(pattern);
  }
  if (!instance.match(regexp)) {
    result.addError({
      name: 'pattern',
      argument: schema.pattern,
      message: "does not match pattern " + JSON.stringify(schema.pattern.toString()),
    });
  }
  return result;
};

/**
 * Validates whether the instance value is of a certain defined format or a custom
 * format.
 * The following formats are supported for string types:
 *   - date-time
 *   - date
 *   - time
 *   - ip-address
 *   - ipv6
 *   - uri
 *   - color
 *   - host-name
 *   - alpha
 *   - alpha-numeric
 *   - utc-millisec
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {String|null}
 */
validators.format = function validateFormat (instance, schema, options, ctx) {
  if (instance===undefined) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (!result.disableFormat && !helpers.isFormat(instance, schema.format, this)) {
    result.addError({
      name: 'format',
      argument: schema.format,
      message: "does not conform to the " + JSON.stringify(schema.format) + " format",
    });
  }
  return result;
};

/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minLength = function validateMinLength (instance, schema, options, ctx) {
  if (!this.types.string(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var hsp = instance.match(/[\uDC00-\uDFFF]/g);
  var length = instance.length - (hsp ? hsp.length : 0);
  if (!(length >= schema.minLength)) {
    result.addError({
      name: 'minLength',
      argument: schema.minLength,
      message: "does not meet minimum length of " + schema.minLength,
    });
  }
  return result;
};

/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maxLength = function validateMaxLength (instance, schema, options, ctx) {
  if (!this.types.string(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  // TODO if this was already computed in "minLength", use that value instead of re-computing
  var hsp = instance.match(/[\uDC00-\uDFFF]/g);
  var length = instance.length - (hsp ? hsp.length : 0);
  if (!(length <= schema.maxLength)) {
    result.addError({
      name: 'maxLength',
      argument: schema.maxLength,
      message: "does not meet maximum length of " + schema.maxLength,
    });
  }
  return result;
};

/**
 * Validates whether instance contains at least a minimum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minItems = function validateMinItems (instance, schema, options, ctx) {
  if (!this.types.array(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (!(instance.length >= schema.minItems)) {
    result.addError({
      name: 'minItems',
      argument: schema.minItems,
      message: "does not meet minimum length of " + schema.minItems,
    });
  }
  return result;
};

/**
 * Validates whether instance contains no more than a maximum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maxItems = function validateMaxItems (instance, schema, options, ctx) {
  if (!this.types.array(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (!(instance.length <= schema.maxItems)) {
    result.addError({
      name: 'maxItems',
      argument: schema.maxItems,
      message: "does not meet maximum length of " + schema.maxItems,
    });
  }
  return result;
};

/**
 * Deep compares arrays for duplicates
 * @param v
 * @param i
 * @param a
 * @private
 * @return {boolean}
 */
function testArrays (v, i, a) {
  var j, len = a.length;
  for (j = i + 1, len; j < len; j++) {
    if (helpers.deepCompareStrict(v, a[j])) {
      return false;
    }
  }
  return true;
}

/**
 * Validates whether there are no duplicates, when the instance is an Array.
 * @param instance
 * @return {String|null}
 */
validators.uniqueItems = function validateUniqueItems (instance, schema, options, ctx) {
  if (schema.uniqueItems!==true) return;
  if (!this.types.array(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (!instance.every(testArrays)) {
    result.addError({
      name: 'uniqueItems',
      message: "contains duplicate item",
    });
  }
  return result;
};

/**
 * Validate for the presence of dependency properties, if the instance is an object.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */
validators.dependencies = function validateDependencies (instance, schema, options, ctx) {
  if (!this.types.object(instance)) return;
  var result = new ValidatorResult(instance, schema, options, ctx);
  for (var property in schema.dependencies) {
    if (instance[property] === undefined) {
      continue;
    }
    var dep = schema.dependencies[property];
    var childContext = ctx.makeChild(dep, property);
    if (typeof dep == 'string') {
      dep = [dep];
    }
    if (Array.isArray(dep)) {
      dep.forEach(function (prop) {
        if (instance[prop] === undefined) {
          result.addError({
            // FIXME there's two different "dependencies" errors here with slightly different outputs
            // Can we make these the same? Or should we create different error types?
            name: 'dependencies',
            argument: childContext.propertyPath,
            message: "property " + prop + " not found, required by " + childContext.propertyPath,
          });
        }
      });
    } else {
      var res = this.validateSchema(instance, dep, options, childContext);
      if(result.instance !== res.instance) result.instance = res.instance;
      if (res && res.errors.length) {
        result.addError({
          name: 'dependencies',
          argument: childContext.propertyPath,
          message: "does not meet dependency required by " + childContext.propertyPath,
        });
        result.importErrors(res);
      }
    }
  }
  return result;
};

/**
 * Validates whether the instance value is one of the enumerated values.
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */
validators['enum'] = function validateEnum (instance, schema, options, ctx) {
  if (instance === undefined) {
    return null;
  }
  if (!Array.isArray(schema['enum'])) {
    throw new SchemaError("enum expects an array", schema);
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (!schema['enum'].some(helpers.deepCompareStrict.bind(null, instance))) {
    result.addError({
      name: 'enum',
      argument: schema['enum'],
      message: "is not one of enum values: " + schema['enum'].map(String).join(','),
    });
  }
  return result;
};

/**
 * Validates whether the instance exactly matches a given value
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */
validators['const'] = function validateEnum (instance, schema, options, ctx) {
  if (instance === undefined) {
    return null;
  }
  var result = new ValidatorResult(instance, schema, options, ctx);
  if (!helpers.deepCompareStrict(schema['const'], instance)) {
    result.addError({
      name: 'const',
      argument: schema['const'],
      message: "does not exactly match expected constant: " + schema['const'],
    });
  }
  return result;
};

/**
 * Validates whether the instance if of a prohibited type.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */
validators.not = validators.disallow = function validateNot (instance, schema, options, ctx) {
  var self = this;
  if(instance===undefined) return null;
  var result = new ValidatorResult(instance, schema, options, ctx);
  var notTypes = schema.not || schema.disallow;
  if(!notTypes) return null;
  if(!Array.isArray(notTypes)) notTypes=[notTypes];
  notTypes.forEach(function (type) {
    if (self.testType(instance, schema, options, ctx, type)) {
      var id = type && (type.$id || type.id);
      var schemaId = id || type;
      result.addError({
        name: 'not',
        argument: schemaId,
        message: "is of prohibited type " + schemaId,
      });
    }
  });
  return result;
};

module.exports = attribute;


/***/ }),

/***/ 5484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uri = __webpack_require__(8398);

var ValidationError = exports.ValidationError = function ValidationError (message, instance, schema, path, name, argument) {
  if(Array.isArray(path)){
    this.path = path;
    this.property = path.reduce(function(sum, item){
      return sum + makeSuffix(item);
    }, 'instance');
  }else if(path !== undefined){
    this.property = path;
  }
  if (message) {
    this.message = message;
  }
  if (schema) {
    var id = schema.$id || schema.id;
    this.schema = id || schema;
  }
  if (instance !== undefined) {
    this.instance = instance;
  }
  this.name = name;
  this.argument = argument;
  this.stack = this.toString();
};

ValidationError.prototype.toString = function toString() {
  return this.property + ' ' + this.message;
};

var ValidatorResult = exports.ValidatorResult = function ValidatorResult(instance, schema, options, ctx) {
  this.instance = instance;
  this.schema = schema;
  this.options = options;
  this.path = ctx.path;
  this.propertyPath = ctx.propertyPath;
  this.errors = [];
  this.throwError = options && options.throwError;
  this.throwFirst = options && options.throwFirst;
  this.throwAll = options && options.throwAll;
  this.disableFormat = options && options.disableFormat === true;
};

ValidatorResult.prototype.addError = function addError(detail) {
  var err;
  if (typeof detail == 'string') {
    err = new ValidationError(detail, this.instance, this.schema, this.path);
  } else {
    if (!detail) throw new Error('Missing error detail');
    if (!detail.message) throw new Error('Missing error message');
    if (!detail.name) throw new Error('Missing validator type');
    err = new ValidationError(detail.message, this.instance, this.schema, this.path, detail.name, detail.argument);
  }

  this.errors.push(err);
  if (this.throwFirst) {
    throw new ValidatorResultError(this);
  }else if(this.throwError){
    throw err;
  }
  return err;
};

ValidatorResult.prototype.importErrors = function importErrors(res) {
  if (typeof res == 'string' || (res && res.validatorType)) {
    this.addError(res);
  } else if (res && res.errors) {
    this.errors = this.errors.concat(res.errors);
  }
};

function stringizer (v,i){
  return i+': '+v.toString()+'\n';
}
ValidatorResult.prototype.toString = function toString(res) {
  return this.errors.map(stringizer).join('');
};

Object.defineProperty(ValidatorResult.prototype, "valid", { get: function() {
  return !this.errors.length;
} });

module.exports.ValidatorResultError = ValidatorResultError;
function ValidatorResultError(result) {
  if(Error.captureStackTrace){
    Error.captureStackTrace(this, ValidatorResultError);
  }
  this.instance = result.instance;
  this.schema = result.schema;
  this.options = result.options;
  this.errors = result.errors;
}
ValidatorResultError.prototype = new Error();
ValidatorResultError.prototype.constructor = ValidatorResultError;
ValidatorResultError.prototype.name = "Validation Error";

/**
 * Describes a problem with a Schema which prevents validation of an instance
 * @name SchemaError
 * @constructor
 */
var SchemaError = exports.SchemaError = function SchemaError (msg, schema) {
  this.message = msg;
  this.schema = schema;
  Error.call(this, msg);
  Error.captureStackTrace(this, SchemaError);
};
SchemaError.prototype = Object.create(Error.prototype,
  {
    constructor: {value: SchemaError, enumerable: false},
    name: {value: 'SchemaError', enumerable: false},
  });

var SchemaContext = exports.SchemaContext = function SchemaContext (schema, options, path, base, schemas) {
  this.schema = schema;
  this.options = options;
  if(Array.isArray(path)){
    this.path = path;
    this.propertyPath = path.reduce(function(sum, item){
      return sum + makeSuffix(item);
    }, 'instance');
  }else{
    this.propertyPath = path;
  }
  this.base = base;
  this.schemas = schemas;
};

SchemaContext.prototype.resolve = function resolve (target) {
  return uri.resolve(this.base, target);
};

SchemaContext.prototype.makeChild = function makeChild(schema, propertyName){
  var path = (propertyName===undefined) ? this.path : this.path.concat([propertyName]);
  var id = schema.$id || schema.id;
  var base = uri.resolve(this.base, id||'');
  var ctx = new SchemaContext(schema, this.options, path, base, Object.create(this.schemas));
  if(id && !ctx.schemas[base]){
    ctx.schemas[base] = schema;
  }
  return ctx;
};

var FORMAT_REGEXPS = exports.FORMAT_REGEXPS = {
  // 7.3.1. Dates, Times, and Duration
  'date-time': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,
  'date': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,
  'time': /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,
  'duration': /P(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S)|\d+(D|M(\d+D)?|Y(\d+M(\d+D)?)?)(T\d+(H(\d+M(\d+S)?)?|M(\d+S)?|S))?|\d+W)/i,

  // 7.3.2. Email Addresses
  // TODO: fix the email production
  'email': /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
  'idn-email': /^("(?:[!#-\[\]-\u{10FFFF}]|\\[\t -\u{10FFFF}])*"|[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*)@([!#-'*+\-/-9=?A-Z\^-\u{10FFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\u{10FFFF}])*|\[[!-Z\^-\u{10FFFF}]*\])$/u,

  // 7.3.3. Hostnames

  // 7.3.4. IP Addresses
  'ip-address': /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  // FIXME whitespace is invalid
  'ipv6': /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,

  // 7.3.5. Resource Identifiers
  // TODO: A more accurate regular expression for "uri" goes:
  // [A-Za-z][+\-.0-9A-Za-z]*:((/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?)?#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])|/?%[0-9A-Fa-f]{2}|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*(#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?)?
  'uri': /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/,
  'uri-reference': /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/,
  'iri': /^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]*$/,
  'iri-reference': /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~-\u{10FFFF}]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~-\u{10FFFF}])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~-\u{10FFFF}]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~-\u{10FFFF}])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~-\u{10FFFF}])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~-\u{10FFFF}])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~-\u{10FFFF}]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/u,
  'uuid': /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,

  // 7.3.6. uri-template
  'uri-template': /(%[0-9a-f]{2}|[!#$&(-;=?@\[\]_a-z~]|\{[!#&+,./;=?@|]?(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?(,(%[0-9a-f]{2}|[0-9_a-z])(\.?(%[0-9a-f]{2}|[0-9_a-z]))*(:[1-9]\d{0,3}|\*)?)*\})*/iu,

  // 7.3.7. JSON Pointers
  'json-pointer': /^(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*$/iu,
  'relative-json-pointer': /^\d+(#|(\/([\x00-\x2e0-@\[-}\x7f]|~[01])*)*)$/iu,

  // hostname regex from: http://stackoverflow.com/a/1420225/5628
  'hostname': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
  'host-name': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,

  'utc-millisec': function (input) {
    return (typeof input === 'string') && parseFloat(input) === parseInt(input, 10) && !isNaN(input);
  },

  // 7.3.8. regex
  'regex': function (input) {
    var result = true;
    try {
      new RegExp(input);
    } catch (e) {
      result = false;
    }
    return result;
  },

  // Other definitions
  // "style" was removed from JSON Schema in draft-4 and is deprecated
  'style': /[\r\n\t ]*[^\r\n\t ][^:]*:[\r\n\t ]*[^\r\n\t ;]*[\r\n\t ]*;?/,
  // "color" was removed from JSON Schema in draft-4 and is deprecated
  'color': /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,
  'phone': /^\+(?:[0-9] ?){6,14}[0-9]$/,
  'alpha': /^[a-zA-Z]+$/,
  'alphanumeric': /^[a-zA-Z0-9]+$/,
};

FORMAT_REGEXPS.regexp = FORMAT_REGEXPS.regex;
FORMAT_REGEXPS.pattern = FORMAT_REGEXPS.regex;
FORMAT_REGEXPS.ipv4 = FORMAT_REGEXPS['ip-address'];

exports.isFormat = function isFormat (input, format, validator) {
  if (typeof input === 'string' && FORMAT_REGEXPS[format] !== undefined) {
    if (FORMAT_REGEXPS[format] instanceof RegExp) {
      return FORMAT_REGEXPS[format].test(input);
    }
    if (typeof FORMAT_REGEXPS[format] === 'function') {
      return FORMAT_REGEXPS[format](input);
    }
  } else if (validator && validator.customFormats &&
      typeof validator.customFormats[format] === 'function') {
    return validator.customFormats[format](input);
  }
  return true;
};

var makeSuffix = exports.makeSuffix = function makeSuffix (key) {
  key = key.toString();
  // This function could be capable of outputting valid a ECMAScript string, but the
  // resulting code for testing which form to use would be tens of thousands of characters long
  // That means this will use the name form for some illegal forms
  if (!key.match(/[.\s\[\]]/) && !key.match(/^[\d]/)) {
    return '.' + key;
  }
  if (key.match(/^\d+$/)) {
    return '[' + key + ']';
  }
  return '[' + JSON.stringify(key) + ']';
};

exports.deepCompareStrict = function deepCompareStrict (a, b) {
  if (typeof a !== typeof b) {
    return false;
  }
  if (Array.isArray(a)) {
    if (!Array.isArray(b)) {
      return false;
    }
    if (a.length !== b.length) {
      return false;
    }
    return a.every(function (v, i) {
      return deepCompareStrict(a[i], b[i]);
    });
  }
  if (typeof a === 'object') {
    if (!a || !b) {
      return a === b;
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    return aKeys.every(function (v) {
      return deepCompareStrict(a[v], b[v]);
    });
  }
  return a === b;
};

function deepMerger (target, dst, e, i) {
  if (typeof e === 'object') {
    dst[i] = deepMerge(target[i], e);
  } else {
    if (target.indexOf(e) === -1) {
      dst.push(e);
    }
  }
}

function copyist (src, dst, key) {
  dst[key] = src[key];
}

function copyistWithDeepMerge (target, src, dst, key) {
  if (typeof src[key] !== 'object' || !src[key]) {
    dst[key] = src[key];
  }
  else {
    if (!target[key]) {
      dst[key] = src[key];
    } else {
      dst[key] = deepMerge(target[key], src[key]);
    }
  }
}

function deepMerge (target, src) {
  var array = Array.isArray(src);
  var dst = array && [] || {};

  if (array) {
    target = target || [];
    dst = dst.concat(target);
    src.forEach(deepMerger.bind(null, target, dst));
  } else {
    if (target && typeof target === 'object') {
      Object.keys(target).forEach(copyist.bind(null, target, dst));
    }
    Object.keys(src).forEach(copyistWithDeepMerge.bind(null, target, src, dst));
  }

  return dst;
}

module.exports.deepMerge = deepMerge;

/**
 * Validates instance against the provided schema
 * Implements URI+JSON Pointer encoding, e.g. "%7e"="~0"=>"~", "~1"="%2f"=>"/"
 * @param o
 * @param s The path to walk o along
 * @return any
 */
exports.objectGetPath = function objectGetPath(o, s) {
  var parts = s.split('/').slice(1);
  var k;
  while (typeof (k=parts.shift()) == 'string') {
    var n = decodeURIComponent(k.replace(/~0/,'~').replace(/~1/g,'/'));
    if (!(n in o)) return;
    o = o[n];
  }
  return o;
};

function pathEncoder (v) {
  return '/'+encodeURIComponent(v).replace(/~/g,'%7E');
}
/**
 * Accept an Array of property names and return a JSON Pointer URI fragment
 * @param Array a
 * @return {String}
 */
exports.encodePath = function encodePointer(a){
  // ~ must be encoded explicitly because hacks
  // the slash is encoded by encodeURIComponent
  return a.map(pathEncoder).join('');
};


/**
 * Calculate the number of decimal places a number uses
 * We need this to get correct results out of multipleOf and divisibleBy
 * when either figure is has decimal places, due to IEEE-754 float issues.
 * @param number
 * @returns {number}
 */
exports.getDecimalPlaces = function getDecimalPlaces(number) {

  var decimalPlaces = 0;
  if (isNaN(number)) return decimalPlaces;

  if (typeof number !== 'number') {
    number = Number(number);
  }

  var parts = number.toString().split('e');
  if (parts.length === 2) {
    if (parts[1][0] !== '-') {
      return decimalPlaces;
    } else {
      decimalPlaces = Number(parts[1].slice(1));
    }
  }

  var decimalParts = parts[0].split('.');
  if (decimalParts.length === 2) {
    decimalPlaces += decimalParts[1].length;
  }

  return decimalPlaces;
};

exports.isSchema = function isSchema(val){
  return (typeof val === 'object' && val) || (typeof val === 'boolean');
};



/***/ }),

/***/ 663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var Validator = module.exports.Validator = __webpack_require__(9852);

/* unused reexport */ __webpack_require__(5484).ValidatorResult;
/* unused reexport */ __webpack_require__(5484).ValidatorResultError;
/* unused reexport */ __webpack_require__(5484).ValidationError;
/* unused reexport */ __webpack_require__(5484).SchemaError;
/* unused reexport */ __webpack_require__(6456);
/* unused reexport */ __webpack_require__(6456)/* .scan */ .R;

__webpack_unused_export__ = function (instance, schema, options) {
  var v = new Validator();
  return v.validate(instance, schema, options);
};


/***/ }),

/***/ 6456:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var urilib = __webpack_require__(8398);
var helpers = __webpack_require__(5484);

__webpack_unused_export__ = SchemaScanResult;
function SchemaScanResult(found, ref){
  this.id = found;
  this.ref = ref;
}

/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param string uri
 * @param object schema
 * @return {Object}
 */
module.exports.R = function scan(base, schema){
  function scanSchema(baseuri, schema){
    if(!schema || typeof schema!='object') return;
    // Mark all referenced schemas so we can tell later which schemas are referred to, but never defined
    if(schema.$ref){
      var resolvedUri = urilib.resolve(baseuri, schema.$ref);
      ref[resolvedUri] = ref[resolvedUri] ? ref[resolvedUri]+1 : 0;
      return;
    }
    var id = schema.$id || schema.id;
    var ourBase = id ? urilib.resolve(baseuri, id) : baseuri;
    if (ourBase) {
      // If there's no fragment, append an empty one
      if(ourBase.indexOf('#')<0) ourBase += '#';
      if(found[ourBase]){
        if(!helpers.deepCompareStrict(found[ourBase], schema)){
          throw new Error('Schema <'+ourBase+'> already exists with different definition');
        }
        return found[ourBase];
      }
      found[ourBase] = schema;
      // strip trailing fragment
      if(ourBase[ourBase.length-1]=='#'){
        found[ourBase.substring(0, ourBase.length-1)] = schema;
      }
    }
    scanArray(ourBase+'/items', (Array.isArray(schema.items)?schema.items:[schema.items]));
    scanArray(ourBase+'/extends', (Array.isArray(schema.extends)?schema.extends:[schema.extends]));
    scanSchema(ourBase+'/additionalItems', schema.additionalItems);
    scanObject(ourBase+'/properties', schema.properties);
    scanSchema(ourBase+'/additionalProperties', schema.additionalProperties);
    scanObject(ourBase+'/definitions', schema.definitions);
    scanObject(ourBase+'/patternProperties', schema.patternProperties);
    scanObject(ourBase+'/dependencies', schema.dependencies);
    scanArray(ourBase+'/disallow', schema.disallow);
    scanArray(ourBase+'/allOf', schema.allOf);
    scanArray(ourBase+'/anyOf', schema.anyOf);
    scanArray(ourBase+'/oneOf', schema.oneOf);
    scanSchema(ourBase+'/not', schema.not);
  }
  function scanArray(baseuri, schemas){
    if(!Array.isArray(schemas)) return;
    for(var i=0; i<schemas.length; i++){
      scanSchema(baseuri+'/'+i, schemas[i]);
    }
  }
  function scanObject(baseuri, schemas){
    if(!schemas || typeof schemas!='object') return;
    for(var p in schemas){
      scanSchema(baseuri+'/'+p, schemas[p]);
    }
  }

  var found = {};
  var ref = {};
  scanSchema(base, schema);
  return new SchemaScanResult(found, ref);
};


/***/ }),

/***/ 9852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var urilib = __webpack_require__(8398);

var attribute = __webpack_require__(9412);
var helpers = __webpack_require__(5484);
var scanSchema = (__webpack_require__(6456)/* .scan */ .R);
var ValidatorResult = helpers.ValidatorResult;
var ValidatorResultError = helpers.ValidatorResultError;
var SchemaError = helpers.SchemaError;
var SchemaContext = helpers.SchemaContext;
//var anonymousBase = 'vnd.jsonschema:///';
var anonymousBase = '/';

/**
 * Creates a new Validator object
 * @name Validator
 * @constructor
 */
var Validator = function Validator () {
  // Allow a validator instance to override global custom formats or to have their
  // own custom formats.
  this.customFormats = Object.create(Validator.prototype.customFormats);
  this.schemas = {};
  this.unresolvedRefs = [];

  // Use Object.create to make this extensible without Validator instances stepping on each other's toes.
  this.types = Object.create(types);
  this.attributes = Object.create(attribute.validators);
};

// Allow formats to be registered globally.
Validator.prototype.customFormats = {};

// Hint at the presence of a property
Validator.prototype.schemas = null;
Validator.prototype.types = null;
Validator.prototype.attributes = null;
Validator.prototype.unresolvedRefs = null;

/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param schema
 * @param urn
 * @return {Object}
 */
Validator.prototype.addSchema = function addSchema (schema, base) {
  var self = this;
  if (!schema) {
    return null;
  }
  var scan = scanSchema(base||anonymousBase, schema);
  var ourUri = base || schema.$id || schema.id;
  for(var uri in scan.id){
    this.schemas[uri] = scan.id[uri];
  }
  for(var uri in scan.ref){
    // If this schema is already defined, it will be filtered out by the next step
    this.unresolvedRefs.push(uri);
  }
  // Remove newly defined schemas from unresolvedRefs
  this.unresolvedRefs = this.unresolvedRefs.filter(function(uri){
    return typeof self.schemas[uri]==='undefined';
  });
  return this.schemas[ourUri];
};

Validator.prototype.addSubSchemaArray = function addSubSchemaArray(baseuri, schemas) {
  if(!Array.isArray(schemas)) return;
  for(var i=0; i<schemas.length; i++){
    this.addSubSchema(baseuri, schemas[i]);
  }
};

Validator.prototype.addSubSchemaObject = function addSubSchemaArray(baseuri, schemas) {
  if(!schemas || typeof schemas!='object') return;
  for(var p in schemas){
    this.addSubSchema(baseuri, schemas[p]);
  }
};



/**
 * Sets all the schemas of the Validator instance.
 * @param schemas
 */
Validator.prototype.setSchemas = function setSchemas (schemas) {
  this.schemas = schemas;
};

/**
 * Returns the schema of a certain urn
 * @param urn
 */
Validator.prototype.getSchema = function getSchema (urn) {
  return this.schemas[urn];
};

/**
 * Validates instance against the provided schema
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {Array}
 */
Validator.prototype.validate = function validate (instance, schema, options, ctx) {
  if((typeof schema !== 'boolean' && typeof schema !== 'object') || schema === null){
    throw new SchemaError('Expected `schema` to be an object or boolean');
  }
  if (!options) {
    options = {};
  }
  // This section indexes subschemas in the provided schema, so they don't need to be added with Validator#addSchema
  // This will work so long as the function at uri.resolve() will resolve a relative URI to a relative URI
  var id = schema.$id || schema.id;
  var base = urilib.resolve(options.base||anonymousBase, id||'');
  if(!ctx){
    ctx = new SchemaContext(schema, options, [], base, Object.create(this.schemas));
    if (!ctx.schemas[base]) {
      ctx.schemas[base] = schema;
    }
    var found = scanSchema(base, schema);
    for(var n in found.id){
      var sch = found.id[n];
      ctx.schemas[n] = sch;
    }
  }
  if(options.required && instance===undefined){
    var result = new ValidatorResult(instance, schema, options, ctx);
    result.addError('is required, but is undefined');
    return result;
  }
  var result = this.validateSchema(instance, schema, options, ctx);
  if (!result) {
    throw new Error('Result undefined');
  }else if(options.throwAll && result.errors.length){
    throw new ValidatorResultError(result);
  }
  return result;
};

/**
* @param Object schema
* @return mixed schema uri or false
*/
function shouldResolve(schema) {
  var ref = (typeof schema === 'string') ? schema : schema.$ref;
  if (typeof ref=='string') return ref;
  return false;
}

/**
 * Validates an instance against the schema (the actual work horse)
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @private
 * @return {ValidatorResult}
 */
Validator.prototype.validateSchema = function validateSchema (instance, schema, options, ctx) {
  var result = new ValidatorResult(instance, schema, options, ctx);

  // Support for the true/false schemas
  if(typeof schema==='boolean') {
    if(schema===true){
      // `true` is always valid
      schema = {};
    }else if(schema===false){
      // `false` is always invalid
      schema = {type: []};
    }
  }else if(!schema){
    // This might be a string
    throw new Error("schema is undefined");
  }

  if (schema['extends']) {
    if (Array.isArray(schema['extends'])) {
      var schemaobj = {schema: schema, ctx: ctx};
      schema['extends'].forEach(this.schemaTraverser.bind(this, schemaobj));
      schema = schemaobj.schema;
      schemaobj.schema = null;
      schemaobj.ctx = null;
      schemaobj = null;
    } else {
      schema = helpers.deepMerge(schema, this.superResolve(schema['extends'], ctx));
    }
  }

  // If passed a string argument, load that schema URI
  var switchSchema = shouldResolve(schema);
  if (switchSchema) {
    var resolved = this.resolve(schema, switchSchema, ctx);
    var subctx = new SchemaContext(resolved.subschema, options, ctx.path, resolved.switchSchema, ctx.schemas);
    return this.validateSchema(instance, resolved.subschema, options, subctx);
  }

  var skipAttributes = options && options.skipAttributes || [];
  // Validate each schema attribute against the instance
  for (var key in schema) {
    if (!attribute.ignoreProperties[key] && skipAttributes.indexOf(key) < 0) {
      var validatorErr = null;
      var validator = this.attributes[key];
      if (validator) {
        validatorErr = validator.call(this, instance, schema, options, ctx);
      } else if (options.allowUnknownAttributes === false) {
        // This represents an error with the schema itself, not an invalid instance
        throw new SchemaError("Unsupported attribute: " + key, schema);
      }
      if (validatorErr) {
        result.importErrors(validatorErr);
      }
    }
  }

  if (typeof options.rewrite == 'function') {
    var value = options.rewrite.call(this, instance, schema, options, ctx);
    result.instance = value;
  }
  return result;
};

/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/
Validator.prototype.schemaTraverser = function schemaTraverser (schemaobj, s) {
  schemaobj.schema = helpers.deepMerge(schemaobj.schema, this.superResolve(s, schemaobj.ctx));
};

/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/
Validator.prototype.superResolve = function superResolve (schema, ctx) {
  var ref = shouldResolve(schema);
  if(ref) {
    return this.resolve(schema, ref, ctx).subschema;
  }
  return schema;
};

/**
* @private
* @param Object schema
* @param Object switchSchema
* @param SchemaContext ctx
* @return Object resolved schemas {subschema:String, switchSchema: String}
* @throws SchemaError
*/
Validator.prototype.resolve = function resolve (schema, switchSchema, ctx) {
  switchSchema = ctx.resolve(switchSchema);
  // First see if the schema exists under the provided URI
  if (ctx.schemas[switchSchema]) {
    return {subschema: ctx.schemas[switchSchema], switchSchema: switchSchema};
  }
  // Else try walking the property pointer
  var parsed = urilib.parse(switchSchema);
  var fragment = parsed && parsed.hash;
  var document = fragment && fragment.length && switchSchema.substr(0, switchSchema.length - fragment.length);
  if (!document || !ctx.schemas[document]) {
    throw new SchemaError("no such schema <" + switchSchema + ">", schema);
  }
  var subschema = helpers.objectGetPath(ctx.schemas[document], fragment.substr(1));
  if(subschema===undefined){
    throw new SchemaError("no such schema " + fragment + " located in <" + document + ">", schema);
  }
  return {subschema: subschema, switchSchema: switchSchema};
};

/**
 * Tests whether the instance if of a certain type.
 * @private
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @param type
 * @return {boolean}
 */
Validator.prototype.testType = function validateType (instance, schema, options, ctx, type) {
  if(type===undefined){
    return;
  }else if(type===null){
    throw new SchemaError('Unexpected null in "type" keyword');
  }
  if (typeof this.types[type] == 'function') {
    return this.types[type].call(this, instance);
  }
  if (type && typeof type == 'object') {
    var res = this.validateSchema(instance, type, options, ctx);
    return res === undefined || !(res && res.errors.length);
  }
  // Undefined or properties not on the list are acceptable, same as not being defined
  return true;
};

var types = Validator.prototype.types = {};
types.string = function testString (instance) {
  return typeof instance == 'string';
};
types.number = function testNumber (instance) {
  // isFinite returns false for NaN, Infinity, and -Infinity
  return typeof instance == 'number' && isFinite(instance);
};
types.integer = function testInteger (instance) {
  return (typeof instance == 'number') && instance % 1 === 0;
};
types.boolean = function testBoolean (instance) {
  return typeof instance == 'boolean';
};
types.array = function testArray (instance) {
  return Array.isArray(instance);
};
types['null'] = function testNull (instance) {
  return instance === null;
};
types.date = function testDate (instance) {
  return instance instanceof Date;
};
types.any = function testAny (instance) {
  return true;
};
types.object = function testObject (instance) {
  // TODO: fix this - see #15
  return instance && (typeof instance === 'object') && !(Array.isArray(instance)) && !(instance instanceof Date);
};

module.exports = Validator;


/***/ }),

/***/ 9515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(8761),
    root = __webpack_require__(7772);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 9612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2118),
    hashDelete = __webpack_require__(6909),
    hashGet = __webpack_require__(8138),
    hashHas = __webpack_require__(4174),
    hashSet = __webpack_require__(7942);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3945),
    listCacheDelete = __webpack_require__(1846),
    listCacheGet = __webpack_require__(8028),
    listCacheHas = __webpack_require__(2344),
    listCacheSet = __webpack_require__(4769);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(8761),
    root = __webpack_require__(7772);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 6738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2411),
    mapCacheDelete = __webpack_require__(6417),
    mapCacheGet = __webpack_require__(6928),
    mapCacheHas = __webpack_require__(9493),
    mapCacheSet = __webpack_require__(4150);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 2760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(8761),
    root = __webpack_require__(7772);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(8761),
    root = __webpack_require__(7772);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 5386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(6738),
    setCacheAdd = __webpack_require__(2842),
    setCacheHas = __webpack_require__(2482);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 6571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(235),
    stackClear = __webpack_require__(5243),
    stackDelete = __webpack_require__(2858),
    stackGet = __webpack_require__(4417),
    stackHas = __webpack_require__(8605),
    stackSet = __webpack_require__(445);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(7772);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 9162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(7772);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 3215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(8761),
    root = __webpack_require__(7772);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 7552:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 1634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(6473),
    isArguments = __webpack_require__(9631),
    isArray = __webpack_require__(6152),
    isBuffer = __webpack_require__(3226),
    isIndex = __webpack_require__(9045),
    isTypedArray = __webpack_require__(7598);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 343:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 5067:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 7064:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 2218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(1225);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 2034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(5067),
    isFlattenable = __webpack_require__(5882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 3324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(7297),
    toKey = __webpack_require__(3812);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 1897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(5067),
    isArray = __webpack_require__(6152);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 3366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(857),
    getRawTag = __webpack_require__(890),
    objectToString = __webpack_require__(7157);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 5183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(3366),
    isObjectLike = __webpack_require__(5125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 8746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1952),
    isObjectLike = __webpack_require__(5125);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 1952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6571),
    equalArrays = __webpack_require__(4871),
    equalByTag = __webpack_require__(1491),
    equalObjects = __webpack_require__(7416),
    getTag = __webpack_require__(940),
    isArray = __webpack_require__(6152),
    isBuffer = __webpack_require__(3226),
    isTypedArray = __webpack_require__(7598);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1049),
    isMasked = __webpack_require__(7394),
    isObject = __webpack_require__(9259),
    toSource = __webpack_require__(7035);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 5522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(3366),
    isLength = __webpack_require__(1158),
    isObjectLike = __webpack_require__(5125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 6411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(6001),
    nativeKeys = __webpack_require__(4248);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 3228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 6473:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 1054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(857),
    arrayMap = __webpack_require__(343),
    isArray = __webpack_require__(6152),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 1704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(2153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7826:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 9950:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 7297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6152),
    isKey = __webpack_require__(1401),
    stringToPath = __webpack_require__(4452),
    toString = __webpack_require__(6188);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 1522:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 4019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(7772);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 2941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(3228),
    isIterateeCall = __webpack_require__(2406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 4871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(5386),
    arraySome = __webpack_require__(7064),
    cacheHas = __webpack_require__(9950);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 1491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(857),
    Uint8Array = __webpack_require__(9162),
    eq = __webpack_require__(1225),
    equalArrays = __webpack_require__(4871),
    mapToArray = __webpack_require__(5179),
    setToArray = __webpack_require__(4207);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 7416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(3483);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 1242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 3483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1897),
    getSymbols = __webpack_require__(633),
    keys = __webpack_require__(249);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 7937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(8304);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 8761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(6840),
    getValue = __webpack_require__(8109);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 890:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(857);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(7552),
    stubArray = __webpack_require__(981);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(9515),
    Map = __webpack_require__(326),
    Promise = __webpack_require__(2760),
    Set = __webpack_require__(2143),
    WeakMap = __webpack_require__(3215),
    baseGetTag = __webpack_require__(3366),
    toSource = __webpack_require__(7035);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 8109:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 2118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(9191);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 6909:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 8138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(9191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 4174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(9191);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 7942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(9191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(857),
    isArguments = __webpack_require__(9631),
    isArray = __webpack_require__(6152);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 9045:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 2406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(1225),
    isArrayLike = __webpack_require__(7878),
    isIndex = __webpack_require__(9045),
    isObject = __webpack_require__(9259);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 1401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6152),
    isSymbol = __webpack_require__(4795);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 8304:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 7394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(4019);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 6001:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 3945:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 1846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(2218);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 8028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(2218);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 2344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(2218);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 4769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(2218);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 2411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(9612),
    ListCache = __webpack_require__(235),
    Map = __webpack_require__(326);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 6417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(7937);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 6928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(7937);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 9493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(7937);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 4150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(7937);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 5179:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 7777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(733);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 9191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(8761);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 4248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 4146:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(1242);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 7157:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 241:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 7772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1242);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 2842:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 2482:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 4207:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 5243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(235);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 2858:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 4417:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 8605:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(235),
    Map = __webpack_require__(326),
    MapCache = __webpack_require__(6738);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 4452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(7777);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 3812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 7035:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 2153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2487:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(5067),
    baseFlatten = __webpack_require__(2034),
    copyArray = __webpack_require__(1522),
    isArray = __webpack_require__(6152);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),

/***/ 4073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(9259),
    now = __webpack_require__(1100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 1225:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 2579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(3324);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 9631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(5183),
    isObjectLike = __webpack_require__(5125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 6152:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 7878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1049),
    isLength = __webpack_require__(1158);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 3226:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(7772),
    stubFalse = __webpack_require__(9207);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 8149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(8746);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 1049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(3366),
    isObject = __webpack_require__(9259);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1158:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 9259:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 5125:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 4795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(3366),
    isObjectLike = __webpack_require__(5125);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(5522),
    baseUnary = __webpack_require__(7826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1634),
    baseKeys = __webpack_require__(6411),
    isArrayLike = __webpack_require__(7878);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(6738);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 1100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(7772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(2941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 981:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 9207:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(1704),
    isObject = __webpack_require__(9259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 6188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(1054);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 2174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var e=__webpack_require__(5965),r=__webpack_require__(5632);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=t(__webpack_require__(2784));function o(){return o=Object.assign?Object.assign.bind():function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},o.apply(this,arguments)}var i=["children","locale","now"];function l(t){var l,u=t.children,a=t.locale,c=t.now,f=function(e,r){if(null==e)return{};var t,n,o={},i=Object.keys(e);for(n=0;n<i.length;n++)r.indexOf(t=i[n])>=0||(o[t]=e[t]);return o}(t,i);try{l=r.useRouter()}catch(e){}if(!a&&l&&(a=l.locale),"string"==typeof c&&(c=new Date(c)),!a)throw new Error(void 0);return n.default.createElement(e.IntlProvider,o({locale:a,now:c},f),u)}exports.NextIntlClientProvider=l,exports.NextIntlProvider=l,Object.keys(e).forEach((function(r){"default"===r||exports.hasOwnProperty(r)||Object.defineProperty(exports,r,{enumerable:!0,get:function(){return e[r]}})}));
//# sourceMappingURL=next-intl.cjs.production.min.js.map


/***/ }),

/***/ 6570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(7218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4260:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4406);
/** @type {import('tailwindcss').Config} */ 
var ref, ref1;
module.exports = {
    theme: {
        screens: {
            // No need for 'xs' (as specified as the smalles viewport by UX), because Tailwind approaches mobile-first
            // See: https://www.figma.com/file/D6rYLd5IYqWsqcXTDLqZQA/ST-MVP-Pattern-Library?node-id=1861%3A13942
            // xs: '375px',
            md: "768px",
            lg: "992px",
            xl: "1280px"
        },
        colors: {
            primary: "#222222",
            color1: {
                DEFAULT: "#00977D",
                800: "#006E5B",
                900: "#005244"
            },
            color2: {
                400: "#C5E7E2",
                DEFAULT: "#6EC2B7"
            },
            color3: "#FF4B19",
            color4: "#E4A5A3",
            color5: "#F5F5F5",
            color6: "#B6BFC1",
            color7: "#5E6E6A",
            color8: "#E8EDEC",
            white: "#FFFFFF",
            dark: "#00000080",
            error: "#880D1E",
            errorLight: "#FFE8EB",
            current: "currentcolor",
            transparent: "transparent",
            green: {
                gradient: {
                    from: "#0D8C76",
                    to: "#06705F"
                }
            },
            orange: {
                gradient: {
                    from: "#FF4B19",
                    to: "#FF8664"
                }
            },
            mint: {
                gradient: {
                    from: "#6EC2B7",
                    to: "#4FBBAD"
                }
            },
            brand: {
                gradient: {
                    from: "#FF4B19",
                    via: "#E4A5A3",
                    to: "#6CC2B6"
                }
            }
        },
        fontFamily: {
            quicksand: [
                "Quicksand",
                "Bryant",
                '"Proxima Nova Soft"',
                "Arial Rounded MT Bold",
                "sans-serif", 
            ],
            source: [
                '"Source Sans Pro"',
                "ui-sans-serif",
                "system-ui",
                "sans-serif"
            ]
        },
        lineHeight: {
            base: "32px",
            focus: "0.666",
            xxs: "1",
            xs: "1.2",
            sm: "1.25",
            md: "1.3",
            lg: "1.333",
            xl: "1.4",
            xxl: "1.466"
        },
        fontSize: {
            basetext: "18px",
            focus: "0.666rem",
            xxs: "0.833rem",
            xs: "0.888rem",
            sm: "1rem",
            md: "1.555rem",
            lg: "2.111rem",
            xl: "2.666rem"
        },
        spacing: {
            0: "0",
            5: "2px",
            10: "4px",
            20: "8px",
            30: "12px",
            40: "16px",
            50: "24px",
            60: "32px",
            70: "40px",
            80: "48px",
            90: "64px",
            100: "72px",
            110: "96px",
            120: "112px",
            130: "128px",
            140: "144px",
            150: "160px"
        },
        borderRadius: {
            none: "0",
            xxs: "2px",
            xs: "4px",
            sm: "8px",
            md: "12px",
            lg: "24px"
        },
        boxShadow: {
            sm: "0px 6px 20px rgba(0, 0, 0, 0.06)",
            md: "0px 10px 25px rgba(0, 0, 0, 0.08)",
            lg: "0px 10px 30px rgba(0, 0, 0, 0.14)"
        },
        backgroundImage: {
            // @see https://www.scien.cx/2021/11/10/adding-radial-gradients-to-tailwind-css/
            none: "none",
            "gradient-to-t": "linear-gradient(0deg, var(--tw-gradient-stops))",
            "gradient-to-b": "linear-gradient(180deg, var(--tw-gradient-stops))",
            "gradient-to-r": "linear-gradient(90deg, var(--tw-gradient-stops))",
            "gradient-to-l": "linear-gradient(270deg, var(--tw-gradient-stops))",
            "gradient-radial": "radial-gradient(ellipse at center, var(--tw-gradient-stops))",
            "gradient-radial-at-t": "radial-gradient(ellipse at top, var(--tw-gradient-stops))",
            "gradient-radial-at-b": "radial-gradient(ellipse at bottom, var(--tw-gradient-stops))",
            "gradient-radial-at-l": "radial-gradient(ellipse at left, var(--tw-gradient-stops))",
            "gradient-radial-at-r": "radial-gradient(ellipse at right, var(--tw-gradient-stops))",
            "gradient-radial-at-tl": "radial-gradient(ellipse at top left, var(--tw-gradient-stops))",
            "gradient-radial-at-tr": "radial-gradient(ellipse at top right, var(--tw-gradient-stops))",
            "gradient-radial-at-bl": "radial-gradient(ellipse at bottom left, var(--tw-gradient-stops))",
            "gradient-radial-at-br": "radial-gradient(ellipse at bottom right, var(--tw-gradient-stops))"
        },
        extend: {
            backgroundImage: {
                "footer-small": ((ref = process.env.npm_lifecycle_event) === null || ref === void 0 ? void 0 : ref.includes("storybook")) ? "url('../components/layout/footer/swirl.svg')" : "url('~/components/layout/footer/swirl.svg')",
                "footer-large": ((ref1 = process.env.npm_lifecycle_event) === null || ref1 === void 0 ? void 0 : ref1.includes("storybook")) ? "url('../components/layout/footer/swirl-large.svg')" : "url('~/components/layout/footer/swirl-large.svg')"
            },
            transitionDuration: {
                400: "400ms",
                600: "600ms",
                800: "800ms",
                900: "900ms"
            },
            width: {
                350: "350px"
            },
            gridTemplateColumns: {
                "1-2-1": "1fr 2fr 1fr",
                24: "repeat(24, minmax(0, 1fr))"
            },
            maxWidth: {
                400: "400px"
            }
        }
    }
};


/***/ }),

/***/ 2081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "useHost": function() { return /* reexport */ useHost; }
});

// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var src = __webpack_require__(2775);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/Host/hooks/useHost.ts

var useClientContext = src/* Context.useClientContext */._y.useClientContext;
// have to do this because type assertion functions have some stupid restrictions
var hasContext = src/* Context.guardContext */._y.guardContext;
var useHost = function useHost() {
    var result = useClientContext("host");
    hasContext("host", result);
    var _value = result.value, baseUrl = _value.baseUrl, baseImageUrl = _value.baseImageUrl;
    return {
        alternativeBaseUrls: baseUrl.alternatives,
        baseUrl: baseUrl.current,
        formatImage: function formatImage(path) {
            if (!path) {
                return "";
            }
            var join = path.indexOf("/") === 0 ? "" : "/";
            if (path.indexOf("/car_image.php") === 0) {
                // car_image.php only works with '290' width at the moment
                return "".concat(baseUrl.current).concat(join).concat(path.replace(/width=120/, "width=290"));
            }
            return "".concat(baseImageUrl).concat(join).concat(path);
        }
    };
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/Host/hooks/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/Host/index.ts



/***/ }),

/***/ 7857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jL": function() { return /* reexport */ Banner; },
  "IW": function() { return /* reexport */ Host; },
  "uN": function() { return /* reexport */ LayoutLegacy_namespaceObject; },
  "C5": function() { return /* reexport */ TooltipBadge; }
});

// UNUSED EXPORTS: AccordionContentBlock, AutoRentalData, BrandLogo, CollapsableContentBlock, DataVizLegacy, DateRangePicker, FaqData, HeaderIconStyles, ImageContentBlock, InfolinePopoverButton, LinkListBlock, MembershipPopover, MintGradientBanner, OpeningTimes, PlainContentModuleContainer, ProductData, ResponsiveLogo, Runtime, SiteInfoContext, SiteInfoProvider, StandardContentRowBlock, TabBodyContentBlock, TabListContentBlock, TextContentBlock, TextContentBlockWithFigures, TextContentBlockWithIcons, WaveContentModuleContainer, account, analytics, currency, getDisplayName, getLocation, selectBackgroundStyle, selectBadgeStyle, selectLayoutFlow, subscription, useKeyNavigation, useSearchSuggestions, useSiteInfo

// NAMESPACE OBJECT: ../../frontend/entities/src/_legacy/LayoutLegacy/index.ts
var LayoutLegacy_namespaceObject = {};
__webpack_require__.r(LayoutLegacy_namespaceObject);
__webpack_require__.d(LayoutLegacy_namespaceObject, {
  "Eu": function() { return ColumnRatioOption; },
  "OO": function() { return ContentContainer; },
  "wP": function() { return FilledSegment; },
  "tE": function() { return FooterSegment; },
  "rj": function() { return Grid; },
  "oQ": function() { return ImageSegment; },
  "_V": function() { return PlainSegment; },
  "VZ": function() { return TwoColumns; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var src = __webpack_require__(2775);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/Banner/Banner.styles.ts



var BannerBackgroundSwirlWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1j0zz9x0"
}, "target", "e1j0zz9x0"))("svg{position:absolute;bottom:0;left:0;right:0;}");
var Banner_styles_BannerBackground = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1j0zz9x1"
}, "target", "e1j0zz9x1"))("background:linear-gradient(\n    103.44deg,#6ec2b7 3.17%,", src/* Theme.Color.primary */.Q2.Color.primary, " 100%\n  );background-repeat:no-repeat;box-shadow:0 -0.125rem 0.25rem rgb(0 0 0 / 20%);border-radius:0.5rem 0.5rem 0 0;height:13.375rem;position:relative;overflow:hidden;");
var Banner_styles_BannerPromoText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1j0zz9x2"
}, "target", "e1j0zz9x2"))("width:86%;margin:1rem auto 1.5rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;line-height:1.5;display:flex;align-items:center;text-align:center;position:relative;z-index:1;");


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/Banner/Banner.tsx




var BannerBackgroundSwirl = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 159).then(__webpack_require__.bind(__webpack_require__, 159)).then(function(module) {
        return module.BannerBackgroundSwirl;
    });
}, (0,src_define_property/* default */.Z)({
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(159)
            ];
        }
    }
}, "loadableGenerated", {
    webpack: function webpack() {
        return [
            /*require.resolve*/(159)
        ];
    }
}));
var Banner = function Banner(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Banner_styles_BannerBackground, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Banner_styles_BannerPromoText, {
                children: title
            }),
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BannerBackgroundSwirlWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BannerBackgroundSwirl, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/Banner/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/MintGradientBanner/MintGradientBanner.styles.ts



var MintGradientBanner_styles_BannerBackground = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "evu72rm0"
}, "target", "evu72rm0"))("background:", function(param) {
    var theme = param.theme;
    return "linear-gradient(to right,  ".concat(theme.color.primaryGradient1, ", ").concat(theme.color.primary, ")");
}, ";")));
var MintGradientBanner_styles_BannerPromoText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "evu72rm1"
}, "target", "evu72rm1"))(src/* interactiveText */.Tp, "  margin:auto;");


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/MintGradientBanner/MintGradientBanner.tsx


var MintGradientBanner = function MintGradientBanner(param) {
    var children = param.children, text = param.text, className = param.className, onClickTracking = param.onClickTracking;
    return /*#__PURE__*/ _jsxs(BannerBackground, {
        className: className,
        onClick: onClickTracking,
        children: [
            /*#__PURE__*/ _jsx(BannerPromoText, {
                id: "banner-text",
                textColor: "white",
                children: text
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/MintGradientBanner/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/PromotionLegacy/index.ts



;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/DataViz/components/Table.styles.ts



var Table_styles_TableContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("table", (0,src_define_property/* default */.Z)({
    target: "e12j11q60"
}, "target", "e12j11q60"))("width:100%;margin-bottom:1rem;border:1px solid ", src/* Theme.Color.natural50 */.Q2.Color.natural50, ";");
var Table_styles_TableHead = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("thead", (0,src_define_property/* default */.Z)({
    target: "e12j11q61"
}, "target", "e12j11q61"))("background-color:", src/* Theme.Color.primary */.Q2.Color.primary, ";");
var Table_styles_Row = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("tr", _define_property({
    target: "e12j11q62"
}, "target", "e12j11q62"))("height:3rem;")));
var Table_styles_ColumnHead = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("th", (0,src_define_property/* default */.Z)({
    target: "e12j11q63"
}, "target", "e12j11q63"))("padding:0.3125rem 0.625rem;font-weight:bold;text-align:left;color:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";");
var Table_styles_Cell = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("td", _define_property({
    target: "e12j11q64"
}, "target", "e12j11q64"))("padding:0.3125rem 0.625rem;")));


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/DataViz/components/Table.tsx



var makeTableRowWithColumns = function makeTableRowWithColumns(columns) {
    return function(row) {
        return /*#__PURE__*/ _jsx(Row, {
            children: columns.map(function(param) {
                var key = param.key, CellContent = param.component;
                // eslint-disable-next-line react/destructuring-assignment
                var data = row[key];
                if (CellContent) {
                    return /*#__PURE__*/ _jsx(Cell, {
                        children: /*#__PURE__*/ _jsx(CellContent, {
                            data: data
                        })
                    }, String(key));
                }
                return /*#__PURE__*/ _jsx(Cell, {
                    children: "".concat(data)
                }, String(key));
            })
        });
    };
};
var Table = function Table(param) {
    var columns = param.columns, id = param.id, rows = param.rows;
    var SupplierRow = makeTableRowWithColumns(columns);
    return /*#__PURE__*/ _jsxs(TableContainer, {
        id: id,
        children: [
            /*#__PURE__*/ _jsx(TableHead, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: columns.map(function(param) {
                        var columnHeader = param.columnHeader;
                        return /*#__PURE__*/ _jsx(ColumnHead, {
                            children: columnHeader
                        }, columnHeader);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: rows.map(function(row, index) {
                    return /*#__PURE__*/ _jsx(SupplierRow, _object_spread({}, row), "row-".concat(String(index)));
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/DataViz/components/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/DataViz/index.ts


// EXTERNAL MODULE: ../../frontend/entities/src/_legacy/Host/index.ts + 2 modules
var Host = __webpack_require__(2081);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/ContentContainer/ContentContainer.styles.ts


var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", (0,src_define_property/* default */.Z)({
    target: "emby44w0"
}, "target", "emby44w0"))("display:flex;flex-direction:column;gap:6rem;justify-content:space-around;margin:0 auto;");


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/ContentContainer/ContentContainer.tsx


var ContentContainer = function ContentContainer(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/ContentContainer/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Columns/ColumnRatioOption.ts
var ColumnRatioOption;
(function(ColumnRatioOption) {
    ColumnRatioOption[ColumnRatioOption["One"] = 1] = "One";
    ColumnRatioOption[ColumnRatioOption["Two"] = 2] = "Two";
    ColumnRatioOption[ColumnRatioOption["Three"] = 3] = "Three";
})(ColumnRatioOption || (ColumnRatioOption = {}));


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Columns/Columns.styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 100%;\n\n    ",
        " {\n      column-gap: 2rem;\n      flex: 0 0 calc(50% - 1rem);\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 100%;\n\n    ",
        " {\n      column-gap: 2rem;\n      flex: 0 0 calc(50% - 1rem);\n    }\n\n    ",
        " {\n      column-gap: 2rem;\n      flex: 0 0 calc(33% - 1.75rem);\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var forColumns = function forColumns(columnCountForStyles) {
    return function(styles) {
        return function(param) {
            var antecedent = param.antecedent, columnCount = param.columnCount;
            return !antecedent && columnCount === columnCountForStyles && styles;
        };
    };
};
var ColumnContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1u6u1ey0"
}, "target", "e1u6u1ey0"))("max-width:100%;", src/* Theme.mq */.Q2.mq("md"), "{display:flex;flex-flow:row wrap;justify-content:space-between;column-gap:1.25rem;}");
var Column = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1u6u1ey1"
}, "target", "e1u6u1ey1"))("flex:", function(param) {
    var antecedent = param.antecedent;
    return antecedent || 1;
}, ";display:flex;flex-direction:column;gap:1.25rem;&:first-of-type{margin-bottom:1.25rem;", src/* Theme.mq */.Q2.mq("md"), "{margin-bottom:0;}}", forColumns(2)((0,emotion_react_browser_esm/* css */.iv)(_templateObject(), src/* Theme.mq */.Q2.mq("md"))), " ", forColumns(3)((0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), src/* Theme.mq */.Q2.mq("md"), src/* Theme.mq */.Q2.mq("lg"))));


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Columns/ThreeColumns.tsx





// eslint-disable-next-line react/jsx-no-useless-fragment
var ColumnBody = function ColumnBody(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
};
var column = {
    columnCount: 3
};
var ThreeColumns = function ThreeColumns(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(children(ColumnBody, ColumnBody, ColumnBody), 3), columnContent1 = ref[0], columnContent2 = ref[1], columnContent3 = ref[2];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, column), {
                children: columnContent1
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, column), {
                children: columnContent2
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, column), {
                children: columnContent3
            }))
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Columns/TwoColumns.tsx





// eslint-disable-next-line react/jsx-no-useless-fragment
var TwoColumns_ColumnBody = function ColumnBody(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
};
var TwoColumns_column = {
    columnCount: 2
};
var TwoColumns = function TwoColumns(param) {
    var children = param.children, id = param.id, _ratio = (0,_sliced_to_array/* default */.Z)(param.ratio, 2), part1 = _ratio[0], part2 = _ratio[1];
    var consequent = part1 + part2;
    var ref = (0,_sliced_to_array/* default */.Z)(children(TwoColumns_ColumnBody, TwoColumns_ColumnBody), 2), columnContent1 = ref[0], columnContent2 = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnContainer, {
        consequent: consequent,
        id: id,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                antecedent: part1
            }, TwoColumns_column), {
                children: columnContent1
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                antecedent: part2
            }, TwoColumns_column), {
                children: columnContent2
            }))
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Columns/index.ts




;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Grid/Grid.tsx


var Grid = function Grid(param) {
    var children = param.children, columns = param.columns;
    /** @todo: implement something more dynamic if needed */ if (columns.length !== 3) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThreeColumns, {
        children: function children1(Column1, Column2, Column3) {
            return [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column1, {
                    children: children(columns[0])
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column2, {
                    children: children(columns[1])
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column3, {
                    children: children(columns[2])
                }), 
            ];
        }
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Grid/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/Segment.styles.ts


function Segment_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n      ",
        " {\n        padding-top: ",
        ";\n        padding-bottom: ",
        ";\n      }\n    "
    ]);
    Segment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Segment_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 100%;\n        object-fit: cover;\n        object-position: right;\n      "
    ]);
    Segment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SegmentContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", (0,src_define_property/* default */.Z)({
    target: "eohdt8x0"
}, "target", "eohdt8x0"))("display:block;position:relative;color:", src/* Theme.Color.secondary100 */.Q2.Color.secondary100, ";background-color:", function(param) {
    var theme = param.theme, fillColor = param.fillColor;
    return fillColor ? theme.color[fillColor] : "transparent";
}, ";", function(param) {
    var _needLayoutContentPadding = param.needLayoutContentPadding, needLayoutContentPadding = _needLayoutContentPadding === void 0 ? true : _needLayoutContentPadding;
    return needLayoutContentPadding && src/* Styles.Global.layoutContentOnlyPadding */.z0.x.rS;
}, ";", function(param) {
    var hasPadding = param.hasPadding, spacingScale = param.spacingScale;
    return hasPadding && (0,emotion_react_browser_esm/* css */.iv)(Segment_styles_templateObject(), "".concat(spacingScale * 0.75, "rem"), "".concat(spacingScale * 0.75, "rem"), src/* Theme.mq */.Q2.mq("xl"), "".concat(spacingScale * 1.25, "rem"), "".concat(spacingScale * 1.25, "rem"));
}, ";");
var HeaderContainer = SegmentContainer.withComponent("header");
var NavigationContainer = SegmentContainer.withComponent("nav");
var SegmentImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eohdt8x1"
}, "target", "eohdt8x1"))("overflow:hidden;position:absolute;top:0;left:0;z-index:0;width:100%;display:block;img{/* Stage image usally has important details on right side,make them visible in any resolution */\n    ", function(param) {
    var isStage = param.isStage, includeSearch = param.includeSearch;
    return isStage && includeSearch && (0,emotion_react_browser_esm/* css */.iv)(Segment_styles_templateObject1());
}, "}", function(param) {
    var isStage = param.isStage, includeSearch = param.includeSearch;
    return isStage && !includeSearch && "position: relative;\n    aspect-ratio: 1.66/1;\n    ".concat(src/* Theme.mq */.Q2.mq("md"), " {\n      aspect-ratio: 2/1;\n    }\n    ").concat(src/* Theme.mq */.Q2.mq("lg"), " {\n      position: absolute;\n      aspect-ratio: unset;\n    }\n    ");
}, " ", src/* Theme.mq */.Q2.mq("lg"), "{height:100%;}");
var SegmentForegroundContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eohdt8x2"
}, "target", "eohdt8x2"))("left:0;width:100%;", src/* Theme.mq */.Q2.mq("lg"), "{position:relative;margin:0 auto;}");


// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/index.ts + 80 modules
var _legacy = __webpack_require__(6522);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/SegmentImageBackground.tsx
/* eslint-disable react/destructuring-assignment */ 





var isImageSegment = function isImageSegment(props) {
    return Object.prototype.hasOwnProperty.call(props, "image");
};
var SegmentImageBackground = function SegmentImageBackground(props) {
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat(_legacy/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), true);
    if (!isImageSegment(props) || props.isStage && isMobile && props.includeSearch) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentImageContainer, {
        id: props.id,
        isStage: props.isStage,
        includeSearch: props.includeSearch,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* OptimizationLegacy.ResponsiveImage */.CE.t, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.image), {
            priority: true
        }))
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/Segment.tsx
/* eslint-disable react/destructuring-assignment */ 




var isBasicSegment = function isBasicSegment(props) {
    return !Object.prototype.hasOwnProperty.call(props, "image");
};
var selectContainer = function selectContainer(segmentType) {
    switch(segmentType){
        case "header":
            return HeaderContainer;
        case "nav":
            return NavigationContainer;
        case "segment":
        default:
            return SegmentContainer;
    }
};
var DEFAULT_OPTIONS = {
    hasPadding: false,
    segmentType: "segment",
    spacingScale: 1
};
var processOptions = function processOptions(props) {
    if (isBasicSegment(props)) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            hasPadding: Boolean(props.hasPadding),
            segmentType: props.segmentType || DEFAULT_OPTIONS.segmentType,
            spacingScale: props.spacingScale || DEFAULT_OPTIONS.spacingScale
        });
    }
    return DEFAULT_OPTIONS;
};
var Segment_Segment = function Segment(props) {
    var ref = processOptions(props), fillColor = ref.fillColor, hasPadding = ref.hasPadding, segmentType = ref.segmentType, spacingScale = ref.spacingScale;
    var Container = selectContainer(segmentType);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        fillColor: fillColor,
        hasPadding: hasPadding,
        id: props.id,
        spacingScale: spacingScale,
        needLayoutContentPadding: isBasicSegment(props) || !props.isStage || props.includeSearch,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentImageBackground, (0,src_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentForegroundContainer, {
                children: props.children
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/FilledSegment.tsx




var FilledSegment = function FilledSegment(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment_Segment, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        fillColor: "natural10"
    }));
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/FooterSegment.tsx




var FooterSegment = function FooterSegment(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment_Segment, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        fillColor: "primary"
    }));
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/HeaderSegment.tsx




var HeaderSegment = function HeaderSegment(props) {
    return /*#__PURE__*/ _jsx(Segment, _object_spread_props(_object_spread({}, props), {
        fillColor: "natural0"
    }));
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/ImageSegment.tsx



var ImageSegment = function ImageSegment(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment_Segment, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/PlainSegment.tsx



var PlainSegment = function PlainSegment(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment_Segment, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/Segment/index.ts






;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/LayoutLegacy/index.ts





// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Info.js
var Info = __webpack_require__(1647);
var Info_default = /*#__PURE__*/__webpack_require__.n(Info);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/TooltipBadge/TooltipBadge.styles.ts




var Badge = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "em40rlz0"
}, "target", "em40rlz0"))("position:absolute;right:0;top:-1.625rem;height:2.125rem;display:inline-flex;align-items:center;gap:0.5rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural70;
}, ";background-image:", function(param) {
    var theme = param.theme;
    return src/* Theme.getLinearGradient */.Q2.getLinearGradient(theme.gradient.orange, "to left");
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:700;padding:0 1rem;border-radius:100px;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{top:0;right:-1.5625rem;}svg{width:1.6rem;height:1.6rem;fill:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";vertical-align:middle;cursor:pointer;}");
var InfoIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Info_default()), (0,src_define_property/* default */.Z)({
    target: "em40rlz1"
}, "target", "em40rlz1"))("width:1.6rem;height:1.6rem;fill:currentcolor;vertical-align:middle;cursor:pointer;");


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/TooltipBadge/TooltipBadge.tsx



var TooltipBadge = function TooltipBadge(param) {
    var badgeText = param.badgeText, tooltipTitle = param.tooltipTitle, tooltipText = param.tooltipText, onHover = param.onHover;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Badge, {
        children: [
            badgeText,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Tooltip */.ws.Tooltip, {
                content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Markup */.ws.Markup, {
                    content: tooltipText
                }),
                title: tooltipTitle,
                width: "wide",
                trigger: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoIcon, {
                    onMouseEnter: onHover
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/TooltipBadge/index.ts


// EXTERNAL MODULE: ../../frontend/entities/src/index.ts + 176 modules
var entities_src = __webpack_require__(3631);
;// CONCATENATED MODULE: ../../frontend/entities/src/_legacy/index.ts











/***/ }),

/***/ 3631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xh": function() { return /* reexport */ AccordionContentBlock; },
  "KM": function() { return /* reexport */ AutoRentalData; },
  "IO": function() { return /* reexport */ CollapsableContentBlock; },
  "v4": function() { return /* reexport */ FaqData; },
  "VZ": function() { return /* reexport */ HeaderIconStyles; },
  "m4": function() { return /* reexport */ ImageContentBlock; },
  "eX": function() { return /* reexport */ InfolinePopover; },
  "ek": function() { return /* reexport */ LinkListBlock; },
  "sm": function() { return /* reexport */ MembershipPopover; },
  "E5": function() { return /* reexport */ OpeningTimes; },
  "bc": function() { return /* reexport */ PlainContentModuleContainer; },
  "eW": function() { return /* reexport */ ProductData; },
  "li": function() { return /* reexport */ ResponsiveLogo; },
  "r_": function() { return /* reexport */ Runtime_namespaceObject; },
  "rq": function() { return /* reexport */ SiteInfoProvider; },
  "rI": function() { return /* reexport */ StandardContentRowBlock; },
  "X2": function() { return /* reexport */ TabBodyContentBlock; },
  "vG": function() { return /* reexport */ TabListContentBlock; },
  "vH": function() { return /* reexport */ TextContentBlock; },
  "BD": function() { return /* reexport */ TextContentBlockWithFigures; },
  "ro": function() { return /* reexport */ TextContentBlockWithIcons; },
  "w4": function() { return /* reexport */ WaveContentModuleContainer; },
  "JT": function() { return /* reexport */ account_namespaceObject; },
  "co": function() { return /* reexport */ analytics_namespaceObject; },
  "k$": function() { return /* reexport */ getLocation; },
  "p9": function() { return /* reexport */ selectBackgroundStyle; },
  "G2": function() { return /* reexport */ selectBadgeStyle; },
  "VR": function() { return /* reexport */ selectLayoutFlow; },
  "Fp": function() { return /* reexport */ useKeyNavigation; },
  "fb": function() { return /* reexport */ useSearchSuggestions; },
  "Mj": function() { return /* reexport */ useSiteInfo; }
});

// UNUSED EXPORTS: BrandLogo, DateRangePicker, SiteInfoContext, currency, getDisplayName, subscription

// NAMESPACE OBJECT: ../../frontend/entities/src/Runtime/index.ts
var Runtime_namespaceObject = {};
__webpack_require__.r(Runtime_namespaceObject);
__webpack_require__.d(Runtime_namespaceObject, {
  "useAccountConfig": function() { return useAccountConfig; },
  "useBrand": function() { return useBrand; },
  "useConfig": function() { return useConfig; },
  "useConsumerApi": function() { return useConsumerApi; },
  "useHost": function() { return useHost; },
  "useLocale": function() { return useLocale_useLocale; },
  "usePath": function() { return usePath; },
  "useWhitelabel": function() { return useWhitelabel; }
});

// NAMESPACE OBJECT: ../../frontend/entities/src/account/index.ts
var account_namespaceObject = {};
__webpack_require__.r(account_namespaceObject);
__webpack_require__.d(account_namespaceObject, {
  "LoginError": function() { return LoginError; },
  "getAccountSession": function() { return getAccountSession; },
  "login": function() { return login; },
  "resendConfirmUser": function() { return resendConfirmUser; },
  "useSessionData": function() { return useSessionData; }
});

// NAMESPACE OBJECT: ../../frontend/entities/src/analytics/gtm/index.ts
var gtm_namespaceObject = {};
__webpack_require__.r(gtm_namespaceObject);
__webpack_require__.d(gtm_namespaceObject, {
  "NoScript": function() { return GTMNoScript; },
  "Script": function() { return GTMScript; },
  "baseConfig": function() { return baseConfig; },
  "blockUserCentricsScript": function() { return blockUserCentricsScript; },
  "crossDomainBridgeScript": function() { return crossDomainBridgeScript; },
  "getTrackingDataForPath": function() { return getTrackingDataForPath; },
  "trackAndroidAppLinkClicked": function() { return trackAndroidAppLinkClicked; },
  "trackAndroidAppLinkFooterClicked": function() { return trackAndroidAppLinkFooterClicked; },
  "trackCancellationHover": function() { return trackCancellationHover; },
  "trackConfienzaClicked": function() { return trackConfienzaClicked; },
  "trackCriteo": function() { return trackCriteo; },
  "trackCustomerReviewClicked": function() { return trackCustomerReviewClicked; },
  "trackDriverAgeHover": function() { return trackDriverAgeHover; },
  "trackDriverAgeSelect": function() { return trackDriverAgeSelect; },
  "trackEvent": function() { return trackEvent; },
  "trackFacebookFooterClicked": function() { return trackFacebookFooterClicked; },
  "trackFaqItemClicked": function() { return trackFaqItemClicked; },
  "trackFooterClicked": function() { return trackFooterClicked; },
  "trackFooterTooltipOpened": function() { return trackFooterTooltipOpened; },
  "trackHelpcenterButtonClicked": function() { return trackHelpcenterButtonClicked; },
  "trackInfoBannerCloseClicked": function() { return trackInfoBannerCloseClicked; },
  "trackInfoBannerLinkClicked": function() { return trackInfoBannerLinkClicked; },
  "trackInstagramFooterClicked": function() { return trackInstagramFooterClicked; },
  "trackIosAppLinkClicked": function() { return trackIosAppLinkClicked; },
  "trackIosAppLinkFooterClicked": function() { return trackIosAppLinkFooterClicked; },
  "trackLogin": function() { return trackLogin; },
  "trackLogout": function() { return trackLogout; },
  "trackMyBookings": function() { return trackMyBookings; },
  "trackMyData": function() { return trackMyData; },
  "trackMyPayment": function() { return trackMyPayment; },
  "trackNavigationClicked": function() { return trackNavigationClicked; },
  "trackNewUser": function() { return trackNewUser; },
  "trackNewsletterRegistration": function() { return trackNewsletterRegistration; },
  "trackNewsletterRegistrationIndex": function() { return trackNewsletterRegistrationIndex; },
  "trackOpeningTimesTooltipOpened": function() { return trackOpeningTimesTooltipOpened; },
  "trackOptionsChange": function() { return trackOptionsChange; },
  "trackPageView": function() { return trackPageView; },
  "trackPasswordForgotten": function() { return trackPasswordForgotten; },
  "trackPinterestFooterClicked": function() { return trackPinterestFooterClicked; },
  "trackRoundtripOneway": function() { return trackRoundtripOneway; },
  "trackSavingHover": function() { return trackSavingHover; },
  "trackSearchButtonOfferBoxClicked": function() { return trackSearchButtonOfferBoxClicked; },
  "trackSearchHistoryDelete": function() { return trackSearchHistoryDelete; },
  "trackSearchHistorySelect": function() { return trackSearchHistorySelect; },
  "trackShowLogin": function() { return trackShowLogin; },
  "trackStationMapStationClick": function() { return trackStationMapStationClick; },
  "trackToggleMoreOptions": function() { return trackToggleMoreOptions; },
  "trackVoucherButtonClick": function() { return trackVoucherButtonClick; },
  "trackWebVitalsMetric": function() { return trackWebVitalsMetric; },
  "useElementScrolledToView": function() { return useElementScrolledToView; },
  "usePageView": function() { return usePageView; },
  "useReportWebVitals": function() { return useReportWebVitals; }
});

// NAMESPACE OBJECT: ../../frontend/entities/src/analytics/index.ts
var analytics_namespaceObject = {};
__webpack_require__.r(analytics_namespaceObject);
__webpack_require__.d(analytics_namespaceObject, {
  "CookieConsent": function() { return CookieConsent; },
  "gtm": function() { return gtm_namespaceObject; },
  "useConsent": function() { return useConsent; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var src = __webpack_require__(2775);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Badge.styles.ts



var StyledBadge = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.Badge */.Ui.Ct, (0,src_define_property/* default */.Z)({
    target: "e10446j30"
}, "target", "e10446j30"))("margin-bottom:1.5rem;", function(param) {
    var isLargeAtMD = param.isLargeAtMD, theme = param.theme;
    return isLargeAtMD && "".concat(theme.mq("sm"), " {\n    margin-bottom: 3rem;\n  }");
});


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Badge.tsx


var Badge = function Badge(param) {
    var content = param.content, _rules = param.rules, badgeRules = _rules.badge, verticalSpacing = _rules.verticalSpacing;
    var ref = badgeRules || {}, _shouldHide = ref.shouldHide, shouldHide = _shouldHide === void 0 ? false : _shouldHide, _style = ref.style, style = _style === void 0 ? "default" : _style;
    if (shouldHide) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBadge, {
        text: content === null || content === void 0 ? void 0 : content.text,
        type: style,
        isLargeAtMD: verticalSpacing === null || verticalSpacing === void 0 ? void 0 : verticalSpacing.isLargeAtMD
    });
};

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Button.styles.ts




var getExpandedStyles = function getExpandedStyles(theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-block:2rem;min-width:100%;", theme.mq("sm"), "{min-width:100px;}");
};
var getCenteredStyles = function getCenteredStyles(theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;/* must be a block-level element for centering */\n  margin-inline:auto;justify-content:center;", theme.mq("sm"), "{left:50%;}");
};
var ExpandButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "e1xj0bsl0"
}, "target", "e1xj0bsl0"))("margin-top:", function(param) {
    var spacingDirection = param.spacingDirection;
    return spacingDirection === "bottom" ? "1.5rem" : "";
}, ";", function(param) {
    var theme = param.theme, isExpanded = param.isExpanded;
    return isExpanded && getExpandedStyles(theme);
}, ";", function(param) {
    var theme = param.theme, isCentered = param.isCentered;
    return isCentered && getCenteredStyles(theme);
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Button.tsx


var Button_Button = function Button(param) {
    var label = param.content.label, onClick = param.onClick, rules = param.rules;
    var ref = rules || {}, _expanded = ref.expanded, expanded = _expanded === void 0 ? false : _expanded, tmp = ref.horizontalSpacing, ref1 = tmp === void 0 ? {} : tmp, _isCentered = ref1.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _size = ref.size, size = _size === void 0 ? "large" : _size, _variant = ref.variant, variant = _variant === void 0 ? "primary" : _variant, tmp1 = ref.verticalSpacing, ref2 = tmp1 === void 0 ? {} : tmp1, _spacingDirection = ref2.spacingDirection, spacingDirection = _spacingDirection === void 0 ? "bottom" : _spacingDirection;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExpandButton, {
        size: size,
        variant: variant,
        isCentered: isCentered,
        isExpanded: expanded,
        spacingDirection: spacingDirection,
        onClick: onClick,
        children: label
    });
};

// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/index.js
var dist = __webpack_require__(7294);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/pictograms/car-types/index.js
var car_types = __webpack_require__(8785);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(6383);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Icon.styles.ts




var getSizes = function getSizes(size, theme, mq) {
    if (Array.isArray(size)) {
        var responsiveSizeForMedia = size.find(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), _breakpoint = _param[1];
            return _breakpoint === mq;
        });
        if (responsiveSizeForMedia) {
            var _responsiveSizeForMedia = (0,src_sliced_to_array/* default */.Z)(responsiveSizeForMedia, 1), responsiveSize = _responsiveSizeForMedia[0];
            return responsiveSize === "full" ? "100%" : theme.spacing[responsiveSize];
        }
        return null;
    }
    return size === "full" ? "100%" : theme.spacing[size];
};
var IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1lyeg8y0"
}, "target", "e1lyeg8y0"))("& > svg{border-radius:0;padding:", function(param) {
    var indent = param.indent, theme = param.theme;
    return "0 ".concat(theme.spacing[indent]);
}, ";fill:", function(param) {
    var color = param.color, theme = param.theme;
    return color === "current" ? "current" : theme.color[color];
}, ";width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme);
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme);
}, ";", src/* Theme.mq */.Q2.mq("sm"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "sm");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "sm");
}, ";}", src/* Theme.mq */.Q2.mq("md"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "md");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "md");
}, ";}", src/* Theme.mq */.Q2.mq("lg"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "lg");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "lg");
}, ";}", src/* Theme.mq */.Q2.mq("xl"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "xl");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "xl");
}, ";}}");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Icon.tsx




var isCarPictogram = function isCarPictogram(iconKey) {
    return Object.keys(car_types).includes(iconKey);
};
var Icon = function Icon(param) {
    var content = param.content, rules = param.rules;
    if (!content) {
        return null;
    }
    var ref = rules || {}, _color = ref.color, color = _color === void 0 ? "current" : _color, _indent = ref.indent, indent = _indent === void 0 ? 0 : _indent, _size = ref.size, size = _size === void 0 ? 50 : _size;
    var icon = content.key;
    var IconComponent = isCarPictogram(icon) ? car_types[icon] : dist[icon];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
        color: color,
        size: size,
        indent: indent,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconComponent, {})
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/particle/BadgeStyle.ts
var BadgeStyle = {
    default: "orange",
    gray: "orange",
    green: "light",
    mint: "light",
    orange: "light"
};
var selectBadgeStyle = function selectBadgeStyle() {
    var style = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
    return BadgeStyle[style];
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/particle/Columns.ts



// Tailwind doesn't support dynamic class names so we have to use maps with explicit values
var spansWithoutOverride = {
    "1": "col-span-1",
    "2": "col-span-2",
    "3": "col-span-3",
    "4": "col-span-4",
    "5": "col-span-5",
    "6": "col-span-6",
    "7": "col-span-7",
    "8": "col-span-8",
    "9": "col-span-9",
    "10": "col-span-10",
    "11": "col-span-11",
    "12": "col-span-12"
};
var spansWithOverride = {
    "1": "!col-span-1",
    "2": "!col-span-2",
    "3": "!col-span-3",
    "4": "!col-span-4",
    "5": "!col-span-5",
    "6": "!col-span-6",
    "7": "!col-span-7",
    "8": "!col-span-8",
    "9": "!col-span-9",
    "10": "!col-span-10",
    "11": "!col-span-11",
    "12": "!col-span-12"
};
var spansWithoutOverrideSm = {
    "1": "sm:col-span-1",
    "2": "sm:col-span-2",
    "3": "sm:col-span-3",
    "4": "sm:col-span-4",
    "5": "sm:col-span-5",
    "6": "sm:col-span-6",
    "7": "sm:col-span-7",
    "8": "sm:col-span-8",
    "9": "sm:col-span-9",
    "10": "sm:col-span-10",
    "11": "sm:col-span-11",
    "12": "sm:col-span-12"
};
var spansWithOverrideSm = {
    "1": "sm:!col-span-1",
    "2": "sm:!col-span-2",
    "3": "sm:!col-span-3",
    "4": "sm:!col-span-4",
    "5": "sm:!col-span-5",
    "6": "sm:!col-span-6",
    "7": "sm:!col-span-7",
    "8": "sm:!col-span-8",
    "9": "sm:!col-span-9",
    "10": "sm:!col-span-10",
    "11": "sm:!col-span-11",
    "12": "sm:!col-span-12"
};
var spansWithoutOverrideMd = {
    "1": "md:col-span-1",
    "2": "md:col-span-2",
    "3": "md:col-span-3",
    "4": "md:col-span-4",
    "5": "md:col-span-5",
    "6": "md:col-span-6",
    "7": "md:col-span-7",
    "8": "md:col-span-8",
    "9": "md:col-span-9",
    "10": "md:col-span-10",
    "11": "md:col-span-11",
    "12": "md:col-span-12"
};
var spansWithOverrideMd = {
    "1": "md:!col-span-1",
    "2": "md:!col-span-2",
    "3": "md:!col-span-3",
    "4": "md:!col-span-4",
    "5": "md:!col-span-5",
    "6": "md:!col-span-6",
    "7": "md:!col-span-7",
    "8": "md:!col-span-8",
    "9": "md:!col-span-9",
    "10": "md:!col-span-10",
    "11": "md:!col-span-11",
    "12": "md:!col-span-12"
};
var spansWithoutOverrideLg = {
    "1": "lg:col-span-1",
    "2": "lg:col-span-2",
    "3": "lg:col-span-3",
    "4": "lg:col-span-4",
    "5": "lg:col-span-5",
    "6": "lg:col-span-6",
    "7": "lg:col-span-7",
    "8": "lg:col-span-8",
    "9": "lg:col-span-9",
    "10": "lg:col-span-10",
    "11": "lg:col-span-11",
    "12": "lg:col-span-12"
};
var spansWithOverrideLg = {
    "1": "lg:!col-span-1",
    "2": "lg:!col-span-2",
    "3": "lg:!col-span-3",
    "4": "lg:!col-span-4",
    "5": "lg:!col-span-5",
    "6": "lg:!col-span-6",
    "7": "lg:!col-span-7",
    "8": "lg:!col-span-8",
    "9": "lg:!col-span-9",
    "10": "lg:!col-span-10",
    "11": "lg:!col-span-11",
    "12": "lg:!col-span-12"
};
var spansWithoutOverrideXl = {
    "1": "xl:col-span-1",
    "2": "xl:col-span-2",
    "3": "xl:col-span-3",
    "4": "xl:col-span-4",
    "5": "xl:col-span-5",
    "6": "xl:col-span-6",
    "7": "xl:col-span-7",
    "8": "xl:col-span-8",
    "9": "xl:col-span-9",
    "10": "xl:col-span-10",
    "11": "xl:col-span-11",
    "12": "xl:col-span-12"
};
var spansWithOverrideXl = {
    "1": "xl:!col-span-1",
    "2": "xl:!col-span-2",
    "3": "xl:!col-span-3",
    "4": "xl:!col-span-4",
    "5": "xl:!col-span-5",
    "6": "xl:!col-span-6",
    "7": "xl:!col-span-7",
    "8": "xl:!col-span-8",
    "9": "xl:!col-span-9",
    "10": "xl:!col-span-10",
    "11": "xl:!col-span-11",
    "12": "xl:!col-span-12"
};
/** @deprecated This generates Tailwind classes, use `formatColumnsAsStyles` instead. */ var formatColumnsAsClassNames = function formatColumnsAsClassNames(param) {
    var _param = _sliced_to_array(param, 3), span = _param[0], breakpoint = _param[1], tmp = _param[2], ref = tmp === void 0 ? {} : tmp, _override = ref.override, override = _override === void 0 ? false : _override, _condition = ref.condition, condition = _condition === void 0 ? true : _condition;
    if (!condition) {
        return "";
    }
    switch(breakpoint){
        case "sm":
            return override ? spansWithOverrideSm[span] : spansWithoutOverrideSm[span];
        case "md":
            return override ? spansWithOverrideMd[span] : spansWithoutOverrideMd[span];
        case "lg":
            return override ? spansWithOverrideLg[span] : spansWithoutOverrideLg[span];
        case "xl":
            return override ? spansWithOverrideXl[span] : spansWithoutOverrideXl[span];
        default:
            return override ? spansWithOverride[span] : spansWithoutOverride[span];
    }
};
var formatColumnsAsStyles = function formatColumnsAsStyles(param) {
    var _param = (0,src_sliced_to_array/* default */.Z)(param, 3), span = _param[0], breakpoint = _param[1], tmp = _param[2], ref = tmp === void 0 ? {} : tmp, _override = ref.override, override = _override === void 0 ? false : _override, _condition = ref.condition, condition = _condition === void 0 ? true : _condition;
    if (!condition) {
        return "";
    }
    var columnStyle = "grid-column: span ".concat(span).concat(override ? " !important" : "", ";");
    if (breakpoint) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(src/* Theme.mq */.Q2.mq(breakpoint), "{", columnStyle, "}");
    }
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(columnStyle);
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/particle/index.ts




;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Heading.styles.ts




var getSpacingDirection = function getSpacingDirection(spacingDirection) {
    return ({
        bottom: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:1rem;"),
        both: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:1rem;margin-top:1rem;"),
        top: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:1rem;"),
        neither: ""
    })[spacingDirection];
};
var HeadingWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eic6xwr0"
}, "target", "eic6xwr0"))(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";", function(param) {
    var rules = param.rules;
    var ref;
    return ((ref = rules.verticalSpacing) === null || ref === void 0 ? void 0 : ref.spacingDirection) ? getSpacingDirection(rules.verticalSpacing.spacingDirection) : getSpacingDirection("bottom");
}, ";", function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon && "\n    & > h1, h2, h3 {\n      display: flex;\n      align-items: center;\n      column-gap: 1rem;\n    }\n    ";
});


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Heading.tsx




var headingMap = {
    h1: src/* Heading1 */.nL,
    h2: src/* Heading2 */.XJ,
    h3: src/* Heading3 */.aC,
    h4: src/* Heading4 */.k8,
    h5: src/* Heading5 */.by,
    h6: src/* Heading6 */.Cd
};
var Heading = function Heading(param) {
    var content = param.content, rules = param.rules;
    if (!content) {
        return null;
    }
    var ref = rules || {}, _columns = ref.columns, columns = _columns === void 0 ? [] : _columns, _isSubTitle = ref.isSubTitle, isSubTitle = _isSubTitle === void 0 ? false : _isSubTitle, verticalSpacing = ref.verticalSpacing, textStyle = ref.textStyle;
    var ref1 = textStyle || {}, _style = ref1.style, style = _style === void 0 ? src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary : _style;
    var isPrimaryColor = style === src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary;
    var icon = content.icon, _level = content.level, level = _level === void 0 ? "h2" : _level, text = content.text, lead = content.lead;
    var element = isSubTitle ? "div" : level;
    var HeadingComponent = isSubTitle ? src/* Subtitle */.QE : headingMap[level];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeadingWrapper, {
        rules: {
            columns: columns,
            verticalSpacing: verticalSpacing
        },
        hasIcon: !!icon,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeadingComponent, {
                as: element,
                textColor: isPrimaryColor ? "default" : "white",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                        content: icon,
                        rules: {
                            color: isPrimaryColor ? "primary" : "natural0",
                            size: [
                                [
                                    50
                                ],
                                [
                                    60,
                                    "sm"
                                ]
                            ]
                        }
                    }),
                    text
                ]
            }),
            lead && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SecondaryText */.MQ, {
                children: lead
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Image.styles.ts


var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eter9uj0"
}, "target", "eter9uj0"))("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";", function(param) {
    var hasMinSize = param.hasMinSize;
    return hasMinSize ? "min-height: 350px;" : "";
}, "}position:relative;height:100%;min-height:250px;overflow:hidden;border-radius:0.75rem;");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/Image.tsx




var Image = function Image(param) {
    var content = param.content, hasMinSize = param.rules.hasMinSize;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        hasMinSize: hasMinSize,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,src_object_spread/* default */.Z)({
            layout: "fill",
            objectFit: "cover"
        }, content))
    });
};

// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/LinkButton.styles.ts





var getPrimaryStyles = function getPrimaryStyles(defaultColor, highlightColor, theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", theme.color.natural0, ";background-color:", defaultColor, ";transition:background 1s;&:hover,&:focus-visible{background-color:", highlightColor, ";background-image:radial-gradient(\n      circle,transparent 1%,", highlightColor, " 1%\n    );background-position:center;background-size:15000%;}&:active{background-color:", (0,polished_esm/* tint */.nV)(0.15, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getSecondaryStyles = function getSecondaryStyles(defaultColor, highlightColor, isSmallButton, theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:", isSmallButton ? "0.5rem 0.75rem" : "0.875rem 1.875rem", ";border:2px solid currentcolor;color:", defaultColor, ";background-color:", theme.color.natural0, ";transition-property:color,background,border-color;transition-duration:1s;&:hover,&:focus-visible{color:", highlightColor, ";background-color:", theme.color.natural0, ";background-image:radial-gradient(\n      circle,transparent 1%,", theme.color.natural0, " 1%\n    );background-position:center;background-size:15000%;}&:active{color:", highlightColor, ";background-color:", (0,polished_esm/* tint */.nV)(0.8, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getBasicStyles = function getBasicStyles(isCentered, isSmallButton, theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;margin:", theme.spacing[50], " ", isCentered ? "auto" : "0", " 0;padding:", isSmallButton ? "0.625rem 1rem" : "1rem 2rem", ";border:0;outline:0;border-radius:0.5rem;box-sizing:border-box;max-width:fit-content;white-space:nowrap;text-decoration:none;fill:currentcolor;background-position:center;");
};
var getVariantSpecificStyles = function getVariantSpecificStyles(isSecondaryButton, isSmallButton, theme) {
    var defaultColor = theme.color.primary;
    var highlightColor = (0,polished_esm/* lighten */.$n)(0.3, (0,polished_esm/* desaturate */.vG)(0.6, defaultColor));
    if (isSecondaryButton) {
        return getSecondaryStyles(defaultColor, highlightColor, isSmallButton, theme);
    }
    return getPrimaryStyles(defaultColor, highlightColor, theme);
};
var StyledAnchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "e1po54mf0"
}, "target", "e1po54mf0"))(function(param) {
    var theme = param.theme, isCentered = param.isCentered, isSmallButton = param.isSmallButton;
    return getBasicStyles(isCentered, isSmallButton, theme);
}, " ", function(param) {
    var theme = param.theme, isSecondaryButton = param.isSecondaryButton, isSmallButton = param.isSmallButton;
    return getVariantSpecificStyles(isSecondaryButton, isSmallButton, theme);
}, ";");
var StyledMaskedLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.MaskedLink */.Ui.Fz, (0,src_define_property/* default */.Z)({
    target: "e1po54mf1"
}, "target", "e1po54mf1"))(function(param) {
    var theme = param.theme, isCentered = param.isCentered, isSmallButton = param.isSmallButton;
    return getBasicStyles(isCentered, isSmallButton, theme);
}, " ", function(param) {
    var theme = param.theme, isSecondaryButton = param.isSecondaryButton, isSmallButton = param.isSmallButton;
    return getVariantSpecificStyles(isSecondaryButton, isSmallButton, theme);
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/LinkButton.tsx



var LinkButton = function LinkButton(param) {
    var className = param.className, content = param.content, variant = param.variant, rules = param.rules;
    if (!content) {
        return null;
    }
    var href = content.href, label = content.label, target = content.target, rel = content.rel;
    var ref = rules || {}, tmp = ref.horizontalSpacing, ref1 = tmp === void 0 ? {} : tmp, _isCentered = ref1.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _size = ref.size, size = _size === void 0 ? "large" : _size;
    var isSmallButton = size === "small";
    var isSecondaryButton = variant === "secondary";
    return content.masked ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMaskedLink, {
        body: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InteractiveText */.G9, {
            inline: true,
            textColor: "current",
            size: isSmallButton ? "small" : "normal",
            children: label
        }),
        className: className,
        href: href,
        target: target,
        rel: rel,
        isCentered: isCentered,
        isSmallButton: isSmallButton,
        isSecondaryButton: isSecondaryButton
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAnchor, {
        className: className,
        href: href,
        target: target,
        rel: rel,
        isCentered: isCentered,
        isSmallButton: isSmallButton,
        isSecondaryButton: isSecondaryButton,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InteractiveText */.G9, {
            inline: true,
            textColor: "current",
            size: isSmallButton ? "small" : "normal",
            children: label
        })
    });
};
var defaultProps = {
    variant: "primary"
};
LinkButton.defaultProps = defaultProps;


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/ModuleContainer.styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-column-start: 1;\n      grid-row-start: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-column-start: 2;\n      grid-row-start: 1;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        padding-top: 4rem;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        " {\n      ",
        "\n      ",
        "\n      ",
        "\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ModuleContainerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1c3alc40"
}, "target", "e1c3alc40"))(function(param) {
    var isFirstColumn = param.isFirstColumn;
    return isFirstColumn && (0,emotion_react_browser_esm/* css */.iv)(_templateObject());
}, " ", function(param) {
    var isSecondColumn = param.isSecondColumn;
    return isSecondColumn && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1());
}, " ", function(param) {
    var isLargeAtLG = param.isLargeAtLG, theme = param.theme;
    return isLargeAtLG && (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), theme.mq("lg"));
}, " ", function(param) {
    var theme = param.theme, isNoneAtXL = param.isNoneAtXL, isSmallAtXL = param.isSmallAtXL, isLargeAtXL = param.isLargeAtXL;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), theme.mq("xl"), isNoneAtXL && "padding-top: 0rem;", isSmallAtXL && "padding-top: 0.5rem;", isLargeAtXL && "padding-top: 4rem;");
});


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/ModuleContainer.tsx


var ModuleContainer = function ModuleContainer(param) {
    var children = param.children, rules = param.rules;
    var ref = rules || {}, isFirstColumn = ref.isFirstColumn, isSecondColumn = ref.isSecondColumn, verticalSpacing = ref.verticalSpacing;
    var ref1 = verticalSpacing || {}, isLargeAtLG = ref1.isLargeAtLG, isLargeAtXL = ref1.isLargeAtXL, isNoneAtXL = ref1.isNoneAtXL, isSmallAtXL = ref1.isSmallAtXL;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModuleContainerWrapper, {
        isFirstColumn: isFirstColumn,
        isSecondColumn: isSecondColumn,
        isLargeAtLG: isLargeAtLG,
        isLargeAtXL: isLargeAtXL,
        isNoneAtXL: isNoneAtXL,
        isSmallAtXL: isSmallAtXL,
        children: children
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/RichText.styles.tsx



var RichTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1nyhtc30"
}, "target", "e1nyhtc30"))(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/RichText.tsx



var RichText = function RichText(props) {
    var content = props.content, _rules = props.rules, rules = _rules === void 0 ? {} : _rules;
    var textStyle = rules.textStyle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichTextWrapper, {
        rules: rules,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.RichText */.Ui.Ho, {
            content: content,
            rules: {
                textStyle: textStyle
            }
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/element/index.ts









// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowDown.js
var dist_ArrowDown = __webpack_require__(1143);
var ArrowDown_default = /*#__PURE__*/__webpack_require__.n(dist_ArrowDown);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionItem/AccordionItem.styles.ts





/* @TODO: Add correct FLOYT colors to theme. */ var ArrowDownIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowDown_default()), (0,src_define_property/* default */.Z)({
    target: "e26dlfq0"
}, "target", "e26dlfq0"))("width:1.5rem;height:1.5rem;", src/* Theme.mq */.Q2.mq("sm"), "{width:2rem;height:2rem;}");
var AccordionItemTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Subtitle */.QE, (0,src_define_property/* default */.Z)({
    target: "e26dlfq1"
}, "target", "e26dlfq1"))("grid-column:span 10;transition:transform 0.15s cubic-bezier(0.4,0,0.2,1);");
var AccordionItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("details", (0,src_define_property/* default */.Z)({
    target: "e26dlfq2"
}, "target", "e26dlfq2"))("border-top:", function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "" : "1px solid #b6bfc1";
}, ";&[open] ", ArrowDownIcon, "{transform:scaleY(-1);}");
var AccordionItemPromptWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("summary", (0,src_define_property/* default */.Z)({
    target: "e26dlfq3"
}, "target", "e26dlfq3"))("display:grid;grid-template-columns:repeat(12,minmax(0,1fr));align-items:center;padding-top:1rem;padding-bottom:1rem;cursor:pointer;&:hover{background-color:#f5f5f5;", AccordionItemTitle, "{transform:translateX(0.5rem);}}&::-webkit-details-marker{display:none;}", src/* Theme.mq */.Q2.mq("lg"), "{padding-top:1.5rem;padding-bottom:1.5rem;}");
var AccordionItemContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e26dlfq4"
}, "target", "e26dlfq4"))("display:grid;grid-template-columns:repeat(12,minmax(0,1fr));gap:1.5rem;margin-bottom:1rem;", src/* Theme.mq */.Q2.mq("lg"), "{margin-top:1rem;margin-bottom:1.5rem;}");
var AccordionItemArrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e26dlfq5"
}, "target", "e26dlfq5"))("grid-column:span 2;display:flex;justify-content:end;fill:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";");
var AccordionFigure = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("figure", (0,src_define_property/* default */.Z)({
    target: "e26dlfq6"
}, "target", "e26dlfq6"))(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";filter:drop-shadow(0 10px 25px rgb(0 0 0 / 8%));img{border-radius:0.75rem;}");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionItem/AccordionItemPrompt.tsx


var AccordionItemPrompt = function AccordionItemPrompt(param) {
    var prompt = param.prompt;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionItemPromptWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItemTitle, {
                as: "span",
                children: prompt
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItemArrow, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownIcon, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionItem/Figure.tsx




var Figure = function Figure(param) {
    var image = param.content.image, rules = param.rules;
    if (!image) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionFigure, {
        rules: rules,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,src_object_spread/* default */.Z)({
            layout: "responsive"
        }, image))
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionItem/AccordionItemContent.tsx




var AccordionItemContent = function AccordionItemContent(param) {
    var content = param.content, image = param.image;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionItemContentWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText, {
                content: content,
                rules: {
                    columns: [
                        [
                            10
                        ],
                        [
                            11,
                            "sm"
                        ],
                        [
                            8,
                            "lg"
                        ],
                        [
                            7,
                            "lg",
                            {
                                override: true
                            }
                        ]
                    ]
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Figure, {
                content: {
                    image: image
                },
                rules: {
                    columns: [
                        [
                            10
                        ],
                        [
                            11,
                            "sm"
                        ],
                        [
                            5,
                            "lg"
                        ]
                    ]
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionItem/AccordionItem.tsx




var AccordionItem = function AccordionItem(param) {
    var _item = param.item, content = _item.content, image = _item.image, prompt = _item.prompt, index = param.index;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionItemWrapper, {
        isFirst: index === 0,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItemPrompt, {
                prompt: prompt
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItemContent, {
                content: content,
                image: image
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionItem/index.ts




;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/Accordion.styles.ts



var AccordionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "exfiqsh0"
}, "target", "exfiqsh0"))("margin-top:2rem;", src/* Theme.mq */.Q2.mq("lg"), "{margin-top:2.5rem;}");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/Accordion.tsx



var Accordion = function Accordion(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionWrapper, {
        children: content.map(function(item, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
                item: item,
                index: index
            }, item.prompt);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/AccordionContentBlock.tsx



var AccordionContentBlock = function AccordionContentBlock(param) {
    var content = param.content, rules = param.rules, translations = param.translations;
    var accordion = content.accordion, badge = content.badge, heading = content.heading;
    var ref = rules || {}, badgeRules = ref.badge, textStyle = ref.textStyle, verticalSpacing = ref.verticalSpacing;
    var style = (textStyle || {}).style;
    var ref1 = translations || {}, buttonLabel = ref1.buttonLabel, supportUrl = ref1.supportUrl;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModuleContainer, {
        rules: {
            verticalSpacing: verticalSpacing
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                content: badge,
                rules: {
                    badge: badgeRules
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: heading,
                rules: {
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion, {
                content: accordion
            }),
            supportUrl && buttonLabel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkButton, {
                content: {
                    href: supportUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    label: buttonLabel
                },
                rules: {
                    horizontalSpacing: {
                        isCentered: true
                    }
                },
                variant: "secondary"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/AccordionContentBlock/index.ts


// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapsableContainer/CollapsableContainer.styles.ts


function CollapsableContainer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          overflow: hidden;\n          height: 93.75rem;\n          position: relative;\n        "
    ]);
    CollapsableContainer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CollapsableContainer_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "einwm4c0"
}, "target", "einwm4c0"))(function(param) {
    var isCollapsed = param.isCollapsed;
    return isCollapsed ? (0,emotion_react_browser_esm/* css */.iv)(CollapsableContainer_styles_templateObject()) : "";
});
var CollapsedOverlay = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "einwm4c1"
}, "target", "einwm4c1"))("width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.spacing[110];
}, ";display:", function(param) {
    var isCollapsed = param.isCollapsed;
    return isCollapsed ? "inline-block" : "none";
}, ";bottom:0;position:absolute;background-image:", function(param) {
    var theme = param.theme;
    return "linear-gradient(0deg,".concat(theme.color.natural0, ", #0000)");
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapsableContainer/CollapsableContainer.tsx


var CollapsableContainer = function CollapsableContainer(param) {
    var ref = param.behavior.ref, children = param.children, _rules = param.rules, canBeCollapsed = _rules.canBeCollapsed, isCollapsed = _rules.isCollapsed;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollapsableContainer_styles_Container, {
        isCollapsed: isCollapsed,
        ref: ref,
        children: [
            children,
            canBeCollapsed && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapsedOverlay, {
                isCollapsed: isCollapsed
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapsableContainer/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowUp.js
var ArrowUp = __webpack_require__(1025);
var ArrowUp_default = /*#__PURE__*/__webpack_require__.n(ArrowUp);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapseButton/CollapseToggle/CollapseToggle.styles.ts




var ArrowStyle40 = "\n    width: 1rem;\n    height: 1rem;\n    fill: currentcolor;\n  ";
var ArrowStyle60 = "\n    width: 2rem;\n    height: 2rem;\n    fill: currentcolor;\n  ";
var StyledArrowUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowUp_default()), (0,src_define_property/* default */.Z)({
    target: "ei2iz980"
}, "target", "ei2iz980"))(function(param) {
    var iconSize = param.iconSize;
    return iconSize === 40 ? ArrowStyle40 : ArrowStyle60;
});
var StyledArrowDown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowDown_default()), (0,src_define_property/* default */.Z)({
    target: "ei2iz981"
}, "target", "ei2iz981"))(function(param) {
    var iconSize = param.iconSize;
    return iconSize === 40 ? ArrowStyle40 : ArrowStyle60;
});


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapseButton/CollapseToggle/CollapseToggle.tsx


var CollapseToggle = function CollapseToggle(param) {
    var isCollapsed = param.isCollapsed, rules = param.rules;
    var ref = rules || {}, _iconSize = ref.iconSize, iconSize = _iconSize === void 0 ? 60 : _iconSize;
    var ArrowComponent = isCollapsed ? StyledArrowDown : StyledArrowUp;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowComponent, {
        iconSize: iconSize
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapseButton/CollapseToggle/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapseButton/CollapseButton.styles.ts



var CollapseToggleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* InteractiveText */.G9, (0,src_define_property/* default */.Z)({
    target: "e12l0rcq0"
}, "target", "e12l0rcq0"))("display:flex;flex-direction:row;align-items:center;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";");
var StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e12l0rcq1"
}, "target", "e12l0rcq1"))("z-index:20;", function(param) {
    var isCollapsed = param.isCollapsed;
    return isCollapsed ? "padding-top: ".concat(function(param) {
        var theme = param.theme;
        return theme.spacing[70];
    }) : "\n  margin-top: -3rem;\n  position: absolute;\n  ";
}, "  background-color:#0000;border:none;cursor:pointer;");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/useCollapse.ts

var HEIGHT_LIMIT = 1500;
var useCollapse = function useCollapse(allowCollapse, ref) {
    var _$ref = (0,react.useState)(false), isCollapsed = _$ref[0], setIsCollapsed = _$ref[1];
    var _$ref1 = (0,react.useState)(false), canBeCollapsed = _$ref1[0], setCanBeCollapsed = _$ref1[1];
    (0,react.useEffect)(function() {
        if (ref.current && allowCollapse) {
            // collapse the whole content if the height of the ref wrapping div is higher than the set limit
            setIsCollapsed(ref.current.clientHeight >= HEIGHT_LIMIT);
        } else {
            setIsCollapsed(false);
        }
    }, [
        ref,
        allowCollapse
    ]);
    (0,react.useEffect)(function() {
        if (ref.current && ref.current.clientHeight > HEIGHT_LIMIT) {
            setCanBeCollapsed(true);
        }
    }, [
        ref
    ]);
    return {
        canBeCollapsed: canBeCollapsed,
        isCollapsed: isCollapsed,
        setIsCollapsed: setIsCollapsed
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapseButton/CollapseButton.tsx




var CollapseButton = function CollapseButton(param) {
    var _behavior = param.behavior, onCollapseToggled = _behavior.onCollapseToggled, ref = _behavior.ref, _rules = param.rules, canBeCollapsed = _rules.canBeCollapsed, isCollapsed = _rules.isCollapsed, _labels = param.labels, showLessLabel = _labels.showLess, showMoreLabel = _labels.showMore;
    if (!canBeCollapsed) {
        return null;
    }
    var handleClick = function handleClick() {
        onCollapseToggled(!isCollapsed);
        if (!isCollapsed && ref.current) {
            var topBeforeCollapse = document.documentElement.scrollTop || document.body.scrollTop;
            var collapsedHeight = Math.min(ref.current.clientHeight, HEIGHT_LIMIT);
            var newTop = topBeforeCollapse - (ref.current.clientHeight - collapsedHeight);
            window.scroll({
                top: newTop
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
        isCollapsed: isCollapsed,
        type: "button",
        onClick: handleClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollapseToggleWrapper, {
            inline: true,
            textColor: "green",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapseToggle, {
                    isCollapsed: isCollapsed
                }),
                isCollapsed ? showMoreLabel : showLessLabel
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapseButton/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/SectionRows/SectionRows.styles.ts


var SectionContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1yk720w0"
}, "target", "e1yk720w0"))("display:grid;grid-auto-flow:row dense;grid-template-columns:repeat(12,minmax(0,1fr));column-gap:1rem;:not(:last-child){margin-bottom:4rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{:not(:last-child){margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[100];
}, ";}}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{column-gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/SectionRows/SectionRows.tsx


var SectionRows = function SectionRows(param) {
    var children = param.children, sections = param.sections;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: sections.map(function(section) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainer, {
                children: children(section)
            }, section.position);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/SectionRows/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/CollapsableContentBlock.tsx







var CollapsableContentBlock = function CollapsableContentBlock(param) {
    var children = param.children, _content = param.content, badge = _content.badge, heading = _content.heading, sections = _content.sections, allowCollapse = param.rules.allowCollapse, translations = param.translations;
    var ref = (0,react.useRef)(null);
    var ref1 = useCollapse(allowCollapse, ref), canBeCollapsed = ref1.canBeCollapsed, isCollapsed = ref1.isCollapsed, setIsCollapsed = ref1.setIsCollapsed;
    var handleCollapseToggled = function handleCollapseToggled(isNowCollapsed) {
        setIsCollapsed(isNowCollapsed);
    };
    var ref2 = translations || {
        collapseButton: {}
    }, _collapseButton = ref2.collapseButton, _showLessLabel = _collapseButton.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "" : _showLessLabel, _showMoreLabel = _collapseButton.showMoreLabel, showMoreLabel = _showMoreLabel === void 0 ? "" : _showMoreLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollapsableContainer, {
                behavior: {
                    ref: ref
                },
                rules: {
                    canBeCollapsed: canBeCollapsed,
                    isCollapsed: isCollapsed
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                        content: badge,
                        rules: {
                            badge: {
                                style: "orange"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                        content: heading
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionRows, {
                        sections: sections,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapseButton, {
                behavior: {
                    ref: ref,
                    onCollapseToggled: handleCollapseToggled
                },
                rules: {
                    canBeCollapsed: canBeCollapsed,
                    isCollapsed: isCollapsed
                },
                labels: {
                    showLess: showLessLabel,
                    showMore: showMoreLabel
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/CollapsableContentBlock/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(6670);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/ImageContentBlock.tsx





var ImageContentBlock = function ImageContentBlock(param) {
    var _content = param.content, badge = _content.badge, image = _content.image, rules = param.rules;
    if (!image) {
        return null;
    }
    var ref = rules || {}, badgeRules = ref.badge, imagePosition = ref.imagePosition, isFirstColumn = ref.isFirstColumn, verticalSpacing = ref.verticalSpacing;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModuleContainer, {
        rules: {
            isFirstColumn: isFirstColumn,
            verticalSpacing: verticalSpacing
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                content: badge,
                rules: {
                    badge: badgeRules,
                    verticalSpacing: {
                        isLargeAtMD: true
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Image */.Ui.Ee, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, image), {
                roundedBorder: true,
                layout: imagePosition === "bottom" || imagePosition === "top" ? "responsive" : undefined
            }))
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/GridSetSize.ts
var SET_SIZE = 8;

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/LinkGrid.styles.tsx



function LinkGrid_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        ",
        "\n      }\n    "
    ]);
    LinkGrid_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkGridContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e6n7wp40"
}, "target", "e6n7wp40"))("display:grid;grid-template-rows:auto;grid-template-columns:repeat(12,minmax(0,1fr));gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");
var getLayoutProperty = function getLayoutProperty(value) {
    if (typeof value === "number") {
        // Only column value provided
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("grid-column:span ", value, " / span ", value, ";");
    }
    var _value = (0,src_sliced_to_array/* default */.Z)(value, 2), column = _value[0], row = _value[1];
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("grid-column:span ", column, " / span ", column, ";grid-row:span ", row, " / span ", row, ";");
};
var makeLayout = function makeLayout(param, theme) {
    var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), baseValue = _param[0], responsive = _param[1];
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(getLayoutProperty(baseValue), ";", responsive && Object.entries(responsive).map(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), breakpoint = _param[0], value = _param[1];
        return (0,emotion_react_browser_esm/* css */.iv)(LinkGrid_styles_templateObject(), theme.mq(breakpoint), getLayoutProperty(value));
    }));
};
var Anchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "e6n7wp41"
}, "target", "e6n7wp41"))("display:", function(param) {
    var hidden = param.hidden;
    return hidden ? "none" : "flex";
}, ";align-items:flex-end;position:relative;height:100%;min-height:164px;overflow:hidden;border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";background-color:", function(param) {
    var bgColor = param.bgColor, theme = param.theme;
    return theme.color[bgColor];
}, ";text-decoration:none;", function(param) {
    var layout = param.layout, theme = param.theme;
    return makeLayout(layout, theme);
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{min-height:200px;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{min-height:250px;}");
var StyledImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), (0,src_define_property/* default */.Z)({
    target: "e6n7wp42"
}, "target", "e6n7wp42"))("width:100%;transition:transform 0.3s ease;", Anchor, ":hover &{transform:scale(1.1);}");
var StyledImageWithFocalPoint = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* ImageWithFocalPoint */.rk, (0,src_define_property/* default */.Z)({
    target: "e6n7wp43"
}, "target", "e6n7wp43"))("width:100%;transition:transform 0.3s ease;", Anchor, ":hover &{transform:scale(1.1);}");
var GradientBackground = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e6n7wp44"
}, "target", "e6n7wp44"))("display:inline-block;width:100%;z-index:10;background-image:", function(param) {
    var theme = param.theme;
    return src/* Theme.getLinearGradient */.Q2.getLinearGradient({
        from: (0,polished_esm/* transparentize */.DZ)(0.5, theme.color.natural100 || "#000"),
        to: (0,polished_esm/* transparentize */.DZ)(1, theme.color.natural100 || "#000")
    }, "to top");
}, ";");
var LinkGrid_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e6n7wp45"
}, "target", "e6n7wp45"))("position:relative;");
var Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Subtitle */.QE, (0,src_define_property/* default */.Z)({
    target: "e6n7wp46"
}, "target", "e6n7wp46"))("display:block;margin-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";word-break:break-word;padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";transition:transform 0.3s ease;/* Styles on hover */\n  ", Anchor, ":hover &{transform:translateY(-20px);/* Translate on hover */}");

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridImageLink.tsx



var GridImageLink = function GridImageLink(param) {
    var _content = param.content, href = _content.href, image = _content.image, label = _content.label, _rules = param.rules, color = _rules.color, layout = _rules.layout, hidden = _rules.hidden;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Anchor, {
        bgColor: color,
        layout: layout,
        href: href,
        hidden: !!hidden,
        children: [
            (image === null || image === void 0 ? void 0 : image.src) && image.focalPoint && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImageWithFocalPoint, (0,src_object_spread/* default */.Z)({}, image)),
            (image === null || image === void 0 ? void 0 : image.src) && !image.focalPoint && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, (0,src_object_spread/* default */.Z)({
                layout: "fill",
                objectFit: "cover"
            }, image)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientBackground, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                    as: "span",
                    textColor: "white",
                    children: label
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf1.tsx


var GridSetOf1 = function GridSetOf1(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
        content: set[0],
        rules: {
            color: set[0].color,
            layout: [
                12
            ],
            hidden: set[0].hidden
        }
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf2.tsx


var GridSetOf2 = function GridSetOf2(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: [
                        12,
                        {
                            md: 6
                        }
                    ],
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: [
                        12,
                        {
                            md: 6
                        }
                    ],
                    hidden: set[1].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf3.tsx


var GridSetOf3 = function GridSetOf3(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: [
                        12,
                        {
                            xl: 4
                        }
                    ],
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: [
                        6,
                        {
                            xl: 4
                        }
                    ],
                    hidden: set[1].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[2],
                rules: {
                    color: set[2].color,
                    layout: [
                        6,
                        {
                            xl: 4
                        }
                    ],
                    hidden: set[2].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf4.tsx


var LAYOUT = [
    12,
    {
        md: 6,
        xl: 3
    }
];
var GridSetOf4 = function GridSetOf4(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: LAYOUT,
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: LAYOUT,
                    hidden: set[1].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[2],
                rules: {
                    color: set[2].color,
                    layout: LAYOUT,
                    hidden: set[2].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[3],
                rules: {
                    color: set[3].color,
                    layout: LAYOUT,
                    hidden: set[3].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf5.tsx


var GridSetOf5 = function GridSetOf5(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: [
                        12,
                        {
                            md: 6
                        }
                    ],
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: [
                        12,
                        {
                            md: 6
                        }
                    ],
                    hidden: set[1].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[2],
                rules: {
                    color: set[2].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[2].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[3],
                rules: {
                    color: set[3].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[3].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[4],
                rules: {
                    color: set[4].color,
                    layout: [
                        12,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[4].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf6.tsx


var GridSetOf6 = function GridSetOf6(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: [
                        12,
                        {
                            xl: [
                                4,
                                2
                            ]
                        }
                    ],
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: [
                        12,
                        {
                            md: 4,
                            xl: 8
                        }
                    ],
                    hidden: set[1].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[2],
                rules: {
                    color: set[2].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[2].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[3],
                rules: {
                    color: set[3].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[3].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[4],
                rules: {
                    color: set[4].color,
                    layout: [
                        6
                    ],
                    hidden: set[4].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[5],
                rules: {
                    color: set[5].color,
                    layout: [
                        6
                    ],
                    hidden: set[5].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf7.tsx


var GridSetOf7 = function GridSetOf7(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: [
                        12,
                        {
                            md: 6,
                            xl: [
                                4,
                                2
                            ]
                        }
                    ],
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: [
                        12,
                        {
                            md: 6,
                            xl: 8
                        }
                    ],
                    hidden: set[1].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[2],
                rules: {
                    color: set[2].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[2].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[3],
                rules: {
                    color: set[3].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[3].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[4],
                rules: {
                    color: set[4].color,
                    layout: [
                        12,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[4].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[5],
                rules: {
                    color: set[5].color,
                    layout: [
                        6,
                        {
                            xl: 4
                        }
                    ],
                    hidden: set[5].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[6],
                rules: {
                    color: set[6].color,
                    layout: [
                        6,
                        {
                            xl: 4
                        }
                    ],
                    hidden: set[6].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/GridSetOf8.tsx


var GridSetOf8 = function GridSetOf8(param) {
    var set = param.content.set;
    if (set.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[0],
                rules: {
                    color: set[0].color,
                    layout: [
                        12,
                        {
                            xl: [
                                4,
                                2
                            ]
                        }
                    ],
                    hidden: set[0].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[1],
                rules: {
                    color: set[1].color,
                    layout: [
                        6,
                        {
                            xl: 8
                        }
                    ],
                    hidden: set[1].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[2],
                rules: {
                    color: set[2].color,
                    layout: [
                        6,
                        {
                            xl: 4
                        }
                    ],
                    hidden: set[2].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[3],
                rules: {
                    color: set[3].color,
                    layout: [
                        6,
                        {
                            md: 4
                        }
                    ],
                    hidden: set[3].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[4],
                rules: {
                    color: set[4].color,
                    layout: [
                        6,
                        {
                            md: 4,
                            xl: 3
                        }
                    ],
                    hidden: set[4].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[5],
                rules: {
                    color: set[5].color,
                    layout: [
                        12,
                        {
                            md: 4,
                            xl: 3
                        }
                    ],
                    hidden: set[5].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[6],
                rules: {
                    color: set[6].color,
                    layout: [
                        6,
                        {
                            md: 6,
                            xl: 3
                        }
                    ],
                    hidden: set[6].hidden
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridImageLink, {
                content: set[7],
                rules: {
                    color: set[7].color,
                    layout: [
                        6,
                        {
                            md: 6,
                            xl: 3
                        }
                    ],
                    hidden: set[7].hidden
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/GridSet/index.ts









;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/LinkGrid.tsx



var LinkGrid = function LinkGrid(param) {
    var sets = param.content.sets;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkGridContainer, {
        children: sets.map(function(set, setIndex) {
            var key = setIndex;
            switch(set.length){
                case 1:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf1, {
                        content: {
                            set: set
                        }
                    }, key);
                case 2:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf2, {
                        content: {
                            set: set
                        }
                    }, key);
                case 3:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf3, {
                        content: {
                            set: set
                        }
                    }, key);
                case 4:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf4, {
                        content: {
                            set: set
                        }
                    }, key);
                case 5:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf5, {
                        content: {
                            set: set
                        }
                    }, key);
                case 6:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf6, {
                        content: {
                            set: set
                        }
                    }, key);
                case 7:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf7, {
                        content: {
                            set: set
                        }
                    }, key);
                default:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridSetOf8, {
                        content: {
                            set: set
                        }
                    }, key);
            }
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/LinkGrid/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/GridLinkList.tsx








var BACKGROUND_COLORS = [
    "primary",
    "primaryGradient1",
    "natural70",
    "warning20", 
];
var getColor = function getColor() {
    return BACKGROUND_COLORS[Math.floor(Math.random() * BACKGROUND_COLORS.length)];
};
var addColorsToLinks = function addColorsToLinks(links) {
    return links.map(function(link) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, link), {
            color: getColor(),
            hidden: false
        });
    });
};
var splitIntoSets = function splitIntoSets(links) {
    var sets = [];
    for(var index = 0; index < links.length; index += SET_SIZE){
        sets.push(links.slice(index, index + SET_SIZE));
    }
    return sets;
};
var GridLinkList = function GridLinkList(param) {
    var _content = param.content, badge = _content.badge, heading = _content.heading, links = _content.links, translations = param.translations;
    var ref = translations || {}, _allDestinationsLabel = ref.allDestinationsLabel, allDestinationsLabel = _allDestinationsLabel === void 0 ? "" : _allDestinationsLabel, _moreDestinationsLabel = ref.moreDestinationsLabel, moreDestinationsLabel = _moreDestinationsLabel === void 0 ? "" : _moreDestinationsLabel;
    var ref1 = (0,react.useState)(1), visibleSetCount = ref1[0], setVisibleSetCount = ref1[1];
    var coloredLinks = (0,react.useMemo)(function() {
        return addColorsToLinks(links);
    }, [
        links
    ]);
    var visibleItems = visibleSetCount * SET_SIZE;
    var hasMoreItemsToShow = visibleItems < links.length;
    var hasOneMoreSetRemaining = visibleItems + SET_SIZE > links.length;
    var sets = splitIntoSets(coloredLinks);
    var visibleSets = sets.map(function(set, index) {
        if (visibleSetCount < index + 1) {
            return set.map(function(link) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, link), {
                    hidden: true
                });
            });
        }
        return set;
    });
    var incrementSets = function incrementSets() {
        setVisibleSetCount(visibleSetCount + 1);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkGrid_styles_Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                content: badge,
                rules: {
                    badge: {
                        style: "orange"
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: heading,
                rules: {
                    verticalSpacing: {
                        spacingDirection: "both"
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkGrid, {
                content: {
                    sets: visibleSets
                }
            }),
            hasMoreItemsToShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button_Button, {
                content: {
                    label: hasOneMoreSetRemaining ? allDestinationsLabel : moreDestinationsLabel
                },
                onClick: incrementSets,
                rules: {
                    variant: "secondary",
                    expanded: true,
                    horizontalSpacing: {
                        isCentered: true
                    },
                    verticalSpacing: {
                        spacingDirection: "neither"
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/GridLinkList/index.ts


// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowNext.js
var ArrowNext = __webpack_require__(5403);
var ArrowNext_default = /*#__PURE__*/__webpack_require__.n(ArrowNext);
;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/PlainLinkList/ArrowLink/ArrowLink.styles.ts




var ArrowLink_styles_Anchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "efplofn0"
}, "target", "efplofn0"))("display:flex;justify-content:space-between;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:none;&:hover{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary70;
}, ";}");
var Text = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* InteractiveText */.G9, (0,src_define_property/* default */.Z)({
    target: "efplofn1"
}, "target", "efplofn1"))("margin-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";");
var ArrowNextIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowNext_default()), (0,src_define_property/* default */.Z)({
    target: "efplofn2"
}, "target", "efplofn2"))("height:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";width:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";flex-shrink:0;fill:currentcolor;");

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/PlainLinkList/ArrowLink/ArrowLink.tsx


var ArrowLink = function ArrowLink(param) {
    var _link = param.link, href = _link.href, label = _link.label;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ArrowLink_styles_Anchor, {
        href: href,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                inline: true,
                textColor: "current",
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowNextIcon, {})
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/PlainLinkList/ArrowLink/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/PlainLinkList/PlainLinkList.styles.ts


function PlainLinkList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n      }\n\n      ",
        " {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n      }\n    "
    ]);
    PlainLinkList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlainLinkList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    PlainLinkList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e2qcobp0"
}, "target", "e2qcobp0"))("position:relative;display:flex;flex-direction:column;justify-content:center;");
var List = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e2qcobp1"
}, "target", "e2qcobp1"))("display:grid;grid-template-columns:repeat(1,minmax(0,1fr));gap:0;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{column-gap:", function(param) {
    var length = param.length, theme = param.theme;
    return length >= 6 ? theme.spacing[80] : 0;
}, ";}", function(param) {
    var length = param.length, theme = param.theme;
    return length >= 6 && (0,emotion_react_browser_esm/* css */.iv)(PlainLinkList_styles_templateObject(), theme.mq("md"), theme.mq("lg"));
});
var ListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e2qcobp2"
}, "target", "e2qcobp2"))("min-width:150px;border-bottom:", function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.color.natural20);
}, ";padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";position:relative;", function(param) {
    var linksAreExpanded = param.linksAreExpanded, maxVisibleLinks = param.maxVisibleLinks, index = param.index;
    return !linksAreExpanded && maxVisibleLinks <= index && (0,emotion_react_browser_esm/* css */.iv)(PlainLinkList_styles_templateObject1());
});


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/PlainLinkList/PlainLinkList.tsx







var MAX_LINKS_MOBILE = 10;
var MAX_LINKS_DESKTOP = 15;
var PlainLinkList = function PlainLinkList(param) {
    var _content = param.content, heading = _content.heading, links = _content.links, translations = param.translations;
    var ref = translations || {}, _showAllLabel = ref.showAllLabel, showAllLabel = _showAllLabel === void 0 ? "" : _showAllLabel, _showLessLabel = ref.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "" : _showLessLabel;
    var ref1 = (0,react.useState)(MAX_LINKS_MOBILE), maxVisibleLinks = ref1[0], setMaxVisibleLinks = ref1[1];
    var hasHiddenLinks = links.length > maxVisibleLinks;
    var ref2 = (0,react.useState)(false), linksAreExpanded = ref2[0], setLinksExpanded = ref2[1];
    var wideViewPort = (0,useMedia/* default */.Z)("(min-width:".concat(src/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), false);
    (0,react.useEffect)(function() {
        var maxLinks = wideViewPort ? MAX_LINKS_DESKTOP : MAX_LINKS_MOBILE;
        setMaxVisibleLinks(maxLinks);
    }, [
        wideViewPort,
        links
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: heading,
                rules: {
                    verticalSpacing: {
                        spacingDirection: "neither"
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                length: links.length,
                children: links.map(function(link, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                        linksAreExpanded: linksAreExpanded,
                        maxVisibleLinks: maxVisibleLinks,
                        index: index,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowLink, {
                            link: link
                        })
                    }, link.href + link.label);
                })
            }),
            hasHiddenLinks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button_Button, {
                content: {
                    label: linksAreExpanded ? showLessLabel : showAllLabel
                },
                onClick: function onClick() {
                    return setLinksExpanded(!linksAreExpanded);
                },
                rules: {
                    variant: "secondary",
                    expanded: true,
                    horizontalSpacing: {
                        isCentered: true
                    },
                    verticalSpacing: {
                        spacingDirection: "neither"
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/PlainLinkList/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/LinkListBlock.tsx



var LinkListBlock = function LinkListBlock(param) {
    var content = param.content, translations = param.translations;
    var groupType = content.groupType;
    if (groupType === "grid") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridLinkList, {
            content: content,
            translations: translations
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlainLinkList, {
        content: content,
        translations: translations
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/LinkListBlock/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/StandardContentRowBlock/StandardContentRowBlock.styles.ts



var StandardContentRowBlock_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eyqdobf0"
}, "target", "eyqdobf0"))(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";display:flex;columns:12;flex-direction:column;:not(:last-child){margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";}", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{:not(:last-child){margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[0];
}, ";}}");
var ColumnContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eyqdobf1"
}, "target", "eyqdobf1"))("display:flex;flex-direction:column;");
var TextContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eyqdobf2"
}, "target", "eyqdobf2"))("display:grid;grid-template-columns:repeat(12,minmax(0,1fr));");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/StandardContentRowBlock/StandardContentRowBlock.tsx





var getCols = function getCols(chunks) {
    if (chunks === 2) {
        return 6;
    }
    return chunks === 3 ? 4 : 3;
};
var getContainerCols = function getContainerCols(chunks) {
    return [
        [
            12
        ],
        [
            getCols(chunks),
            "md",
            {
                condition: chunks > 1 && chunks < 5
            }
        ], 
    ];
};
var getContentCols = function getContentCols(chunks) {
    return [
        [
            12
        ],
        [
            8,
            "lg",
            {
                condition: chunks === 1
            }
        ], 
    ];
};
var StandardContentRowBlock = function StandardContentRowBlock(param) {
    var chunks = param.content.chunks;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: chunks.map(function(param) {
            var body = param.body, image = param.image, heading = param.heading, link = param.link;
            var containerColumns = getContainerCols(chunks.length);
            var columns = getContentCols(chunks.length);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardContentRowBlock_styles_Container, {
                rules: {
                    columns: containerColumns
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnContainer, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                            content: image,
                            rules: {
                                hasMinSize: chunks.length < 3
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                                    content: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, heading), {
                                        level: heading.level || "h3"
                                    }),
                                    rules: {
                                        columns: columns
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText, {
                                    content: body,
                                    rules: {
                                        columns: columns
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkButton, {
                            content: link,
                            rules: {
                                variant: "secondary",
                                size: "small"
                            }
                        })
                    ]
                })
            }, heading.text);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/StandardContentRowBlock/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabBodyContentBlock/TabBodyContentBlock.styles.ts



var Block = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", (0,src_define_property/* default */.Z)({
    target: "e21o5a30"
}, "target", "e21o5a30"))("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";& >:first-child h1,& >:first-child h2,& >:first-child h3,& >:first-child h4,& >:first-child h5,& >:first-child h6{margin-top:0;padding-top:0;}display:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "block";
}, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return textStyle === src/* Ui.RichTextStyle.Alternative */.Ui.J$.Alternative ? theme.color.natural0 : theme.color.secondary100;
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabBodyContentBlock/TabBodyContentBlock.tsx



var TabBodyContentBlock = function TabBodyContentBlock(param) {
    var children = param.children, _content = param.content, currentTab = _content.currentTab, subModule = _content.subModule, tabGroup = _content.tabGroup, rules = param.rules;
    var name = subModule.name, position = subModule.position;
    var ref = rules || {}, _textStyle = ref.textStyle, textStyle = _textStyle === void 0 ? src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary : _textStyle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Block, {
        isHidden: currentTab !== name,
        id: "".concat(tabGroup, "-panel-").concat(position),
        "aria-labelledby": "".concat(tabGroup, "-tab-").concat(position),
        role: "tabpanel",
        tabIndex: 0,
        textStyle: textStyle,
        children: children(subModule.module)
    }, name);
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabBodyContentBlock/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabListContentBlock/Tabs/Tabs.tsx





var Tabs = function Tabs(param) {
    var onTabSelected = param.behavior.onTabSelected, content = param.content, rules = param.rules;
    // We'll use a random string to avoid any id collisions with other tab segments
    var tabGroup = "tabGroup-".concat((0,react.useId)());
    var initialName = content && content.length ? content[0].name : "";
    var ref = (0,react.useState)(initialName), activeTabName = ref[0], setActiveTabName = ref[1];
    if (!content || content.length === 0) {
        return null;
    }
    var ref1 = rules || {}, _textStyle = ref1.textStyle, textStyle = _textStyle === void 0 ? src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary : _textStyle;
    var handleTabSelected = function handleTabSelected(tabName) {
        setActiveTabName(tabName);
        onTabSelected(tabName);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TabNavigation */.Ui.LU, {
        textStyle: textStyle,
        children: content.map(function(tab) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TabButton */.Ui.Y6, {
                behavior: {
                    onSelectTab: handleTabSelected
                },
                content: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tab), {
                    tabGroup: tabGroup
                }),
                rules: {
                    activeTabName: activeTabName,
                    textStyle: textStyle
                }
            }, tab.position);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabListContentBlock/Tabs/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabListContentBlock/TabListContentBlock.tsx





var TabListContentBlock = function TabListContentBlock(param) {
    var behavior = param.behavior, _content = param.content, badge = _content.badge, heading = _content.heading, modules = _content.modules, rules = param.rules;
    var ref = rules || {}, _textStyle = ref.textStyle, textStyle = _textStyle === void 0 ? src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary : _textStyle;
    var headingContent = heading ? (0,src_object_spread/* default */.Z)({
        level: heading.level || "h2"
    }, heading) : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModuleContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                content: badge,
                rules: {
                    badge: {
                        style: "orange"
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: headingContent,
                rules: {
                    textStyle: {
                        style: textStyle
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs, {
                behavior: behavior,
                content: modules,
                rules: rules
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TabListContentBlock/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlock.tsx



var TextContentBlock = function TextContentBlock(param) {
    var _content = param.content, badge = _content.badge, heading = _content.heading, content = _content.content, link = _content.link, rules = param.rules;
    var ref = rules || {}, badgeRules = ref.badge, columns = ref.columns, tmp = ref.heading, headingStyle = tmp === void 0 ? {} : tmp, isContainerMultiColumn = ref.isContainerMultiColumn, isSecondColumn = ref.isSecondColumn, textStyle = ref.textStyle, verticalSpacing = ref.verticalSpacing;
    var style = (textStyle || {}).style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModuleContainer, {
        rules: {
            isSecondColumn: isSecondColumn,
            verticalSpacing: verticalSpacing
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                content: badge,
                rules: {
                    badge: badgeRules
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: heading,
                rules: (0,src_object_spread/* default */.Z)({
                    textStyle: {
                        style: style
                    }
                }, headingStyle)
            }),
            content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText, {
                content: content,
                rules: {
                    columns: columns,
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkButton, {
                content: link,
                rules: {
                    variant: "secondary",
                    size: "small",
                    horizontalSpacing: {
                        isCentered: !isContainerMultiColumn
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithFigures/FigureList.styles.ts



var FigureListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "em8yrqz0"
}, "target", "em8yrqz0"))("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";display:grid;grid-auto-flow:row dense;grid-template-columns:repeat(4,minmax(0,1fr));justify-items:center;gap:", function(param) {
    var theme = param.theme;
    return "".concat(theme.spacing[60], " ").concat(theme.spacing[70]);
}, ";padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural20;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";border-width:", function(param) {
    var theme = param.theme;
    return theme.spacing[5];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";grid-template-columns:", function(param) {
    var contentLength = param.contentLength;
    return "repeat(".concat(contentLength <= 5 ? contentLength : 4, ", minmax(0, 1fr))");
}, ";}");
var FigureList_styles_Figure = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("figure", (0,src_define_property/* default */.Z)({
    target: "em8yrqz1"
}, "target", "em8yrqz1"))("grid-column:span 2 / span 2;display:flex;flex-direction:column;max-height:200px;&:nth-of-type(odd){&:last-child{grid-column-start:2;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{grid-column-start:auto;}}}", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{grid-column:span 1 / span 1;}");
var FigureImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", (0,src_define_property/* default */.Z)({
    target: "em8yrqz2"
}, "target", "em8yrqz2"))("margin:", function(param) {
    var theme = param.theme;
    return "auto 0 ".concat(theme.spacing[40], " 0");
}, ";max-height:48px;max-width:120px;");
var PositionLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "em8yrqz3"
}, "target", "em8yrqz3"))(src/* secondaryText */.wz, "  margin-right:auto;margin-left:auto;margin-top:auto;");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithFigures/FigureList.tsx


var FigureList = function FigureList(param) {
    var content = param.content, positionLabel = param.positionLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FigureListContainer, {
        contentLength: content.length,
        children: content.map(function(param) {
            var position = param.position, src = param.src;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FigureList_styles_Figure, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FigureImage, {
                        src: src,
                        alt: "Provider Logo"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PositionLabel, {
                        textColor: "current",
                        children: [
                            position,
                            ". ",
                            positionLabel
                        ]
                    })
                ]
            }, position);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithFigures/TextContentBlockWithFigures.tsx




var TextContentBlockWithFigures = function TextContentBlockWithFigures(param) {
    var _content = param.content, content = _content.content, heading = _content.heading, figures = _content.figures, positionLabel = _content.positionLabel, rules = param.rules;
    var style = (rules === null || rules === void 0 ? void 0 : rules.textStyle) || src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModuleContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: heading,
                rules: {
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText, {
                content: content,
                rules: {
                    columns: [
                        [
                            12
                        ],
                        [
                            8,
                            "lg"
                        ]
                    ],
                    textStyle: {
                        hasSpacedParagraphs: true,
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FigureList, {
                content: figures,
                positionLabel: positionLabel
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithFigures/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithIcons/IconGrid.styles.ts



var IconGridContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1t9q3ib0"
}, "target", "e1t9q3ib0"))("height:100%;display:flex;width:100%;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{height:146px;}");
var IconGrid_styles_IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1t9q3ib1"
}, "target", "e1t9q3ib1"))("background-image:", function(param) {
    var theme = param.theme;
    return src/* Theme.getLinearGradient */.Q2.getLinearGradient(theme.gradient.orange, "270deg");
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{width:146px;}& svg{max-height:104px;}");
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1t9q3ib2"
}, "target", "e1t9q3ib2"))(src/* secondaryText */.wz, "  margin:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";justify-self:center;");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithIcons/IconGrid.tsx



var IconGrid = function IconGrid(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconGridContainer, {
        children: content.map(function(icon) {
            var key = icon.key, label = icon.label;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconGrid_styles_IconWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                        content: icon,
                        rules: {
                            color: "natural0",
                            indent: 40,
                            size: "full"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                        textColor: "white",
                        children: label
                    })
                ]
            }, key);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithIcons/TextContentBlockWithIcons.styles.ts


function TextContentBlockWithIcons_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        " {\n      flex-direction: row;\n      justify-content: center;\n    }\n  "
    ]);
    TextContentBlockWithIcons_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ResponsiveWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1niacss0"
}, "target", "e1niacss0"))("display:flex;flex-direction:column;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm/* css */.iv)(TextContentBlockWithIcons_styles_templateObject(), theme.mq("xl"));
});


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithIcons/TextContentBlockWithIcons.tsx





var TextContentBlockWithIcons = function TextContentBlockWithIcons(param) {
    var _content = param.content, content = _content.content, heading = _content.heading, icons = _content.icons, rules = param.rules;
    var style = (rules === null || rules === void 0 ? void 0 : rules.textStyle) || src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModuleContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                content: heading,
                rules: {
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResponsiveWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText, {
                        content: content,
                        rules: {
                            columns: [
                                [
                                    12
                                ],
                                [
                                    7,
                                    "lg"
                                ]
                            ],
                            textStyle: {
                                hasSpacedParagraphs: true,
                                style: style
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconGrid, {
                        content: icons
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/TextContentBlockWithIcons/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/block/index.ts











;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/container/rule/BackgroundStyle.ts
var selectBackgroundStyle = function selectBackgroundStyle(style) {
    return style;
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/container/rule/LayoutFlow.ts
var selectLayoutFlow = function selectLayoutFlow(position) {
    return position;
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/container/Container.styles.ts


function Container_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 4rem;\n      padding-bottom: 4rem;\n\n      ",
        " {\n        padding-top: 6rem;\n        padding-bottom: 6rem;\n      }\n    "
    ]);
    Container_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getLayoutFlow = function getLayoutFlow(layoutFlow) {
    return ({
        top: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column-reverse;"),
        bottom: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;"),
        left: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", src/* Theme.mq */.Q2.mq("sm"), "{display:grid;grid-template-columns:repeat(2,minmax(0,auto));}"),
        right: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", src/* Theme.mq */.Q2.mq("sm"), "{display:grid;grid-template-columns:repeat(2,minmax(0,auto));}")
    })[layoutFlow];
};
var getBackgroundColor = function getBackgroundColor(theme, style) {
    return ({
        default: "",
        gray: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", theme.color.natural10, ";"),
        green: "",
        mint: "",
        orange: ""
    })[style];
};
var Container_styles_getSpacingDirection = function getSpacingDirection(spacingDirection) {
    return ({
        top: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:4rem;padding-bottom:0;", src/* Theme.mq */.Q2.mq("lg"), "{padding-top:6rem;}"),
        bottom: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:0;padding-bottom:4rem;", src/* Theme.mq */.Q2.mq("lg"), "{padding-bottom:6rem;}"),
        both: "",
        neither: ""
    })[spacingDirection];
};
var Container_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", (0,src_define_property/* default */.Z)({
    target: "ejdft7l0"
}, "target", "ejdft7l0"))(src/* Styles.Global.layoutContainerContent */.z0.x.b1, "  gap:2.5rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{gap:3rem;}", function(param) {
    var isLarge = param.isLarge, layoutFlow = param.layoutFlow;
    return isLarge && layoutFlow && getLayoutFlow(layoutFlow);
}, ";", function(param) {
    var theme = param.theme, backgroundStyle = param.backgroundStyle;
    return backgroundStyle && getBackgroundColor(theme, backgroundStyle);
}, ";", function(param) {
    var isLarge = param.isLarge, _layoutFlow = param.layoutFlow, layoutFlow = _layoutFlow === void 0 ? "" : _layoutFlow;
    return isLarge && ![
        "left",
        "right"
    ].includes(layoutFlow) && (0,emotion_react_browser_esm/* css */.iv)(Container_styles_templateObject(), src/* Theme.mq */.Q2.mq("xl"));
}, ";");
var WaveContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container_styles_Container, (0,src_define_property/* default */.Z)({
    target: "ejdft7l1"
}, "target", "ejdft7l1"))("padding-top:2.5rem;padding-bottom:2.5rem;", function(param) {
    var spacingDirection = param.spacingDirection;
    return spacingDirection && Container_styles_getSpacingDirection(spacingDirection);
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/container/PlainContentModuleContainer.tsx


var PlainContentModuleContainer = function PlainContentModuleContainer(param) {
    var children = param.children, rules = param.rules;
    var ref = rules || {}, _backgroundStyle = ref.backgroundStyle, backgroundStyle = _backgroundStyle === void 0 ? "default" : _backgroundStyle, _layoutFlow = ref.layoutFlow, layoutFlow = _layoutFlow === void 0 ? "right" : _layoutFlow, verticalSpacing = ref.verticalSpacing;
    var isLarge = (verticalSpacing || {}).isLarge;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container_styles_Container, {
        isLarge: isLarge,
        layoutFlow: layoutFlow,
        backgroundStyle: backgroundStyle,
        children: children
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/container/WaveContentModuleContainer.tsx



var WaveContentModuleContainer = function WaveContentModuleContainer(param) {
    var children = param.children, rules = param.rules;
    var ref = rules || {}, _backgroundStyle = ref.backgroundStyle, backgroundStyle = _backgroundStyle === void 0 ? "default" : _backgroundStyle, _layoutFlow = ref.layoutFlow, layoutFlow = _layoutFlow === void 0 ? "right" : _layoutFlow, verticalSpacing = ref.verticalSpacing;
    var ref1 = verticalSpacing || {}, isLarge = ref1.isLarge, spacingDirection = ref1.spacingDirection;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Wave */.Ui.iC, {
        type: spacingDirection ? "scalable4" : "scalable1",
        fullWidth: true,
        backgroundStyle: backgroundStyle,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveContainer, {
            isLarge: isLarge,
            layoutFlow: layoutFlow,
            backgroundStyle: backgroundStyle,
            spacingDirection: spacingDirection,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/container/index.ts




;// CONCATENATED MODULE: ../../frontend/entities/src/ContentModule/index.ts




// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Close.js
var dist_Close = __webpack_require__(2530);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(2579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/react-day-picker/dist/index.esm.js + 20 modules
var index_esm = __webpack_require__(3412);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(1502);
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(1461);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowLast.js
var ArrowLast = __webpack_require__(4327);
var ArrowLast_default = /*#__PURE__*/__webpack_require__.n(ArrowLast);
// EXTERNAL MODULE: ../../config/tailwind/tailwind.config.js
var tailwind_config = __webpack_require__(4260);
var tailwind_config_default = /*#__PURE__*/__webpack_require__.n(tailwind_config);
;// CONCATENATED MODULE: ../../frontend/entities/src/DateRangePicker/DatePicker.tsx











/** @todo: Remove the hard dependency on the config file which should only be a dev dependency */ 
var DatePicker_defaultProps = {
    scrollToSelectedMonth: false
};
/**
 * Mimics Tailwinds `theme()` function.
 * @see https://tailwindcss.com/docs/functions-and-directives#theme
 */ var theme = function theme(property) {
    return get_default()((tailwind_config_default()), "theme.".concat(property));
};
/**
These global styles required by the `react-day-picker` code are applied using
`styled-jsx` to add them only when this component is used. This also fixes
missing styles in Storybook. Adding them to Storybook using a CSS file via
"import" unfortunately does not work with Tailwind’s `theme()` function.
*/ var globalStyles = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".rdp{position:relative;outline:0;color:", theme("colors.primary"), ";user-select:none;}.rdp-button_reset{margin:0;padding:0;border:0;font:inherit;background:none;appearance:none;}.rdp-months{display:flex;flex-wrap:wrap;justify-content:center;}.rdp-month{margin:1.5rem 1rem 1rem;}.rdp-nav_button{position:absolute;top:1.5rem;width:36px;height:36px;outline:0;color:inherit;-webkit-tap-highlight-color:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;&:disabled{cursor:not-allowed;}}.rdp-nav_button.rdp-nav_button_previous{left:0.75rem;}.rdp-nav_button.rdp-nav_button_next{right:0.75rem;transform:rotate(0.5turn);}.rdp-caption_label{margin:0.25rem 0;font-size:1.125rem;font-weight:600;text-align:center;text-transform:capitalize;}.rdp-table{border-spacing:0;border-collapse:collapse;}.rdp-head_cell{display:table-cell;padding:8px 0;color:", theme("colors.color6"), ";font-size:0.938rem;font-weight:600;text-align:center;}.rdp-cell{padding:8px 0 0;}.rdp-day{outline:0;width:40px;height:32px;font-size:1.125rem;text-align:center;vertical-align:middle;cursor:pointer;color:", theme("colors.primary"), ";}.rdp-day.rdp-day_outside{color:", theme("colors.color2"), ";cursor:default;}.rdp-day.rdp-day_disabled{color:", theme("colors.color6"), ";cursor:default;}/* selected pick-up/drop-off dates */\n  .rdp-day.rdp-day_selected:not(.rdp-day_disabled,.rdp-day_outside){position:relative;color:", theme("colors.white"), ";}.rdp-day.rdp-day_range_start.rdp-day_selected:not(\n      .rdp-day_disabled,.rdp-day_outside\n    ){background-image:radial-gradient(\n        circle at center,", theme("colors.color1.DEFAULT"), ",", theme("colors.color1.DEFAULT"), " 60%,transparent 65%\n      ),linear-gradient(\n        to right,transparent,transparent 49%,", theme("colors.color2.400"), " 50%\n      );}.rdp-day.rdp-day_range_end.rdp-day_selected:not(\n      .rdp-day_disabled,.rdp-day_outside\n    ){background-image:radial-gradient(\n        circle at center,", theme("colors.color1.DEFAULT"), ",", theme("colors.color1.DEFAULT"), " 60%,transparent 65%\n      ),linear-gradient(\n        to left,transparent,transparent 49%,", theme("colors.color2.400"), " 50%\n      );}.rdp-day.rdp-day_range_start.rdp-day_range_end.rdp-day_selected:not(\n      .rdp-day_disabled,.rdp-day_outside\n    ){background-image:radial-gradient(\n      circle at center,", theme("colors.color1.DEFAULT"), ",", theme("colors.color1.DEFAULT"), " 70%,transparent 71%\n    );}/* range between pick-up and drop-off */\n  .rdp-day.rdp-day_selected:not(\n      .rdp-day_range_start,.rdp-day_range_end,.rdp-day_outside\n    ){color:", theme("colors.primary"), ";background-color:", theme("colors.color2.400"), ";}/* today but not selected */\n  .rdp-day.rdp-day_today:not(.rdp-day_selected){margin:0 0.25rem;width:32px;border:1px solid ", theme("colors.color6"), ";border-radius:100%;}.rdp-vhidden{position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);}@media screen and (min-width:", theme("screens.xl"), "){.rdp-months{justify-content:space-around;}}");
var NavigationIcon = function NavigationIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((ArrowLast_default()), {
        className: "hover:fill-primary/80 w-50 h-50"
    });
};
var DatePicker_DatePicker = function DatePicker(_param) {
    var from = _param.from, to = _param.to, scrollToSelectedMonth = _param.scrollToSelectedMonth, onDatesChange = _param.onDatesChange, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "from",
        "to",
        "scrollToSelectedMonth",
        "onDatesChange"
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if (!scrollToSelectedMonth) {
            return;
        }
        var selectedDay = document.querySelector(".rdp-day_selected");
        var selectedMonthElm = selectedDay === null || selectedDay === void 0 ? void 0 : (ref = selectedDay.parentElement) === null || ref === void 0 ? void 0 : (ref1 = ref.parentElement) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.parentElement) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.parentElement) === null || ref3 === void 0 ? void 0 : ref3.parentElement;
        if (selectedMonthElm) {
            selectedMonthElm.scrollIntoView();
        }
    }, [
        scrollToSelectedMonth
    ]);
    var ref = (0,react.useState)(from || null), selectedFrom = ref[0], setFrom = ref[1];
    var ref1 = (0,react.useState)(to || null), selectedTo = ref1[0], setTo = ref1[1];
    var ref2 = (0,react.useState)(undefined), hoveredTo = ref2[0], setHoveredTo = ref2[1];
    var isSelectingFirstDay = function isSelectingFirstDay(date) {
        var isBeforeFirstDay = selectedFrom && (0,isBefore/* isBefore */.R)(date, selectedFrom);
        var isRangeSelected = selectedFrom && selectedTo;
        return !selectedFrom || isBeforeFirstDay || isRangeSelected;
    };
    var handleOnDayClick = function handleOnDayClick(date, modifiers) {
        if (modifiers.disabled) {
            return;
        }
        if (isSelectingFirstDay(date)) {
            setFrom(date);
            setTo(null);
            setHoveredTo(undefined);
        } else {
            setTo(date);
            setHoveredTo(date);
            if (typeof onDatesChange !== "undefined") {
                onDatesChange({
                    from: selectedFrom,
                    to: date
                });
            }
        }
    };
    var getHighlightedDays = function getHighlightedDays() {
        var highlightRules = [
            function(day) {
                if (selectedFrom && selectedTo) {
                    return (0,isAfter/* isAfter */.A)(day, selectedFrom) && (0,isBefore/* isBefore */.R)(day, selectedTo);
                }
                return false;
            }, 
        ];
        if (selectedFrom) {
            highlightRules.push(selectedFrom);
        }
        if (selectedFrom && hoveredTo) {
            highlightRules.push({
                from: selectedFrom,
                to: hoveredTo
            });
        }
        if (selectedFrom && selectedTo) {
            highlightRules.push({
                from: selectedFrom,
                to: selectedTo
            });
        }
        return highlightRules;
    };
    var getModifiers = function getModifiers() {
        var modifiers = {};
        if (selectedFrom) {
            modifiers = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, modifiers), {
                from: [
                    selectedFrom
                ]
            });
        }
        if (hoveredTo) {
            modifiers = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, modifiers), {
                to: hoveredTo
            });
        } else if (selectedTo) {
            modifiers = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, modifiers), {
                to: selectedTo
            });
        }
        return modifiers;
    };
    var handleDayMouseEnter = function handleDayMouseEnter(day) {
        if (from && (0,isBefore/* isBefore */.R)(day, from) || isSelectingFirstDay(day)) {
            return;
        }
        setHoveredTo(day);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
                styles: [
                    globalStyles
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* DayPicker */._W, (0,src_object_spread/* default */.Z)({
                components: {
                    IconLeft: NavigationIcon,
                    IconRight: NavigationIcon
                },
                onDayClick: handleOnDayClick,
                onDayMouseEnter: handleDayMouseEnter,
                selected: getHighlightedDays(),
                modifiers: getModifiers(),
                disabled: {
                    before: new Date()
                },
                modifiersClassNames: {
                    outside: "rdp-day_outside",
                    disabled: "rdp-day_disabled",
                    today: "rdp-day_today",
                    from: "rdp-day_range_start",
                    to: "rdp-day_range_end"
                }
            }, props))
        ]
    });
};
DatePicker_DatePicker.defaultProps = DatePicker_defaultProps;


;// CONCATENATED MODULE: ../../frontend/entities/src/DateRangePicker/TimePicker.tsx




var generateTimeRange = function generateTimeRange() {
    var options = [];
    for(var m = 0; m < 1440; m += 15){
        var time = "".concat(Math.floor(m / 60).toString().padStart(2, "0"), ":").concat((m % 60).toString().padStart(2, "0"));
        options.push({
            label: time,
            value: time
        });
    }
    return options;
};
var TimePicker_TimePicker = function TimePicker(param) {
    var type = param.type, onChange = param.onChange, pickupTimeText = param.pickupTimeText, pickupTimeLabel = param.pickupTimeLabel, returnTimeText = param.returnTimeText, returnTimeLabel = param.returnTimeLabel, value = param.value;
    var output = useRef(null);
    var timeOptions = generateTimeRange();
    var content = {
        from: {
            label: pickupTimeLabel,
            value: pickupTimeText
        },
        to: {
            label: returnTimeLabel,
            value: returnTimeText
        }
    };
    var setValue = function setValue(newValue) {
        return "".concat(content[type].value, " ").concat(newValue);
    };
    var handleChange = function handleChange(event) {
        var ref;
        var _target = event.target, selectedValue = _target.value;
        if ((ref = output.current) === null || ref === void 0 ? void 0 : ref.firstChild) {
            output.current.firstChild.textContent = setValue(selectedValue);
        }
        if (typeof onChange !== "undefined") {
            onChange(selectedValue, type);
        }
    };
    return /*#__PURE__*/ _jsxs("span", {
        className: "color-primary hover:bg-color8 relative flex items-center gap-10 rounded-sm p-10",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute bottom-0 left-0 right-0 top-0 w-full p-0 opacity-0",
                children: /*#__PURE__*/ _jsx(Ui.Dropdown, {
                    design: "compact",
                    id: "".concat(type, "TimeDropdown"),
                    label: content[type].label,
                    options: timeOptions,
                    onChange: handleChange,
                    value: value
                })
            }),
            /*#__PURE__*/ _jsx("output", {
                ref: output,
                children: /*#__PURE__*/ _jsx(SecondaryText, {
                    inline: true,
                    children: setValue(value)
                })
            }),
            /*#__PURE__*/ _jsx(ArrowDown, {
                className: "h-30 w-30 fill-current"
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useRuntime.ts

// have to do this because type assertion functions have some stupid restrictions
var hasContext = src/* Context.guardContext */._y.guardContext;
var useRuntime = function useRuntime() {
    var result = src/* Context.useClientContext */._y.useClientContext("runtime");
    hasContext("runtime", result);
    return result.value;
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useAccountConfig.ts

var join = function join(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
var useAccountConfig = function useAccountConfig() {
    var ref = useRuntime(), _account = ref.account, apiBaseUrl = _account.apiBaseUrl, sessionBaseUrl = _account.sessionBaseUrl;
    return {
        formatApiUrl: function formatApiUrl(path) {
            return join(apiBaseUrl, path);
        },
        formatSessionUrl: function formatSessionUrl(path) {
            return join(sessionBaseUrl, path);
        }
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useConfig.ts

var useConfig = function useConfig() {
    var apiConfig = useRuntime().apiConfig;
    return {
        api: apiConfig
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useConsumerApi.ts

var useConsumerApi = function useConsumerApi() {
    var consumerApiSettings = useRuntime().consumerApiSettings;
    return {
        consumerApiSettings: consumerApiSettings
    };
};


;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useBrand.ts

var useBrand = function useBrand() {
    var brand = useRuntime().brand;
    return brand;
};

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useHost.ts


var useHost = function useHost() {
    var ref;
    var ref1 = useRuntime(), _host = ref1.host, hostName = _host.hostName, imageHost = _host.imageHost, locale = ref1.locale;
    var router = (0,next_router.useRouter)();
    var localeString = "";
    if (router === null || router === void 0 ? void 0 : (ref = router.locales) === null || ref === void 0 ? void 0 : ref.map(function(l) {
        return l.toLowerCase();
    }).includes(locale.toLowerCase())) {
        localeString = "/".concat(locale.toLowerCase());
    }
    var cleanHostName = hostName // remove subdomains
    .replace(/^[^.]+\./g, "") // remove port
    .replace(/:\d+$/, "");
    var cookieDomain = cleanHostName === "localhost" ? undefined : cleanHostName;
    /**
   * @todo: Align with the BM/CG host context, driven by the same
   * settings-based approach
   * */ return {
        baseUrl: "https://".concat(hostName),
        baseLocalizedUrl: "https://".concat(hostName).concat(localeString),
        baseImageUrl: "https://".concat(imageHost),
        hostName: hostName,
        cookieDomain: cookieDomain
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useLocale.ts

var useLocale_useLocale = function useLocale() {
    var ref = useRuntime(), locale = ref.locale, language = ref.language, market = ref.market;
    return {
        locale: locale,
        language: language,
        market: market
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/usePath.ts

var usePath = function usePath() {
    var ref = useRuntime(), path = ref.page.path;
    return {
        isHomepage: /^index\.?/.test(path)
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/useWhitelabel.ts

// Map locales to Whitelabels
var whitelabels = {
    "de-DE": "DE_billiger-mietwagen",
    "fr-FR": "FR_carigami",
    "es-ES": "ES_floyt",
    "it-IT": "IT_floyt",
    "nl-NL": "NL_floyt"
};
var getWhitelabel = function getWhitelabel() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "de-DE";
    return whitelabels[locale];
};
var useWhitelabel = function useWhitelabel() {
    var locale = useRuntime().locale;
    var whitelabel = getWhitelabel(locale);
    return {
        whitelabel: whitelabel
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/hooks/index.ts









;// CONCATENATED MODULE: ../../frontend/entities/src/Runtime/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Calendar.js
var dist_Calendar = __webpack_require__(5241);
;// CONCATENATED MODULE: ../../frontend/entities/src/DateRangePicker/DateRangePicker.styles.ts




var DateRangePicker_styles_TopBarHeadline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1kfjw1p0"
}, "target", "e1kfjw1p0"))(src/* bodyBold */.Hp);
var DateRangePicker_styles_DatePickerButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("button", _define_property({
    target: "e1kfjw1p1"
}, "target", "e1kfjw1p1"))("display:inline-flex;flex-wrap:nowrap;align-items:center;gap:0.5rem;margin:0;padding:0.625rem 1rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";width:100%;height:3.5rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.default;
}, ";font-size:1rem;font-weight:600;line-height:1.5;text-transform:capitalize;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";cursor:pointer;&:hover,&:focus{border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";}")));
var DateRangePicker_styles_DatePickerValues = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("span", _define_property({
    target: "e1kfjw1p2"
}, "target", "e1kfjw1p2"))("display:inline-grid;grid-template-columns:1fr min-content 1fr;gap:0.5rem;align-items:center;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{gap:1rem;}")));
var DateRangePicker_styles_DatePickerValue = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("time", _define_property({
    target: "e1kfjw1p3"
}, "target", "e1kfjw1p3"))("width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;")));
var DateRangePicker_styles_DateSeparator = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("span", _define_property({
    target: "e1kfjw1p4"
}, "target", "e1kfjw1p4"))("width:1px;height:1.5rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";")));
var DateRangePicker_styles_CalendarIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(Calendar, _define_property({
    target: "e1kfjw1p5"
}, "target", "e1kfjw1p5"))("display:none;width:1.6rem;height:1.6rem;fill:currentcolor;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{display:block;}")));


;// CONCATENATED MODULE: ../../frontend/entities/src/DateRangePicker/DateRangePicker.tsx
















var HOUR_IN_MS = (/* unused pure expression or super */ null && (1000 * 60 * 60));
var DateRangePicker = function DateRangePicker(_param) {
    var from = _param.from, to = _param.to, _open = _param.open, open = _open === void 0 ? false : _open, _vertical = _param.vertical, vertical = _vertical === void 0 ? false : _vertical, error = _param.error, onDatesChange = _param.onDatesChange, className = _param.className, translations = _object_without_properties(_param, [
        "from",
        "to",
        "open",
        "vertical",
        "error",
        "onDatesChange",
        "className"
    ]);
    var ref;
    var language = useLocale().language;
    var dateLocale = datetime.dateLocales[language];
    var localDateFormats = String.dateFormats[language];
    var ref1 = useState(open), isCalendarVisible = ref1[0], setCalendarVisibility = ref1[1];
    var ref2 = useState({
        from: from,
        to: to
    }), selectedDates = ref2[0], setSelectedDates = ref2[1];
    useEffect(function() {
        setSelectedDates({
            from: from,
            to: to
        });
    }, [
        from,
        to
    ]);
    var handleBackdropClick = function handleBackdropClick(event) {
        event.stopPropagation();
        setCalendarVisibility(false);
    };
    var handleOnDatesChange = function handleOnDatesChange(dateRange) {
        var newDateRange = {
            from: new Date(),
            to: new Date()
        };
        if (dateRange.from && dateRange.to && selectedDates.from && selectedDates.to) {
            newDateRange = {
                from: datetime.addTimeToDate(dateRange.from, selectedDates.from.getHours(), selectedDates.from.getMinutes()),
                to: datetime.addTimeToDate(dateRange.to, selectedDates.to.getHours(), selectedDates.to.getMinutes())
            };
            if (format(dateRange.from, String.isoDateTime).split("T")[0] === format(dateRange.to, String.isoDateTime).split("T")[0]) {
                newDateRange = {
                    from: datetime.addTimeToDate(dateRange.from, 10, 0),
                    to: datetime.addTimeToDate(dateRange.to, 17, 0)
                };
            }
            if (typeof onDatesChange !== "undefined") {
                onDatesChange(newDateRange);
            }
            setSelectedDates(newDateRange);
        }
    };
    var handleOnTimeChange = function handleOnTimeChange(time, type) {
        var ref = _sliced_to_array(time.split(":"), 2), hours = ref[0], minutes = ref[1];
        if (selectedDates[type]) {
            var dateWithTime = datetime.addTimeToDate(selectedDates[type], Number(hours), Number(minutes));
            var newDateRange = _object_spread_props(_object_spread({}, selectedDates), _define_property({}, type, dateWithTime));
            if (typeof onDatesChange !== "undefined") {
                onDatesChange(newDateRange);
            }
            setSelectedDates(newDateRange);
        }
    };
    var getDays = function getDays() {
        if (selectedDates.from && selectedDates.to) {
            // Inspired by https://youmightnotneed.com/date-fns#differenceInDays,
            // because differenceInHours() from date-fns always rounds which is not what we want
            var days = (selectedDates.to - selectedDates.from) / HOUR_IN_MS / 24;
            return Number.isInteger(days) ? days : Math.ceil(days);
        }
        return 1;
    };
    // calendar range: current month up to two years
    var now = new Date();
    var calendarRange = {
        start: now,
        end: addYears(now, 2)
    };
    // scrolling shadow effect
    var shadowEffect = vertical ? {
        background: "\n      linear-gradient(white 30%, rgba(255, 255, 255, 0)),\n      linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,\n      radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)),\n      radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)) 0 100%",
        backgroundRepeat: "no-repeat",
        backgroundColor: "white",
        backgroundSize: "100% 40px, 100% 40px, 100% 14px, 100% 14px",
        backgroundAttachment: "local, local, scroll, scroll"
    } : undefined;
    var renderDate = function renderDate(date) {
        return date && format(date, vertical ? localDateFormats.dayTimeShort : localDateFormats.dayTimeLong, {
            locale: dateLocale
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx("relative", className),
        children: [
            isCalendarVisible && // OnKeyDown is necessary for accessibility reasons
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            /*#__PURE__*/ _jsx("div", {
                className: "fixed bottom-0 left-0 right-0 top-0 select-none bg-transparent",
                onClick: handleBackdropClick,
                "data-testid": "date-picker-backdrop"
            }),
            /*#__PURE__*/ _jsxs(DatePickerButton, {
                type: "button",
                id: "datepicker",
                onClick: function onClick() {
                    return setCalendarVisibility(true);
                },
                isInvalid: !!error,
                children: [
                    /*#__PURE__*/ _jsx(CalendarIcon, {
                        id: "datepicker-cal-icon"
                    }),
                    /*#__PURE__*/ _jsxs(DatePickerValues, {
                        id: "datepickerValue",
                        children: [
                            /*#__PURE__*/ _jsx(DatePickerValue, {
                                children: renderDate(selectedDates.from)
                            }),
                            /*#__PURE__*/ _jsx(DateSeparator, {}),
                            /*#__PURE__*/ _jsx(DatePickerValue, {
                                children: renderDate(selectedDates.to)
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ _jsx(Ui.ErrorMessage, {
                children: error
            }),
            isCalendarVisible && /*#__PURE__*/ _jsxs("div", {
                className: "md:border-color8 fixed bottom-0 left-0 right-0 top-0 z-50 flex flex-col rounded-md bg-white md:absolute md:bottom-auto md:right-auto md:top-auto md:mt-10 md:block md:w-[688px] md:overflow-hidden md:border-2",
                children: [
                    vertical && /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-row items-center justify-between bg-white p-40",
                        children: [
                            /*#__PURE__*/ _jsx(TopBarHeadline, {
                                children: translations.topBarHeadline
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                "aria-label": translations.close,
                                onClick: function onClick() {
                                    return setCalendarVisibility(false);
                                },
                                children: /*#__PURE__*/ _jsx(Close, {
                                    className: "fill-primary h-60 w-60"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-auto flex-grow overflow-y-scroll md:overflow-hidden",
                        style: shadowEffect,
                        "data-testid": "date-picker",
                        children: /*#__PURE__*/ _jsx(DatePicker, {
                            onDatesChange: handleOnDatesChange,
                            disableNavigation: vertical,
                            disabled: {
                                before: new Date()
                            },
                            numberOfMonths: vertical ? 15 : 2,
                            fromMonth: calendarRange.start,
                            toMonth: calendarRange.end,
                            from: selectedDates.from ? selectedDates.from : undefined,
                            to: selectedDates.to ? selectedDates.to : undefined,
                            locale: dateLocale,
                            defaultMonth: (vertical ? undefined : selectedDates.from) || undefined,
                            scrollToSelectedMonth: vertical
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-color5 md:p-50 flex flex-col items-center justify-between gap-40 p-40 md:flex-row",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex justify-between gap-60 md:justify-start md:gap-40",
                                children: [
                                    /*#__PURE__*/ _jsx(TimePicker, {
                                        type: "from",
                                        onChange: handleOnTimeChange,
                                        returnTimeLabel: translations.returnTimeLabel,
                                        returnTimeText: translations.returnTimeText,
                                        pickupTimeLabel: translations.pickupTimeLabel,
                                        pickupTimeText: translations.pickupTimeText,
                                        value: selectedDates.from ? format(selectedDates.from, localDateFormats.time) : undefined
                                    }),
                                    /*#__PURE__*/ _jsx(TimePicker, {
                                        type: "to",
                                        onChange: handleOnTimeChange,
                                        returnTimeLabel: translations.returnTimeLabel,
                                        returnTimeText: translations.returnTimeText,
                                        pickupTimeLabel: translations.pickupTimeLabel,
                                        pickupTimeText: translations.pickupTimeText,
                                        value: selectedDates.to ? format(selectedDates.to, localDateFormats.time) : undefined
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "w-full md:w-auto",
                                size: "small",
                                type: "button",
                                variant: "primary",
                                onClick: function onClick() {
                                    return setCalendarVisibility(false);
                                },
                                children: /*#__PURE__*/ _jsx(BodyBoldText, {
                                    inline: true,
                                    textColor: "white",
                                    children: (ref = translations.confirmButtonText) === null || ref === void 0 ? void 0 : ref.replace("{{days}}", getDays().toString())
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/DateRangePicker/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/Header.styles.ts

var HeaderIconStyles = function HeaderIconStyles(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("fill:", theme.color.primary, ";width:", theme.spacing[50], ";height:", theme.spacing[50], ";");
};


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Comment.js
var Comment = __webpack_require__(1257);
var Comment_default = /*#__PURE__*/__webpack_require__.n(Comment);
;// CONCATENATED MODULE: ../../frontend/entities/src/Header/InfolinePopover/InfolinePopover.styles.ts





var PhoneInfoPopoverWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ezm1i8k0"
}, "target", "ezm1i8k0"))("display:flex;align-items:center;");
var PhoneNumberWrapperSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ezm1i8k1"
}, "target", "ezm1i8k1"))(function(param) {
    var theme = param.theme;
    return (0,src/* interactiveText */.Tp)({
        textColor: "grey",
        theme: theme
    });
}, ";");
var PhoneNumber = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.PhoneNumber */.Ui.Bh, (0,src_define_property/* default */.Z)({
    target: "ezm1i8k2"
}, "target", "ezm1i8k2"))("color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";display:none;", function(param) {
    var phoneNumber = param.phoneNumber;
    return phoneNumber && "gap: 0.5rem;";
}, " ", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:flex;white-space:nowrap;}");
var ContactIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Comment_default()), (0,src_define_property/* default */.Z)({
    target: "ezm1i8k3"
}, "target", "ezm1i8k3"))(HeaderIconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";min-width:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/SiteInfo/defaults.ts


var localeSpecificDefaultsMap = {
    "de-DE": {
        settings: {
            market: "DE",
            language: "de",
            phoneNumber: "+49 221 567 999 11"
        },
        openingTimes: {
            common: {
                always: {
                    open: "08:00",
                    close: "20:00"
                }
            }
        }
    },
    "es-ES": {
        settings: {
            market: "ES",
            language: "es",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    },
    "fr-FR": {
        settings: {
            market: "FR",
            language: "fr",
            phoneNumber: "+33 1 73 79 33 33"
        },
        openingTimes: {
            common: {
                workdays: {
                    open: "09:00",
                    close: "18:00"
                }
            }
        }
    },
    "it-IT": {
        settings: {
            market: "IT",
            language: "it",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    },
    "nl-NL": {
        settings: {
            market: "NL",
            language: "nl",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    },
    en: {
        settings: {
            market: "ES",
            language: "en",
            phoneNumber: ""
        },
        openingTimes: {
            common: {}
        }
    }
};
var getDefaults = function getDefaults(locale) {
    var localeSpecificDefaults = localeSpecificDefaultsMap[locale];
    var defaults = {
        settings: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            isAppMode: false,
            isTwa: false,
            isInternalCall: false,
            isInfolineCall: false,
            isBotCall: false,
            locale: locale,
            market: "DE",
            validMarkets: [
                "DE",
                "FR",
                "ES",
                "NL",
                "IT"
            ],
            validLanguages: [
                "de",
                "fr",
                "es",
                "nl",
                "it"
            ],
            language: "de",
            phoneNumber: "+49 221 567 999 11"
        }, localeSpecificDefaults.settings), {
            featureToggles: {
                waitForResults: true,
                erv: true,
                maintenanceInfo: false,
                showScaMessage: false,
                hideInfoline: true,
                hideInfolineOnIndex: true,
                isLoginActive: true,
                useElasticSearch: false,
                showSurveyOnSuccess: false,
                showMarketPicker: true,
                skipSecondScaCall: true,
                useSavingBadge: false,
                trustElementOnStageImage: false,
                useNewDesignFooter: false
            },
            sessionData: {
                securityTokenValue: "",
                isMobileUserAgent: false,
                gtmEnvironment: "live",
                anonymizeIP: true
            }
        }),
        openingTimes: (0,src_object_spread/* default */.Z)({
            common: {
                always: {
                    open: "08:00",
                    close: "20:00"
                }
            },
            exceptions: []
        }, localeSpecificDefaults.openingTimes)
    };
    return defaults;
};

;// CONCATENATED MODULE: ../../frontend/entities/src/SiteInfo/hooks/useGetSiteInfo.ts




var useGetSiteInfo = function useGetSiteInfo() {
    var api = useConfig().api;
    var locale = useLocale_useLocale().locale;
    var defaults = getDefaults(locale);
    var ref = src/* http.useClientSideRequest */.dJ.useClientSideRequest(api.host, src/* http.API.siteSettings */.dJ.API.siteSettings), settingsData = ref.data, settingsRequest = ref.request;
    var ref1 = src/* http.useClientSideRequest */.dJ.useClientSideRequest(api.host, src/* http.API.openingHours */.dJ.API.openingHours), openingTimesData = ref1.data, openingTimesRequest = ref1.request;
    (0,react.useEffect)(function() {
        settingsRequest("get");
        openingTimesRequest("get");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        settings: settingsData || defaults.settings,
        openingTimes: openingTimesData || defaults.openingTimes,
        settingsLoaded: !!settingsData
    };
};


;// CONCATENATED MODULE: ../../frontend/entities/src/SiteInfo/context.tsx



var SiteInfoContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var SiteInfoProvider = function SiteInfoProvider(param) {
    var children = param.children;
    var siteInfo = useGetSiteInfo();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SiteInfoContext.Provider, {
        value: siteInfo,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/SiteInfo/hooks/useSiteInfo.ts


var useSiteInfo = function useSiteInfo() {
    var context = (0,react.useContext)(SiteInfoContext);
    if (context === undefined) {
        throw new Error("useSiteInfo must be used within a SiteInfoContext Provider");
    }
    return context;
};


;// CONCATENATED MODULE: ../../frontend/entities/src/SiteInfo/index.ts



;// CONCATENATED MODULE: ../../frontend/entities/src/Header/InfolinePopover/InfolinePopover.tsx





var HIDE_PHONE_NUMBER_FOR_BRAND = {
    floyt: false,
    "billiger-mietwagen": true,
    carigami: false
};
var InfolinePopover = function InfolinePopover(param) {
    var popupContent = param.popupContent;
    var ref = useSiteInfo(), _settings = ref.settings, phoneNumber = _settings.phoneNumber, language = _settings.language;
    var isHomepage = usePath().isHomepage;
    var brandName = useBrand().brandName;
    var hidePhoneNumber = isHomepage || HIDE_PHONE_NUMBER_FOR_BRAND[brandName];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneInfoPopoverWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Popover */.Ui.J2, {
            button: {
                as: "div",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneNumberWrapperSection, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneNumber, {
                        phoneNumber: hidePhoneNumber ? "" : phoneNumber,
                        language: language,
                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactIcon, {})
                    })
                })
            },
            triggerAction: "click",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PopoverPanel */.Ui.Hi, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PanelContentWrapper */.Ui.Ut, {
                    width: "14rem",
                    widthMd: "21.875rem",
                    padding: "1.5rem 0 0 0",
                    children: popupContent
                })
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/InfolinePopover/index.ts


// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js + 1 modules
var emotion_element_43c6fea0_browser_esm = __webpack_require__(7216);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Checked.js
var Checked = __webpack_require__(1691);
var Checked_default = /*#__PURE__*/__webpack_require__.n(Checked);
;// CONCATENATED MODULE: ../../frontend/entities/src/Header/MembershipPopover/driver_illustration.png
/* harmony default export */ var driver_illustration = ({"src":"/_next/static/media/driver_illustration.735ff1f8.png","height":150,"width":185,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAArklEQVR42mMAgU///zMxQMG6//8ZYeyCY7sYGR5AJRNXzrfP3r9lb/aeTbdzD2ztjF0+B66Q4cHZCwZTtm/8n7Fv8/+cvZv+Z+3e+D/v8I5iuILnT54uXbd39//CtUu/p2xa8S1j+5r/qRuXb4PJi18+d37yjtMn/rosmfk/Y/3S/6mbVvz3qCopA8opghRETJ0yZc/SFSvWuk7ubElauWClf0dDKR8DQ522rZUSALz5VFSARG3MAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ../../frontend/entities/src/Header/MembershipPopover/MembershipPopover.styles.ts



var BenefitsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt0"
}, "target", "e1ks8bpt0"))("color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";justify-content:space-between;margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";");
var BenefitText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* TertiaryText */.Q1, (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt1"
}, "target", "e1ks8bpt1"))("padding-left:10px;font-weight:400;text-transform:none;");
var BenefitWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt2"
}, "target", "e1ks8bpt2"))("display:flex;padding:5px 0;");
var ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt3"
}, "target", "e1ks8bpt3"))("padding:10px;text-align:center;");
var JoinButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt4"
}, "target", "e1ks8bpt4"))("margin:0.5rem 0 1.5rem;");
var LinkWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt5"
}, "target", "e1ks8bpt5"))("margin:1rem 0 0;");
var MembershipWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ks8bpt6"
}, "target", "e1ks8bpt6"))("display:flex;flex-direction:column;padding:0 1rem;", src/* Theme.mq */.Q2.mq("lg"), "{padding:1.5rem 1rem;}");


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/MembershipPopover/MembershipPopover.tsx









var BenefitItem = function BenefitItem(param) {
    var benefit = param.benefit;
    var theme = (0,emotion_element_43c6fea0_browser_esm.u)();
    return benefit && benefit !== "" && benefit !== "null" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BenefitWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((Checked_default()), {
                width: "24px",
                fill: theme.color.primary
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BenefitText, {
                inline: true,
                children: benefit
            }, benefit)
        ]
    }) : null;
};
var MembershipPopover = function MembershipPopover(param) {
    var handleLoginClick = param.handleLoginClick, handleSignUpClick = param.handleSignUpClick, _translations = param.translations, welcomeSubtitle = _translations.welcomeSubtitle, loginButton = _translations.loginButton, joinButton = _translations.joinButton, benefitsSubtitle = _translations.benefitsSubtitle, benefits = _translations.benefits, moreInfoLink = _translations.moreInfoLink;
    var onJoinClick = function onJoinClick() {
        trackNewUser({
            isLoggedIn: false
        });
        handleSignUpClick();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MembershipWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Subtitle */.QE, {
                as: "p",
                children: welcomeSubtitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: driver_illustration,
                    objectFit: "contain",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                onClick: handleLoginClick,
                children: loginButton
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JoinButton, {
                onClick: onJoinClick,
                variant: "secondary",
                children: joinButton
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Subtitle */.QE, {
                children: benefitsSubtitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BenefitsWrapper, {
                children: benefits === null || benefits === void 0 ? void 0 : benefits.map(function(param) {
                    var benefit = param.benefit;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BenefitItem, {
                        benefit: benefit
                    }, benefit);
                })
            }),
            moreInfoLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, (0,src_object_spread/* default */.Z)({}, moreInfoLink))
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/MembershipPopover/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/OpeningTimes/OpeningTimes.styles.ts




var layout = function layout() {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;max-width:500px;display:flex;flex-direction:column;align-items:center;", src/* Theme.mq */.Q2.mq("lg"), "{margin-left:1.5rem;margin-right:1.5rem;max-width:none;}> *{width:100%;}");
};
var OpeningTimes_styles_Anchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "ey1yccs0"
}, "target", "ey1yccs0"))("color:inherit;text-decoration:inherit;");
var OpeningTimesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs1"
}, "target", "ey1yccs1"))("display:flex;flex-direction:column;align-items:center;");
var InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs2"
}, "target", "ey1yccs2"))(layout(), ";padding-left:1rem;padding-right:1rem;row-gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";");
var InteractivePhoneNumber = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* InteractiveText */.G9, (0,src_define_property/* default */.Z)({
    target: "ey1yccs3"
}, "target", "ey1yccs3"))("margin-top:1.5rem;text-align:center;font-size:24px;", src/* Theme.mq */.Q2.mq("lg"), "{margin-top:1rem;}");
var OpeningHours = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs4"
}, "target", "ey1yccs4"))("padding-bottom:", function(param) {
    var showVoucherInfo = param.showVoucherInfo;
    return !showVoucherInfo && "2rem";
}, ";max-width:222px;align-self:center;");
var Information = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs5"
}, "target", "ey1yccs5"))("margin-top:0.5rem;");
var ScheduleRow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs6"
}, "target", "ey1yccs6"))("color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";font-weight:", function(param) {
    var type = param.type;
    return type === "common" && "bold";
}, ";font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.sm.size;
}, ";display:grid;grid-template-columns:minmax(0,1fr) max-content;");
var Footer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs7"
}, "target", "ey1yccs7"))(layout(), ";background-color:#f5f5f5;margin-top:2.5rem;padding:1.5rem 1rem;", src/* Theme.mq */.Q2.mq("lg"), "{margin-top:2rem;}");
var VoucherWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ey1yccs8"
}, "target", "ey1yccs8"))("text-align:center;max-width:500px;");
var VoucherText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* SecondaryText */.MQ, (0,src_define_property/* default */.Z)({
    target: "ey1yccs9"
}, "target", "ey1yccs9"))("margin-top:1rem;");


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/OpeningTimes/email.png
/* harmony default export */ var email = ({"src":"/_next/static/media/email.b66dca94.png","height":150,"width":185,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAtklEQVR42mOAgaZjezRLDm63hPGX3bzIBJeM27epPXrfpv9Zh7f/Lzi47XDHhlUyIPH6q6cYGQL2rLftOXXw/6qzx/9X7lj/r/zg9v+vXr/+//zZs0KI9kUTXU7fvfX/2b37v0+fOfN3zvbNv969e/f/y5cv3jAbGN++f3f/xcuX/3/8+PH/7p07/+bOm/ff389vGkwBy4MHD7pfvXq14d79+3u3bd/+68iRI/8rKipuMzAwcAAABr5mLhPKPd8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ../../frontend/entities/src/Header/OpeningTimes/call.png
/* harmony default export */ var call = ({"src":"/_next/static/media/call.eaf4a321.png","height":150,"width":185,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAq0lEQVR42mMAgbaHVxlBdN3FY/IdD6/aNn9/wQbiF53az8RQeHgHM4hTdnJfRuqOtb+c+lr+F+zZdL3s9H4FBhioPbBdJOHg1t/ly+b/b8sp/CnbUfs/7/T+hXAF0ZePijfu3vx92rIl/1+/fftz+4Uz/9tP7F/GgAzuP32y5NnbN/+h4PWta9ctwRIh4WHsQEqktrpa4fLFiwnnzp2rW7V2rRFQjD82NlYMAIQEV1sdAz6LAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ../../frontend/entities/src/Header/OpeningTimes/Schedule.tsx





var Schedule = function Schedule(param) {
    var showVoucherInfo = param.showVoucherInfo;
    var ref = useSiteInfo(), language = ref.settings.language, openingTimes = ref.openingTimes;
    var locale = src/* datetime.dateLocales */.t2.Z[language];
    var ref1 = (0,src_sliced_to_array/* default */.Z)([
        1,
        5,
        6,
        0
    ].map(function(day) {
        return locale.localize.day(day, {
            width: "abbreviated"
        });
    }), 4), monday = ref1[0], friday = ref1[1], saturday = ref1[2], sunday = ref1[3];
    var commonSchedule = Object.entries(openingTimes.common).map(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], hours = _param[1];
        if (typeof hours === "undefined") {
            return undefined;
        }
        var open = hours.open, close = hours.close;
        var days;
        switch(key){
            case "always":
                days = "".concat(monday, " - ").concat(sunday);
                break;
            case "weekdays":
            case "workdays":
                days = "".concat(monday, " - ").concat(friday);
                break;
            case "weekends":
                days = "".concat(saturday, " - ").concat(sunday);
                break;
            case "saturday":
                days = saturday;
                break;
            case "sunday":
                days = sunday;
                break;
            default:
                days = key;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ScheduleRow, {
            type: "common",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: days
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    children: [
                        open,
                        " - ",
                        close
                    ]
                })
            ]
        }, key);
    }).filter(Boolean);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpeningHours, {
        textColor: "grey",
        showVoucherInfo: showVoucherInfo,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Information, {
            children: openingTimes.common ? commonSchedule : null
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/Header/OpeningTimes/OpeningTimes.tsx









var OpeningTimes_defaultProps = {
    showHeader: true,
    showNumber: true,
    showVoucherInfo: false
};
var OpeningTimes = function OpeningTimes(param) {
    var showVoucherInfo = param.showVoucherInfo, showHeader = param.showHeader, showNumber = param.showNumber, _translations = param.translations, buttonHref = _translations.buttonHref, buttonLabel = _translations.buttonLabel, voucher = _translations.voucher, title = _translations.title;
    var ref = useSiteInfo(), _settings = ref.settings, phoneNumber = _settings.phoneNumber, language = _settings.language;
    var formattedNumber = src/* String.parsePhoneNumber */.Ld.parsePhoneNumber(phoneNumber, language);
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat(src/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OpeningTimesWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoWrapper, {
                children: [
                    showHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Subtitle */.QE, {
                        as: "p",
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        src: email,
                        objectFit: "contain",
                        alt: "Email",
                        height: 150
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                        href: buttonHref,
                        variant: "primary",
                        fullWidth: true,
                        target: "_blank",
                        children: buttonLabel
                    }),
                    showNumber && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                src: call,
                                objectFit: "contain",
                                alt: "Email",
                                height: 150
                            }),
                            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InteractivePhoneNumber, {
                                textColor: "green",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpeningTimes_styles_Anchor, {
                                    href: formattedNumber.url,
                                    children: formattedNumber.international
                                })
                            }),
                            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                                href: formattedNumber.url,
                                variant: "secondary",
                                fullWidth: true,
                                children: formattedNumber.international
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Schedule, {
                                showVoucherInfo: showVoucherInfo
                            })
                        ]
                    })
                ]
            }),
            showVoucherInfo && voucher && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VoucherWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                            href: "/voucher.html",
                            rel: "nofollow",
                            variant: "secondary",
                            fullWidth: true,
                            children: voucher.buttonLabel
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VoucherText, {
                            textColor: "grey",
                            children: voucher.text
                        })
                    ]
                })
            })
        ]
    });
};
OpeningTimes.defaultProps = OpeningTimes_defaultProps;


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/OpeningTimes/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/Header/index.ts





// EXTERNAL MODULE: ../../node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(6883);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useEvent.js


var defaultTarget = util/* isBrowser */.jU ? window : null;
var isListenerType1 = function (target) {
    return !!target.addEventListener;
};
var isListenerType2 = function (target) {
    return !!target.on;
};
var useEvent = function (name, handler, target, options) {
    if (target === void 0) { target = defaultTarget; }
    (0,react.useEffect)(function () {
        if (!handler) {
            return;
        }
        if (!target) {
            return;
        }
        if (isListenerType1(target)) {
            (0,util.on)(target, name, handler, options);
        }
        else if (isListenerType2(target)) {
            target.on(name, handler, options);
        }
        return function () {
            if (isListenerType1(target)) {
                (0,util/* off */.S1)(target, name, handler, options);
            }
            else if (isListenerType2(target)) {
                target.off(name, handler, options);
            }
        };
    }, [name, handler, target, JSON.stringify(options)]);
};
/* harmony default export */ var esm_useEvent = (useEvent);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useKey.js



var createKeyPredicate = function (keyFilter) {
    return typeof keyFilter === 'function'
        ? keyFilter
        : typeof keyFilter === 'string'
            ? function (event) { return event.key === keyFilter; }
            : keyFilter
                ? function () { return true; }
                : function () { return false; };
};
var useKey = function (key, fn, opts, deps) {
    if (fn === void 0) { fn = util/* noop */.ZT; }
    if (opts === void 0) { opts = {}; }
    if (deps === void 0) { deps = [key]; }
    var _a = opts.event, event = _a === void 0 ? 'keydown' : _a, target = opts.target, options = opts.options;
    var useMemoHandler = (0,react.useMemo)(function () {
        var predicate = createKeyPredicate(key);
        var handler = function (handlerEvent) {
            if (predicate(handlerEvent)) {
                return fn(handlerEvent);
            }
        };
        return handler;
    }, deps);
    esm_useEvent(event, useMemoHandler, target, options);
};
/* harmony default export */ var esm_useKey = (useKey);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useKeyPress.js


var useKeyPress = function (keyFilter) {
    var _a = (0,react.useState)([false, null]), state = _a[0], set = _a[1];
    esm_useKey(keyFilter, function (event) { return set([true, event]); }, { event: 'keydown' }, [state]);
    esm_useKey(keyFilter, function (event) { return set([false, event]); }, { event: 'keyup' }, [state]);
    return state;
};
/* harmony default export */ var esm_useKeyPress = (useKeyPress);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useFirstMountState.js

function useFirstMountState() {
    var isFirst = (0,react.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useUpdateEffect.js


var useUpdateEffect = function (effect, deps) {
    var isFirstMount = useFirstMountState();
    (0,react.useEffect)(function () {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};
/* harmony default export */ var esm_useUpdateEffect = (useUpdateEffect);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useKeyPressEvent.js


var useKeyPressEvent = function (key, keydown, keyup, useKeyPress) {
    if (useKeyPress === void 0) { useKeyPress = esm_useKeyPress; }
    var _a = useKeyPress(key), pressed = _a[0], event = _a[1];
    esm_useUpdateEffect(function () {
        if (!pressed && keyup) {
            keyup(event);
        }
        else if (pressed && keydown) {
            keydown(event);
        }
    }, [pressed]);
};
/* harmony default export */ var esm_useKeyPressEvent = (useKeyPressEvent);

;// CONCATENATED MODULE: ../../frontend/entities/src/keyNavigation/useKeyNavigation.ts


var revealFocused = function revealFocused(parent, child) {
    if (!child || !parent) {
        return;
    }
    var itemOffsetRelativeToParent = child.offsetParent === parent ? child.offsetTop : child.offsetTop - parent.offsetTop;
    var scrollTop = parent.scrollTop;
    // Top not visible
    if (itemOffsetRelativeToParent < scrollTop) {
        scrollTop = itemOffsetRelativeToParent;
    }
    // Bottom not visible
    if (itemOffsetRelativeToParent + child.offsetHeight > scrollTop + parent.offsetHeight) {
        scrollTop = itemOffsetRelativeToParent + child.offsetHeight - parent.offsetHeight;
    }
    if (scrollTop !== parent.scrollTop) {
        parent.scrollTo({
            top: scrollTop
        });
    }
};
var useKeyNavigation = function useKeyNavigation(items, listRef, handleEnter) {
    var ref = (0,react.useState)(0), focusedItem = ref[0], setFocusedItem = ref[1];
    var ignoreMouse = (0,react.useRef)(false);
    var up = function up() {
        setFocusedItem(function(item) {
            if (item === null) {
                return 0;
            }
            if (item === 0) {
                return items.length - 1;
            }
            return item - 1;
        });
    };
    var down = function down() {
        setFocusedItem(function(item) {
            if (item === null || item === items.length - 1) {
                return 0;
            }
            return item + 1;
        });
        return 0;
    };
    var navigate = function navigate(directionHandler) {
        ignoreMouse.current = true;
        directionHandler();
        setTimeout(function() {
            ignoreMouse.current = false;
        }, 100);
    };
    esm_useKey("ArrowUp", function() {
        navigate(up);
    });
    esm_useKey("ArrowDown", function() {
        navigate(down);
    });
    esm_useKeyPressEvent("Enter", function(e) {
        if (focusedItem === null) {
            return;
        }
        e.preventDefault();
        handleEnter(items[focusedItem]);
    });
    (0,react.useEffect)(function() {
        var parent = listRef.current;
        var child = focusedItem !== null ? parent === null || parent === void 0 ? void 0 : parent.children[focusedItem] : null;
        revealFocused(parent, child);
    }, [
        listRef,
        focusedItem
    ]);
    var onMouseEnter = function onMouseEnter(index) {
        if (!ignoreMouse.current) {
            setFocusedItem(index);
        }
    };
    var onMouseLeave = function onMouseLeave() {
        if (!ignoreMouse.current) {
            setFocusedItem(null);
        }
    };
    return {
        focusedItem: focusedItem,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
};


;// CONCATENATED MODULE: ../../frontend/entities/src/keyNavigation/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/BrandLogo/BrandLogo.styled.ts



var StyledLogo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.Logo */.Ui.TR, (0,src_define_property/* default */.Z)({
    target: "e6i4eyv0"
}, "target", "e6i4eyv0"))("fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";");


;// CONCATENATED MODULE: ../../frontend/entities/src/BrandLogo/brands/FloytLogo.tsx






var viewBoxConfiguration = {
    withClaim: "0 0 150 54",
    withoutClaim: "0 0 150 37"
};
var FloytLogo_defaultProps = {
    responsive: false,
    withClaim: false
};
var FloytLogo = function FloytLogo(_param) {
    var withClaim = _param.withClaim, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "withClaim"
    ]);
    var viewBox = viewBoxConfiguration[withClaim ? "withClaim" : "withoutClaim"];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLogo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: viewBox,
        title: "FLOYT"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M149.499 3.729c0 2.029-1.64 3.64-3.55 3.64h-6.892a.942.942 0 0 0-.954.955l.03 24.255a4.03 4.03 0 0 1-4.028 4.028l-.03.029c-2.237 0-3.998-1.849-3.998-4.057l-.029-24.255a.943.943 0 0 0-.955-.955h-9.786c-.447 0-.865.209-1.133.567 0 0-10.502 14.112-10.532 14.171-.269.358-.269.686-.269 1.074v9.428a4.029 4.029 0 0 1-4.027 4.027c-2.208 0-3.998-1.819-3.998-4.027v-9.428c0-.388-.119-.775-.358-1.074L88.22 7.906a1.414 1.414 0 0 0-1.134-.567H68.858c-11.457 0-13.038 13.336-8.145 18.229.328.418.059.984-.448.984h-7.697a.938.938 0 0 1-.865-.566C47.317 16.588 51.643.089 69.723.089h21.033c1.342 0 2.357.717 3.132 1.85.209.239 8.742 12.083 8.742 12.083a.934.934 0 0 0 1.521 0s8.682-12.202 9.01-12.53a3.678 3.678 0 0 1 2.894-1.403h29.805a3.654 3.654 0 0 1 3.639 3.64Zm-64.292 6.594c.387 0 .716.209.865.596 4.654 12.59-2.894 25.688-17.692 25.688H34.429a4.03 4.03 0 0 1-4.028-4.028V8.354a.943.943 0 0 0-.955-.955H9.338a.943.943 0 0 0-.955.955v5.877c0 .537.418.955.955.955h8.622a3.635 3.635 0 0 1 3.64 3.639 3.635 3.635 0 0 1-3.64 3.64H9.368a.943.943 0 0 0-.955.955v9.219a4.03 4.03 0 0 1-4.027 4.027 4.03 4.03 0 0 1-4.028-4.027V4.147A4.03 4.03 0 0 1 4.386.119h30.252c.924 0 1.76.329 2.386.866a4.009 4.009 0 0 1 1.492 3.132v24.345c0 .537.418.955.955.955h28.76c10.86 0 13.843-11.099 8.831-18.14a.575.575 0 0 1 .447-.954h7.698Z"
            }),
            withClaim && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M3.252 49.246.448 45.497a1.204 1.204 0 0 1-.15-.268c-.029-.09-.029-.179-.029-.239 0-.209.089-.358.238-.477a.73.73 0 0 1 .478-.179c.208 0 .387.089.537.298l2.476 3.395 2.327-3.335c.149-.269.358-.388.567-.388.179 0 .328.06.447.209a.593.593 0 0 1 .209.477c0 .06 0 .149-.03.209s-.059.149-.089.209l-2.834 4.001v3.547c0 .209-.06.358-.209.477a.607.607 0 0 1-.448.179.673.673 0 0 1-.477-.179.7.7 0 0 1-.209-.477v-3.71Zm11.576.876c0 .716-.15 1.342-.478 1.879a3.44 3.44 0 0 1-1.253 1.283 3.65 3.65 0 0 1-1.79.477c-.656 0-1.253-.149-1.79-.477a3.235 3.235 0 0 1-1.253-1.283c-.328-.537-.477-1.163-.477-1.879s.149-1.343.477-1.88c.328-.537.746-.985 1.253-1.283.537-.328 1.134-.477 1.79-.477.656 0 1.253.149 1.79.477a3.44 3.44 0 0 1 1.253 1.283c.328.537.478 1.164.478 1.88Zm-1.313 0c0-.478-.09-.895-.298-1.253-.209-.358-.448-.627-.776-.836-.328-.209-.686-.298-1.104-.298-.418 0-.776.089-1.104.298a2.4 2.4 0 0 0-.805.836c-.209.358-.299.775-.299 1.253 0 .477.09.895.299 1.253.208.358.447.656.805.835.328.209.716.298 1.104.298.388 0 .776-.089 1.104-.298.328-.209.597-.477.776-.835.179-.358.298-.776.298-1.253Zm7.996-3.491c.179 0 .328.06.477.179a.678.678 0 0 1 .179.477v3.491c0 .925-.269 1.641-.776 2.148-.507.507-1.223.776-2.178.776-.924 0-1.67-.269-2.177-.776-.508-.507-.776-1.223-.776-2.148v-3.491c0-.209.059-.358.179-.477a.678.678 0 0 1 .477-.179c.179 0 .328.06.478.179a.678.678 0 0 1 .179.477v3.491c0 .567.149 1.014.417 1.283.269.268.657.417 1.194.417.537 0 .924-.149 1.193-.417.268-.269.418-.716.418-1.283v-3.491c0-.209.059-.358.179-.477.179-.09.358-.179.537-.179Zm4.027 1.31c.058-.124.13-.244.209-.355.149-.209.328-.388.537-.567.209-.149.418-.269.686-.358.239-.09.508-.12.776-.12.239 0 .418.06.597.18.179.119.238.268.238.477 0 .239-.059.417-.179.537a.589.589 0 0 1-.417.179.912.912 0 0 1-.388-.09 1.007 1.007 0 0 0-.448-.089c-.179 0-.387.06-.566.149-.209.09-.358.239-.537.418-.15.179-.299.417-.388.656-.09.269-.149.537-.149.865v3.193c0 .208-.06.358-.179.477a.989.989 0 0 1-.448.119c-.209 0-.358-.059-.477-.179a.673.673 0 0 1-.179-.477v-5.609c0-.209.059-.358.179-.477a.673.673 0 0 1 .477-.179c.179 0 .328.059.477.179.12.119.179.298.179.477v.594Zm13.366 4.674a2.124 2.124 0 0 1-.448.43 2.768 2.768 0 0 1-.775.448 2.596 2.596 0 0 1-.955.179c-.597 0-1.163-.149-1.641-.477a3.72 3.72 0 0 1-1.163-1.283c-.269-.537-.418-1.164-.418-1.88s.149-1.342.418-1.879a3.153 3.153 0 0 1 1.133-1.283c.478-.329 1.015-.478 1.611-.478.388 0 .716.06 1.045.179.328.12.596.269.835.478.137.12.255.23.358.347v-3.003c0-.208.06-.358.179-.477.119-.03.268-.119.477-.119.209 0 .358.059.478.179a.678.678 0 0 1 .179.477v8.443c0 .209-.06.358-.179.478-.12.119-.269.179-.478.179-.209 0-.358-.06-.477-.179a.682.682 0 0 1-.179-.478v-.281Zm-2.059-.077c.418 0 .806-.119 1.104-.328.299-.209.567-.507.746-.865a2.73 2.73 0 0 0 .269-1.223c0-.448-.09-.866-.269-1.224-.179-.358-.418-.656-.746-.865-.328-.209-.686-.298-1.104-.298-.417 0-.775.089-1.074.298-.328.209-.566.507-.745.865-.18.358-.269.776-.269 1.224 0 .447.089.865.269 1.223.179.358.417.656.745.865.299.209.657.328 1.074.328Zm6.743-4.597c.058-.124.129-.244.209-.355.149-.209.328-.388.537-.567.209-.149.418-.269.686-.358.239-.09.507-.12.776-.12.239 0 .418.06.597.18.179.119.238.268.238.477 0 .239-.059.417-.179.537a.589.589 0 0 1-.417.179.912.912 0 0 1-.388-.09 1.01 1.01 0 0 0-.448-.089c-.179 0-.388.06-.567.149-.209.09-.358.239-.537.418a2.395 2.395 0 0 0-.388.656 2.643 2.643 0 0 0-.149.865v3.193c0 .208-.059.358-.179.477a.98.98 0 0 1-.447.119c-.209 0-.358-.059-.478-.179a.678.678 0 0 1-.179-.477v-5.609c0-.209.06-.358.179-.477a.677.677 0 0 1 .478-.179c.179 0 .328.059.477.179a.678.678 0 0 1 .179.477v.594Zm4.982-2.235c-.268 0-.447-.06-.567-.149-.119-.09-.179-.239-.179-.477v-.209c0-.209.06-.388.179-.478.12-.089.299-.119.567-.119.269 0 .448.06.567.149.119.09.179.239.179.448v.209c0 .238-.06.387-.179.477-.119.119-.298.149-.567.149Zm.686 7.22c0 .209-.059.358-.179.477-.119.12-.268.179-.477.179-.209 0-.358-.059-.477-.179a.673.673 0 0 1-.179-.477v-5.668c0-.209.059-.358.179-.478a.678.678 0 0 1 .477-.179c.209 0 .358.06.477.179.12.12.179.299.179.478v5.668Zm4.769-1.32 1.974-4.587c.119-.298.328-.448.597-.418.179 0 .328.06.447.179.119.12.179.269.179.418 0 .06 0 .119-.03.179s-.03.119-.059.149l-2.506 5.669c-.12.268-.299.417-.567.417-.12.03-.269 0-.388-.089-.12-.09-.239-.179-.299-.328l-2.506-5.669c-.029-.03-.029-.089-.059-.149-.03-.06-.03-.119-.03-.209 0-.119.06-.268.179-.388.06-.149.239-.209.418-.209.119 0 .268.03.387.12.12.059.209.179.269.328l1.994 4.587Zm5.483-1.097c.036.333.125.637.28.925.209.358.477.657.836.836.357.208.716.298 1.133.298.328 0 .597-.03.806-.09.209-.059.388-.149.537-.238.149-.09.268-.179.388-.269a.657.657 0 0 1 .387-.119c.179 0 .299.06.418.179a.495.495 0 0 1 .149.388c0 .209-.089.358-.298.537a2.638 2.638 0 0 1-.985.597 5.306 5.306 0 0 1-1.253.178c-.745 0-1.372-.149-1.909-.447a3.16 3.16 0 0 1-1.253-1.253c-.298-.537-.448-1.134-.448-1.82 0-.776.15-1.432.478-1.999.328-.567.716-.984 1.223-1.283a3.13 3.13 0 0 1 1.611-.447c.418 0 .835.089 1.223.268.388.179.746.418 1.044.716.299.299.537.657.716 1.074.179.418.269.866.269 1.343 0 .179-.09.328-.209.447a.673.673 0 0 1-.477.179h-4.666Zm.055-1.133h3.865v-.09c-.03-.298-.119-.567-.328-.805a1.722 1.722 0 0 0-.686-.537 2.162 2.162 0 0 0-.866-.209c-.268 0-.507.03-.775.119-.239.09-.448.209-.657.418-.179.179-.328.418-.447.746a2.154 2.154 0 0 0-.106.358Zm7.504 4.236c-.209 0-.388-.059-.507-.179-.119-.119-.179-.298-.179-.507v-.239c0-.209.06-.388.179-.507s.298-.179.507-.179h.149c.209 0 .388.06.507.179.12.119.179.298.179.507v.239c0 .209-.059.388-.179.507-.119.12-.268.179-.507.179h-.149Zm8.861-4.366-2.805-3.749c-.059-.089-.119-.179-.149-.268-.03-.09-.03-.179-.03-.239a.58.58 0 0 1 .239-.477.727.727 0 0 1 .477-.179c.209 0 .388.089.537.298l2.477 3.395 2.327-3.335c.179-.269.358-.388.567-.388.179 0 .328.06.447.209a.593.593 0 0 1 .209.477c0 .06 0 .149-.03.209s-.06.149-.089.209l-2.835 4.001v3.547c0 .209-.059.358-.208.477a.607.607 0 0 1-.448.179.673.673 0 0 1-.477-.179.7.7 0 0 1-.209-.477v-3.71Zm11.576.876c0 .716-.149 1.342-.478 1.879a3.44 3.44 0 0 1-1.253 1.283 3.646 3.646 0 0 1-1.79.477c-.656 0-1.253-.149-1.79-.477a3.242 3.242 0 0 1-1.253-1.283c-.328-.537-.477-1.163-.477-1.879s.149-1.343.477-1.88c.328-.537.746-.985 1.253-1.283.537-.328 1.134-.477 1.79-.477.657 0 1.253.149 1.79.477a3.44 3.44 0 0 1 1.253 1.283c.329.537.478 1.164.478 1.88Zm-1.313 0c0-.478-.089-.895-.298-1.253-.209-.358-.448-.627-.776-.836-.328-.209-.686-.298-1.104-.298-.417 0-.775.089-1.104.298a2.41 2.41 0 0 0-.805.836c-.209.358-.299.775-.299 1.253 0 .477.09.895.299 1.253.209.358.447.656.805.835.329.209.716.298 1.104.298.418 0 .776-.089 1.104-.298.328-.209.597-.477.776-.835.209-.358.298-.776.298-1.253Zm8.026-3.491c.179 0 .328.06.477.179a.678.678 0 0 1 .179.477v3.491c0 .925-.268 1.641-.776 2.148-.507.507-1.223.776-2.178.776-.924 0-1.67-.269-2.177-.776-.508-.507-.776-1.223-.776-2.148v-3.491c0-.209.059-.358.179-.477a.678.678 0 0 1 .477-.179c.179 0 .328.06.478.179a.677.677 0 0 1 .178.477v3.491c0 .567.15 1.014.418 1.283.269.268.657.417 1.194.417.537 0 .924-.149 1.193-.417.269-.269.418-.716.418-1.283v-3.491c0-.209.059-.358.179-.477.179-.09.328-.179.537-.179Zm3.997 1.31c.058-.124.129-.244.209-.355.149-.209.328-.388.537-.567.209-.149.418-.269.686-.358.239-.09.507-.12.776-.12.238 0 .417.06.597.18.179.119.238.268.238.477 0 .239-.059.417-.179.537a.59.59 0 0 1-.418.179.91.91 0 0 1-.387-.09 1.01 1.01 0 0 0-.448-.089c-.179 0-.388.06-.567.149-.209.09-.358.239-.537.418a2.395 2.395 0 0 0-.388.656 2.643 2.643 0 0 0-.149.865v3.193c0 .208-.059.358-.179.477a.799.799 0 0 1-.447.119c-.209 0-.358-.059-.478-.179a.678.678 0 0 1-.179-.477v-5.609c0-.209.06-.358.179-.477a.677.677 0 0 1 .478-.179c.179 0 .328.059.477.179a.678.678 0 0 1 .179.477v.594Zm11.397-1.459c.478 0 .895.059 1.283.149.358.089.656.239.865.418a.787.787 0 0 1 .299.626c0 .149-.03.299-.12.418-.089.119-.209.179-.388.179a1.07 1.07 0 0 1-.328-.06c-.089-.03-.149-.089-.238-.149-.09-.06-.15-.119-.269-.179a1.102 1.102 0 0 0-.447-.149c-.209-.03-.358-.06-.508-.06-.477 0-.865.12-1.223.328a2.505 2.505 0 0 0-.805.866 2.74 2.74 0 0 0-.299 1.223c0 .447.09.865.299 1.223.179.358.447.656.775.865a2.13 2.13 0 0 0 1.164.328c.268 0 .477-.03.656-.059.179-.03.328-.09.418-.15.149-.089.268-.149.358-.238.089-.09.209-.12.388-.12.209 0 .328.06.447.179.09.12.15.269.15.448 0 .209-.12.388-.359.567a2.958 2.958 0 0 1-.924.447c-.388.12-.836.179-1.313.179-.686 0-1.283-.149-1.79-.477a3.395 3.395 0 0 1-1.194-1.313 4.12 4.12 0 0 1-.417-1.849c0-.687.149-1.313.447-1.85.299-.537.687-.985 1.224-1.283.566-.358 1.163-.507 1.849-.507Zm5.371 1.235.059-.102c.149-.208.328-.387.537-.566.209-.179.448-.299.716-.418.239-.06.508-.119.806-.119.597 0 1.074.119 1.432.388.328.268.567.626.716 1.044.149.447.209.925.209 1.462v3.52c0 .209-.06.358-.179.477a.677.677 0 0 1-.478.179c-.208 0-.358-.059-.477-.179a.678.678 0 0 1-.179-.477v-3.52c0-.299-.03-.597-.119-.836a1.447 1.447 0 0 0-.418-.596c-.209-.15-.477-.239-.865-.239-.358 0-.656.089-.925.239a1.737 1.737 0 0 0-.627.596c-.149.239-.208.537-.208.836v3.52c0 .209-.06.358-.179.477a.677.677 0 0 1-.478.179c-.209 0-.358-.059-.477-.179a.678.678 0 0 1-.179-.477v-8.443c0-.209.06-.358.179-.477a.673.673 0 0 1 .477-.179c.179 0 .328.059.478.179a.678.678 0 0 1 .179.477v3.234Zm13.186 2.405c0 .716-.149 1.342-.478 1.879a3.44 3.44 0 0 1-1.253 1.283 3.646 3.646 0 0 1-1.79.477c-.656 0-1.253-.149-1.79-.477a3.242 3.242 0 0 1-1.253-1.283c-.328-.537-.477-1.163-.477-1.879s.149-1.343.477-1.88c.328-.537.746-.985 1.253-1.283.537-.328 1.134-.477 1.79-.477.657 0 1.253.149 1.79.477a3.44 3.44 0 0 1 1.253 1.283c.299.537.478 1.164.478 1.88Zm-1.343 0c0-.478-.089-.895-.298-1.253-.209-.358-.448-.627-.776-.836-.328-.209-.686-.298-1.104-.298-.417 0-.775.089-1.103.298a2.403 2.403 0 0 0-.806.836c-.209.358-.298.775-.298 1.253 0 .477.089.895.298 1.253.209.358.448.656.806.835.328.209.716.298 1.103.298.418 0 .776-.089 1.104-.298.328-.209.597-.477.776-.835.209-.358.298-.776.298-1.253Zm3.581-4.416c-.268 0-.447-.06-.567-.149-.119-.09-.179-.239-.179-.477v-.209c0-.209.06-.388.179-.478.12-.089.299-.119.567-.119.269 0 .448.06.567.149.119.09.179.239.179.448v.209c0 .238-.06.387-.179.477-.09.119-.298.149-.567.149Zm.686 7.22c0 .209-.059.358-.179.477-.119.12-.268.179-.477.179-.209 0-.358-.059-.478-.179a.678.678 0 0 1-.179-.477v-5.668c0-.209.06-.358.179-.478a.682.682 0 0 1 .478-.179c.209 0 .358.06.477.179.12.12.179.299.179.478v5.668Zm5.072-6.444c.477 0 .895.059 1.283.149.358.089.656.239.865.418a.786.786 0 0 1 .298.626.682.682 0 0 1-.119.418c-.089.119-.209.179-.388.179a1.07 1.07 0 0 1-.328-.06c-.089-.03-.149-.089-.239-.149-.089-.06-.149-.119-.268-.179a1.108 1.108 0 0 0-.448-.149c-.208-.03-.358-.06-.507-.06-.477 0-.865.12-1.223.328a2.508 2.508 0 0 0-.806.866 2.74 2.74 0 0 0-.298 1.223c0 .447.09.865.298 1.223a2.127 2.127 0 0 0 1.94 1.193c.268 0 .477-.03.656-.059.179-.03.328-.09.418-.15.149-.089.268-.149.358-.238.089-.09.209-.12.388-.12.208 0 .328.06.447.179.09.12.149.269.149.448 0 .209-.119.388-.358.567a2.953 2.953 0 0 1-.925.447c-.387.12-.835.179-1.312.179-.687 0-1.283-.149-1.79-.477a3.387 3.387 0 0 1-1.194-1.313 4.12 4.12 0 0 1-.417-1.849c0-.687.149-1.313.447-1.85.298-.537.686-.985 1.223-1.283.567-.358 1.164-.507 1.85-.507Zm4.851 4.027c.036.333.126.637.28.925.209.358.478.657.836.836.358.208.716.298 1.133.298.329 0 .597-.03.806-.09.209-.059.388-.149.537-.238.149-.09.269-.179.388-.269a.658.658 0 0 1 .388-.119.54.54 0 0 1 .417.179c.12.119.15.239.15.388 0 .209-.09.358-.299.537a2.633 2.633 0 0 1-.984.597c-.418.149-.806.178-1.253.178-.746 0-1.373-.149-1.91-.447a3.166 3.166 0 0 1-1.253-1.253c-.298-.537-.447-1.134-.447-1.82 0-.776.149-1.432.477-1.999.328-.567.716-.984 1.223-1.283a3.13 3.13 0 0 1 1.611-.447c.448 0 .836.089 1.224.268a3.64 3.64 0 0 1 1.044.716c.298.299.537.657.716 1.074.179.418.268.866.268 1.343a.63.63 0 0 1-.209.447.673.673 0 0 1-.477.179h-4.666Zm.055-1.133h3.865v-.09c-.03-.298-.119-.567-.328-.805a1.722 1.722 0 0 0-.686-.537 2.161 2.161 0 0 0-.865-.209c-.269 0-.508.03-.776.119-.239.09-.448.209-.656.418a1.98 1.98 0 0 0-.448.746 2.254 2.254 0 0 0-.106.358Zm7.505 4.236c-.209 0-.388-.059-.507-.179-.12-.119-.179-.298-.179-.507v-.239c0-.209.059-.388.179-.507.119-.119.298-.179.507-.179h.149c.209 0 .388.06.507.179.12.119.179.298.179.507v.239c0 .209-.059.388-.179.507-.119.12-.268.179-.507.179h-.149Z"
            })
        ]
    }));
};
FloytLogo.defaultProps = FloytLogo_defaultProps;


;// CONCATENATED MODULE: ../../frontend/entities/src/BrandLogo/brands/BMLogo.tsx






var BMLogo_viewBoxConfiguration = {
    default: "0 0 615 63",
    stacked: "0 0 337 58.7"
};
var BMLogo_defaultProps = {
    withClaim: false,
    responsive: false
};
var BMLogo = function BMLogo(_param) {
    var withClaim = _param.withClaim, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "withClaim"
    ]);
    var viewBox = BMLogo_viewBoxConfiguration[withClaim ? "default" : "stacked"];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLogo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: viewBox,
        title: "billiger-mietwagen.de"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.5 37.26c.33.43.04 1.1-.53 1.1h-8.72a1.1 1.1 0 0 1-1-.63C4.03 23.51 12.55 8.71 29.2 8.66h28.23A8.66 8.66 0 0 0 48.8.56H8.67A8.66 8.66 0 0 0 0 9.23V41.8h27.97c12.26 0 15.62-12.5 9.91-20.45-.33-.43-.04-1.1.53-1.1h8.71c.43 0 .82.24 1.01.62 5.22 14.23-3.3 29.03-19.97 29.08H.03a8.66 8.66 0 0 0 8.65 8.1H48.8a8.67 8.67 0 0 0 8.67-8.67V16.8H29.4c-12.26 0-15.61 12.5-9.91 20.46Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M264.75 10.18h-.01c0 4.52-2.26 7.31-5.75 8.75l4.4 5.33c.61.78 1.02 1.44 1.02 2.42a2.95 2.95 0 0 1-3 2.92c-1.44 0-2.38-.7-3.12-1.64l-6.02-7.62a.5.5 0 0 0-.38-.19h-4.33a.48.48 0 0 0-.48.49v5.8A3.1 3.1 0 0 1 244 29.6c-1.8.05-3.25-1.52-3.25-3.31V9.61c0-.35.28-.64.64-.64h5.05c.35 0 .64.29.64.64v4.48c0 .27.22.48.48.48h5.93c3.07 0 4.84-1.64 4.84-4.06v-.09c0-2.71-1.88-4.1-4.96-4.1l-33.59.15a.49.49 0 0 0-.48.48v4.9c0 .28.22.5.5.5l10.56-.2a2.86 2.86 0 0 1 2.85 2.87 2.83 2.83 0 0 1-2.85 2.81l-10.58.19a.48.48 0 0 0-.48.48v4.93c0 .27.22.49.48.49h12.65c1.66 0 3 1.42 2.84 3.12a2.9 2.9 0 0 1-2.93 2.55h-16.18a3.2 3.2 0 0 1-3.2-3.2V3.8a3.2 3.2 0 0 1 3.2-3.18h37.74c3.66 0 6.49 1.02 8.38 2.91 1.6 1.61 2.46 3.87 2.46 6.58v.08ZM102.4 3.44c0-1.79 1.41-3.2 3.2-3.2a3.16 3.16 0 0 1 3.18 3.2v23.1c0 1.78-1.4 3.2-3.19 3.2a3.18 3.18 0 0 1-3.19-3.2V3.44Zm12.01 0a3.17 3.17 0 0 1 3.1-3.2c1.73-.05 3.28 1.54 3.28 3.35V23.2c0 .26.21.48.48.48h11.18c1.64 0 3.08 1.34 3.04 2.97a2.88 2.88 0 0 1-2.9 2.83H117.6a3.2 3.2 0 0 1-3.19-3.2V3.45Zm26.42 0a3.17 3.17 0 0 1 3.1-3.2c1.8-.04 3.27 1.54 3.27 3.35V23.2c0 .26.22.48.49.48h11.18c1.64 0 3.08 1.34 3.04 2.97a2.88 2.88 0 0 1-2.9 2.83h-14.99a3.2 3.2 0 0 1-3.19-3.2V3.45Zm26.5 0c0-1.79 1.4-3.2 3.18-3.2 1.79 0 3.2 1.41 3.2 3.2v23.1c0 1.78-1.41 3.2-3.2 3.2a3.18 3.18 0 0 1-3.19-3.2V3.44Zm11.71 11.63v-.08c0-8.24 6.42-14.99 15.2-14.99 4.39 0 7.29 1 9.9 2.82.65.47 1.39 1.4 1.32 2.73a3.2 3.2 0 0 1-3.34 2.98 3.11 3.11 0 0 1-1.74-.66 10.19 10.19 0 0 0-6.34-1.99c-4.64 0-8.32 4.1-8.32 9.03V15c0 5.3 3.65 9.2 8.78 9.2 2.22 0 4.21-.53 5.79-1.6a.48.48 0 0 0 .2-.4v-3.4a.49.49 0 0 0-.47-.49h-3.76a2.8 2.8 0 0 1-2.83-2.49 2.77 2.77 0 0 1 2.76-3.02h7.29a3.2 3.2 0 0 1 3.19 3.2v7.03a4.3 4.3 0 0 1-2.24 4.06 19.28 19.28 0 0 1-10.14 2.9c-9.03 0-15.24-6.34-15.24-14.91h-.01Zm90.93 2.44a2.96 2.96 0 0 1 2.95-2.94h12.35a2.96 2.96 0 0 1 2.95 2.94 2.96 2.96 0 0 1-2.95 2.95h-12.35a2.96 2.96 0 0 1-2.95-2.95ZM72.3.95c0-.26.22-.48.49-.48h13.04c3.33 0 5.95.91 7.61 2.58a6.68 6.68 0 0 1 2 4.95v.08a6.7 6.7 0 0 1-3.54 6.12c-.11.07-.1.24.03.3 3.19 1.29 5.14 3.24 5.14 7.03v.08c0 5.33-4.33 7.99-10.9 7.99H72.79a.49.49 0 0 1-.48-.49V.95Zm13.86 23.03c2.83 0 4.54-1 4.54-3.17v-.08c0-1.95-1.46-3.16-4.74-3.16h-6.93a.49.49 0 0 0-.48.48v5.44c0 .27.22.49.48.49h7.13Zm-1.7-11.73c2.82 0 4.61-.91 4.61-3.08v-.09c0-1.9-1.5-3-4.2-3h-5.85a.49.49 0 0 0-.48.5v5.19c0 .27.22.48.48.48h5.43Z",
                transform: withClaim ? undefined : "translate(9, 0.6) scale(0.83)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M293.08 3.64a3.2 3.2 0 0 1 3.19-3.2h.7a3.3 3.3 0 0 1 2.9 1.66l7.52 12.24c.08.14.28.14.37 0l7.56-12.28a3.12 3.12 0 0 1 2.86-1.61h.7a3.2 3.2 0 0 1 3.2 3.19v22.91c0 1.5-1 2.88-2.47 3.22a3.17 3.17 0 0 1-3.88-3.11V12.4c0-.05-.07-.08-.1-.03l-5.49 8.45c-.66 1-1.49 1.61-2.65 1.61-1.17 0-1.99-.62-2.66-1.61l-5.4-8.32c-.03-.05-.1-.03-.1.03v14.02c0 1.78-1.46 3.34-3.23 3.3a3.03 3.03 0 0 1-3.03-3.1V3.63Zm34.47-.09a3.17 3.17 0 0 1 3.2-3.19c1.77 0 3.18 1.4 3.18 3.2v23.1c0 1.78-1.4 3.19-3.19 3.19a3.17 3.17 0 0 1-3.19-3.2V3.56Zm11.72 22.87V3.8a3.2 3.2 0 0 1 3.19-3.19h15.93c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.08H346.1a.48.48 0 0 0-.49.48v4.92c0 .26.22.48.49.48h10.45c1.5 0 2.83 1.11 2.96 2.6a2.83 2.83 0 0 1-2.84 3.08h-10.58a.49.49 0 0 0-.48.48v5.12c0 .27.22.49.49.49h12.51c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.07h-16.27a3.2 3.2 0 0 1-3.2-3.2Zm35.6-20.13h-5.54a3 3 0 0 1-2.97-2.28 2.95 2.95 0 0 1 2.86-3.6h18.54a3 3 0 0 1 2.96 2.28 2.95 2.95 0 0 1-2.86 3.6h-5.65a.48.48 0 0 0-.48.49V26.3c0 1.8-1.48 3.39-3.28 3.34a3.12 3.12 0 0 1-3.1-3.19V6.78a.49.49 0 0 0-.48-.49Zm81.08 8.9v-.09c0-8.24 6.42-14.98 15.2-14.98 4.39 0 7.29.99 9.9 2.81.65.48 1.39 1.4 1.32 2.74a3.16 3.16 0 0 1-5.1 2.32A10.15 10.15 0 0 0 470.94 6c-4.64 0-8.32 4.1-8.32 9.03v.08c0 5.3 3.65 9.2 8.78 9.2 2.21 0 4.2-.54 5.79-1.6a.48.48 0 0 0 .2-.4v-3.4a.48.48 0 0 0-.48-.5h-3.75a2.8 2.8 0 0 1-2.83-2.48 2.77 2.77 0 0 1 2.76-3.02h7.29a3.2 3.2 0 0 1 3.19 3.19v7.03c0 1.87-.71 3.15-2.24 4.06a19.27 19.27 0 0 1-10.14 2.9c-9.03 0-15.24-6.33-15.24-14.9Zm33.77 11.23V3.8A3.2 3.2 0 0 1 492.9.61h15.93c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.08h-12.43a.48.48 0 0 0-.49.48v4.92c0 .26.22.48.49.48h10.45c1.5 0 2.83 1.11 2.96 2.6a2.83 2.83 0 0 1-2.84 3.08h-10.57a.48.48 0 0 0-.49.48v5.12c0 .27.22.49.49.49h12.51c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.07H492.9a3.2 3.2 0 0 1-3.2-3.2Zm27.76-22.78a3.2 3.2 0 0 1 3.19-3.2h.66c1.53 0 2.44.76 3.31 1.87l11.43 15.01c.28.37.87.17.87-.29V3.64c0-1.65 1.2-3.1 2.84-3.27a3.14 3.14 0 0 1 3.45 3.14v23.07a3.2 3.2 0 0 1-3.2 3.19h-.2c-1.53 0-2.44-.75-3.3-1.87l-11.9-15.6a.48.48 0 0 0-.86.3v13.97c0 1.64-1.2 3.1-2.84 3.26a3.15 3.15 0 0 1-3.46-3.13V3.64Zm35.57 18.97c2.07 0 3.6 1.53 3.6 3.52v.09a3.5 3.5 0 0 1-3.6 3.52 3.49 3.49 0 0 1-3.6-3.52v-.09a3.49 3.49 0 0 1 3.6-3.52Zm7.54-18.94c0-1.78 1.41-3.2 3.2-3.2h8.12c9.12 0 15.42 6.27 15.42 14.44v.08c0 8.16-6.3 14.51-15.42 14.51h-8.13a3.16 3.16 0 0 1-3.19-3.19V3.67Zm11.32 20.06c5.22 0 8.75-3.52 8.75-8.67v-.08c0-5.14-3.53-8.75-8.75-8.75h-4.45a.48.48 0 0 0-.48.49v16.53c0 .26.21.48.48.48h4.45Zm20.76 2.57V3.67a3.2 3.2 0 0 1 3.2-3.2h15.95c1.5 0 2.84 1.12 2.97 2.61a2.83 2.83 0 0 1-2.85 3.08h-12.45a.48.48 0 0 0-.48.48v4.93c0 .26.21.48.48.48h10.46c1.5 0 2.84 1.1 2.97 2.6a2.83 2.83 0 0 1-2.85 3.08h-10.59a.48.48 0 0 0-.48.48v5.13c0 .27.22.49.48.49h12.53c1.5 0 2.85 1.1 2.98 2.6a2.83 2.83 0 0 1-2.85 3.08h-16.3a3.2 3.2 0 0 1-3.19-3.2h.02Zm-140.45-.11.01.01c.45 1.44-.21 3.07-1.61 3.63a2.88 2.88 0 0 1-3.84-1.8l-.63-2.04a719.6 719.6 0 0 0-1.66-5.3.49.49 0 0 0-.47-.35h-9.33a.47.47 0 0 1-.44-.66l1.25-4.26c.1-.32.39-.55.73-.55h5.72c.33 0 .56-.32.46-.63-1.17-3.52-2.19-6.38-2.62-7.1-.58-.87-2-.87-2-.87-.02 0-1.5 0-2.18.96-.5.81-1.66 4.8-2.76 8.67-.95 3.3-2.13 7.39-3.54 11.8-.42 1.34-1.86 2.42-3.23 2.34l-.28.02h-.66c-1.53 0-2.7-.95-3.27-2.61l-5.52-16.02a.21.21 0 0 0-.4 0l-5.5 16.02c-.6 1.66-1.75 2.6-3.28 2.6h-.66c-1.53 0-2.74-1-3.32-2.6l-8.11-22.78a3.94 3.94 0 0 1-.25-1.2c0-1.78 1.49-3.1 3.27-3.1a3.2 3.2 0 0 1 3.1 2.28l5.68 17.52c.02.07.13.07.15 0l5.72-17.36c.5-1.49 1.62-2.52 3.23-2.52h.5c1.62 0 2.73.99 3.23 2.52l5.71 17.35c.02.07.14.08.16 0 .28-.95 1.31-4.36 1.74-5.85 1.78-6.21 2.62-9.02 3.6-10.41 2.31-3.23 6.13-3.4 6.87-3.4 2.17 0 5.1.9 6.8 3.45 1.14 1.73 3.25 8.05 7.05 20.32l.6 1.9Z",
                transform: withClaim ? undefined : "translate(-174.2, 33.2) scale(0.83)"
            }),
            withClaim && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M78.23 43.92A5.39 5.39 0 0 1 82.69 46c.51.65.9 1.4 1.14 2.25.26.85.39 1.75.39 2.7 0 1.3-.24 2.48-.68 3.55a5.9 5.9 0 0 1-2.01 2.54 5.5 5.5 0 0 1-3.3.95h-4.9a1 1 0 0 1-1.03-1.03V44.94a1 1 0 0 1 1.03-1.03h4.9Zm-3.81 1.92v10.2h3.61v.01c.93 0 1.7-.23 2.3-.7a4 4 0 0 0 1.3-1.85 7.9 7.9 0 0 0 .18-4.48 5.07 5.07 0 0 0-.72-1.64 3.51 3.51 0 0 0-3.06-1.54h-3.61Zm13.94 7.4c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15a4.22 4.22 0 0 0 1.37-.8c.2-.12.4-.18.59-.18a.83.83 0 0 1 .86.84c0 .3-.15.57-.44.8-.36.35-.86.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.18.24-2.18.72-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.87.81 5.13 5.13 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.43.25-.7.25h-6.98Zm.06-1.7h5.8v-.15a2.2 2.2 0 0 0-.48-1.22 2.98 2.98 0 0 0-2.34-1.12c-.4 0-.79.06-1.16.19-.36.13-.69.33-.98.6a3.6 3.6 0 0 0-.84 1.69Zm18.4-4.13a1.02 1.02 0 0 1 1 1.03v5.29c0 1.4-.39 2.48-1.16 3.26a4.44 4.44 0 0 1-3.3 1.18c-1.43 0-2.52-.4-3.3-1.18a4.46 4.46 0 0 1-1.15-3.26v-5.29a1 1 0 0 1 1.03-1.03c.3 0 .52.1.71.3.2.2.3.44.3.73v5.29c0 .87.2 1.52.6 1.95.42.43 1.02.64 1.8.64.8 0 1.41-.21 1.82-.64.41-.43.61-1.08.61-1.95v-5.29a1 1 0 0 1 1.03-1.03Zm5.05 2h-1.1a.91.91 0 0 1-.67-.27.91.91 0 0 1-.27-.68c0-.26.08-.49.27-.66a.9.9 0 0 1 .67-.26h1.1v-1.6c0-.29.1-.53.3-.73a1 1 0 0 1 .72-.3v.01c.28 0 .53.1.71.3.2.2.28.44.28.73v1.59h1.61c.27 0 .5.08.68.27.18.18.27.4.27.67a.9.9 0 0 1-.27.67.93.93 0 0 1-.68.26h-1.6v5.87c0 .24.03.43.11.58.09.15.2.25.34.3.14.06.28.09.43.09a.9.9 0 0 0 .4-.09.96.96 0 0 1 .41-.08c.17 0 .3.08.44.22.14.15.2.35.2.6 0 .33-.17.59-.52.79-.34.2-.72.3-1.12.3-.23 0-.5-.02-.8-.06-.3-.05-.6-.15-.9-.3a1.91 1.91 0 0 1-.71-.78c-.2-.35-.3-.86-.3-1.5v-5.94Zm6.88 6.93c-.12-.19-.18-.4-.16-.65.01-.25.15-.46.42-.64a.9.9 0 0 1 .6-.15c.2.03.4.13.58.32a3.63 3.63 0 0 0 3.76 1.22c.29-.08.53-.22.73-.4.2-.2.3-.48.3-.86 0-.34-.11-.6-.32-.8-.22-.2-.5-.36-.85-.49a9.03 9.03 0 0 0-1.14-.36c-.43-.12-.86-.25-1.29-.4a5.4 5.4 0 0 1-1.17-.57 2.68 2.68 0 0 1-.86-.92 2.71 2.71 0 0 1-.32-1.38c0-.64.18-1.17.52-1.63.35-.45.81-.8 1.4-1.07a4.36 4.36 0 0 1 1.84-.38 5.37 5.37 0 0 1 2.5.62c.4.22.74.5 1.04.84.14.18.21.39.23.63.02.24-.09.46-.33.67a.76.76 0 0 1-.59.17.92.92 0 0 1-.56-.23 2.46 2.46 0 0 0-.99-.75 3.47 3.47 0 0 0-2.16-.15c-.27.07-.5.2-.7.38-.18.19-.27.46-.27.82 0 .34.1.6.33.8.22.21.51.37.88.5.36.14.75.26 1.18.37.42.1.83.23 1.24.38.4.15.78.34 1.1.57a2.65 2.65 0 0 1 1.13 2.3c0 .66-.2 1.22-.58 1.68a3.6 3.6 0 0 1-1.45 1.06c-.58.23-1.2.36-1.83.36-.76 0-1.53-.14-2.28-.42a4.25 4.25 0 0 1-1.92-1.43v-.01Zm15.22-9.16c.72 0 1.37.07 1.93.23.57.15 1 .36 1.32.64.32.27.47.59.47.95 0 .23-.06.44-.2.63-.14.2-.33.3-.6.3-.21 0-.37-.03-.5-.1a1.36 1.36 0 0 1-.34-.23c-.1-.1-.23-.2-.4-.27-.14-.1-.36-.17-.66-.22a4.9 4.9 0 0 0-.76-.06 3.3 3.3 0 0 0-3.04 1.78 3.94 3.94 0 0 0-.44 1.86c0 .69.15 1.32.44 1.87a3.21 3.21 0 0 0 2.95 1.79 3.86 3.86 0 0 0 1.62-.32c.22-.12.4-.25.53-.38.14-.13.34-.19.6-.19.29 0 .51.1.67.28a1 1 0 0 1 .23.67c0 .3-.18.58-.53.86-.36.27-.83.5-1.42.67-.59.18-1.24.26-1.97.26a4.86 4.86 0 0 1-4.49-2.7 6.13 6.13 0 0 1-.63-2.81c0-1.05.22-2 .66-2.83a5.09 5.09 0 0 1 1.84-1.96c.78-.48 1.7-.72 2.72-.72Zm8.06 1.91.1-.16a4.18 4.18 0 0 1 3.21-1.69c.93 0 1.65.2 2.16.59.5.4.87.92 1.07 1.6.21.67.32 1.4.32 2.2v5.34a1 1 0 0 1-1.01 1.02 1 1 0 0 1-1.03-1.02v-5.33a4 4 0 0 0-.19-1.28 1.93 1.93 0 0 0-.65-.93c-.3-.23-.74-.35-1.3-.35-.53 0-1 .12-1.4.35a2.48 2.48 0 0 0-1.28 2.2v5.34a1 1 0 0 1-1 1.02 1 1 0 0 1-1.04-1.02V44.14a1 1 0 0 1 1.03-1.03c.3 0 .52.1.71.3.2.2.3.43.3.73v4.95Zm12.12 7.88a1 1 0 0 1-1 1.02.97.97 0 0 1-.72-.29.97.97 0 0 1-.3-.73V44.14a1 1 0 0 1 .3-.73 1 1 0 0 1 .73-.3c.28 0 .53.1.71.3a1 1 0 0 1 .28.73v12.83Zm10.96-.4c-.18.24-.4.47-.67.68a4.7 4.7 0 0 1-1.18.68 4.48 4.48 0 0 1-3.96-.44 5.04 5.04 0 0 1-1.75-1.97 6.1 6.1 0 0 1-.65-2.83c0-1.06.22-2.04.65-2.87.43-.82 1-1.47 1.74-1.94.73-.47 1.54-.7 2.42-.7a4.5 4.5 0 0 1 3.4 1.5v-.4c0-.28.1-.53.27-.72.2-.2.43-.3.73-.3.29 0 .53.1.72.29.19.2.28.44.28.73v8.69c0 .29-.1.53-.28.73-.2.2-.43.3-.72.3a.99.99 0 0 1-1-1.03v-.4Zm-3.1-.23c.63 0 1.18-.16 1.66-.48.48-.32.86-.76 1.12-1.32.27-.56.4-1.18.4-1.86 0-.68-.13-1.3-.4-1.86a3 3 0 0 0-2.79-1.78 2.9 2.9 0 0 0-1.64.48c-.47.3-.85.74-1.12 1.3a4.17 4.17 0 0 0-.41 1.87c0 .7.13 1.3.41 1.85.27.56.65 1 1.12 1.32.48.32 1.02.49 1.64.49v-.01Zm10.23-7.3.13-.17a4.55 4.55 0 0 1 1.98-1.47 3.6 3.6 0 0 1 1.32-.23c.96 0 1.7.2 2.22.6.52.4.89.92 1.1 1.58.2.66.3 1.4.3 2.22v5.39a1 1 0 0 1-1 1.03 1 1 0 0 1-1.03-1.03v-5.37c0-.48-.06-.91-.2-1.3a1.84 1.84 0 0 0-.68-.91 2.36 2.36 0 0 0-1.37-.34 3 3 0 0 0-1.45.34 2.47 2.47 0 0 0-1.33 2.21v5.37a1 1 0 0 1-1 1.03c-.29 0-.54-.1-.74-.3a.97.97 0 0 1-.29-.73v-8.53a1 1 0 0 1 1.03-1.02 1 1 0 0 1 1 1.03v.6Zm17.82 7.52a4.36 4.36 0 0 1-5.81.92 5.02 5.02 0 0 1-1.75-1.96 6.07 6.07 0 0 1-.65-2.84 6 6 0 0 1 .65-2.84c.43-.83 1-1.48 1.74-1.96a4.5 4.5 0 0 1 5.82.78v-4.53c0-.3.09-.54.27-.74.19-.2.43-.29.72-.29v.01c.3 0 .54.1.73.3a1 1 0 0 1 .27.73v12.83c0 .29-.09.53-.27.73-.2.2-.43.3-.73.3a1 1 0 0 1-1-1.03v-.41Zm-3.1-.22c.64 0 1.2-.16 1.67-.48a3.3 3.3 0 0 0 1.12-1.3c.26-.56.4-1.18.4-1.88s-.14-1.32-.4-1.87a3 3 0 0 0-2.79-1.77 2.9 2.9 0 0 0-1.64.47c-.48.31-.85.75-1.12 1.3a4.16 4.16 0 0 0-.42 1.87c0 .7.14 1.32.42 1.87.27.55.64.99 1.12 1.3.47.33 1.02.49 1.63.49h.01Zm7.6 0c-.13-.19-.18-.4-.17-.65.01-.25.16-.46.42-.64a.9.9 0 0 1 .6-.15c.2.03.4.13.59.32a3.63 3.63 0 0 0 3.76 1.22c.28-.08.52-.22.72-.4.2-.2.3-.48.3-.86 0-.34-.11-.6-.32-.8-.22-.2-.5-.36-.85-.49a9.03 9.03 0 0 0-1.14-.36c-.43-.12-.86-.25-1.28-.4a5.4 5.4 0 0 1-1.18-.57 2.69 2.69 0 0 1-.86-.92 2.71 2.71 0 0 1-.32-1.38c0-.64.18-1.17.53-1.63.34-.45.8-.8 1.38-1.07.58-.26 1.2-.38 1.85-.38a5.37 5.37 0 0 1 2.5.62c.4.22.74.5 1.04.84.14.18.21.39.23.63.02.24-.08.46-.33.67a.77.77 0 0 1-.58.17.93.93 0 0 1-.57-.23 2.46 2.46 0 0 0-.99-.75 3.47 3.47 0 0 0-2.16-.15c-.27.07-.5.2-.7.38-.18.19-.27.46-.27.82 0 .34.1.6.33.8.22.21.51.37.88.5.36.14.75.26 1.18.37.42.1.83.23 1.24.38.4.15.78.34 1.1.57a2.65 2.65 0 0 1 1.13 2.3c0 .66-.2 1.22-.58 1.68a3.6 3.6 0 0 1-1.45 1.06c-.58.23-1.2.36-1.83.36-.76 0-1.53-.14-2.28-.42a4.25 4.25 0 0 1-1.92-1.43v-.01Zm24.33 0-.16.25a3.95 3.95 0 0 1-1.96 1.38 4.73 4.73 0 0 1-3.9-.48 5.01 5.01 0 0 1-1.78-1.95 5.98 5.98 0 0 1-.66-2.85c0-1.07.22-2.02.66-2.84a5.08 5.08 0 0 1 1.77-1.95 4.58 4.58 0 0 1 2.51-.72 4.34 4.34 0 0 1 2.83.99c.28.22.51.46.7.7v-.6c0-.27.1-.52.28-.71.19-.2.42-.3.72-.3.29 0 .53.1.72.29.19.2.28.44.28.73v8.89c0 1.12-.24 2.05-.72 2.76a4.26 4.26 0 0 1-1.92 1.58 6.75 6.75 0 0 1-3.81.38c-.46-.1-.87-.2-1.26-.32a2.6 2.6 0 0 1-.8-.36c-.3-.16-.5-.34-.61-.56a.74.74 0 0 1 0-.65c.12-.3.3-.48.52-.54.24-.07.5-.05.8.06l.61.22c.29.11.6.2.95.3.35.08.68.12 1 .12 1.05 0 1.86-.24 2.4-.74.56-.5.83-1.16.83-2v-1.07Zm-3.21-7.3a3.16 3.16 0 0 0-2.9 1.78 4.08 4.08 0 0 0-.41 1.87c0 .7.14 1.32.42 1.87a3.13 3.13 0 0 0 2.9 1.79 3.11 3.11 0 0 0 2.86-1.78c.28-.56.42-1.18.42-1.88s-.14-1.32-.42-1.87a3.14 3.14 0 0 0-2.87-1.77Zm10.33.24c.09-.17.18-.34.29-.5a3.75 3.75 0 0 1 3.03-1.62c.34 0 .64.1.9.28.25.2.38.42.38.7 0 .36-.1.63-.28.8a.9.9 0 0 1-.62.25c-.2 0-.4-.04-.59-.13-.19-.09-.4-.13-.67-.13s-.57.08-.86.23a3.02 3.02 0 0 0-1.37 1.66c-.15.39-.21.83-.21 1.3v4.83a1 1 0 0 1-1.01 1.03 1 1 0 0 1-1.02-1.02v-8.53a1 1 0 0 1 1.03-1.02 1 1 0 0 1 1 1.03v.84Zm16.82 3.42c0 1.08-.23 2.02-.7 2.84a5.13 5.13 0 0 1-4.63 2.64 5.27 5.27 0 0 1-5.34-5.48 5.33 5.33 0 0 1 2.63-4.82c.8-.47 1.7-.71 2.71-.71a5.22 5.22 0 0 1 4.63 2.67c.47.82.7 1.77.7 2.86Zm-2 0a4 4 0 0 0-.45-1.92c-.29-.54-.7-.96-1.2-1.28a3.11 3.11 0 0 0-1.68-.46 3.2 3.2 0 0 0-2.89 1.74 4 4 0 0 0-.44 1.92 4 4 0 0 0 .44 1.9 3.22 3.22 0 0 0 2.9 1.74 3.18 3.18 0 0 0 2.87-1.75c.3-.55.44-1.18.44-1.89Zm-5.3-6.82c-.35 0-.63-.07-.8-.21-.17-.15-.25-.4-.25-.73v-.3c0-.33.1-.57.28-.72.19-.15.45-.22.8-.22.4 0 .69.07.86.21.18.14.26.39.26.73v.3c0 .36-.09.62-.27.75-.19.13-.47.2-.87.2Zm3.84 0c-.37 0-.64-.07-.81-.21-.17-.15-.25-.4-.25-.73v-.3c0-.34.1-.59.28-.73.19-.14.45-.21.8-.21.39 0 .67.07.84.22.18.15.26.4.26.72v.3c0 .36-.09.62-.27.75-.19.13-.46.2-.86.2h.01Zm6.9 4.05h-.66c-.28 0-.52-.1-.72-.28a.9.9 0 0 1-.29-.68.99.99 0 0 1 1-.97h.67v-.06c0-.66.1-1.27.3-1.85a3.96 3.96 0 0 1 2.31-2.5 5.2 5.2 0 0 1 1.96-.36c.87 0 1.6.14 2.2.44a2.98 2.98 0 0 1 1.84 2.8c0 .4-.1.78-.3 1.13a3 3 0 0 1-.77.94c-.3.24-.62.45-.98.62.56.19 1.08.46 1.58.82a4.24 4.24 0 0 1 1.83 3.64c0 .88-.19 1.67-.56 2.36a4.11 4.11 0 0 1-3.7 2.2c-.64 0-1.16-.08-1.58-.25a2.4 2.4 0 0 1-.96-.65.92.92 0 0 1-.2-.61c0-.25.14-.47.4-.66a.9.9 0 0 1 .6-.18 1 1 0 0 1 .6.3 1.91 1.91 0 0 0 1.2.42c.47 0 .85-.12 1.17-.35.32-.23.58-.56.75-.97.17-.4.25-.86.25-1.35 0-.7-.13-1.28-.39-1.72-.26-.45-.6-.8-1.03-1.07a4.78 4.78 0 0 0-1.4-.57 1.6 1.6 0 0 1-.62-.37.77.77 0 0 1-.2-.54c0-.22.04-.42.14-.57.1-.16.22-.27.38-.35.36-.15.67-.33.95-.53.26-.22.47-.44.6-.7.15-.25.22-.53.22-.82 0-.5-.2-.89-.59-1.16a2.68 2.68 0 0 0-1.56-.41 2.22 2.22 0 0 0-1.82.8 2.5 2.5 0 0 0-.47.88c-.11.34-.17.7-.17 1.11l-.02 9.09c0 .29-.1.53-.28.73-.19.2-.42.3-.72.3l.02.01a.98.98 0 0 1-.72-.29.99.99 0 0 1-.28-.73l.02-7.04Zm13.4-.52h-1.1a.91.91 0 0 1-.67-.27.91.91 0 0 1-.28-.68c0-.26.1-.49.28-.66a.9.9 0 0 1 .67-.26h1.1v-1.6c0-.29.1-.53.3-.73a1 1 0 0 1 .72-.3l-.01.01c.29 0 .53.1.72.3.19.2.28.44.28.73v1.59h1.61c.27 0 .49.08.67.27.19.18.28.4.28.67s-.1.5-.28.67a.93.93 0 0 1-.67.26h-1.61v5.87c0 .24.04.43.12.58.08.15.2.25.33.3.15.06.29.09.44.09a.9.9 0 0 0 .4-.09.97.97 0 0 1 .4-.08c.17 0 .32.08.45.22.14.15.2.35.2.6 0 .33-.17.59-.52.79-.35.2-.72.3-1.12.3-.23 0-.5-.02-.8-.06a2.98 2.98 0 0 1-.9-.3 1.9 1.9 0 0 1-.72-.78 3.1 3.1 0 0 1-.29-1.5v-5.94Zm8.43 3.83c.06.51.2.97.43 1.38a3.32 3.32 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15a4.22 4.22 0 0 0 1.37-.8c.2-.12.4-.18.59-.18a.83.83 0 0 1 .86.84c0 .3-.15.57-.44.8-.36.35-.86.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.72-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.87.81 5.15 5.15 0 0 1 1.52 3.67.94.94 0 0 1-.32.67c-.2.17-.43.25-.7.25h-6.98Zm.06-1.7h5.8v-.15a2.2 2.2 0 0 0-.48-1.22 2.98 2.98 0 0 0-2.34-1.12c-.4 0-.79.06-1.15.19-.37.13-.7.33-1 .6a3.6 3.6 0 0 0-.84 1.69Zm12.53-2.26a3.84 3.84 0 0 1 1.08-1.35 3.54 3.54 0 0 1 2.23-.77c.35 0 .65.1.9.28.26.2.39.42.39.7 0 .36-.1.63-.28.8-.2.17-.4.25-.63.25-.2 0-.4-.04-.58-.13-.2-.09-.41-.13-.67-.13a2.35 2.35 0 0 0-1.66.88c-.24.28-.44.62-.58 1.01-.14.39-.2.83-.2 1.3v4.83a1 1 0 0 1-.3.74c-.2.2-.43.29-.72.29h.01a1 1 0 0 1-1.03-1.02v-8.53a1 1 0 0 1 1.03-1.02 1 1 0 0 1 1 1.03v.84Zm14.73-1.5v9.2a1 1 0 0 1-.27.73.9.9 0 0 1-.71.29.9.9 0 0 1-.7-.3 1 1 0 0 1-.27-.73V44.93c0-.26.1-.5.31-.71a1 1 0 0 1 .74-.32h.01c.17 0 .33.04.5.13.18.08.31.2.4.33l4.67 7.1 4.78-7.1a1 1 0 0 1 .83-.46c.26 0 .5.1.7.29.22.2.32.44.32.73v12.05a1 1 0 0 1-1.05 1.02c-.3 0-.55-.1-.75-.29a.98.98 0 0 1-.3-.73v-9.08l-3.78 5.76c-.1.13-.21.23-.37.32a.92.92 0 0 1-.45.13.93.93 0 0 1-.45-.13c-.16-.1-.28-.2-.38-.32l-3.78-5.88ZM310.93 46c-.38 0-.66-.07-.84-.2-.17-.15-.26-.39-.26-.72v-.32c0-.34.1-.57.28-.7.2-.14.47-.2.85-.2.4 0 .69.06.86.2.18.15.26.38.26.7v.32c0 .34-.09.59-.27.72-.19.13-.48.2-.87.2h-.01Zm1.03 10.96c0 .29-.1.53-.28.73-.2.2-.43.3-.72.3-.3 0-.54-.1-.72-.3a1 1 0 0 1-.28-.73v-8.6a1 1 0 0 1 1-1.03c.3 0 .54.1.72.3.2.19.3.43.3.73v8.6h-.02Zm4.44-3.73c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15.31-.1.58-.23.8-.38.22-.15.42-.28.57-.42.2-.12.4-.18.59-.18.25 0 .46.08.63.25.16.17.23.37.23.6 0 .28-.15.56-.44.8-.36.34-.86.65-1.5.92a5.78 5.78 0 0 1-4.9-.3 4.84 4.84 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.72-3.03a5.14 5.14 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.87.81 5.15 5.15 0 0 1 1.52 3.67.94.94 0 0 1-.32.67c-.2.17-.43.25-.7.25h-6.98Zm.06-1.7h5.8v-.15c-.04-.47-.2-.87-.49-1.22a3.04 3.04 0 0 0-2.33-1.12c-.4 0-.79.06-1.15.19a2.67 2.67 0 0 0-1.67 1.73 3.6 3.6 0 0 0-.16.57Zm11.46-2.13h-1.09a.91.91 0 0 1-.67-.27.91.91 0 0 1-.28-.68.93.93 0 0 1 .94-.92h1.1v-1.6c0-.29.1-.53.3-.73a1 1 0 0 1 .72-.3v.01c.3 0 .54.1.72.3.18.2.28.44.28.73v1.59h1.61c.27 0 .5.08.68.27.18.18.27.4.27.67a.9.9 0 0 1-.27.67.93.93 0 0 1-.68.26h-1.61v5.87c0 .24.04.43.12.58.08.15.2.25.34.3.14.06.28.09.43.09a.9.9 0 0 0 .4-.09.96.96 0 0 1 .41-.08c.16 0 .3.08.44.22.14.15.2.35.2.6 0 .33-.18.59-.52.79-.35.2-.73.3-1.13.3-.22 0-.5-.02-.8-.06-.3-.05-.6-.15-.9-.3a1.9 1.9 0 0 1-.72-.78c-.2-.35-.3-.86-.3-1.5V49.4Zm14.12 2.58-1.87 5.36c-.2.4-.48.62-.87.65a.96.96 0 0 1-.61-.13.92.92 0 0 1-.44-.5l-3.11-8.6a1.36 1.36 0 0 1-.06-.4c0-.26.09-.5.27-.72a.92.92 0 0 1 .73-.32 1 1 0 0 1 .58.17c.17.1.28.26.35.48l2.34 6.6 1.86-4.87a.92.92 0 0 1 .92-.63c.24 0 .43.06.57.16.13.11.24.26.32.47l1.84 4.77 2.31-6.5c.15-.43.47-.65.97-.65v-.01c.27 0 .5.1.7.3.2.19.29.43.29.75a1.08 1.08 0 0 1-.08.4l-3.08 8.6a.9.9 0 0 1-.42.5 1 1 0 0 1-.64.13c-.38-.03-.67-.24-.87-.65l-2-5.36Zm17.18 4.59a4.08 4.08 0 0 1-1.85 1.35 4.48 4.48 0 0 1-3.96-.44 5.04 5.04 0 0 1-1.75-1.97 6.09 6.09 0 0 1-.64-2.83c0-1.06.22-2.04.64-2.87a4.98 4.98 0 0 1 1.75-1.94c.72-.47 1.53-.7 2.42-.7a4.5 4.5 0 0 1 3.4 1.5v-.4c0-.28.09-.53.27-.72.2-.2.43-.3.72-.3a.97.97 0 0 1 1 1.02v8.69c0 .29-.1.53-.28.73-.19.2-.42.3-.72.3a.99.99 0 0 1-1-1.03v-.4Zm-3.1-.24a2.97 2.97 0 0 0 2.79-1.8c.26-.56.4-1.18.4-1.86 0-.68-.14-1.3-.4-1.86a3 3 0 0 0-2.79-1.78 2.9 2.9 0 0 0-1.64.48c-.48.3-.85.74-1.12 1.3a4.17 4.17 0 0 0-.42 1.87c0 .7.14 1.3.42 1.85.27.56.64 1 1.12 1.32.48.32 1.02.49 1.64.49v-.01Zm16.13 0-.16.25a3.95 3.95 0 0 1-1.96 1.38 4.73 4.73 0 0 1-3.9-.48 5.02 5.02 0 0 1-1.79-1.95 5.99 5.99 0 0 1-.65-2.85 6 6 0 0 1 .65-2.84 5.05 5.05 0 0 1 1.78-1.95 4.57 4.57 0 0 1 2.51-.72h.01a4.34 4.34 0 0 1 2.82.99c.28.22.51.46.7.7v-.6c0-.27.1-.52.28-.71.19-.2.43-.3.72-.3a.97.97 0 0 1 1 1.02v8.89c0 1.12-.24 2.05-.72 2.76a4.27 4.27 0 0 1-1.92 1.58 6.75 6.75 0 0 1-3.81.38c-.46-.1-.88-.2-1.26-.32a2.6 2.6 0 0 1-.8-.36c-.3-.16-.5-.34-.6-.56a.75.75 0 0 1-.01-.65c.12-.3.3-.48.53-.54.23-.07.5-.05.8.06l.6.22c.29.11.61.2.96.3.34.08.67.12.98.12 1.07 0 1.87-.24 2.42-.74.55-.5.82-1.16.82-2v-1.09Zm-3.2-7.3a3.16 3.16 0 0 0-2.9 1.78 4.08 4.08 0 0 0-.42 1.87c0 .7.14 1.32.42 1.87a3.13 3.13 0 0 0 2.9 1.79 3.1 3.1 0 0 0 2.86-1.78c.28-.56.42-1.18.42-1.88s-.14-1.32-.42-1.87a3.14 3.14 0 0 0-2.87-1.77Zm9.34 4.2c.06.51.2.97.43 1.38a3.32 3.32 0 0 0 2.98 1.73 3.3 3.3 0 0 0 2.02-.53c.22-.15.41-.28.57-.42.2-.12.4-.18.59-.18a.83.83 0 0 1 .86.84c0 .3-.15.57-.44.8-.36.35-.87.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.15 5.15 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15a2.2 2.2 0 0 0-.49-1.22 3.05 3.05 0 0 0-3.49-.93 2.67 2.67 0 0 0-1.67 1.73 3.6 3.6 0 0 0-.15.57Zm12.5-2.5.13-.17a4.55 4.55 0 0 1 1.98-1.47c.42-.16.86-.23 1.33-.23h.01c.95 0 1.69.2 2.21.6.53.4.9.92 1.1 1.58.2.66.31 1.4.31 2.22v5.39a1 1 0 0 1-1 1.03 1 1 0 0 1-1.03-1.03v-5.37c0-.48-.07-.91-.2-1.3a1.81 1.81 0 0 0-.7-.91 2.36 2.36 0 0 0-1.36-.34 3 3 0 0 0-1.45.34 2.47 2.47 0 0 0-1.33 2.21v5.37a1 1 0 0 1-1 1.03 1 1 0 0 1-1.03-1.03v-8.53a1 1 0 0 1 1.03-1.02c.3 0 .51.1.71.29.19.2.3.44.3.73v.62Zm10.83 3.74a.99.99 0 0 1-.72-.3.93.93 0 0 1-.3-.7c0-.3.1-.54.3-.72.2-.18.44-.27.72-.27h3.78c.28 0 .52.1.72.3.2.19.3.43.3.73 0 .29-.1.5-.3.69-.2.18-.44.27-.72.27h-3.78Zm9.73-.13v4.3a1 1 0 0 1-.27.74c-.18.2-.42.3-.71.3a.9.9 0 0 1-.7-.3 1.01 1.01 0 0 1-.27-.73V44.94a1 1 0 0 1 1.03-1.03h4.64c.7 0 1.37.2 1.97.58.6.38 1.09.9 1.45 1.56.36.66.55 1.4.55 2.23a4.44 4.44 0 0 1-2 3.78c-.6.4-1.26.6-1.97.6h-3.72Zm0-6.8v4.9h3.71v-.02c.35 0 .67-.11.96-.34a2.7 2.7 0 0 0 .97-2.11 2.65 2.65 0 0 0-.97-2.1c-.29-.22-.6-.33-.95-.33h-3.72Zm12.22 3.43a3.62 3.62 0 0 1 2.12-1.91c.38-.14.78-.2 1.2-.2.34 0 .64.09.9.27.26.2.38.42.38.7 0 .36-.1.63-.28.8a.9.9 0 0 1-.62.25c-.2 0-.4-.04-.59-.13a1.5 1.5 0 0 0-.66-.13c-.28 0-.58.08-.87.23-.3.15-.56.36-.8.65a3.42 3.42 0 0 0-.78 2.32v4.82a1 1 0 0 1-.3.74c-.2.2-.43.29-.71.29a1 1 0 0 1-1.02-1.02v-8.53a1 1 0 0 1 1.03-1.02c.3 0 .51.1.71.29.2.2.3.44.3.73v.85Zm7.67 3.96c.06.51.21.97.44 1.38a3.3 3.3 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15.31-.1.58-.23.8-.38.22-.15.42-.28.57-.42.2-.12.4-.18.59-.18.25 0 .46.08.62.25a.8.8 0 0 1 .24.6c0 .28-.15.56-.44.8-.36.34-.87.65-1.5.92a5.78 5.78 0 0 1-4.9-.3 4.84 4.84 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.14 5.14 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.15 5.15 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15a2.2 2.2 0 0 0-.49-1.22 3.05 3.05 0 0 0-3.49-.93 2.67 2.67 0 0 0-1.66 1.73 3.6 3.6 0 0 0-.16.57ZM442.85 46c-.38 0-.67-.07-.84-.2-.18-.15-.26-.39-.26-.72v-.32c0-.34.1-.57.28-.7.2-.14.47-.2.85-.2.4 0 .68.06.86.2.18.15.26.38.26.7v.32c0 .34-.08.59-.27.72-.18.13-.47.2-.88.2Zm1.03 10.96c0 .29-.1.53-.28.73-.19.2-.43.3-.72.3-.3 0-.54-.1-.72-.3a1 1 0 0 1-.28-.73v-8.6a1 1 0 0 1 1-1.03c.3 0 .55.1.73.3.19.19.28.43.28.73v8.6Zm2.39-.63c-.12-.19-.18-.4-.16-.65.01-.25.15-.46.42-.64a.9.9 0 0 1 .59-.15c.2.03.4.13.6.32a3.63 3.63 0 0 0 3.76 1.22c.27-.08.52-.22.72-.4.2-.2.3-.48.3-.86 0-.34-.11-.6-.32-.8-.22-.2-.5-.36-.85-.49-.34-.13-.73-.25-1.14-.36a23.2 23.2 0 0 1-1.29-.4 5.38 5.38 0 0 1-1.17-.57 2.67 2.67 0 0 1-.86-.92 2.79 2.79 0 0 1-.32-1.38c0-.63.18-1.17.52-1.63.35-.45.81-.8 1.4-1.07a4.47 4.47 0 0 1 1.84-.38 5.36 5.36 0 0 1 2.5.62c.4.22.74.5 1.04.85.13.17.21.38.23.62.02.24-.09.46-.33.67a.76.76 0 0 1-.59.17.93.93 0 0 1-.56-.23 2.5 2.5 0 0 0-.99-.75 3.36 3.36 0 0 0-2.16-.15c-.27.07-.5.2-.7.38-.19.19-.28.46-.28.82 0 .34.11.6.34.8.22.21.5.37.87.5.37.15.76.26 1.19.37.41.1.83.23 1.24.38.4.15.77.34 1.1.57a2.67 2.67 0 0 1 1.12 2.3c0 .66-.19 1.22-.57 1.68a3.6 3.6 0 0 1-1.45 1.06c-.58.23-1.2.36-1.84.36-.76 0-1.52-.14-2.28-.42a4.2 4.2 0 0 1-1.91-1.43l-.01-.01Zm14.75-1.43 2.97-6.92c.19-.45.49-.66.9-.65.27 0 .5.09.68.26.18.17.27.39.27.64 0 .08-.02.17-.04.26a.94.94 0 0 1-.1.23l-3.82 8.6c-.18.4-.46.62-.87.65a.94.94 0 0 1-.6-.13.97.97 0 0 1-.44-.51l-3.8-8.59a3 3 0 0 1-.08-.23.9.9 0 0 1 .23-.92c.18-.2.42-.3.73-.3v.02c.2 0 .4.05.57.16.18.11.31.27.4.49l3 6.94Zm8.48-1.67c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.98 1.73c.5 0 .9-.05 1.21-.15a5.17 5.17 0 0 0 1.38-.8c.2-.12.4-.18.58-.18a.83.83 0 0 1 .87.84c0 .3-.15.57-.44.8a5.17 5.17 0 0 1-3.5 1.33 5.71 5.71 0 0 1-2.9-.7 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.13 5.13 0 0 1 1.52 3.67.94.94 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15c-.05-.47-.2-.87-.5-1.22a3.03 3.03 0 0 0-2.32-1.12c-.4 0-.8.06-1.16.19a2.66 2.66 0 0 0-1.67 1.73 3.6 3.6 0 0 0-.15.57Zm12.52-2.26a3.62 3.62 0 0 1 2.12-1.91c.38-.14.78-.2 1.2-.2.34 0 .64.09.9.27.26.2.38.42.38.7 0 .36-.1.63-.28.8a.91.91 0 0 1-.62.25c-.2 0-.4-.04-.59-.13-.19-.09-.4-.13-.67-.13s-.57.08-.86.23c-.3.15-.56.36-.8.65a3.4 3.4 0 0 0-.57 1.01c-.15.39-.22.83-.22 1.3v4.83a1 1 0 0 1-1 1.03 1 1 0 0 1-1.02-1.02v-8.53a1 1 0 0 1 1.02-1.02c.3 0 .52.1.72.29.19.2.3.44.3.73v.85Zm14.3 7.05a3.05 3.05 0 0 1-.98 1.05 4.31 4.31 0 0 1-2.47.82c-.96 0-1.8-.23-2.57-.71a5.01 5.01 0 0 1-1.79-1.95 5.99 5.99 0 0 1-.65-2.85 6 6 0 0 1 .65-2.84 5.05 5.05 0 0 1 1.79-1.95 4.57 4.57 0 0 1 2.5-.72h.01a4.34 4.34 0 0 1 2.83.99c.27.22.5.46.69.7v-.6c0-.27.1-.52.28-.71.19-.2.43-.3.72-.3a.97.97 0 0 1 1 1.02v8.89c0 1.12-.24 2.05-.72 2.76a4.27 4.27 0 0 1-1.92 1.58 6.75 6.75 0 0 1-3.81.38c-.46-.1-.88-.2-1.26-.32a2.6 2.6 0 0 1-.8-.36c-.3-.16-.5-.34-.6-.56a.75.75 0 0 1-.01-.65c.12-.3.3-.48.53-.54.23-.07.5-.05.8.06l.6.22c.3.11.61.2.96.3.34.08.67.12.98.12 1.07 0 1.87-.24 2.42-.74.55-.5.82-1.16.82-2v-1.09Zm-3.2-7.28a3.16 3.16 0 0 0-2.9 1.77 4.08 4.08 0 0 0-.42 1.87c0 .7.14 1.32.42 1.87a3.13 3.13 0 0 0 2.9 1.79 3.1 3.1 0 0 0 2.86-1.78c.28-.56.42-1.18.42-1.88s-.14-1.32-.42-1.87a3.14 3.14 0 0 0-2.87-1.77Zm10.49 7.92a1 1 0 0 1-1 1.02.96.96 0 0 1-.72-.29.98.98 0 0 1-.3-.73V44.14c0-.3.1-.54.3-.73a1 1 0 0 1 .73-.3c.28 0 .53.1.71.3.18.2.27.43.27.73v12.83h.01Zm4.52-3.73c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.98 1.73c.5 0 .9-.05 1.21-.15.32-.1.59-.23.8-.38.22-.15.42-.28.58-.42.2-.12.4-.18.58-.18a.83.83 0 0 1 .87.84c0 .3-.15.57-.44.8-.36.35-.87.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.84 4.84 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.13 5.13 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15c-.05-.47-.2-.87-.5-1.22a3.05 3.05 0 0 0-3.48-.93 2.67 2.67 0 0 0-1.67 1.73c-.06.17-.11.36-.15.57ZM519.63 46c-.38 0-.67-.07-.84-.2-.18-.15-.26-.39-.26-.72v-.32c0-.34.1-.57.28-.7.2-.14.47-.2.85-.2.4 0 .68.06.86.2.18.15.26.38.26.7v.32c0 .34-.08.59-.27.72-.18.13-.47.2-.88.2Zm1.03 10.96c0 .29-.1.53-.28.73-.19.2-.43.3-.72.3-.3 0-.54-.1-.72-.3a1 1 0 0 1-.28-.73v-8.6a1 1 0 0 1 1-1.03c.3 0 .55.1.73.3.19.19.28.43.28.73v8.6Zm7.7-9.8c.73 0 1.37.08 1.94.24.56.15 1 .36 1.3.64.32.27.48.59.48.95 0 .23-.07.44-.2.63a.7.7 0 0 1-.61.3c-.2 0-.37-.03-.5-.1a1.48 1.48 0 0 1-.33-.23c-.1-.1-.23-.2-.4-.27a1.8 1.8 0 0 0-.66-.22 4.9 4.9 0 0 0-.76-.06 3.3 3.3 0 0 0-3.04 1.78 3.93 3.93 0 0 0-.43 1.86 4 4 0 0 0 .42 1.87 3.2 3.2 0 0 0 2.95 1.79 3.8 3.8 0 0 0 1.63-.32c.2-.12.4-.25.53-.38.14-.13.34-.19.59-.19.3 0 .52.1.67.28a1 1 0 0 1 .23.67c0 .3-.17.58-.53.86-.35.27-.83.5-1.41.67a6.8 6.8 0 0 1-1.97.26 4.87 4.87 0 0 1-4.5-2.7 6.15 6.15 0 0 1-.63-2.81c0-1.05.22-2 .66-2.83a5.1 5.1 0 0 1 1.84-1.96c.78-.48 1.7-.72 2.72-.72h.01Zm8.06 1.92a4.14 4.14 0 0 1 2.03-1.61c.4-.16.83-.24 1.28-.24.94 0 1.65.2 2.16.59.51.4.87.92 1.07 1.6.2.67.32 1.4.32 2.2v5.34a1 1 0 0 1-1.01 1.02 1 1 0 0 1-1.03-1.02v-5.33c0-.47-.06-.9-.19-1.28a1.93 1.93 0 0 0-.65-.93c-.3-.23-.74-.35-1.3-.35-.53 0-1 .12-1.4.35a2.47 2.47 0 0 0-1.28 2.2v5.34a1 1 0 0 1-1 1.02 1 1 0 0 1-1.04-1.02V44.14a1 1 0 0 1 1.03-1.03 1.01 1.01 0 0 1 1 1.03v4.95Z"
            })
        ]
    }));
};
BMLogo.defaultProps = BMLogo_defaultProps;


;// CONCATENATED MODULE: ../../frontend/entities/src/BrandLogo/brands/CGLogo.tsx






var CGLogo_defaultProps = {
    withClaim: false,
    responsive: false
};
var CGLogo = function CGLogo(_param) /*#__PURE__*/ {
    var withClaim = _param.withClaim, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "withClaim"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLogo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 616 111",
        title: "CARIGAMI"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M35.73 67.25c.61.79.09 2.02-.97 2.02H18.78c-.79 0-1.49-.44-1.84-1.14C7.37 42.06 23 14.93 53.55 14.84h51.74A15.87 15.87 0 0 0 89.45 0H15.89A15.88 15.88 0 0 0 0 15.89v59.7h51.27c22.47 0 28.62-22.91 18.17-37.49-.61-.79-.09-2.02.97-2.02h15.98c.79 0 1.49.44 1.84 1.14 9.57 26.07-6.06 53.2-36.61 53.29H.05a15.87 15.87 0 0 0 15.84 14.84h73.57c8.78 0 15.89-7.11 15.89-15.89v-59.7H53.9c-22.47 0-28.62 22.91-18.17 37.49Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M336.2 8.6a7.53 7.53 0 0 1 8.28-7.54c3.95.34 6.86 3.9 6.86 7.87v54.19c0 3.97-2.91 7.53-6.86 7.87a7.52 7.52 0 0 1-8.28-7.54V8.6Zm28.31 27.62v-.2c0-19.56 15.24-35.59 36.08-35.59 10.42 0 17.3 2.36 23.5 6.69a7.57 7.57 0 0 1 3.14 6.38 7.64 7.64 0 0 1-8.48 7.12c-1.6-.2-2.7-.85-3.6-1.51-4.13-2.95-8.55-4.72-15.04-4.72-11.01 0-19.76 9.73-19.76 21.43v.2c0 12.58 8.65 21.82 20.84 21.82 5.5 0 10.42-1.38 14.25-4.13v-9.83h-9.97c-3.26 0-6.28-2.25-6.76-5.47a6.6 6.6 0 0 1 6.51-7.61h17.3a7.57 7.57 0 0 1 7.57 7.57v16.71c0 4.43-1.67 7.47-5.31 9.63a45.77 45.77 0 0 1-24.09 6.88c-21.42 0-36.17-15.03-36.18-35.37ZM517.45 8.79a7.57 7.57 0 0 1 7.57-7.57h1.67a7.76 7.76 0 0 1 6.88 3.93l18.29 29.78 18.38-29.88a7.4 7.4 0 0 1 6.78-3.83h1.67a7.57 7.57 0 0 1 7.57 7.57v54.26c0 3.51-2.2 6.81-5.59 7.7a7.53 7.53 0 0 1-9.45-7.31V29.13l-13.27 20.45c-1.57 2.36-3.54 3.83-6.29 3.83s-4.72-1.48-6.29-3.83l-13.08-20.16V63.2c0 3.74-2.6 7.18-6.3 7.71a7.32 7.32 0 0 1-8.54-7.29V8.79Zm83.06-.19a7.53 7.53 0 0 1 8.28-7.54c3.95.34 6.86 3.9 6.86 7.87v54.19c0 3.97-2.91 7.53-6.86 7.87a7.52 7.52 0 0 1-8.28-7.54V8.6Zm-92.4 53.15h-.02c1.1 3.55-.61 7.49-4.09 8.8a6.97 6.97 0 0 1-9.14-4.45l-1.53-4.93-3.84-12.36a.72.72 0 0 0-.68-.5h-22.8c-.82 0-1.38-.85-1.06-1.61l3.02-10.34c.23-.79.95-1.33 1.77-1.33h14.42a.7.7 0 0 0 .67-.93c-2.86-8.8-5.36-16-6.46-17.81-1.4-2.1-4.82-2.12-4.86-2.12-.04 0-3.61.03-5.26 2.35-1.23 1.95-4.01 11.64-6.71 21.01-2.3 7.98-5.15 17.91-8.56 28.62a6.98 6.98 0 0 1-13.28-4.22c3.35-10.52 6.18-20.35 8.45-28.24 4.33-15.06 6.35-21.85 8.75-25.23C462.45.65 471.72.25 473.52.25c5.27 0 12.37 2.19 16.48 8.36 2.8 4.19 7.44 18.67 16.65 48.44l1.46 4.7ZM310.75 45.16l.01-.01a.57.57 0 0 0-.22.88l10.04 12.2c1.48 1.87 2.46 3.44 2.46 5.8 0 4.23-3.54 6.98-7.18 6.98-3.44 0-5.7-1.67-7.47-3.93l-14.53-18.41a.72.72 0 0 0-.56-.27h-11.04a.71.71 0 0 0-.71.71v14.33a7.53 7.53 0 0 1-8.37 7.53c-3.9-.38-6.77-3.88-6.77-7.81V49.01a.71.71 0 0 0-.71-.71h-14.8a.7.7 0 0 0-.68.91l2.46 7.94 1.49 4.82a6.98 6.98 0 0 1-13.32 4.13l-1.49-4.82-3.87-12.47a.72.72 0 0 0-.68-.5h-23.43c-.95 0-1.59-.85-1.22-1.61l3.45-10.34c.26-.79 1.08-1.33 2.02-1.33h14.52a.7.7 0 0 0 .67-.93c-2.86-8.8-5.35-16-6.46-17.81-1.28-2.14-4.82-2.12-4.86-2.12-.29-.04-3.69.01-5.14 2.18-1.83 2.74-2.67 5.89-3.84 10.25-1.18 4.41-2.65 9.91-5.68 16.8-6.09 13.83-16 27.9-42.01 27.9-21.62 0-35.9-15.63-35.9-35.39v-.2c0-19.57 14.74-35.59 35.88-35.59 10.32 0 17.3 2.75 23 6.98a7.59 7.59 0 0 1 2.9 6.88c-.39 3.49-3.85 6.47-7.37 6.49a7.98 7.98 0 0 1-4.57-1.48c-4.23-3.14-8.66-4.91-14.06-4.91-11.6 0-20.55 9.52-20.55 21.31v.64c0 11.22 8.38 21.29 20.67 21.35 17.61.12 25.16-10.3 29.25-19.59A94.26 94.26 0 0 0 197.06 23c1.34-5 2.6-9.72 5.71-14.38C207.95.86 216.78.24 219.45.24h.05c5.27 0 12.37 2.19 16.48 8.36 1.98 2.96 4.87 11.03 9.62 25.94.1.29.37.5.68.5h50.6c7.37 0 11.6-3.93 11.6-9.73v-.2c0-6.48-4.52-9.83-11.89-9.83h-11.52a3.52 3.52 0 0 0-3.52 3.52v9.25c0 .64-.52 1.16-1.16 1.16h-12.83c-.64 0-1.16-.52-1.16-1.16V15.82a14.2 14.2 0 0 1 14.21-14.21h17.25c8.75 0 15.54 2.46 20.06 6.98 3.83 3.84 5.9 9.24 5.9 15.73v.2c0 10.51-5.11 17.12-13.07 20.64Z",
                transform: withClaim ? undefined : "translate(0, 20)"
            }),
            withClaim && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M143.02 86.81c.41.2.65.52.71.95.06.43-.05.82-.35 1.17-.2.3-.46.46-.78.49-.32.03-.64-.04-.98-.21a8.16 8.16 0 0 0-1.69-.67 7.44 7.44 0 0 0-4.74.28 6.32 6.32 0 0 0-3.6 3.74 8.13 8.13 0 0 0-.49 2.9c0 1.17.18 2.21.53 3.11.35.9.84 1.66 1.46 2.29a5.77 5.77 0 0 0 2.2 1.39 7.88 7.88 0 0 0 6.3-.43c.33-.17.66-.23.98-.18.32.05.59.21.81.49.3.39.41.79.33 1.2-.07.41-.31.71-.7.89a11.53 11.53 0 0 1-3.23 1.13 10.66 10.66 0 0 1-5.56-.52 9.71 9.71 0 0 1-3.18-1.95 9.37 9.37 0 0 1-2.19-3.15 10.66 10.66 0 0 1-.81-4.27c0-1.43.25-2.75.75-3.96a9.46 9.46 0 0 1 5.26-5.23 10.45 10.45 0 0 1 6.57-.41 9.8 9.8 0 0 1 2.36.95h.04Zm18.03 11.06a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm18.2-4.52a6.35 6.35 0 0 1 2.8-2.57 5.02 5.02 0 0 1 2.2-.49c1.28 0 2.28.27 2.98.82.71.55 1.2 1.28 1.48 2.2.28.92.42 1.95.42 3.08v7.39c0 .41-.13.75-.39 1.02s-.6.4-1 .4-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-7.36c0-.65-.09-1.25-.26-1.78a2.6 2.6 0 0 0-.92-1.3 2.94 2.94 0 0 0-1.8-.49 3.63 3.63 0 0 0-3.26 1.79 3.41 3.41 0 0 0-.47 1.78v7.36c0 .41-.13.75-.39 1.02s-.6.4-1 .4-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-7.39c0-.65-.09-1.24-.26-1.77a2.59 2.59 0 0 0-.91-1.28 2.92 2.92 0 0 0-1.78-.49 3.58 3.58 0 0 0-3.68 3.54v7.39c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v.86a5.08 5.08 0 0 1 1.24-1.33 6.1 6.1 0 0 1 1.52-.86 4.9 4.9 0 0 1 1.81-.33l-.03-.01c1.38 0 2.43.34 3.18 1.02a4.65 4.65 0 0 1 1.3 2.04Zm16.97 9.96v6.06c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02V91.92c0-.39.13-.72.4-1s.61-.42 1.02-.42c.41 0 .72.14.99.42.27.28.4.61.4 1v.67l.08-.1a6.22 6.22 0 0 1 2.69-1.88c.59-.2 1.19-.31 1.83-.31l.01-.01c1.3 0 2.46.33 3.47.98a6.97 6.97 0 0 1 2.41 2.66c.6 1.12.89 2.43.89 3.92 0 1.49-.3 2.8-.89 3.94a6.9 6.9 0 0 1-2.4 2.69c-1 .65-2.14.98-3.4.98a6.05 6.05 0 0 1-4.69-2.15Zm4.3-10.46a4.18 4.18 0 0 0-3.88 2.42c-.37.74-.56 1.6-.56 2.56s.19 1.81.56 2.58a4.08 4.08 0 0 0 3.88 2.46 4.03 4.03 0 0 0 3.82-2.46c.37-.77.56-1.63.56-2.58 0-.95-.19-1.8-.56-2.55a4.44 4.44 0 0 0-1.53-1.78 3.97 3.97 0 0 0-2.29-.65Zm21.27 10.4a5.75 5.75 0 0 1-2.55 1.85 6.27 6.27 0 0 1-5.49-.61 6.95 6.95 0 0 1-2.42-2.72 8.49 8.49 0 0 1-.89-3.93c0-1.47.3-2.83.89-3.97a6.91 6.91 0 0 1 2.41-2.69 6.08 6.08 0 0 1 3.36-.98 6.17 6.17 0 0 1 4.72 2.1v-.57c0-.39.13-.72.39-1a1.3 1.3 0 0 1 1-.42l-.03.01c.41 0 .74.13 1 .4s.39.61.39 1.02v12.04c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.53Zm-4.3-.33c.87 0 1.64-.22 2.31-.67a4.44 4.44 0 0 0 1.56-1.83c.37-.77.56-1.63.56-2.58 0-.95-.19-1.81-.56-2.58a4.19 4.19 0 0 0-3.87-2.46c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.81.57 2.58.38.77.9 1.38 1.56 1.83.66.45 1.42.67 2.27.67Zm14.18-9.78a5.1 5.1 0 0 1 4.6-2.94c.48 0 .9.13 1.25.39s.53.59.53.98c0 .5-.13.87-.39 1.1-.26.23-.55.35-.86.35-.28 0-.55-.06-.81-.18a2.19 2.19 0 0 0-.92-.18c-.39 0-.79.1-1.2.31a3.5 3.5 0 0 0-1.11.91c-.33.4-.6.87-.79 1.41a5.41 5.41 0 0 0-.29 1.81v6.69c0 .41-.13.75-.4 1.02s-.6.4-.99.4l-.01-.01c-.41 0-.75-.13-1.02-.4s-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v1.18Zm19.58 10.11a5.75 5.75 0 0 1-2.55 1.85 6.27 6.27 0 0 1-5.49-.61 6.95 6.95 0 0 1-2.42-2.72 8.49 8.49 0 0 1-.89-3.93c0-1.47.3-2.83.89-3.97a6.91 6.91 0 0 1 2.41-2.69 6.08 6.08 0 0 1 3.36-.98 6.17 6.17 0 0 1 4.72 2.1v-.57c0-.39.13-.72.39-1a1.3 1.3 0 0 1 1-.42l-.03.01c.41 0 .74.13 1 .4s.39.61.39 1.02v12.04c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.53Zm-4.3-.33c.87 0 1.64-.22 2.31-.67a4.44 4.44 0 0 0 1.56-1.83c.37-.77.56-1.63.56-2.58 0-.95-.19-1.81-.56-2.58a4.19 4.19 0 0 0-3.87-2.46c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.81.57 2.58.38.77.9 1.38 1.56 1.83.66.45 1.42.67 2.27.67Zm12.72-9.62h-1.52c-.37 0-.68-.13-.93-.38a1.27 1.27 0 0 1-.38-.93c0-.37.13-.68.38-.92s.56-.36.93-.36h1.52v-2.18c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4l-.01-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v2.2h2.23c.37 0 .68.13.93.38s.38.56.38.93-.13.68-.38.92a1.3 1.3 0 0 1-.93.36h-2.23v8.14c0 .33.06.6.17.81.11.21.26.34.46.42.2.07.39.11.6.11.21 0 .39-.04.54-.11.16-.07.35-.11.57-.11.22 0 .43.1.61.31.18.2.28.48.28.84 0 .45-.24.81-.72 1.09s-1 .42-1.56.42c-.32 0-.69-.03-1.11-.08-.42-.05-.84-.2-1.24-.42a2.6 2.6 0 0 1-1-1.07 4.36 4.36 0 0 1-.4-2.08V93.3Zm11.69 5.32c.08.7.28 1.33.59 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.09-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.21.8Zm25.5-5.71c.39 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.93-.54 3.44-1.62 4.53-1.08 1.09-2.6 1.63-4.57 1.63-1.97 0-3.49-.54-4.56-1.63-1.07-1.09-1.6-2.6-1.6-4.53v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.21.28 2.11.85 2.7.57.59 1.4.89 2.49.89 1.09 0 1.96-.3 2.52-.89.56-.59.85-1.5.85-2.7v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4h.02Zm8.47 2.6a5.1 5.1 0 0 1 4.6-2.94c.48 0 .9.13 1.25.39s.53.59.53.98c0 .5-.13.87-.39 1.1-.26.23-.55.35-.86.35-.28 0-.55-.06-.81-.18a2.19 2.19 0 0 0-.92-.18c-.39 0-.79.1-1.2.31a3.5 3.5 0 0 0-1.11.91c-.33.4-.6.87-.79 1.41a5.41 5.41 0 0 0-.29 1.81v6.69c0 .41-.13.75-.4 1.02s-.6.4-.99.4l-.01-.01c-.41 0-.75-.13-1.02-.4s-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v1.18Zm28.08 10.1a5.67 5.67 0 0 1-2.55 1.87 6.27 6.27 0 0 1-5.49-.61 6.96 6.96 0 0 1-2.42-2.7 8.47 8.47 0 0 1-.89-3.94c0-1.48.3-2.8.89-3.94a7.01 7.01 0 0 1 2.41-2.7 6.01 6.01 0 0 1 3.36-.99 6.17 6.17 0 0 1 4.72 2.1v-6.31c0-.41.13-.75.39-1.02s.59-.4 1-.4l-.03-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v17.78c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.55Zm-4.29-.32a4 4 0 0 0 2.32-.67 4.65 4.65 0 0 0 1.55-1.81c.38-.76.56-1.63.56-2.59s-.19-1.83-.56-2.59a4.1 4.1 0 0 0-3.87-2.45c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.83.57 2.59.38.76.9 1.37 1.56 1.81.66.44 1.41.67 2.26.67h.01Zm13.36-4.3c.08.7.28 1.33.59 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.09-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.21.8Zm25.76 7.53c0 .41-.14.75-.4 1.02-.27.27-.6.4-.99.4s-.72-.13-.99-.4-.4-.61-.4-1.02V86c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4s.74.13.99.4.38.61.38 1.02v17.78h-.01Zm18.33-5.91a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm12.86-7.66c1 0 1.9.11 2.68.32a4.6 4.6 0 0 1 1.83.89c.44.38.65.82.65 1.32 0 .32-.09.61-.28.88-.19.27-.46.4-.84.4a1.47 1.47 0 0 1-1.15-.46 2.07 2.07 0 0 0-.54-.38 2.43 2.43 0 0 0-.92-.29c-.41-.07-.76-.1-1.06-.1a4.6 4.6 0 0 0-4.22 2.47 5.4 5.4 0 0 0-.6 2.58c0 .97.2 1.83.6 2.59a4.4 4.4 0 0 0 4.08 2.48c.54 0 .99-.04 1.35-.13.36-.08.66-.19.91-.32.3-.17.54-.34.74-.52.2-.18.47-.27.82-.27.41 0 .72.13.93.38.21.25.32.56.32.93 0 .41-.25.8-.74 1.19-.49.38-1.15.69-1.97.93a9.7 9.7 0 0 1-2.73.36 6.91 6.91 0 0 1-3.75-1 6.74 6.74 0 0 1-2.48-2.73 8.54 8.54 0 0 1-.88-3.9c0-1.45.31-2.77.92-3.92a7.02 7.02 0 0 1 2.55-2.72c1.09-.67 2.35-1 3.78-1v.02Zm19.01 13.04a5.75 5.75 0 0 1-2.55 1.85 6.27 6.27 0 0 1-5.49-.61 6.95 6.95 0 0 1-2.42-2.72 8.49 8.49 0 0 1-.89-3.93c0-1.47.3-2.83.89-3.97a6.91 6.91 0 0 1 2.41-2.69 6.08 6.08 0 0 1 3.36-.98 6.17 6.17 0 0 1 4.72 2.1v-.57c0-.39.13-.72.39-1a1.3 1.3 0 0 1 1-.42l-.03.01c.41 0 .74.13 1 .4s.39.61.39 1.02v12.04c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.53Zm-4.3-.33c.87 0 1.64-.22 2.31-.67a4.44 4.44 0 0 0 1.56-1.83c.37-.77.56-1.63.56-2.58 0-.95-.19-1.81-.56-2.58a4.19 4.19 0 0 0-3.87-2.46c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.81.57 2.58.38.77.9 1.38 1.56 1.83.66.45 1.42.67 2.27.67Zm12.72-9.62h-1.52c-.37 0-.68-.13-.93-.38a1.27 1.27 0 0 1-.38-.93c0-.37.13-.68.38-.92s.56-.36.93-.36h1.52v-2.18c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4l-.01-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v2.2h2.23c.37 0 .68.13.93.38s.38.56.38.93-.13.68-.38.92a1.3 1.3 0 0 1-.93.36h-2.23v8.14c0 .33.06.6.17.81.11.21.26.34.46.42.2.07.39.11.6.11.21 0 .39-.04.54-.11.16-.07.35-.11.57-.11.22 0 .43.1.61.31.18.2.28.48.28.84 0 .45-.24.81-.72 1.09s-1 .42-1.56.42c-.32 0-.69-.03-1.11-.08-.42-.05-.84-.2-1.24-.42a2.6 2.6 0 0 1-1-1.07 4.36 4.36 0 0 1-.4-2.08V93.3Zm11.05-4.71c-.54 0-.93-.1-1.17-.29-.24-.19-.36-.53-.36-.99v-.45c0-.46.13-.79.39-.98.26-.19.65-.28 1.17-.28.56 0 .96.1 1.2.29.24.19.36.52.36.96v.45c0 .48-.13.82-.38 1-.25.18-.65.28-1.21.28v.01Zm1.42 15.19c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02V91.85c0-.41.13-.75.4-1.02s.6-.4.99-.4a1.35 1.35 0 0 1 1.39 1.42v11.93Zm18.23-5.91a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm9.14-5.06.18-.25a6.54 6.54 0 0 1 2.74-2.03 5.35 5.35 0 0 1 1.84-.32h.01a5 5 0 0 1 3.07.82 4.33 4.33 0 0 1 1.52 2.2c.29.92.43 1.95.43 3.08v7.47c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02v-7.44c0-.67-.09-1.27-.28-1.8-.19-.53-.5-.95-.95-1.27a3.24 3.24 0 0 0-1.9-.47 4.2 4.2 0 0 0-2.01.47c-.58.32-1.03.74-1.35 1.27a3.33 3.33 0 0 0-.49 1.8v7.44c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v.85Zm32.87 10.42a5.67 5.67 0 0 1-2.55 1.88 6.27 6.27 0 0 1-5.49-.61 6.96 6.96 0 0 1-2.42-2.7 8.47 8.47 0 0 1-.89-3.94c0-1.48.3-2.8.89-3.94a7.01 7.01 0 0 1 2.41-2.7 6.01 6.01 0 0 1 3.36-.99 6.17 6.17 0 0 1 4.72 2.1v-6.31c0-.41.13-.75.39-1.02s.59-.4 1-.4l-.03-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v17.78c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.55Zm-4.29-.31a4 4 0 0 0 2.32-.67 4.65 4.65 0 0 0 1.55-1.81c.38-.76.56-1.63.56-2.59s-.19-1.83-.56-2.59a4.1 4.1 0 0 0-3.87-2.45c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.83.57 2.59.38.76.9 1.37 1.56 1.81.66.44 1.41.67 2.26.67h.01Zm13.36-4.3c.08.7.28 1.33.59 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.09-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.22.8Zm28.58 4.67 4.11-9.6c.26-.61.68-.91 1.25-.89.37 0 .68.12.93.36a1.2 1.2 0 0 1 .32 1.25c-.04.13-.08.24-.14.33l-5.3 11.93c-.24.56-.64.85-1.2.89a1.3 1.3 0 0 1-.84-.18 1.38 1.38 0 0 1-.61-.71l-5.27-11.9-.11-.32a1.35 1.35 0 0 1-.06-.43c0-.28.13-.56.38-.84a1.3 1.3 0 0 1 1.02-.42l.02.01c.28 0 .54.07.79.22s.43.37.54.67l4.17 9.63Zm23.85-3.05a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm7.56-9.28c-.54 0-.93-.1-1.17-.29-.24-.19-.36-.53-.36-.99v-.45c0-.46.13-.79.39-.98.26-.19.65-.28 1.17-.28.56 0 .96.1 1.2.29.24.19.36.52.36.96v.45c0 .48-.13.82-.38 1-.25.18-.65.28-1.21.28v.01Zm1.42 15.19c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02V91.85c0-.41.13-.75.4-1.02s.6-.4.99-.4a1.35 1.35 0 0 1 1.39 1.42v11.93Zm5.5-10.48h-1.52c-.37 0-.68-.13-.93-.38a1.27 1.27 0 0 1-.38-.93c0-.37.13-.68.38-.92s.56-.36.93-.36h1.52v-2.18c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4l-.01-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v2.2h2.23c.37 0 .68.13.93.38s.38.56.38.93-.13.68-.38.92a1.3 1.3 0 0 1-.93.36h-2.23v8.14c0 .33.06.6.17.81.11.21.26.34.46.42.2.07.39.11.6.11.21 0 .39-.04.54-.11.16-.07.35-.11.57-.11.22 0 .43.1.61.31.18.2.28.48.28.84 0 .45-.24.81-.72 1.09s-1 .42-1.56.42c-.32 0-.69-.03-1.11-.08-.42-.05-.84-.2-1.24-.42a2.6 2.6 0 0 1-1-1.07 4.36 4.36 0 0 1-.4-2.08V93.3Zm20.78-2.76c.39 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.93-.54 3.44-1.62 4.53-1.08 1.09-2.6 1.63-4.57 1.63-1.97 0-3.49-.54-4.56-1.63-1.07-1.09-1.6-2.6-1.6-4.53v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.21.28 2.11.85 2.7.57.59 1.4.89 2.49.89 1.09 0 1.96-.3 2.52-.89.56-.59.85-1.5.85-2.7v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4h.02Zm8.47 2.6a5.1 5.1 0 0 1 4.6-2.94c.48 0 .9.13 1.25.39s.53.59.53.98c0 .5-.13.87-.39 1.1-.26.23-.55.35-.86.35-.28 0-.55-.06-.81-.18a2.19 2.19 0 0 0-.92-.18c-.39 0-.79.1-1.2.31a3.5 3.5 0 0 0-1.11.91c-.33.4-.6.87-.79 1.41a5.41 5.41 0 0 0-.29 1.81v6.69c0 .41-.13.75-.4 1.02s-.6.4-.99.4l-.01-.01c-.41 0-.75-.13-1.02-.4s-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v1.18Zm10.63 5.48c.09.7.28 1.33.6 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.1-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.22.8Z"
            })
        ]
    }));
};
CGLogo.defaultProps = CGLogo_defaultProps;


;// CONCATENATED MODULE: ../../frontend/entities/src/BrandLogo/BrandLogo.tsx







var BrandLogo_defaultProps = {
    withClaim: false,
    responsive: false
};
var RESPONSIVE_LOGOS = {
    "billiger-mietwagen": {
        title: "billiger-mietwagen.de",
        height: {
            mobile: 30,
            desktop: 40
        }
    },
    carigami: {
        height: {
            mobile: 22,
            desktop: 40
        },
        title: "CARIGAMI"
    },
    floyt: {
        height: {
            mobile: 22,
            desktop: 40
        },
        title: "FLOYT"
    }
};
var LOGO_COMPONENTS = {
    floyt: {
        height: "54px",
        component: FloytLogo
    },
    "billiger-mietwagen": {
        height: "54px",
        component: BMLogo
    },
    carigami: {
        height: "54px",
        component: CGLogo
    }
};
var BrandLogo = function BrandLogo(param) {
    var brandName = param.brand, width = param.width, height = param.height, responsive = param.responsive, withClaim = param.withClaim;
    var logo = LOGO_COMPONENTS[brandName];
    var LogoComponent = logo.component;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoComponent, {
        responsive: responsive,
        withClaim: withClaim,
        width: width,
        height: height !== null && height !== void 0 ? height : logo.height
    });
};
var ResponsiveLogo = function ResponsiveLogo() {
    var baseLocalizedUrl = useHost().baseLocalizedUrl;
    var brandName = useBrand().brandName;
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat(src/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), false);
    var _brandName = RESPONSIVE_LOGOS[brandName], height = _brandName.height, title = _brandName.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: baseLocalizedUrl,
        title: title,
        "aria-label": "logo",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLogo, {
            brand: brandName,
            responsive: true,
            height: "".concat(height[isMobile ? "mobile" : "desktop"], "px"),
            withClaim: !isMobile
        })
    });
};
BrandLogo.defaultProps = BrandLogo_defaultProps;


;// CONCATENATED MODULE: ../../frontend/entities/src/BrandLogo/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/search/types.ts


var LOCATION_TYPES = {
    airport: "airport",
    all: "all",
    city: "city",
    citywithoutrail: "citywithoutrail",
    multiairport_single: "multiairport_single",
    multiairports: "multiairports",
    multirail_single: "multirail_single",
    normal: "normal",
    multirail: "multirail",
    rail_only: "rail_only",
    rail: "rail"
};
var getDisplayName = function getDisplayName(suggestion) {
    return "".concat(suggestion.cityName).concat(suggestion.typeDisplay ? " ".concat(suggestion.typeDisplay) : "");
};
function getLocation(suggestion) {
    var name = getDisplayName(suggestion);
    var baseLocation = {
        name: name,
        cityCode: suggestion.bmCode,
        cityName: suggestion.cityName
    };
    switch(suggestion.type){
        case LOCATION_TYPES.multiairport_single:
        case LOCATION_TYPES.airport:
        case LOCATION_TYPES.multiairports:
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, baseLocation), {
                type: "airport",
                iataCode: String(suggestion.airportCode)
            });
        case LOCATION_TYPES.city:
        case LOCATION_TYPES.citywithoutrail:
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, baseLocation), {
                type: "city"
            });
        case LOCATION_TYPES.multirail:
        case LOCATION_TYPES.rail_only:
        case LOCATION_TYPES.multirail_single:
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, baseLocation), {
                type: "rail",
                railCode: String(suggestion.railCode)
            });
        default:
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, baseLocation), {
                type: "all"
            });
    }
}

// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(4073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5680);
;// CONCATENATED MODULE: ../../common/landingpages/view/src/common/element/locale.ts
var ALLOWED_MARKETS = [
    "DE",
    "FR",
    "ES",
    "IT",
    "NL"
];

;// CONCATENATED MODULE: ../../frontend/entities/src/search/SuggestProvider.ts






function assertIsValidMarket(market) {
    if (!ALLOWED_MARKETS.includes(market)) {
        throw new Error("Value ".concat(market, " is not a MarketCode"));
    }
}
var getXWhitelabel = function getXWhitelabel(market) {
    assertIsValidMarket(market);
    switch(market){
        case "DE":
            return "DE_billiger-mietwagen";
        case "FR":
            return "FR_carigami";
        default:
            assertIsValidMarket(market);
            return "".concat(market, "_floyt");
    }
};
var authInterceptorGenerator = function authInterceptorGenerator(bearerAuth) {
    return function(config) {
        Object.assign(config.headers, {
            Authorization: bearerAuth
        });
        return config;
    };
};
var SuggestProvider = /*#__PURE__*/ function() {
    "use strict";
    function SuggestProvider(consumerApiSettings, language, market) {
        (0,_class_call_check/* default */.Z)(this, SuggestProvider);
        this.token = null;
        this.searchSuggestionsCache = {};
        this.consumerApiSettings = consumerApiSettings;
        this.options = {
            headers: {
                "X-Whitelabel": getXWhitelabel(market),
                "Accept-Language": language
            }
        };
        this.suggestClient = src/* http.getApi */.dJ.getApi(consumerApiSettings.host, (0,src_object_spread/* default */.Z)({}, this.options), "");
        this.refreshToken();
    }
    var _proto = SuggestProvider.prototype;
    _proto.refreshToken = function refreshToken() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!_this.token) {
                    src/* http.getApi */.dJ.getApi(_this.consumerApiSettings.host, {}, "").post(_this.consumerApiSettings.refreshTokenPath).then(function(result) {
                        var bearerAuth = "Bearer ".concat(result.data.token);
                        _this.token = bearerAuth;
                        var authInterceptor = authInterceptorGenerator(bearerAuth);
                        _this.suggestClient.interceptors.request.clear();
                        _this.suggestClient.interceptors.request.use(authInterceptor);
                    }).catch(function(e) {
                        if (true) {
                            var newrelic = window.newrelic;
                            newrelic === null || newrelic === void 0 ? void 0 : newrelic.noticeError(e);
                        }
                    });
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.keyExistsInCache = function keyExistsInCache(key) {
        return key in this.searchSuggestionsCache;
    };
    _proto.sendRequest = function sendRequest(searchString) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var searchSuggestions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (_this.keyExistsInCache(searchString)) {
                    return [
                        2,
                        _this.searchSuggestionsCache[searchString]
                    ];
                }
                searchSuggestions = _this.suggestClient.request({
                    method: "get",
                    url: _this.consumerApiSettings.locationSuggest,
                    params: {
                        query: searchString,
                        context: "car_rental"
                    }
                }).then(function(result) {
                    var suggestionResults = result.data.map(function(param) {
                        var bm_code = param.bm_code, city_name = param.city_name, country_name = param.country_name, id = param.id, image_path = param.image_path, latitude = param.latitude, longitude = param.longitude, min_price = param.min_price, state_name = param.state_name, title = param.title, type = param.type, type_display = param.type_display, airport_code = param.airport_code, rail_code = param.rail_code;
                        return {
                            bmCode: bm_code,
                            cityName: city_name,
                            countryName: country_name,
                            id: id,
                            image_path: image_path,
                            latitude: latitude,
                            longitude: longitude,
                            minPrice: min_price,
                            objectID: id,
                            stateName: state_name,
                            title: title,
                            type: type,
                            typeDisplay: type_display,
                            airportCode: airport_code,
                            railCode: rail_code
                        };
                    });
                    _this.searchSuggestionsCache[searchString] = suggestionResults;
                    return suggestionResults;
                }).catch(function(e) {
                    if (true) {
                        var newrelic = window.newrelic;
                        newrelic === null || newrelic === void 0 ? void 0 : newrelic.noticeError(e);
                    }
                    return null;
                });
                return [
                    2,
                    searchSuggestions
                ];
            });
        })();
    };
    SuggestProvider.getInstance = function getInstance(consumerApiSettings, language, market) {
        if (!this.instance) {
            this.instance = new this(consumerApiSettings, language, market);
        }
        return this.instance;
    };
    return SuggestProvider;
}();


;// CONCATENATED MODULE: ../../frontend/entities/src/search/useSearchSuggestions.tsx



var DEBOUNCE_TIME_MS = 250;
var useSearchSuggestions = function useSearchSuggestions(language, market, settings) {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(null), results = ref1[0], setResults = ref1[1];
    var searchSuggestProvider = (0,react.useMemo)(function() {
        return SuggestProvider.getInstance(settings, language, market);
    }, [
        settings,
        language,
        market
    ]);
    var sendRequest = (0,react.useCallback)(function(searchString) {
        searchSuggestProvider.sendRequest(searchString).then(function(searchResults) {
            setLoading(false);
            setResults(searchResults);
        }).catch(function() {
            setLoading(false);
        });
    }, [
        searchSuggestProvider
    ]);
    var debouncedSendRequest = (0,react.useMemo)(function() {
        return debounce_default()(sendRequest, DEBOUNCE_TIME_MS);
    }, [
        sendRequest
    ]);
    var fetchSuggestions = (0,react.useCallback)(function(searchString) {
        setLoading(true);
        debouncedSendRequest(searchString);
    }, [
        debouncedSendRequest
    ]);
    return {
        clearResults: function clearResults() {
            setResults([]);
        },
        fetchSuggestions: fetchSuggestions,
        loading: loading,
        results: results
    };
};

;// CONCATENATED MODULE: ../../frontend/entities/src/search/index.ts



// EXTERNAL MODULE: ../../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(2174);
// EXTERNAL MODULE: ../../frontend/entities/src/_legacy/Host/index.ts + 2 modules
var Host = __webpack_require__(2081);
;// CONCATENATED MODULE: ../../frontend/entities/src/StructuredData/AutoRentalData.tsx




var AutoRentalData = function AutoRentalData() {
    var messages = (0,next_intl_cjs_production_min.useMessages)();
    var days = Object.keys(messages.features.documentLegacy.siteInformation.openingHoursSpecification.dayOfWeek);
    var formatImage = (0,Host.useHost)().formatImage;
    var siteInfo = (0,next_intl_cjs_production_min.useTranslations)("features.documentLegacy.siteInformation");
    var openingHours = days.map(function(day) {
        return siteInfo("openingHoursSpecification.dayOfWeek.".concat(day));
    }).filter(function(translation) {
        return !translation.startsWith("features");
    });
    var openingHoursSpecification = {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: openingHours,
        opens: siteInfo("openingHoursSpecification.opens"),
        closes: siteInfo("openingHoursSpecification.closes")
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* DataInterop.StructuredData */.Ku.J, {
        type: "AutoRental",
        data: {
            name: siteInfo("name"),
            image: formatImage(siteInfo("image")),
            telephone: siteInfo("telephone"),
            openingHoursSpecification: openingHoursSpecification
        },
        includeContext: true
    });
};


// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(2589);
;// CONCATENATED MODULE: ../../frontend/entities/src/StructuredData/FaqData.tsx



var extractContent = function extractContent(answer) {
    var contentfulAnswer = answer;
    return contentfulAnswer.text;
};
var FaqData = function FaqData(param) {
    var faqs = param.faqs, _name = param.name, name = _name === void 0 ? "" : _name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* DataInterop.StructuredData */.Ku.J, {
        data: {
            name: name,
            mainEntity: faqs.map(function(param) {
                var answer = param.answer, question = param.question;
                return {
                    "@type": "Question",
                    name: question,
                    acceptedAnswer: [
                        {
                            "@type": "Answer",
                            text: (0,rich_text_plain_text_renderer_es5/* documentToPlainTextString */.a)(extractContent(answer))
                        }, 
                    ]
                };
            })
        },
        type: "FAQPage",
        includeContext: true
    });
};

;// CONCATENATED MODULE: ../../frontend/entities/src/StructuredData/ProductData.tsx




var ProductData = function ProductData(param) {
    var products = param.products;
    var ref;
    if (!products || !((ref = products.aggregateRating) === null || ref === void 0 ? void 0 : ref.reviewCount)) {
        return null;
    }
    var aggregateRating = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, products.aggregateRating), {
        "@type": "AggregateRating",
        worstRating: 1,
        bestRating: 5
    });
    var data = (0,src_object_spread/* default */.Z)({
        brand: products === null || products === void 0 ? void 0 : products.brand,
        name: products === null || products === void 0 ? void 0 : products.name
    }, aggregateRating && {
        aggregateRating: aggregateRating
    });
    return products ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* DataInterop.StructuredData */.Ku.J, {
        includeContext: true,
        type: "Product",
        data: data
    }) : null;
};


;// CONCATENATED MODULE: ../../frontend/entities/src/StructuredData/index.ts




// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(613);
;// CONCATENATED MODULE: ../../frontend/entities/src/account/sessionData.ts




var LoginError;
(function(LoginError) {
    LoginError["Blocked"] = "blocked";
    LoginError["ExpiredPassword"] = "expiredPassword";
    LoginError["Unauthorized"] = "unauthorized";
    LoginError["Unknown"] = "unknown";
    LoginError["UnverifiedEmail"] = "unverifiedEmail";
    LoginError["Validation"] = "validation";
    LoginError["WeakPassword"] = "weakPassword";
})(LoginError || (LoginError = {}));
var handleLoginError = function handleLoginError(error) {
    switch(error){
        case "/general/errors/bad-request":
        case "/auth/errors/login/bad-request":
        case "/auth/errors/login/invalid-credentials":
            return LoginError.Validation;
        case "/auth/errors/login/expired-password":
            return LoginError.ExpiredPassword;
        case "/auth/errors/login/unverified-email":
            return LoginError.UnverifiedEmail;
        case "/auth/errors/login/weak-password":
            return LoginError.WeakPassword;
        case "/general/errors/undefined":
        case "/auth/errors/login/undefined":
        default:
            return LoginError.Unknown;
    }
};
var getAccountSession = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        src/* http.axiosInstance.get */.dJ.axiosInstance.get(url, {
                            withCredentials: true,
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getAccountSession(url) {
        return _ref.apply(this, arguments);
    };
}();
var updateAccountSession = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, accessToken, refreshToken) {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        src/* http.axiosInstance.post */.dJ.axiosInstance.post(url, {
                            access_token: accessToken,
                            refresh_token: refreshToken
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.status === 204
                    ];
            }
        });
    });
    return function updateAccountSession(url, accessToken, refreshToken) {
        return _ref.apply(this, arguments);
    };
}();
var login = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, urlSession, username, password, whitelabel) {
        var res, error, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        src/* http.axiosInstance.post */.dJ.axiosInstance.post(url, {
                            username: username,
                            password: password
                        }, {
                            headers: {
                                "X-Whitelabel": whitelabel
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!(res.status >= 200 && res.status <= 299)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        updateAccountSession(urlSession, res.data.access_token, res.data.refresh_token)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            loggedIn: true
                        }
                    ];
                case 4:
                    error = _state.sent();
                    if ((0,axios/* isAxiosError */.IZ)(error)) {
                        return [
                            2,
                            {
                                loggedIn: false,
                                error: handleLoginError((ref = error.response) === null || ref === void 0 ? void 0 : ref.data.type)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            loggedIn: false,
                            error: LoginError.Unknown
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function login(url, urlSession, username, password, whitelabel) {
        return _ref.apply(this, arguments);
    };
}();
var resendConfirmUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, emailAddress, whitelabel) {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        src/* http.axiosInstance.post */.dJ.axiosInstance.post(url, {
                            email_address: emailAddress
                        }, {
                            headers: {
                                "X-Whitelabel": whitelabel
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.status === 204
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function resendConfirmUser(url, emailAddress, whitelabel) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ../../frontend/entities/src/account/useSessionData.ts

var useSessionData = function useSessionData() {
    var result = src/* Context.useClientContext */._y.useClientContext("sessionData");
    var securityTokenValue = result.hasContext ? result.value.securityTokenValue : "";
    var gtmEnvironment = result.hasContext ? result.value.gtmEnvironment : "live";
    var anonymizeIP = result.hasContext ? result.value.anonymizeIP : true;
    return {
        securityTokenValue: securityTokenValue,
        gtmEnvironment: gtmEnvironment,
        anonymizeIP: anonymizeIP
    };
};


;// CONCATENATED MODULE: ../../frontend/entities/src/account/index.ts



;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/consent/consentManagement.ts
var CookieConsent;
(function(CookieConsent) {
    CookieConsent[CookieConsent["Unknown"] = 0] = "Unknown";
    CookieConsent[CookieConsent["Disabled"] = 1] = "Disabled";
    CookieConsent[CookieConsent["Requested"] = 2] = "Requested";
    CookieConsent[CookieConsent["Enabled"] = 3] = "Enabled";
})(CookieConsent || (CookieConsent = {}));
var checkConsent = function checkConsent() {
    try {
        var ucUserInteraction = window.localStorage.getItem("uc_user_interaction");
        if (ucUserInteraction === "true") {
            return CookieConsent.Enabled;
        }
        if (ucUserInteraction === null) {
            return CookieConsent.Requested;
        }
        return CookieConsent.Disabled;
    } catch (err) {
        // Catch `Usercentrics: Cross Domain Consent Sharing is not available.`
        return CookieConsent.Disabled;
    }
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/consent/useConsent.ts


var useConsent = function useConsent() {
    var ref = (0,react.useState)(CookieConsent.Unknown), consent = ref[0], setConsent = ref[1];
    var handleConsentChange = function handleConsentChange() {
        setConsent(checkConsent());
    };
    (0,react.useEffect)(function() {
        if (consent === CookieConsent.Unknown) {
            setConsent(checkConsent());
        }
        document.addEventListener("UC:consentChange", handleConsentChange);
        return function() {
            document.removeEventListener("UC:consentChange", handleConsentChange);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return consent;
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/consent/index.ts



;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/types.ts
var EventType;
(function(EventType) {
    EventType["GA"] = "gaEvent";
    EventType["PAGE_VIEW"] = "pageview";
    EventType["CUSTOM_CRITEO"] = "fireCriteoTag";
})(EventType || (EventType = {}));
var EventCategory;
(function(EventCategory) {
    EventCategory["INDEX"] = "index";
    EventCategory["ACCOUNT_LOGIN"] = "account/login";
    EventCategory["SEARCH_HISTORY"] = "searchHistory";
    EventCategory["TOOLTIP"] = "tooltip";
    EventCategory["ROUNDTRIP"] = "roundtrip";
    EventCategory["NAVIGATION"] = "navigation";
    EventCategory["DRIVERAGE"] = "driverage";
    EventCategory["CONFIENZA"] = "confienza";
    EventCategory["FAQ"] = "faq";
    EventCategory["SEARCH_BUTTON_OFFERBOX"] = "search_button_offerbox";
    EventCategory["CUSTOMER_REVIEW"] = "customer_review";
    EventCategory["APP_ICON"] = "app_icon";
    EventCategory["SOCIAL_MEDIA_ICON"] = "social_media_icon";
    EventCategory["GENERAL_FOOTER_LINKS"] = "general_footer_links";
    EventCategory["NEWSLETTER_REGISTRATION"] = "newsletter/registration";
    EventCategory["ALL"] = "all";
    EventCategory["QR_CODE_BANNER"] = "qr_code_banner";
    EventCategory["INFO_BANNER"] = "info_banner";
    EventCategory["WEB_VITALS"] = "web_vitals";
    EventCategory["STATIONS_MAP"] = "stations_map";
})(EventCategory || (EventCategory = {}));
var EventAction;
(function(EventAction) {
    EventAction["CLICK"] = "click";
    EventAction["CLICK_PHONE_TOOLTIP_VOUCHER_LINK"] = "clickPhoneTooltipVoucherLink";
    EventAction["HOVER"] = "hover";
    EventAction["LOGIN_LOGOUT"] = "login_logout";
    EventAction["LOGIN_MENU"] = "login_menu";
    EventAction["LOGIN_MENU_CREATE_ACCOUNT"] = "login_menu_create_account";
    EventAction["LOGIN_MENU_FORGOTPWD"] = "login_menu_forgotpwd";
    EventAction["LOGIN_MENU_LOGIN"] = "login_menu_login";
    EventAction["LOGIN_MENU_MYBOOKINGS"] = "login_menu_mybookings";
    EventAction["LOGIN_MENU_MYDATA"] = "login_menu_mydata";
    EventAction["LOGIN_MENU_MYPAYMENT"] = "login_menu_mypayment";
    EventAction["MASTERCARD_CARIGAMI_CLICKED"] = "mastercard_carigami_clicked";
    EventAction["MASTERCARD_CARIGAMI_SEEN"] = "mastercard_carigami_seen";
    EventAction["ONEWAY_SELECT"] = "oneway_select";
    EventAction["SEARCHFORM_MORE_OPTIONS"] = "searchform_more_options";
    EventAction["SEARCHFORM_MORE_OPTIONS_FILTER_CLICK"] = "searchform_more_options_filter_click";
    EventAction["SELECT"] = "select";
})(EventAction || (EventAction = {}));
var EventLabel;
(function(EventLabel) {
    EventLabel["LOGGED"] = "logged";
    EventLabel["UNLOGGED"] = "unlogged";
    EventLabel["OPEN"] = "open";
    EventLabel["CLOSED"] = "closed";
})(EventLabel || (EventLabel = {}));
var CriteoPageType;
(function(CriteoPageType) {
    CriteoPageType["Homepage"] = "Homepage";
})(CriteoPageType || (CriteoPageType = {}));
var CriteoSiteType;
(function(CriteoSiteType) {
    CriteoSiteType["desktop"] = "d";
})(CriteoSiteType || (CriteoSiteType = {}));
var environments = {
    live: "live",
    dev: "dev"
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/events.ts




/**
 * Push data to the data layer
 * https://developers.google.com/tag-platform/tag-manager/web/datalayer
 */ var trackEvent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (false) {}
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
            return [
                2
            ];
        });
    });
    return function trackEvent(data) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * PageView events
 */ var trackPageView = function trackPageView(data) {
    if (!data) {
        return;
    }
    trackEvent((0,src_object_spread/* default */.Z)({
        event: EventType.PAGE_VIEW
    }, data));
};
/**
 * Custom events
 * https://silvertours.atlassian.net/wiki/spaces/PAGES/pages/2369650717/Tracking+events+on+the+landing+pages#Current-events
 */ // Account menu opened
var trackShowLogin = function trackShowLogin(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.LOGIN_MENU,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// Landing page loaded | Criteo event
var trackCriteo = function trackCriteo() {
    trackEvent({
        event: EventType.CUSTOM_CRITEO,
        criteo_tag_params: {
            CriteoPageType: CriteoPageType.Homepage,
            CriteoSiteType: CriteoSiteType.desktop
        }
    });
};
// Login form submitted
var trackLogin = function trackLogin() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_LOGIN,
        eventLabel: EventLabel.LOGGED
    });
};
// "Password forgotten" link clicked
var trackPasswordForgotten = function trackPasswordForgotten(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_FORGOTPWD,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "Register new user" link clicked
var trackNewUser = function trackNewUser(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_CREATE_ACCOUNT,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// Logout
var trackLogout = function trackLogout() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_LOGOUT,
        eventLabel: EventLabel.UNLOGGED
    });
};
// "My bookings" link clicked
var trackMyBookings = function trackMyBookings(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_MYBOOKINGS,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "My data“" link clicked
var trackMyData = function trackMyData(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_MYDATA,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "My payment data" link clicked
var trackMyPayment = function trackMyPayment(param) {
    var _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ACCOUNT_LOGIN,
        eventAction: EventAction.LOGIN_MENU_MYPAYMENT,
        eventLabel: isLoggedIn ? EventLabel.LOGGED : EventLabel.UNLOGGED
    });
};
// "Get voucher" button clicked
var trackVoucherButtonClick = function trackVoucherButtonClick() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ALL,
        eventAction: EventAction.CLICK_PHONE_TOOLTIP_VOUCHER_LINK,
        eventLabel: true
    });
};
// Opening times tooltip opened (via hover)
var trackOpeningTimesTooltipOpened = function trackOpeningTimesTooltipOpened() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "callcenter"
    });
};
// Newsletter form submitted on index page
var trackNewsletterRegistrationIndex = function trackNewsletterRegistrationIndex() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.CLICK,
        eventLabel: "click_NewsletterSigninBoxEbook"
    });
};
// Newsletter form submitted anywhere else
var trackNewsletterRegistration = function trackNewsletterRegistration() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.NEWSLETTER_REGISTRATION,
        eventAction: EventAction.CLICK,
        eventLabel: "submit"
    });
};
// "More options" in search form clicked
var trackToggleMoreOptions = function trackToggleMoreOptions(showOptions) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.SEARCHFORM_MORE_OPTIONS,
        eventLabel: showOptions ? EventLabel.OPEN : EventLabel.CLOSED
    });
};
// Filter in search form clicked
var trackOptionsChange = function trackOptionsChange(id) {
    if (!id) {
        return;
    }
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INDEX,
        eventAction: EventAction.SEARCHFORM_MORE_OPTIONS_FILTER_CLICK,
        eventLabel: id
    });
};
// Selecting an item from the search history
var trackSearchHistorySelect = function trackSearchHistorySelect() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SEARCH_HISTORY,
        eventAction: EventAction.CLICK,
        eventLabel: "history_item"
    });
};
// Deleting an item from the search history
var trackSearchHistoryDelete = function trackSearchHistoryDelete() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SEARCH_HISTORY,
        eventAction: EventAction.CLICK,
        eventLabel: "delete_history"
    });
};
// Opening times tooltip footer opened (via hover)
var trackFooterTooltipOpened = function trackFooterTooltipOpened() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "callcenter_footer"
    });
};
// Main navigation list item clicked
var trackNavigationClicked = function trackNavigationClicked(name) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.NAVIGATION,
        eventAction: EventAction.CLICK,
        eventLabel: name
    });
};
// Hover on free cancellation badge
var trackCancellationHover = function trackCancellationHover() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "cancellation_stage"
    });
};
var trackSavingHover = function trackSavingHover() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "saving_stage"
    });
};
// Info Banner link clicked
var trackInfoBannerLinkClicked = function trackInfoBannerLinkClicked(label) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INFO_BANNER,
        eventAction: EventAction.CLICK,
        eventLabel: "info_banner_".concat(label)
    });
};
var trackInfoBannerCloseClicked = function trackInfoBannerCloseClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.INFO_BANNER,
        eventAction: EventAction.CLICK,
        eventLabel: "info_banner_close"
    });
};
// Hover on driver age
var trackDriverAgeHover = function trackDriverAgeHover() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.TOOLTIP,
        eventAction: EventAction.HOVER,
        eventLabel: "driver_age"
    });
};
// Change roundtrip to oneway dropdown
var trackRoundtripOneway = function trackRoundtripOneway() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.ROUNDTRIP,
        eventAction: EventAction.ONEWAY_SELECT,
        eventLabel: ""
    });
};
// Change driver age dropdown from default age
var trackDriverAgeSelect = function trackDriverAgeSelect() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.DRIVERAGE,
        eventAction: EventAction.SELECT,
        eventLabel: ""
    });
};
// Confienza clicked (just Floyt)
var trackConfienzaClicked = function trackConfienzaClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.CONFIENZA,
        eventAction: EventAction.CLICK,
        eventLabel: "confienza_stage"
    });
};
// FAQ list item clicked (open expandable)
var trackFaqItemClicked = function trackFaqItemClicked(pagepath) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.FAQ,
        eventAction: EventAction.CLICK,
        eventLabel: pagepath
    });
};
// Button to Helpcenter is clicked
var trackHelpcenterButtonClicked = function trackHelpcenterButtonClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.FAQ,
        eventAction: EventAction.CLICK,
        eventLabel: "zendesk_button"
    });
};
// Button search in offer boxes clicked
var trackSearchButtonOfferBoxClicked = function trackSearchButtonOfferBoxClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SEARCH_BUTTON_OFFERBOX,
        eventAction: EventAction.CLICK,
        eventLabel: ""
    });
};
// Customer review read more clicked
var trackCustomerReviewClicked = function trackCustomerReviewClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.CUSTOMER_REVIEW,
        eventAction: EventAction.CLICK,
        eventLabel: ""
    });
};
// iOS App link clicked
var trackIosAppLinkClicked = function trackIosAppLinkClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "landingpage_promo_banner_appstore_tap"
    });
};
// iOS App link footer clicked
var trackIosAppLinkFooterClicked = function trackIosAppLinkFooterClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "iOS_download_footer"
    });
};
// Android App link clicked
var trackAndroidAppLinkClicked = function trackAndroidAppLinkClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "landingpage_promo_banner_playstore_tap"
    });
};
// Android App footer link clicked
var trackAndroidAppLinkFooterClicked = function trackAndroidAppLinkFooterClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.APP_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "ANDROID_download_footer"
    });
};
// Facebook footer link clicked
var trackFacebookFooterClicked = function trackFacebookFooterClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SOCIAL_MEDIA_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "FB_footer"
    });
};
// Instagram footer link clicked
var trackInstagramFooterClicked = function trackInstagramFooterClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SOCIAL_MEDIA_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "insta_footer"
    });
};
// Pinterest footer link clicked
var trackPinterestFooterClicked = function trackPinterestFooterClicked() {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.SOCIAL_MEDIA_ICON,
        eventAction: EventAction.CLICK,
        eventLabel: "PIN_footer"
    });
};
// All other footer links clicked
var trackFooterClicked = function trackFooterClicked(name) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.GENERAL_FOOTER_LINKS,
        eventAction: EventAction.CLICK,
        eventLabel: name
    });
};
var trackStationMapStationClick = function trackStationMapStationClick(stationKind) {
    trackEvent({
        event: EventType.GA,
        eventCategory: EventCategory.STATIONS_MAP,
        eventAction: EventAction.CLICK,
        eventLabel: "station_type_".concat(stationKind)
    });
};
function isINPMetric(metric) {
    return metric.name === "INP";
}
var trackWebVitalsMetric = function trackWebVitalsMetric(metric) {
    var name = metric.name, delta = metric.delta, id = metric.id;
    var eventPayload = {
        event: EventType.GA,
        eventCategory: EventCategory.WEB_VITALS,
        eventAction: name,
        // The `id` value will be unique to the current page load. When sending
        // multiple values from the same page (e.g. for CLS), Google Analytics can
        // compute a total by grouping on this ID (note: requires `eventLabel` to
        // be a dimension in your report).
        eventLabel: id,
        // Google Analytics metrics must be integers, so the value is rounded.
        // For CLS the value is first multiplied by 1000 for greater precision
        // (note: increase the multiplier for greater precision if needed).
        eventValue: Math.round(name === "CLS" ? delta * 1000 : delta),
        // Use a non-interaction event to avoid affecting bounce rate.
        nonInteraction: true,
        // Use `sendBeacon()` if the browser supports it.
        transport: "beacon"
    };
    if (isINPMetric(metric)) {
        var attribution = metric.attribution;
        // Element that is interacted with.
        eventPayload.eventTarget = attribution.eventTarget;
        // Type of interaction with the element.
        eventPayload.eventType = attribution.eventType;
    }
    trackEvent(eventPayload);
};


// EXTERNAL MODULE: ../../node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(6182);
;// CONCATENATED MODULE: ../../node_modules/web-vitals/dist/web-vitals.attribution.js
var e,t,n,r,i,a=function(){return window.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0]},o=function(e){if("loading"===document.readyState)return"loading";var t=a();if(t){if(e<t.domInteractive)return"loading";if(0===t.domContentLoadedEventStart||e<t.domContentLoadedEventStart)return"dom-interactive";if(0===t.domComplete||e<t.domComplete)return"dom-content-loaded"}return"complete"},u=function(e){var t=e.nodeName;return 1===e.nodeType?t.toLowerCase():t.toUpperCase().replace(/^#/,"")},c=function(e,t){var n="";try{for(;e&&9!==e.nodeType;){var r=e,i=r.id?"#"+r.id:u(r)+(r.classList&&r.classList.value&&r.classList.value.trim()&&r.classList.value.trim().length?"."+r.classList.value.trim().replace(/\s+/g,"."):"");if(n.length+i.length>(t||100)-1)return n||i;if(n=n?i+">"+n:i,r.id)break;e=r.parentNode}}catch(e){}return n},s=-1,f=function(){return s},d=function(e){addEventListener("pageshow",(function(t){t.persisted&&(s=t.timeStamp,e(t))}),!0)},l=function(){var e=a();return e&&e.activationStart||0},m=function(e,t){var n=a(),r="navigate";f()>=0?r="back-forward-cache":n&&(document.prerendering||l()>0?r="prerender":document.wasDiscarded?r="restore":n.type&&(r=n.type.replace(/_/g,"-")));return{name:e,value:void 0===t?-1:t,rating:"good",delta:0,entries:[],id:"v3-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:r}},v=function(e,t,n){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var r=new PerformanceObserver((function(e){Promise.resolve().then((function(){t(e.getEntries())}))}));return r.observe(Object.assign({type:e,buffered:!0},n||{})),r}}catch(e){}},p=function(e,t,n,r){var i,a;return function(o){t.value>=0&&(o||r)&&((a=t.value-(i||0))||void 0===i)&&(i=t.value,t.delta=a,t.rating=function(e,t){return e>t[1]?"poor":e>t[0]?"needs-improvement":"good"}(t.value,n),e(t))}},h=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},g=function(e){var t=function(t){"pagehide"!==t.type&&"hidden"!==document.visibilityState||e(t)};addEventListener("visibilitychange",t,!0),addEventListener("pagehide",t,!0)},T=function(e){var t=!1;return function(n){t||(e(n),t=!0)}},y=(/* unused pure expression or super */ null && (-1)),E=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},S=function(e){"hidden"===document.visibilityState&&y>-1&&(y="visibilitychange"===e.type?e.timeStamp:0,b())},L=function(){addEventListener("visibilitychange",S,!0),addEventListener("prerenderingchange",S,!0)},b=function(){removeEventListener("visibilitychange",S,!0),removeEventListener("prerenderingchange",S,!0)},C=function(){return y<0&&(y=E(),L(),d((function(){setTimeout((function(){y=E(),L()}),0)}))),{get firstHiddenTime(){return y}}},w=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},M=(/* unused pure expression or super */ null && ([1800,3e3])),x=function(e,t){t=t||{},w((function(){var n,r=C(),i=m("FCP"),a=v("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(a.disconnect(),e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-l(),0),i.entries.push(e),n(!0)))}))}));a&&(n=p(e,i,M,t.reportAllChanges),d((function(r){i=m("FCP"),n=p(e,i,M,t.reportAllChanges),h((function(){i.value=performance.now()-r.timeStamp,n(!0)}))})))}))},A=(/* unused pure expression or super */ null && ([.1,.25])),F=function(e,t){!function(e,t){t=t||{},x(T((function(){var n,r=m("CLS",0),i=0,a=[],o=function(e){e.forEach((function(e){if(!e.hadRecentInput){var t=a[0],n=a[a.length-1];i&&e.startTime-n.startTime<1e3&&e.startTime-t.startTime<5e3?(i+=e.value,a.push(e)):(i=e.value,a=[e])}})),i>r.value&&(r.value=i,r.entries=a,n())},u=v("layout-shift",o);u&&(n=p(e,r,A,t.reportAllChanges),g((function(){o(u.takeRecords()),n(!0)})),d((function(){i=0,r=m("CLS",0),n=p(e,r,A,t.reportAllChanges),h((function(){return n()}))})),setTimeout(n,0))})))}((function(t){!function(e){if(e.entries.length){var t=e.entries.reduce((function(e,t){return e&&e.value>t.value?e:t}));if(t&&t.sources&&t.sources.length){var n=(r=t.sources).find((function(e){return e.node&&1===e.node.nodeType}))||r[0];if(n)return void(e.attribution={largestShiftTarget:c(n.node),largestShiftTime:t.startTime,largestShiftValue:t.value,largestShiftSource:n,largestShiftEntry:t,loadState:o(t.startTime)})}}var r;e.attribution={}}(t),e(t)}),t)},I=function(e,t){x((function(t){!function(e){if(e.entries.length){var t=a(),n=e.entries[e.entries.length-1];if(t){var r=t.activationStart||0,i=Math.max(0,t.responseStart-r);return void(e.attribution={timeToFirstByte:i,firstByteToFCP:e.value-i,loadState:o(e.entries[0].startTime),navigationEntry:t,fcpEntry:n})}}e.attribution={timeToFirstByte:0,firstByteToFCP:e.value,loadState:o(f())}}(t),e(t)}),t)},P={passive:!0,capture:!0},B=new Date,D=function(r,i){e||(e=i,t=r,n=new Date,q(removeEventListener),k())},k=function(){if(t>=0&&t<n-B){var i={entryType:"first-input",name:e.type,target:e.target,cancelable:e.cancelable,startTime:e.timeStamp,processingStart:e.timeStamp+t};r.forEach((function(e){e(i)})),r=[]}},R=function(e){if(e.cancelable){var t=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,t){var n=function(){D(e,t),i()},r=function(){i()},i=function(){removeEventListener("pointerup",n,P),removeEventListener("pointercancel",r,P)};addEventListener("pointerup",n,P),addEventListener("pointercancel",r,P)}(t,e):D(t,e)}},q=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(t){return e(t,R,P)}))},H=(/* unused pure expression or super */ null && ([100,300])),N=function(n,i){i=i||{},w((function(){var a,o=C(),u=m("FID"),c=function(e){e.startTime<o.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),a(!0))},s=function(e){e.forEach(c)},f=v("first-input",s);a=p(n,u,H,i.reportAllChanges),f&&g(T((function(){s(f.takeRecords()),f.disconnect()}))),f&&d((function(){var o;u=m("FID"),a=p(n,u,H,i.reportAllChanges),r=[],t=-1,e=null,q(addEventListener),o=c,r.push(o),k()}))}))},O=function(e,t){N((function(t){!function(e){var t=e.entries[0];e.attribution={eventTarget:c(t.target),eventType:t.name,eventTime:t.startTime,eventEntry:t,loadState:o(t.startTime)}}(t),e(t)}),t)},j=0,U=1/0,V=0,_=function(e){e.forEach((function(e){e.interactionId&&(U=Math.min(U,e.interactionId),V=Math.max(V,e.interactionId),j=V?(V-U)/7+1:0)}))},z=function(){return i?j:performance.interactionCount||0},G=function(){"interactionCount"in performance||i||(i=v("event",_,{type:"event",buffered:!0,durationThreshold:0}))},J=[200,500],K=0,Q=function(){return z()-K},W=[],X={},Y=function(e){var t=W[W.length-1],n=X[e.interactionId];if(n||W.length<10||e.duration>t.latency){if(n)n.entries.push(e),n.latency=Math.max(n.latency,e.duration);else{var r={id:e.interactionId,latency:e.duration,entries:[e]};X[r.id]=r,W.push(r)}W.sort((function(e,t){return t.latency-e.latency})),W.splice(10).forEach((function(e){delete X[e.id]}))}},Z=function(e,t){t=t||{},w((function(){var n;G();var r,i=m("INP"),a=function(e){e.forEach((function(e){(e.interactionId&&Y(e),"first-input"===e.entryType)&&(!W.some((function(t){return t.entries.some((function(t){return e.duration===t.duration&&e.startTime===t.startTime}))}))&&Y(e))}));var t,n=(t=Math.min(W.length-1,Math.floor(Q()/50)),W[t]);n&&n.latency!==i.value&&(i.value=n.latency,i.entries=n.entries,r())},o=v("event",a,{durationThreshold:null!==(n=t.durationThreshold)&&void 0!==n?n:40});r=p(e,i,J,t.reportAllChanges),o&&("PerformanceEventTiming"in window&&"interactionId"in PerformanceEventTiming.prototype&&o.observe({type:"first-input",buffered:!0}),g((function(){a(o.takeRecords()),i.value<0&&Q()>0&&(i.value=0,i.entries=[]),r(!0)})),d((function(){W=[],K=z(),i=m("INP"),r=p(e,i,J,t.reportAllChanges)})))}))},$=function(e,t){Z((function(t){!function(e){if(e.entries.length){var t=e.entries.sort((function(e,t){return t.duration-e.duration||t.processingEnd-t.processingStart-(e.processingEnd-e.processingStart)}))[0],n=e.entries.find((function(e){return e.target}));e.attribution={eventTarget:c(n&&n.target),eventType:t.name,eventTime:t.startTime,eventEntry:t,loadState:o(t.startTime)}}else e.attribution={}}(t),e(t)}),t)},ee=(/* unused pure expression or super */ null && ([2500,4e3])),te={},ne=function(e,t){!function(e,t){t=t||{},w((function(){var n,r=C(),i=m("LCP"),a=function(e){var t=e[e.length-1];t&&t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-l(),0),i.entries=[t],n())},o=v("largest-contentful-paint",a);if(o){n=p(e,i,ee,t.reportAllChanges);var u=T((function(){te[i.id]||(a(o.takeRecords()),o.disconnect(),te[i.id]=!0,n(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return setTimeout(u,0)}),!0)})),g(u),d((function(r){i=m("LCP"),n=p(e,i,ee,t.reportAllChanges),h((function(){i.value=performance.now()-r.timeStamp,te[i.id]=!0,n(!0)}))}))}}))}((function(t){!function(e){if(e.entries.length){var t=a();if(t){var n=t.activationStart||0,r=e.entries[e.entries.length-1],i=r.url&&performance.getEntriesByType("resource").filter((function(e){return e.name===r.url}))[0],o=Math.max(0,t.responseStart-n),u=Math.max(o,i?(i.requestStart||i.startTime)-n:0),s=Math.max(u,i?i.responseEnd-n:0),f=Math.max(s,r?r.startTime-n:0),d={element:c(r.element),timeToFirstByte:o,resourceLoadDelay:u-o,resourceLoadTime:s-u,elementRenderDelay:f-s,navigationEntry:t,lcpEntry:r};return r.url&&(d.url=r.url),i&&(d.lcpResourceEntry=i),void(e.attribution=d)}}e.attribution={timeToFirstByte:0,resourceLoadDelay:0,resourceLoadTime:0,elementRenderDelay:e.value}}(t),e(t)}),t)},re=(/* unused pure expression or super */ null && ([800,1800])),ie=function e(t){document.prerendering?w((function(){return e(t)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(t)}),!0):setTimeout(t,0)},ae=function(e,t){t=t||{};var n=m("TTFB"),r=p(e,n,re,t.reportAllChanges);ie((function(){var i=a();if(i){var o=i.responseStart;if(o<=0||o>performance.now())return;n.value=Math.max(o-l(),0),n.entries=[i],r(!0),d((function(){n=m("TTFB",0),(r=p(e,n,re,t.reportAllChanges))(!0)}))}}))},oe=function(e,t){ae((function(t){!function(e){if(e.entries.length){var t=e.entries[0],n=t.activationStart||0,r=Math.max(t.domainLookupStart-n,0),i=Math.max(t.connectStart-n,0),a=Math.max(t.requestStart-n,0);e.attribution={waitingTime:r,dnsTime:i-r,connectionTime:a-i,requestTime:e.value-a,navigationEntry:t}}else e.attribution={waitingTime:0,dnsTime:0,connectionTime:0,requestTime:0}}(t),e(t)}),t)};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(1899);
;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/dataLayer.ts
var hasSearchParam = function hasSearchParam(param) {
    return  true ? Boolean(new URLSearchParams(window.location.search).get(param)) : 0;
};
var baseConfig = {
    environment: "live",
    affiliateName: "bm",
    SPA: false,
    nextjs: true,
    twa: hasSearchParam("twa"),
    hasTduid: hasSearchParam("tduid"),
    blockUserCentrics: true,
    anonymizeIP: true,
    locale: "",
    language: "",
    market: ""
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/routes.ts



var RegexType = /$/;
var PLACEHOLDER_VAR = "%s";
var getRoutes = function getRoutes(settings) {
    var config = (0,src_object_spread/* default */.Z)({}, baseConfig, settings);
    var routes = [
        {
            path: "/",
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/cars/bm/Index",
                landingpageKategorie: "",
                websitebereich: "Startseite, Mietwagen-Suche",
                englishPageName: "d/funnel/index",
                landingPageType: "index"
            })
        },
        {
            path: "/vermieter-bewertung.html",
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/vermieter-bewertung.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/partnerlist",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen-flughafen.html",
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/mietwagen-flughafen.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/flughafen",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen-bahnhof.html",
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/mietwagen-bahnhof.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/bahnhof",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen.htm",
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/mietwagen.htm",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/weltweit",
                landingPageType: "index"
            })
        },
        {
            path: "/mietwagen-bewertung.html",
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/mietwagen-bewertung.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/feedbacklist/",
                landingPageType: "index"
            })
        },
        {
            // regex, e.g. autovermieter-avis.html
            path: /\/(autovermieter-(.*))\.html/,
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/partner-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/partner-".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. mietwagen-muenchen.html
            path: /\/(mietwagen-(.*))\.html/,
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/mietwagen-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/mietwagen/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. autovermietung-berlin.html
            path: /\/(autovermietung-(.*))\.html/,
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/autovermietung-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/mietwagen/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. rentacar-lax.html
            path: /\/(rentacar-(.*))\.html/,
            lang: "de",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/rentacar-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/rentacar/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            path: "/monde.html",
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/monde.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/weltweit",
                landingPageType: "index"
            })
        },
        {
            path: "/avis-client.html",
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/avis-client.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/feedbacklist/",
                landingPageType: "index"
            })
        },
        {
            path: "/avis-par-loueur.html",
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/avis-par-loueur.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/partnerlist",
                landingPageType: "index"
            })
        },
        {
            path: "/location-voiture-aeroport.html",
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/location-voiture-aeroport.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/flughafen",
                landingPageType: "index"
            })
        },
        {
            path: "/location-voiture-gare.html",
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/location-voiture-gare.html",
                landingpageKategorie: "",
                websitebereich: "Content-Seite",
                englishPageName: "d/seo/mietwagen/bahnhof",
                landingPageType: "index"
            })
        },
        {
            // regex, e.g. loueur-jucy-rentals.html
            path: /\/(loueur-(.*))\.html/,
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/partenaire-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/partenaire-".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. louer-gare-lille.html
            path: /\/(louer-(.*))\.html/,
            lang: "fr",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/location-voiture-".concat(PLACEHOLDER_VAR, ".html"),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/location-voiture-".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        },
        {
            // regex, e.g. /alquiler-coche/espana/navarra
            path: /\/(alquiler-coche\/(.*))/,
            lang: "es",
            tracking: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
                virtPath: "/alquiler-coche/".concat(PLACEHOLDER_VAR),
                landingpageKategorie: PLACEHOLDER_VAR,
                websitebereich: "Landingpage, Mietwagen-Suche",
                englishPageName: "d/seo/alquiler-coche/".concat(PLACEHOLDER_VAR),
                landingPageType: "seo"
            })
        }, 
    ];
    return routes;
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/utils.ts



/**
 * Transform strings like 'loueur-jucy-rentals' to "Loueur Jucy Rentals"
 */ var upperCaseWord = function upperCaseWord(str) {
    var arr = str.replace(/-/g, " ").split(" ");
    var i;
    for(i = 0; i < arr.length; i += 1){
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(" ");
};
var getTrackingDataForPath = function getTrackingDataForPath(settings, path) {
    // remove query string params
    var ref = (0,src_sliced_to_array/* default */.Z)(path.split("?"), 1), pathname = ref[0];
    var routes = getRoutes(settings);
    var route = routes.find(function(r) {
        return r.path === pathname || (0,_type_of/* default */.Z)(r.path) === (typeof RegexType === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(RegexType)) && new RegExp(r.path).test(pathname);
    });
    if (!route) {
        return null;
    }
    var pathIsRegex = (0,_type_of/* default */.Z)(route.path) === (typeof RegexType === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(RegexType));
    if (pathIsRegex) {
        var regex = new RegExp(route.path);
        var ref1 = (0,src_sliced_to_array/* default */.Z)(pathname.match(regex) || [], 3), fullMatch = ref1[1], match = ref1[2];
        if (match) {
            route.tracking.virtPath = route.tracking.virtPath.replace(PLACEHOLDER_VAR, match);
            // TODO: assign Country or State to `landingpageKategorie`
            route.tracking.landingpageKategorie = upperCaseWord(fullMatch);
            route.tracking.englishPageName = route.tracking.englishPageName.replace(PLACEHOLDER_VAR, match);
        }
    }
    return route.tracking;
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/hooks.ts









var mapDataLayerSettings = function mapDataLayerSettings(siteSettings) {
    var ref, ref1;
    return {
        environment: siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.sessionData) === null || ref === void 0 ? void 0 : ref.gtmEnvironment,
        anonymizeIP: siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.sessionData) === null || ref1 === void 0 ? void 0 : ref1.anonymizeIP,
        locale: siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.language,
        language: siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.language,
        market: siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.market
    };
};
/**
 * React Hook to track custom pageView event on every route change
 */ var usePageView = function usePageView() {
    var siteInfo = useSiteInfo();
    var router = (0,next_router.useRouter)();
    var triggerEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(path) {
            var settings, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (siteInfo.settingsLoaded) {
                    settings = mapDataLayerSettings(siteInfo.settings);
                    data = getTrackingDataForPath(settings, path);
                    trackPageView(data);
                    if (!siteInfo.settings.isInternalCall) {
                        trackCriteo();
                    }
                }
                return [
                    2
                ];
            });
        });
        return function(path) {
            return _ref.apply(this, arguments);
        };
    }(), [
        siteInfo.settingsLoaded
    ]);
    // initial page view tracking
    (0,react.useEffect)(function() {
        if (router.isReady && siteInfo.settingsLoaded) {
            triggerEvent(router.asPath);
        }
    }, [
        router.isReady,
        router.asPath,
        triggerEvent,
        siteInfo.settingsLoaded
    ]);
    // route change page view tracking
    (0,react.useEffect)(function() {
        var handleRouteChange = function handleRouteChange(path) {
            triggerEvent(path);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router.events,
        triggerEvent
    ]);
};
var useElementScrolledToView = function useElementScrolledToView(ref, callback) {
    var _$ref = (0,react.useState)(false), seen = _$ref[0], setSeen = _$ref[1];
    var intersection = (0,useIntersection/* default */.Z)(ref, {
        root: null,
        threshold: 1
    });
    (0,react.useEffect)(function() {
        if ((intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting) && !seen) {
            callback();
            setSeen(true);
        }
    }, [
        callback,
        intersection,
        seen
    ]);
};
/** @deprecated Use `next/web-vitals` when Next.js 13+ is available. */ var useReportWebVitals = function useReportWebVitals() {
    (0,react.useEffect)(function() {
        $(trackWebVitalsMetric, {
            reportAllChanges: true
        });
    // onLCP(trackWebVitalsMetric);
    // onCLS(trackWebVitalsMetric);
    // onFID(trackWebVitalsMetric);
    });
};


// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(5847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/script.tsx


/**
 * Google Tag Manager Script
 */ var GTMScript = function GTMScript(param) {
    var id = param.id;
    if (!id) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
        defer: true,
        id: "google-tag-manager",
        dangerouslySetInnerHTML: {
            __html: "\n          try {\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(id, "');\n          } catch (err) {\n            window.newrelic && window.newrelic.noticeError(err);\n          }\n        ")
        },
        strategy: "afterInteractive"
    });
};
/**
 * Google Tag Manager Script (noscript)
 */ var GTMNoScript = function GTMNoScript(param) {
    var id = param.id;
    if (!id) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
        /* eslint-disable react/no-danger */ dangerouslySetInnerHTML: {
            __html: '<iframe src="https://www.googletagmanager.com/ns.html?id='.concat(id, '" height="0" width="0" style="display:none;visibility:hidden"></iframe>')
        }
    });
};
/**
 * Inline script to block the Usercentrics consent layer in GTM
 */ var blockUserCentricsScript = "\n  window.dataLayer = window.dataLayer || [];\n  window.dataLayer.push({ blockUserCentrics: true });\n";
/**
 * Inline script to set the cross-domain bridge for Usercentrics
 */ var crossDomainBridgeScript = function crossDomainBridgeScript() {
    var hostname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "\n  window.UC_UI_DOMAINS = window.UC_UI_DOMAINS || {\n    crossDomainConsentSharingIFrame: '".concat(hostname, "/static/default/de-de/js/cross-domain-bridge.html',\n  };\n");
};


;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/gtm/index.ts






;// CONCATENATED MODULE: ../../frontend/entities/src/analytics/index.ts




// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(4297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(6270);
;// CONCATENATED MODULE: ../../frontend/entities/src/subscription/api/SubscriptionService.ts
/**
 * SilverTours Legacy API v1
 * https://engineering.p.silvertours.net/rentalcars/core/mietwagen/
 */ 



var SubscriptionService = /*#__PURE__*/ function(_LegacyHTTPService) {
    "use strict";
    (0,_inherits/* default */.Z)(SubscriptionService, _LegacyHTTPService);
    var _super = (0,_create_super/* default */.Z)(SubscriptionService);
    function SubscriptionService() {
        (0,_class_call_check/* default */.Z)(this, SubscriptionService);
        var _this;
        _this = _super.apply(this, arguments);
        // Newsletter subscription via Salesforce Marketing Cloud
        _this.submitNewsletterSignup = function(email, sourceParam) {
            return _this.instance.post("/newsletter/subscribe", {
                email: email,
                sourceParam: sourceParam
            });
        };
        return _this;
    }
    SubscriptionService.getInstance = function getInstance() {
        if (!SubscriptionService.classInstance) {
            SubscriptionService.classInstance = new SubscriptionService();
        }
        return SubscriptionService.classInstance;
    };
    return SubscriptionService;
}(src/* api.LegacyHTTPService */.hi.mT);
var subscriptionService = SubscriptionService.getInstance;


;// CONCATENATED MODULE: ../../frontend/entities/src/subscription/api/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/subscription/index.ts


;// CONCATENATED MODULE: ../../frontend/entities/src/index.ts




















/***/ }),

/***/ 5650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ir": function() { return /* binding */ LogoList; },
/* harmony export */   "UR": function() { return /* binding */ GarantieWrapper; },
/* harmony export */   "ZC": function() { return /* binding */ CarigamiWrapper; },
/* harmony export */   "g7": function() { return /* binding */ MgpWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7842);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8730);
/* harmony import */ var _silvertours_front_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2775);



var LogoList = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    target: "e46btjg0"
}, "target", "e46btjg0"))("list-style:none;margin:0;padding:0;display:flex;align-items:center;justify-content:space-around;flex-direction:column;gap:1.25rem;", _silvertours_front_shared__WEBPACK_IMPORTED_MODULE_1__/* .Theme.mq */ .Q2.mq("lg"), "{flex-direction:row;gap:0;}");
var GarantieWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    target: "e46btjg1"
}, "target", "e46btjg1"))("position:relative;height:5.625rem;margin-bottom:1.25rem;");
var MgpWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    target: "e46btjg2"
}, "target", "e46btjg2"))("height:5.625rem;");
var CarigamiWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    target: "e46btjg3"
}, "target", "e46btjg3"))("svg{height:1.688rem;", _silvertours_front_shared__WEBPACK_IMPORTED_MODULE_1__/* .Theme.mq */ .Q2.mq("md"), "{height:2.375rem;}", _silvertours_front_shared__WEBPACK_IMPORTED_MODULE_1__/* .Theme.mq */ .Q2.mq("lg"), "{height:3.063rem;}}& #logo-claim{display:none;", _silvertours_front_shared__WEBPACK_IMPORTED_MODULE_1__/* .Theme.mq */ .Q2.mq("lg"), "{display:block;}}");



/***/ }),

/***/ 9484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "My": function() { return /* reexport */ AppInstallBanner; },
  "B6": function() { return /* reexport */ BenefitsLegacy_namespaceObject; },
  "b3": function() { return /* reexport */ ContentArticle; },
  "Xt": function() { return /* reexport */ DocumentLegacy_namespaceObject; },
  "h4": function() { return /* reexport */ src_Header_Header; },
  "Xx": function() { return /* reexport */ InfoBanner; },
  "U0": function() { return /* reexport */ LoginForm; },
  "_A": function() { return /* reexport */ LoginModal; },
  "md": function() { return /* reexport */ LoginProvider; },
  "qf": function() { return /* reexport */ NewsletterRegistrationLegacy_namespaceObject; },
  "y7": function() { return /* reexport */ OffersModule; },
  "sE": function() { return /* reexport */ PageLegacy_namespaceObject; },
  "W6": function() { return /* reexport */ PageNavigationLegacy_namespaceObject; },
  "Cl": function() { return /* reexport */ ReferralLegacy_namespaceObject; },
  "Gn": function() { return /* reexport */ RentalCompaniesLegacy_namespaceObject; },
  "a9": function() { return /* reexport */ SearchFormLegacy_namespaceObject; },
  "TL": function() { return /* reexport */ StageLegacy_namespaceObject; },
  "Du": function() { return /* reexport */ StructuredDataWidget; },
  "$6": function() { return /* reexport */ src_Suppliers_namespaceObject; },
  "bS": function() { return /* reexport */ SupportInfoLegacy_namespaceObject; },
  "LG": function() { return /* reexport */ TrustLegacy_namespaceObject; },
  "f0": function() { return /* reexport */ useLogin; },
  "OJ": function() { return /* reexport */ useShowAppBanner; }
});

// UNUSED EXPORTS: AffiliateSearchForm, DestinationContentModule, FaqsContentModule, LinkListsContentModule, LocationSuggest, MarketPicker, OfferBox, OffersList, SearchHistory, SearchInput, StandardContentModule, TabsContentModule, TextImageContentModule, TrustSeals, addItemToSearchHistory, clearSearchHistory, getSearchHistory, mapFormToSearchItem

// NAMESPACE OBJECT: ../../frontend/features/src/NewsletterRegistrationLegacy/index.ts
var NewsletterRegistrationLegacy_namespaceObject = {};
__webpack_require__.r(NewsletterRegistrationLegacy_namespaceObject);
__webpack_require__.d(NewsletterRegistrationLegacy_namespaceObject, {
  "O": function() { return NewsletterRegistration; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/StageLegacy/index.ts
var StageLegacy_namespaceObject = {};
__webpack_require__.r(StageLegacy_namespaceObject);
__webpack_require__.d(StageLegacy_namespaceObject, {
  "cD": function() { return NewsletterStage; },
  "Hf": function() { return Stage; },
  "oA": function() { return WidgetStage; },
  "C5": function() { return useStageContext; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/SearchFormLegacy/index.ts
var SearchFormLegacy_namespaceObject = {};
__webpack_require__.r(SearchFormLegacy_namespaceObject);
__webpack_require__.d(SearchFormLegacy_namespaceObject, {
  "SearchForm": function() { return SearchFormWithContext; },
  "SearchProvider": function() { return SearchProvider; },
  "WidgetSearchForm": function() { return WidgetSearchFormWithContext; },
  "useSubmitInitialSearch": function() { return useSubmitInitialSearch; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/Suppliers/index.ts
var src_Suppliers_namespaceObject = {};
__webpack_require__.r(src_Suppliers_namespaceObject);
__webpack_require__.d(src_Suppliers_namespaceObject, {
  "$": function() { return Suppliers_Suppliers; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/BenefitsLegacy/index.ts
var BenefitsLegacy_namespaceObject = {};
__webpack_require__.r(BenefitsLegacy_namespaceObject);
__webpack_require__.d(BenefitsLegacy_namespaceObject, {
  "D": function() { return Usp; },
  "S": function() { return ValuePropositions; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/DocumentLegacy/index.ts
var DocumentLegacy_namespaceObject = {};
__webpack_require__.r(DocumentLegacy_namespaceObject);
__webpack_require__.d(DocumentLegacy_namespaceObject, {
  "Fb": function() { return Head; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/TrustLegacy/index.ts
var TrustLegacy_namespaceObject = {};
__webpack_require__.r(TrustLegacy_namespaceObject);
__webpack_require__.d(TrustLegacy_namespaceObject, {
  "N": function() { return CarigamiGarantie; },
  "x": function() { return Feedback; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/PageLegacy/index.ts
var PageLegacy_namespaceObject = {};
__webpack_require__.r(PageLegacy_namespaceObject);
__webpack_require__.d(PageLegacy_namespaceObject, {
  "_x": function() { return PageBase; },
  "EL": function() { return PageContentBase; },
  "WA": function() { return PageFooter; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/PageNavigationLegacy/index.ts
var PageNavigationLegacy_namespaceObject = {};
__webpack_require__.r(PageNavigationLegacy_namespaceObject);
__webpack_require__.d(PageNavigationLegacy_namespaceObject, {
  "O": function() { return Breadcrumbs; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/RentalCompaniesLegacy/index.ts
var RentalCompaniesLegacy_namespaceObject = {};
__webpack_require__.r(RentalCompaniesLegacy_namespaceObject);
__webpack_require__.d(RentalCompaniesLegacy_namespaceObject, {
  "L": function() { return RentalCompaniesLinks; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/SupportInfoLegacy/index.ts
var SupportInfoLegacy_namespaceObject = {};
__webpack_require__.r(SupportInfoLegacy_namespaceObject);
__webpack_require__.d(SupportInfoLegacy_namespaceObject, {
  "U": function() { return ContactUs; }
});

// NAMESPACE OBJECT: ../../frontend/features/src/ReferralLegacy/index.ts
var ReferralLegacy_namespaceObject = {};
__webpack_require__.r(ReferralLegacy_namespaceObject);
__webpack_require__.d(ReferralLegacy_namespaceObject, {
  "G": function() { return Referral; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(5459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5680);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(2174);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Search.js
var Search = __webpack_require__(133);
var Search_default = /*#__PURE__*/__webpack_require__.n(Search);
// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/index.ts + 80 modules
var _legacy = __webpack_require__(6522);
// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var src = __webpack_require__(2775);
// EXTERNAL MODULE: ../../frontend/entities/src/index.ts + 176 modules
var entities_src = __webpack_require__(3631);
// EXTERNAL MODULE: ../../frontend/entities/src/_legacy/index.ts + 34 modules
var src_legacy = __webpack_require__(7857);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchFormOptions/SearchFormOptions.styles.ts



var OptionsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1fmg4an0"
}, "target", "e1fmg4an0"))("border-left:", function(param) {
    var isMobile = param.isMobile, theme = param.theme;
    return isMobile ? "0" : "1px solid ".concat(theme.color.natural50);
}, ";margin-left:", function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0" : "1rem";
}, ";padding-left:", function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0" : "1rem";
}, ";padding-right:", function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0" : "1rem";
}, ";");
var OptionsSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1fmg4an1"
}, "target", "e1fmg4an1"))("&:not(&:first-of-type){margin-top:1.5rem;}");
var StyledLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,src_define_property/* default */.Z)({
    target: "e1fmg4an2"
}, "target", "e1fmg4an2"))("display:block;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;padding-bottom:0.375rem;margin-bottom:0.625rem;");
var StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "e1fmg4an3"
}, "target", "e1fmg4an3"))("margin-top:1rem;");
var CheckboxContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1fmg4an4"
}, "target", "e1fmg4an4"))("width:100%;display:inline-flex;cursor:pointer;user-select:none;flex-wrap:wrap;gap:0.75rem;> label{width:45%;align-items:center;}");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchFormOptions/const.ts
var CAR_CATEGORY_OPTIONS = [
    {
        key: "carSmall",
        id: "fib_ab",
        value: "M|N|E|H:::"
    },
    {
        key: "carFullSize",
        id: "fib_al",
        value: "S|F|R|G|X|P|U|L|W:::"
    },
    {
        key: "carCompact",
        id: "fib_ad",
        value: "C|D:-V|-M::"
    },
    {
        key: "carWagonEstate",
        id: "fib_ae",
        value: ":W|Y::"
    },
    {
        key: "carMiddleClass",
        id: "fib_af",
        value: "I|J|S|F|R|G|X|P|U|L|W:::"
    }, 
];
var EXTRA_OPTIONS = [
    {
        key: "kmFree",
        id: "fib_ed",
        value: "a[K*]",
        name: "extras[]"
    },
    {
        key: "fairFuelPolicy",
        id: "fib_ee",
        value: "full-full",
        name: "fuel_policy[]"
    },
    {
        key: "additionalDriver",
        id: "fib_ec",
        value: "a[A]",
        name: "extras[]"
    },
    {
        key: "winterTires",
        id: "fib_eb",
        value: "a[W]",
        name: "extras[]"
    }, 
];


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchFormOptions/SearchFormOptions.tsx








var OptionsContainer = function OptionsContainer(param) {
    var buttonText = param.buttonText, children = param.children, isMobile = param.isMobile, onClose = param.onClose, title = param.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsWrapper, {
        isMobile: isMobile,
        children: isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Ui.Overlay */.Ui.aV, {
            open: true,
            title: title,
            onClose: onClose,
            children: [
                children,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                    fullWidth: true,
                    onClick: onClose,
                    children: buttonText
                })
            ]
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("aside", {
            children: children
        })
    });
};
var SearchFormOptions = function SearchFormOptions(param) {
    var checked = param.checked, onChange = param.onChange, setShowOptions = param.setShowOptions;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat(src/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), false);
    var handleChange = function handleChange(event) {
        entities_src/* analytics.gtm.trackOptionsChange */.co.gtm.trackOptionsChange(event.target.id);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.id);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionsContainer, {
        buttonText: t("options.modalButton"),
        onClose: function onClose() {
            setShowOptions(false);
        },
        isMobile: isMobile,
        title: t("options.modalTitle"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionsSection, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabel, {
                        children: t("options.headline.insurance")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Checkbox */.ws.Checkbox, {
                        label: t("options.checkbox.insurance"),
                        id: "insfull",
                        name: "insurance_coverage",
                        value: "full",
                        onChange: handleChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionsSection, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabel, {
                        children: t("options.headline.vehicleClass")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxContainer, {
                        children: CAR_CATEGORY_OPTIONS.map(function(param) {
                            var id = param.id, key = param.key, value = param.value;
                            var label = t("options.checkbox.".concat(key));
                            if (!label) {
                                /* Translation file contains the logic for which options to render per locale */ return null;
                            }
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Checkbox */.ws.Checkbox, {
                                checked: checked.includes(value),
                                label: label,
                                id: id,
                                name: "acrissDescriptions[]",
                                value: value,
                                onChange: handleChange
                            }, id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OptionsSection, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabel, {
                        children: t("options.headline.inclusive")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxContainer, {
                        children: EXTRA_OPTIONS.map(function(param) {
                            var id = param.id, key = param.key, name = param.name, value = param.value;
                            var label = t("options.checkbox.".concat(key));
                            if (!label) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Checkbox */.ws.Checkbox, {
                                checked: checked.includes(value),
                                label: label,
                                id: id,
                                name: name,
                                value: value,
                                onChange: handleChange
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchFormOptions/index.ts


// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/LocationSuggest/LocationSuggest.styles.ts



var StyledList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e8ct1hl0"
}, "target", "e8ct1hl0"))("position:absolute;left:0;top:3.5rem;z-index:50;margin:0;padding:0;width:100%;max-height:400px;overflow-y:auto;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";border:0.125rem solid\n    ", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";border-radius:0.5rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);font-size:1rem;line-height:1.5;list-style-type:none;@media (max-height:250px){top:2.75rem;max-height:55vh;}@media (max-width:319px){top:2.75rem;max-height:60vh;}");
var ListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e8ct1hl1"
}, "target", "e8ct1hl1"))("&:not(:first-of-type){border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";}");
var LocationSuggest_styles_StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e8ct1hl2"
}, "target", "e8ct1hl2"))("display:inline-grid;grid-template:auto / 1.5rem 1fr;gap:0 0.5rem;align-items:center;margin:0;padding:0.75rem;border:0;outline:0;width:100%;font:inherit;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background:none;cursor:pointer;@media (max-width:319px){display:block;}&:hover,&:focus-visible{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";}");
var IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e8ct1hl3"
}, "target", "e8ct1hl3"))("grid-row:1 / span 2;display:flex;@media (max-width:319px){display:none;}svg{fill:currentcolor;}");
var Price = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("data", (0,src_define_property/* default */.Z)({
    target: "e8ct1hl4"
}, "target", "e8ct1hl4"))("display:block;font-size:0.875rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";");
var ErrorMessage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e8ct1hl5"
}, "target", "e8ct1hl5"))("position:absolute;left:0;top:100%;background-color:#bf3d1f;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:0.75rem;border:0;border-radius:0;box-shadow:0 1px 3px rgb(0 0 0 / 30%);padding:1rem;z-index:3;");


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Airport.js
var Airport = __webpack_require__(569);
var Airport_default = /*#__PURE__*/__webpack_require__.n(Airport);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/CityStation.js
var CityStation = __webpack_require__(8484);
var CityStation_default = /*#__PURE__*/__webpack_require__.n(CityStation);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/TrainStation.js
var TrainStation = __webpack_require__(2534);
var TrainStation_default = /*#__PURE__*/__webpack_require__.n(TrainStation);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/LocationSuggest/SearchResultItem.tsx






var icons = {
    city: (CityStation_default()),
    citywithoutrail: (CityStation_default()),
    multiairports: (Airport_default()),
    multiairport_single: (Airport_default()),
    airport: (Airport_default()),
    multirail: (TrainStation_default()),
    rail_only: (TrainStation_default()),
    multirail_single: (TrainStation_default())
};
var SearchResultItem = function SearchResultItem(param) {
    var suggestion = param.suggestion;
    var Icon = icons[suggestion.type];
    var _title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                "aria-hidden": "true",
                children: Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                    width: "24",
                    height: "24"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (_title = suggestion.title) !== null && _title !== void 0 ? _title : ""
            }),
            suggestion.minPrice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Price, {
                children: suggestion.minPrice
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/content/content.ts
var StatusCode;
(function(StatusCode) {
    StatusCode[StatusCode["Ok"] = 200] = "Ok";
    StatusCode[StatusCode["NoContent"] = 204] = "NoContent";
    StatusCode[StatusCode["PermanentRedirect"] = 301] = "PermanentRedirect";
    StatusCode[StatusCode["TemporaryRedirect"] = 302] = "TemporaryRedirect";
    StatusCode[StatusCode["NotFound"] = 404] = "NotFound";
    StatusCode[StatusCode["Gone"] = 410] = "Gone";
})(StatusCode || (StatusCode = {}));

;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/content/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(581);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(4297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(6270);
// EXTERNAL MODULE: ../../node_modules/jsonschema/lib/index.js
var lib = __webpack_require__(663);
;// CONCATENATED MODULE: ../../lib/core/types/src/check.ts

var validator = new lib.Validator();
var schemas = new Map();
var check_isString = function isString(val) {
    return typeof val === "string";
};
var isNotEmpty = function isNotEmpty(val) {
    return check_isString(val) && val !== "";
};
var check_isDefined = function isDefined(val) {
    return typeof val !== "undefined";
};
var check_isTruthy = function isTruthy(val) {
    return !!val;
};
var check_implementsType = function implementsType(obj, schema) {
    var onValidationError = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).onValidationError;
    if (!schemas.has(schema.id)) {
        validator.addSchema(schema, schema.id);
        schemas.set(schema.id, schema);
    }
    var result = validator.validate(obj, schema);
    if (!result.valid && onValidationError) {
        onValidationError(result);
    }
    return result.valid;
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(1899);
;// CONCATENATED MODULE: ../../lib/core/types/src/guard.ts




var formatData = function formatData(data) {
    return Object.entries(data).reduce(function(previousValue, param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        var formattedEntry = "".concat(key, ": ").concat(value);
        return previousValue.length > 0 ? "".concat(previousValue, ", ").concat(formattedEntry) : formattedEntry;
    }, "");
};
var message = function message(options, fallbackMessage) {
    var dataString = (options === null || options === void 0 ? void 0 : options.errorData) ? " (".concat(formatData(options.errorData), ")") : undefined;
    var message1 = (options === null || options === void 0 ? void 0 : options.errorMessage) || fallbackMessage;
    return dataString ? "".concat(message1, " ").concat(dataString) : message1;
};
var extendOptions = function extendOptions(options, args) {
    var data = Object.prototype.hasOwnProperty.call(options, "data") ? options.errorData : {};
    return Object.assign({}, options, {
        data: (0,_object_spread/* default */.Z)({}, args, data)
    });
};
var isString = function isString(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!check_isString(value)) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value not string"));
    }
};
var isTruthy = function isTruthy(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!check_isTruthy(value)) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value not truthy"));
    }
};
var isDefined = function isDefined(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!check_isDefined(value)) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value undefined"));
    }
};
var isNotNull = function isNotNull(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (value !== null) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value null"));
    }
};
var isType = function isType(value, test) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (check_isString(test)) {
        if ((typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) !== test) {
            throw new Error(message(extendOptions(options, {
                type: test,
                value: value
            }), "Value of incorrect type"));
        }
    } else {
        if (!test(value)) {
            throw new Error(message(extendOptions(options, {
                value: value
            }), "Value of incorrect type"));
        }
    }
};
var implementsType = function implementsType(obj, schema) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!check_implementsType(obj, schema, options)) {
        throw new Error(message(extendOptions(options, {
            schema: schema.id
        }), "Object failed schema validation"));
    }
};

;// CONCATENATED MODULE: ../../lib/core/types/src/index.ts





;// CONCATENATED MODULE: ../../lib/system/domain/src/entity/entity.ts


var isExistingEntity = function isExistingEntity(data) {
    return Object.prototype.hasOwnProperty.call(data, "id");
};
var Entity = /*#__PURE__*/ function() {
    "use strict";
    function Entity(entityName, memento) {
        (0,_class_call_check/* default */.Z)(this, Entity);
        this.entityName = entityName;
        this.memento = memento;
    }
    _createClass(Entity, [
        {
            key: "id",
            get: function get() {
                return isExistingEntity(this.memento) ? this.memento.id : null;
            }
        },
        {
            key: "idRequired",
            get: function get() {
                if (!isExistingEntity(this.memento)) {
                    throw new Error("The ".concat(this.entityName, " entity's ID is required, but it is missing"));
                }
                return this.memento.id;
            }
        }
    ]);
    return Entity;
}();


;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/pageAttributes/PageAttributes.ts


var PageAttributesOrganizer = /*#__PURE__*/ function() {
    "use strict";
    function PageAttributesOrganizer(attributes) {
        (0,_class_call_check/* default */.Z)(this, PageAttributesOrganizer);
        this.attributes = attributes;
    }
    _createClass(PageAttributesOrganizer, [
        {
            key: "available",
            get: function get() {
                return this.ordered.filter(function(entity) {
                    return !!entity;
                });
            }
        },
        {
            key: "ordered",
            get: function get() {
                var _attributes = this.attributes, cityDistrict = _attributes.cityDistrict, airport = _attributes.airport, railStation = _attributes.railStation, city = _attributes.city, island = _attributes.island, state = _attributes.state, country = _attributes.country, bookingAttributes = _attributes.bookingAttributes, category = _attributes.category, partners = _attributes.partners;
                return [
                    partners ? partners[0] : null,
                    cityDistrict,
                    airport,
                    railStation,
                    city,
                    island,
                    state,
                    country,
                    bookingAttributes ? bookingAttributes[0] : null,
                    category, 
                ];
            }
        },
        {
            key: "primary",
            get: function get() {
                return this.available.length > 0 ? this.available[0] : null;
            }
        },
        {
            key: "secondary",
            get: function get() {
                return this.available.length > 1 ? this.available[1] : null;
            }
        }
    ]);
    return PageAttributesOrganizer;
}();


;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/pageAttributes/PageAttributeRefForType.ts
var PageAttributeRefForType_PageAttributeType;
(function(PageAttributeType) {
    PageAttributeType["Airport"] = "airport";
    PageAttributeType["BookingAttribute"] = "bookingAttribute";
    PageAttributeType["Category"] = "category";
    PageAttributeType["City"] = "city";
    PageAttributeType["CityDistrict"] = "cityDistrict";
    PageAttributeType["Country"] = "country";
    PageAttributeType["Island"] = "island";
    PageAttributeType["Partner"] = "partner";
    PageAttributeType["Product"] = "product";
    PageAttributeType["RailStation"] = "railStation";
    PageAttributeType["State"] = "state";
})(PageAttributeRefForType_PageAttributeType || (PageAttributeRefForType_PageAttributeType = {}));


;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/pageAttributes/index.ts



;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/stage/modern.ts


var ModernStage = /*#__PURE__*/ function() {
    "use strict";
    function ModernStage(content) {
        (0,_class_call_check/* default */.Z)(this, ModernStage);
        this.content = content;
        this.type = "modern";
    }
    _createClass(ModernStage, [
        {
            key: "banderole",
            get: function get() {
                return this.content.stage.banderole;
            }
        },
        {
            key: "headline",
            get: function get() {
                return this.content.stage.headline;
            }
        },
        {
            key: "image",
            get: function get() {
                return this.content.stage.image;
            }
        },
        {
            key: "includeSearch",
            get: function get() {
                return this.content.stage.includeSearch;
            }
        },
        {
            key: "pageTitle",
            get: function get() {
                return this.content.stage.pageTitle;
            }
        },
        {
            key: "partners",
            get: function get() {
                return this.content.stage.partners;
            }
        }
    ]);
    return ModernStage;
}();

;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/stage/legacy.ts


var LegacyStage = /*#__PURE__*/ function() {
    "use strict";
    function LegacyStage(content) {
        (0,_class_call_check/* default */.Z)(this, LegacyStage);
        this.content = content;
        this.type = "legacy";
    }
    _createClass(LegacyStage, [
        {
            key: "keyword",
            get: function get() {
                return this.content.mainKeyword;
            }
        },
        {
            key: "image",
            get: function get() {
                var ref;
                return (ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.image;
            }
        },
        {
            key: "headline",
            get: function get() {
                var ref;
                return ((ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.headline) || "";
            }
        },
        {
            key: "includeSearch",
            get: function get() {
                var ref;
                return ((ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.includeSearch) || false;
            }
        },
        {
            key: "pageTitle",
            get: function get() {
                var ref;
                return ((ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.pageTitle) || "";
            }
        }
    ]);
    return LegacyStage;
}();

;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/body/modern.ts


var ModernBody = /*#__PURE__*/ function() {
    "use strict";
    function ModernBody(content) {
        (0,_class_call_check/* default */.Z)(this, ModernBody);
        this.content = content;
        this.type = "modern";
    }
    _createClass(ModernBody, [
        {
            key: "segments",
            get: function get() {
                return this.content.body.segments;
            }
        }
    ]);
    return ModernBody;
}();

;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/body/legacy.ts

var LegacyBody = function LegacyBody() {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, LegacyBody);
    this.type = "legacy";
};

;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/page.ts










var isOfStatus = function isOfStatus(param, statusCode) {
    var content = param.content;
    return content.statusCode === statusCode;
};
var isOk = function isOk(memento) {
    return isOfStatus(memento, StatusCode.Ok);
};
var isRedirect = function isRedirect(memento) {
    return isOfStatus(memento, StatusCode.PermanentRedirect) || isOfStatus(memento, StatusCode.TemporaryRedirect);
};
var isRetired = function isRetired(memento) {
    return isOfStatus(memento, StatusCode.Gone) || isOfStatus(memento, StatusCode.NotFound);
};
var LandingPage = /*#__PURE__*/ function(Entity) {
    "use strict";
    (0,_inherits/* default */.Z)(LandingPage, Entity);
    var _super = (0,_create_super/* default */.Z)(LandingPage);
    function LandingPage(memento) {
        (0,_class_call_check/* default */.Z)(this, LandingPage);
        return _super.call(this, "LandingPage", memento);
    }
    var _proto = LandingPage.prototype;
    /**
   * @remarks
   * A page is more specific when it has a greater number of associated entities
   * than the alternative.
   */ _proto.isMoreSpecificThan = function isMoreSpecificThan(otherPage) {
        return this.attributes.length > otherPage.attributes.length;
    };
    _proto.getPropertyIfIsStatus = function getPropertyIfIsStatus(isStatus, getProperty, fallback) {
        if (isStatus(this.memento)) {
            return getProperty(this.memento);
        }
        isDefined(fallback, {
            errorMessage: "Attempt to access a property which is not available for the given status"
        });
        return fallback;
    };
    _proto.getBmcgContentIfOk = function getBmcgContentIfOk(getProperty, fallback) {
        return this.getPropertyIfIsStatus(isOk, function(param) {
            var content = param.content;
            if (content.type === "bmcg") {
                return getProperty(content);
            }
            isDefined(fallback, {
                errorMessage: "Attempt to access a property which is not available for the given status"
            });
            return fallback;
        }, fallback);
    };
    // private getFloytContentIfOk<TResult, TFallback extends TResult = TResult>(
    //   getProperty: (content: FloytOkContent) => TResult,
    //   fallback?: TFallback,
    // ) {
    //   return this.getPropertyIfIsStatus(
    //     isOk,
    //     ({ content }) => {
    //       if (content.type === 'floyt') {
    //         return getProperty(content);
    //       }
    //       Guard.isDefined(fallback, {
    //         errorMessage:
    //           'Attempt to access a property which is not available for the given status',
    //       });
    //       return fallback;
    //     },
    //     fallback,
    //   );
    // }
    _proto.getIfOk = function getIfOk(getProperty, fallback) {
        return this.getPropertyIfIsStatus(isOk, getProperty, fallback);
    };
    _proto.getIfRedirect = function getIfRedirect(getProperty) {
        return this.getPropertyIfIsStatus(isRedirect, getProperty);
    };
    LandingPage.Redirect = function Redirect(landingUrl, content) {
        return new LandingPage({
            id: landingUrl,
            content: content
        });
    };
    LandingPage.Gone = function Gone(landingUrl) {
        return new LandingPage({
            id: landingUrl,
            content: {
                landingUrl: landingUrl,
                statusCode: StatusCode.Gone
            }
        });
    };
    LandingPage.NotFound = function NotFound(landingUrl) {
        return new LandingPage({
            id: landingUrl,
            content: {
                landingUrl: landingUrl,
                statusCode: StatusCode.NotFound
            }
        });
    };
    LandingPage.Ok = function Ok(landingUrl, content, product, attributes) {
        // @todo: Validation guard clauses
        return new LandingPage({
            id: landingUrl,
            attributes: attributes,
            content: content,
            path: landingUrl,
            product: product
        });
    };
    _createClass(LandingPage, [
        {
            key: "slug",
            get: function get() {
                return this.idRequired.replace(/\..*/g, "");
            }
        },
        {
            key: "statusCode",
            get: function get() {
                return this.memento.content.statusCode;
            }
        },
        {
            key: "isOk",
            get: function get() {
                return isOk(this.memento);
            }
        },
        {
            key: "isRedirect",
            get: function get() {
                return isRedirect(this.memento);
            }
        },
        {
            key: "isRetired",
            get: function get() {
                return isRetired(this.memento);
            }
        },
        {
            key: "redirectUrl",
            get: function get() {
                return this.getIfRedirect(function(param) {
                    var content = param.content;
                    return content.redirectUrl;
                });
            }
        },
        {
            key: "alternativePaths",
            get: function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    return content.alternativePaths;
                }, []);
            }
        },
        {
            key: "headlines",
            get: function get() {
                return this.getBmcgContentIfOk(function(param) {
                    var headlines = param.headlines;
                    return headlines;
                });
            }
        },
        {
            key: "path",
            get: function get() {
                return this.getIfOk(function(param) {
                    var path = param.path;
                    return path;
                }, "");
            }
        },
        {
            key: "body",
            get: function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    if (content.type === "floyt") {
                        return new ModernBody(content);
                    }
                    return new LegacyBody();
                });
            }
        },
        {
            key: "modernBodyBeta",
            get: /**
   * @todo
   * This "beta" property is for testing the modern approach on BM/CG without
   * impacting the existing approach. Once BM/CG is ready switch over fully, it
   * can replace the `body` property so that both site groups are fully aligned.
   * */ function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    return new ModernBody(content);
                });
            }
        },
        {
            key: "meta",
            get: function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    return content.meta;
                });
            }
        },
        {
            key: "stage",
            get: function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    if (content.type === "floyt") {
                        return new ModernStage(content);
                    }
                    return new LegacyStage(content);
                });
            }
        },
        {
            key: "airport",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.airport;
                }, null);
            }
        },
        {
            key: "bookingAttribute",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.bookingAttributes;
                }, []);
            }
        },
        {
            key: "category",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.category;
                }, null);
            }
        },
        {
            key: "city",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.city;
                }, null);
            }
        },
        {
            key: "cityDistrict",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.cityDistrict;
                }, null);
            }
        },
        {
            key: "country",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.country;
                }, null);
            }
        },
        {
            key: "infoBanner",
            get: function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    return content.infoBanner;
                });
            }
        },
        {
            key: "intro",
            get: function get() {
                return this.getBmcgContentIfOk(function(param) {
                    var introModule = param.introModule;
                    return introModule;
                });
            }
        },
        {
            key: "island",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.island;
                }, null);
            }
        },
        {
            key: "partners",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.partners;
                }, []);
            }
        },
        {
            key: "railStation",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.railStation;
                }, null);
            }
        },
        {
            key: "state",
            get: function get() {
                return this.getIfOk(function(param) {
                    var attributes = param.attributes;
                    return attributes.state;
                }, null);
            }
        },
        {
            key: "navigation",
            get: function get() {
                return this.getIfOk(function(param) {
                    var content = param.content;
                    if (content.type === "bmcg") {
                        return content.navigation;
                    }
                    return {
                        // Floyt static links not yet integrated into backend architecture
                        staticLinks: []
                    };
                });
            }
        },
        {
            key: "stationsMap",
            get: function get() {
                var _this = this;
                return this.getIfOk(function(param) {
                    var content = param.content;
                    if (content.type === "bmcg") {
                        return {
                            stations: content.stations,
                            boundingBox: _this.boundingBox
                        };
                    }
                    return {
                        stations: content.stations,
                        boundingBox: null
                    };
                });
            }
        },
        {
            key: "product",
            get: function get() {
                return this.getIfOk(function(param) {
                    var product = param.product;
                    return product;
                });
            }
        },
        {
            key: "boundingBox",
            get: function get() {
                var ref, ref1, ref2, ref3;
                return ((ref = this.island) === null || ref === void 0 ? void 0 : ref.boundingBox) || ((ref1 = this.cityDistrict) === null || ref1 === void 0 ? void 0 : ref1.boundingBox) || ((ref2 = this.city) === null || ref2 === void 0 ? void 0 : ref2.boundingBox) || ((ref3 = this.state) === null || ref3 === void 0 ? void 0 : ref3.boundingBox) || null;
            }
        },
        {
            key: "locationName",
            get: function get() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                return ((ref = this.city) === null || ref === void 0 ? void 0 : ref.name) || ((ref1 = this.state) === null || ref1 === void 0 ? void 0 : ref1.name) || ((ref2 = this.country) === null || ref2 === void 0 ? void 0 : ref2.name) || ((ref3 = this.island) === null || ref3 === void 0 ? void 0 : ref3.name) || ((ref4 = this.airport) === null || ref4 === void 0 ? void 0 : ref4.city) || ((ref5 = this.railStation) === null || ref5 === void 0 ? void 0 : ref5.cityName) || ((ref6 = this.cityDistrict) === null || ref6 === void 0 ? void 0 : ref6.cityName) || "";
            }
        },
        {
            key: "attributeSet",
            get: function get() {
                return this.organizer.attributes;
            }
        },
        {
            key: "attributes",
            get: function get() {
                return this.organizer.available;
            }
        },
        {
            key: "primaryAttribute",
            get: function get() {
                return this.organizer.primary;
            }
        },
        {
            key: "secondaryAttribute",
            get: function get() {
                return this.organizer.secondary;
            }
        },
        {
            key: "possibleAttributes",
            get: function get() {
                return this.organizer.ordered;
            }
        },
        {
            key: "organizer",
            get: function get() {
                if (!check_isDefined(this._attributeOganizer)) {
                    var attributes = this.getIfOk(function(param) {
                        var attributes = param.attributes;
                        return attributes;
                    });
                    this._attributeOganizer = new PageAttributesOrganizer(attributes);
                }
                return this._attributeOganizer;
            }
        }
    ]);
    return LandingPage;
}(Entity);


;// CONCATENATED MODULE: ../../backend/domain/page/src/entity/index.ts






;// CONCATENATED MODULE: ../../backend/domain/page/src/service/pageContent/loadAttributePages.ts




var loadAttributePages_makeAttributePagesLoader = function makeAttributePagesLoader(loadAttributePageContent) {
    return function() {
        var _ref = _async_to_generator(function(slug, primaryAttribute) {
            var tryPickAttribute, cityDistrict, city, state, country, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tryPickAttribute = makeAttributePicker(primaryAttribute);
                        cityDistrict = tryPickAttribute(PageAttributeType.CityDistrict);
                        city = tryPickAttribute(PageAttributeType.City, cityDistrict);
                        state = tryPickAttribute(PageAttributeType.State, city);
                        country = tryPickAttribute(PageAttributeType.Country, state);
                        _tmp = {
                            attributes: {
                                city: city,
                                cityDistrict: cityDistrict,
                                country: country,
                                state: state
                            }
                        };
                        return [
                            4,
                            Promise.all([
                                loadAttributePageContent(slug, primaryAttribute),
                                loadAttributePageContent(slug, cityDistrict),
                                loadAttributePageContent(slug, city),
                                loadAttributePageContent(slug, state),
                                loadAttributePageContent(slug, country)
                            ])
                        ];
                    case 1:
                        /**
     * For each of the ancestor attibutes located above, we'll try to load a
     * page but there may be none available or could be gone (i.e. status
     * 404/410).
     */ return [
                            2,
                            (_tmp.pages = _state.sent(), _tmp)
                        ];
                }
            });
        });
        return function(slug, primaryAttribute) {
            return _ref.apply(this, arguments);
        };
    }();
};


;// CONCATENATED MODULE: ../../backend/domain/page/src/service/pageContent/pageContentService.ts






var makePageContentService = function makePageContentService(logger, contentRepo, linksRepo) {
    var loadAttributePageContent = makeAttributePageContentLoader(logger, contentRepo);
    var loadAttributePages = makeAttributePagesLoader(loadAttributePageContent);
    return {
        getPageAncestorReferences: function getPageAncestorReferences(slug, primaryAttribute) {
            return _async_to_generator(function() {
                var ref, _attributes, city, cityDistrict, country, state, _pages, pageForAttribute, pageForCityDistrict, pageForCity, pageForState, pageForCountry;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!Check.isDefined(primaryAttribute)) {
                                logger.warn("A page was loaded without any parent attribute", {
                                    slug: slug
                                });
                                return [
                                    2,
                                    []
                                ];
                            }
                            return [
                                4,
                                loadAttributePages(slug, primaryAttribute)
                            ];
                        case 1:
                            ref = _state.sent(), _attributes = ref.attributes, city = _attributes.city, cityDistrict = _attributes.cityDistrict, country = _attributes.country, state = _attributes.state, _pages = _sliced_to_array(ref.pages, 5), pageForAttribute = _pages[0], pageForCityDistrict = _pages[1], pageForCity = _pages[2], pageForState = _pages[3], pageForCountry = _pages[4];
                            /**
       * Return the pages for those entities which are available
       */ return [
                                2,
                                [
                                    [
                                        country,
                                        pageForCountry
                                    ],
                                    [
                                        state,
                                        pageForState
                                    ],
                                    [
                                        city,
                                        pageForCity
                                    ],
                                    [
                                        cityDistrict,
                                        pageForCityDistrict
                                    ],
                                    [
                                        primaryAttribute,
                                        pageForAttribute
                                    ]
                                ].filter(function(param) {
                                    var _param = _sliced_to_array(param, 1), entity = _param[0];
                                    return Check.isTruthy(entity);
                                })
                            ];
                    }
                });
            })();
        },
        getPageContentForSlug: function getPageContentForSlug(slug) {
            return contentRepo.loadPageContentForSlug(slug);
        },
        getPageLinks: function getPageLinks(param) {
            var attributeSet = param.attributeSet, product = param.product, slug = param.slug;
            Guard.isDefined(linksRepo, {
                errorMessage: "The page links repository is not defined",
                errorData: {
                    slug: slug,
                    product: product
                }
            });
            return linksRepo.loadPageLinks(slug, product.id, attributeSet);
        }
    };
};

;// CONCATENATED MODULE: ../../backend/domain/page/src/service/pageContent/index.ts


;// CONCATENATED MODULE: ../../backend/domain/page/src/service/index.ts



;// CONCATENATED MODULE: ../../backend/domain/page/src/index.ts



// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 6 modules
var format = __webpack_require__(6569);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(729);
;// CONCATENATED MODULE: ../../node_modules/date-fns/setSeconds.mjs


/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(date, seconds) {
  const _date = (0,toDate/* toDate */.Q)(date);
  _date.setSeconds(seconds);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_setSeconds = ((/* unused pure expression or super */ null && (setSeconds)));

// EXTERNAL MODULE: ../../node_modules/date-fns/setMinutes.mjs
var setMinutes = __webpack_require__(5465);
// EXTERNAL MODULE: ../../node_modules/date-fns/setHours.mjs
var setHours = __webpack_require__(6930);
// EXTERNAL MODULE: ../../node_modules/date-fns/addDays.mjs
var addDays = __webpack_require__(8016);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/utils.ts



var isDeptDateInLessThanDays = function isDeptDateInLessThanDays(depDate, days) {
    return new Date(depDate) <= (0,addDays/* addDays */.E)(new Date(), days);
};
var isDestDateBeforeDepDate = function isDestDateBeforeDepDate(destDate, depDate) {
    return new Date(destDate) <= new Date(depDate);
};
var isSearchInCuba = function isSearchInCuba(dep, dest) {
    return (dep === null || dep === void 0 ? void 0 : dep.countryCode) === "CU" || (dest === null || dest === void 0 ? void 0 : dest.countryCode) === "CU";
};
var formatDate = function formatDate(date) {
    return (0,format/* format */.WU)(date, src/* String.isoDateTimeWithSeconds */.Ld.isoDateTimeWithSeconds);
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/types.ts
var ActionType;
(function(ActionType) {
    ActionType["CLEAR_SEARCH_HISTORY"] = "CLEAR_SEARCH_HISTORY";
    ActionType["POPULATE_FORM"] = "POPULATE_FORM";
    ActionType["POPULATE_HISTORY_ITEMS"] = "POPULATE_HISTORY_ITEMS";
    ActionType["SET_CUSTOMER_AGE"] = "SET_CUSTOMER_AGE";
    ActionType["SET_DATE"] = "SET_DATE";
    ActionType["SET_LOCATION_INPUT_VALUE"] = "SET_LOCATION_INPUT_VALUE";
    ActionType["SET_LOCATION"] = "SET_LOCATION";
    ActionType["SET_ERROR"] = "SET_ERROR";
    ActionType["SET_SHOW_DEST_LOCATION"] = "SET_SHOW_DEST_LOCATION";
    ActionType["SET_SEARCH_FROM_HISTORY"] = "SET_SEARCH_FROM_HISTORY";
    ActionType["VALIDATE"] = "VALIDATE";
})(ActionType || (ActionType = {}));
var isFormError = function isFormError(error) {
    return [
        "locationError",
        "dateError",
        "axiosError"
    ].includes(error);
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/reducer.ts









var LOCATION_FIELD_NAME = {
    departure: "depLocation",
    destination: "destLocation"
};
var DEFAULT_AGE = 47;
var today = new Date();
var DEFAULT_DEPARTURE_DATE = setSeconds((0,setMinutes/* setMinutes */.H)((0,setHours/* setHours */.B)((0,addDays/* addDays */.E)(today, 7), 12), 0), 0);
var DEFAULT_DESTINATION_DATE = setSeconds((0,setMinutes/* setMinutes */.H)((0,setHours/* setHours */.B)((0,addDays/* addDays */.E)(today, 14), 9), 0), 0);
var DEFAULT_VALUES = {
    affiliate: "",
    customerAge: DEFAULT_AGE,
    depLocation: null,
    destLocation: null,
    depDate: formatDate(DEFAULT_DEPARTURE_DATE),
    destDate: formatDate(DEFAULT_DESTINATION_DATE),
    dateError: "",
    locationError: "",
    axiosError: "",
    showDestLocation: false,
    history: {
        items: []
    },
    inputValue: {
        departure: "",
        destination: ""
    }
};
var makeTranslatedSearchReducer = function makeTranslatedSearchReducer(translate) {
    return function(state, action) {
        switch(action.type){
            case ActionType.POPULATE_FORM:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, action.payload), {
                    showDestLocation: !!action.payload.destLocation
                });
            case ActionType.POPULATE_HISTORY_ITEMS:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    history: action.payload.history
                });
            case ActionType.SET_CUSTOMER_AGE:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    customerAge: action.payload.customerAge
                });
            case ActionType.SET_DATE:
                {
                    var date = formatDate(action.payload.date);
                    var field = action.payload.direction === "departure" ? "depDate" : "destDate";
                    var hasError = action.payload.direction === "departure" ? isDestDateBeforeDepDate(state.destDate, date) : isDestDateBeforeDepDate(date, state.depDate);
                    var _obj;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, field, date), (0,src_define_property/* default */.Z)(_obj, "dateError", hasError ? translate("errorTexts.time") : ""), _obj));
                }
            case ActionType.SET_LOCATION:
                {
                    var _payload = action.payload, direction = _payload.direction, location = _payload.location;
                    var field1 = LOCATION_FIELD_NAME[direction];
                    var _obj1;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, field1, location), (0,src_define_property/* default */.Z)(_obj1, "inputValue", (0,_object_spread/* default */.Z)({}, state.inputValue, location ? (0,src_define_property/* default */.Z)({}, direction, location.name) : {})), _obj1));
                }
            case ActionType.SET_LOCATION_INPUT_VALUE:
                {
                    var _payload1 = action.payload, direction1 = _payload1.direction, value = _payload1.value;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        inputValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.inputValue), (0,src_define_property/* default */.Z)({}, direction1, value))
                    });
                }
            case ActionType.SET_ERROR:
                {
                    if (action.payload === null) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            dateError: "",
                            locationError: "",
                            axiosError: ""
                        });
                    }
                    var _payload2 = action.payload, kind = _payload2.kind, message = _payload2.message;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,src_define_property/* default */.Z)({}, kind, message));
                }
            case ActionType.SET_SEARCH_FROM_HISTORY:
                {
                    var _payload3 = action.payload, depLocation = _payload3.depLocation, destLocation = _payload3.destLocation;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, action.payload), {
                        showDestLocation: Boolean(destLocation),
                        inputValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.inputValue, depLocation ? {
                            departure: depLocation.name
                        } : {}), {
                            destination: (destLocation === null || destLocation === void 0 ? void 0 : destLocation.name) || ""
                        })
                    });
                }
            case ActionType.SET_SHOW_DEST_LOCATION:
                return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showDestLocation: action.payload
                }), action.payload ? {} : {
                    destLocation: null,
                    inputValue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.inputValue), {
                        destination: ""
                    })
                });
            case ActionType.VALIDATE:
                if (isDeptDateInLessThanDays(state.depDate, 0)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        dateError: translate("errorTexts.time")
                    });
                }
                if (isDestDateBeforeDepDate(state.destDate, state.depDate)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        dateError: translate("errorTexts.time")
                    });
                }
                if (isSearchInCuba(state.depLocation, state.destLocation) && isDeptDateInLessThanDays(state.depDate, 30)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        locationError: translate("errorTexts.cuba")
                    });
                }
                return state;
            default:
                return state;
        }
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/useInitializeSearchContext.tsx







var getQueryParamValues = function getQueryParamValues(query) {
    var values = {};
    values.showDestLocation = !!query.dest;
    values.affiliate = query.affiliate || query.aff || "";
    if (query.dep || query.depAirport) {
        // e.g. ?dep=Berlin, or ?depAirport=BER
        var name = query.dep || "";
        var iataCode = query.depAirport || "";
        values.depLocation = {
            name: name,
            cityCode: iataCode,
            type: iataCode ? "airport" : "all",
            iataCode: iataCode
        };
    }
    if (query.dest || query.destAirport) {
        // e.g. ?dest=Madrid, or ?depAirport=MAD
        var name1 = query.dest || "";
        var iataCode1 = query.destAirport || "";
        values.destLocation = {
            name: name1,
            cityCode: iataCode1,
            type: iataCode1 ? "airport" : "all",
            iataCode: iataCode1
        };
    }
    if (typeof query.depDate === "string") {
        // e.g. ?depDate=2022-12-01
        values.depDate = (0,format/* format */.WU)(new Date(query.depDate), src/* String.isoDateTimeWithSeconds */.Ld.isoDateTimeWithSeconds);
    }
    if (typeof query.destDate === "string") {
        // e.g. ?destDate=2022-12-07
        values.destDate = (0,format/* format */.WU)(new Date(query.destDate), src/* String.isoDateTimeWithSeconds */.Ld.isoDateTimeWithSeconds);
    }
    if (typeof query.customerAge === "string") {
        values.customerAge = query.customerAge;
    }
    return values;
};
var ATTRIBUTE_TO_SEARCH_TYPE = {
    airport: "airport",
    city: "all",
    cityDistrict: "city",
    railStation: "rail"
};
var mapStageLocationToQuery = function mapStageLocationToQuery(location) {
    if (!location || location.type !== PageAttributeRefForType_PageAttributeType.Airport && location.type !== PageAttributeRefForType_PageAttributeType.City) {
        return {
            inputValue: "",
            query: null
        };
    }
    var type = ATTRIBUTE_TO_SEARCH_TYPE[location.type] || "all";
    return {
        inputValue: location.displayName,
        query: {
            name: location.query || "",
            cityName: location.cityName || "",
            type: type
        }
    };
};
var useSearchInitializer = function useSearchInitializer() {
    var router = (0,next_router.useRouter)();
    return {
        /** "Plain" search state to use when needed outside of search form */ getDefaultState: function getDefaultState(location) {
            var stageLocationQuery = mapStageLocationToQuery(location);
            return (0,_object_spread/* default */.Z)({}, DEFAULT_VALUES, stageLocationQuery.query ? {
                depLocation: stageLocationQuery.query
            } : {});
        },
        /**
     * Search form initial state has multiple sources of truth, in order of importance:
     * 1. Stored in query params
     * 2. City name retrieved from page content (within stage property)
     * 3. Stored in session storage
     * 4. Hard-coded default values
     *
     * Note: session storage must be rendered separately because SSR doesn't have access to browser data
     */ initializeFormState: function initializeFormState(defaultValues, location) {
            var ref, ref1, ref2;
            var queryParams = getQueryParamValues(router.query);
            var stageLocationQuery = mapStageLocationToQuery(location);
            var initialState = (0,_object_spread/* default */.Z)({}, defaultValues, stageLocationQuery.query ? {
                depLocation: stageLocationQuery.query
            } : {}, queryParams);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
                inputValue: {
                    departure: ((ref = queryParams.depLocation) === null || ref === void 0 ? void 0 : ref.name) || stageLocationQuery.inputValue || ((ref1 = initialState.depLocation) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
                    destination: ((ref2 = initialState.destLocation) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
                },
                showDestLocation: !!initialState.destLocation
            });
        }
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/hooks/useAffiliate.ts


var useAffiliate = function useAffiliate() {
    var router = (0,next_router.useRouter)();
    /**
   * Check for TradeDoubler affiliate params in url
   * see https://dev.tradedoubler.com/tracking/advertiser/#Pixel_Redirect
   */ var redirectToTradedoubler = (0,react.useCallback)(function(bookingUrl) {
        var url = router.query.tdClick;
        // Example for tradeDoublerUrl: https://clk.tradedoubler.com/click?p=301944&a=3146932&g=24832700
        if (!url || !url.match(/^https:\/\/clk\.tradedoubler\.com\/click\?p=\d+&a=\d+&g=\d+/)) {
            return null;
        }
        var queryString = "&url=".concat(encodeURIComponent(bookingUrl));
        var redirectUrl = url + queryString;
        return redirectUrl;
    }, [
        router.query
    ]);
    return {
        redirectToTradedoubler: redirectToTradedoubler
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/hooks/useSearch.ts

var useClientContext = _legacy/* Context.useClientContext */._y.useClientContext;
var hasContext = _legacy/* Context.guardContext */._y.guardContext;
var join = function join(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
var useSearch = function useSearch() {
    var result = useClientContext("search");
    hasContext("search", result);
    var baseUrl = result.value.baseUrl;
    return {
        formatApiUrl: function formatApiUrl(path) {
            return join(baseUrl, path);
        }
    };
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/hooks/useSession.ts



var SESSION_STORAGE_NAME_FOR_FIND_CLICK = "userClickOnFindTimestamp";
var SEARCH_FORM_SESSION_STORAGE_KEY = "searchForm";
var useSession = function useSession() {
    var router = (0,next_router.useRouter)();
    var hasUrlQueryParams = (0,react.useMemo)(function() {
        return Object.keys(router.query).some(function(key) {
            return [
                "dep",
                "dest",
                "depAirport",
                "destAirport",
                "depDate",
                "destDate",
                "customerAge", 
            ].includes(key);
        });
    }, [
        router.query
    ]);
    // Initialize the session from storage
    var getSessionData = (0,react.useCallback)(function(cityName) {
        // only restore from session if we are not on a landing page with default values
        if (hasUrlQueryParams || cityName) {
            return null;
        }
        var data = src/* Session.SessionStorageManager.getData */.z_.h.getData(SEARCH_FORM_SESSION_STORAGE_KEY);
        if (!data) {
            return null;
        }
        // check for expired dates in session
        var today = new Date();
        var depDate = new Date(data.depDate);
        var destDate = new Date(data.destDate);
        if (depDate <= today || destDate <= today) {
            return null;
        }
        return data;
    }, [
        hasUrlQueryParams
    ]);
    // Track current click timestamp
    var trackClickTimestamp = function trackClickTimestamp() {
        src/* Session.SessionStorageManager.setData */.z_.h.setData(SESSION_STORAGE_NAME_FOR_FIND_CLICK, Date.now());
    };
    // Remove current click timestamp
    var removeClickTimestamp = function removeClickTimestamp() {
        src/* Session.SessionStorageManager.removeData */.z_.h.removeData(SESSION_STORAGE_NAME_FOR_FIND_CLICK);
    };
    return {
        getSessionData: getSessionData,
        trackClickTimestamp: trackClickTimestamp,
        removeClickTimestamp: removeClickTimestamp
    };
};

// EXTERNAL MODULE: ../../node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(162);
// EXTERNAL MODULE: ../../node_modules/lodash/isEqual.js
var lodash_isEqual = __webpack_require__(8149);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/de.mjs + 5 modules
var de = __webpack_require__(1466);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchHistory/SearchHistory.styles.ts



var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eozo8fq0"
}, "target", "eozo8fq0"))("position:absolute;left:0;top:3.5rem;z-index:50;margin:0;padding:0;width:100%;max-height:400px;overflow-y:auto;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";border:0.125rem solid\n    ", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";border-radius:0.5rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);font-size:1rem;line-height:1.5;list-style-type:none;");
var Headline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eozo8fq1"
}, "target", "eozo8fq1"))("padding:0.75rem 0.75rem 0.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";font-size:0.875rem;font-weight:bold;letter-spacing:0.2em;text-transform:uppercase;");
var List = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "eozo8fq2"
}, "target", "eozo8fq2"))("margin:0;padding:0;list-style:none;li{border-bottom:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";}");
var ItemButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "eozo8fq3"
}, "target", "eozo8fq3"))("margin:0;padding:0.75rem;border:0;width:100%;font:inherit;text-align:left;color:inherit;background:none;cursor:pointer;&:hover{background-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";}");
var Destination = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "eozo8fq4"
}, "target", "eozo8fq4"))("display:block;font-weight:600;");
var Duration = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("time", (0,src_define_property/* default */.Z)({
    target: "eozo8fq5"
}, "target", "eozo8fq5"))("display:block;font-size:0.875rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";");
var DeleteButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "eozo8fq6"
}, "target", "eozo8fq6"))("margin:0;padding:0.75rem;border:0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;font-weight:bold;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";background:none;cursor:pointer;&:hover{text-decoration:none;}");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchHistory/SearchHistory.tsx











var SEARCH_HISTORY_SESSION_STORAGE_KEY = "SearchHistoryKey8934087340";
var SEARCH_HISTORY_LIMIT = 6;
var getSearchHistory = function getSearchHistory() {
    var data = src/* Session.SessionStorageManager.getData */.z_.h.getData(SEARCH_HISTORY_SESSION_STORAGE_KEY);
    return {
        items: data || []
    };
};
var mapFormToSearchItem = function mapFormToSearchItem(formBody) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return {
        depAirportCode: ((ref = formBody.depLocation) === null || ref === void 0 ? void 0 : ref.iataCode) || ((ref1 = formBody.depLocation) === null || ref1 === void 0 ? void 0 : ref1.cityCode) || "",
        destAirportCode: ((ref2 = formBody.destLocation) === null || ref2 === void 0 ? void 0 : ref2.iataCode) || ((ref3 = formBody.destLocation) === null || ref3 === void 0 ? void 0 : ref3.cityCode) || "",
        destName: ((ref4 = formBody.destLocation) === null || ref4 === void 0 ? void 0 : ref4.cityName) || ((ref5 = formBody.destLocation) === null || ref5 === void 0 ? void 0 : ref5.name) || "",
        depName: ((ref6 = formBody.depLocation) === null || ref6 === void 0 ? void 0 : ref6.cityName) || ((ref7 = formBody.depLocation) === null || ref7 === void 0 ? void 0 : ref7.name) || "",
        depDate: formBody.depDate.split("T")[0],
        depTime: formBody.depDate.split("T")[1],
        destDate: formBody.destDate.split("T")[0],
        destTime: formBody.destDate.split("T")[1],
        depWeekDay: "",
        destWeekDay: "",
        imageUrl: ""
    };
};
var mapHistoryItemToForm = function mapHistoryItemToForm(item) {
    var depName = item.depName, depDate = item.depDate, depTime = item.depTime, destName = item.destName, destDate = item.destDate, destTime = item.destTime, depAirportCode = item.depAirportCode, destAirportCode = item.destAirportCode;
    var depDateTime = "".concat(depDate, "T").concat(depTime);
    var destDateTime = "".concat(destDate, "T").concat(destTime);
    var revertToDefaultDates = isDeptDateInLessThanDays(depDateTime, 0) || isDestDateBeforeDepDate(destDateTime, depDateTime);
    return {
        depLocation: {
            name: depName,
            cityCode: depAirportCode,
            type: depAirportCode ? "airport" : "city"
        },
        depDate: revertToDefaultDates ? formatDate(DEFAULT_DEPARTURE_DATE) : depDateTime,
        destLocation: destName ? {
            cityCode: destAirportCode,
            name: destName,
            type: destAirportCode ? "airport" : "city"
        } : null,
        destDate: revertToDefaultDates ? formatDate(DEFAULT_DESTINATION_DATE) : destDateTime
    };
};
var addItemToSearchHistory = function addItemToSearchHistory(item) {
    var history = getSearchHistory();
    if (!history.items.find(function(storedItem) {
        return isEqual_default()(storedItem, item);
    })) {
        history.items.unshift(item);
        if (history.items.length > SEARCH_HISTORY_LIMIT) {
            history.items.pop();
        }
        src/* Session.SessionStorageManager.setData */.z_.h.setData(SEARCH_HISTORY_SESSION_STORAGE_KEY, history.items);
    }
};
var clearSearchHistory = function clearSearchHistory() {
    src/* Session.SessionStorageManager.removeData */.z_.h.removeData(SEARCH_HISTORY_SESSION_STORAGE_KEY);
};
var SearchHistory = function SearchHistory(param) {
    var onItemClick = param.onItemClick, _items = param.items, items = _items === void 0 ? [] : _items, onLastElementBlur = param.onLastElementBlur;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var language = _legacy/* I18nLegacy.useLocale */.P7.useLocale().language;
    var ref = useSearchContext(), setSearchFromHistory = ref.setSearchFromHistory, clearHistoryState = ref.clearSearchHistory;
    var handleSetItem = (0,react.useCallback)(function(item) {
        setSearchFromHistory(mapHistoryItemToForm(item));
        entities_src/* analytics.gtm.trackSearchHistorySelect */.co.gtm.trackSearchHistorySelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleClearItem = (0,react.useCallback)(function() {
        clearSearchHistory();
        clearHistoryState();
        entities_src/* analytics.gtm.trackSearchHistoryDelete */.co.gtm.trackSearchHistoryDelete();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var localDateFormats = src/* String.dateFormats */.Ld.dateFormats[language];
    var formatDateLong = function formatDateLong(value) {
        return (0,format/* format */.WU)(new Date(value), localDateFormats.dateLong, {
            locale: de.de
        });
    };
    var formatDuration = function formatDuration(start, end) {
        return [
            formatDateLong(start),
            formatDateLong(end)
        ].join(" – ");
    };
    var filteredItems = items.filter(function(item) {
        return item.language === language || item.language === undefined;
    });
    if (filteredItems.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline, {
                children: t("searchHistory.title")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                children: filteredItems.map(function(item, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemButton, {
                            onMouseDown: function onMouseDown(e) {
                                e.stopPropagation();
                                handleSetItem(item);
                                onItemClick();
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Destination, {
                                    children: [
                                        item.depName,
                                        " ",
                                        item.destName ? " - ".concat(item.destName) : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Duration, {
                                    children: formatDuration(item.depDate, item.destDate)
                                })
                            ]
                        })
                    }, item.depName + index);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteButton, {
                onMouseDown: handleClearItem,
                onBlur: onLastElementBlur,
                children: t("searchHistory.deleteLink")
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchHistory/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/hooks/useSubmitHandler.ts












var createPayload = function createPayload(param, isInternalCall) {
    var affiliate = param.affiliate, customerAge = param.customerAge, depDate = param.depDate, depLocation = param.depLocation, destDate = param.destDate, destLocation = param.destLocation, inputValue = param.inputValue;
    var shouldSearchServiceNumbers = isInternalCall && inputValue.departure[0] === "#";
    return shouldSearchServiceNumbers ? {
        customerAge: customerAge,
        depDate: depDate,
        depLocation: {
            name: inputValue.departure
        },
        destDate: destDate
    } : {
        aff: affiliate,
        customerAge: customerAge,
        depDate: depDate,
        depLocation: depLocation,
        destDate: destDate,
        destLocation: destLocation
    };
};
var matchError = function matchError(axiosError) {
    var ref, ref1, ref2, ref3;
    var errorData = (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.data;
    var errors = errorData === null || errorData === void 0 ? void 0 : (ref1 = errorData.error) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.meta) === null || ref2 === void 0 ? void 0 : ref2.errors;
    if (errorData && [
        "validation_error",
        "form_validation_error"
    ].includes((ref3 = errorData.error) === null || ref3 === void 0 ? void 0 : ref3.name)) {
        if (errors && Array.isArray(errors)) {
            return {
                type: "locationError",
                message: errors[0]
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.depDate) {
            return {
                type: "dateError",
                message: errors.depDate
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.destDate) {
            return {
                type: "dateError",
                message: errors.destDate
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.depLocation) {
            return {
                type: "locationError",
                message: errors.depLocation
            };
        }
        if (errors === null || errors === void 0 ? void 0 : errors.destLocation) {
            return {
                type: "locationError",
                message: errors.destLocation
            };
        }
    }
    return {
        type: "axiosError",
        message: axiosError.message
    };
};
var useSubmitHandler = function useSubmitHandler() {
    var formatApiUrl = useSearch().formatApiUrl;
    var redirectToTradedoubler = useAffiliate().redirectToTradedoubler;
    var ref = useSearchContext(), prefilterQuery = ref.prefilterQuery, isInternalCall = ref.isInternalCall;
    var ref1 = _legacy/* I18nLegacy.useLocale */.P7.useLocale(), language = ref1.language, market = ref1.market;
    return function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(formState, queryParams, onSuccess, onError) {
            var openInNewWindow, payload, data, savedSearchItem, url, tdUrl, targetUrl, axiosError;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        openInNewWindow = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                        if (!formState) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        payload = createPayload(formState, isInternalCall);
                        return [
                            4,
                            src/* http.axiosInstance.post */.dJ.axiosInstance.post(formatApiUrl("v1/quotes"), payload)
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (onSuccess) {
                            onSuccess(data);
                        }
                        if (data.redirectUrl) {
                            savedSearchItem = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mapFormToSearchItem(formState)), {
                                language: language || "",
                                market: market || ""
                            });
                            addItemToSearchHistory(savedSearchItem);
                            src/* Session.SessionStorageManager.setData */.z_.h.setData(SEARCH_FORM_SESSION_STORAGE_KEY, formState);
                            url = [
                                data.redirectUrl,
                                queryParams,
                                prefilterQuery
                            ].filter(Boolean).join("&");
                            tdUrl = redirectToTradedoubler(url);
                            targetUrl = tdUrl || url;
                            if (openInNewWindow) {
                                window.open(targetUrl, "_blank");
                            } else {
                                window.location.assign(targetUrl);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        axiosError = _state.sent();
                        if (axiosError && axios/* default.isAxiosError */.Z.isAxiosError(axiosError)) {
                            if (onError) {
                                onError(axiosError);
                            } else {
                                throw new Error(axiosError.message);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(formState, queryParams, onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }();
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/hooks/useSubmitInitialSearch.ts


// Creates a search handler that submits a search with default form state
var useSubmitInitialSearch = function useSubmitInitialSearch() {
    var handleSearch = useSubmitHandler();
    var getDefaultState = useSearchInitializer().getDefaultState;
    return {
        makeSearchHandler: function makeSearchHandler(location) {
            if (!location || !location.query) {
                return undefined;
            }
            var searchData = getDefaultState(location || null);
            return function(query) {
                handleSearch(searchData, query);
            };
        }
    };
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/hooks/index.ts






;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/Provider.tsx










var SearchContext = /*#__PURE__*/ react.createContext({
    clearSearchHistory: function clearSearchHistory() {
        return null;
    },
    getInputValue: function getInputValue() {
        return "";
    },
    isInternalCall: false,
    setCustomerAge: function setCustomerAge() {
        return null;
    },
    setDate: function setDate() {
        return null;
    },
    setInputValue: function setInputValue() {
        return null;
    },
    makeSetLocation: function makeSetLocation() {
        return function() {
            return null;
        };
    },
    setError: function setError() {
        return null;
    },
    setSearchFromHistory: function setSearchFromHistory() {
        return null;
    },
    setShowDestLocation: function setShowDestLocation() {
        return null;
    },
    state: null,
    validate: function validate() {
        return null;
    }
});
var SearchProvider = function SearchProvider(param) {
    var children = param.children, pageData = param.pageData;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var searchReducer = makeTranslatedSearchReducer(t);
    var initializeFormState = useSearchInitializer().initializeFormState;
    var getSessionData = useSession().getSessionData;
    var ref = (0,entities_src/* useSiteInfo */.Mj)(), isInternalCall = ref.settings.isInternalCall;
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useReducer(searchReducer, DEFAULT_VALUES, function(defaultValues) {
        return initializeFormState(defaultValues, (pageData === null || pageData === void 0 ? void 0 : pageData.location) || null);
    }), 2), state = ref1[0], dispatch = ref1[1];
    var validate = function validate() {
        dispatch({
            type: ActionType.VALIDATE
        });
    };
    var setCustomerAge = function setCustomerAge(customerAge) {
        dispatch({
            type: ActionType.SET_CUSTOMER_AGE,
            payload: {
                customerAge: customerAge
            }
        });
    };
    var setDate = function setDate(direction, date) {
        dispatch({
            type: ActionType.SET_DATE,
            payload: {
                direction: direction,
                date: date
            }
        });
    };
    var makeSetLocation = function makeSetLocation(direction) {
        return function(_location) {
            dispatch({
                type: ActionType.SET_LOCATION,
                payload: {
                    direction: direction,
                    location: _location
                }
            });
        };
    };
    var setError = function setError(error) {
        dispatch({
            type: ActionType.SET_ERROR,
            payload: error
        });
    };
    var setShowDestLocation = function setShowDestLocation(show) {
        dispatch({
            type: ActionType.SET_SHOW_DEST_LOCATION,
            payload: show
        });
    };
    var setSearchFromHistory = function setSearchFromHistory(payload) {
        dispatch({
            type: ActionType.SET_SEARCH_FROM_HISTORY,
            payload: payload
        });
    };
    var clearSearchHistory = function clearSearchHistory() {
        dispatch({
            type: ActionType.CLEAR_SEARCH_HISTORY
        });
    };
    var setInputValue = function setInputValue(direction, value) {
        dispatch({
            type: ActionType.SET_LOCATION_INPUT_VALUE,
            payload: {
                direction: direction,
                value: value
            }
        });
    };
    // Session data must be initialized here because it is not available in SSR
    (0,react.useEffect)(function() {
        var ref;
        var data = getSessionData(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.location) === null || ref === void 0 ? void 0 : ref.cityName);
        var history = getSearchHistory();
        if (data && !(pageData === null || pageData === void 0 ? void 0 : pageData.location)) {
            dispatch({
                type: ActionType.POPULATE_FORM,
                payload: data
            });
        }
        if (history) {
            dispatch({
                type: ActionType.POPULATE_HISTORY_ITEMS,
                payload: {
                    history: history
                }
            });
        }
    }, [
        getSessionData,
        pageData === null || pageData === void 0 ? void 0 : pageData.location
    ]);
    var value = (0,react.useMemo)(function() {
        return {
            clearSearchHistory: clearSearchHistory,
            getInputValue: function getInputValue(direction) {
                return state.inputValue[direction];
            },
            isInternalCall: isInternalCall,
            setCustomerAge: setCustomerAge,
            setDate: setDate,
            setError: setError,
            state: state,
            setInputValue: setInputValue,
            makeSetLocation: makeSetLocation,
            setSearchFromHistory: setSearchFromHistory,
            setShowDestLocation: setShowDestLocation,
            validate: validate,
            prefilterQuery: pageData === null || pageData === void 0 ? void 0 : pageData.prefilterQuery
        };
    }, [
        isInternalCall,
        state,
        pageData
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchContext.Provider, {
        value: value,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/useSearchContext.tsx


var useSearchContext = function useSearchContext() {
    return react.useContext(SearchContext);
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/context/index.ts






// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/Stage.styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      height: 100vh;\n      align-items: flex-start;\n      justify-content: center;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e9awvit0"
}, "target", "e9awvit0"))("position:relative;");
var Stage_styles_StageContentContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e9awvit1"
}, "target", "e9awvit1"))("width:100%;padding:0;", function(param) {
    var isAffiliate = param.isAffiliate;
    return isAffiliate && (0,emotion_react_browser_esm/* css */.iv)(_templateObject());
}, " ", src/* Theme.mq */.Q2.mq("sm"), "{margin:0 auto;background-color:transparent;}/* FIXME:This block causes layout issues with larger WidgetSearch,new type of StageContentContainer? */\n  ", src/* Theme.mq */.Q2.mq("lg"), "{display:flex;height:29.375rem;align-items:center;}");
var Stage_styles_StageCaption = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e9awvit2"
}, "target", "e9awvit2"))("background-color:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";display:inline-block;position:relative;width:100%;margin:1.875rem 0;", src/* Theme.mq */.Q2.mq("sm"), "{width:auto;}", src/* Theme.mq */.Q2.mq("md"), "{margin-top:0.625rem;margin-bottom:0.625rem;margin-right:0.625rem;padding:0.625rem 0.9375rem;}", src/* Theme.mq */.Q2.mq("lg"), "{margin-top:1rem;margin-bottom:1rem;margin-right:1rem;}");
var StageLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "e9awvit3"
}, "target", "e9awvit3"))("display:none;", src/* Theme.mq */.Q2.mq("sm"), "{display:block;overflow:hidden;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);min-height:29.375rem;width:100vw;text-indent:-100em;}");
var SuppliersContentContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e9awvit4"
}, "target", "e9awvit4"))("padding-bottom:2rem;")));
var Stage_styles_SupplierList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e9awvit5"
}, "target", "e9awvit5"))("height:auto;margin:0 auto;padding:0.85rem;display:flex;flex-wrap:wrap;justify-content:space-around;gap:1rem;", src/* Theme.mq */.Q2.mq("sm"), "{border:0;min-height:3.52rem;}");
var Stage_styles_SupplierListItem = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("li", _define_property({
    target: "e9awvit6"
}, "target", "e9awvit6"))("svg{height:1.5rem;}")));
var BadgesContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("aside", _define_property({
    target: "e9awvit7"
}, "target", "e9awvit7"))("position:absolute;bottom:1rem;right:1rem;z-index:1;display:flex;place-items:flex-end;gap:1rem;flex-direction:column;")));
var TrustElement = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e9awvit8"
}, "target", "e9awvit8"))("display:inline-flex;padding:0.5rem;border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.xs;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";")));


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/context.ts

var StageContext = (0,react.createContext)({
    stageImage: "Stage-Bilder_PalmaDeMallorca1.jpg",
    setStageImage: function setStageImage() {}
});
var useStageContext = function useStageContext() {
    return (0,react.useContext)(StageContext);
};


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/Error.tsx






var Error_Error = function Error(param) {
    var statusCode = param.statusCode;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage");
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat(src/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), false);
    var ref = (0,react.useState)(true), showModal = ref[0], setShowModal = ref[1];
    var handleHideModal = function handleHideModal() {
        setShowModal(false);
    };
    var messageProps = {
        404: {
            headline: t("errors.404.title"),
            children: t("errors.404.text")
        },
        500: {
            headline: t("errors.500.title"),
            children: t("errors.500.text")
        },
        503: {
            headline: t("errors.503.title"),
            children: t("errors.503.text")
        }
    };
    var hasError = statusCode ? Object.keys(messageProps).includes(statusCode.toString()) : false;
    if (!statusCode || !hasError) {
        return null;
    }
    if (isMobile) {
        if (showModal) {
            var _statusCode = messageProps[statusCode], headline = _statusCode.headline, children = _statusCode.children;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Overlay */.Ui.aV, {
                title: headline,
                open: showModal,
                onClose: handleHideModal,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Message */.Ui.v0, {
                    severity: src/* Ui.MessageSeverity.ERROR */.Ui.CE.ERROR,
                    role: src/* Ui.MessageRole.ALERT */.Ui.lB.ALERT,
                    children: children
                })
            });
        }
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Message */.Ui.v0, (0,_object_spread/* default */.Z)({
        severity: src/* Ui.MessageSeverity.ERROR */.Ui.CE.ERROR,
        role: src/* Ui.MessageRole.ALERT */.Ui.lB.ALERT
    }, messageProps[statusCode]));
};


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/Stage.tsx









var IMAGE_PATH_PREFIX = "/bm/global/files/images/";
var Stage = function Stage(param) {
    var content = param.content, link = param.link, statusCode = param.statusCode;
    var ref = content || {}, keyword = ref.keyword, search = ref.search, imageData = ref.image, includeSearch = ref.includeSearch;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage");
    var formatImage = src_legacy/* HostLegacy.useHost */.IW.useHost().formatImage;
    var defaultImage = {
        src: t("defaultImage.src"),
        alt: t("defaultImage.alt"),
        id: t("defaultImage.id")
    };
    var image = imageData || defaultImage;
    var ref1 = (0,react.useState)(image.src), stageImage = ref1[0], setStageImage = ref1[1];
    var handleStageImageChange = (0,react.useCallback)(function(src) {
        var imageSrc = src ? "".concat(IMAGE_PATH_PREFIX).concat(src) : defaultImage.src;
        setStageImage(imageSrc);
    }, [
        defaultImage.src
    ]);
    var value = (0,react.useMemo)(function() {
        return {
            stageImage: stageImage,
            setStageImage: handleStageImageChange
        };
    }, [
        handleStageImageChange,
        stageImage
    ]);
    var newImage = (0,_object_spread/* default */.Z)({}, image);
    if (image === defaultImage) {
        newImage.src = formatImage(stageImage || image.src);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* LayoutLegacy.ImageSegment */.uN.oQ, {
            id: "stage-image",
            image: newImage,
            isStage: true,
            includeSearch: includeSearch,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageContext.Provider, {
                value: value,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stage_styles_StageContentContainer, {
                    children: [
                        Boolean(link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageLink, {
                            href: link === null || link === void 0 ? void 0 : link.href,
                            target: link === null || link === void 0 ? void 0 : link.target,
                            children: link === null || link === void 0 ? void 0 : link.title
                        }),
                        includeSearch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stage_styles_StageCaption, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFormWithContext, {
                                stageTitle: keyword,
                                pageData: search
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error_Error, {
                            statusCode: statusCode
                        })
                    ]
                })
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/NewsletterRegistrationLegacy/NewsletterRegistration.styles.ts


function NewsletterRegistration_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      align-items: center;\n    "
    ]);
    NewsletterRegistration_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NewsletterRegistration_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7kvkwu0"
}, "target", "e7kvkwu0"))("display:flex;gap:1rem;", function(param) {
    var alignCenter = param.alignCenter;
    return alignCenter && (0,emotion_react_browser_esm/* css */.iv)(NewsletterRegistration_styles_templateObject());
});
var ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7kvkwu1"
}, "target", "e7kvkwu1"))("display:none;", src/* Theme.mq */.Q2.mq("lg"), "{display:block;position:relative;max-width:300px;height:300px;flex:0 0 50%;}");
var NewsletterRegistration_styles_Headline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7kvkwu2"
}, "target", "e7kvkwu2"))("margin:0 0 1rem;font-weight:bold;font-size:1rem;");
var LegalText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7kvkwu3"
}, "target", "e7kvkwu3"))("margin:1rem 0;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";font-size:0.75rem;a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:underline;text-underline-offset:0.125rem;transition:text-underline-offset 0.2s linear;&:hover,&:focus{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";}&:focus-visible{outline:0.125rem dashed ", function(param) {
    var theme = param.theme;
    return theme.color.natural70;
}, ";outline-offset:0.25rem;}&:active{color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* darken */._j)(0.08, theme === null || theme === void 0 ? void 0 : theme.color.primary);
}, ";text-underline-offset:0.25rem;}}");
var FormContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7kvkwu4"
}, "target", "e7kvkwu4"))("height:100%;display:flex;flex-direction:column;justify-content:space-between;");


;// CONCATENATED MODULE: ../../frontend/features/src/NewsletterRegistrationLegacy/NewsletterSignup.tsx









var NewsletterSignup = function NewsletterSignup(param) {
    var showImage = param.showImage, showTitle = param.showTitle, showHeadline = param.showHeadline, onSubmit = param.onSubmit;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.newsletterRegistrationLegacy.newsletterRegistration");
    var formatImage = src_legacy/* HostLegacy.useHost */.IW.useHost().formatImage;
    var inputRef = (0,react.useRef)(null);
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                if (inputRef.current) {
                    onSubmit(inputRef.current.value);
                }
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            showTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SectionTitle */.ws.SectionTitle, {
                children: t("title")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewsletterRegistration_styles_Container, {
                children: [
                    showImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* OptimizationLegacy.ResponsiveImage */.CE.t, {
                            src: formatImage(t("imageSource")),
                            alt: "Email",
                            width: 300,
                            height: 300
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                        method: "post",
                        id: "newsletter-form",
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormContainer, {
                            children: [
                                showHeadline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterRegistration_styles_Headline, {
                                    children: t("headline")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Input */.Ui.II, {
                                    ref: inputRef,
                                    type: "email",
                                    id: "newsletter-email",
                                    name: "email",
                                    label: t("label"),
                                    autoComplete: "email",
                                    autoCorrect: "off",
                                    autoCapitalize: "off",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LegalText, {
                                    dangerouslySetInnerHTML: {
                                        __html: t.raw("legalText")
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                                    type: "submit",
                                    fullWidth: true,
                                    children: t("buttonText")
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/NewsletterRegistrationLegacy/NewsletterSignupSuccess.tsx





var NewsletterSignupSuccess = function NewsletterSignupSuccess(param) {
    var showTitle = param.showTitle;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.newsletterRegistrationLegacy.newsletterRegistration");
    var formatImage = src_legacy/* HostLegacy.useHost */.IW.useHost().formatImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            showTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SectionTitle */.ws.SectionTitle, {
                children: t("newsletterSuccessTitle")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewsletterRegistration_styles_Container, {
                alignCenter: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                        src: formatImage("/bm/global/graphic/image/flexsite/nl_success.svg"),
                        alt: "",
                        width: 115,
                        height: 132
                    }),
                    t("newsletterSuccessText")
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/NewsletterRegistrationLegacy/useNewsletter.ts

var useNewsletter_useClientContext = _legacy/* Context.useClientContext */._y.useClientContext;
var useNewsletter_hasContext = _legacy/* Context.guardContext */._y.guardContext;
var useNewsletter_join = function join(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
var useNewsletter = function useNewsletter() {
    var result = useNewsletter_useClientContext("newsletter");
    useNewsletter_hasContext("newsletter", result);
    var baseUrl = result.value.baseUrl;
    return {
        formatApiUrl: function formatApiUrl(path) {
            return useNewsletter_join(baseUrl, path);
        }
    };
};


;// CONCATENATED MODULE: ../../frontend/features/src/NewsletterRegistrationLegacy/NewsletterRegistration.tsx










var NewsletterRegistration = function NewsletterRegistration(param) {
    var type = param.type;
    var formatApiUrl = useNewsletter().formatApiUrl;
    var ref = (0,react.useState)(false), success = ref[0], setSuccess = ref[1];
    var isIndexType = type === "index";
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.newsletterRegistrationLegacy.newsletterRegistration");
    var trackRegistration = function trackRegistration() {
        if (type === "index") {
            entities_src/* analytics.gtm.trackNewsletterRegistrationIndex */.co.gtm.trackNewsletterRegistrationIndex();
        } else {
            entities_src/* analytics.gtm.trackNewsletterRegistration */.co.gtm.trackNewsletterRegistration();
        }
    };
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(email) {
            var sourceParam, axiosError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sourceParam = {
                            index: t("sourceParam.index"),
                            landing: t("sourceParam.landing")
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            src/* http.axiosInstance.post */.dJ.axiosInstance.post(formatApiUrl("v1/newsletter/subscribe"), {
                                email: email,
                                sourceParam: sourceParam[type]
                            })
                        ];
                    case 2:
                        _state.sent();
                        setSuccess(true);
                        trackRegistration();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        axiosError = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(email) {
            return _ref.apply(this, arguments);
        };
    }();
    return success ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterSignupSuccess, {
        showTitle: isIndexType
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterSignup, {
        showImage: isIndexType,
        showTitle: isIndexType,
        showHeadline: isIndexType,
        onSubmit: onSubmit
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/NewsletterRegistrationLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/NewsletterStage.tsx





var NewsletterStage = function NewsletterStage() {
    var formatImage = src_legacy/* HostLegacy.useHost */.IW.useHost().formatImage;
    var image = {
        src: formatImage("/bm/global/files/images/XL-M_1400x470_200kb.jpg"),
        alt: "Newsletter",
        id: "newsletter-stage"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* LayoutLegacy.ImageSegment */.uN.oQ, {
        image: image,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stage_styles_StageContentContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stage_styles_StageCaption, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterRegistration, {
                    type: "landing"
                })
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/WidgetStage.styles.ts


function WidgetStage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        /* stylelint-disable-next-line media-query-no-invalid */\n        @media ",
        " {\n          background-image: url('",
        "",
        "/bg-",
        "-",
        ".jpg');\n\n          @media (min-resolution: 2dppx) {\n            background-image: url('",
        "",
        "/bg-",
        "-",
        "@2x.jpg');\n          }\n        }\n      "
    ]);
    WidgetStage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var imagePath = "/bm/global/graphic/image/widget";
var sizes = [
    {
        width: 250,
        height: 250,
        media: "(max-width: 250px) and (max-height: 250px)"
    },
    {
        width: 300,
        height: 250,
        media: "(min-width: 251px) and (max-width: 300px) and (max-height: 250px)"
    },
    {
        width: 300,
        height: 400,
        media: "(min-width: 251px) and (min-height: 251px) and (max-width: 300px) and (max-height: 400px)"
    },
    {
        width: 320,
        height: 480,
        media: "(min-width: 301px) and (max-width: 320px) and (max-height: 480px)"
    },
    {
        width: 300,
        height: 600,
        media: "(min-width: 251px) and (min-height: 401px) and (max-width: 300px) and (max-height: 600px)"
    },
    {
        width: 800,
        height: 250,
        media: "(min-width: 321px) and (max-width: 800px)"
    },
    {
        width: 970,
        height: 250,
        media: "(min-width: 801px) and (max-width: 970px)"
    }, 
];
var WidgetStage_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e70x080"
}, "target", "e70x080"))("position:relative;z-index:1;display:flex;width:100vw;height:100vh;flex-direction:column;justify-content:space-between;background-repeat:no-repeat;background-size:cover;", function(param) {
    var baseImageUrl = param.baseImageUrl;
    return sizes.map(function(param) {
        var width = param.width, height = param.height, media = param.media;
        return (0,emotion_react_browser_esm/* css */.iv)(WidgetStage_styles_templateObject(), media, baseImageUrl, imagePath, width, height, baseImageUrl, imagePath, width, height);
    });
}, "  @media (min-width:780px){flex-direction:row-reverse;}");
var LogoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e70x081"
}, "target", "e70x081"))("position:relative;");
var Logo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e70x082"
}, "target", "e70x082"))("display:inline-flex;margin:0.3125rem 0.625rem;@media (min-height:400px) or (min-width:800px){position:absolute;left:0;bottom:1rem;margin:0;padding:0.25rem 0.625rem;background:#fffb;}img{width:auto;height:25px;vertical-align:bottom;}");


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/WidgetStage.tsx





/**
 * Rendered sizes:
 * - 250x250
 * - 300x250
 * - 300x400
 * - 300x600
 * - 320x480
 * - 800x250
 * - 970x250
 * @see https://silvertours.atlassian.net/browse/DGN-1785
 * @see https://silvertours.atlassian.net/browse/DGN-1784
 */ var WidgetStage = function WidgetStage(param) {
    var baseImageUrl = param.baseImageUrl;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WidgetStage_styles_Wrapper, {
        baseImageUrl: baseImageUrl,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WidgetSearchFormWithContext, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
                id: "logo",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                        src: "".concat(baseImageUrl).concat(t("widget.logo.src")),
                        alt: t("widget.logo.alt"),
                        loading: "lazy"
                    })
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/Suppliers.tsx





var Suppliers = function Suppliers(param) {
    var suppliers = param.suppliers;
    if (!suppliers || suppliers.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(LayoutLegacy.PlainSegment, {
        id: "suppliers",
        children: /*#__PURE__*/ _jsx(SupplierList, {
            children: suppliers.map(function(param) {
                var id = param.id;
                return /*#__PURE__*/ _jsx(SupplierListItem, {
                    children: /*#__PURE__*/ _jsx(UiLegacy.ImageSVG, {
                        name: id
                    })
                }, id);
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/StageLegacy/index.ts






;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/LocationSuggest/LocationSuggest.tsx
/* eslint-disable no-underscore-dangle */ 








var LocationSuggest = function LocationSuggest(param) {
    var connectedInputContainer = param.connectedInputContainer, onLastElementBlur = param.onLastElementBlur, loading = param.loading, onItemClick = param.onItemClick, results = param.results;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var state = useSearchContext().state;
    var setStageImage = useStageContext().setStageImage;
    var listRef = (0,react.useRef)(null);
    var isMobileTouchDevice = src/* Theme.useIsMobileTouchDevice */.Q2.useIsMobileTouchDevice();
    var handleEnter = function handleEnter(item) {
        onItemClick(item);
    };
    var ref = (0,entities_src/* useKeyNavigation */.Fp)(results || [], listRef, handleEnter), focusedItem = ref.focusedItem, onMouseEnter = ref.onMouseEnter, onMouseLeave = ref.onMouseLeave;
    (0,react.useEffect)(function() {
        if (isMobileTouchDevice && (connectedInputContainer === null || connectedInputContainer === void 0 ? void 0 : connectedInputContainer.current)) {
            connectedInputContainer.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isMobileTouchDevice,
        connectedInputContainer
    ]);
    var handleClick = function handleClick(suggestion) {
        onItemClick(suggestion);
        setStageImage(suggestion.image_path);
    };
    if (!loading && !(results === null || results === void 0 ? void 0 : results.length) && !(state === null || state === void 0 ? void 0 : state.depLocation)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorMessage, {
            children: t("errorTexts.dep")
        });
    }
    return results && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledList, {
        ref: listRef,
        id: "locationSuggest",
        children: results.map(function(suggestion, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationSuggest_styles_StyledButton, {
                    type: "button",
                    tabIndex: 0,
                    onBlur: onLastElementBlur,
                    onMouseDown: function onMouseDown() {
                        return handleClick(suggestion);
                    },
                    onMouseEnter: function onMouseEnter1() {
                        return onMouseEnter(index);
                    },
                    onMouseLeave: onMouseLeave,
                    id: "locationSuggestItem-".concat(index + 1),
                    "aria-selected": index === focusedItem,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchResultItem, {
                        suggestion: suggestion
                    })
                })
            }, suggestion.objectID);
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/LocationSuggest/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchInput/SearchInput.styles.ts


var SearchInput_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1l6pp6z0"
}, "target", "e1l6pp6z0"))("position:relative;");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchInput/SearchInput.tsx









var isDeparture = function isDeparture(props) {
    return props.direction === "departure";
};
var getSubmit = function getSubmit(props) {
    return isDeparture(props) ? props.onServiceNumbersSubmit : undefined;
};
var SearchInput = function SearchInput(props) {
    var ref = useSearchContext(), getInputValue = ref.getInputValue, isInternalCall = ref.isInternalCall, state = ref.state, setInputValue = ref.setInputValue, makeSetLocation = ref.makeSetLocation, setError = ref.setError;
    var direction = props.direction, _history = props.history, history = _history === void 0 ? {
        items: []
    } : _history, icon = props.icon, label = props.label, placeholder = props.placeholder, id = props.id, name = props.name;
    var handleSubmit = getSubmit(props);
    var setLocation = makeSetLocation(direction);
    var value = getInputValue(direction);
    var shouldSearchServiceNumbers = isInternalCall && direction === "departure" && value[0] === "#";
    var ref1 = (0,react.useState)(false), showSearchHistory = ref1[0], setShowSearchHistory = ref1[1];
    var ref2 = (0,react.useState)(false), showLocationSuggest = ref2[0], setShowLocationSuggest = ref2[1];
    var fieldRef = (0,react.useRef)(null);
    var ref3 = _legacy/* I18nLegacy.useLocale */.P7.useLocale(), language = ref3.language, market = ref3.market;
    var consumerApiSettings = entities_src/* Runtime.useConsumerApi */.r_.useConsumerApi().consumerApiSettings;
    var ref4 = (0,entities_src/* useSearchSuggestions */.fb)(language, market, consumerApiSettings), clearResults = ref4.clearResults, fetchSuggestions = ref4.fetchSuggestions, loading = ref4.loading, results = ref4.results;
    var handleChange = function handleChange(inputValue) {
        setInputValue(direction, inputValue);
        if (inputValue === "") {
            clearResults();
            setShowSearchHistory(true);
            setShowLocationSuggest(false);
        } else {
            setShowSearchHistory(false);
            if (shouldSearchServiceNumbers) {
                setShowLocationSuggest(false);
            } else {
                setShowLocationSuggest(true);
                setLocation(null);
                fetchSuggestions(inputValue);
            }
        }
    };
    var handleSuggestionValue = function handleSuggestionValue(suggestion) {
        if (suggestion) {
            var location = (0,entities_src/* getLocation */.k$)(suggestion);
            setShowLocationSuggest(false);
            setInputValue(direction, location.name);
            setLocation(location);
            clearResults();
        } else {
            handleChange(value);
            if (shouldSearchServiceNumbers && !!handleSubmit) {
                handleSubmit();
            }
        }
    };
    if (!state) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchInput_styles_Container, {
        role: "combobox",
        "aria-expanded": showSearchHistory,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Input */.Ui.II, {
                ref: fieldRef,
                value: value,
                label: label,
                name: name !== null && name !== void 0 ? name : id,
                id: id,
                placeholder: placeholder,
                icon: icon,
                error: state.locationError,
                autoComplete: "off",
                forcedLabel: true,
                onFocus: function onFocus(e) {
                    setError({
                        kind: "locationError",
                        message: ""
                    });
                    if (e.target.value === "") {
                        setShowSearchHistory(true);
                    } else {
                        fetchSuggestions(e.target.value);
                        setShowLocationSuggest(true);
                    }
                },
                onBlur: function onBlur(e) {
                    var ref, ref1, ref2;
                    if (!((ref = e.relatedTarget) === null || ref === void 0 ? void 0 : ref.className.includes("searchHistory"))) {
                        setShowSearchHistory(false);
                    }
                    if (!(((ref1 = e.relatedTarget) === null || ref1 === void 0 ? void 0 : ref1.className.includes("inputCloseIcon")) || ((ref2 = e.relatedTarget) === null || ref2 === void 0 ? void 0 : ref2.id.includes("locationSuggest")))) {
                        setShowLocationSuggest(false);
                    }
                },
                onChange: function onChange(event) {
                    return handleChange(event.target.value);
                }
            }),
            history.items.length > 0 && showSearchHistory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHistory, {
                items: history.items,
                onItemClick: clearResults,
                onLastElementBlur: function onLastElementBlur() {
                    setShowSearchHistory(false);
                }
            }),
            showLocationSuggest && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationSuggest, {
                connectedInputContainer: fieldRef,
                loading: loading,
                onLastElementBlur: function onLastElementBlur() {
                    setShowLocationSuggest(false);
                },
                onItemClick: handleSuggestionValue,
                results: results
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchInput/index.ts


// EXTERNAL MODULE: ../../node_modules/lodash/concat.js
var concat = __webpack_require__(2487);
var concat_default = /*#__PURE__*/__webpack_require__.n(concat);
// EXTERNAL MODULE: ../../node_modules/lodash/range.js
var range = __webpack_require__(2689);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Info.js
var Info = __webpack_require__(1647);
var Info_default = /*#__PURE__*/__webpack_require__.n(Info);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/AgeDropdown/AgeDropdown.styles.ts



var DropdownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eisnkt40"
}, "target", "eisnkt40"))("display:flex;align-items:center;column-gap:1rem;");
var InfoIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Info_default()), (0,src_define_property/* default */.Z)({
    target: "eisnkt41"
}, "target", "eisnkt41"))("fill:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";width:1.6rem;height:1.6rem;vertical-align:middle;cursor:pointer;");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/AgeDropdown/AgeDropdown.tsx








var AgeDropdown = function AgeDropdown(param) {
    var value = param.value, label = param.label, onChange = param.onChange;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var ref = (0,react.useState)(value < 26 || value > 65), showDropdown = ref[0], setShowDropdown = ref[1];
    var ageDropdownData = concat_default()(range_default()(18, 26).map(function(item) {
        return {
            label: item.toString(),
            value: item.toString()
        };
    }), {
        label: t("age.defaultAge"),
        value: DEFAULT_AGE.toString()
    }, range_default()(66, 100).map(function(item) {
        return {
            label: item.toString(),
            value: item.toString()
        };
    }));
    var handleChange = function handleChange(event) {
        var age = Number(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(age);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropdownWrapper, {
        children: [
            showDropdown ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                        htmlFor: "customerAge",
                        children: t("age.select.label")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Dropdown */.ws.Dropdown, {
                        id: "customerAge",
                        value: value,
                        options: ageDropdownData,
                        onChange: handleChange
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Checkbox */.ws.Checkbox, {
                id: "driverIsAdult",
                label: label,
                checked: true,
                onChange: function onChange() {
                    return setShowDropdown(!showDropdown);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Tooltip */.ws.Tooltip, {
                    content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Markup */.ws.Markup, {
                        content: t("age.tooltip.text")
                    }),
                    trigger: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoIcon, {})
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/AgeDropdown/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/Logo/Logo.styles.ts


var Logo_styles_LogoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e106cohp0"
}, "target", "e106cohp0"))("display:flex;align-items:center;justify-content:center;gap:0.5rem;font-size:0.75rem;img{height:30px;vertical-align:middle;}a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";}");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/Logo/Logo.tsx




var Logo_Logo = function Logo() {
    var ref = entities_src/* Runtime.useHost */.r_.useHost(), baseUrl = ref.baseUrl, baseImageUrl = ref.baseImageUrl;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Logo_styles_LogoWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: t("widget.poweredBy")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: "".concat(baseUrl, "/"),
                target: "_blank",
                rel: "noopener noreferrer nofollow",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: "".concat(baseImageUrl).concat(t("widget.logo.src")),
                    alt: t("widget.logo.alt"),
                    title: t("widget.logo.title"),
                    loading: "lazy"
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/Logo/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowLast.js
var ArrowLast = __webpack_require__(4327);
var ArrowLast_default = /*#__PURE__*/__webpack_require__.n(ArrowLast);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowNext.js
var ArrowNext = __webpack_require__(5403);
var ArrowNext_default = /*#__PURE__*/__webpack_require__.n(ArrowNext);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Close.js
var dist_Close = __webpack_require__(2530);
var Close_default = /*#__PURE__*/__webpack_require__.n(dist_Close);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchForm.styles.ts






var SearchForm_styles_Header = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "edjb2sm0"
}, "target", "edjb2sm0"))("position:relative;min-height:2.5rem;margin-bottom:0.625rem;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("b", (0,src_define_property/* default */.Z)({
    target: "edjb2sm1"
}, "target", "edjb2sm1"))("display:inline-block;padding:0.75rem 0 0.5rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;font-weight:400;line-height:1.125;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{max-width:18.5rem;}", function(param) {
    var customColor = param.customColor;
    return customColor && "color: ".concat(customColor, "; font-weight: 700;");
});
var Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "edjb2sm2"
}, "target", "edjb2sm2"))("color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";font-size:1rem;");
var SearchForm_styles_FormContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "edjb2sm3"
}, "target", "edjb2sm3"))("width:505px;flex-grow:0;> *:not(:last-of-type){margin-bottom:0.625rem;}");
var StyledForm = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("form", (0,src_define_property/* default */.Z)({
    target: "edjb2sm4"
}, "target", "edjb2sm4"))("display:flex;flex-direction:row;aside{width:320px;flex-grow:1;}");
var ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "edjb2sm5"
}, "target", "edjb2sm5"))("button{margin:0.625rem 0;", function(param) {
    var customColor = param.customColor;
    return customColor && "background-color: ".concat(customColor, ";");
}, "}");
var FooterLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "edjb2sm6"
}, "target", "edjb2sm6"))("text-align:right;margin-bottom:0;a{", function(param) {
    var iconOnLeft = param.iconOnLeft;
    return iconOnLeft && "flex-direction: row-reverse;";
}, "}");
var getOptionsStyles = function getOptionsStyles(theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:0.75rem;height:0.75rem;fill:", theme.color.primary, ";");
};
var OptionsOpenIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowLast_default()), (0,src_define_property/* default */.Z)({
    target: "edjb2sm7"
}, "target", "edjb2sm7"))(function(param) {
    var theme = param.theme;
    return getOptionsStyles(theme);
}, ";");
var OptionsCloseIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowNext_default()), (0,src_define_property/* default */.Z)({
    target: "edjb2sm8"
}, "target", "edjb2sm8"))(function(param) {
    var theme = param.theme;
    return getOptionsStyles(theme);
}, ";");
var CloseIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Close_default()), (0,src_define_property/* default */.Z)({
    target: "edjb2sm9"
}, "target", "edjb2sm9"))("cursor:pointer;");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/utils.ts
// Format checked options for use in the booking funnel
var getOptionsParam = function getOptionsParam(checkedOptions) {
    var queryParams = {};
    if (checkedOptions.includes("insfull")) {
        queryParams.coverage_type = "without_excess";
    }
    if (checkedOptions.includes("fib_ab")) {
        queryParams.car_class = "mini_economy";
    }
    if (checkedOptions.includes("fib_ad")) {
        queryParams.car_class = "compact";
    }
    if (checkedOptions.includes("fib_al")) {
        queryParams.car_class = "standard_elite_full_size";
    }
    if (checkedOptions.includes("fib_ae")) {
        queryParams.car_type = "wagon_estate";
    }
    if (checkedOptions.includes("fib_af")) {
        queryParams.car_class = "intermediate_standard";
    }
    if (checkedOptions.includes("fib_ed")) {
        queryParams.all_km_included = true;
    }
    if (checkedOptions.includes("fib_ec")) {
        queryParams.additional_driver_included = true;
    }
    if (checkedOptions.includes("fib_eb")) {
        queryParams.winterwheel = true;
    }
    if (checkedOptions.includes("fib_ee")) {
        queryParams.fair_fuel_policy = true;
    }
    var queryString = new URLSearchParams(queryParams).toString();
    return queryString;
};

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/SearchForm.tsx























var SearchForm_SearchForm = function SearchForm(param) {
    var customColor = param.customColor, isAffiliate = param.isAffiliate, stageTitle = param.stageTitle;
    var ref = (0,entities_src/* useSiteInfo */.Mj)(), featureToggles = ref.settings.featureToggles;
    var ref1 = useSearchContext(), setCustomerAge = ref1.setCustomerAge, setDate = ref1.setDate, setError = ref1.setError, setShowDestLocation = ref1.setShowDestLocation, state = ref1.state;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var submitHandler = useSubmitHandler();
    var ref2 = useSession(), trackClickTimestamp = ref2.trackClickTimestamp, removeClickTimestamp = ref2.removeClickTimestamp;
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var isMobileTouchDevice = src/* Theme.useIsMobileTouchDevice */.Q2.useIsMobileTouchDevice();
    var ref4 = (0,react.useState)(false), showOptions = ref4[0], setShowOptions = ref4[1];
    var ref5 = (0,react.useState)([]), checkedOptions = ref5[0], setCheckedOptions = ref5[1];
    // Show or hide the options on the right side of the form
    var toggleOptions = function toggleOptions() {
        var showOptionsValue = !showOptions;
        setShowOptions(showOptionsValue);
        entities_src/* analytics.gtm.trackToggleMoreOptions */.co.gtm.trackToggleMoreOptions(showOptionsValue);
    };
    var handleOptionsChange = function handleOptionsChange(optionsId) {
        var checked = checkedOptions;
        if (checked.includes(optionsId)) {
            checked = checked.filter(function(key) {
                return key !== optionsId;
            });
        } else {
            checked = _toConsumableArray(checked).concat([
                optionsId
            ]);
        }
        setCheckedOptions(checked);
    };
    var onError = (0,react.useCallback)(function(error) {
        setLoading(false);
        removeClickTimestamp();
        var ref = matchError(error), kind = ref.type, message = ref.message;
        if (isFormError(kind)) {
            setError({
                kind: kind,
                message: message
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleSearchSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        trackClickTimestamp();
                        return [
                            4,
                            submitHandler(state, getOptionsParam(checkedOptions), function() {
                                setLoading(false);
                            }, onError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                if (loading) {
                    return [
                        2
                    ];
                }
                handleSearchSubmit();
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!state) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchForm_styles_Header, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        customColor: customColor,
                        children: stageTitle || t("title")
                    }),
                    !isAffiliate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                        children: t("subtitle")
                    }),
                    featureToggles.useSavingBadge ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* TooltipBadge */.C5, {
                        badgeText: t("savingBadge"),
                        tooltipTitle: t("savingBadge"),
                        tooltipText: t.raw("saving.tooltip.text"),
                        onHover: function onHover() {
                            return entities_src/* analytics.gtm.trackSavingHover */.co.gtm.trackSavingHover();
                        }
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* TooltipBadge */.C5, {
                        badgeText: t("cancellationBadge"),
                        tooltipTitle: t("cancellationBadge"),
                        tooltipText: t.raw("cancellation.tooltip.text"),
                        onHover: function onHover() {
                            return entities_src/* analytics.gtm.trackCancellationHover */.co.gtm.trackCancellationHover();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledForm, {
                onSubmit: handleSubmit,
                id: "search",
                role: "search",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchForm_styles_FormContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchInput, {
                                id: "dep",
                                onServiceNumbersSubmit: handleSearchSubmit,
                                history: state.history,
                                direction: "departure",
                                label: t("departure.label"),
                                placeholder: t("departure.placeholder"),
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((Search_default()), {})
                            }),
                            !state.showDestLocation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Checkbox */.ws.Checkbox, {
                                label: t("destination.label"),
                                id: "destSelect",
                                checked: state.showDestLocation,
                                onChange: function onChange() {
                                    return setShowDestLocation(true);
                                }
                            }),
                            state.showDestLocation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchInput, {
                                id: "dest",
                                direction: "destination",
                                label: t("destination.label"),
                                placeholder: t("destination.placeholder"),
                                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon, {
                                    className: "inputCloseIcon",
                                    onClick: function onClick() {
                                        return setShowDestLocation(false);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.DateRangePicker */.ws.DateRangePicker, {
                                from: new Date(state.depDate),
                                to: new Date(state.destDate),
                                error: state.dateError || "",
                                onDatesChange: function onDatesChange(dates) {
                                    setDate("departure", dates.from);
                                    setDate("destination", dates.to);
                                },
                                vertical: isMobileTouchDevice
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AgeDropdown, {
                                value: state.customerAge,
                                label: t("age.label"),
                                onChange: setCustomerAge
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
                                customColor: customColor,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                                    id: "find",
                                    loading: loading,
                                    type: "submit",
                                    fullWidth: true,
                                    textId: "find-button-text",
                                    children: t("button.label")
                                })
                            }),
                            state.axiosError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.ErrorMessage */.Ui.Bc, {
                                children: t("errorTexts.request")
                            }),
                            isAffiliate && !isMobileTouchDevice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo_Logo, {}),
                            !isAffiliate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterLink, {
                                iconOnLeft: showOptions,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Ui.TextLink */.Ui.hh, {
                                    id: "more-options-text",
                                    as: "button",
                                    onClick: toggleOptions,
                                    children: [
                                        t("options.label"),
                                        " ",
                                        checkedOptions.length > 0 && "(".concat(checkedOptions.length, ")"),
                                        showOptions ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsOpenIcon, {
                                            id: "more-options-open-icon"
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OptionsCloseIcon, {
                                            id: "more-options-close-icon"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    showOptions && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFormOptions, {
                        onChange: handleOptionsChange,
                        setShowOptions: setShowOptions,
                        checked: checkedOptions
                    })
                ]
            })
        ]
    });
};
var SearchFormWithContext = function SearchFormWithContext(_param) /*#__PURE__*/ {
    var pageData = _param.pageData, formProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "pageData"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchProvider, {
        pageData: pageData,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchForm_SearchForm, (0,_object_spread/* default */.Z)({}, formProps))
    });
};


;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/WidgetSearchForm.styles.ts



/**
 * TODO: Maybe use @emotion/babel-plugin to target Title, Subtitle, Badge, ButtonWrapper here
 * instead of passing props repeatedly to every single component
 * or introduce additional smaller `size` type to SearchInput, DateRangePicker components
 */ var WidgetSearchForm_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ia8t210"
}, "target", "e1ia8t210"))("margin:0 0.625rem;");
var WidgetSearchForm_styles_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", (0,src_define_property/* default */.Z)({
    target: "e1ia8t211"
}, "target", "e1ia8t211"))("margin:0;width:100%;overflow:hidden;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;font-weight:bold;line-height:1.875;text-overflow:ellipsis;white-space:nowrap;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";@media (min-width:300px) and (min-height:400px){font-size:1.125rem;line-height:2.75;text-shadow:0 0 1rem ", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}@media (min-width:780px){font-size:1.125rem;line-height:2.7778;text-shadow:0 0 1rem ", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}");
var WidgetSearchForm_styles_FormContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ia8t212"
}, "target", "e1ia8t212"))("width:505px;flex-grow:0;> *:not(:last-of-type){margin-bottom:0.625rem;}input{height:2.5rem;padding:1rem 0.75rem 0.25rem;font-size:0.75rem;line-height:1;& + svg{top:0.5rem;right:0.5rem;}}select{height:2.5rem;padding:1rem 0.75rem 0.25rem;font-size:0.75rem;line-height:1;& + svg{top:62.5%;right:0.5rem;}}#datepicker{padding-left:0.75rem;& + svg{right:0.5rem;}}label{top:1px;left:calc(0.75rem - 2px);color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";}@media (min-width:780px){max-width:300px;}");
var WidgetSearchForm_styles_StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "e1ia8t213"
}, "target", "e1ia8t213"))("padding-top:0.25rem;padding-bottom:0.25rem;");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/WidgetSearchForm.tsx

















var WidgetSearchForm = function WidgetSearchForm() {
    var ref = useSearchContext(), setDate = ref.setDate, setError = ref.setError, state = ref.state;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var submitHandler = useSubmitHandler();
    var ref1 = useSession(), trackClickTimestamp = ref1.trackClickTimestamp, removeClickTimestamp = ref1.removeClickTimestamp;
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var isSmallWidgetWidth = (0,useMedia/* default */.Z)("(max-width: 768px)", true);
    var isSmallWidgetHeight = (0,useMedia/* default */.Z)("(max-height: 320px) and (max-width: 600px)", true);
    var isVerticalLayout = isSmallWidgetWidth || isSmallWidgetHeight;
    var onError = (0,react.useCallback)(function(error) {
        setLoading(false);
        removeClickTimestamp();
        var ref = matchError(error), kind = ref.type, message = ref.message;
        if (isFormError(kind)) {
            setError({
                kind: kind,
                message: message
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleSearchSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        trackClickTimestamp();
                        return [
                            4,
                            submitHandler(state, "", function() {
                                return setLoading(false);
                            }, onError, true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                handleSearchSubmit();
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!state) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WidgetSearchForm_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WidgetSearchForm_styles_Title, {
                children: t("title")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledForm, {
                onSubmit: handleSubmit,
                id: "search",
                role: "search",
                target: "_blank",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WidgetSearchForm_styles_FormContainer, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchInput, {
                            id: "dep",
                            history: state.history,
                            direction: "departure",
                            onServiceNumbersSubmit: handleSearchSubmit,
                            label: t("departure.label"),
                            placeholder: t("departure.placeholder"),
                            icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((Search_default()), {})
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.DateRangePicker */.ws.DateRangePicker, {
                            from: new Date(state.depDate),
                            to: new Date(state.destDate),
                            error: state.dateError || "",
                            onDatesChange: function onDatesChange(dates) {
                                setDate("departure", dates.from);
                                setDate("destination", dates.to);
                            },
                            size: "small",
                            vertical: isVerticalLayout
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WidgetSearchForm_styles_StyledButton, {
                                type: "submit",
                                id: "find",
                                size: "small",
                                loading: loading,
                                fullWidth: true,
                                children: t("button.label")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var WidgetSearchFormWithContext = function WidgetSearchFormWithContext(_param) /*#__PURE__*/ {
    var formProps = _extends({}, _param);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchProvider, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WidgetSearchForm, (0,_object_spread/* default */.Z)({}, formProps))
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchFormLegacy/index.ts





;// CONCATENATED MODULE: ../../frontend/features/src/AffiliateSearchForm/AffiliateSearchForm.tsx



var AffiliateSearchForm = function AffiliateSearchForm(param) {
    var color = param.color;
    return /*#__PURE__*/ _jsx(StageContentContainer, {
        isAffiliate: true,
        children: /*#__PURE__*/ _jsx(StageCaption, {
            children: /*#__PURE__*/ _jsx(SearchForm, {
                isAffiliate: true,
                customColor: color
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/AffiliateSearchForm/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/ContentArticle.styles.ts



var ContentModuleSegment = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eo9003m0"
}, "target", "eo9003m0"))("margin-bottom:", function(param) {
    var bottomMargin = param.bottomMargin, theme = param.theme;
    return bottomMargin === "small" ? theme.spacing[30] : theme.spacing[120];
}, ";", src/* Theme.mq */.Q2.mq("sm"), "{margin-bottom:", function(param) {
    var bottomMargin = param.bottomMargin, theme = param.theme;
    return bottomMargin === "small" ? theme.spacing[40] : theme.spacing[140];
}, ";}&:last-child{margin-bottom:0;}");

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/destination/Destination.tsx





var Destination_Destination = function Destination(props) {
    var icons = props.icons, translations = props.translations, providers = props.providers, rules = props.rules;
    if (icons === null || icons === void 0 ? void 0 : icons.length) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TextContentBlockWithIcons */.ro, {
                content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    icons: icons
                }),
                rules: rules
            })
        });
    }
    if (providers === null || providers === void 0 ? void 0 : providers.length) {
        var ref = translations || {}, _providerPositionLabel = ref.providerPositionLabel, providerPositionLabel = _providerPositionLabel === void 0 ? "" : _providerPositionLabel;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TextContentBlockWithFigures */.BD, {
                content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    figures: providers.map(function(provider, index) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provider), {
                            position: index + 1
                        });
                    }),
                    positionLabel: providerPositionLabel
                }),
                rules: rules
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TextContentBlock */.vH, {
            content: props,
            rules: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rules), {
                isContainerMultiColumn: false,
                textStyle: {
                    style: (rules === null || rules === void 0 ? void 0 : rules.textStyle) || src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/destination/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/faq/Faq.tsx




var Faq = function Faq(props) {
    var content = props.content, translations = props.translations;
    var accordion = content.map(function(param) {
        var answer = param.answer, question = param.question, image = param.image;
        return {
            prompt: question,
            content: answer,
            image: image
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* AccordionContentBlock */.Xh, {
            content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                accordion: accordion
            }),
            rules: {
                badge: {
                    style: "orange"
                }
            },
            translations: translations
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/faq/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/SequentialLinkLists/SequentialLinkLists.tsx


var SequentialLinkLists = function SequentialLinkLists(param) {
    var lists = param.lists, translations = param.translations;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: lists.map(function(list) {
            var ref;
            if (list.links.length === 0) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* LinkListBlock */.ek, {
                content: list,
                translations: translations
            }, ((ref = list.heading) === null || ref === void 0 ? void 0 : ref.text) || list.links[0].label);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/SequentialLinkLists/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/SingleLinkList/SingleLinkList.tsx




var SingleLinkList = function SingleLinkList(param) {
    var badge = param.badge, heading = param.heading, list = param.list, translations = param.translations;
    if (list.links.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* LinkListBlock */.ek, {
            content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, list), {
                badge: badge,
                heading: heading
            }),
            translations: translations
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/SingleLinkList/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/tabs/Tabs.tsx






var Tabs = function Tabs(param) {
    var badge = param.badge, heading = param.heading, modules = param.modules, rules = param.rules, translations = param.translations;
    var tabGroup = "tabGroup-".concat((0,react.useId)());
    var ref = (0,react.useState)(modules.length && modules[0].name || ""), currentTab = ref[0], setCurrentTab = ref[1];
    if (modules.length === 0) {
        return null;
    }
    var textStyle = (rules || {}).textStyle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(entities_src/* PlainContentModuleContainer */.bc, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TabListContentBlock */.vG, {
                behavior: {
                    onTabSelected: setCurrentTab
                },
                content: {
                    badge: badge,
                    heading: heading,
                    modules: modules
                },
                rules: {
                    textStyle: textStyle
                }
            }),
            modules.map(function(subModule) {
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TabBodyContentBlock */.X2, {
                    content: {
                        currentTab: currentTab,
                        subModule: subModule,
                        tabGroup: tabGroup
                    },
                    rules: {
                        textStyle: textStyle
                    },
                    children: function children(module) {
                        switch(module.moduleType){
                            case "linkList":
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* LinkListBlock */.ek, {
                                    content: module
                                });
                            case "destination":
                            default:
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Destination_Destination, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                                    rules: rules,
                                    translations: translations === null || translations === void 0 ? void 0 : translations.destination
                                }));
                        }
                    }
                }, subModule.name);
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/tabs/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/TabbedLinkLists/TabbedLinkLists.tsx




var TabbedLinkLists = function TabbedLinkLists(param) {
    var lists = param.lists;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs, {
            moduleType: "tabs",
            modules: lists.map(function(list, index) {
                var ref;
                return {
                    module: (0,_object_spread/* default */.Z)({
                        moduleType: "linkList"
                    }, list),
                    name: ((ref = list.heading) === null || ref === void 0 ? void 0 : ref.text) || "",
                    position: index
                };
            })
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/TabbedLinkLists/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/LinkList.tsx




var LinkLists = function LinkLists(props) {
    var badge = props.badge, heading = props.heading, lists = props.lists, rules = props.rules, translations = props.translations;
    var renderSequentially = (rules || {}).renderSequentially;
    if (renderSequentially) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SequentialLinkLists, {
            lists: lists,
            translations: translations
        });
    }
    if (lists.length === 1) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SingleLinkList, {
            badge: badge,
            heading: heading,
            list: lists[0],
            translations: translations
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabbedLinkLists, {
        lists: lists
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/linkLists/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/stationsMap/StationsMap.tsx




var StationsMap = function StationsMap(_param) /*#__PURE__*/ {
    var content = _extends({}, _param);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TextContentBlock */.vH, {
            content: content,
            rules: {
                textStyle: {
                    style: src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary
                },
                isContainerMultiColumn: false
            }
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/stationsMap/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/standardContent/StandardContent.styles.ts


var TabContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1o0fjmy0"
}, "target", "e1o0fjmy0"))("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";grid-column:span 12 / span 12;");


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/standardContent/StandardContent.tsx






var StandardContent = function StandardContent(_param) {
    var rules = _param.rules, translations = _param.translations, content = (0,src_object_without_properties/* default */.Z)(_param, [
        "rules",
        "translations"
    ]);
    var ref = rules || {}, _allowCollapse = ref.allowCollapse, allowCollapse = _allowCollapse === void 0 ? true : _allowCollapse;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* PlainContentModuleContainer */.bc, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* CollapsableContentBlock */.IO, {
            content: content,
            translations: translations,
            rules: {
                allowCollapse: allowCollapse
            },
            children: function children(param) {
                var module = param.module;
                switch(module.moduleType){
                    case "tabs":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabContainer, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs, (0,_object_spread/* default */.Z)({}, module))
                        });
                    default:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* StandardContentRowBlock */.rI, {
                            content: module
                        });
                }
            }
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/standardContent/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/particle/ImagePosition.ts
var getSpacingDirectionFromImagePosition = function getSpacingDirectionFromImagePosition(imagePosition) {
    if (imagePosition === "top" || imagePosition === "bottom") {
        return imagePosition;
    }
    return undefined;
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/textImage/TextImage.tsx




var TextImage = function TextImage(props) {
    var badge = props.badge, image = props.image, _rules = props.rules, rules = _rules === void 0 ? {} : _rules;
    var style = rules.style || "default";
    var imagePosition = rules.imagePosition || "right";
    var backgroundStyle = (0,entities_src/* selectBackgroundStyle */.p9)(style);
    var badgeStyle = (0,entities_src/* selectBadgeStyle */.G2)(style);
    var isPlain = ![
        "green",
        "mint",
        "orange"
    ].includes(style);
    var layoutFlow = (0,entities_src/* selectLayoutFlow */.VR)(imagePosition);
    var spacingDirection = getSpacingDirectionFromImagePosition(imagePosition);
    var moduleContainerRules = {
        backgroundStyle: backgroundStyle,
        layoutFlow: layoutFlow,
        verticalSpacing: {
            isLarge: !!image,
            spacingDirection: spacingDirection
        }
    };
    var ContentModuleContainer = isPlain ? entities_src/* PlainContentModuleContainer */.bc : entities_src/* WaveContentModuleContainer */.w4;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentModuleContainer, {
        rules: moduleContainerRules,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* TextContentBlock */.vH, {
                content: props,
                rules: {
                    badge: {
                        shouldHide: imagePosition === "top",
                        style: badgeStyle
                    },
                    isContainerMultiColumn: !!image,
                    isSecondColumn: imagePosition === "left",
                    textStyle: {
                        style: isPlain ? src/* Ui.RichTextStyle.Primary */.Ui.J$.Primary : src/* Ui.RichTextStyle.Alternative */.Ui.J$.Alternative
                    },
                    verticalSpacing: {
                        isLargeAtXL: image && !isPlain,
                        isSmallAtXL: image && isPlain
                    }
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* ImageContentBlock */.m4, {
                content: props,
                rules: {
                    badge: {
                        shouldHide: imagePosition !== "top",
                        style: badgeStyle
                    },
                    imagePosition: imagePosition,
                    isFirstColumn: imagePosition === "left",
                    verticalSpacing: {
                        isLargeAtLG: badge && !isPlain,
                        isNoneAtXL: !isPlain
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/textImage/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/renderContentModule.tsx









var renderContentModule = function renderContentModule(module, translations) {
    switch(module.moduleType){
        case "faqs":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                translations: translations.faq
            }));
        case "linkListGroup":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkLists, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                translations: translations.linklists
            }));
        case "standardContent":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                translations: translations.standardContent
            }));
        case "stationsMap":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StationsMap, (0,_object_spread/* default */.Z)({}, module));
        case "tabs":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                translations: translations.tabs
            }));
        case "textImage":
        default:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextImage, (0,_object_spread/* default */.Z)({}, module));
    }
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/contentModule/index.ts








;// CONCATENATED MODULE: ../../frontend/features/src/Content/ContentArticle.tsx



var ContentArticle = function ContentArticle(param) {
    var modules = param.modules, translations = param.translations;
    if (!modules || modules.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: modules.map(function(module, index) {
            var key = "".concat(module.moduleType, "-").concat(index);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentModuleSegment, {
                bottomMargin: module.bottomMargin || "default",
                children: renderContentModule(module, translations)
            }, key);
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/Content/index.ts



// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Menu.js
var Menu = __webpack_require__(608);
var Menu_default = /*#__PURE__*/__webpack_require__.n(Menu);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js + 1 modules
var emotion_element_43c6fea0_browser_esm = __webpack_require__(7216);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/User.js
var User = __webpack_require__(6828);
var User_default = /*#__PURE__*/__webpack_require__.n(User);
;// CONCATENATED MODULE: ../../frontend/features/src/Header/Header.styles.ts





var Header_styles_Header = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", (0,src_define_property/* default */.Z)({
    target: "ewdhhe80"
}, "target", "ewdhhe80"))("height:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";position:relative;z-index:30;display:flex;align-items:center;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:", function(param) {
    var theme = param.theme;
    return theme.spacing[100];
}, ";z-index:auto;}");
var MenuIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Menu_default()), (0,src_define_property/* default */.Z)({
    target: "ewdhhe81"
}, "target", "ewdhhe81"))(entities_src/* HeaderIconStyles */.VZ, ";/* For accessibility reasons,the menu icon should be slightly bigger. */\n  width:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";height:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";");
var Separator = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("hr", (0,src_define_property/* default */.Z)({
    target: "ewdhhe82"
}, "target", "ewdhhe82"))("height:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";width:2px;flex:none;border:0;background-color:#5e6e6a;display:block;margin-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var UserIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((User_default()), (0,src_define_property/* default */.Z)({
    target: "ewdhhe83"
}, "target", "ewdhhe83"))(entities_src/* HeaderIconStyles */.VZ);
var IconButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ewdhhe84"
}, "target", "ewdhhe84"))("display:flex;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";");
var ActionArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ewdhhe85"
}, "target", "ewdhhe85"))("display:flex;flex-grow:1;margin-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";justify-content:flex-end;");
var DesktopActions = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ewdhhe86"
}, "target", "ewdhhe86"))("display:grid;grid-template-columns:1fr auto;align-items:center;width:100%;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var ActionButtons = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ewdhhe87"
}, "target", "ewdhhe87"))("align-items:center;display:flex;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/HiddenLinksPopover.styles.ts


var HiddenLinksPopover_styles_List = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e35e35j0"
}, "target", "e35e35j0"))("display:flex;flex-direction:column;row-gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/HiddenLinksPopover.tsx







var HiddenLinksPopover = function HiddenLinksPopover(param) {
    var children = param.children;
    var spacing = (0,emotion_element_43c6fea0_browser_esm.u)().spacing;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Popover */.Ui.J2, {
        button: {
            as: "div",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.IconButton */.Ui.hU, {
                    icon: (Menu_default()),
                    size: "medium"
                })
            }, "actionButton-hiddenLinks")
        },
        triggerAction: "click",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PopoverPanel */.Ui.Hi, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PanelContentWrapper */.Ui.Ut, {
                padding: spacing[50],
                width: "255px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenLinksPopover_styles_List, {
                    children: children
                })
            })
        })
    });
};


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Locked.js
var Locked = __webpack_require__(4715);
var Locked_default = /*#__PURE__*/__webpack_require__.n(Locked);
;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/LoginButton/LoginButton.styles.ts





var LoginButton_styles_List = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("ul", _define_property({
    target: "e2xgy7j0"
}, "target", "e2xgy7j0"))("padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";width:238px;*{font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";}")));
var MembershipPanelWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e2xgy7j1"
}, "target", "e2xgy7j1"))("width:403px;");
var NavigationItem = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("li", _define_property({
    target: "e2xgy7j2"
}, "target", "e2xgy7j2"))("padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, " 0;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";text-overflow:ellipsis;overflow-x:hidden;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}")));
var StyledLink = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(Ui.TextLink, _define_property({
    target: "e2xgy7j3"
}, "target", "e2xgy7j3"))(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}")));
var LockIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Locked_default()), (0,src_define_property/* default */.Z)({
    target: "e2xgy7j4"
}, "target", "e2xgy7j4"))("fill:currentcolor;width:1.5rem;height:1.5rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:none;}");
var LoginButton_styles_UserIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((User_default()), (0,src_define_property/* default */.Z)({
    target: "e2xgy7j5"
}, "target", "e2xgy7j5"))("display:none;fill:currentcolor;width:1.5rem;height:1.5rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");


// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Checked.js
var Checked = __webpack_require__(1691);
var Checked_default = /*#__PURE__*/__webpack_require__.n(Checked);
;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/LoginForm.styles.ts




var SwirlWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eqoxmth0"
}, "target", "eqoxmth0"))("display:none;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;position:absolute;top:30px;left:-170px;width:550px;height:113px;transform:rotate(-20deg);}");
var LoginForm_styles_StyledForm = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("form", (0,src_define_property/* default */.Z)({
    target: "eqoxmth1"
}, "target", "eqoxmth1"))("display:flex;flex-direction:column;padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var TitleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eqoxmth2"
}, "target", "eqoxmth2"))("button{position:absolute;top:1rem;right:1rem;margin:0;padding:0;border:0;appearance:none;background:none;cursor:pointer;}");
var LoginForm_styles_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "eqoxmth3"
}, "target", "eqoxmth3"))("margin:0 0 1rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:normal;font-size:1.25rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";text-align:left;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin:0 0 2rem;padding-top:140px;font-size:1.5rem;text-align:center;}");
var FormActionArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eqoxmth4"
}, "target", "eqoxmth4"))("display:flex;justify-content:center;padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var MaxWidthWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eqoxmth5"
}, "target", "eqoxmth5"))("max-width:455px;width:100%;");
var InputWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eqoxmth6"
}, "target", "eqoxmth6"))("margin-bottom:1rem;");
var PasswordLostWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "eqoxmth7"
}, "target", "eqoxmth7"))("margin:-0.75rem 1rem 1rem;font-size:0.875rem;text-align:right;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin:1rem 0 2rem;font-size:1rem;text-align:left;}");
var SubmitButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "eqoxmth8"
}, "target", "eqoxmth8"))(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin:0 auto;padding-left:3rem;padding-right:3rem;width:auto;}");
var Footer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eqoxmth9"
}, "target", "eqoxmth9"))("padding:1rem;text-align:center;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural20;
}, ";");
var CheckIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Checked_default()), (0,src_define_property/* default */.Z)({
    target: "eqoxmth10"
}, "target", "eqoxmth10"))("margin-left:0.5em;width:1rem;height:1rem;fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";vertical-align:middle;");


;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/swirl.png
/* harmony default export */ var swirl = ({"src":"/_next/static/media/swirl.e11baa02.png","height":408,"width":1992,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR4nGP85y6Sy/j1za3v2q6PGQSkNM+Ye//n/vMnqFtKaK/I33+CjP88xXMZv31R+sfNwvXRIff8e2k1zzP83J+WCHC3MTEyXAcA4W8cJF7ItlUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/LoginState.tsx

var LoginContext = /*#__PURE__*/ (0,react.createContext)(null);
var useLogin = function useLogin() {
    var context = (0,react.useContext)(LoginContext);
    if (context === null) {
        throw new Error("Ensure you have wrapped the login form in a LoginProvider");
    }
    return context;
};


;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/LoginError.tsx








var LoginError = function LoginError(param) {
    var _translations = param.translations, headline = _translations.headline, message = _translations.message, passwordLostHref = _translations.passwordLostHref, passwordLostLabel = _translations.passwordLostLabel, resendConfirmUser = _translations.resendConfirmUser;
    var ref = useLogin(), username = ref.username, type = ref.error;
    var ref1 = (0,react.useState)(false), isSuccessful = ref1[0], setIsSuccessful = ref1[1];
    var formatApiUrl = entities_src/* Runtime.useAccountConfig */.r_.useAccountConfig().formatApiUrl;
    var whitelabel = entities_src/* Runtime.useWhitelabel */.r_.useWhitelabel().whitelabel;
    if (!type) {
        return null;
    }
    if (type === entities_src/* account.LoginError.UnverifiedEmail */.JT.LoginError.UnverifiedEmail) {
        var handleClick = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                entities_src/* account.resendConfirmUser */.JT.resendConfirmUser(formatApiUrl(src/* http.API.accountResendConfirmUser */.dJ.API.accountResendConfirmUser), username !== null && username !== void 0 ? username : "", whitelabel)
                            ];
                        case 1:
                            res = _state.sent();
                            setIsSuccessful(res);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleClick() {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Ui.Message */.Ui.v0, {
            headline: headline,
            children: [
                message,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                    as: "button",
                    text: resendConfirmUser,
                    onClick: handleClick
                }),
                isSuccessful && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckIcon, {})
            ]
        });
    }
    if ([
        entities_src/* account.LoginError.ExpiredPassword */.JT.LoginError.ExpiredPassword,
        entities_src/* account.LoginError.WeakPassword */.JT.LoginError.WeakPassword, 
    ].includes(type)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Ui.Message */.Ui.v0, {
            headline: headline,
            severity: src/* Ui.MessageSeverity.ERROR */.Ui.CE.ERROR,
            role: src/* Ui.MessageRole.ALERT */.Ui.lB.ALERT,
            children: [
                message,
                " ",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                    href: passwordLostHref,
                    text: passwordLostLabel
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Message */.Ui.v0, {
        severity: src/* Ui.MessageSeverity.ERROR */.Ui.CE.ERROR,
        role: src/* Ui.MessageRole.ALERT */.Ui.lB.ALERT,
        children: message
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/Footer.tsx



var Footer_Footer = function Footer(param) {
    var _translations = param.translations, newUserHref = _translations.newUserHref, newUserText = _translations.newUserText, noAccountText = _translations.noAccountText, isLoggedIn = param.isLoggedIn;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            noAccountText,
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                href: newUserHref,
                text: newUserText,
                onClick: function onClick() {
                    return entities_src/* analytics.gtm.trackNewUser */.co.gtm.trackNewUser({
                        isLoggedIn: isLoggedIn
                    });
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/LoginForm.tsx












var LoginForm = function LoginForm(param) {
    var withinModal = param.withinModal, translations = param.translations;
    var actionPath = translations.actionPath, emailLabel = translations.emailLabel, loginTitle = translations.loginTitle, error = translations.error, passwordLabel = translations.passwordLabel, passwordLostHref = translations.passwordLostHref, passwordLostText = translations.passwordLostText, submitText = translations.submitText;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = useLogin(), setUsername = ref1.setUsername, setShowLogin = ref1.setShowLogin, setLoggedIn = ref1.setLoggedIn, setError = ref1.setError, securityToken = ref1.securityToken;
    var whitelabel = entities_src/* Runtime.useWhitelabel */.r_.useWhitelabel().whitelabel;
    var isLoggedIn = false;
    var ref2 = entities_src/* Runtime.useAccountConfig */.r_.useAccountConfig(), formatApiUrl = ref2.formatApiUrl, formatSessionUrl = ref2.formatSessionUrl;
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
            var emailAddress, password, ref, loggedIn, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        emailAddress = event.currentTarget.elements.namedItem("emailAddress").value;
                        password = event.currentTarget.elements.namedItem("password").value;
                        setUsername(emailAddress);
                        setLoading(true);
                        return [
                            4,
                            entities_src/* account.login */.JT.login(formatApiUrl(src/* http.API.accountLogin */.dJ.API.accountLogin), formatSessionUrl(src/* http.API.accountSession */.dJ.API.accountSession), emailAddress, password, whitelabel)
                        ];
                    case 1:
                        ref = _state.sent(), loggedIn = ref.loggedIn, errorMessage = ref.error;
                        if (loggedIn) {
                            setShowLogin(false);
                            setLoggedIn(true);
                        } else {
                            setError(errorMessage || null);
                            setLoggedIn(false);
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoginForm_styles_StyledForm, {
                method: "post",
                action: actionPath,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                        type: "hidden",
                        name: "securityToken",
                        value: securityToken
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SwirlWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            src: swirl,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginForm_styles_Title, {
                            children: loginTitle
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginError, {
                        translations: error
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormActionArea, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MaxWidthWrapper, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Input */.Ui.II, {
                                        id: "email",
                                        type: "email",
                                        name: "emailAddress",
                                        label: emailLabel,
                                        autoComplete: "section-login username",
                                        autoCorrect: "off",
                                        autoCapitalize: "off",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Input */.Ui.II, {
                                        id: "password",
                                        type: "password",
                                        name: "password",
                                        label: passwordLabel,
                                        autoComplete: "section-login current-password",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PasswordLostWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                                        href: passwordLostHref,
                                        text: passwordLostText,
                                        onClick: function onClick() {
                                            return entities_src/* analytics.gtm.trackPasswordForgotten */.co.gtm.trackPasswordForgotten({
                                                isLoggedIn: isLoggedIn
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitButton, {
                                    type: "submit",
                                    loading: loading,
                                    disabled: loading,
                                    onClick: entities_src/* analytics.gtm.trackLogin */.co.gtm.trackLogin,
                                    fullWidth: true,
                                    children: submitText
                                })
                            ]
                        })
                    })
                ]
            }),
            !withinModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Footer, {
                    translations: translations,
                    isLoggedIn: isLoggedIn
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/LoginModal.tsx





var LoginModal = function LoginModal(param) {
    var translations = param.translations;
    var ref = useLogin(), showLogin = ref.showLogin, setShowLogin = ref.setShowLogin;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Overlay */.Ui.aV, {
        footerContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Footer, {
            isLoggedIn: false,
            translations: translations
        }),
        open: showLogin,
        onClose: function onClose() {
            return setShowLogin(false);
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginForm, {
            translations: translations,
            withinModal: true
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/Provider.tsx







var LoginProvider = function LoginProvider(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isLoggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react.useState)(false), showLogin = ref1[0], setShowLogin = ref1[1];
    var ref2 = (0,react.useState)(false), showMobileLogin = ref2[0], setShowMobileLogin = ref2[1];
    var ref3 = (0,react.useState)(""), username = ref3[0], setUsername = ref3[1];
    var ref4 = (0,react.useState)(null), error = ref4[0], setError = ref4[1];
    var sessionData = entities_src/* account.useSessionData */.JT.useSessionData();
    var formatSessionUrl = entities_src/* Runtime.useAccountConfig */.r_.useAccountConfig().formatSessionUrl;
    var url = formatSessionUrl(src/* http.API.accountSession */.dJ.API.accountSession);
    var getAccountSession = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        entities_src/* account.getAccountSession */.JT.getAccountSession(url)
                    ];
                case 1:
                    res = _state.sent();
                    setLoggedIn(Boolean(res.access_token));
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        url
    ]);
    (0,react.useEffect)(function() {
        getAccountSession();
    }, [
        getAccountSession
    ]);
    var handleShowLogin = (0,react.useCallback)(function(show) {
        setShowLogin(show);
        if (show) {
            entities_src/* analytics.gtm.trackShowLogin */.co.gtm.trackShowLogin({
                isLoggedIn: isLoggedIn
            });
        }
    }, [
        isLoggedIn
    ]);
    var handleShowMobileLogin = (0,react.useCallback)(function(show) {
        setShowMobileLogin(show);
        if (show) {
            entities_src/* analytics.gtm.trackShowLogin */.co.gtm.trackShowLogin({
                isLoggedIn: isLoggedIn
            });
        }
    }, [
        isLoggedIn
    ]);
    var value = (0,react.useMemo)(function() {
        return {
            isLoggedIn: isLoggedIn,
            setLoggedIn: setLoggedIn,
            error: error,
            setError: setError,
            showLogin: showLogin,
            setShowLogin: handleShowLogin,
            showMobileLogin: showMobileLogin,
            setShowMobileLogin: handleShowMobileLogin,
            securityToken: sessionData.securityTokenValue || "",
            username: username,
            setUsername: setUsername
        };
    }, [
        error,
        handleShowLogin,
        handleShowMobileLogin,
        isLoggedIn,
        sessionData.securityTokenValue,
        showLogin,
        showMobileLogin,
        username, 
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginContext.Provider, {
        value: value,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/LoginForm/index.ts





;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/LoggedInActions.styles.ts



var LoggedInActions_styles_List = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e69h6860"
}, "target", "e69h6860"))("padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";width:100%;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{width:238px;}*{font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";}");
var LoggedInActions_styles_NavigationItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e69h6861"
}, "target", "e69h6861"))("padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, " 0;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";text-overflow:ellipsis;overflow-x:hidden;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");
var LoggedInActions_styles_StyledLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.TextLink */.Ui.hh, (0,src_define_property/* default */.Z)({
    target: "e69h6862"
}, "target", "e69h6862"))(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;}");


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/LoggedInActions.tsx






var LoggedInActions = function LoggedInActions(param) {
    var translations = param.translations;
    var isLoggedIn = useLogin().isLoggedIn;
    var linkTranslations = translations.accountLinks;
    var accountLinks = [
        {
            text: linkTranslations.myBookings.text,
            href: linkTranslations.myBookings.href,
            onClick: function onClick() {
                entities_src/* analytics.gtm.trackMyBookings */.co.gtm.trackMyBookings({
                    isLoggedIn: isLoggedIn
                });
            }
        },
        {
            text: linkTranslations.myData.text,
            href: linkTranslations.myData.href,
            onClick: function onClick() {
                entities_src/* analytics.gtm.trackMyData */.co.gtm.trackMyData({
                    isLoggedIn: isLoggedIn
                });
            }
        },
        {
            text: linkTranslations.myPayment.text,
            href: linkTranslations.myPayment.href,
            onClick: function onClick() {
                entities_src/* analytics.gtm.trackMyPayment */.co.gtm.trackMyPayment({
                    isLoggedIn: isLoggedIn
                });
            }
        },
        {
            text: linkTranslations.logout.text,
            href: linkTranslations.logout.href,
            onClick: function onClick() {
                entities_src/* analytics.gtm.trackLogout */.co.gtm.trackLogout();
            }
        }, 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoggedInActions_styles_List, {
        role: "menu",
        "aria-label": translations.account,
        children: accountLinks.map(function(link, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                children: [
                    index === accountLinks.length - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoggedInActions_styles_NavigationItem, {
                        role: "presentation",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            passHref: true,
                            href: link.href,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoggedInActions_styles_StyledLink, {
                                text: link.text,
                                href: link.href,
                                role: "menuitem",
                                onClick: link.onClick
                            })
                        })
                    })
                ]
            }, "nav-".concat(link.href));
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/LoginButton/LoginButton.tsx







var LoginButton = function LoginButton(param) {
    var onClick = param.onClick, translations = param.translations;
    var ref = useLogin(), isLoggedIn = ref.isLoggedIn, setShowLogin = ref.setShowLogin;
    var membership = translations.membership;
    var handleLoginClick = function handleLoginClick() {
        if (typeof onClick === "function") {
            onClick();
        }
        setShowLogin(true);
    };
    var handleSignUpClick = function handleSignUpClick() {
        window.location.assign(membership.signUpLink);
    };
    if (!isLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Popover */.Ui.J2, {
            button: {
                as: "div",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LockIcon, {}),
                    variant: "secondary",
                    size: "small",
                    children: translations.label
                })
            },
            triggerAction: "click",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PopoverPanel */.Ui.Hi, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PanelContentWrapper */.Ui.Ut, {
                    width: "403px",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MembershipPanelWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* MembershipPopover */.sm, {
                            translations: membership,
                            handleLoginClick: handleLoginClick,
                            handleSignUpClick: handleSignUpClick
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Popover */.Ui.J2, {
        button: {
            as: "div",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginButton_styles_UserIcon, {}),
                variant: "secondary",
                size: "small",
                children: translations.account
            })
        },
        triggerAction: "click",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PopoverPanel */.Ui.Hi, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoggedInActions, {
                translations: translations
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/LoginButton/index.ts


// EXTERNAL MODULE: ../../node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(6883);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLockBodyScroll.js


function getClosestBody(el) {
    if (!el) {
        return null;
    }
    else if (el.tagName === 'BODY') {
        return el;
    }
    else if (el.tagName === 'IFRAME') {
        var document_1 = el.contentDocument;
        return document_1 ? document_1.body : null;
    }
    else if (!el.offsetParent) {
        return null;
    }
    return getClosestBody(el.offsetParent);
}
function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
}
var isIosDevice = util/* isBrowser */.jU &&
    window.navigator &&
    window.navigator.platform &&
    /iP(ad|hone|od)/.test(window.navigator.platform);
var bodies = new Map();
var doc = typeof document === 'object' ? document : undefined;
var documentListenerAdded = false;
/* harmony default export */ var useLockBodyScroll = (!doc
    ? function useLockBodyMock(_locked, _elementRef) {
        if (_locked === void 0) { _locked = true; }
    }
    : function useLockBody(locked, elementRef) {
        if (locked === void 0) { locked = true; }
        var bodyRef = (0,react.useRef)(doc.body);
        elementRef = elementRef || bodyRef;
        var lock = function (body) {
            var bodyInfo = bodies.get(body);
            if (!bodyInfo) {
                bodies.set(body, { counter: 1, initialOverflow: body.style.overflow });
                if (isIosDevice) {
                    if (!documentListenerAdded) {
                        (0,util.on)(document, 'touchmove', preventDefault, { passive: false });
                        documentListenerAdded = true;
                    }
                }
                else {
                    body.style.overflow = 'hidden';
                }
            }
            else {
                bodies.set(body, {
                    counter: bodyInfo.counter + 1,
                    initialOverflow: bodyInfo.initialOverflow,
                });
            }
        };
        var unlock = function (body) {
            var bodyInfo = bodies.get(body);
            if (bodyInfo) {
                if (bodyInfo.counter === 1) {
                    bodies.delete(body);
                    if (isIosDevice) {
                        body.ontouchmove = null;
                        if (documentListenerAdded) {
                            (0,util/* off */.S1)(document, 'touchmove', preventDefault);
                            documentListenerAdded = false;
                        }
                    }
                    else {
                        body.style.overflow = bodyInfo.initialOverflow;
                    }
                }
                else {
                    bodies.set(body, {
                        counter: bodyInfo.counter - 1,
                        initialOverflow: bodyInfo.initialOverflow,
                    });
                }
            }
        };
        (0,react.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            if (locked) {
                lock(body);
            }
            else {
                unlock(body);
            }
        }, [locked, elementRef.current]);
        // clean up, on un-mount
        (0,react.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            return function () {
                unlock(body);
            };
        }, []);
    });

;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/MobileMenu.styles.ts


function MobileMenu_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    visibility: ",
        ";\n    transition: visibility 0.3s;\n  "
    ]);
    MobileMenu_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: ",
        ";\n    transition: max-height 0.15s ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: ",
        ";\n    transition: opacity 0.3s ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var IconButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.IconButton */.Ui.hU, (0,src_define_property/* default */.Z)({
    target: "e15c5ooz0"
}, "target", "e15c5ooz0"))("fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";display:block;flex:none;");
var StyledDialog = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz1"
}, "target", "e15c5ooz1"))("position:fixed;inset:0;top:", function(param) {
    var topPosition = param.topPosition;
    return topPosition;
}, "px;z-index:20;", function(param) {
    var show = param.show;
    return (0,emotion_react_browser_esm/* css */.iv)(MobileMenu_styles_templateObject(), show ? "visible" : "hidden");
});
var StyledDialogPanel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz2"
}, "target", "e15c5ooz2"))("display:flex;align-items:start;overflow:hidden;background-color:white;", function(param) {
    var show = param.show;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), show ? "100%" : 0, show ? "ease-in" : "ease-out");
});
var BackgroundOverlay = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz3"
}, "target", "e15c5ooz3"))("background-color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";position:relative;height:100%;inset:0;", function(param) {
    var show = param.show;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), show ? 0.7 : 0, show ? "ease-in" : "ease-out");
});
var PanelContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz4"
}, "target", "e15c5ooz4"))("position:absolute;top:0;width:100%;z-index:20;max-height:100%;overflow-y:auto;");
var GridContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz5"
}, "target", "e15c5ooz5"))("display:grid;");
var FlexContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz6"
}, "target", "e15c5ooz6"))("display:flex;flex-direction:column;");
var StyledContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e15c5ooz7"
}, "target", "e15c5ooz7"))("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";flex:1;");
var CloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.IconButton */.Ui.hU, (0,src_define_property/* default */.Z)({
    target: "e15c5ooz8"
}, "target", "e15c5ooz8"))("position:absolute;top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/MobileMenu.tsx




var DEFAULT_HEADER_HEIGHT = 32;
var MobileMenu = function MobileMenu(param) {
    var id = param.id, closeMenuLabel = param.closeMenuLabel, icon = param.icon, iconLabel = param.iconLabel, onClose = param.onClose, open = param.open, toggleOpen = param.toggleOpen, topPosition = param.topPosition, renderContent = param.renderContent;
    useLockBodyScroll(open);
    var handleClose = function handleClose() {
        toggleOpen();
        if (typeof onClose === "function") {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton, {
                id: id,
                "aria-label": iconLabel,
                icon: icon,
                selected: open,
                size: "medium",
                onClick: toggleOpen
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledDialog, {
                show: open,
                topPosition: topPosition || DEFAULT_HEADER_HEIGHT,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundOverlay, {
                        show: open,
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelContainer, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridContainer, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexContainer, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDialogPanel, {
                                    show: open,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContent, {
                                        "data-testid": "menu-content",
                                        children: [
                                            renderContent(toggleOpen),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
                                                id: "".concat(id, "-close-button"),
                                                "aria-label": closeMenuLabel,
                                                icon: (Close_default()),
                                                onClick: handleClose
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/Navigation.styles.ts


function Navigation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > :nth-of-type(-n + ",
        ") {\n      visibility: hidden;\n    }\n  "
    ]);
    Navigation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Nav = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", (0,src_define_property/* default */.Z)({
    target: "eou6uu90"
}, "target", "eou6uu90"))("display:", function(param) {
    var $mode = param.$mode;
    return $mode === "desktop" ? "none" : "flex";
}, ";justify-content:center;overflow:", function(param) {
    var $mode = param.$mode;
    return $mode === "desktop" ? "hidden" : "initial";
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:", function(param) {
    var $mode = param.$mode;
    return $mode === "mobile" ? "none" : "block";
}, ";}");
var LinkList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "eou6uu91"
}, "target", "eou6uu91"))("max-width:400px;margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";margin-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";display:flex;flex-direction:column;flex:1;justify-content:flex-end;", function(param) {
    var hideChildren = param.hideChildren;
    return (0,emotion_react_browser_esm/* css */.iv)(Navigation_styles_templateObject(), hideChildren);
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-bottom:0;margin-left:0;max-width:none;flex-direction:row;padding-top:0;}");
var LinkListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "eou6uu92"
}, "target", "eou6uu92"))("display:flex;gap:0.5rem;align-items:center;position:relative;margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";white-space:nowrap;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:", function(param) {
    var container = param.container;
    return container === "navbar" && "50px";
}, ";margin-bottom:", function(param) {
    var container = param.container;
    return container === "navbar" ? "25px" : 0;
}, ";align-items:", function(param) {
    var container = param.container;
    return container === "navbar" && "end";
}, ";}");
var LinkText = function LinkText(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", theme.color.primary, ";", theme.mq("lg"), "{color:", theme.color.natural30, ";}&:hover{color:", theme.color.primary100, ";}&:active{color:", (0,polished_esm/* darken */._j)(0.1, theme.color.primary100 || "#000"), ";}");
};
var MaskedLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.MaskedLink */.Ui.Fz, (0,src_define_property/* default */.Z)({
    target: "eou6uu93"
}, "target", "eou6uu93"))(LinkText, ";");
var Anchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "eou6uu94"
}, "target", "eou6uu94"))(LinkText, "  text-decoration:none;");
var StyledText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* InteractiveText */.G9, (0,src_define_property/* default */.Z)({
    target: "eou6uu95"
}, "target", "eou6uu95"))(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding-left:", function(param) {
    var theme = param.theme, withPadding = param.withPadding;
    return withPadding ? theme.spacing[50] : 0;
}, ";margin-top:0;list-style-type:none;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{padding-left:", function(param) {
    var theme = param.theme, withPadding = param.withPadding;
    return withPadding ? theme.spacing[60] : 0;
}, ";}");
var StyledBadge = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.Badge */.Ui.Ct, (0,src_define_property/* default */.Z)({
    target: "eou6uu96"
}, "target", "eou6uu96"))("font-size:0.75rem;/* @TODO:Move this to Ui.Badge once the legacy header has been removed. */\n\n  ", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{position:", function(param) {
    var container = param.container;
    return container === "navbar" && "absolute";
}, ";top:", function(param) {
    var container = param.container;
    return container === "navbar" && "0.5rem";
}, ";right:", function(param) {
    var container = param.container;
    return container === "navbar" && "-0.75rem";
}, ";}");


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/Navigation.tsx









var makeLinkMapper = function makeLinkMapper(container, onClick) {
    return function(param) {
        var href = param.href, target = param.target, text = param.text, title = param.title, masked = param.masked, highlightText = param.highlightText;
        var linkProps = {
            href: href,
            target: target,
            title: title
        };
        var handleClick = function handleClick() {
            entities_src/* analytics.gtm.trackNavigationClicked */.co.gtm.trackNavigationClicked(text);
            if (typeof onClick === "function") {
                onClick();
            }
        };
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkListItem, {
            container: container,
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, {
                    withPadding: container === "navbar",
                    children: masked ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaskedLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                        body: text
                    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: href,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Anchor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                            rel: linkProps.target === "_blank" ? "noopener noreferrer" : undefined,
                            children: text
                        }))
                    })
                }),
                highlightText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBadge, {
                    text: highlightText,
                    type: "orange",
                    size: "small",
                    container: container
                })
            ]
        }, href);
    };
};
var Navigation = function Navigation(param) {
    var getHiddenElements = param.getHiddenElements, links = param.links, mode = param.mode, onAction = param.onAction;
    var getLinks = (0,react.useMemo)(function() {
        return src/* Links.makeLinkTypeMapper */.yX.makeLinkTypeMapper(links);
    }, [
        links
    ]);
    var headerLinks = (0,react.useMemo)(function() {
        return getLinks("main");
    }, [
        getLinks
    ]);
    var linksRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(headerLinks.length), visibleLinks = ref[0], setVisibleLinks = ref[1];
    var ref1 = (0,react.useState)([]), linkWidths = ref1[0], setLinkWidths = ref1[1];
    (0,react.useEffect)(function() {
        // Width of links component on first render
        var container = linksRef.current;
        if (!container) return undefined;
        // Create a ResizeObserver instance
        var resizeObserver = new ResizeObserver(function() {
            var linkElements = Array.from(container.children);
            setLinkWidths(linkElements.map(function(element) {
                return element.getBoundingClientRect().width;
            }));
        });
        // Attach the ResizeObserver to the container element
        resizeObserver.observe(container);
        // Cleanup function to disconnect the ResizeObserver when the component unmounts
        return function() {
            resizeObserver.disconnect();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!getHiddenElements || !linkWidths.length) {
            return;
        }
        var container = linksRef.current;
        if (!container) return;
        var totalWidth = 0;
        var visible = 0;
        _toConsumableArray(linkWidths).reverse().forEach(function(width) {
            totalWidth += width;
            if (totalWidth <= container.clientWidth) {
                visible += 1;
            }
        });
        setVisibleLinks(visible);
        var mapLinks = makeLinkMapper("popover", onAction);
        getHiddenElements(headerLinks.slice(0, headerLinks.length - visible).map(mapLinks));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        linkWidths,
        headerLinks
    ]);
    var mapLinks = makeLinkMapper("navbar", onAction);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav, {
        $mode: mode,
        "aria-label": "Main navigation",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkList, {
            ref: linksRef,
            hideChildren: headerLinks.length - visibleLinks,
            children: headerLinks.map(mapLinks)
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Header/components/index.ts






;// CONCATENATED MODULE: ../../frontend/features/src/Header/hooks/useMobileMenus.ts

var initialState = {
    openMenu: null
};
var menuReducer = function menuReducer(state, action) {
    switch(action.type){
        case "TOGGLE_MENU":
            return {
                openMenu: state.openMenu === action.index ? null : action.index
            };
        default:
            return state;
    }
};
/**
 * Convenience hook for controlling mobile menus when multiple menus are needed
 * (only one should be visible at once)
 */ var useMobileMenus = function useMobileMenus() {
    var ref = (0,react.useReducer)(menuReducer, initialState), openMenu = ref[0].openMenu, dispatch = ref[1];
    var setOpenMenu = function setOpenMenu(index) {
        return dispatch({
            type: "TOGGLE_MENU",
            index: index
        });
    };
    return {
        openMenu: openMenu,
        setOpenMenu: setOpenMenu
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/Header/hooks/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Header/Header.tsx












var Header_Header = function Header(_param) {
    var children = _param.children, desktopActions = _param.desktopActions, desktopLinks = _param.desktopLinks, mobileMenus = _param.mobileMenus, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "desktopActions",
        "desktopLinks",
        "mobileMenus"
    ]);
    var ref = useMobileMenus(), openMenu = ref.openMenu, setOpenMenu = ref.setOpenMenu;
    var actionAreaRef = react.useRef(null);
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), menuTop = ref1[0], setMenuTop = ref1[1];
    var positionMenu = function positionMenu() {
        if (actionAreaRef.current) {
            var bottom = actionAreaRef.current.getBoundingClientRect().bottom;
            setMenuTop(bottom);
        }
    };
    (0,react.useEffect)(function() {
        positionMenu();
        window.addEventListener("resize", positionMenu);
        return function() {
            window.removeEventListener("resize", positionMenu);
        };
    }, [
        actionAreaRef,
        mobileMenus
    ]);
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), hiddenLinks = ref2[0], setHiddenLinks = ref2[1];
    var getHiddenLinks = function getHiddenLinks(links) {
        setHiddenLinks(links);
    };
    var wideViewPort = (0,useMedia/* default */.Z)("(min-width:".concat(src/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), true);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header_styles_Header, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                ref: actionAreaRef,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* ResponsiveLogo */.li, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionArea, {
                        children: wideViewPort ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopActions, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation, {
                                    mode: "desktop",
                                    links: desktopLinks,
                                    getHiddenElements: getHiddenLinks
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActionButtons, {
                                    children: [
                                        desktopActions.map(function(param) {
                                            var component = param.component, key = param.key, hide = param.hide;
                                            return hide ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonContainer, {
                                                children: component
                                            }, "actionButton-".concat(key));
                                        }),
                                        Boolean(hiddenLinks.length) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenLinksPopover, {
                                            children: hiddenLinks
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionButtons, {
                            id: "header-action-buttons",
                            children: mobileMenus.map(function(param, index) {
                                var id = param.id, closeLabel = param.closeLabel, content = param.content, hide = param.hide, icon = param.icon, iconLabel = param.iconLabel, onClose = param.onClose;
                                var handleMenuClick = function handleMenuClick() {
                                    setOpenMenu(index);
                                };
                                return hide ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenu, {
                                    id: id,
                                    closeMenuLabel: closeLabel,
                                    renderContent: content,
                                    icon: icon,
                                    iconLabel: iconLabel,
                                    toggleOpen: handleMenuClick,
                                    open: openMenu === index,
                                    onClose: onClose,
                                    topPosition: menuTop
                                }, iconLabel);
                            })
                        })
                    })
                ]
            }))
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Header/index.ts




var src_Header_Header = Header_Header;
src_Header_Header.Navigation = Navigation;
src_Header_Header.Separator = Separator;
src_Header_Header.InfolinePopoverButton = entities_src/* InfolinePopoverButton */.eX;
src_Header_Header.LoginButton = LoginButton;
src_Header_Header.LoggedInActions = LoggedInActions;


;// CONCATENATED MODULE: ../../frontend/features/src/MarketPicker/MarketPicker.styles.ts


var MarketPicker_styles_Container = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e2bv6xj0"
}, "target", "e2bv6xj0"))("padding:", function(param) {
    var theme = param.theme, hasHeader = param.hasHeader;
    return hasHeader ? theme.spacing[50] : "";
}, ";")));
var MarketPicker_styles_Element = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e2bv6xj1"
}, "target", "e2bv6xj1"))("margin:", function(param) {
    var theme = param.theme;
    return "".concat(theme.spacing[50], " 0");
}, ";")));
var MarketPicker_styles_Header = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e2bv6xj2"
}, "target", "e2bv6xj2"))("display:flex;justify-content:space-between;/* On large screens header is displayed in the overlay */\n  ", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:none;}")));


;// CONCATENATED MODULE: ../../frontend/features/src/MarketPicker/MarketPicker.tsx





var MarketPicker = function MarketPicker(_param) {
    var redirectInfo = _param.selectedMarket.redirectInfo, markets = _param.markets, selectMarket = _param.selectMarket, onClose = _param.onClose, onSubmit = _param.onSubmit, selectedMarket = _object_without_properties(_param.selectedMarket, [
        "redirectInfo"
    ]), translatedContent = _object_without_properties(_param, [
        "selectedMarket",
        "markets",
        "selectMarket",
        "onClose",
        "onSubmit"
    ]);
    var handleSubmit = function handleSubmit() {
        onSubmit(selectedMarket);
    };
    return /*#__PURE__*/ _jsxs(Container, {
        hasHeader: !!translatedContent.header,
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                children: [
                    /*#__PURE__*/ _jsx(Ui.Typography, {
                        as: "h3",
                        children: translatedContent.header
                    }),
                    onClose && /*#__PURE__*/ _jsx(Ui.IconButton, {
                        icon: Close,
                        title: translatedContent.close,
                        onClick: onClose,
                        size: "large"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Element, {
                children: /*#__PURE__*/ _jsx(Ui.Dropdown, {
                    label: translatedContent.countryLabel,
                    options: markets.map(function(param) {
                        var country = param.country;
                        return {
                            label: country.name,
                            value: country.code
                        };
                    }),
                    value: selectedMarket.country.code,
                    onChange: function onChange(e) {
                        return selectMarket(markets[e.target.selectedIndex]);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Element, {
                children: /*#__PURE__*/ _jsx(Ui.Dropdown, {
                    label: translatedContent.languageLabel,
                    options: markets.map(function(param) {
                        var language = param.language;
                        return {
                            label: language.name,
                            value: language.code
                        };
                    }),
                    value: selectedMarket.language.code,
                    disabled: true
                })
            }),
            redirectInfo && /*#__PURE__*/ _jsx(Element, {
                children: /*#__PURE__*/ _jsxs(Ui.Message, {
                    headline: redirectInfo.header,
                    children: [
                        redirectInfo.text,
                        /*#__PURE__*/ _jsx("br", {}),
                        redirectInfo.link && /*#__PURE__*/ _jsx(Ui.TextLink, {
                            href: redirectInfo.link.url,
                            text: redirectInfo.link.text
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "primary",
                fullWidth: true,
                onClick: handleSubmit,
                disabled: selectedMarket.redirectOnly,
                children: translatedContent.saveButtonText
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/MarketPicker/mock.ts

var MARKETS = [
    {
        country: {
            name: "Deutschland",
            code: "DE"
        },
        language: {
            name: "Deutsch",
            code: "de"
        },
        redirectInfo: {
            text: "Wir k\xf6nnen Sie auf unseren deutschen Marktf\xfchrer billiger-mietwagen.de weiterleiten, damit Sie Ihr bestes Angebot finden.",
            header: "Weiterleiten",
            link: {
                text: "Zu billiger-mietwagen.de",
                url: "https://www.billiger-mietwagen.de"
            }
        }
    },
    {
        country: {
            name: "Frankreich",
            code: "FR"
        },
        language: {
            name: "Franz\xf6sisch",
            code: "fr"
        },
        redirectInfo: {
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            header: "Weiterleiten",
            link: {
                text: "Zu carigami.fr",
                url: "https://www.carigami.fr"
            }
        }
    },
    {
        country: {
            name: "Spanien",
            code: "ES"
        },
        language: {
            name: "Spanisch",
            code: "es"
        }
    },
    {
        country: {
            name: "Niederlande",
            code: "NL"
        },
        language: {
            name: "Niederl\xe4ndisch",
            code: "nl"
        }
    },
    {
        country: {
            name: "Italien",
            code: "IT"
        },
        language: {
            name: "Italienisch",
            code: "it"
        }
    }, 
];
var useMockedMarketPicker = function useMockedMarketPicker() {
    // Use mock data in storybook / testing
    var ref = useState(MARKETS[0]), selectedMarket = ref[0], setMarket = ref[1];
    return {
        selectedMarket: selectedMarket,
        selectMarket: setMarket,
        markets: MARKETS
    };
};


;// CONCATENATED MODULE: ../../frontend/features/src/MarketPicker/index.ts



// EXTERNAL MODULE: ../../node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(6182);
;// CONCATENATED MODULE: ../../frontend/features/src/InfoBanner/InfoBanner.styles.ts



// ToDo: use theme variables to ensure a unified design
var InfoBanner_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1orei6p0"
}, "target", "e1orei6p0"))("position:", function(param) {
    var isIntersecting = param.isIntersecting;
    return isIntersecting ? "fixed" : "relative";
}, ";top:0;left:0;width:100%;z-index:100;margin:0;display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:0.5rem 1rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.0625rem;font-weight:600;font-style:normal;line-height:1.5rem;&::after{content:'';display:none;width:100%;height:0.5em;}a:link{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-weight:700;}a:visited{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}&.important{background-image:", function(param) {
    var theme = param.theme;
    return src/* Theme.getLinearGradient */.Q2.getLinearGradient(theme.gradient.orange, "to left");
}, ";}&.less-important{background-color:#c8c8c8;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";a:link{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}a:visited{color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}.close{fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}}&.regular-black{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";}&.regular-green{background-image:", function(param) {
    var theme = param.theme;
    return "linear-gradient(to right,  ".concat(theme.color.primaryGradient1, ", ").concat(theme.color.primary, ")");
}, ";}.close{position:absolute;right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";background-color:transparent;width:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";border:none;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";cursor:pointer;}", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{justify-content:center;}");
var InfoBanner_styles_CloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.IconButton */.Ui.hU, (0,src_define_property/* default */.Z)({
    target: "e1orei6p1"
}, "target", "e1orei6p1"))("position:absolute;right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/InfoBanner/InfoBanner.tsx







var InfoBanner = function InfoBanner(param) {
    var closable = param.closable, sticky = param.sticky, theme = param.theme, content = param.content;
    var ref = (0,react.useState)(true), isInfoBannerVisible = ref[0], setInfobannerVisible = ref[1];
    var intersectionRef = (0,react.useRef)(null);
    var intersection = (0,useIntersection/* default */.Z)(intersectionRef, {
        root: null,
        rootMargin: "0px",
        threshold: 1
    });
    (0,react.useEffect)(function() {
        var banner = document.getElementById("infobanner");
        var links = banner === null || banner === void 0 ? void 0 : banner.getElementsByTagName("a");
        if (links) {
            var linkList = [].slice.call(links);
            linkList.forEach(function(link) {
                var anchor = link;
                var label = anchor.pathname.replace(/^\/|\/$/g, "");
                anchor.onclick = function() {
                    return entities_src/* analytics.gtm.trackInfoBannerLinkClicked */.co.gtm.trackInfoBannerLinkClicked(label);
                };
            });
        }
    }, []);
    var onClose = function onClose() {
        setInfobannerVisible(false);
        entities_src/* analytics.gtm.trackInfoBannerCloseClicked */.co.gtm.trackInfoBannerCloseClicked();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: intersectionRef,
        children: isInfoBannerVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoBanner_styles_Wrapper, {
            isIntersecting: sticky && Boolean(intersection && intersection.intersectionRatio < 1),
            className: theme,
            id: "infobanner",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.RichText */.Ui.Ho, {
                    content: content
                }),
                closable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoBanner_styles_CloseButton, {
                    icon: (Close_default()),
                    title: "close" // @TODO: Add translation
                    ,
                    onClick: onClose
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/InfoBanner/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/MobileAppPromotionLegacy/AppInstallBanner/AppInstallBanner.styles.ts


var ButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eldw9yo0"
}, "target", "eldw9yo0"))("display:flex;justify-content:space-around;a{width:43%;z-index:1;svg{width:100%;}}");


;// CONCATENATED MODULE: ../../frontend/features/src/MobileAppPromotionLegacy/AppInstallBanner/AppInstallBanner.tsx







var AppInstallBanner = function AppInstallBanner(param) {
    var isShowing = param.isShowing, onClose = param.onClose;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.mobileAppPromotionLegacy");
    var promoTitle = t("globalApptrafficPromoTitle");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.ForegroundLayer */.ws.ForegroundLayer, {
        id: "app-install-banner",
        isShowing: isShowing,
        onClose: onClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* Banner */.jL, {
            title: promoTitle,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PlayStoreLink */.Ui.L_, {
                        id: "app-install-banner-play-store-anchor",
                        href: t("playStoreLink"),
                        onClick: entities_src/* analytics.gtm.trackIosAppLinkClicked */.co.gtm.trackIosAppLinkClicked
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.AppStoreLink */.Ui.pG, {
                        id: "app-install-banner-app-store-anchor",
                        href: t("appStoreLink"),
                        onClick: entities_src/* analytics.gtm.trackIosAppLinkClicked */.co.gtm.trackIosAppLinkClicked
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/date-fns/_lib/addLeadingZeros.mjs
var addLeadingZeros = __webpack_require__(8935);
;// CONCATENATED MODULE: ../../node_modules/date-fns/formatISO.mjs



/**
 * The {@link formatISO} function options.
 */

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */
function formatISO(date, options) {
  const _date = (0,toDate/* toDate */.Q)(date);

  if (isNaN(_date.getTime())) {
    throw new RangeError("Invalid time value");
  }

  const format = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";

  let result = "";
  let tzOffset = "";

  const dateDelimiter = format === "extended" ? "-" : "";
  const timeDelimiter = format === "extended" ? ":" : "";

  // Representation is either 'date' or 'complete'
  if (representation !== "time") {
    const day = (0,addLeadingZeros/* addLeadingZeros */.r)(_date.getDate(), 2);
    const month = (0,addLeadingZeros/* addLeadingZeros */.r)(_date.getMonth() + 1, 2);
    const year = (0,addLeadingZeros/* addLeadingZeros */.r)(_date.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }

  // Representation is either 'time' or 'complete'
  if (representation !== "date") {
    // Add the timezone.
    const offset = _date.getTimezoneOffset();

    if (offset !== 0) {
      const absoluteOffset = Math.abs(offset);
      const hourOffset = (0,addLeadingZeros/* addLeadingZeros */.r)(Math.trunc(absoluteOffset / 60), 2);
      const minuteOffset = (0,addLeadingZeros/* addLeadingZeros */.r)(absoluteOffset % 60, 2);
      // If less than 0, the sign is +, because it is ahead of time.
      const sign = offset < 0 ? "+" : "-";

      tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }

    const hour = (0,addLeadingZeros/* addLeadingZeros */.r)(_date.getHours(), 2);
    const minute = (0,addLeadingZeros/* addLeadingZeros */.r)(_date.getMinutes(), 2);
    const second = (0,addLeadingZeros/* addLeadingZeros */.r)(_date.getSeconds(), 2);

    // If there's also date, separate it with time with 'T'
    const separator = result === "" ? "" : "T";

    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
    const time = [hour, minute, second].join(timeDelimiter);

    // HHmmss or HH:mm:ss.
    result = `${result}${separator}${time}${tzOffset}`;
  }

  return result;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_formatISO = ((/* unused pure expression or super */ null && (formatISO)));

// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(1502);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(5790);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(8106);
;// CONCATENATED MODULE: ../../frontend/features/src/MobileAppPromotionLegacy/AppInstallBanner/useShowAppBanner.ts








var SUPPORTED_LANGUAGES = [
    "de",
    "fr"
];
var STORAGE_NAME = "appPromotionBannerShownOn";
var PARAMETER_NAME = "disableAppPromotionBanner";
var useShowAppBanner = function useShowAppBanner(language) {
    var ref = _legacy/* UiLegacy.useForegroundLayer */.ws.useForegroundLayer(), isShowing = ref.isShowing, toggle = ref.toggle;
    var consent = entities_src/* analytics.useConsent */.co.useConsent();
    var ref1 = (0,react.useState)(false), isAlreadyShown = ref1[0], setIsAlreadyShown = ref1[1];
    var isLanguageAllowed = SUPPORTED_LANGUAGES.includes(language);
    var isMobileTouchDevice = _legacy/* Theme.useIsMobileTouchDevice */.Q2.useIsMobileTouchDevice();
    var preConditionsMet = isLanguageAllowed && isMobileTouchDevice;
    if (preConditionsMet) {
        var appPromotionBannerShownOn = null;
        if (consent === entities_src/* analytics.CookieConsent.Enabled */.co.CookieConsent.Enabled) {
            appPromotionBannerShownOn = window.localStorage.getItem(STORAGE_NAME);
        }
        var startOfNextDay = appPromotionBannerShownOn ? (0,addDays/* addDays */.E)((0,startOfDay/* startOfDay */.b)((0,parseISO/* parseISO */.D)(appPromotionBannerShownOn)), 1) : (0,startOfDay/* startOfDay */.b)(new Date());
        var shouldShowBanner = (0,isBefore/* isBefore */.R)(startOfNextDay, Date.now());
        var shouldHideBanner = Boolean(new URLSearchParams(window.location.search).get(PARAMETER_NAME));
        if ((consent === entities_src/* analytics.CookieConsent.Enabled */.co.CookieConsent.Enabled && shouldShowBanner || // OR cookie consent denied and banner was not already rendered
        consent === entities_src/* analytics.CookieConsent.Disabled */.co.CookieConsent.Disabled && !isAlreadyShown) && !shouldHideBanner && !isShowing) {
            toggle();
            setIsAlreadyShown(true);
        }
    }
    var onClose = (0,react.useCallback)(function() {
        toggle();
        setIsAlreadyShown(true);
        if (consent === entities_src/* analytics.CookieConsent.Enabled */.co.CookieConsent.Enabled) {
            window.localStorage.setItem(STORAGE_NAME, formatISO(Date.now()));
        }
    }, [
        consent,
        toggle
    ]);
    return {
        isShowing: isShowing,
        onClose: onClose
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/MobileAppPromotionLegacy/AppInstallBanner/index.ts



;// CONCATENATED MODULE: ../../frontend/features/src/MobileAppPromotionLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OfferBox/OfferBox.styles.ts



var PricePrefixTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* SecondaryText */.MQ, (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo0"
}, "target", "e1a2s2xo0"))("white-space:nowrap;padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";text-align:right;font-variant-numeric:tabular-nums;");
var SubtitleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Heading3 */.aC, (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo1"
}, "target", "e1a2s2xo1"))("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";}");
var OfferBox_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo2"
}, "target", "e1a2s2xo2"))("height:100%;border:", function(param) {
    var theme = param.theme;
    return "".concat(theme.color.natural20, " 1px solid");
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";box-shadow:", function(param) {
    var theme = param.theme;
    return theme.boxShadow.md;
}, ";cursor:", function(param) {
    var hasAction = param.hasAction;
    return hasAction ? "pointer" : "initial";
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");
var OfferBox_styles_ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo3"
}, "target", "e1a2s2xo3"))("border-bottom:", function(param) {
    var theme = param.theme;
    return "".concat(theme.color.natural20, " 1px solid");
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";display:flex;position:relative;height:130px;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:150px;margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";}");
var ProviderOffersList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo4"
}, "target", "e1a2s2xo4"))("display:flex;width:100%;flex-direction:column;");
var ProviderOffer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo5"
}, "target", "e1a2s2xo5"))("display:flex;justify-content:space-between;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";");
var ProviderName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* BodyText */.Ac, (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo6"
}, "target", "e1a2s2xo6"))("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";");
var SearchButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "e1a2s2xo7"
}, "target", "e1a2s2xo7"))("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OfferBox/OfferBox.tsx






var OfferBox = function OfferBox(param) {
    var category = param.category, image = param.image, offers = param.offers, _translations = param.translations, pricePrefix = _translations.pricePrefix, priceSuffix = _translations.priceSuffix, searchButtonText = _translations.searchButtonText, onClick = param.onClick;
    var language = entities_src/* Runtime.useLocale */.r_.useLocale().language;
    var baseImageUrl = entities_src/* Runtime.useHost */.r_.useHost().baseImageUrl;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref[0], setLoading = ref[1];
    var handleClick = function handleClick() {
        if (onClick && !loading) {
            setLoading(true);
            onClick();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OfferBox_styles_Container, {
        onClick: handleClick,
        hasAction: !!onClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferBox_styles_ImageWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Image */.Ui.Ee, {
                    src: "".concat(baseImageUrl).concat(image),
                    alt: "",
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubtitleWrapper, {
                as: "h3",
                children: category
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProviderOffersList, {
                children: offers.map(function(param) {
                    var supplier = param.supplier, price = param.price, currency = param.currency;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProviderOffer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProviderName, {
                                inline: true,
                                children: supplier
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PricePrefixTextWrapper, {
                                inline: true,
                                textColor: "grey",
                                children: [
                                    pricePrefix,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Subtitle */.QE, {
                                        as: "span",
                                        textColor: "orange",
                                        children: src/* String.formatPrice */.Ld.formatPrice(price, currency, language, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    priceSuffix
                                ]
                            })
                        ]
                    }, supplier);
                })
            }),
            onClick && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchButton, {
                variant: "primary",
                onClick: handleClick,
                fullWidth: true,
                children: searchButtonText
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OfferBox/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersList/OffersList.styles.ts



var Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", (0,src_define_property/* default */.Z)({
    target: "ew8k6qo0"
}, "target", "ew8k6qo0"))("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[90];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[100];
}, ";}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[110];
}, ";}");
var Offers = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "ew8k6qo1"
}, "target", "ew8k6qo1"))("display:grid;scroll-snap-type:x mandatory;grid-template-columns:repeat(3,minmax(282px,396px));gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";overflow-x:auto;padding:", function(param) {
    var hasTitle = param.hasTitle, theme = param.theme;
    return "".concat(hasTitle ? 0 : theme.spacing[60], " 2rem ").concat(theme.spacing[60], " 2rem");
}, ";margin-left:-2rem;margin-right:-2rem;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{margin-left:-4rem;margin-right:-4rem;padding-left:4rem;padding-right:4rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-left:0;margin-right:0;padding-left:0;padding-right:0;overflow-x:visible;}");
var Offer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "ew8k6qo2"
}, "target", "ew8k6qo2"))("scroll-snap-align:center;");
var DisclaimerText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* SecondaryText */.MQ, (0,src_define_property/* default */.Z)({
    target: "ew8k6qo3"
}, "target", "ew8k6qo3"))("text-align:center;");
var OverlayLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "ew8k6qo4"
}, "target", "ew8k6qo4"))("display:inline-block;margin:0;padding:0;border:0;color:inherit;background-color:transparent;text-decoration:underline;cursor:pointer;&:hover,&:focus{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";}");


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersList/OffersList.tsx





var Background = function Background(param) {
    var children = param.children, waveColor = param.waveColor;
    return waveColor ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Wave */.Ui.iC, {
        type: "fixed5",
        fullWidth: true,
        backgroundStyle: waveColor,
        children: children
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: children
    });
};
var OffersList = function OffersList(param) {
    var badge = param.badge, _badgeStyle = param.badgeStyle, badgeStyle = _badgeStyle === void 0 ? "light" : _badgeStyle, children = param.children, disclaimer = param.disclaimer, _disclaimerOverlayCTA = param.disclaimerOverlayCTA, disclaimerOverlayCTA = _disclaimerOverlayCTA === void 0 ? "" : _disclaimerOverlayCTA, offerDetails = param.offerDetails, offerDetailsTitle = param.offerDetailsTitle, title = param.title, _titleColor = param.titleColor, titleColor = _titleColor === void 0 ? "default" : _titleColor, waveColor = param.waveColor;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), showDialog = ref[0], setShowDialog = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            offerDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Overlay */.Ui.aV, {
                open: showDialog,
                onClose: function onClose() {
                    return setShowDialog(false);
                },
                title: offerDetailsTitle,
                width: "wide",
                children: offerDetails
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Background, {
                waveColor: waveColor,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
                    children: [
                        badge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Badge */.Ui.Ct, {
                            text: badge,
                            type: badgeStyle
                        }),
                        title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Heading2 */.XJ, {
                            textColor: titleColor,
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Offers, {
                            hasTitle: !!title,
                            children: react.Children.map(children, function(child) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Offer, {
                                    children: child
                                });
                            })
                        }),
                        disclaimer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DisclaimerText, {
                            textColor: "grey",
                            children: [
                                disclaimer,
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverlayLink, {
                                    onClick: function onClick() {
                                        return setShowDialog(true);
                                    },
                                    type: "button",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SecondaryText */.MQ, {
                                        textColor: "grey",
                                        children: disclaimerOverlayCTA
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersList/index.ts


// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInCalendarDays.mjs
var differenceInCalendarDays = __webpack_require__(9219);
;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersModule/OfferDetails.styles.ts



var Category = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7ripzs0"
}, "target", "e7ripzs0"))("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";");
var Details = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7ripzs1"
}, "target", "e7ripzs1"))("gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var Pricing = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e7ripzs2"
}, "target", "e7ripzs2"))("display:flex;flex-direction:row;justify-content:space-between;");
var Dates = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* SecondaryText */.MQ, (0,src_define_property/* default */.Z)({
    target: "e7ripzs3"
}, "target", "e7ripzs3"))("display:flex;flex-direction:row;justify-content:space-between;");


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersModule/OfferDetails.tsx








var OfferDetails = function OfferDetails(param) {
    var content = param.content, translations = param.translations;
    var locale = entities_src/* Runtime.useLocale */.r_.useLocale();
    var dateLong = src/* String.dateFormats */.Ld.dateFormats[locale.language].dateLong;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: Object.entries(content).map(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), category = _param[0], data = _param[1];
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Category, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.Typography */.Ui.ZT, {
                        as: "h2",
                        children: translations.carTypes[category]
                    }),
                    data.offers.map(function(offer) {
                        var destinationDate = new Date(offer.destinationDate);
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Details, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Pricing, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BodyText */.Ac, {
                                            children: offer.supplier
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* BodyText */.Ac, {
                                            children: [
                                                translations.pricePrefix,
                                                offer.price,
                                                "€ ",
                                                translations.priceSuffix
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dates, {
                                    textColor: "grey",
                                    children: [
                                        (0,differenceInCalendarDays/* differenceInCalendarDays */.w)((0,parseISO/* parseISO */.D)(offer.destinationDate), (0,parseISO/* parseISO */.D)(offer.departureDate)),
                                        translations.durationFrom,
                                        (0,format/* format */.WU)(destinationDate, dateLong),
                                        "; ",
                                        offer.city
                                    ]
                                })
                            ]
                        }, "".concat(offer.category, "-").concat(offer.supplier));
                    })
                ]
            }, category);
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersModule/OffersModule.tsx






var OffersModule = function OffersModule(param) {
    var content = param.content, onClick = param.onClick, translations = param.translations;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OffersList, {
        badge: translations.badgeText,
        disclaimer: translations.disclaimer,
        disclaimerOverlayCTA: translations.disclaimerOverlayCTA,
        title: translations.headline,
        titleColor: "white",
        waveColor: "orange",
        offerDetails: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferDetails, {
            content: content,
            translations: translations
        }),
        offerDetailsTitle: translations.offerDetailsTitle,
        children: Object.entries(content).map(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), category = _param[0], offersData = _param[1];
            var handleClick = onClick ? function handleClick() {
                if (onClick) {
                    onClick(offersData.searchQuery);
                    entities_src/* analytics.gtm.trackSearchButtonOfferBoxClicked */.co.gtm.trackSearchButtonOfferBoxClicked();
                }
            } : undefined;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferBox, {
                category: translations.carTypes[category],
                image: offersData.offers[0].image,
                onClick: handleClick,
                offers: offersData.offers.map(function(offer) {
                    return {
                        currency: "EUR",
                        price: offer.price,
                        supplier: offer.supplier
                    };
                }),
                translations: {
                    pricePrefix: translations.pricePrefix,
                    priceSuffix: translations.priceSuffix,
                    searchButtonText: translations.searchButtonText
                }
            }, category);
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/OffersModule/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Offers/index.ts




;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/LocationSuggest/LocationSuggest.styles.ts








var IconAirport = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Airport_default()), (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm0"
}, "target", "e1i5dgqm0"))("height:1.5rem;width:1.5rem;fill:currentcolor;");
var IconCity = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((CityStation_default()), (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm1"
}, "target", "e1i5dgqm1"))("height:1.5rem;width:1.5rem;fill:currentcolor;");
var IconRail = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((TrainStation_default()), (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm2"
}, "target", "e1i5dgqm2"))("height:1.5rem;width:1.5rem;fill:currentcolor;");
var DisplayExpressionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm3"
}, "target", "e1i5dgqm3"))("width:1.5rem;grid-row:span 2 / span 2;margin-right:1rem;display:flex;flex-shrink:0;align-items:center;");
var ListWrapperBaseStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;top:3.75rem;left:0;z-index:50;max-height:25rem;width:100%;overflow-y:auto;border-radius:0.5rem;border-width:0.125rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);");
var ResultsListWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm4"
}, "target", "e1i5dgqm4"))(ListWrapperBaseStyle, "  border-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var ResultsItemBaseStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0.75rem 1.5rem;display:flex;border-bottom-width:0.0625rem;font-size:1.063rem;font-weight:100;line-height:1.412em;", src/* Theme.mq */.Q2.mq("lg"), "{font-size:1.125rem;line-height:1.333em;}");
var ResultItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm5"
}, "target", "e1i5dgqm5"))(ResultsItemBaseStyle, ";border-bottom-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";width:100%;cursor:pointer;text-align:left;outline-width:0;background-color:", function(param) {
    var selected = param.selected, theme = param.theme;
    return selected && (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";&:hover{background-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";}");
var NoResultsItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm6"
}, "target", "e1i5dgqm6"))(ListWrapperBaseStyle, "  border-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var NoResultsItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1i5dgqm7"
}, "target", "e1i5dgqm7"))(ResultsItemBaseStyle, ";border-bottom-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/LocationSuggest/LocationSuggest.tsx
/* eslint-disable no-underscore-dangle */ 




var LocationSuggest_LocationSuggest = function LocationSuggest(param) {
    var results = param.results, connectedInputContainer = param.connectedInputContainer, onItemClick = param.onItemClick, onLastElementBlur = param.onLastElementBlur, noResultsText = param.noResultsText, loading = param.loading;
    var getNoResultsItem = function getNoResultsItem() {
        return loading ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoResultsItemWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoResultsItem, {
                children: noResultsText
            })
        });
    };
    var listRef = (0,react.useRef)(null);
    var isMobileTouchDevice = src/* Theme.useIsMobileTouchDevice */.Q2.useIsMobileTouchDevice();
    var handleEnter = function handleEnter(item) {
        onItemClick(item);
    };
    var ref = (0,entities_src/* useKeyNavigation */.Fp)(results || [], listRef, handleEnter), focusedItem = ref.focusedItem, onMouseEnter = ref.onMouseEnter, onMouseLeave = ref.onMouseLeave;
    (0,react.useEffect)(function() {
        if (isMobileTouchDevice && (connectedInputContainer === null || connectedInputContainer === void 0 ? void 0 : connectedInputContainer.current)) {
            connectedInputContainer.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isMobileTouchDevice,
        connectedInputContainer
    ]);
    var getDisplayIconAndDescription = function getDisplayIconAndDescription(suggestion, suggest) {
        var icon = null;
        var html = "";
        switch(suggestion.type){
            case "city":
            case "citywithoutrail":
                icon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCity, {});
                break;
            case "multiairports":
            case "multiairport_single":
            case "airport":
                icon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAirport, {});
                break;
            case "multirail_single":
            case "multirail":
            case "rail_only":
            case "rail":
                icon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconRail, {});
                break;
            case "normal":
            case "all":
            default:
                break;
        }
        if (!suggest) {
            icon = null;
        }
        html = suggestion.title;
        return {
            icon: icon,
            html: html
        };
    };
    var getDisplayExpression = function getDisplayExpression(suggestion) {
        var suggest = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var displayExpression = getDisplayIconAndDescription(suggestion, suggest);
        if (typeof displayExpression.html === "string" && suggest) {
            displayExpression.html = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                dangerouslySetInnerHTML: {
                    __html: displayExpression.html
                }
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisplayExpressionWrapper, {
                    children: displayExpression.icon
                }),
                displayExpression.html
            ]
        });
    };
    return results && results.length ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResultsListWrapper, {
        ref: listRef,
        children: results.map(function(suggestion, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResultItem, {
                    type: "button",
                    tabIndex: 0,
                    onBlur: onLastElementBlur,
                    onMouseDown: function onMouseDown() {
                        return onItemClick(suggestion);
                    },
                    onMouseEnter: function onMouseEnter1() {
                        return onMouseEnter(index);
                    },
                    onMouseLeave: onMouseLeave,
                    selected: index === focusedItem,
                    children: getDisplayExpression(suggestion)
                })
            }, suggestion.cityName + index);
        })
    }) : getNoResultsItem();
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/LocationSuggest/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/StationMarker.js
var StationMarker = __webpack_require__(667);
var StationMarker_default = /*#__PURE__*/__webpack_require__.n(StationMarker);
;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchHistory/DeleteButtonContent.tsx


var DeleteButtonInteractiveText = function DeleteButtonInteractiveText(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InteractiveText */.G9, {
        className: className,
        size: "small",
        inline: true,
        textColor: "current",
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchHistory/SearchHistory.styles.ts





var SearchHistoryHeadline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* TertiaryText */.Q1, (0,src_define_property/* default */.Z)({
    target: "enlutcz0"
}, "target", "enlutcz0"))("padding-left:1.5rem;padding-right:1.5rem;");
var SearchHistoryListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* BodyBoldText */.wy, (0,src_define_property/* default */.Z)({
    target: "enlutcz1"
}, "target", "enlutcz1"))("display:block;");
var SearchHistoryDate = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* SecondaryText */.MQ, (0,src_define_property/* default */.Z)({
    target: "enlutcz2"
}, "target", "enlutcz2"))("display:block;");
var DeleteButtonContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(DeleteButtonInteractiveText, (0,src_define_property/* default */.Z)({
    target: "enlutcz3"
}, "target", "enlutcz3"))("margin-left:1.5rem;margin-right:1.5rem;display:inline-block;text-underline-offset:0.125rem;&:hover{text-decoration-line:underline;}");
var SearchHistoryWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "enlutcz4"
}, "target", "enlutcz4"))("display:", function(param) {
    var hidden = param.hidden;
    return hidden && "none";
}, ";border-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight));
}, ";padding-top:1.5rem;padding-bottom:1.5rem;position:absolute;top:3.75rem;left:0;z-index:50;box-sizing:border-box;max-height:25rem;width:100%;overflow-y:auto;border-radius:0.5rem;border-width:0.125rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchHistory/SearchHistory.tsx










var SearchHistory_SEARCH_HISTORY_SESSION_STORAGE_KEY = "SearchHistoryKey8934087340";
var SearchHistory_SEARCH_HISTORY_LIMIT = 6;
var SearchHistory_getSearchHistory = function getSearchHistory() {
    var data = src/* Session.SessionStorageManager.getData */.z_.h.getData(SearchHistory_SEARCH_HISTORY_SESSION_STORAGE_KEY);
    if (data) {
        return data;
    }
    return {
        items: []
    };
};
var ref, ref1, ref2, ref3, ref4, ref5;
var SearchHistory_mapFormToSearchItem = function mapFormToSearchItem(formBody) {
    var ref6, ref7, ref8, ref9, ref10, ref11;
    return {
        depAirportCode: (ref1 = (ref = (ref6 = formBody.depLocation) === null || ref6 === void 0 ? void 0 : ref6.iataCode) !== null && ref !== void 0 ? ref : (ref7 = formBody.depLocation) === null || ref7 === void 0 ? void 0 : ref7.cityCode) !== null && ref1 !== void 0 ? ref1 : "",
        destAirportCode: (ref3 = (ref2 = (ref8 = formBody.destLocation) === null || ref8 === void 0 ? void 0 : ref8.iataCode) !== null && ref2 !== void 0 ? ref2 : (ref9 = formBody.destLocation) === null || ref9 === void 0 ? void 0 : ref9.cityCode) !== null && ref3 !== void 0 ? ref3 : "",
        destName: (ref4 = (ref10 = formBody.destLocation) === null || ref10 === void 0 ? void 0 : ref10.name) !== null && ref4 !== void 0 ? ref4 : "",
        depName: (ref5 = (ref11 = formBody.depLocation) === null || ref11 === void 0 ? void 0 : ref11.name) !== null && ref5 !== void 0 ? ref5 : "",
        depDate: formBody.depDate.split("T")[0],
        depTime: formBody.depDate.split("T")[1],
        destDate: formBody.destDate.split("T")[0],
        destTime: formBody.destDate.split("T")[1],
        depWeekDay: "",
        destWeekDay: "",
        imageUrl: ""
    };
};
var SearchHistory_addItemToSearchHistory = function addItemToSearchHistory(item) {
    var history = SearchHistory_getSearchHistory();
    if (!history.items.find(function(storedItem) {
        return isEqual(storedItem, item);
    })) {
        history.items.unshift(item);
        if (history.items.length > SearchHistory_SEARCH_HISTORY_LIMIT) {
            history.items.pop();
        }
        Session.SessionStorageManager.setData(SearchHistory_SEARCH_HISTORY_SESSION_STORAGE_KEY, history);
    }
};
var SearchHistory_clearSearchHistory = function clearSearchHistory() {
    src/* Session.SessionStorageManager.removeData */.z_.h.removeData(SearchHistory_SEARCH_HISTORY_SESSION_STORAGE_KEY);
};
var SearchHistory_SearchHistory = function SearchHistory(_param) {
    var clearSearchHistoryCallback = _param.clearSearchHistoryCallback, deleteLabel = _param.deleteLabel, hidden = _param.hidden, onLastElementBlur = _param.onLastElementBlur, handleKeyDown = _param.handleKeyDown, handleItemClick = _param.handleItemClick, headline = _param.headline, history = _param.history, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "clearSearchHistoryCallback",
        "deleteLabel",
        "hidden",
        "onLastElementBlur",
        "handleKeyDown",
        "handleItemClick",
        "headline",
        "history"
    ]);
    var ref;
    var language = entities_src/* Runtime.useLocale */.r_.useLocale().language;
    var localDateFormats = src/* String.dateFormats */.Ld.dateFormats[language];
    var filteredItems = (ref = history.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item.language === language || item.language === undefined;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchHistoryWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        hidden: hidden || (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) === 0,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHistoryHeadline, {
                textColor: "grey",
                children: headline
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                className: "mb-50 pt-20",
                children: filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function(item, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        className: "border-b-color8 py-30 px-50 hover:bg-color8 cursor-pointer border-b-[1px]",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                            type: "button",
                            onClick: function onClick() {
                                return handleItemClick(item);
                            },
                            onKeyDown: function onKeyDown(event) {
                                handleKeyDown(event, function() {
                                    return handleItemClick(item);
                                });
                            },
                            className: "searchHistory w-full text-left",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchHistoryListItem, {
                                    inline: true,
                                    children: [
                                        item.depName,
                                        " ",
                                        item.destName ? " - ".concat(item.destName) : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchHistoryDate, {
                                    inline: true,
                                    textColor: "grey",
                                    children: [
                                        (0,format/* format */.WU)(new Date(item.depDate), localDateFormats.dateLong, {
                                            locale: de.de
                                        }),
                                        " ",
                                        "-",
                                        " ",
                                        (0,format/* format */.WU)(new Date(item.destDate), localDateFormats.dateLong, {
                                            locale: de.de
                                        })
                                    ]
                                })
                            ]
                        })
                    }, item.depName + index);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                type: "button",
                onMouseDown: clearSearchHistoryCallback,
                onKeyDown: function onKeyDown(event) {
                    return handleKeyDown(event, clearSearchHistoryCallback);
                },
                onBlur: onLastElementBlur,
                className: "text-color1 hover:text-color1-800 focus-visible:outline-color3 active:text-color1-900 rounded-sm focus-visible:outline-dashed focus-visible:outline-2 focus-visible:outline-offset-4",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteButtonContent, {
                    children: deleteLabel
                })
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchHistory/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchInput/SearchInput.styles.ts



var StyledInput = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.Input */.Ui.II, (0,src_define_property/* default */.Z)({
    target: "e1jrd9ib0"
}, "target", "e1jrd9ib0"))("input{height:3.5rem;font-weight:600;& + svg{top:1rem;}}");


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchInput/SearchInput.tsx







var defaultProps = {
    showHistory: false
};
var SearchInput_SearchInput = function SearchInput(param) {
    var deleteHistoryLabel = param.deleteHistoryLabel, error = param.error, fieldName = param.fieldName, historyCallback = param.historyCallback, historyHeadline = param.historyHeadline, label = param.label, noResultsText = param.noResultsText, showHistory = param.showHistory, suggestionCallback = param.suggestionCallback, value = param.value;
    var ref;
    var ref1 = (0,react.useState)(false), showSearchHistory = ref1[0], setShowSearchHistory = ref1[1];
    var ref2 = (0,react.useState)(false), showLocationSuggest = ref2[0], setShowLocationSuggest = ref2[1];
    var ref3 = (0,react.useState)({
        items: []
    }), searchHistory = ref3[0], setSearchHistory = ref3[1];
    (0,react.useEffect)(function() {
        setSearchHistory(SearchHistory_getSearchHistory());
    }, []);
    var ref4 = (0,react.useState)(""), searchTerm = ref4[0], setSearchTerm = ref4[1];
    var fieldRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(error), errorMessage = ref5[0], setErrorMessage = ref5[1];
    var ref6 = entities_src/* Runtime.useLocale */.r_.useLocale(), language = ref6.language, market = ref6.market;
    var consumerApiSettings = entities_src/* Runtime.useConsumerApi */.r_.useConsumerApi().consumerApiSettings;
    var ref7 = (0,entities_src/* useSearchSuggestions */.fb)(language, market, consumerApiSettings), clearResults = ref7.clearResults, fetchSuggestions = ref7.fetchSuggestions, loading = ref7.loading, results = ref7.results;
    (0,react.useEffect)(function() {
        setErrorMessage(error);
    }, [
        error
    ]);
    var handleChange = function handleChange(inputValue) {
        setSearchTerm(inputValue);
        if (inputValue === "") {
            clearResults();
            setShowSearchHistory(true);
            setShowLocationSuggest(false);
        } else {
            setShowLocationSuggest(true);
            setShowSearchHistory(false);
            fetchSuggestions(inputValue);
        }
        suggestionCallback({});
    };
    var handleSuggestionValue = function handleSuggestionValue(suggestion) {
        if (suggestion) {
            var name = "".concat(suggestion.cityName, " ").concat(suggestion.typeDisplay ? suggestion.typeDisplay : "");
            setSearchTerm(name);
            setShowLocationSuggest(false);
            clearResults();
            suggestionCallback((0,entities_src/* getLocation */.k$)(suggestion));
        } else {
            handleChange(value);
        }
    };
    var handleKeyDown = function handleKeyDown(event, handleEnterKey) {
        switch(event.key){
            case "Enter":
                if (handleEnterKey) {
                    event.preventDefault();
                    handleEnterKey();
                    setShowSearchHistory(false);
                    setShowLocationSuggest(false);
                }
                break;
            case "Escape":
                event.preventDefault();
                setShowSearchHistory(false);
                setShowLocationSuggest(false);
                break;
            default:
                break;
        }
    };
    var handleFocus = function handleFocus(event) {
        if (event.target.value === "") {
            setShowSearchHistory(true);
        } else {
            fetchSuggestions(event.target.value);
            setShowLocationSuggest(true);
        }
    };
    var handleBlur = function handleBlur(event) {
        var ref, ref1, ref2;
        if (!((ref = event.relatedTarget) === null || ref === void 0 ? void 0 : ref.className.includes("searchHistory"))) {
            setShowSearchHistory(false);
        }
        if (!(((ref1 = event.relatedTarget) === null || ref1 === void 0 ? void 0 : ref1.className.includes("inputCloseIcon")) || ((ref2 = event.relatedTarget) === null || ref2 === void 0 ? void 0 : ref2.className.includes("locationSuggest")))) {
            setShowLocationSuggest(false);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledInput, {
                ref: fieldRef,
                id: fieldName,
                type: "text",
                label: label,
                value: value || searchTerm,
                error: errorMessage,
                autoComplete: "off",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((StationMarker_default()), {}),
                iconPosition: "left",
                appearActive: true,
                hiddenLabel: true,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyDown: handleKeyDown,
                onChange: function onChange(event) {
                    handleChange(event.target.value);
                }
            }),
            showHistory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchHistory_SearchHistory, {
                hidden: ((ref = searchHistory.items) === null || ref === void 0 ? void 0 : ref.length) === 0 || !showSearchHistory,
                history: searchHistory,
                handleItemClick: function handleItemClick(item) {
                    if (historyCallback) {
                        historyCallback(item);
                    }
                    setShowSearchHistory(false);
                },
                handleKeyDown: handleKeyDown,
                clearSearchHistoryCallback: function clearSearchHistoryCallback() {
                    SearchHistory_clearSearchHistory();
                    setSearchHistory(SearchHistory_getSearchHistory());
                    setShowSearchHistory(false);
                },
                onLastElementBlur: function onLastElementBlur() {
                    setShowSearchHistory(false);
                },
                headline: historyHeadline,
                deleteLabel: deleteHistoryLabel
            }),
            showLocationSuggest && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationSuggest_LocationSuggest, {
                connectedInputContainer: fieldRef,
                onItemClick: handleSuggestionValue,
                onLastElementBlur: function onLastElementBlur() {
                    setShowLocationSuggest(false);
                },
                results: results,
                noResultsText: noResultsText,
                loading: loading
            })
        ]
    });
};
SearchInput_SearchInput.defaultProps = defaultProps;


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/SearchInput/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/SearchForm/index.ts




;// CONCATENATED MODULE: ../../frontend/features/src/StructuredDataWidget/useStructuredData.ts
var useStructuredData = function useStructuredData(products, page) {
    if (!page || !("content" in page) || !("article" in page.content)) return {
        faqs: undefined
    };
    var faqs = page.content.article.segments.filter(function(segment) {
        return segment.moduleType === "faqs";
    }).flatMap(function(segment) {
        return segment.content;
    });
    var ref;
    return {
        faqs: faqs,
        name: (ref = products === null || products === void 0 ? void 0 : products.name) !== null && ref !== void 0 ? ref : ""
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/StructuredDataWidget/StructuredDataWidget.tsx



var StructuredDataWidget = function StructuredDataWidget(param) {
    var page = param.page, products = param.products;
    var ref = useStructuredData(products, page), faqs = ref.faqs, name = ref.name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* AutoRentalData */.KM, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* ProductData */.eW, {
                products: products
            }),
            faqs && faqs.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* FaqData */.v4, {
                faqs: faqs,
                name: name
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/StructuredDataWidget/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Suppliers/Suppliers.styles.ts



var PrimaryTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", (0,src_define_property/* default */.Z)({
    target: "e9nspsd0"
}, "target", "e9nspsd0"))("margin:0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:bold;font-size:1.375rem;line-height:1.25;text-align:center;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";", src/* Theme.mq */.Q2.mq("sm"), "{text-align:left;}", src/* Theme.mq */.Q2.mq("lg"), "{font-size:1.75rem;line-height:1.4285;}");
var Suppliers_styles_SupplierList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e9nspsd1"
}, "target", "e9nspsd1"))("grid-column:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "span 2" : "";
}, ";display:flex;flex-wrap:wrap;align-items:center;justify-content:space-around;gap:1rem;margin:0 auto;padding:0;", src/* Theme.mq */.Q2.mq("sm"), "{margin-left:0;margin-right:0;justify-content:space-between;}", src/* Theme.mq */.Q2.mq("lg"), "{padding-top:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "0" : "0.5rem";
}, ";padding-bottom:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "0" : "0.5rem";
}, ";align-items:end;justify-content:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "center" : "end";
}, ";gap:", function(param) {
    var isStandAlone = param.isStandAlone;
    return isStandAlone ? "2.5rem" : "1.5rem";
}, ";}");
var Suppliers_styles_SupplierListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e9nspsd2"
}, "target", "e9nspsd2"))("display:inline-flex;align-items:center;svg{width:auto;height:1.5rem;vertical-align:bottom;filter:grayscale() opacity(0.7);}");
var SupplierWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e9nspsd3"
}, "target", "e9nspsd3"))("display:grid;gap:1rem;padding:3rem 0 2rem;", function(param) {
    var includeSearch = param.includeSearch;
    return includeSearch && "".concat(src/* Theme.mq */.Q2.mq("lg"), " {\n    grid-template-columns: repeat(2, 0.5fr);\n  }\n\n  ").concat(src/* Theme.mq */.Q2.mq("xl"), " {\n    grid-template-columns: 0.4fr 0.6fr;\n  }");
});


;// CONCATENATED MODULE: ../../frontend/features/src/TrustSeals/TrustSeals.styles.ts


var TrustWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("aside", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv0"
}, "target", "e1ojz8wv0"))("display:flex;flex-direction:column;gap:1rem;position:absolute;bottom:calc(100% - 30px);right:0;");
var TrustSeals_styles_TrustElement = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv1"
}, "target", "e1ojz8wv1"))("padding:0.5rem;border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";border:", function(param) {
    var theme = param.theme, isHighlighted = param.isHighlighted;
    return isHighlighted ? "" : "1px solid ".concat(theme.color.natural20);
}, ";color:", function(param) {
    var theme = param.theme, isHighlighted = param.isHighlighted;
    return isHighlighted ? theme.color.natural0 : theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme, isHighlighted = param.isHighlighted;
    return isHighlighted ? theme.color.primary : theme.color.natural0;
}, ";");
var TrustpilotWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv2"
}, "target", "e1ojz8wv2"))("padding:0 0.5rem;text-align:center;");
var TrustpilotBlackPath = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("path", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv3"
}, "target", "e1ojz8wv3"))("fill:#000;");
var TrustpilotGreenPath = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("path", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv4"
}, "target", "e1ojz8wv4"))("fill:#00b67a;");
var TrustpilotDarkGreenPath = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("path", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv5"
}, "target", "e1ojz8wv5"))("fill:#005128;");
var TrustpilotGrayPath = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("path", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv6"
}, "target", "e1ojz8wv6"))("fill:#cecece;");
var TrustpilotWhitePath = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("path", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv7"
}, "target", "e1ojz8wv7"))("fill:#fff;");
var AppPromoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv8"
}, "target", "e1ojz8wv8"))("display:grid;grid-template:'title title' 'stores qr';grid-template-columns:minmax(50px,1fr) max-content;gap:0.5rem;");
var AppPromoHeadline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv9"
}, "target", "e1ojz8wv9"))("grid-area:title;margin:0;font-size:0.75rem;line-height:1.125;strong{display:block;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.25rem;line-height:1.5;}");
var AppPromoStores = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv10"
}, "target", "e1ojz8wv10"))("grid-area:stores;display:flex;flex-direction:column;gap:0.25rem;margin:0;padding:0;list-style:none;");
var AppPromoQrCode = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", (0,src_define_property/* default */.Z)({
    target: "e1ojz8wv11"
}, "target", "e1ojz8wv11"))("grid-area:qr;shape-rendering:crispedges;width:4.5rem;height:4.5rem;");


;// CONCATENATED MODULE: ../../frontend/features/src/TrustSeals/TrustElements/TrustPilot.tsx


var viewBox = "0 0 262 151";
var width = 136;
var titleId = "trustpilotTitle";
var TrustPilotDe = function TrustPilotDe() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
            role: "img",
            "aria-describedby": titleId,
            viewBox: viewBox,
            width: width,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    id: titleId,
                    children: "Trustpilot"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotBlackPath, {
                    d: "M69.7 23.1H96v4.8H85.7V55H80V27.9H69.7v-4.8Zm25.2 8.8h4.8v4.5h.1c.2-.6.5-1.2.9-1.8.4-.6.9-1.2 1.6-1.6.6-.5 1.3-.9 2.1-1.2.7-.3 1.5-.5 2.3-.5h1.3c.2 0 .5.1.7.1v4.9c-.3-.1-.7-.1-1.1-.2-.4-.1-.7-.1-1.1-.1-.9 0-1.7.2-2.5.5s-1.4.8-2 1.5c-.6.7-1 1.5-1.4 2.5-.4 1-.6 2.2-.6 3.5v11h-5.2l.1-23.1ZM132.5 55h-5.1v-3.2h-.1c-.7 1.2-1.6 2.1-2.9 2.8-1.3.7-2.6 1.1-3.8 1.1-3.1 0-5.3-.7-6.7-2.3-1.4-1.5-2.1-3.8-2.1-6.8V31.9h5.2v14.2c0 2 .4 3.5 1.2 4.3.8.8 1.9 1.3 3.3 1.3 1.1 0 2-.2 2.7-.5.7-.3 1.3-.8 1.8-1.3s.8-1.2 1-2c.2-.8.3-1.6.3-2.5V31.9h5.2V55Zm8.8-7.4c.2 1.5.7 2.5 1.7 3.2 1 .6 2.2.9 3.6.9.5 0 1 0 1.6-.1.6-.1 1.2-.2 1.7-.4.6-.2 1-.5 1.3-.9.4-.4.5-.9.5-1.6 0-.7-.3-1.2-.7-1.6-.5-.4-1-.7-1.7-1-.7-.3-1.5-.5-2.4-.6-.9-.2-1.8-.4-2.8-.6-.9-.2-1.9-.5-2.8-.8-.9-.3-1.7-.7-2.4-1.2s-1.3-1.2-1.7-2c-.4-.8-.6-1.8-.6-2.9 0-1.3.3-2.3.9-3.2.6-.8 1.4-1.5 2.4-2 .9-.5 2-.9 3.2-1.1 1.2-.2 2.3-.3 3.3-.3 1.2 0 2.4.1 3.5.4 1.1.3 2.1.6 3 1.2.9.5 1.6 1.3 2.2 2.2.6.9.9 2 1.1 3.3h-5.4c-.3-1.2-.8-2-1.7-2.5-.9-.4-1.9-.6-3.1-.6-.4 0-.8 0-1.3.1s-.9.2-1.4.3c-.4.2-.8.4-1.1.7-.3.3-.5.7-.5 1.2 0 .6.2 1.1.6 1.5.4.4 1 .7 1.7 1 .7.3 1.5.5 2.4.6.9.2 1.9.4 2.8.6.9.2 1.9.5 2.8.8.9.3 1.7.7 2.4 1.2s1.3 1.2 1.7 1.9c.4.8.6 1.8.6 2.8 0 1.4-.3 2.5-.9 3.5-.6.9-1.5 1.8-2.5 2.3-1 .6-2.2 1-3.4 1.3-1.3.3-2.5.4-3.7.4-1.5 0-2.9-.2-4.1-.5-1.2-.3-2.4-.8-3.3-1.5-.9-.7-1.6-1.5-2.2-2.5-.5-1-.8-2.2-.9-3.6l5.6.1Zm17.1-15.7h3.9v-7h5.2v6.9h4.7v3.8h-4.7V48c0 .5 0 1 .1 1.4 0 .4.2.7.3 1 .2.3.4.5.7.6.4.1.8.2 1.4.2h1.1c.4 0 .7-.1 1.1-.2v4c-.6.1-1.1.1-1.7.2-.6.1-1.1.1-1.7.1-1.4 0-2.5-.1-3.3-.4-.8-.3-1.5-.6-1.9-1.1-.5-.5-.8-1.1-.9-1.8-.1-.7-.3-1.6-.3-2.5V35.7h-3.9l-.1-3.8Zm17.5 0h4.9v3.2h.1c.7-1.4 1.7-2.3 3-2.9 1.3-.6 2.7-.9 4.2-.9 1.9 0 3.5.3 4.9 1 1.4.6 2.5 1.5 3.4 2.6.9 1.1 1.6 2.4 2 3.9.4 1.5.7 3.1.7 4.8 0 1.7-.2 3.1-.6 4.5-.4 1.5-1 2.8-1.9 3.9-.8 1.1-1.9 2-3.2 2.7-1.3.7-2.8 1-4.5 1-.7 0-1.5-.1-2.2-.2-.7-.1-1.5-.3-2.2-.6-.7-.3-1.3-.7-1.9-1.2-.6-.5-1.1-1-1.5-1.6h-.1v11.5h-5.2l.1-31.7ZM194 43.5c0-1-.1-2-.4-3-.3-1-.7-1.8-1.3-2.6-.6-.8-1.3-1.4-2-1.8-.8-.5-1.8-.7-2.8-.7-2.2 0-3.8.7-4.9 2.2-1.1 1.5-1.6 3.5-1.6 6 0 1.2.1 2.3.4 3.2.3.9.7 1.8 1.3 2.5.6.7 1.3 1.3 2.1 1.7.8.4 1.7.6 2.8.6 1.2 0 2.2-.3 3-.7.8-.5 1.5-1.1 2-1.8.5-.8.9-1.6 1.1-2.6.2-1 .3-2 .3-3Zm9.1-20.4h5.2v4.8h-5.2v-4.8Zm0 8.8h5.2V55h-5.2V31.9Zm9.9-8.8h5.2V55H213V23.1Zm21 32.6c-1.9 0-3.6-.3-5-.9-1.4-.6-2.7-1.5-3.7-2.5-1-1.1-1.8-2.4-2.3-3.9-.5-1.5-.8-3.2-.8-4.9 0-1.7.3-3.4.8-4.8.5-1.5 1.3-2.8 2.3-3.9 1-1.1 2.2-1.9 3.7-2.5 1.5-.6 3.2-.9 5-.9 1.8 0 3.6.3 5 .9 1.5.6 2.7 1.5 3.7 2.5 1 1.1 1.8 2.4 2.3 3.9.5 1.5.8 3.1.8 4.8 0 1.7-.3 3.4-.8 4.9-.6 1.5-1.3 2.8-2.3 3.9-1 1.1-2.2 1.9-3.7 2.5-1.4.5-3.1.9-5 .9Zm0-4.1c1.1 0 2.2-.3 3-.7.9-.5 1.5-1.1 2.1-1.9.6-.8.9-1.7 1.2-2.6.3-1 .4-2 .4-3s-.1-2-.4-2.9c-.3-.9-.6-1.8-1.2-2.6s-1.3-1.4-2.1-1.8c-.9-.5-1.9-.7-3-.7s-2.2.3-3 .7c-.9.5-1.5 1.1-2.1 1.8-.6.8-.9 1.6-1.2 2.6-.3 1-.4 2-.4 2.9 0 .9.1 2 .4 3 .3 1 .6 1.8 1.2 2.6s1.3 1.4 2.1 1.9c.9.5 1.9.7 3 .7Zm13.4-19.7h3.9v-7h5.2v6.9h4.7v3.8h-4.7V48c0 .5 0 1 .1 1.4 0 .4.2.7.3 1 .2.3.4.5.7.6.4.1.8.2 1.4.2h1.1c.4 0 .7-.1 1.1-.2v4c-.6.1-1.1.1-1.7.2-.6.1-1.1.1-1.7.1-1.4 0-2.5-.1-3.3-.4-.8-.3-1.5-.6-1.9-1.1-.5-.5-.8-1.1-.9-1.8-.1-.7-.3-1.6-.3-2.5V35.7h-3.9l-.1-3.8Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M63.2 22.4H39.4L32.1 0l-7.3 22.4L1 22.3l19.2 13.9-7.3 22.3 19.2-13.8 19.2 13.8L44 36.2l19.2-13.8Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotDarkGreenPath, {
                    d: "m45.8 41.3-1.6-5.1-12.1 8.6 13.7-3.5Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "M1 69h260.5v50.1H1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M1 69h50.1v50.1H1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m26.1 102.9 7.6-2 3.2 9.9-10.8-7.9Zm17.5-12.8H30.2L26 77.4l-4.1 12.8H8.4l10.9 7.9-4.1 12.8L26 103l6.7-4.9c.1 0 10.9-8 10.9-8Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M53.1 69h50.1v50.1H53.1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m78.2 102.9 7.6-2 3.2 9.9-10.8-7.9Zm17.6-12.8H82.3l-4.2-12.8L74 90.1H60.5L71.4 98l-4.2 12.8 10.9-7.9 6.7-4.9c.1.1 11-7.9 11-7.9Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M105.9 69h49.9v50.1h-49.9V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m130.9 102.9 7.6-2 3.2 9.9-10.8-7.9Zm17.5-12.8H135l-4.1-12.8-4.1 12.8h-13.4l10.8 7.9-4.1 12.8 10.8-7.9 6.7-4.9 10.8-7.9Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M158 69h50.1v50.1H158V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m182.1 104.4 7.4-2.1 3.1 10.2-10.5-8.1Zm17.2-13.1h-13.1l-4.1-13.1-4.1 13.1h-13.1l10.6 8.2-4.1 13.1 10.6-8.1 6.6-5 10.7-8.2Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M211.1 69h50.1v50.1h-50.1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGrayPath, {
                    d: "M235 69h26.2v50.1H235V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m235.1 104.2 7.4-2.1 3.1 10.1-10.5-8Zm17-13H239l-4-13-4 13h-13l10.6 8.1-4 13 10.6-8 6.5-5c-.1-.1 10.4-8.1 10.4-8.1Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotBlackPath, {
                    d: "M5.5 127.7h-4v-1.4h9.6v1.4h-4v11.7H5.5v-11.7Zm6.8 2h1.5l.1 1.8h.1c.7-1.2 1.7-2 2.8-2 .4 0 .7.1 1 .2l-.4 1.4c-.3-.1-.5-.1-.9-.1-.8 0-1.8.6-2.5 2.2v6.2h-1.7v-9.7Zm7 6.1v-6.2H21v5.9c0 1.8.6 2.6 1.8 2.6 1 0 1.7-.5 2.6-1.6v-6.9H27v9.7h-1.4l-.1-1.5h-.1c-.9 1.1-1.9 1.8-3.2 1.8-2 0-2.9-1.3-2.9-3.8Zm9.9 2.4.8-1c.8.7 1.7 1.1 2.9 1.1 1.3 0 1.9-.7 1.9-1.5 0-1-1.1-1.4-2.2-1.8-1.5-.5-2.9-1.2-2.9-2.8 0-1.6 1.2-2.8 3.4-2.8 1.2 0 2.3.5 3 1.1l-.8 1c-.7-.5-1.4-.8-2.2-.8-1.2 0-1.8.7-1.8 1.4 0 .9.8 1.2 2.1 1.7 1.5.5 3 1.2 3 3 0 1.6-1.3 2.9-3.6 2.9-1.4-.1-2.7-.6-3.6-1.5Zm9.3-1.8V131h-1.4v-1.2l1.5-.1.2-3.1h1.4v3.1h2.6v1.3h-2.6v5.4c0 1.2.4 1.9 1.5 1.9.4 0 .7-.1 1.1-.2l.3 1.2c-.5.2-1.2.4-1.8.4-2.1-.1-2.8-1.4-2.8-3.3Zm5.7 1.3.9-1.1c1 1 2.3 1.6 3.7 1.6 1.7 0 2.7-.9 2.7-2.1 0-1.3-1-1.8-2.2-2.3l-1.9-.8c-1.2-.5-2.6-1.4-2.6-3.4s1.7-3.5 4.1-3.5c1.6 0 3 .7 3.9 1.6l-.9 1.1c-.8-.8-1.8-1.2-3-1.2-1.5 0-2.4.7-2.4 1.9 0 1.3 1.1 1.7 2.2 2.2l1.9.8c1.5.6 2.7 1.6 2.7 3.5 0 2.1-1.7 3.7-4.5 3.7-1.8-.1-3.4-.8-4.6-2Zm10.8-3.2c0-3.3 2.2-5.1 4.7-5.1 1.3 0 2.2.5 2.8 1.1l-.8 1c-.5-.5-1.2-.8-1.9-.8-1.8 0-3 1.5-3 3.7s1.2 3.7 3 3.7c.9 0 1.7-.4 2.3-.9l.7 1.1c-.9.8-2 1.2-3.1 1.2-2.7.1-4.7-1.7-4.7-5Zm8.7 0c0-3.3 2.1-5.1 4.5-5.1s4.5 1.9 4.5 5.1c0 3.2-2.1 5.1-4.5 5.1s-4.5-1.8-4.5-5.1Zm7.3 0c0-2.2-1.1-3.7-2.8-3.7-1.7 0-2.8 1.5-2.8 3.7s1.1 3.7 2.8 3.7c1.7 0 2.8-1.4 2.8-3.7Zm4.2-4.8h1.5l.1 1.8h.1c.7-1.2 1.7-2 2.8-2 .4 0 .7.1 1 .2l-.4 1.4c-.3-.1-.5-.1-.9-.1-.8 0-1.8.6-2.5 2.2v6.2h-1.7v-9.7Zm6.1 4.8c0-3.2 2.1-5.1 4.4-5.1 2.5 0 3.9 1.8 3.9 4.6 0 .4 0 .7-.1 1H83c.1 2 1.4 3.3 3.2 3.3.9 0 1.8-.3 2.4-.7l.6 1.1c-.8.6-1.9 1-3.2 1-2.7-.1-4.7-2-4.7-5.2Zm6.8-.8c0-1.9-.9-2.9-2.4-2.9-1.4 0-2.6 1.1-2.8 2.9h5.2Zm16.9 2.7h-5.5v-2.2l4.5-7.6h3.8v7.4h1.4v2.4h-1.4v3H105v-3Zm0-2.3v-1.9c0-.8.1-2.1.1-2.9h-.1c-.3.7-.7 1.5-1 2.2l-1.5 2.6h2.5Zm5.7 7.6c1.5-.5 2.3-1.5 2.3-2.4h-.1c-1 0-1.9-.6-1.9-1.7 0-1 .9-1.7 1.9-1.7 1.4 0 2.1 1.1 2.1 2.9 0 2.2-1.3 4-3.7 4.7l-.6-1.8Zm11-5.3h-5.5v-2.2l4.5-7.6h3.8v7.4h1.4v2.4h-1.4v3h-2.9v-3h.1Zm0-2.3v-1.9c0-.8.1-2.1.1-2.9h-.1c-.3.7-.7 1.5-1 2.2l-1.5 2.6h2.5Zm11.7-9.7h1.2v20h-1.2zm8.8 1.9h1.7v5.5h6.1v-5.5h1.7v13.1H150v-6.2h-6.1v6.2h-1.7v-13.1Zm12.2 8.2c0-3.2 2.1-5.1 4.4-5.1 2.5 0 3.9 1.8 3.9 4.6 0 .4 0 .7-.1 1H156c.1 2 1.4 3.3 3.2 3.3.9 0 1.8-.3 2.4-.7l.6 1.1c-.8.6-1.9 1-3.2 1-2.6-.1-4.6-2-4.6-5.2Zm6.8-.8c0-1.9-.9-2.9-2.4-2.9-1.4 0-2.6 1.1-2.8 2.9h5.2Zm3.8-4h1.4l.1 1.8h.1c.7-1.2 1.7-2 2.8-2 .4 0 .7.1 1 .2l-.4 1.3c-.3-.1-.5-.1-.9-.1-.8 0-1.8.6-2.5 2.2v6.2H165v-9.6Zm6.1 0h1.7l1.8 5.5c.3 1 .6 1.9.9 2.9h.1c.3-.9.6-1.9.9-2.9l1.8-5.5h1.6l-3.4 9.7h-1.9l-3.5-9.7Zm10 4.8c0-3.3 2.1-5.1 4.5-5.1s4.5 1.9 4.5 5.1c0 3.2-2.1 5.1-4.5 5.1s-4.5-1.8-4.5-5.1Zm7.3 0c0-2.2-1.1-3.7-2.8-3.7-1.7 0-2.8 1.5-2.8 3.7s1.1 3.7 2.8 3.7c1.6 0 2.8-1.4 2.8-3.7Zm4.1-4.8h1.5l.1 1.8h.1c.7-1.2 1.7-2 2.8-2 .4 0 .7.1 1 .2l-.4 1.4c-.3-.1-.5-.1-.9-.1-.8 0-1.8.6-2.5 2.2v6.2h-1.7v-9.7Zm7 0h1.5l.1 1.8h.1c.7-1.2 1.7-2 2.8-2 .4 0 .7.1 1 .2l-.4 1.4c-.3-.1-.5-.1-.9-.1-.8 0-1.8.6-2.5 2.2v6.2h-1.7v-9.7Zm6 7.2c0-2.2 1.8-3.2 6-3.7 0-1.2-.4-2.4-2-2.4-1.1 0-2.1.5-2.9 1l-.6-1.1c.9-.6 2.3-1.3 3.8-1.3 2.4 0 3.4 1.6 3.4 4v6h-1.4l-.2-1.2h-.1c-.9.8-2 1.4-3.2 1.4-1.6 0-2.8-1-2.8-2.7Zm5.9.1v-2.6c-3.3.4-4.3 1.1-4.3 2.4 0 1.1.7 1.5 1.7 1.5.9 0 1.7-.5 2.6-1.3Zm4 4.2c0-.8.5-1.6 1.4-2.2-.5-.3-.9-.8-.9-1.6s.6-1.5 1.1-1.8v-.1c-.6-.5-1.3-1.5-1.3-2.6 0-2.1 1.7-3.5 3.7-3.5.5 0 1 .1 1.4.2h3.4v1.3h-2c.5.4.8 1.2.8 2 0 2.1-1.6 3.4-3.6 3.4-.5 0-1-.1-1.4-.3-.4.3-.6.6-.6 1.2s.4 1 1.7 1h1.9c2.3 0 3.4.7 3.4 2.3 0 1.8-1.9 3.4-4.9 3.4-2.5 0-4.1-1-4.1-2.7Zm7.3-.5c0-.9-.7-1.2-2-1.2H219c-.4 0-.8 0-1.3-.2-.7.5-1 1.1-1 1.6 0 1 1.1 1.7 2.8 1.7 2 .1 3.2-.9 3.2-1.9Zm-1.2-7.8c0-1.4-.9-2.3-2.1-2.3-1.1 0-2.1.8-2.1 2.3 0 1.4.9 2.3 2.1 2.3 1.1 0 2.1-.9 2.1-2.3Zm3.7 1.6c0-3.2 2.1-5.1 4.4-5.1 2.5 0 3.9 1.8 3.9 4.6 0 .4 0 .7-.1 1h-6.5c.1 2 1.4 3.3 3.2 3.3.9 0 1.8-.3 2.4-.7l.6 1.1c-.8.6-1.9 1-3.2 1-2.6-.1-4.7-2-4.7-5.2Zm6.8-.8c0-1.9-.9-2.9-2.4-2.9-1.4 0-2.6 1.1-2.8 2.9h5.2Zm3.9-4h1.4l.1 1.4h.1c.9-.9 1.9-1.6 3.3-1.6 2.1 0 3 1.3 3 3.8v6.2H242v-5.9c0-1.8-.6-2.6-1.8-2.6-1 0-1.7.5-2.6 1.5v7h-1.7v-9.8Zm10.2 4.8c0-3.2 2-5.1 4.2-5.1 1.1 0 1.9.4 2.7 1.1l-.1-1.7v-3.7h1.7v14.2h-1.4l-.1-1.1h-.1c-.8.7-1.8 1.4-2.9 1.4-2.4 0-4-1.8-4-5.1Zm6.9 2.4v-5.1c-.8-.7-1.6-1-2.4-1-1.5 0-2.8 1.5-2.8 3.7 0 2.3 1 3.7 2.7 3.7.9 0 1.7-.4 2.5-1.3Z"
                })
            ]
        })
    });
};
var TrustPilotFr = function TrustPilotFr() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
            role: "img",
            "aria-describedby": titleId,
            viewBox: viewBox,
            width: width,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    id: titleId,
                    children: "Trustpilot"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotBlackPath, {
                    d: "M69.7 23.1H96v4.8H85.7V55H80V27.9H69.7v-4.8Zm25.2 8.8h4.8v4.5h.1c.2-.6.5-1.2.9-1.8.4-.6.9-1.2 1.6-1.6.6-.5 1.3-.9 2.1-1.2.7-.3 1.5-.5 2.3-.5h1.3c.2 0 .5.1.7.1v4.9c-.3-.1-.7-.1-1.1-.2-.4-.1-.7-.1-1.1-.1-.9 0-1.7.2-2.5.5s-1.4.8-2 1.5c-.6.7-1 1.5-1.4 2.5-.4 1-.6 2.2-.6 3.5v11h-5.2l.1-23.1ZM132.5 55h-5.1v-3.2h-.1c-.7 1.2-1.6 2.1-2.9 2.8-1.3.7-2.6 1.1-3.8 1.1-3.1 0-5.3-.7-6.7-2.3-1.4-1.5-2.1-3.8-2.1-6.8V31.9h5.2v14.2c0 2 .4 3.5 1.2 4.3.8.8 1.9 1.3 3.3 1.3 1.1 0 2-.2 2.7-.5.7-.3 1.3-.8 1.8-1.3s.8-1.2 1-2c.2-.8.3-1.6.3-2.5V31.9h5.2V55Zm8.8-7.4c.2 1.5.7 2.5 1.7 3.2 1 .6 2.2.9 3.6.9.5 0 1 0 1.6-.1.6-.1 1.2-.2 1.7-.4.6-.2 1-.5 1.3-.9.4-.4.5-.9.5-1.6 0-.7-.3-1.2-.7-1.6-.5-.4-1-.7-1.7-1-.7-.3-1.5-.5-2.4-.6-.9-.2-1.8-.4-2.8-.6-.9-.2-1.9-.5-2.8-.8-.9-.3-1.7-.7-2.4-1.2s-1.3-1.2-1.7-2c-.4-.8-.6-1.8-.6-2.9 0-1.3.3-2.3.9-3.2.6-.8 1.4-1.5 2.4-2 .9-.5 2-.9 3.2-1.1 1.2-.2 2.3-.3 3.3-.3 1.2 0 2.4.1 3.5.4 1.1.3 2.1.6 3 1.2.9.5 1.6 1.3 2.2 2.2.6.9.9 2 1.1 3.3h-5.4c-.3-1.2-.8-2-1.7-2.5-.9-.4-1.9-.6-3.1-.6-.4 0-.8 0-1.3.1s-.9.2-1.4.3c-.4.2-.8.4-1.1.7-.3.3-.5.7-.5 1.2 0 .6.2 1.1.6 1.5.4.4 1 .7 1.7 1 .7.3 1.5.5 2.4.6.9.2 1.9.4 2.8.6.9.2 1.9.5 2.8.8.9.3 1.7.7 2.4 1.2s1.3 1.2 1.7 1.9c.4.8.6 1.8.6 2.8 0 1.4-.3 2.5-.9 3.5-.6.9-1.5 1.8-2.5 2.3-1 .6-2.2 1-3.4 1.3-1.3.3-2.5.4-3.7.4-1.5 0-2.9-.2-4.1-.5-1.2-.3-2.4-.8-3.3-1.5-.9-.7-1.6-1.5-2.2-2.5-.5-1-.8-2.2-.9-3.6l5.6.1Zm17.1-15.7h3.9v-7h5.2v6.9h4.7v3.8h-4.7V48c0 .5 0 1 .1 1.4 0 .4.2.7.3 1 .2.3.4.5.7.6.4.1.8.2 1.4.2h1.1c.4 0 .7-.1 1.1-.2v4c-.6.1-1.1.1-1.7.2-.6.1-1.1.1-1.7.1-1.4 0-2.5-.1-3.3-.4-.8-.3-1.5-.6-1.9-1.1-.5-.5-.8-1.1-.9-1.8-.1-.7-.3-1.6-.3-2.5V35.7h-3.9l-.1-3.8Zm17.5 0h4.9v3.2h.1c.7-1.4 1.7-2.3 3-2.9 1.3-.6 2.7-.9 4.2-.9 1.9 0 3.5.3 4.9 1 1.4.6 2.5 1.5 3.4 2.6.9 1.1 1.6 2.4 2 3.9.4 1.5.7 3.1.7 4.8 0 1.7-.2 3.1-.6 4.5-.4 1.5-1 2.8-1.9 3.9-.8 1.1-1.9 2-3.2 2.7-1.3.7-2.8 1-4.5 1-.7 0-1.5-.1-2.2-.2-.7-.1-1.5-.3-2.2-.6-.7-.3-1.3-.7-1.9-1.2-.6-.5-1.1-1-1.5-1.6h-.1v11.5h-5.2l.1-31.7ZM194 43.5c0-1-.1-2-.4-3-.3-1-.7-1.8-1.3-2.6-.6-.8-1.3-1.4-2-1.8-.8-.5-1.8-.7-2.8-.7-2.2 0-3.8.7-4.9 2.2-1.1 1.5-1.6 3.5-1.6 6 0 1.2.1 2.3.4 3.2.3.9.7 1.8 1.3 2.5.6.7 1.3 1.3 2.1 1.7.8.4 1.7.6 2.8.6 1.2 0 2.2-.3 3-.7.8-.5 1.5-1.1 2-1.8.5-.8.9-1.6 1.1-2.6.2-1 .3-2 .3-3Zm9.1-20.4h5.2v4.8h-5.2v-4.8Zm0 8.8h5.2V55h-5.2V31.9Zm9.9-8.8h5.2V55H213V23.1Zm21 32.6c-1.9 0-3.6-.3-5-.9-1.4-.6-2.7-1.5-3.7-2.5-1-1.1-1.8-2.4-2.3-3.9-.5-1.5-.8-3.2-.8-4.9 0-1.7.3-3.4.8-4.8.5-1.5 1.3-2.8 2.3-3.9 1-1.1 2.2-1.9 3.7-2.5 1.5-.6 3.2-.9 5-.9 1.8 0 3.6.3 5 .9 1.5.6 2.7 1.5 3.7 2.5 1 1.1 1.8 2.4 2.3 3.9.5 1.5.8 3.1.8 4.8 0 1.7-.3 3.4-.8 4.9-.6 1.5-1.3 2.8-2.3 3.9-1 1.1-2.2 1.9-3.7 2.5-1.4.5-3.1.9-5 .9Zm0-4.1c1.1 0 2.2-.3 3-.7.9-.5 1.5-1.1 2.1-1.9.6-.8.9-1.7 1.2-2.6.3-1 .4-2 .4-3s-.1-2-.4-2.9c-.3-.9-.6-1.8-1.2-2.6s-1.3-1.4-2.1-1.8c-.9-.5-1.9-.7-3-.7s-2.2.3-3 .7c-.9.5-1.5 1.1-2.1 1.8-.6.8-.9 1.6-1.2 2.6-.3 1-.4 2-.4 2.9 0 .9.1 2 .4 3 .3 1 .6 1.8 1.2 2.6s1.3 1.4 2.1 1.9c.9.5 1.9.7 3 .7Zm13.4-19.7h3.9v-7h5.2v6.9h4.7v3.8h-4.7V48c0 .5 0 1 .1 1.4 0 .4.2.7.3 1 .2.3.4.5.7.6.4.1.8.2 1.4.2h1.1c.4 0 .7-.1 1.1-.2v4c-.6.1-1.1.1-1.7.2-.6.1-1.1.1-1.7.1-1.4 0-2.5-.1-3.3-.4-.8-.3-1.5-.6-1.9-1.1-.5-.5-.8-1.1-.9-1.8-.1-.7-.3-1.6-.3-2.5V35.7h-3.9l-.1-3.8Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M63.2 22.4H39.4L32.1 0l-7.3 22.4L1 22.3l19.2 13.9-7.3 22.3 19.2-13.8 19.2 13.8L44 36.2l19.2-13.8Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotDarkGreenPath, {
                    d: "m45.8 41.3-1.6-5.1-12.1 8.6 13.7-3.5Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "M1 69h260.5v50.1H1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M1 69h50.1v50.1H1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m26.1 102.9 7.6-2 3.2 9.9-10.8-7.9Zm17.5-12.8H30.2L26 77.4l-4.1 12.8H8.4l10.9 7.9-4.1 12.8L26 103l6.7-4.9c.1 0 10.9-8 10.9-8Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M53.1 69h50.1v50.1H53.1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m78.2 102.9 7.6-2 3.2 9.9-10.8-7.9Zm17.6-12.8H82.3l-4.2-12.8L74 90.1H60.5L71.4 98l-4.2 12.8 10.9-7.9 6.7-4.9c.1.1 11-7.9 11-7.9Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M105.9 69h49.9v50.1h-49.9V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m130.9 102.9 7.6-2 3.2 9.9-10.8-7.9Zm17.5-12.8H135l-4.1-12.8-4.1 12.8h-13.4l10.8 7.9-4.1 12.8 10.8-7.9 6.7-4.9 10.8-7.9Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M158 69h50.1v50.1H158V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m182.1 104.4 7.4-2.1 3.1 10.2-10.5-8.1Zm17.2-13.1h-13.1l-4.1-13.1-4.1 13.1h-13.1l10.6 8.2-4.1 13.1 10.6-8.1 6.6-5 10.7-8.2Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGreenPath, {
                    d: "M211.1 69h50.1v50.1h-50.1V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotGrayPath, {
                    d: "M235 69h26.2v50.1H235V69Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWhitePath, {
                    d: "m235.1 104.2 7.4-2.1 3.1 10.1-10.5-8Zm17-13H239l-4-13-4 13h-13l10.6 8.1-4 13 10.6-8 6.5-5c-.1-.1 10.4-8.1 10.4-8.1Z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotBlackPath, {
                    d: "M6.4 130.3H1.7v-1.7h11.5v1.7H8.4v14h-2v-14Zm8.2 2.4h1.7l.2 2.1h.1c.8-1.5 2-2.4 3.3-2.4.5 0 .9.1 1.2.2l-.4 1.7c-.3-.1-.6-.1-1.1-.1-1 0-2.2.7-3 2.7v7.5h-2v-11.7Zm8.3 7.4v-7.4h2v7.1c0 2.2.7 3.1 2.2 3.1 1.2 0 2-.6 3.1-2v-8.3h2v11.7h-1.6l-.2-1.8h-.1c-1.1 1.3-2.2 2.1-3.8 2.1-2.5.1-3.6-1.5-3.6-4.5Zm11.9 2.9.9-1.2c1 .8 2.1 1.3 3.5 1.3 1.5 0 2.3-.8 2.3-1.8 0-1.2-1.3-1.7-2.6-2.2-1.8-.6-3.4-1.5-3.4-3.4s1.5-3.3 4-3.3c1.5 0 2.7.6 3.6 1.3l-.9 1.2c-.8-.6-1.7-.9-2.7-.9-1.5 0-2.1.8-2.1 1.7 0 1.1 1 1.5 2.5 2 1.8.6 3.6 1.4 3.6 3.6 0 1.9-1.5 3.5-4.3 3.5-1.7-.1-3.3-.8-4.4-1.8Zm11.2-2.2v-6.4h-1.7v-1.5l1.8-.1.2-3.7H48v3.7h3.2v1.6H48v6.5c0 1.4.5 2.2 1.8 2.2.4 0 .9-.1 1.3-.3l.4 1.4c-.6.3-1.4.5-2.2.5-2.4 0-3.3-1.6-3.3-3.9Zm6.9 1.5L54 141c1.2 1.2 2.8 1.9 4.4 1.9 2.1 0 3.3-1 3.3-2.5 0-1.6-1.2-2.1-2.6-2.8l-2.3-1c-1.5-.6-3.2-1.7-3.2-4.1 0-2.4 2.1-4.2 4.9-4.2 1.9 0 3.6.8 4.7 1.9l-1.1 1.3c-1-.9-2.2-1.5-3.6-1.5-1.8 0-2.9.9-2.9 2.3 0 1.5 1.4 2.1 2.6 2.6l2.3 1c1.8.8 3.2 1.9 3.2 4.2 0 2.5-2.1 4.5-5.4 4.5-2.1.1-4-.8-5.4-2.3Zm12.9-3.7c0-3.9 2.6-6.1 5.6-6.1 1.5 0 2.6.6 3.4 1.4l-1 1.2c-.6-.6-1.4-1-2.3-1-2.1 0-3.6 1.8-3.6 4.5s1.4 4.4 3.6 4.4c1.1 0 2-.5 2.7-1.1l.9 1.3c-1.1 1-2.4 1.5-3.8 1.5-3.1 0-5.5-2.3-5.5-6.1Zm10.4 0c0-3.9 2.5-6.1 5.4-6.1 2.9 0 5.4 2.2 5.4 6.1 0 3.9-2.6 6.1-5.4 6.1-2.8 0-5.4-2.3-5.4-6.1Zm8.8 0c0-2.7-1.3-4.5-3.4-4.5-2 0-3.3 1.8-3.3 4.5s1.3 4.4 3.3 4.4c2.1 0 3.4-1.8 3.4-4.4Zm5-5.9h1.7l.2 2.1h.1c.8-1.5 2-2.4 3.3-2.4.5 0 .9.1 1.2.2l-.4 1.7c-.3-.1-.6-.1-1.1-.1-1 0-2.2.7-3 2.7v7.5h-2v-11.7Zm7.4 5.9c0-3.8 2.6-6.1 5.2-6.1 3 0 4.7 2.1 4.7 5.5 0 .4 0 .8-.1 1.2h-7.8c.2 2.4 1.6 4 3.8 4 1.1 0 2.1-.3 2.9-.9l.7 1.3c-1 .7-2.3 1.2-3.9 1.2-3.1-.1-5.5-2.4-5.5-6.2Zm8.1-1.1c0-2.3-1.1-3.5-2.9-3.5-1.6 0-3.1 1.3-3.3 3.5h6.2Zm16.8 3.3h-6.6v-2.6l5.4-9.1h4.6v8.9h1.7v2.8h-1.7v3.6h-3.5v-3.6h.1Zm0-2.8v-2.3c0-1 .1-2.5.1-3.5h-.1c-.4.9-.8 1.8-1.2 2.6l-1.8 3.1h3v.1Zm6.9 9.1c1.8-.6 2.8-1.8 2.8-2.9h-.2c-1.2 0-2.2-.8-2.2-2.1 0-1.2 1-2.1 2.3-2.1 1.6 0 2.5 1.3 2.5 3.5 0 2.7-1.6 4.8-4.4 5.6l-.8-2Zm6.7-4.6 1.7-2.4c.9.9 2.1 1.5 3.3 1.5 1.5 0 2.4-.6 2.4-1.7 0-1.3-.7-2-4-2v-2.6c2.7 0 3.5-.8 3.5-1.9 0-1-.6-1.6-1.8-1.6-1.1 0-1.8.5-2.8 1.3l-1.9-2.3c1.4-1.2 3-2 4.8-2 3.2 0 5.4 1.5 5.4 4.2 0 1.5-.9 2.7-2.5 3.4v.1c1.8.5 3 1.7 3 3.7 0 2.9-2.6 4.4-5.7 4.4-2.5.1-4.2-.8-5.4-2.1Zm19.3-16.1h1.4v24h-1.4zm10.6 2.2h9.1v1.7h-7.1v4.9h6v1.7h-6v5.7h7.3v1.7h-9.3v-15.7Zm13.9 9.7-3.5-5.6h2.2l1.6 2.5c.4.6.7 1.3 1.1 1.9h.1c.4-.6.7-1.3 1.1-1.9l1.4-2.5h2.1l-3.5 5.8 3.8 5.9h-2.2l-1.7-2.7c-.4-.7-.8-1.4-1.3-2.1h-.1l-1.2 2.1-1.6 2.7h-2.1l3.8-6.1Zm7.2.3c0-3.9 2.6-6.1 5.6-6.1 1.5 0 2.6.6 3.4 1.4l-1 1.2c-.6-.6-1.4-1-2.3-1-2.1 0-3.6 1.8-3.6 4.5s1.4 4.4 3.6 4.4c1.1 0 2-.5 2.7-1.1l.9 1.3c-1.1 1-2.4 1.5-3.8 1.5-3.1 0-5.5-2.3-5.5-6.1Zm10.5 0c0-3.8 2.6-6.1 5.2-6.1 3 0 4.7 2.1 4.7 5.5 0 .4 0 .8-.1 1.2h-7.8c.2 2.4 1.6 4 3.8 4 1.1 0 2.1-.3 2.9-.9l.7 1.3c-1 .7-2.3 1.2-3.9 1.2-3.1-.1-5.5-2.4-5.5-6.2Zm8.1-1.1c0-2.3-1.1-3.5-2.9-3.5-1.6 0-3.1 1.3-3.3 3.5h6.2Zm4.6 4.5v-14.7h2v14.9c0 .6.3.8.6.8h.4l.3 1.5c-.3.1-.6.2-1.2.2-1.5 0-2.1-1-2.1-2.7Zm6.2 0v-14.7h2v14.9c0 .6.3.8.6.8h.4l.3 1.5c-.3.1-.6.2-1.2.2-1.5 0-2.1-1-2.1-2.7Zm5.2-3.4c0-3.8 2.6-6.1 5.2-6.1 3 0 4.7 2.1 4.7 5.5 0 .4 0 .8-.1 1.2h-7.8c.2 2.4 1.6 4 3.8 4 1.1 0 2.1-.3 2.9-.9l.7 1.3c-1 .7-2.3 1.2-3.9 1.2-3-.1-5.5-2.4-5.5-6.2Zm8.2-1.1c0-2.3-1.1-3.5-2.9-3.5-1.6 0-3.1 1.3-3.3 3.5h6.2Zm4.6-4.8h1.6l.2 1.7h.1c1.1-1.1 2.3-2 3.9-2 2.5 0 3.6 1.6 3.6 4.6v7.4h-2v-7.1c0-2.2-.7-3.1-2.2-3.1-1.2 0-2 .6-3.2 1.8v8.4h-2v-11.7Zm13.5 8.1v-6.4H246v-1.5l1.8-.1.2-3.7h1.7v3.7h3.2v1.6h-3.2v6.5c0 1.4.5 2.2 1.8 2.2.4 0 .9-.1 1.3-.3l.4 1.4c-.6.3-1.4.5-2.2.5-2.4 0-3.2-1.6-3.2-3.9Z"
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustSeals/TrustElements/AppPromotion.tsx




var AppPromotion = function AppPromotion() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustElements");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppPromoWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppPromoHeadline, {
                children: [
                    t("appPromotion.headline"),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        children: t("appPromotion.subHeadline")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppPromoStores, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.AppStoreLink */.Ui.pG, {
                            href: t("appPromotion.appStoreLink"),
                            target: "_blank",
                            rel: "noopener noreferrer"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.PlayStoreLink */.Ui.L_, {
                            href: t("appPromotion.playStoreLink"),
                            target: "_blank",
                            rel: "noopener noreferrer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppPromoQrCode, {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 72 72",
                role: "img",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#fff",
                        d: "M0 0h72v72H0z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "#222",
                        d: "M0 72V59.71h12.29V72H0Zm14.04 0v-1.76l1.77.02h1.76L17.6 72h-3.55Zm5.27 0v-1.75h1.75v-1.76h5.27v-1.75h5.3v1.75h1.76v1.76h1.75v-3.47l-1.77-.03-.03-1.73h-3.5v-1.8h5.3v-3.47H33.4v1.76l-1.78-.02v-1.77l-.02-1.76h3.55V56.2h1.76v1.76h3.5V56.2h-1.75v-1.75H36.9v-1.8l1.76.01 1.77.01.01.9.01.88h1.71l.02-1.78 1.74-.02v-1.71h-1.76v-3.55h1.76v-1.76h1.8v1.8h-1.76v3.47h1.71v-1.76h1.76v-5.22h-1.76v-8.78h-1.75V33.4h-3.47l-.02 1.73-1.74.02v3.47h1.72v-1.75h3.55v1.8h-3.5l-.03 1.73h-.89l-.89.02v-1.76H36.9v1.76h-1.76v1.71h1.76v1.76h3.5v-1.76h1.76v-1.75h1.8v3.55H42.2v1.75h-3.5v1.72l1.73.02v1.76l.02 1.77h-1.8v-3.51H36.9v-3.51h-1.76v1.75h-3.5v1.72h1.75v1.8h-1.76v1.7h1.76v1.76h1.75v1.8H33.4v1.75h-1.8v-5.26h-1.76l.02-.89v-.89l1.74-.02v-1.71h-1.75v-1.76h-3.47v1.72h1.75v1.8h-1.75v1.75h-1.8v-5.27H21.1v1.76l-10.59-.02-.02-1.74H6.98v-1.8h3.51v-1.7H6.98v-1.8h3.51v-1.72H8.74L7 38.62l-.01-.89-.01-.88h1.75v-1.72H5.26v1.76h-1.8v-1.76h-1.7v3.47H3.5v1.76h1.75v1.8H3.51v1.7h1.75v3.52h3.52v1.8H5.22v-1.76H3.47v-1.76H1.7v-3.5H0V35.1h1.71v-3.5H0v-3.56h1.71V26.3h3.51v-1.72H3.47v-5.3h1.75v-1.72H1.75v1.76H0V14h1.75v1.76h3.51v1.75h1.72v-1.75h1.8v3.5h1.7l.03-1.73 2.64-.01 2.65-.01V15.8h-1.76v-5.31h1.8v1.75h1.71v-3.5H15.8V6.97h-1.76v-5.3h1.77l1.76.01.01.9.01.88h-1.75v3.51h1.71V5.22h1.76V0h5.3v1.71h-1.75v1.72l1.73.02.01 1.76.01 1.77h1.72V5.22h1.8v1.76h3.46V5.22h1.76V3.47h-1.76V1.7h-1.71v1.76h-3.55V0h7.06v3.43h3.5V1.7h-1.75V0h1.76v1.67l1.76.01 1.77.01.01.9.01.88H36.9v5.26h1.8v1.76h1.75l-.01.89-.01.88-1.78.03v-1.76H36.9v3.51h-5.27v1.71h3.51v1.76h1.76v-1.76h3.5V14h1.76v-3.51h1.8V14h1.71V3.43l1.78.02.02 12.3h1.75v3.51h1.76v3.52h5.22v-1.72h-1.75v-1.75h-1.76v-1.76h-1.75V14h1.75v-3.47h-1.71v1.76h-1.8v-1.8h1.76V8.73h1.75V6.98h-1.75V5.22h-1.76l.02-1.77 1.78-.02v1.8h1.75v1.75h1.72V5.22h1.75l.02-1.77L58 3.43v1.8h-1.75v3.5H58v3.56l-1.78-.03V10.5l-.02-1.77h-3.47v1.76h1.76v3.55h-1.75v3.47h1.7v-1.76h1.76V14h5.31v1.75h3.51V14h5.3v3.55h-1.79V15.8h-3.47v3.46h1.76v1.8h-1.76v1.72h3.47v-3.52h1.8v1.76H72v3.55h-1.71v-1.75h-1.72v7.02H72v3.55h-1.67l-.02 1.73-.9.01-.88.01V31.6h-1.71v5.27h1.75v1.8h-1.8V36.9h-1.7v3.47h1.75v1.8H63.3v1.7h3.5v1.8h-1.75v1.72h3.51v3.55h-3.5v3.5h1.7l.03-1.77h1.75l.02 1.78h1.72V50.9H72v3.55h-1.67l-.01 1.76-.01 1.77-1.75.01-1.74.01v1.71h1.75v1.76h1.76v1.8h-1.8V61.5h-1.71v3.51H63.3v1.72h1.75V72H61.5v-1.71h-1.76V72h-1.8l.02-2.62.01-2.62 1.76-.02h1.77v-1.72h-7.02v1.76h-5.27v1.71h1.76v1.76h1.71v-1.76h3.55v1.8H54.5V72h-5.3v-1.71h-1.72V72h-8.82v-1.75h1.76v-1.76h1.8v1.76h3.46v-1.72h-1.75v-1.75H40.4v-1.8h3.5v-1.71h-1.75v-1.8h1.8v1.75h1.71v-1.75h1.76V58h-3.51v-1.8h1.75v-1.75h1.76v-1.76h-3.47v1.76H42.2v2.64l-.02 2.65-1.73.02-.02 1.73-.87.01-.87.01v1.75L38.66 65l-1.77.02V72h-3.55v-1.71h-1.76v-1.76h-5.22v1.72h3.5V72h-3.54v-1.71H24.6V72h-5.3Zm47.47 0v-3.51h1.8V72h-1.8Zm3.5-1.71v-1.8H72v1.8h-1.71Zm-59.79-.05v-8.73H1.76v8.74h8.73Zm52.77 0v-1.7h-1.75v1.7h1.75Zm-59.8-1.7v-5.32h5.32v5.31H3.47Zm12.34 0v-5.32h1.75v-1.71H15.8v-1.75h-1.76V56.2H12.3V58l-1.78-.02-.01-.89-.01-.89H8.78V58H6.13l-2.64-.01-.01-.89-.01-.89h1.75v-1.75H1.76l-.01 1.76-.01 1.77L0 58V47.4h1.76v3.5h7.02v1.76h3.5v1.8h1.76v-1.8l1.78.02v.9l.02.88h3.47V52.7h-1.76v-1.8h1.76v-1.75h1.8v1.8h-1.76v1.71l1.73.02.01 1.77.01 1.76h-1.75v1.76h5.22V56.2h1.8v1.76h3.5v1.8h-1.75v1.75h-1.8v-1.75h-3.46v1.7h1.75v1.8h-1.75v1.72h1.75v1.8h-3.55v-3.52h-1.71v5.27H15.8Zm52.73-1.76v-1.8h1.8v1.8h-1.8Zm-19.35-1.8v-1.72h-1.71v1.72h1.71Zm5.27 0v-1.72h-1.71v1.72h1.7Zm-31.63-1.76v-1.71H21.1v1.71h1.72Zm28.12 0v-1.71h-1.72v1.71h1.72Zm12.33 0V58H58v5.22h5.27Zm-3.51-1.71v-1.8h1.75v1.8h-1.75Zm-38.7-.04v-1.71h-1.71v1.7h1.71Zm17.6 0v-1.71H36.9v1.7h1.75Zm17.54 0v-1.71h-3.46v1.7h3.46ZM19.3 59.7V58h-1.7v1.71h1.7Zm35.15-1.75V56.2h-1.71v1.76h1.7Zm12.33 0V56.2h-1.72v1.76h1.72ZM8.74 56.2v-3.5H7.02v3.5h1.72Zm3.55 0v-1.75h-1.76v1.75h1.76Zm3.5 0v-1.75h-1.75v1.75h1.76Zm12.3 0v-1.75h-3.52l.01-.89.01-.89h5.27v1.77l.02 1.76h-1.8Zm24.6 0v-1.75h1.76v-7.02h-1.76v-1.76h-1.71v3.47h1.76v3.55h-1.8v-1.75h-3.47v1.71l1.73.02.03 1.78h-1.76v1.75h5.22Zm7.07 0v-1.75h1.75v-1.76h-1.75v1.76h-5.27v1.75h5.27Zm8.77 0v-1.75h-1.71v1.75h1.71Zm-8.77-3.55V50.9h5.26v-1.72h-3.51v-1.8h1.76v-1.7H58v1.75h-1.75v3.47H58v1.75h1.76ZM10.5 49.16h5.3l.02.9v.88h-2.65a19.1 19.1 0 0 1-2.67-.05 10.7 10.7 0 0 1-.01-.9l.01-.83Zm24.63 1.78v-1.8h1.76v1.8h-1.76Zm21.06-3.55v-1.72H54.5v1.72h1.71Zm14.09-1.72v-1.75h-1.76v-1.8h1.76v-1.75H72v1.8h-1.67v1.7H72v1.8h-1.71Zm-58-.04v-1.71h-1.76v1.71h1.76Zm7.02 0v-1.71h-3.47v1.71h3.47Zm7.02 0v-1.75h1.75v-1.72h-1.75v-3.5h-3.51v-3.52h-3.47v1.72h1.75v3.55h-1.75v1.71h1.75v1.76h3.51v1.75h1.72Zm5.26 0v-1.75h1.76v-3.51h1.8v-1.72h-3.52v1.76h-3.5v1.71h1.75v3.51h1.71Zm19.35 0v-1.71h-1.72v1.71h1.72Zm7.02 0v-1.71h-1.71v1.71h1.7Zm-43.92-1.75v-1.72H12.3v1.72h1.75Zm42.16 0v-5.23H54.5v1.76h-1.8v-5.3h1.76v-3.52h-1.71l-.03 1.78-1.73.02v3.5h-1.76v1.72h1.76v1.8h-3.51v1.71h3.51v1.76h5.22Zm3.56 0v-1.72H58v1.72h1.76Zm-36.94-1.72v-1.8h1.8v1.8h-1.8Zm-19.35-.04v-1.71h-1.7v1.71h1.7Zm8.82 0v-1.71h-1.76v1.71h1.76Zm5.26 0v-1.75h1.76V36.9h-3.47l-.02 1.73-.9.01-.88.01v1.72h1.8v1.75h1.71Zm43.96 0v-3.5h1.76V36.9H61.5v-1.76H58v1.72h1.76v1.8H58v1.7h1.76v1.76h1.75Zm-49.22-3.5V36.9h-1.76v1.71h1.76Zm17.55 0v-1.76h5.3v-1.72h-4.4l-4.4-.02v-1.76l-.01-1.77h1.8v1.76h5.22v-1.76h1.8v-1.75h1.75v1.75h3.5v-1.75h-3.5v-1.8l1.76.01 1.77.01.01.89.01.89h1.71v-3.56l1.78.03.02 1.73h1.71v-3.47h-3.5v-1.75h-1.72v1.75h-1.8v-1.8h1.76v-1.7h-1.76V19.3H36.9v5.26h-1.76v5.27h-3.5v1.75h-1.8v-3.5h-5.27v-3.52h-1.75v-1.8h1.8v1.76h1.7v-1.75h1.8v3.5h1.76v1.76h3.47v-3.47h-1.76v-5.3h3.55v-1.72h-5.26v3.51h-5.3v-3.5h-1.76v-5.27h-1.76v-1.76h-1.71v5.27h-1.76v1.71h1.76v1.8h-3.51v1.71h5.26v5.3h-1.8v-3.5h-1.7v5.22l2.61.01 2.63.01v1.77l.02 1.76H21.1v1.76h1.76v1.75h1.75v1.76h3.51v1.75h1.72ZM15.8 36.85v-1.72h-1.76V31.6h1.76v-1.75h1.75v-1.76h-3.5v-1.8h1.75v-3.46h-1.76V19.3h-3.5v1.71h1.75v1.8H8.78v3.47h1.7l.03-1.74 1.78-.02v1.8h-1.76v1.71h1.76v1.8h-1.8v-1.76H8.78v1.76H7.02v1.75h5.27v1.8H8.78v1.71h3.5v1.76h3.52Zm33.38 0v-3.47l-1.73-.02-.01-1.77-.01-1.76H45.7v1.75h-1.75v1.76h1.75v1.75h1.76v1.76h1.71Zm15.84 0v-1.72h-1.71v1.72h1.71ZM19.31 35.1v-1.7h-3.47v1.71h3.47Zm19.34 0v-1.7h-3.5v1.71h3.5Zm24.62 0v-1.7H61.5v1.71h1.76ZM5.22 33.35v-3.51h1.76v-1.76H1.76v1.76H3.5v3.5h1.71Zm45.72 0v-1.76h-1.72v1.76h1.72Zm10.57 0v-1.76h-5.26v1.76h5.26Zm-49.22-1.76v-1.75h1.75v1.75H12.3Zm40.4 0v-1.75h-1.71v1.75h1.71Zm14.09 0v-3.5h-1.76v-3.52h-3.51v-1.75h-1.75V19.3H58v5.22h1.76v5.3h1.75v-1.8l1.78.03.02 1.78h1.75v1.75h1.72Zm-15.84-1.75.02-1.78 1.78-.02v1.8h1.7v-3.51H52.7v-1.76h-3.5v-3.5h-1.76V19.3h-5.27v-1.76H38.7v1.71l1.74.03.02 1.73h1.75v1.76h5.27v3.5h1.75v1.8h-1.75v1.76h3.47Zm7.02 0v-3.51h-1.71v3.5h1.7Zm12.33-1.76v-1.8H72v1.8h-1.71Zm-61.55-.04v-1.71H7.02v1.71h1.72ZM56.2 26.3v-1.72h-1.7v1.72h1.71ZM6.98 24.53 7 22.8l1.74-.03v-3.46H7.02v1.75H5.27v3.47h1.7Zm28.16 0v-3.47H33.4v3.47h1.75Zm28.13-1.75v-1.72H61.5v1.72h1.76Zm-7.07-3.52v-1.7h-1.7v1.7h1.71Zm5.31 0V15.8h-5.26v1.71h3.5v1.75h1.76Zm-35.18-1.75V15.8H24.6v1.71h1.72Zm21.1 0V15.8H42.2v1.71h5.23ZM10.5 14.02l1.78-.02v1.8h-.88c-.68 0-.89-.02-.9-.06a8.99 8.99 0 0 1-.01-.88l.01-.84Zm7.04 1.73v-1.7h-1.71v1.7h1.71Zm12.29 0v-1.7h-3.47v1.7h3.47ZM26.33 14v-1.71H24.6V14h1.72Zm5.26 0V8.73h-1.71V14h1.71ZM0 12.29V0h12.29v12.29H0Zm59.76 0V0H72v12.29H59.76Zm-35.19-.05v-3.5h-1.75V6.97H21.1v3.51h1.76v1.75h1.71Zm3.51 0v-1.7h-1.71v1.7h1.71Zm7.06 0V10.5h1.76V8.73h-3.51v3.51h1.75ZM10.5 10.5V1.71H1.76v8.78h8.73Zm59.8 0V1.71h-8.8v8.78h8.78ZM3.47 8.73l.02-5.28 2.64-.01 2.65-.01v5.3H3.47Zm29.88 0V6.98h-1.72v1.75h1.72Zm7.06 0V6.98h1.8v1.75h-1.8Zm22.86 0v-5.3h2.64l2.64.02.01 2.64.01 2.64h-5.3ZM35.14 6.98V5.22H33.4v1.76h1.75Zm7.02-5.27V0h5.3v1.71h-5.3Zm10.53 0V0h1.8v1.71h-1.8Z"
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustSeals/TrustSeals.tsx






var TrustSeals = function TrustSeals() {
    var ref = (0,entities_src/* useSiteInfo */.Mj)(), featureToggles = ref.settings.featureToggles;
    var language = entities_src/* Runtime.useLocale */.r_.useLocale().language;
    var isLargeViewport = (0,useMedia/* default */.Z)("(min-width: 992px)", false);
    if (!isLargeViewport || !featureToggles.trustElementOnStageImage) {
        return null;
    }
    if (language === "de") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrustWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustSeals_styles_TrustElement, {
                    isHighlighted: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppPromotion, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustSeals_styles_TrustElement, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustPilotDe, {})
                })
            ]
        });
    }
    if (language === "fr") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrustWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustSeals_styles_TrustElement, {
                    isHighlighted: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppPromotion, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustSeals_styles_TrustElement, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustPilotFr, {})
                })
            ]
        });
    }
    return null;
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustSeals/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/Suppliers/Suppliers.tsx






var Suppliers_Suppliers = function Suppliers(param) {
    var title = param.title, suppliers = param.suppliers, _includeSearch = param.includeSearch, includeSearch = _includeSearch === void 0 ? true : _includeSearch;
    if (!title && (!suppliers || suppliers.length === 0)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src_legacy/* LayoutLegacy.FilledSegment */.uN.wP, {
        id: "suppliers",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustSeals, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SupplierWrapper, {
                includeSearch: includeSearch,
                children: [
                    title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryTitle, {
                        children: title
                    }),
                    suppliers && includeSearch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Suppliers_styles_SupplierList, {
                        isStandAlone: !title,
                        children: suppliers.map(function(param) {
                            var id = param.id;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Suppliers_styles_SupplierListItem, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.ImageSVG */.ws.ImageSVG, {
                                    name: id
                                })
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/Suppliers/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Cancel24H.js
var Cancel24H = __webpack_require__(2690);
var Cancel24H_default = /*#__PURE__*/__webpack_require__.n(Cancel24H);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/FloytCut.js
var FloytCut = __webpack_require__(6637);
var FloytCut_default = /*#__PURE__*/__webpack_require__.n(FloytCut);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Help.js
var Help = __webpack_require__(8852);
var Help_default = /*#__PURE__*/__webpack_require__.n(Help);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Like.js
var Like = __webpack_require__(4556);
var Like_default = /*#__PURE__*/__webpack_require__.n(Like);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/MapView.js
var MapView = __webpack_require__(3844);
var MapView_default = /*#__PURE__*/__webpack_require__.n(MapView);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Phone.js
var Phone = __webpack_require__(4689);
var Phone_default = /*#__PURE__*/__webpack_require__.n(Phone);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/StarEmpty.js
var StarEmpty = __webpack_require__(8068);
var StarEmpty_default = /*#__PURE__*/__webpack_require__.n(StarEmpty);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/World.js
var World = __webpack_require__(3785);
var World_default = /*#__PURE__*/__webpack_require__.n(World);
;// CONCATENATED MODULE: ../../frontend/features/src/BenefitsLegacy/components/Benefits.styles.ts



var UspContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h0"
}, "target", "e1jjcm4h0"))("display:flex;flex-direction:column;");
var UspItems = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h1"
}, "target", "e1jjcm4h1"))("display:flex;flex-direction:column;gap:0.5rem;", src/* Theme.mq */.Q2.mq("lg"), "{flex-direction:row;}");
var UspItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h2"
}, "target", "e1jjcm4h2"))("display:flex;flex:1;margin:0 0 1.5rem;", src/* Theme.mq */.Q2.mq("lg"), "{margin:0.5rem 0;}");
var UspTitleContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h3"
}, "target", "e1jjcm4h3"))("margin-bottom:1rem;");
var UspTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h4"
}, "target", "e1jjcm4h4"))("color:", src/* Theme.Color.secondary100 */.Q2.Color.secondary100, ";margin:0 0 0.5rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;font-weight:normal;line-height:1.125;a{color:inherit;}");
var RatingContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h5"
}, "target", "e1jjcm4h5"))("display:flex;flex-direction:row;align-items:flex-end;gap:1rem;margin-top:0.5rem;");
var Benefits_styles_IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1jjcm4h6"
}, "target", "e1jjcm4h6"))("margin-right:0.3125rem;fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";svg{width:45px;height:45px;}");


;// CONCATENATED MODULE: ../../frontend/features/src/BenefitsLegacy/components/Usp.tsx














var Usp_icons = {
    Cancel24H: (Cancel24H_default()),
    Checked: (Checked_default()),
    FloytCut: (FloytCut_default()),
    MapView: (MapView_default()),
    StarEmpty: (StarEmpty_default()),
    Help: (Help_default()),
    Phone: (Phone_default()),
    Like: (Like_default()),
    World: (World_default())
};
var Usp = function Usp(param) {
    var title = param.title, rating = param.rating, _translationKey = param.translationKey, translationKey = _translationKey === void 0 ? "usps" : _translationKey;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.benefitsLegacy.".concat(translationKey));
    var formatter = (0,next_intl_cjs_production_min.useFormatter)();
    var messages = (0,next_intl_cjs_production_min.useMessages)();
    var items = Object.keys(messages.features.benefitsLegacy[translationKey].content);
    var makeTranslateKey = function makeTranslateKey(item) {
        return function(key, values) {
            return t("content.".concat(item, ".").concat(key), values);
        };
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UspContainer, {
        children: [
            Boolean(title) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UspTitleContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PrimaryTitle */.ws.PrimaryTitle, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UspItems, {
                children: items.filter(function(item) {
                    return !(item === "customerReviews" && !rating);
                }).map(function(item) {
                    var translateKey = makeTranslateKey(item);
                    if (rating && item === "customerReviews") {
                        var reviewsCount = formatter.number(rating.count, {
                            useGrouping: true
                        });
                        var averageRating = formatter.number(rating.averageRating, {
                            maximumFractionDigits: 1
                        });
                        var Icon = Usp_icons[translateKey("icon")];
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UspItem, {
                            children: [
                                Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Benefits_styles_IconWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UspTitle, {
                                            children: translateKey("title")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                                            href: "".concat(t("ratingSlug"), ".html"),
                                            text: translateKey("description", {
                                                reviewsCount: reviewsCount
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RatingContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Rating */.ws.Rating, {
                                                    value: rating.averageRating,
                                                    starSize: "large"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SmallText */.ws.SmallText, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("b", {
                                                        children: [
                                                            averageRating,
                                                            " / 5"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item);
                    }
                    var Icon1 = Usp_icons[translateKey("icon")];
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UspItem, {
                        children: [
                            Icon1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Benefits_styles_IconWrapper, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon1, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UspTitle, {
                                        children: translateKey("href") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: translateKey("href"),
                                            children: translateKey("title")
                                        }) : translateKey("title")
                                    }),
                                    translateKey("description")
                                ]
                            })
                        ]
                    }, item);
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/BenefitsLegacy/components/ValuePropositions.tsx





var ValuePropositions = function ValuePropositions() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.benefitsLegacy.valuePropositions");
    var title = t("title");
    var propositions = [
        [
            t("propositions.1.1"),
            t("propositions.1.2"),
            t("propositions.1.3")
        ],
        [
            t("propositions.2.1"),
            t("propositions.2.2"),
            t("propositions.2.3")
        ],
        [
            t("propositions.3.1"),
            t("propositions.3.2"),
            t("propositions.3.3")
        ], 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SectionTitle */.ws.SectionTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* LayoutLegacy.Grid */.uN.rj, {
                columns: propositions,
                children: function children(items) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.BulletList */.ws.BulletList, {
                        items: items,
                        type: "checkmark"
                    });
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/BenefitsLegacy/components/index.ts



;// CONCATENATED MODULE: ../../frontend/features/src/BenefitsLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/DocumentLegacy/hooks/usePath.ts

var usePath_hasContext = src/* Context.guardContext */._y.guardContext;
var usePath = function usePath() {
    var pathContext = src/* Context.useClientContext */._y.useClientContext("path");
    usePath_hasContext("path", pathContext);
    var _value = pathContext.value, alternatives = _value.alternatives, current = _value.current;
    var isHomepage = current.startsWith("index.");
    var currentPath = isHomepage ? "" : current;
    return {
        alternatives: alternatives,
        current: currentPath,
        isHomepage: isHomepage
    };
};


;// CONCATENATED MODULE: ../../frontend/features/src/DocumentLegacy/hooks/useDocumentUrls.ts


var useDocumentUrls_join = function join(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
var useDocumentUrls = function useDocumentUrls() {
    var ref = src_legacy/* HostLegacy.useHost */.IW.useHost(), alternativeBaseUrls = ref.alternativeBaseUrls, baseUrl = ref.baseUrl;
    var ref1 = usePath(), current = ref1.current, alternatives = ref1.alternatives;
    return {
        canonicalUrl: {
            rel: "canonical",
            href: useDocumentUrls_join(baseUrl, current)
        },
        hreflangUrls: alternatives.map(function(param) {
            var locale = param.locale, path = param.path;
            return {
                hrefLang: locale,
                href: useDocumentUrls_join(alternativeBaseUrls[locale], path),
                rel: "alternate"
            };
        })
    };
};


;// CONCATENATED MODULE: ../../frontend/features/src/DocumentLegacy/Head.tsx







var metaKey = function metaKey(param, index) {
    var charSet = param.charSet, content = param.content, httpEquiv = param.httpEquiv, name = param.name, property = param.property;
    if (charSet) {
        return charSet;
    }
    if (name && content) {
        return "".concat(name, "-").concat(content);
    }
    if (property && content) {
        return "".concat(property, "-").concat(content);
    }
    if (httpEquiv && content) {
        return "".concat(httpEquiv, "-").concat(content);
    }
    return "".concat(index);
};
var Head = function Head(param) {
    var document = param.document, HeadComponent = param.headComponent;
    var ref = useDocumentUrls(), canonicalUrl = ref.canonicalUrl, hreflangUrls = ref.hreflangUrls;
    var title = (document === null || document === void 0 ? void 0 : document.title) || "";
    var messages = (0,next_intl_cjs_production_min.useMessages)();
    var _documentLegacy = messages.features.documentLegacy, links = _documentLegacy.links, metaItems = _documentLegacy.meta;
    var linkTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.documentLegacy.links");
    var metaTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.documentLegacy.meta");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeadComponent, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: title
            }),
            Object.keys(metaItems).map(function(item, index) {
                var meta = metaTranslations.raw(item);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", (0,_object_spread/* default */.Z)({}, meta)),
                        meta.name === "description" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:description",
                            content: meta.content
                        })
                    ]
                }, metaKey(meta, index));
            }),
            document === null || document === void 0 ? void 0 : document.meta.map(function(meta) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", (0,_object_spread/* default */.Z)({}, meta)),
                        meta.name === "description" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:description",
                            content: meta.content
                        })
                    ]
                }, meta.name);
            }),
            Object.keys(links).map(function(link) {
                var linkData = linkTranslations.raw(link);
                return /*#__PURE__*/ (0,react.createElement)("link", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkData), {
                    key: linkData.href
                }));
            }),
            hreflangUrls.map(function(hreflangUrl) {
                return /*#__PURE__*/ (0,react.createElement)("link", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hreflangUrl), {
                    key: hreflangUrl.href
                }));
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", (0,_object_spread/* default */.Z)({}, canonicalUrl))
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/DocumentLegacy/hooks/index.ts



;// CONCATENATED MODULE: ../../frontend/features/src/DocumentLegacy/index.ts



// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowDown.js
var ArrowDown = __webpack_require__(1143);
var ArrowDown_default = /*#__PURE__*/__webpack_require__.n(ArrowDown);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowUp.js
var ArrowUp = __webpack_require__(1025);
var ArrowUp_default = /*#__PURE__*/__webpack_require__.n(ArrowUp);
;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/Reviews.styles.ts





// eslint-disable-next-line @typescript-eslint/no-unused-vars
var cq = function cq(_size) {
    return "@container (min-width: 39.375rem) ";
};
var FeedbackContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz0"
}, "target", "e1huomwz0"))("display:flex;flex-direction:column;column-gap:1rem;", cq("g8"), "{flex-direction:", function(props) {
    return props.hasSummary ? "row" : "column";
}, ";row-gap:1rem;}");
var SummaryContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz1"
}, "target", "e1huomwz1"))(cq("g8"), "{flex:1;}");
var AverageRating = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz2"
}, "target", "e1huomwz2"))("margin-bottom:1.875rem;", cq("g8"), "{margin-bottom:0;}");
var ColoredText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1huomwz3"
}, "target", "e1huomwz3"))("color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";");
var LocationName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1huomwz4"
}, "target", "e1huomwz4"))("display:inline-block;margin-bottom:0.5rem;");
var ReviewListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz5"
}, "target", "e1huomwz5"))("width:100%;", cq("g8"), "{flex:1;}");
var ReviewContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz6"
}, "target", "e1huomwz6"))("padding:0.5rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";margin-bottom:", function(param) {
    var largeReview = param.largeReview;
    return largeReview ? "1rem" : "-1px";
}, ";");
var StyledHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz7"
}, "target", "e1huomwz7"))("width:100%;display:inline-flex;column-gap:0.625rem;");
var ReviewFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz8"
}, "target", "e1huomwz8"))("width:100%;display:inline-flex;justify-content:space-between;column-gap:0.625rem;button{padding:0.6rem;}");
var QuoteContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1huomwz9"
}, "target", "e1huomwz9"))("margin:0.625rem 0;p{margin:0.3125rem 0;}");
var RatingGroupList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e1huomwz10"
}, "target", "e1huomwz10"))("margin-top:0.625rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, ";padding:0.625rem;p{font-size:0.75rem;display:flex;column-gap:0.625rem;> span{width:35%;}}");
var RatingGroupItemCriterion = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1huomwz11"
}, "target", "e1huomwz11"))("margin-right:2.1875rem;");
var getArrowStyles = function getArrowStyles(theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:0.75rem;height:0.75rem;fill:", theme.color.primary, ";");
};
var ArrowDownIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowDown_default()), (0,src_define_property/* default */.Z)({
    target: "e1huomwz12"
}, "target", "e1huomwz12"))(function(param) {
    var theme = param.theme;
    return getArrowStyles(theme);
}, ";");
var ArrowUpIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowUp_default()), (0,src_define_property/* default */.Z)({
    target: "e1huomwz13"
}, "target", "e1huomwz13"))(function(param) {
    var theme = param.theme;
    return getArrowStyles(theme);
}, ";");


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/FeedbackSummary.tsx




var important = _legacy/* I18nLegacy.important */.P7.important;
var FeedbackSummary = function FeedbackSummary(param) {
    var averageRating = param.averageRating, count = param.count, _hideSummaryDescription = param.hideSummaryDescription, hideSummaryDescription = _hideSummaryDescription === void 0 ? false : _hideSummaryDescription, _locationName = param.locationName, locationName = _locationName === void 0 ? "" : _locationName;
    var format = (0,next_intl_cjs_production_min.useFormatter)();
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.feedbackGroup");
    var title = t("title.seo");
    var description = t("description");
    var descriptionLocation = t.rich("descriptionLocation", {
        locationName: locationName,
        important: important
    });
    var reviewCountLabel = t.rich("reviewCountLabel", {
        count: format.number(count, {
            useGrouping: "auto"
        }),
        important: important
    });
    var averagePercentLabel = t("averagePercentLabel");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SectionTitle */.ws.SectionTitle, {
                children: title
            }),
            !hideSummaryDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AverageRating, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.CalloutText */.ws.CalloutText, {
                        children: locationName ? descriptionLocation : description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: reviewCountLabel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Rating */.ws.Rating, {
                                value: averageRating
                            }),
                            averagePercentLabel
                        ]
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/RatingGroups.tsx




var ratingFormatOptions = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
};
var useRatingGroupTitle = function useRatingGroupTitle(organizers, hostName) {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.reviewItem.ratingGroupTitle");
    return function(groupName) {
        switch(groupName){
            case "site":
                return t("site", {
                    host: hostName
                });
            case "organizers":
                return t("organizers", {
                    organizers: organizers
                });
            default:
                return t("rentalCompanies");
        }
    };
};
var RatingGroups = function RatingGroups(param) {
    var ratingGroups = param.ratingGroups, providerQuote = param.providerQuote, host = param.host;
    var format = (0,next_intl_cjs_production_min.useFormatter)();
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.reviewItem");
    var getGroupTitle = useRatingGroupTitle(providerQuote.organizers, host);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingGroupList, {
        children: ratingGroups.map(function(param) {
            var groupType = param.type, items = param.items;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                        children: getGroupTitle(groupType)
                    }),
                    items.map(function(param) {
                        var rating = param.rating, ratingType = param.type;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingGroupItemCriterion, {
                                    children: t("ratingTitle.".concat(ratingType))
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Rating */.ws.Rating, {
                                    value: rating
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                                    children: format.number(rating, ratingFormatOptions)
                                }),
                                " / 5"
                            ]
                        }, ratingType);
                    })
                ]
            }, groupType);
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/ReviewHeader.tsx




var ReviewHeader = function ReviewHeader(param) {
    var aggregateRating = param.aggregateRating, dateLabel = param.dateLabel, ratingLabel = param.ratingLabel, locationName = param.locationName, ratingLocation = param.ratingLocation;
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat(_legacy/* Theme.getBreakpoint */.Q2.getBreakpoint("lg"), "px)"), true);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: dateLabel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Rating */.ws.Rating, {
                        value: aggregateRating
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SmallText */.ws.SmallText, {
                        children: ratingLabel
                    }),
                    locationName && !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SmallText */.ws.SmallText, {
                        children: ratingLocation
                    })
                ]
            }),
            locationName && isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SmallText */.ws.SmallText, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationName, {
                    children: ratingLocation
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/useReviewItem.ts


var hosts = {
    de: "billiger-mietwagen.de",
    fr: "carigami.fr"
};
var useReviewItem = function useReviewItem(item) {
    var aggregateRating = item.aggregateRating, date = item.date, locationName = item.locationName, providerQuote = item.providerQuote, reviewerName = item.reviewerName;
    var ratingFormatOptions = {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    };
    var important = _legacy/* I18nLegacy.important */.P7.important;
    var format = (0,next_intl_cjs_production_min.useFormatter)();
    var language = _legacy/* I18nLegacy.useLocale */.P7.useLocale().language;
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.reviewItem");
    var dateLabel = _legacy/* String.useRelativeDate */.Ld.useRelativeDate(date);
    var host = hosts[language];
    var ratingLabel = t.rich("ratingLabel", {
        rating: format.number(aggregateRating, ratingFormatOptions),
        important: important
    });
    var ratingLocation = t.rich("ratingLocation", {
        location: locationName,
        important: important
    });
    var reviewerLabel = t("reviewerLabel", {
        reviewerName: reviewerName
    });
    var providersQuoteTitleLabel = t("providersQuoteTitleLabel", {
        organizers: providerQuote.organizers,
        rentalCompanies: providerQuote.rentalCompanies
    });
    var siteQuoteTitleLabel = t("siteQuoteTitleLabel", {
        host: host
    });
    return {
        host: host,
        providersQuoteTitleLabel: providersQuoteTitleLabel,
        reviewerLabel: reviewerLabel,
        siteQuoteTitleLabel: siteQuoteTitleLabel,
        header: {
            aggregateRating: aggregateRating,
            dateLabel: dateLabel,
            ratingLabel: ratingLabel,
            locationName: locationName,
            ratingLocation: ratingLocation
        }
    };
};

;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/ExpandedReviewItem.tsx









var ExpandedReviewItem = function ExpandedReviewItem(props) {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.reviewItem");
    var providerQuote = props.providerQuote, ratingGroups = props.ratingGroups, onClose = props.onClose, siteQuote = props.siteQuote;
    var ref = useReviewItem(props), header = ref.header, host = ref.host, providersQuoteTitleLabel = ref.providersQuoteTitleLabel, reviewerLabel = ref.reviewerLabel, siteQuoteTitleLabel = ref.siteQuoteTitleLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewHeader, (0,_object_spread/* default */.Z)({}, header)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuoteContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                            children: siteQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Quote */.ws.Quote, {
                        children: siteQuote
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                            children: providersQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Quote */.ws.Quote, {
                        children: providerQuote.quote
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingGroups, {
                ratingGroups: ratingGroups,
                providerQuote: providerQuote,
                host: host
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewFooter, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.TinyText */.ws.TinyText, {
                        children: reviewerLabel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Ui.TextLink */.Ui.hh, {
                        as: "button",
                        onClick: onClose,
                        children: [
                            t("readLess"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpIcon, {})
                        ]
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/LargeReviewItem.tsx






var LargeReviewItem = function LargeReviewItem(props) {
    var providerQuote = props.providerQuote, siteQuote = props.siteQuote;
    var ref = useReviewItem(props), header = ref.header, providersQuoteTitleLabel = ref.providersQuoteTitleLabel, reviewerLabel = ref.reviewerLabel, siteQuoteTitleLabel = ref.siteQuoteTitleLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewContainer, {
        largeReview: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewHeader, (0,_object_spread/* default */.Z)({}, header)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuoteContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredText, {
                            children: siteQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Quote */.ws.Quote, {
                        children: siteQuote
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColoredText, {
                            children: providersQuoteTitleLabel
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Quote */.ws.Quote, {
                        children: providerQuote.quote
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewFooter, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                    children: reviewerLabel
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/SummaryReviewItem.tsx








var SummaryReviewItem = function SummaryReviewItem(props) {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.reviewItem");
    var ref = useReviewItem(props), header = ref.header, reviewerLabel = ref.reviewerLabel;
    var element = props.element, siteQuote = props.siteQuote, onClick = props.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewContainer, {
        as: element,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewHeader, (0,_object_spread/* default */.Z)({}, header)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Quote */.ws.Quote, {
                children: siteQuote
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewFooter, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.TinyText */.ws.TinyText, {
                        children: reviewerLabel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Ui.TextLink */.Ui.hh, {
                        as: "button",
                        onClick: onClick,
                        children: [
                            t("readMore"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownIcon, {})
                        ]
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/ReviewList.tsx









var ReviewList = function ReviewList(props) {
    var largeReviews = props.largeReviews, locationName = props.locationName, items = props.items;
    var ref = (0,react.useState)(), selectedItem = ref[0], setSelectedItem = ref[1];
    var Item = largeReviews ? LargeReviewItem : SummaryReviewItem;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewListContainer, {
        children: selectedItem ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExpandedReviewItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedItem), {
            locationName: locationName,
            onClose: function onClose() {
                return setSelectedItem(null);
            }
        })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
            children: items.map(function(item) {
                return /*#__PURE__*/ (0,react.createElement)(Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    locationName: locationName,
                    element: "li",
                    key: item.reviewerName,
                    onClick: function onClick() {
                        return setSelectedItem(item);
                    }
                }));
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/Feedback.tsx







var Feedback = function Feedback(props) {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.trustLegacy.feedback.feedbackGroup.groupLink");
    var hideSummaryDescription = props.hideSummaryDescription, groupLink = props.groupLink;
    var name = t("name");
    var path = t("path");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeedbackContainer, {
        hasSummary: !hideSummaryDescription,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedbackSummary, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewList, (0,_object_spread/* default */.Z)({}, props)),
            !!groupLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                        text: name,
                        href: path
                    }),
                    " \xa0>"
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/Reviews/index.ts


// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../frontend/features/src/TrustLegacy/components/CarigamiGarantie/CarigamiGarantie.styles.ts
var CarigamiGarantie_styles = __webpack_require__(5650);
;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/CarigamiGarantie/CarigamiGarantie.tsx





var Garantie = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 601).then(__webpack_require__.bind(__webpack_require__, 5601)).then(function(module) {
        return module.Garantie;
    });
}, (0,src_define_property/* default */.Z)({
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5601)
            ];
        }
    }
}, "loadableGenerated", {
    webpack: function webpack() {
        return [
            /*require.resolve*/(5601)
        ];
    }
}));
var CarigamiGarantie = function CarigamiGarantie() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarigamiGarantie_styles/* LogoList */.Ir, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarigamiGarantie_styles/* MgpWrapper */.g7, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Garantie, {})
            }, "gmp"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarigamiGarantie_styles/* CarigamiWrapper */.ZC, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.ImageSVG */.ws.ImageSVG, {
                    name: "cg"
                })
            }, "carigami")
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/CarigamiGarantie/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/components/index.ts



;// CONCATENATED MODULE: ../../frontend/features/src/TrustLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/PageLegacy/Page.styles.ts



var HeaderContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf0"
}, "target", "e19o1ydf0"))("color:", src/* Theme.Color.secondary100 */.Q2.Color.secondary100, ";background-color:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";box-sizing:border-box;height:3rem;margin-bottom:-3px;", src/* Theme.mq */.Q2.mq("sm"), "{height:4.375rem;margin:0;}");
var HeaderLogoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf1"
}, "target", "e19o1ydf1"))("display:flex;align-items:center;svg{display:block;flex:0 0 auto;width:auto;height:27px;", src/* Theme.mq */.Q2.mq("sm"), "{height:49px;}}/* hack to reduce the viewBox size on small screens for the stacked BM logo */\n  html[lang='de'] &{width:155px !important;", src/* Theme.mq */.Q2.mq("sm"), "{width:265px !important;}", src/* Theme.mq */.Q2.mq("lg"), "{width:auto !important;}}.logo-bm-part-1{transform:translate(9px,0.6px) scale(0.83);}.logo-bm-part-2{transform:translate(-174.2px,33.2px) scale(0.83);}.logo-cg-title{transform:translate(0,20px);}.logo-claim{display:none;}", src/* Theme.mq */.Q2.mq("lg"), "{.logo-bm-part-1,.logo-bm-part-2,.logo-cg-title{/* translateZ(0) fixes an issue with iOS Safari <= 14 when rotating the device */\n      transform:translateZ(0);}.logo-claim{display:block;}}");
var LayoutContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf2"
}, "target", "e19o1ydf2"))("width:100%;background-color:", function(param) {
    var theme = param.theme, isAffiliate = param.isAffiliate;
    return isAffiliate ? theme.color.natural0 : theme.color.natural20;
}, ";");
var PageBaseContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf3"
}, "target", "e19o1ydf3"))("position:relative;min-width:20rem;", src/* Theme.mq */.Q2.mq("xl"), "{margin:0 auto;max-width:1920px;overflow-x:hidden;}");
var PageContentContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf4"
}, "target", "e19o1ydf4"))("width:100%;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var FooterBaseContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf5"
}, "target", "e19o1ydf5"))("position:relative;display:flex;flex-direction:column;align-items:center;justify-content:space-between;gap:1.5rem;contain:content;");
var FooterList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf6"
}, "target", "e19o1ydf6"))("display:flex;justify-content:flex-start;flex-wrap:wrap;list-style:none;margin:1.5rem auto 0;padding:0;max-width:21em;contain:content;li{flex-basis:50%;}", src/* Theme.mq */.Q2.mq("lg"), "{justify-content:center;max-width:fit-content;li{flex-basis:auto;}}a{color:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";display:inline-block;font-size:1rem;padding:0.5rem 0.75rem;text-decoration:none;}");
var FooterContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("footer", (0,src_define_property/* default */.Z)({
    target: "e19o1ydf7"
}, "target", "e19o1ydf7"))("color:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";background-color:", src/* Theme.Color.primary */.Q2.Color.primary, ";width:100%;margin-left:0;margin-right:0;padding:1rem 0;position:relative;display:flex;flex-direction:column;align-items:center;contain:layout style;button{display:flex;align-items:center;justify-content:center;position:absolute;left:50%;top:-1.25rem;width:2.5rem;height:2.5rem;background:", src/* Theme.Color.natural0 */.Q2.Color.natural0, ";border:2px solid ", src/* Theme.Color.primary */.Q2.Color.primary, ";border-radius:100%;transform:translate3d(-50%,0,0);cursor:pointer;svg{fill:", src/* Theme.Color.primary */.Q2.Color.primary, ";height:0.9375rem;width:0.9375rem;}}");


;// CONCATENATED MODULE: ../../frontend/features/src/PageLegacy/PageBase.tsx



var PageBase = function PageBase(param) {
    var children = param.children, isAffiliate = param.isAffiliate;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutContainer, {
        isAffiliate: isAffiliate,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageBaseContainer, {
            id: "page-body",
            children: children
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/PageLegacy/PageContentBase.tsx



var PageContentBase = function PageContentBase(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageContentContainer, {
        id: "page-content",
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/PageLegacy/PageFooter.tsx







var LinkWrapper = function LinkWrapper(param) {
    var item = param.item, children = param.children;
    var external = Object.prototype.hasOwnProperty.call(item, "external") && item.external;
    // links marked as 'external' use the standard anchor tag
    // instead of the Link component provided by next.js
    return external ? children : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        passHref: true,
        href: item.href,
        children: children
    });
};
var PageFooter = function PageFooter(param) {
    var _showLogo = param.showLogo, showLogo = _showLogo === void 0 ? true : _showLogo;
    var scrollToTop = function scrollToTop() {
        if (true) {
            window.scrollTo(0, 0);
        }
    };
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.navigationLegacy.footer");
    var links = t.raw("links");
    var logo = t("logo");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* LayoutLegacy.FooterSegment */.uN.tE, {
        id: "page-footer",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterContainer, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "button",
                    onClick: scrollToTop,
                    "aria-label": "back to top",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SvgIcon */.ws.SvgIcon, {
                        name: "arrowUp"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterBaseContent, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterList, {
                            role: "menu",
                            children: links.map(function(item) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    role: "presentation",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
                                        item: item,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: item.href,
                                            rel: item.rel,
                                            target: item.target,
                                            role: "menuitem",
                                            children: item.text
                                        })
                                    })
                                }, "footer-".concat(item.href));
                            })
                        }),
                        showLogo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.ImageSVG */.ws.ImageSVG, {
                            name: logo
                        })
                    ]
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/PageLegacy/index.ts




;// CONCATENATED MODULE: ../../frontend/features/src/PageNavigationLegacy/PageNavigation.styles.ts


function PageNavigation_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-weight: bold;\n    "
    ]);
    PageNavigation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var BreadcrumbsContentContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "egrx0h0"
}, "target", "egrx0h0"))("z-index:10;position:relative;overflow-x:auto;", src/* Theme.mq */.Q2.mq("sm"), "{margin-bottom:0;overflow-x:auto;}", src/* Theme.mq */.Q2.mq("lg"), "{position:static;margin:0;}");
var BreadcrumbList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "egrx0h1"
}, "target", "egrx0h1"))("display:inline-flex;flex-flow:row wrap;padding:0 1rem;font-size:0.75rem;", src/* Theme.mq */.Q2.mq("sm"), "{font-size:inherit;padding:0;}");
var BreadcrumbItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "egrx0h2"
}, "target", "egrx0h2"))("white-space:nowrap;&:not(:last-child)::after{content:'\\0000a0|\\0000a0';}");
var BreadcrumbText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "egrx0h3"
}, "target", "egrx0h3"))(function(param) {
    var isLast = param.isLast;
    return !!isLast && (0,emotion_react_browser_esm/* css */.iv)(PageNavigation_styles_templateObject());
});
var BreadcrumbLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "egrx0h4"
}, "target", "egrx0h4"))("color:", src/* Theme.Color.primary */.Q2.Color.primary, ";text-decoration:none;cursor:pointer;");


;// CONCATENATED MODULE: ../../frontend/features/src/PageNavigationLegacy/Breadcrumbs.tsx




var BreadcrumbListItem = function BreadcrumbListItem(param) {
    var _breadcrumb = param.breadcrumb, name = _breadcrumb.name, url = _breadcrumb.url, isLast = param.isLast, index = param.index;
    var shouldRenderText = isLast || !url;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BreadcrumbItem, {
        itemProp: "itemListElement",
        itemScope: true,
        itemType: "https://schema.org/ListItem",
        children: [
            shouldRenderText ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadcrumbText, {
                isLast: isLast,
                "aria-current": "page",
                itemProp: "name",
                children: name
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadcrumbLink, {
                href: url,
                itemProp: "item",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    itemProp: "name",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                itemProp: "position",
                content: String(index + 1)
            })
        ]
    });
};
var Breadcrumbs = function Breadcrumbs(param) {
    var breadcrumbs = param.breadcrumbs;
    if (!breadcrumbs || breadcrumbs.length === 0) {
        return null;
    }
    var lastIndex = breadcrumbs.length - 1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* LayoutLegacy.PlainSegment */.uN._V, {
        id: "breadcrumbs",
        hasPadding: true,
        spacingScale: 0.5,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadcrumbsContentContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadcrumbList, {
                itemScope: true,
                itemType: "https://schema.org/BreadcrumbList",
                children: breadcrumbs.map(function(breadcrumb, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadcrumbListItem, {
                        isLast: index === lastIndex,
                        breadcrumb: breadcrumb,
                        index: index
                    }, breadcrumb.name);
                })
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/PageNavigationLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/RentalCompaniesLegacy/RentalCompaniesLinks.styles.ts



var LinksList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", (0,src_define_property/* default */.Z)({
    target: "e1h8kj3w0"
}, "target", "e1h8kj3w0"))("margin-bottom:1rem;display:grid;column-gap:1rem;grid-template-columns:1;", src/* Theme.mq */.Q2.mq("sm"), "{grid-template-columns:repeat(3,1fr);}");
var LinkItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e1h8kj3w1"
}, "target", "e1h8kj3w1"))("display:flex;align-items:center;gap:0.625rem;margin-bottom:0.3125rem;");


;// CONCATENATED MODULE: ../../frontend/features/src/RentalCompaniesLegacy/RentalCompaniesLinks.tsx





var RentalCompaniesLinks = function RentalCompaniesLinks() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.rentalCompaniesLinksLegacy");
    var links = t.raw("links");
    if (!links) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SectionTitle */.ws.SectionTitle, {
                children: t("title")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinksList, {
                children: links.map(function(link) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkItem, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.Rating */.ws.Rating, {
                                value: link.rating
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Ui.TextLink */.Ui.hh, {
                                href: link.href,
                                text: link.text
                            })
                        ]
                    }, link.href);
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/RentalCompaniesLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/SupportInfoLegacy/SupportInfo.styles.ts



var ContactText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eilay7t0"
}, "target", "eilay7t0"))("margin-bottom:1rem;text-align:center;");
var PhoneNumberContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eilay7t1"
}, "target", "eilay7t1"))("padding-top:3rem;padding-bottom:3rem;display:flex;flex-direction:column;align-items:center;");
var PhoneNumberIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Phone_default()), (0,src_define_property/* default */.Z)({
    target: "eilay7t2"
}, "target", "eilay7t2"))("fill:currentcolor;width:1.5rem;height:1.5rem;");


;// CONCATENATED MODULE: ../../frontend/features/src/SupportInfoLegacy/ContactUs.tsx








var ContactUs = function ContactUs() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.supportInfoLegacy");
    var ref = (0,entities_src/* useSiteInfo */.Mj)(), featureToggles = ref.settings.featureToggles;
    if (featureToggles.hideInfoline) {
        return null;
    }
    var handleClick = function handleClick() {
        window.location.assign("tel:".concat(t("phoneNumber.link")));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* LayoutLegacy.PlainSegment */.uN._V, {
        id: "contact-us",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PhoneNumberContainer, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContactText, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                                children: t("contactUs.title")
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.PlainText */.ws.PlainText, {
                            children: t("contactUs.text")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                    variant: "secondary",
                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneNumberIcon, {}),
                    onClick: handleClick,
                    children: t("phoneNumber.display")
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/features/src/SupportInfoLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/ReferralLegacy/Referral.styles.tsx



var Referral_styles_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1tnw5ws0"
}, "target", "e1tnw5ws0"))("display:flex;flex-wrap:wrap;justify-content:space-between;gap:0.625rem;margin-bottom:2rem;", src/* Theme.mq */.Q2.mq("sm"), "{flex-wrap:no-wrap;}");
var Image = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", (0,src_define_property/* default */.Z)({
    target: "e1tnw5ws1"
}, "target", "e1tnw5ws1"))("width:100%;filter:brightness(70%);transition:all 0.3s;");
var ItemContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1tnw5ws2"
}, "target", "e1tnw5ws2"))("overflow:hidden;position:relative;display:block;box-sizing:border-box;flex-basis:100%;", src/* Theme.mq */.Q2.mq("sm"), "{flex-basis:calc(50% - 0.625rem);}&:hover img{transform:scale(1.1);filter:brightness(100%);}");
var LinkContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "e1tnw5ws3"
}, "target", "e1tnw5ws3"))("align-items:center;justify-content:center;display:flex;");
var ImageContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e1tnw5ws4"
}, "target", "e1tnw5ws4"))("display:inline-block;overflow:hidden;img{object-fit:cover;width:100%;height:auto;}")));
var ReferralHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", (0,src_define_property/* default */.Z)({
    target: "e1tnw5ws5"
}, "target", "e1tnw5ws5"))("background-color:transparent;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:1.375rem;font-weight:700;position:absolute;text-align:center;text-shadow:0 0 5px ", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";z-index:2;");


;// CONCATENATED MODULE: ../../frontend/features/src/ReferralLegacy/ReferralImageBox.tsx


var ReferralImageBox = function ReferralImageBox(param) {
    var title = param.title, href = param.href, imageSource = param.imageSource, imageFallback = param.imageFallback;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkContainer, {
            href: href,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralHeader, {
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                    src: imageSource,
                    alt: imageFallback
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/ReferralLegacy/Referral.tsx







var Referral = function Referral() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.referralsLegacy.referrals");
    var formatImage = src_legacy/* HostLegacy.useHost */.IW.useHost().formatImage;
    var camper = {
        title: t("items.camper.title"),
        href: t("items.camper.href"),
        imageSource: formatImage("/bm/global/graphic/image/flexsite/Camper_AdobeStock_294851778.jpg"),
        imageFallback: t("items.camper.imageFallback")
    };
    var transporter = {
        title: t("items.transporter.title"),
        href: t("items.transporter.href"),
        imageSource: formatImage("/bm/global/graphic/image/flexsite/Transporter_AdobeStock_242368361.jpg"),
        imageFallback: t("items.transporter.imageFallback")
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* UiLegacy.SectionTitle */.ws.SectionTitle, {
                children: t("title")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Referral_styles_Container, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralImageBox, (0,_object_spread/* default */.Z)({}, camper)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralImageBox, (0,_object_spread/* default */.Z)({}, transporter))
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/features/src/ReferralLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/features/src/index.ts






































/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ LandingPageLegacy_namespaceObject; },
  "Z": function() { return /* reexport */ SiteLegacy_namespaceObject; }
});

// NAMESPACE OBJECT: ../../frontend/pages/src/LandingPageLegacy/index.ts
var LandingPageLegacy_namespaceObject = {};
__webpack_require__.r(LandingPageLegacy_namespaceObject);
__webpack_require__.d(LandingPageLegacy_namespaceObject, {
  "mf": function() { return ErrorPage; },
  "fy": function() { return LandingPageLegacy_LandingPage_LandingPage; },
  "It": function() { return NewsletterPage; },
  "lg": function() { return WidgetPage; }
});

// NAMESPACE OBJECT: ../../frontend/pages/src/SiteLegacy/index.ts
var SiteLegacy_namespaceObject = {};
__webpack_require__.r(SiteLegacy_namespaceObject);
__webpack_require__.d(SiteLegacy_namespaceObject, {
  "z": function() { return BilligerMietwagenSite; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../frontend/features/src/index.ts + 225 modules
var src = __webpack_require__(9484);
// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var shared_src = __webpack_require__(2775);
;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/AffiliatePage.tsx







var AffiliatePage = function AffiliatePage(param) {
    var color = param.color;
    var theme = _object_spread_props(_object_spread({}, Theme.defaultTheme), {
        color: _object_spread_props(_object_spread({}, Theme.defaultTheme.color), {
            primary: color
        })
    });
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: theme,
        children: /*#__PURE__*/ _jsx(AffiliateSearchForm, {
            color: color
        })
    });
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../frontend/entities/src/index.ts + 176 modules
var entities_src = __webpack_require__(3631);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../frontend/entities/src/_legacy/index.ts + 34 modules
var _legacy = __webpack_require__(7857);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/index.ts + 80 modules
var src_legacy = __webpack_require__(6522);
;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/ContentModule.tsx


var ContentModule = function ContentModule(param) {
    var content = param.content, renderCondition = param.renderCondition;
    return renderCondition ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: content
    }) : null;
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/ContainerModule.tsx





var ContainerModule = function ContainerModule(param) {
    var id = param.id, modules = param.modules, renderCondition = param.renderCondition;
    var mods = Array.isArray(modules) ? modules : [
        modules
    ];
    return renderCondition ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src_legacy/* UiLegacy.Card */.ws.Card, {
        id: id,
        children: mods.map(function(module) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentModule, (0,src_object_spread/* default */.Z)({}, module));
        })
    }) : null;
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/ModuleType.ts
var ModuleType;
(function(ModuleType) {
    ModuleType["Columns"] = "columns";
    ModuleType["Container"] = "container";
    ModuleType["ContentModule"] = "content-module";
})(ModuleType || (ModuleType = {}));


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/ColumnsModule/ColumnContent.tsx






var ColumnContent = function ColumnContent(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: content.map(function(part) {
            switch(part.type){
                case ModuleType.Container:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContainerModule, (0,src_object_spread/* default */.Z)({}, part));
                case ModuleType.ContentModule:
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentModule, (0,src_object_spread/* default */.Z)({}, part));
                default:
                    return null;
            }
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/ColumnsModule/ColumnsModule.tsx





var RATIO = [
    _legacy/* LayoutLegacy.ColumnRatioOption.One */.uN.Eu.One,
    _legacy/* LayoutLegacy.ColumnRatioOption.Two */.uN.Eu.Two, 
];
var ColumnsModule = function ColumnsModule(param) {
    var _columns = (0,_sliced_to_array/* default */.Z)(param.columns, 2), column1Content = _columns[0], column2Content = _columns[1], id = param.id;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* LayoutLegacy.TwoColumns */.uN.VZ, {
        ratio: RATIO,
        id: id,
        children: function children(Column1, Column2) {
            return [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column1, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnContent, {
                        content: column1Content
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column2, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnContent, {
                        content: column2Content
                    })
                }), 
            ];
        }
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/ColumnsModule/index.ts


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/module/index.ts





;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/content/columns.ts

var buildColumns = function buildColumns(key, column1Content, column2Content) {
    return {
        columns: [
            column1Content,
            column2Content
        ],
        id: key,
        key: key,
        type: ModuleType.Columns
    };
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/content/container.ts

var buildContainer = function buildContainer(key, modules) {
    var renderCondition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return {
        id: key,
        key: key,
        modules: modules,
        renderCondition: renderCondition,
        type: ModuleType.Container
    };
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/content/contentModule.ts

var buildContentModule = function buildContentModule(key, content) {
    var renderCondition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return {
        content: content,
        key: key,
        renderCondition: renderCondition,
        type: ModuleType.ContentModule
    };
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/content/containerModule.ts


var buildContainerModule = function buildContainerModule(key, content) {
    var renderCondition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return {
        id: key,
        key: key,
        modules: [
            buildContentModule(key, content)
        ],
        type: ModuleType.Container,
        renderCondition: renderCondition
    };
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/content/builder.ts




var contentBuilders = {
    columns: buildColumns,
    container: buildContainer,
    containerModule: buildContainerModule,
    contentModule: buildContentModule
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/content/index.ts






;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/ContentModules.tsx







var ContentModules = function ContentModules(param) {
    var content = param.content;
    // @todo: validate unique keys
    var pageContent = content(contentBuilders);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* LayoutLegacy.PlainSegment */.uN._V, {
        id: "content-modules",
        hasPadding: true,
        spacingScale: 4,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* LayoutLegacy.ContentContainer */.uN.OO, {
            children: pageContent.map(function(part) {
                switch(part.type){
                    case ModuleType.Columns:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnsModule, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, part), {
                            id: part.key
                        }));
                    case ModuleType.Container:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContainerModule, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, part), {
                            id: part.key
                        }));
                    case ModuleType.ContentModule:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentModule, (0,src_object_spread/* default */.Z)({}, part));
                    default:
                        return null;
                }
            })
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/Body.tsx




var Body = function Body(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, content = param.content, suppliers = param.suppliers, stage = param.stage, _includeSearch = param.includeSearch, includeSearch = _includeSearch === void 0 ? true : _includeSearch;
    var language = entities_src/* Runtime.useLocale */.r_.useLocale().language;
    var ref = (0,src/* useShowAppBanner */.OJ)(language), isShowing = ref.isShowing, onClose = ref.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* PageLegacy.PageContentBase */.sE.EL, {
        children: [
            stage,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Suppliers.Suppliers */.$6.$, {
                title: title,
                suppliers: suppliers.content,
                includeSearch: includeSearch
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* PageNavigationLegacy.Breadcrumbs */.W6.O, {
                breadcrumbs: breadcrumbs.links
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentModules, {
                content: content
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SupportInfoLegacy.ContactUs */.bS.U, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        id: "fglayer",
                        role: "application"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* AppInstallBanner */.My, {
                        isShowing: isShowing,
                        onClose: onClose
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/CustomContentModule.tsx



var CustomContentModule_CustomContentModule = function CustomContentModule(param) {
    var slug = param.slug;
    var consent = analytics.useConsent();
    if (consent === analytics.CookieConsent.Enabled) {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("iframe", {
                width: "100%",
                src: "https://c0001.m1ca.de/billiger-mietwagen-slotmachine",
                title: slug,
                scrolling: "no",
                style: {
                    width: "100%",
                    height: "50rem",
                    border: "0"
                },
                children: "\xa0"
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        style: {
            overflow: "hidden",
            width: "100%",
            height: "50rem",
            border: "0",
            backgroundColor: "black"
        },
        children: "\xa0"
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/BodyLight.tsx



var BodyLight_BodyLight = function BodyLight(param) {
    var slug = param.slug;
    return /*#__PURE__*/ _jsx(PageLegacy.PageContentBase, {
        children: /*#__PURE__*/ _jsx(CustomContentModule, {
            slug: slug
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/body/index.ts



;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/Error.tsx






var ErrorContent = function ErrorContent(_param) /*#__PURE__*/ {
    var _content = _param.content, globalRating = _content.globalRating, statusCode = _content.statusCode, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            statusCode: statusCode
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content,
                    translationKey: "errorUsps"
                })), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/Newsletter.tsx






var NewsletterContent = function NewsletterContent(_param) /*#__PURE__*/ {
    var content = _param.content, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.NewsletterStage */.TL.cD, {}),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    translationKey: "newsletterUsps"
                })), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/Custom.tsx





var Custom_CustomContent = function CustomContent(_param) /*#__PURE__*/ {
    var commonProps = _extends({}, _param);
    return _jsx(BodyLight, _object_spread({}, commonProps));
};


// EXTERNAL MODULE: ../../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(2174);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js + 1 modules
var emotion_element_43c6fea0_browser_esm = __webpack_require__(7216);
;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/Home.tsx










var HomeContent = function HomeContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, offersByCategory = _content.offersByCategory, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var offersTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.offers");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            var ref1;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("offers", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: !!offersByCategory.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* OffersModule */.y7, {
                        content: offersByCategory.content,
                        translations: {
                            disclaimer: offersTranslations("disclaimer"),
                            disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                            durationFrom: offersTranslations("durationFrom"),
                            headline: offersTranslations("headline"),
                            pricePrefix: offersTranslations("pricePrefix"),
                            priceSuffix: offersTranslations("priceSuffix"),
                            searchButtonText: offersTranslations("searchButtonText"),
                            badgeText: offersTranslations("badge"),
                            offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                            carTypes: t.raw("offers.car.type")
                        }
                    })
                }), !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    groupLink: true,
                    hideSummaryDescription: true
                })) : null),
                containerModule("newsletter", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* NewsletterRegistrationLegacy.NewsletterRegistration */.qf.O, {
                    type: "index"
                })),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/General.tsx









var GeneralContent = function GeneralContent(_param) {
    var _content = _param.content, article = _content.article, country = _content.attributes.country, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, location = _content.location, offersByCategory = _content.offersByCategory, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var offersTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.offers");
    var makeSearchHandler = src/* SearchFormLegacy.useSubmitInitialSearch */.a9.useSubmitInitialSearch().makeSearchHandler;
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            var ref1, ref2;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                container("intro", [
                    contentModule("offers", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                        theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                        children: !!offersByCategory.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* OffersModule */.y7, {
                            content: offersByCategory.content,
                            onClick: makeSearchHandler((ref1 = stage.content.search) === null || ref1 === void 0 ? void 0 : ref1.location),
                            translations: {
                                badgeText: offersTranslations("badge"),
                                disclaimer: offersTranslations("disclaimerLocation"),
                                disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                                durationFrom: offersTranslations("durationFrom"),
                                headline: "".concat(offersTranslations("headlineLocation"), " ").concat(location.name),
                                pricePrefix: offersTranslations("pricePrefix"),
                                priceSuffix: offersTranslations("priceSuffix"),
                                searchButtonText: offersTranslations("searchButtonText"),
                                offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                                carTypes: t.raw("offers.car.type")
                            }
                        })
                    }), !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0 && !country), 
                ]),
                containerModule("feedbacks", (feedback === null || feedback === void 0 ? void 0 : (ref2 = feedback.content) === null || ref2 === void 0 ? void 0 : ref2.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    locationName: location.name
                })) : null),
                container("lists", [
                    contentModule("value-propositions", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.ValuePropositions */.B6.S, {})), 
                ]),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                })), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/Pillar.tsx








var PillarContent = function PillarContent(_param) {
    var _content = _param.content, article = _content.article, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content,
                    title: primaryHeadline
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/RentalCompany.tsx








var RentalCompanyContent = function RentalCompanyContent(_param) {
    var _content = _param.content, article = _content.article, introduction = _content.introduction, links = _content.links, offersByCategory = _content.offersByCategory, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var offersTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.offers");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    translationKey: "rentalCompanyUsps"
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("offers", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: !!offersByCategory.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* OffersModule */.y7, {
                        content: offersByCategory.content,
                        translations: {
                            badgeText: offersTranslations("badge"),
                            headline: offersTranslations("headline"),
                            disclaimer: offersTranslations("disclaimer"),
                            disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                            durationFrom: offersTranslations("durationFrom"),
                            pricePrefix: offersTranslations("pricePrefix"),
                            priceSuffix: offersTranslations("priceSuffix"),
                            searchButtonText: offersTranslations("searchButtonText"),
                            offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                            carTypes: t.raw("offers.car.type")
                        }
                    })
                }), !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0),
                container("referral-and-value-props", [
                    contentModule("referral", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ReferralLegacy.Referral */.Cl.G, {})),
                    contentModule("value-propositions", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.ValuePropositions */.B6.S, {})), 
                ]),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/SupplierRatings.tsx








var SupplierRatingsContent = function SupplierRatingsContent(_param) {
    var _content = _param.content, article = _content.article, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("rental-companies-links", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* RentalCompaniesLegacy.RentalCompaniesLinks */.Gn.L, {})),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/Transporter.tsx









var TransporterContent = function TransporterContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, location = _content.location, links = _content.links, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            var ref1;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    locationName: location === null || location === void 0 ? void 0 : location.name
                })) : null),
                contentModule("value-propositions", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.ValuePropositions */.B6.S, {})),
                container("content-modules", [
                    contentModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                        theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                            modules: article.segments,
                            translations: translations
                        })
                    })), 
                ]),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/ReviewsPillar.tsx









var ReviewsPillarContent = function ReviewsPillarContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, stage = _content.stage, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            var ref1;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    hideSummaryDescription: true,
                    largeReviews: true
                })) : null),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/common/Plain.tsx








/**
 * This is a page template that only renders search form, introduction and content modules.
 * Create for black friday promo page, but can be used for rendering other pages where we don't
 * want to render legacy elements. To use the template, add necessary slug in i18n/json/app/pageContent/[LOCALE].ts
 */ var PlainPage = function PlainPage(_param) {
    var _content = _param.content, article = _content.article, introduction = _content.introduction, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            return [
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                container("content-modules", [
                    contentModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                        theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                            modules: article.segments,
                            translations: translations
                        })
                    })), 
                ]), 
            ];
        },
        includeSearch: stage.content.includeSearch
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/LandingPage.tsx











var isPageOfType = function isPageOfType(contentPageType, props) {
    return props.content.type === contentPageType;
};
var LandingPage = function LandingPage(props) {
    if (isPageOfType("home", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomeContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("general", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GeneralContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("pillar", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PillarContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("reviewsPillar", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewsPillarContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("rentalCompany", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RentalCompanyContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("supplierRatings", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupplierRatingsContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("transporter", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransporterContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (isPageOfType("plain", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlainPage, (0,src_object_spread/* default */.Z)({}, props));
    }
    return null;
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/de/index.ts



;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/Home.tsx










var Home_HomeContent = function HomeContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, offersByCategory = _content.offersByCategory, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var offersTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.offers");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            var ref1;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("offers", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: !!offersByCategory.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* OffersModule */.y7, {
                        content: offersByCategory.content,
                        translations: {
                            badgeText: offersTranslations("badge"),
                            disclaimer: offersTranslations("disclaimer"),
                            disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                            durationFrom: offersTranslations("durationFrom"),
                            headline: offersTranslations("headline"),
                            pricePrefix: offersTranslations("pricePrefix"),
                            priceSuffix: offersTranslations("priceSuffix"),
                            searchButtonText: offersTranslations("searchButtonText"),
                            offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                            carTypes: t.raw("offers.car.type")
                        }
                    })
                }), !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    groupLink: true,
                    hideSummaryDescription: true
                })) : null),
                containerModule("test-winner", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.CarigamiGarantie */.LG.N, {})),
                containerModule("newsletter", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* NewsletterRegistrationLegacy.NewsletterRegistration */.qf.O, {
                    type: "index"
                })),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/General.tsx









var General_GeneralContent = function GeneralContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, location = _content.location, offersByCategory = _content.offersByCategory, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var offersTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.offers");
    var makeSearchHandler = src/* SearchFormLegacy.useSubmitInitialSearch */.a9.useSubmitInitialSearch().makeSearchHandler;
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            var ref1, ref2;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                container("intro", [
                    contentModule("offers", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                        theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                        children: !!offersByCategory.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* OffersModule */.y7, {
                            content: offersByCategory.content,
                            onClick: makeSearchHandler((ref1 = stage.content.search) === null || ref1 === void 0 ? void 0 : ref1.location),
                            translations: {
                                badgeText: offersTranslations("badge"),
                                disclaimer: offersTranslations("disclaimerLocation"),
                                disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                                durationFrom: offersTranslations("durationFrom"),
                                headline: "".concat(offersTranslations("headlineLocation"), " ").concat(location.name),
                                pricePrefix: offersTranslations("pricePrefix"),
                                priceSuffix: offersTranslations("priceSuffix"),
                                searchButtonText: offersTranslations("searchButtonText"),
                                offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                                carTypes: t.raw("offers.car.type")
                            }
                        })
                    }), !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0), 
                ]),
                containerModule("test-winner", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.CarigamiGarantie */.LG.N, {})),
                containerModule("feedbacks", (feedback === null || feedback === void 0 ? void 0 : (ref2 = feedback.content) === null || ref2 === void 0 ? void 0 : ref2.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    locationName: location.name
                })) : null),
                containerModule("value-propositions", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.ValuePropositions */.B6.S, {})),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/Global.tsx








var GlobalContent = function GlobalContent(_param) {
    var _content = _param.content, globalRating = _content.globalRating, links = _content.links, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/Pillar.tsx








var Pillar_PillarContent = function PillarContent(_param) {
    var _content = _param.content, article = _content.article, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/RentalCompany.tsx









var RentalCompany_RentalCompanyContent = function RentalCompanyContent(_param) {
    var _content = _param.content, article = _content.article, introduction = _content.introduction, links = _content.links, offersByCategory = _content.offersByCategory, globalRating = _content.globalRating, feedback = _content.feedback, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var offersTranslations = (0,next_intl_cjs_production_min.useTranslations)("features.offers");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            var ref1;
            return [
                /** @todo:PAGES-780 change for locale and company specific behaviour */ containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                container("offers", [
                    contentModule("offers", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                        theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                        children: !!offersByCategory.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* OffersModule */.y7, {
                            content: offersByCategory.content,
                            translations: {
                                badgeText: offersTranslations("badge"),
                                headline: offersTranslations("headline"),
                                disclaimer: offersTranslations("disclaimer"),
                                disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                                durationFrom: offersTranslations("durationFrom"),
                                pricePrefix: offersTranslations("pricePrefix"),
                                priceSuffix: offersTranslations("priceSuffix"),
                                searchButtonText: offersTranslations("searchButtonText"),
                                offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                                carTypes: t.raw("offers.car.type")
                            }
                        })
                    })), 
                ], !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    groupLink: true,
                    hideSummaryDescription: true
                })) : null),
                container("supplier-offers-and-value-propositions", [
                    contentModule("value-propositions", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.ValuePropositions */.B6.S, {})), 
                ]),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                contentModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/ReviewsPillar.tsx









var ReviewsPillar_ReviewsPillarContent = function ReviewsPillarContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, stage = _content.stage, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            var ref1;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    hideSummaryDescription: true,
                    largeReviews: true
                })) : null),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/SupplierRatings.tsx








var SupplierRatings_SupplierRatingsContent = function SupplierRatingsContent(_param) {
    var _content = _param.content, article = _content.article, globalRating = _content.globalRating, introduction = _content.introduction, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("rental-companies-links", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* RentalCompaniesLegacy.RentalCompaniesLinks */.Gn.L, {})),
                containerModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: article.segments,
                        translations: translations
                    })
                })), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/Transporter.tsx









var Transporter_TransporterContent = function TransporterContent(_param) {
    var _content = _param.content, article = _content.article, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, location = _content.location, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "content"
    ]);
    var t = (0,next_intl_cjs_production_min.useTranslations)("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, (0,src_object_spread/* default */.Z)({
        title: primaryHeadline,
        stage: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.Stage */.TL.Hf, {
            content: stage.content
        }),
        content: function content(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            var ref1;
            return [
                containerModule("usp", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.Usp */.B6.D, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("feedback", (feedback === null || feedback === void 0 ? void 0 : (ref1 = feedback.content) === null || ref1 === void 0 ? void 0 : ref1.items.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TrustLegacy.Feedback */.LG.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback.content), {
                    locationName: location === null || location === void 0 ? void 0 : location.name
                })) : null),
                container("offers-and-value-propositions", [
                    contentModule("value-propositions", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* BenefitsLegacy.ValuePropositions */.B6.S, {})), 
                ]),
                container("content-modules", [
                    contentModule("article", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                        theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                            modules: article.segments,
                            translations: translations
                        })
                    })), 
                ]),
                containerModule("linkLists", /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_element_43c6fea0_browser_esm.a, {
                    theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ContentArticle */.b3, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/LandingPage.tsx












var LandingPage_isPageOfType = function isPageOfType(contentPageType, props) {
    return props.content.type === contentPageType;
};
var LandingPage_LandingPage = function LandingPage(props) {
    if (LandingPage_isPageOfType("home", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Home_HomeContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("general", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(General_GeneralContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("global", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("pillar", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pillar_PillarContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("rentalCompany", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RentalCompany_RentalCompanyContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("reviewsPillar", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewsPillar_ReviewsPillarContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("supplierRatings", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupplierRatings_SupplierRatingsContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("transporter", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transporter_TransporterContent, (0,src_object_spread/* default */.Z)({}, props));
    }
    if (LandingPage_isPageOfType("plain", props)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlainPage, (0,src_object_spread/* default */.Z)({}, props));
    }
    return null;
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/fr/index.ts



;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/useLocalizedLandingPage.ts



var localizedComponents = {
    de: LandingPage,
    fr: LandingPage_LandingPage
};
var useLocalizedLandingPage = function useLocalizedLandingPage() {
    var language = src_legacy/* I18nLegacy.useLocale */.P7.useLocale().language;
    if (!Object.keys(localizedComponents).includes(language)) {
        /** @todo: this is an error, we should log it as high priority if it occurs */ return null;
    }
    return localizedComponents[language];
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/content/index.ts





;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/ErrorPage.tsx



var ErrorPage = function ErrorPage(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContent, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/NewsletterPage.tsx




var NewsletterPage = function NewsletterPage(props) {
    var content = props.content;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterContent, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/LandingPage.tsx




var LandingPageLegacy_LandingPage_LandingPage = function LandingPage(props) {
    var content = props.content;
    var LocalizedLandingPage = useLocalizedLandingPage();
    if (!content || !LocalizedLandingPage) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocalizedLandingPage, (0,src_object_spread/* default */.Z)({}, props));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/WidgetPage.tsx



var WidgetPage = function WidgetPage() {
    var baseImageUrl = entities_src/* Runtime.useHost */.r_.useHost().baseImageUrl;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StageLegacy.WidgetStage */.TL.oA, {
        baseImageUrl: baseImageUrl
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/CustomPage.tsx




var CustomPage = function CustomPage(props) {
    return /*#__PURE__*/ _jsx(CustomContent, _object_spread({}, props));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/LandingPageLegacy/index.ts







// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Menu.js
var Menu = __webpack_require__(608);
var Menu_default = /*#__PURE__*/__webpack_require__.n(Menu);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Comment.js
var Comment = __webpack_require__(1257);
var Comment_default = /*#__PURE__*/__webpack_require__.n(Comment);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/User.js
var User = __webpack_require__(6828);
var User_default = /*#__PURE__*/__webpack_require__.n(User);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/display/useHeader.ts




var useHeader = function useHeader() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.navigationLegacy.navigation");
    var openingTimesTooltip = (0,next_intl_cjs_production_min.useTranslations)("features.supportInfoLegacy")("openingTimes.tooltip.title");
    var router = (0,next_router.useRouter)();
    var ref = (0,src/* useLogin */.f0)(), loginError = ref.error;
    var ref1 = (0,entities_src/* useSiteInfo */.Mj)(), featureToggles = ref1.settings.featureToggles;
    var translationPrefix = featureToggles.floytPlus ? "floytPlus" : "legacy";
    var translations = {
        loginButton: {
            accountLinks: {
                myBookings: {
                    text: t("login.button.authenticated.menu.myBookings.text"),
                    href: t("login.button.authenticated.menu.myBookings.href")
                },
                myData: {
                    text: t("login.button.authenticated.menu.myData.text"),
                    href: t("login.button.authenticated.menu.myData.href")
                },
                myPayment: {
                    text: t("login.button.authenticated.menu.myPayment.text"),
                    href: t("login.button.authenticated.menu.myPayment.href")
                },
                logout: {
                    text: t("logout.text"),
                    href: t("logout.href")
                }
            },
            account: t("login.button.account"),
            label: t("login.button.label")
        },
        loginModal: {
            actionPath: t("login.href", {
                redirectPath: encodeURIComponent(router.asPath)
            }),
            error: {
                headline: loginError ? t("login.error.".concat(loginError, "Title")) : "",
                message: loginError ? t("login.error.".concat(loginError)) : "",
                passwordLostHref: t("passwordLost.href"),
                passwordLostLabel: t("login.error.resetPasswordLink"),
                resendConfirmUser: t("login.error.resendConfirmUser")
            },
            emailLabel: t("login.emailLabel"),
            loginTitle: t("login.title.".concat(translationPrefix)),
            loginButtonText: t("login.buttonText"),
            newUserHref: t("newUser.".concat(translationPrefix, ".href")),
            newUserText: t("newUser.".concat(translationPrefix, ".text")),
            noAccountText: t("login.noAccountText"),
            passwordLabel: t("login.passwordLabel"),
            passwordLostHref: t("passwordLost.href"),
            passwordLostText: t("passwordLost.text"),
            submitText: t("login.submitText")
        },
        closeMenuLabel: t("header.closeLabel"),
        menuLabel: t("header.menuLabel"),
        openingTimesTooltip: openingTimesTooltip,
        membership: {
            welcomeSubtitle: t("login.membership.".concat(translationPrefix, ".welcomeSubtitle")),
            loginButton: t("login.membership.".concat(translationPrefix, ".loginButton")),
            joinButton: t("login.membership.".concat(translationPrefix, ".joinButton")),
            benefitsSubtitle: t("login.membership.".concat(translationPrefix, ".benefitsSubtitle")),
            benefits: t.raw("login.membership.".concat(translationPrefix, ".benefits")),
            signUpLink: t("newUser.".concat(translationPrefix, ".href")),
            moreInfoLink: featureToggles.floytPlus ? {
                text: t("login.membership.floytPlus.moreInfoLink.text"),
                href: t("login.membership.floytPlus.moreInfoLink.href")
            } : undefined
        }
    };
    return {
        getLinks: function getLinks(staticLinks) {
            return staticLinks.filter(function(param) {
                var type = param.type;
                return type === "main";
            });
        },
        translations: translations
    };
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/display/Content.style.ts



var StyledHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Header */.h4, (0,_define_property/* default */.Z)({
    target: "ej6paxa0"
}, "target", "ej6paxa0"))("background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");


;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/display/Content.tsx














var ContactMenu = function ContactMenu() {
    var t = (0,next_intl_cjs_production_min.useTranslations)("features.supportInfoLegacy");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* OpeningTimes */.E5, {
        showVoucherInfo: true,
        translations: {
            buttonLabel: t("newDesign.buttonLabel"),
            buttonHref: t("newDesign.buttonHref"),
            title: t("newDesign.title"),
            voucher: {
                buttonLabel: t("newDesign.voucher.buttonLabel"),
                text: t("newDesign.voucher.text")
            }
        }
    });
};
var LoginMobileMenu = function LoginMobileMenu() {
    var ref = (0,src/* useLogin */.f0)(), isLoggedIn = ref.isLoggedIn, showMobileLogin = ref.showMobileLogin, setShowMobileLogin = ref.setShowMobileLogin;
    var translations = useHeader().translations;
    var handleLoginClick = function handleLoginClick(event) {
        event.preventDefault();
        setShowMobileLogin(true);
    };
    var handleSignUpClick = function handleSignUpClick() {
        window.location.assign(translations.membership.signUpLink);
    };
    if (isLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Header.LoggedInActions */.h4.LoggedInActions, {
            translations: translations.loginButton
        });
    }
    return showMobileLogin ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LoginForm */.U0, {
        translations: translations.loginModal
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* MembershipPopover */.sm, {
        translations: translations.membership,
        handleLoginClick: handleLoginClick,
        handleSignUpClick: handleSignUpClick
    });
};
var makeHamburgerMenu = function makeHamburgerMenu(links) {
    return function(handleCloseMenu) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Header.Navigation */.h4.Navigation, {
            links: links,
            mode: "mobile",
            onAction: handleCloseMenu
        });
    };
};
var ContentDisplay = function ContentDisplay(param) {
    var children = param.children, page = param.page;
    var ref;
    var ref1 = useHeader(), getLinks = ref1.getLinks, translations = ref1.translations;
    var headerLinks = getLinks(page.content.navigation.staticLinks);
    var setShowMobileLogin = (0,src/* useLogin */.f0)().setShowMobileLogin;
    var ref2 = (0,entities_src/* useSiteInfo */.Mj)(), _settings = ref2.settings, hideInfoline = _settings.featureToggles.hideInfoline;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* PageLegacy.PageBase */.sE._x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_element_43c6fea0_browser_esm.a, {
                theme: shared_src/* Theme.defaultTheme */.Q2.defaultTheme,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeader, {
                        desktopActions: [
                            {
                                key: "infoline",
                                component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Header.Separator */.h4.Separator, {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Header.InfolinePopoverButton */.h4.InfolinePopoverButton, {
                                            popupContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactMenu, {})
                                        })
                                    ]
                                }),
                                hide: hideInfoline !== false
                            },
                            {
                                key: "login",
                                component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Header.LoginButton */.h4.LoginButton, {
                                    translations: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, translations.loginButton), {
                                        membership: translations.membership
                                    })
                                })
                            }, 
                        ],
                        desktopLinks: headerLinks,
                        mobileMenus: [
                            {
                                id: "mobile-menu-contact",
                                closeLabel: translations.closeMenuLabel,
                                iconLabel: translations.openingTimesTooltip,
                                content: ContactMenu,
                                icon: (Comment_default()),
                                hide: hideInfoline !== false
                            },
                            {
                                id: "mobile-menu-account",
                                closeLabel: translations.closeMenuLabel,
                                iconLabel: translations.loginButton.account,
                                content: LoginMobileMenu,
                                icon: (User_default()),
                                onClose: function onClose() {
                                    return setShowMobileLogin(false);
                                }
                            },
                            {
                                id: "mobile-menu-hamburger",
                                closeLabel: translations.closeMenuLabel,
                                iconLabel: translations.menuLabel,
                                content: makeHamburgerMenu(headerLinks),
                                icon: (Menu_default())
                            }, 
                        ],
                        children: ((ref = page.content) === null || ref === void 0 ? void 0 : ref.infoBanner) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InfoBanner */.Xx, (0,src_object_spread/* default */.Z)({}, page.content.infoBanner))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LoginModal */._A, {
                        translations: translations.loginModal
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* PageLegacy.PageFooter */.sE.WA, {})
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/display/Layoutless.tsx


var LayoutlessDisplay = function LayoutlessDisplay(param) {
    var children = param.children, page = param.page;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* PageLegacy.PageBase */.sE._x, {
        isAffiliate: (page === null || page === void 0 ? void 0 : page.color) !== undefined,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/display/index.ts



;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/BilligerMietwagenSite.tsx
/* eslint-disable react/no-unused-prop-types */ 






var isContentPage = function isContentPage(props) {
    return props.type === "content";
};
var BilligerMietwagenSite = function BilligerMietwagenSite(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    entities_src/* analytics.gtm.usePageView */.co.gtm.usePageView();
    entities_src/* analytics.gtm.useReportWebVitals */.co.gtm.useReportWebVitals();
    return isContentPage(props) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentDisplay, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: children
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutlessDisplay, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: children
    }));
};


;// CONCATENATED MODULE: ../../frontend/pages/src/SiteLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/pages/src/index.ts






/***/ }),

/***/ 6729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ClientContextProvider": function() { return /* reexport */ ClientContextProvider; },
  "I18nContext": function() { return /* reexport */ I18nContext; },
  "MetaInformationContext": function() { return /* reexport */ MetaInformationContext; },
  "SitePropsContext": function() { return /* reexport */ SitePropsContext; },
  "guardContext": function() { return /* reexport */ guardContext; },
  "useClientContext": function() { return /* reexport */ useClientContext; },
  "useMetaInformationProps": function() { return /* reexport */ useMetaInformationProps; },
  "useSiteProps": function() { return /* reexport */ useSiteProps; },
  "useTranslations": function() { return /* reexport */ useTranslations; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../frontend/shared/src/Context/clientContext.ts

var clientContext = (0,react.createContext)({});


;// CONCATENATED MODULE: ../../frontend/shared/src/Context/ClientContextProvider.ts

var ClientContextProvider = clientContext.Provider;


;// CONCATENATED MODULE: ../../frontend/shared/src/Context/guardContextResult.ts
var guardContext = function guardContext(key, result) {
    if (!result.hasContext) {
        throw new Error("The requested data is not been provided in the context (contextKey: ".concat(key, ")"));
    }
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Context/MetaInformationContext.ts

/** @todo: Integrate into `ClientContext` */ var MetaInformationContext = (0,react.createContext)(undefined);
var useMetaInformationProps = function useMetaInformationProps() {
    var context = (0,react.useContext)(MetaInformationContext);
    if (context === undefined) {
        throw new Error("useMetaIntormationProps must be used within a MetaInformationContext.Provider");
    }
    return context;
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Context/SitePropsContext.ts

/** @todo: Integrate into `ClientContext` */ var SitePropsContext = (0,react.createContext)(undefined);
var useSiteProps = function useSiteProps() {
    var context = (0,react.useContext)(SitePropsContext);
    if (context === undefined) {
        throw new Error("useSiteProps must be used within a SitePropsContext.Provider");
    }
    return context;
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Context/useClientContext.ts


var useClientContext = function useClientContext(key) {
    var context = (0,react.useContext)(clientContext);
    if (!Object.prototype.hasOwnProperty.call(context, key)) {
        return {
            hasContext: false
        };
    }
    return {
        hasContext: true,
        value: context[key]
    };
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Context/i18nContext.ts

var I18nContext = (0,react.createContext)(undefined);
var useTranslations = function useTranslations() {
    var context = (0,react.useContext)(I18nContext);
    if (context === undefined) {
        throw new Error("useTranslations must be used within an I18nContext.Provider");
    }
    return context;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Context/index.ts








/***/ }),

/***/ 2408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wy": function() { return /* reexport */ BodyBoldText; },
  "Ac": function() { return /* reexport */ BodyText; },
  "nL": function() { return /* reexport */ Heading1; },
  "XJ": function() { return /* reexport */ Heading2; },
  "aC": function() { return /* reexport */ Heading3; },
  "k8": function() { return /* reexport */ Heading4; },
  "by": function() { return /* reexport */ Heading5; },
  "Cd": function() { return /* reexport */ Heading6; },
  "G9": function() { return /* reexport */ InteractiveText; },
  "MQ": function() { return /* reexport */ SecondaryText; },
  "QE": function() { return /* reexport */ Subtitle; },
  "Q1": function() { return /* reexport */ TertiaryText; },
  "Hp": function() { return /* reexport */ bodyBold; },
  "Tp": function() { return /* reexport */ interactiveText; },
  "wz": function() { return /* reexport */ secondaryText; }
});

// UNUSED EXPORTS: body, subtitle

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../frontend/shared/src/Theme/index.ts + 8 modules
var Theme = __webpack_require__(6321);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../frontend/shared/src/Text/textUtils.ts

var mapColor = function mapColor(theme) {
    var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    return ({
        green: theme.color.primary,
        grey: (0,polished_esm/* darken */._j)(0.46, (0,polished_esm/* desaturate */.vG)(0.32, theme.color.primaryHighlight)),
        default: (0,polished_esm/* darken */._j)(0.84, theme.color.natural10),
        white: theme.color.natural0,
        orange: theme.color.natural70,
        error: (0,polished_esm/* darken */._j)(0.3, (0,polished_esm/* saturate */.p_)(0.51, (0,polished_esm/* complement */.Cy)(theme.color.secondaryHighlight))),
        current: "currentcolor"
    })[color];
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/BodyText/BodyText.styles.ts





var body = function body(param) {
    var textColor = param.textColor, theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:1.063rem;font-weight:400;line-height:1.412em;", (0,Theme.mq)("lg"), "{font-size:1.125rem;line-height:1.333em;}color:", mapColor(theme, textColor), ";");
};
var BodyTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,_define_property/* default */.Z)({
    target: "e1u2kiro0"
}, "target", "e1u2kiro0"))(body);
var InlineBodyTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,_define_property/* default */.Z)({
    target: "e1u2kiro1"
}, "target", "e1u2kiro1"))(body);


// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ../../frontend/shared/src/Text/BodyText/BodyText.tsx


var BodyText = function BodyText(param) {
    var children = param.children, className = param.className, _inline = param.inline, inline = _inline === void 0 ? false : _inline, textColor = param.textColor;
    var Wrapper = inline ? InlineBodyTextWrapper : BodyTextWrapper;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        className: className,
        textColor: textColor,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/BodyText/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/Text/BodyBoldText/BodyBoldText.styles.ts





var bodyBold = function bodyBold(param) {
    var textColor = param.textColor, theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:1.063rem;font-weight:600;line-height:1.412em;", (0,Theme.mq)("lg"), "{font-size:1.125rem;line-height:1.333em;}color:", mapColor(theme, textColor), ";");
};
var BodyBoldTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,_define_property/* default */.Z)({
    target: "ehobp8f0"
}, "target", "ehobp8f0"))(bodyBold);
var InlineBodyBoldTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,_define_property/* default */.Z)({
    target: "ehobp8f1"
}, "target", "ehobp8f1"))(bodyBold);


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/BodyBoldText/BodyBoldText.tsx


var BodyBoldText = function BodyBoldText(param) {
    var children = param.children, className = param.className, _inline = param.inline, inline = _inline === void 0 ? false : _inline, textColor = param.textColor;
    var Wrapper = inline ? InlineBodyBoldTextWrapper : BodyBoldTextWrapper;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        className: className,
        textColor: textColor,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/BodyBoldText/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/Text/Heading/Heading.styles.ts




// @todo: Use heading sizes from theme config via `props.theme.fontSize`
var Heading1 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", (0,_define_property/* default */.Z)({
    target: "eyz28g40"
}, "target", "eyz28g40"))(bodyBold, "  font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:", function(param) {
    var theme = param.theme;
    return theme.fontWeight.heading;
}, ";font-size:2.125rem;line-height:1.235em;padding-top:0.75rem;padding-bottom:0.75rem;", (0,Theme.mq)("lg"), "{font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.xl.size;
}, ";line-height:1.188em;}");
var Heading2 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", (0,_define_property/* default */.Z)({
    target: "eyz28g41"
}, "target", "eyz28g41"))(bodyBold, "  font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:", function(param) {
    var theme = param.theme;
    return theme.fontWeight.heading;
}, ";font-size:1.688rem;line-height:1.259em;padding-top:0.75rem;padding-bottom:0.75rem;", (0,Theme.mq)("lg"), "{font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.lg.size;
}, ";line-height:1.25em;}");
var Heading3 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", (0,_define_property/* default */.Z)({
    target: "eyz28g42"
}, "target", "eyz28g42"))(bodyBold, "  font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:", function(param) {
    var theme = param.theme;
    return theme.fontWeight.heading;
}, ";font-size:1.375rem;line-height:1.273em;padding-top:0.75rem;padding-bottom:0.75rem;", (0,Theme.mq)("lg"), "{font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.md.size;
}, ";line-height:1.4em;}");
var Heading4 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h4", (0,_define_property/* default */.Z)({
    target: "eyz28g43"
}, "target", "eyz28g43"))(bodyBold);
var Heading5 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h5", (0,_define_property/* default */.Z)({
    target: "eyz28g44"
}, "target", "eyz28g44"))(bodyBold);
var Heading6 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h6", (0,_define_property/* default */.Z)({
    target: "eyz28g45"
}, "target", "eyz28g45"))(bodyBold);


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/Heading/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/Subtitle/Subtitle.styles.ts





var subtitle = function subtitle(param) {
    var textColor = param.textColor, theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:600;color:", mapColor(theme, textColor), ";font-size:1.313rem;line-height:1.238em;", (0,Theme.mq)("lg"), "{font-size:", theme.fontSize.md.size, ";font-weight:", theme.fontWeight.heading, ";line-height:1.3rem;}");
};
var SubtitleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e1afh08i0"
}, "target", "e1afh08i0"))(subtitle);


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/Subtitle/Subtitle.tsx


var Subtitle = function Subtitle(param) {
    var children = param.children, className = param.className, textColor = param.textColor, _as = param.as, as = _as === void 0 ? "div" : _as;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubtitleWrapper, {
        as: as,
        className: className,
        textColor: textColor,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/Subtitle/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/Text/InteractiveText/InteractiveText.styles.ts





var getCss = function getCss(size) {
    switch(size){
        case "small":
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:", "0.938rem", ";line-height:", "1.6em", ";", (0,Theme.mq)("lg"), "{font-size:", "1rem", ";line-height:", "1.25em", ";}");
        case "xs":
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:", "0.75rem", ";line-height:", "1.5em", ";", (0,Theme.mq)("lg"), "{font-size:", "0.875rem", ";line-height:", "1.429em", ";}");
        default:
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:", "1.125rem", ";line-height:", "1.333em", ";");
    }
};
var interactiveText = function interactiveText(param) {
    var textColor = param.textColor, theme = param.theme, _size = param.size, size = _size === void 0 ? "normal" : _size;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-family:", theme.fontFamily.alternate, ";font-weight:700;color:", mapColor(theme, textColor), ";", getCss(size));
};
var InteractiveWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,_define_property/* default */.Z)({
    target: "e9o9emm0"
}, "target", "e9o9emm0"))(interactiveText);
var InteractiveInlineWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,_define_property/* default */.Z)({
    target: "e9o9emm1"
}, "target", "e9o9emm1"))(interactiveText);


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/InteractiveText/InteractiveText.tsx


var InteractiveText = function InteractiveText(param) {
    var children = param.children, className = param.className, id = param.id, textColor = param.textColor, _size = param.size, size = _size === void 0 ? "normal" : _size, inline = param.inline, propertyName = param.propertyName;
    var Wrapper = inline ? InteractiveInlineWrapper : InteractiveWrapper;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        id: id,
        itemProp: propertyName,
        className: className,
        size: size,
        textColor: textColor,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/InteractiveText/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/Text/SecondaryText/SecondaryText.styles.ts





var secondaryText = function secondaryText(param) {
    var textColor = param.textColor, theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:0.875rem;line-height:1.429em;", (0,Theme.mq)("lg"), "{font-size:0.938rem;line-height:1.467em;font-weight:600;}color:", mapColor(theme, textColor), ";");
};
var SecondaryTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,_define_property/* default */.Z)({
    target: "e1am9zju0"
}, "target", "e1am9zju0"))(function(param) {
    var theme = param.theme, textColor = param.textColor;
    return secondaryText({
        theme: theme,
        textColor: textColor
    });
});
var InlineSecondaryTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,_define_property/* default */.Z)({
    target: "e1am9zju1"
}, "target", "e1am9zju1"))(function(param) {
    var theme = param.theme, textColor = param.textColor;
    return secondaryText({
        theme: theme,
        textColor: textColor
    });
});


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/SecondaryText/SecondaryText.tsx


var SecondaryText = function SecondaryText(param) {
    var children = param.children, _inline = param.inline, inline = _inline === void 0 ? false : _inline, className = param.className, textColor = param.textColor;
    var Wrapper = inline ? InlineSecondaryTextWrapper : SecondaryTextWrapper;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        className: className,
        textColor: textColor,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/SecondaryText/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/Text/TertiaryText/TertiaryText.styles.ts




var TertiaryTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,_define_property/* default */.Z)({
    target: "efjwu630"
}, "target", "efjwu630"))("font-size:0.813rem;font-weight:600;text-transform:uppercase;line-height:1.538em;", (0,Theme.mq)("lg"), "{font-size:0.938rem;line-height:1.467em;}color:", function(param) {
    var textColor = param.textColor, theme = param.theme;
    return mapColor(theme, textColor);
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/TertiaryText/TertiaryText.tsx


var TertiaryText = function TertiaryText(param) {
    var children = param.children, className = param.className, textColor = param.textColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TertiaryTextWrapper, {
        className: className,
        textColor: textColor,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/TertiaryText/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Text/index.ts









/***/ }),

/***/ 6321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Color": function() { return /* reexport */ Color; },
  "colors": function() { return /* reexport */ colors; },
  "defaultTheme": function() { return /* reexport */ theme; },
  "getBreakpoint": function() { return /* reexport */ getBreakpoint; },
  "getLinearGradient": function() { return /* reexport */ getLinearGradient; },
  "gradients": function() { return /* reexport */ gradients; },
  "mq": function() { return /* reexport */ mq; },
  "mqFactory": function() { return /* reexport */ mqFactory; },
  "useIsMobileTouchDevice": function() { return /* reexport */ useIsMobileTouchDevice; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/theme.ts
// common type declaration for themes used by emotion https://emotion.sh/docs/typescript#define-a-theme
var colors = [
    "primary",
    "primary70",
    "primary100",
    "primaryHighlight",
    "primaryGradient1",
    "secondary100",
    "secondary70",
    "secondaryHighlight",
    "natural100",
    "natural70",
    "natural50",
    "natural40",
    "natural30",
    "natural20",
    "natural10",
    "natural0",
    "info",
    "error",
    "warning",
    "success",
    /** @deprecated */ "warning20", 
];
var gradients = [
    "green",
    "orange",
    "mint",
    "brand",
    "natural",
    "warning",
    "naturalLight", 
];
var breakpoints = (/* unused pure expression or super */ null && ([
    "xxs",
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]));
var spacingKeys = (/* unused pure expression or super */ null && ([
    0,
    5,
    10,
    20,
    30,
    40,
    50,
    60,
    70,
    80,
    90,
    100,
    110,
    120,
    130,
    140,
    150, 
]));

;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/color.ts




/**
 * Color shortcut function, allows access to color property via `Theme.Color.primary100`
 */ var Color = colors.reduce(function(previousValue, key) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousValue), (0,_define_property/* default */.Z)({}, key, function(param) {
        var theme = param.theme;
        var ref;
        return (ref = theme.color) === null || ref === void 0 ? void 0 : ref[key];
    }));
}, {});


;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/gradients.ts
var getLinearGradient = function getLinearGradient(gradient) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0deg";
    if (gradient === null || gradient === void 0 ? void 0 : gradient.via) {
        return "linear-gradient(".concat(direction, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.from, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.via, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.to, ")");
    }
    return "linear-gradient(".concat(direction, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.from, ", ").concat(gradient === null || gradient === void 0 ? void 0 : gradient.to, ")");
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/mediaQueries/breakpoints.ts
var breakpoints_breakpoints = [
    {
        name: "sm",
        width: 576
    },
    {
        name: "md",
        width: 768
    },
    {
        name: "lg",
        width: 992
    },
    {
        name: "xl",
        width: 1280
    },
    {
        name: "xxl",
        width: 1920
    }, 
];


;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/mediaQueries/mediaQueries.ts

// helper to deconstruct mq string
var getMqData = function getMqData(query, breakpoints) {
    var parts = query.split("-");
    var bpIndex = breakpoints.findIndex(function(bp) {
        return bp.name === parts[0];
    });
    if (bpIndex === -1) return false;
    var lowEnd = breakpoints[bpIndex].width;
    var highEnd = bpIndex < breakpoints.length - 1 ? breakpoints[bpIndex + 1].width : null;
    return {
        parts: parts,
        bpIndex: bpIndex,
        lowEnd: lowEnd,
        highEnd: highEnd
    };
};
/**
 * Generate mediaquery to use in CSS
 *
 * @param  {string} name Media query name (straight viewport or with optional '-only' suffix)
 * @param {BreakPoints} [breakpoints=defaultBreakpoints] Optionally override default breakpoints
 * @return {string}      Generated media query string ready to insert into CSS
 */ var mq = function mq(name) {
    var breakpoints = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : breakpoints_breakpoints;
    var mqData = getMqData(name, breakpoints);
    if (!mqData) return "@media screen, print"; // failing gracefully
    if (mqData.parts[1] && mqData.parts[1] === "only") {
        return !mqData.highEnd ? "@media (min-width: ".concat(mqData.lowEnd, "px)") : "@media (min-width: ".concat(mqData.lowEnd, "px) and (max-width: ").concat(mqData.highEnd - 1, "px)");
    }
    return "@media (min-width: ".concat(mqData.lowEnd, "px)");
};
/**
 * Generate mq function with overridden breakpoints
 * @param breakpoints the breakpoints to override the default breakpoints
 * @returns a function to generate a mediaquery to use in CSS
 */ var mqFactory = function mqFactory(breakpoints) {
    return function(name) {
        return mq(name, breakpoints);
    };
};
/**
 * Breakpoint getter, i.e. if you need the width value for a specific breakpoint in other configs
 *
 * @param  {string} name Breakpoint name (i.e. "lg")
 * @return {int}         Width of breakpoint
 */ var getBreakpoint = function getBreakpoint(name) {
    var breakpoints = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : breakpoints_breakpoints;
    var ref;
    return (ref = breakpoints.find(function(bp) {
        return bp.name === name;
    })) === null || ref === void 0 ? void 0 : ref.width;
};


// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/mediaQueries/useIsMobileTouchDevice.ts


// Check for mobile devices that have virtual keyboard
var useIsMobileTouchDevice = function useIsMobileTouchDevice() {
    var isMobileTouchDevice = (0,useMedia/* default */.Z)("(max-width: ".concat(getBreakpoint("md"), "px) and (pointer:coarse)"), false);
    return isMobileTouchDevice;
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/mediaQueries/index.ts



// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/default.ts


/**
 * Default theme settings for all sites, used by Emotion’s `ThemeProvider`.
 * Can be overridden by the corresponding `styles/themes/theme.ts` file per site.
 */ var defaultBreakpoints = [
    {
        name: "sm",
        width: 576
    },
    {
        name: "md",
        width: 768
    },
    {
        name: "lg",
        width: 992
    },
    {
        name: "xl",
        width: 1280
    },
    {
        name: "xxl",
        width: 1920
    }, 
];
var theme = {
    color: {
        // brand colours
        primary: "#00977d",
        primary70: (0,polished_esm/* lighten */.$n)(0.04, "#00977d"),
        primary100: "#006e5b",
        primaryHighlight: "#cceae5",
        secondary100: "#222",
        secondaryHighlight: "#79b7ac",
        primaryGradient1: "#6ec2b7",
        // natural colours
        natural100: "#000",
        natural70: "#ff4b19",
        natural50: "#cecece",
        natural40: "#a3a3a3",
        natural30: "#747474",
        natural20: "#eee",
        natural10: "#f8f8f8",
        natural0: "#fff",
        // notification colours
        info: "#3694ba",
        warning: "#ffa800",
        error: "#d63f24",
        success: "#75b21b",
        // alert colours
        warning20: "#F7D9D3"
    },
    gradient: {
        green: {
            from: "#0D8C76",
            to: "#06705F"
        },
        orange: {
            from: "#FF4B19",
            to: "#FF8664"
        },
        mint: {
            from: "#6EC2B7",
            to: "#4FBBAD"
        },
        brand: {
            from: "#FF4B19",
            via: "#E4A5A3",
            to: "#6CC2B6"
        },
        natural: {
            from: "#B6BFC1",
            to: "#fff"
        },
        warning: {
            from: "#FFE8EB",
            to: "#fff"
        },
        naturalLight: {
            from: "#f5f5f5",
            to: "#fff"
        }
    },
    fontFamily: {
        default: "'Source Sans Pro', ui-sans-serif, system-ui, sans-serif",
        alternate: "Quicksand, Bryant, 'Proxima Nova Soft', Arial Rounded MT Bold, sans-serif"
    },
    fontWeight: {
        body: "normal",
        heading: "bold"
    },
    fontSize: {
        xl: {
            size: "2.666rem",
            lineHeight: "1.4"
        },
        lg: {
            size: "2.111rem",
            lineHeight: "1.333"
        },
        md: {
            size: "1.555rem",
            lineHeight: "1.3"
        },
        sm: {
            size: "1rem",
            lineHeight: "1.25"
        },
        xs: {
            size: "0.888rem",
            lineHeight: "1.2"
        },
        xxs: {
            size: "0.833rem",
            lineHeight: "1"
        }
    },
    baseSize: "18px",
    spacing: {
        0: "0",
        5: "0.125rem",
        10: "0.25rem",
        20: "0.5rem",
        30: "0.75rem",
        40: "1rem",
        50: "1.5rem",
        60: "2rem",
        70: "2.5rem",
        80: "3rem",
        90: "4rem",
        100: "4.5rem",
        110: "6rem",
        120: "7rem",
        130: "8rem",
        140: "9rem",
        150: "10rem"
    },
    borderRadius: {
        none: "0",
        xxs: "0.125rem",
        xs: "0.25rem",
        sm: "0.5rem",
        md: "0.75rem",
        lg: "1.5rem"
    },
    boxShadow: {
        sm: "0 0.375rem 1.25rem rgb(0 0 0 / 6%)",
        md: "0 0.625rem 1.5rem rgb(0 0 0 / 8%)",
        lg: "0 0.625rem 2rem rgb(0 0 0 / 14%)"
    },
    backgroundImage: {
        // @see https://www.scien.cx/2021/11/10/adding-radial-gradients-to-tailwind-css/
        none: "none",
        "gradient-to-t": "linear-gradient(0deg, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(180deg, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(90deg, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(270deg, var(--tw-gradient-stops))",
        "gradient-radial": "radial-gradient(ellipse at center, var(--tw-gradient-stops))",
        "gradient-radial-at-t": "radial-gradient(ellipse at top, var(--tw-gradient-stops))",
        "gradient-radial-at-b": "radial-gradient(ellipse at bottom, var(--tw-gradient-stops))",
        "gradient-radial-at-l": "radial-gradient(ellipse at left, var(--tw-gradient-stops))",
        "gradient-radial-at-r": "radial-gradient(ellipse at right, var(--tw-gradient-stops))",
        "gradient-radial-at-tl": "radial-gradient(ellipse at top left, var(--tw-gradient-stops))",
        "gradient-radial-at-tr": "radial-gradient(ellipse at top right, var(--tw-gradient-stops))",
        "gradient-radial-at-bl": "radial-gradient(ellipse at bottom left, var(--tw-gradient-stops))",
        "gradient-radial-at-br": "radial-gradient(ellipse at bottom right, var(--tw-gradient-stops))"
    },
    mq: mqFactory(defaultBreakpoints)
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Theme/index.ts







/***/ }),

/***/ 3181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ ErrorMessage; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/ErrorMessage/ErrorMessage.styles.ts


var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,_define_property/* default */.Z)({
    target: "e1memdmb0"
}, "target", "e1memdmb0"))("display:block;position:relative;margin:0.5em 1rem 1rem;font-size:0.875rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.error;
}, ";cursor:", function(param) {
    var htmlFor = param.htmlFor;
    return htmlFor ? "pointer" : "";
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/ErrorMessage/ErrorMessage.tsx





var ErrorMessage = function ErrorMessage(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        role: "alert",
        "aria-live": "polite",
        children: children
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/ErrorMessage/index.ts



/***/ }),

/***/ 8145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ IconButton; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/IconButton/IconButton.styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var sizes = {
    small: 16,
    medium: 24,
    large: 32
};
var Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,_define_property/* default */.Z)({
    target: "e6nxdc40"
}, "target", "e6nxdc40"))("display:inline-flex;flex-shrink:0;margin:0;padding:0;border:0;outline:0;width:", function(param) {
    var size = param.size;
    return "".concat(sizes[size], "px");
}, ";height:", function(param) {
    var size = param.size;
    return "".concat(sizes[size], "px");
}, ";text-decoration:underline;color:inherit;background:none;fill:currentcolor;cursor:pointer;");
var IconBackground = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e6nxdc41"
}, "target", "e6nxdc41"))("border-radius:50%;display:flex;padding:4px;margin:-4px;", function(param) {
    var selected = param.selected, theme = param.theme;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), selected && (0,polished_esm/* transparentize */.DZ)(0.8, theme.color.primary || "#FFFFFF"));
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/IconButton/IconButton.tsx





var IconButton = function IconButton(_param) /*#__PURE__*/ {
    var id = _param.id, Icon = _param.icon, title = _param.title, className = _param.className, onClick = _param.onClick, _size = _param.size, size = _size === void 0 ? "medium" : _size, _selected = _param.selected, selected = _selected === void 0 ? false : _selected, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "icon",
        "title",
        "className",
        "onClick",
        "size",
        "selected"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: id,
        type: "button",
        size: size,
        title: title,
        className: className,
        onClick: onClick
    }, rest), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconBackground, {
            id: "".concat(id, "-bg"),
            selected: selected,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                id: "".concat(id, "-icon"),
                width: "100%",
                height: "100%"
            })
        })
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/IconButton/index.ts



/***/ }),

/***/ 4786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Overlay; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/micro-task.js
var micro_task = __webpack_require__(1554);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/disposables.js
function disposables_o(){let n=[],r={addEventListener(e,t,s,a){return e.addEventListener(t,s,a),r.add(()=>e.removeEventListener(t,s,a))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t))},microTask(...e){let t={current:!0};return (0,micro_task/* microTask */.Y)(()=>{t.current&&e[0]()}),r.add(()=>{t.current=!1})},style(e,t,s){let a=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:s}),this.add(()=>{Object.assign(e.style,{[t]:a})})},group(e){let t=disposables_o();return e(t),this.add(()=>t.dispose())},add(e){return n.push(e),()=>{let t=n.indexOf(e);if(t>=0)for(let s of n.splice(t,1))s()}},dispose(){for(let e of n.splice(0))e()}};return r}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-disposables.js
function p(){let[e]=(0,react.useState)(disposables_o);return (0,react.useEffect)(()=>()=>e.dispose(),[e]),e}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(5559);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-event-listener.js
var use_event_listener = __webpack_require__(9410);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(8064);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
function f(){let e=(0,react.useRef)(!1);return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(e.current=!0,()=>{e.current=!1}),[]),e}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-on-unmount.js
var use_on_unmount = __webpack_require__(1385);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-owner.js
var use_owner = __webpack_require__(592);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(6460);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3401);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction = __webpack_require__(859);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-watch.js
function m(u,t){let e=(0,react.useRef)([]),r=(0,use_event/* useEvent */.z)(u);(0,react.useEffect)(()=>{let o=[...e.current];for(let[n,a]of t.entries())if(e.current[n]!==a){let l=r(t,o);return e.current=t,l}},[r,...t])}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(6799);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/document-ready.js
function t(n){function e(){document.readyState!=="loading"&&(n(),document.removeEventListener("DOMContentLoaded",e))}typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("DOMContentLoaded",e),e())}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/active-element-history.js
let active_element_history_t=[];t(()=>{function e(n){n.target instanceof HTMLElement&&n.target!==document.body&&active_element_history_t[0]!==n.target&&(active_element_history_t.unshift(n.target),active_element_history_t=active_element_history_t.filter(r=>r!=null&&r.isConnected),active_element_history_t.splice(10))}window.addEventListener("click",e,{capture:!0}),window.addEventListener("mousedown",e,{capture:!0}),window.addEventListener("focus",e,{capture:!0}),document.body.addEventListener("click",e,{capture:!0}),document.body.addEventListener("mousedown",e,{capture:!0}),document.body.addEventListener("focus",e,{capture:!0})});

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(2929);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(3703);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/render.js + 1 modules
var render = __webpack_require__(9206);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js
function P(t){if(!t)return new Set;if(typeof t=="function")return new Set(t());let n=new Set;for(let e of t.current)e.current instanceof HTMLElement&&n.add(e.current);return n}let X="div";var _=(r=>(r[r.None=1]="None",r[r.InitialFocus=2]="InitialFocus",r[r.TabLock=4]="TabLock",r[r.FocusLock=8]="FocusLock",r[r.RestoreFocus=16]="RestoreFocus",r[r.All=30]="All",r))(_||{});function z(t,n){let e=(0,react.useRef)(null),o=(0,use_sync_refs/* useSyncRefs */.T)(e,n),{initialFocus:l,containers:c,features:r=30,...s}=t;(0,use_server_handoff_complete/* useServerHandoffComplete */.H)()||(r=1);let i=(0,use_owner/* useOwnerDocument */.i)(e);Y({ownerDocument:i},Boolean(r&16));let u=Z({ownerDocument:i,container:e,initialFocus:l},Boolean(r&2));$({ownerDocument:i,container:e,containers:c,previousActiveElement:u},Boolean(r&8));let y=(0,use_tab_direction/* useTabDirection */.l)(),R=(0,use_event/* useEvent */.z)(a=>{let m=e.current;if(!m)return;(B=>B())(()=>{(0,match/* match */.E)(y.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>{(0,focus_management/* focusIn */.jA)(m,focus_management/* Focus.First */.TO.First,{skipElements:[a.relatedTarget]})},[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>{(0,focus_management/* focusIn */.jA)(m,focus_management/* Focus.Last */.TO.Last,{skipElements:[a.relatedTarget]})}})})}),h=p(),H=(0,react.useRef)(!1),j={ref:o,onKeyDown(a){a.key=="Tab"&&(H.current=!0,h.requestAnimationFrame(()=>{H.current=!1}))},onBlur(a){let m=P(c);e.current instanceof HTMLElement&&m.add(e.current);let T=a.relatedTarget;T instanceof HTMLElement&&T.dataset.headlessuiFocusGuard!=="true"&&(S(m,T)||(H.current?(0,focus_management/* focusIn */.jA)(e.current,(0,match/* match */.E)(y.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>focus_management/* Focus.Next */.TO.Next,[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>focus_management/* Focus.Previous */.TO.Previous})|focus_management/* Focus.WrapAround */.TO.WrapAround,{relativeTo:a.target}):a.target instanceof HTMLElement&&(0,focus_management/* focusElement */.C5)(a.target)))}};return react.createElement(react.Fragment,null,Boolean(r&4)&&react.createElement(internal_hidden/* Hidden */._,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:R,features:internal_hidden/* Features.Focusable */.A.Focusable}),(0,render/* render */.sY)({ourProps:j,theirProps:s,defaultTag:X,name:"FocusTrap"}),Boolean(r&4)&&react.createElement(internal_hidden/* Hidden */._,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:R,features:internal_hidden/* Features.Focusable */.A.Focusable}))}let D=(0,render/* forwardRefWithAs */.yV)(z),focus_trap_de=Object.assign(D,{features:_});function Q(t=!0){let n=(0,react.useRef)(active_element_history_t.slice());return m(([e],[o])=>{o===!0&&e===!1&&(0,micro_task/* microTask */.Y)(()=>{n.current.splice(0)}),o===!1&&e===!0&&(n.current=active_element_history_t.slice())},[t,active_element_history_t,n]),(0,use_event/* useEvent */.z)(()=>{var e;return(e=n.current.find(o=>o!=null&&o.isConnected))!=null?e:null})}function Y({ownerDocument:t},n){let e=Q(n);m(()=>{n||(t==null?void 0:t.activeElement)===(t==null?void 0:t.body)&&(0,focus_management/* focusElement */.C5)(e())},[n]),(0,use_on_unmount/* useOnUnmount */.L)(()=>{n&&(0,focus_management/* focusElement */.C5)(e())})}function Z({ownerDocument:t,container:n,initialFocus:e},o){let l=(0,react.useRef)(null),c=f();return m(()=>{if(!o)return;let r=n.current;r&&(0,micro_task/* microTask */.Y)(()=>{if(!c.current)return;let s=t==null?void 0:t.activeElement;if(e!=null&&e.current){if((e==null?void 0:e.current)===s){l.current=s;return}}else if(r.contains(s)){l.current=s;return}e!=null&&e.current?(0,focus_management/* focusElement */.C5)(e.current):(0,focus_management/* focusIn */.jA)(r,focus_management/* Focus.First */.TO.First)===focus_management/* FocusResult.Error */.fE.Error&&console.warn("There are no focusable elements inside the <FocusTrap />"),l.current=t==null?void 0:t.activeElement})},[o]),l}function $({ownerDocument:t,container:n,containers:e,previousActiveElement:o},l){let c=f();(0,use_event_listener/* useEventListener */.O)(t==null?void 0:t.defaultView,"focus",r=>{if(!l||!c.current)return;let s=P(e);n.current instanceof HTMLElement&&s.add(n.current);let i=o.current;if(!i)return;let u=r.target;u&&u instanceof HTMLElement?S(s,u)?(o.current=u,(0,focus_management/* focusElement */.C5)(u)):(r.preventDefault(),r.stopPropagation(),(0,focus_management/* focusElement */.C5)(i)):(0,focus_management/* focusElement */.C5)(o.current)},!0)}function S(t,n){for(let e of t)if(e.contains(n))return!0;return!1}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/portal/portal.js
var portal = __webpack_require__(5577);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimClient.js
function i(e,t){return e===t&&(e!==0||1/e===1/t)||e!==e&&t!==t}const d=typeof Object.is=="function"?Object.is:i,{useState:u,useEffect:h,useLayoutEffect:useSyncExternalStoreShimClient_f,useDebugValue:useSyncExternalStoreShimClient_p}=react_namespaceObject;let useSyncExternalStoreShimClient_S=(/* unused pure expression or super */ null && (!1)),useSyncExternalStoreShimClient_=(/* unused pure expression or super */ null && (!1));function y(e,t,c){const a=t(),[{inst:n},o]=u({inst:{value:a,getSnapshot:t}});return useSyncExternalStoreShimClient_f(()=>{n.value=a,n.getSnapshot=t,r(n)&&o({inst:n})},[e,a,t]),h(()=>(r(n)&&o({inst:n}),e(()=>{r(n)&&o({inst:n})})),[e]),useSyncExternalStoreShimClient_p(a),a}function r(e){const t=e.getSnapshot,c=e.value;try{const a=t();return!d(c,a)}catch{return!0}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimServer.js
function useSyncExternalStoreShimServer_t(r,e,n){return e()}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/use-sync-external-store-shim/index.js
const use_sync_external_store_shim_r=typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined",s=!use_sync_external_store_shim_r,c=s?useSyncExternalStoreShimServer_t:y,a= true?(n=>n.useSyncExternalStore)(react_namespaceObject):c;

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-store.js
function use_store_S(t){return a(t.subscribe,t.getSnapshot,t.getSnapshot)}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/store.js
function store_a(o,r){let t=o(),n=new Set;return{getSnapshot(){return t},subscribe(e){return n.add(e),()=>n.delete(e)},dispatch(e,...s){let i=r[e].call(t,...s);i&&(t=i,n.forEach(c=>c()))}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/adjust-scrollbar-padding.js
function adjust_scrollbar_padding_c(){let o;return{before({doc:e}){var l;let n=e.documentElement;o=((l=e.defaultView)!=null?l:window).innerWidth-n.clientWidth},after({doc:e,d:n}){let t=e.documentElement,l=t.clientWidth-t.offsetWidth,r=o-l;n.style(t,"paddingRight",`${r}px`)}}}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/platform.js
var platform = __webpack_require__(5371);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/handle-ios-locking.js
function handle_ios_locking_d(){return (0,platform/* isIOS */.gn)()?{before({doc:r,d:l,meta:c}){function o(a){return c.containers.flatMap(n=>n()).some(n=>n.contains(a))}l.microTask(()=>{var s;if(window.getComputedStyle(r.documentElement).scrollBehavior!=="auto"){let t=disposables_o();t.style(r.documentElement,"scrollBehavior","auto"),l.add(()=>l.microTask(()=>t.dispose()))}let a=(s=window.scrollY)!=null?s:window.pageYOffset,n=null;l.addEventListener(r,"click",t=>{if(t.target instanceof HTMLElement)try{let e=t.target.closest("a");if(!e)return;let{hash:f}=new URL(e.href),i=r.querySelector(f);i&&!o(i)&&(n=i)}catch{}},!0),l.addEventListener(r,"touchstart",t=>{if(t.target instanceof HTMLElement)if(o(t.target)){let e=t.target;for(;e.parentElement&&o(e.parentElement);)e=e.parentElement;l.style(e,"overscrollBehavior","contain")}else l.style(t.target,"touchAction","none")}),l.addEventListener(r,"touchmove",t=>{if(t.target instanceof HTMLElement)if(o(t.target)){let e=t.target;for(;e.parentElement&&e.dataset.headlessuiPortal!==""&&!(e.scrollHeight>e.clientHeight||e.scrollWidth>e.clientWidth);)e=e.parentElement;e.dataset.headlessuiPortal===""&&t.preventDefault()}else t.preventDefault()},{passive:!1}),l.add(()=>{var e;let t=(e=window.scrollY)!=null?e:window.pageYOffset;a!==t&&window.scrollTo(0,a),n&&n.isConnected&&(n.scrollIntoView({block:"nearest"}),n=null)})})}}:{}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/prevent-scroll.js
function l(){return{before({doc:e,d:o}){o.style(e.documentElement,"overflow","hidden")}}}

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/overflow-store.js
function overflow_store_m(e){let n={};for(let t of e)Object.assign(n,t(n));return n}let overflow_store_a=store_a(()=>new Map,{PUSH(e,n){var o;let t=(o=this.get(e))!=null?o:{doc:e,count:0,d:disposables_o(),meta:new Set};return t.count++,t.meta.add(n),this.set(e,t),this},POP(e,n){let t=this.get(e);return t&&(t.count--,t.meta.delete(n)),this},SCROLL_PREVENT({doc:e,d:n,meta:t}){let o={doc:e,d:n,meta:overflow_store_m(t)},c=[handle_ios_locking_d(),adjust_scrollbar_padding_c(),l()];c.forEach(({before:r})=>r==null?void 0:r(o)),c.forEach(({after:r})=>r==null?void 0:r(o))},SCROLL_ALLOW({d:e}){e.dispose()},TEARDOWN({doc:e}){this.delete(e)}});overflow_store_a.subscribe(()=>{let e=overflow_store_a.getSnapshot(),n=new Map;for(let[t]of e)n.set(t,t.documentElement.style.overflow);for(let t of e.values()){let o=n.get(t.doc)==="hidden",c=t.count!==0;(c&&!o||!c&&o)&&overflow_store_a.dispatch(t.count>0?"SCROLL_PREVENT":"SCROLL_ALLOW",t),t.count===0&&overflow_store_a.dispatch("TEARDOWN",t)}});

;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/document-overflow/use-document-overflow.js
function use_document_overflow_p(e,r,n){let f=use_store_S(overflow_store_a),o=e?f.get(e):void 0,i=o?o.count>0:!1;return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(!(!e||!r))return overflow_store_a.dispatch("PUSH",e,n),()=>overflow_store_a.dispatch("POP",e,n)},[r,e]),i}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(586);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-inert.js
let use_inert_u=new Map,use_inert_t=new Map;function b(r,l=!0){(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{var o;if(!l)return;let e=typeof r=="function"?r():r.current;if(!e)return;function a(){var d;if(!e)return;let i=(d=use_inert_t.get(e))!=null?d:1;if(i===1?use_inert_t.delete(e):use_inert_t.set(e,i-1),i!==1)return;let n=use_inert_u.get(e);n&&(n["aria-hidden"]===null?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden",n["aria-hidden"]),e.inert=n.inert,use_inert_u.delete(e))}let f=(o=use_inert_t.get(e))!=null?o:0;return use_inert_t.set(e,f+1),f!==0||(use_inert_u.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),e.setAttribute("aria-hidden","true"),e.inert=!0),a},[r,l])}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(2994);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-root-containers.js
var use_root_containers = __webpack_require__(1638);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(7215);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/internal/portal-force-root.js
var portal_force_root = __webpack_require__(6137);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/internal/stack-context.js
let stack_context_a=(0,react.createContext)(()=>{});stack_context_a.displayName="StackContext";var stack_context_s=(e=>(e[e.Add=0]="Add",e[e.Remove=1]="Remove",e))(stack_context_s||{});function x(){return (0,react.useContext)(stack_context_a)}function stack_context_b({children:i,onUpdate:r,type:e,element:n,enabled:u}){let l=x(),o=(0,use_event/* useEvent */.z)((...t)=>{r==null||r(...t),l(...t)});return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{let t=u===void 0||u===!0;return t&&o(0,e,n),()=>{t&&o(1,e,n)}},[o,e,n,u]),react.createElement(stack_context_a.Provider,{value:o},i)}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(5426);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/description/description.js
let description_d=(0,react.createContext)(null);function description_f(){let r=(0,react.useContext)(description_d);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,description_f),t}return r}function description_w(){let[r,t]=(0,react.useState)([]);return[r.length>0?r.join(" "):void 0,(0,react.useMemo)(()=>function(e){let i=(0,use_event/* useEvent */.z)(s=>(t(o=>[...o,s]),()=>t(o=>{let p=o.slice(),c=p.indexOf(s);return c!==-1&&p.splice(c,1),p}))),n=(0,react.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react.createElement(description_d.Provider,{value:n},e.children)},[t])]}let I="p";function description_S(r,t){let a=(0,use_id/* useId */.M)(),{id:e=`headlessui-description-${a}`,...i}=r,n=description_f(),s=(0,use_sync_refs/* useSyncRefs */.T)(t);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>n.register(e),[e,n.register]);let o={ref:s,...n.props,id:e};return (0,render/* render */.sY)({ourProps:o,theirProps:i,slot:n.slot||{},defaultTag:I,name:n.name||"Description"})}let description_h=(0,render/* forwardRefWithAs */.yV)(description_S),G=Object.assign(description_h,{});

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(9108);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/dialog/dialog.js
var Me=(r=>(r[r.Open=0]="Open",r[r.Closed=1]="Closed",r))(Me||{}),we=(e=>(e[e.SetTitleId=0]="SetTitleId",e))(we||{});let He={[0](t,e){return t.titleId===e.id?t:{...t,titleId:e.id}}},dialog_I=(0,react.createContext)(null);dialog_I.displayName="DialogContext";function dialog_b(t){let e=(0,react.useContext)(dialog_I);if(e===null){let r=new Error(`<${t} /> is missing a parent <Dialog /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,dialog_b),r}return e}function Be(t,e,r=()=>[document.body]){use_document_overflow_p(t,e,i=>{var n;return{containers:[...(n=i.containers)!=null?n:[],r]}})}function Ge(t,e){return (0,match/* match */.E)(e.type,He,t,e)}let Ne="div",Ue=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function We(t,e){let r=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-${r}`,open:n,onClose:l,initialFocus:s,role:a="dialog",__demoMode:T=!1,...m}=t,[M,f]=(0,react.useState)(0),U=(0,react.useRef)(!1);a=function(){return a==="dialog"||a==="alertdialog"?a:(U.current||(U.current=!0,console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)),"dialog")}();let E=(0,open_closed/* useOpenClosed */.oJ)();n===void 0&&E!==null&&(n=(E&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open);let D=(0,react.useRef)(null),ee=(0,use_sync_refs/* useSyncRefs */.T)(D,e),g=(0,use_owner/* useOwnerDocument */.i)(D),W=t.hasOwnProperty("open")||E!==null,$=t.hasOwnProperty("onClose");if(!W&&!$)throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");if(!W)throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");if(!$)throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");if(typeof n!="boolean")throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);if(typeof l!="function")throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);let p=n?0:1,[h,te]=(0,react.useReducer)(Ge,{titleId:null,descriptionId:null,panelRef:(0,react.createRef)()}),P=(0,use_event/* useEvent */.z)(()=>l(!1)),Y=(0,use_event/* useEvent */.z)(o=>te({type:0,id:o})),S=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)()?T?!1:p===0:!1,x=M>1,j=(0,react.useContext)(dialog_I)!==null,[oe,re]=(0,portal/* useNestedPortals */.k)(),ne={get current(){var o;return(o=h.panelRef.current)!=null?o:D.current}},{resolveContainers:w,mainTreeNodeRef:L,MainTreeNode:le}=(0,use_root_containers/* useRootContainers */.v)({portals:oe,defaultContainers:[ne]}),ae=x?"parent":"leaf",J=E!==null?(E&open_closed/* State.Closing */.ZM.Closing)===open_closed/* State.Closing */.ZM.Closing:!1,ie=(()=>j||J?!1:S)(),se=(0,react.useCallback)(()=>{var o,c;return(c=Array.from((o=g==null?void 0:g.querySelectorAll("body > *"))!=null?o:[]).find(d=>d.id==="headlessui-portal-root"?!1:d.contains(L.current)&&d instanceof HTMLElement))!=null?c:null},[L]);b(se,ie);let pe=(()=>x?!0:S)(),de=(0,react.useCallback)(()=>{var o,c;return(c=Array.from((o=g==null?void 0:g.querySelectorAll("[data-headlessui-portal]"))!=null?o:[]).find(d=>d.contains(L.current)&&d instanceof HTMLElement))!=null?c:null},[L]);b(de,pe);let ue=(()=>!(!S||x))();(0,use_outside_click/* useOutsideClick */.O)(w,P,ue);let fe=(()=>!(x||p!==0))();(0,use_event_listener/* useEventListener */.O)(g==null?void 0:g.defaultView,"keydown",o=>{fe&&(o.defaultPrevented||o.key===keyboard/* Keys.Escape */.R.Escape&&(o.preventDefault(),o.stopPropagation(),P()))});let ge=(()=>!(J||p!==0||j))();Be(g,ge,w),(0,react.useEffect)(()=>{if(p!==0||!D.current)return;let o=new ResizeObserver(c=>{for(let d of c){let F=d.target.getBoundingClientRect();F.x===0&&F.y===0&&F.width===0&&F.height===0&&P()}});return o.observe(D.current),()=>o.disconnect()},[p,D,P]);let[Te,ce]=description_w(),De=(0,react.useMemo)(()=>[{dialogState:p,close:P,setTitleId:Y},h],[p,h,P,Y]),X=(0,react.useMemo)(()=>({open:p===0}),[p]),me={ref:ee,id:i,role:a,"aria-modal":p===0?!0:void 0,"aria-labelledby":h.titleId,"aria-describedby":Te};return react.createElement(stack_context_b,{type:"Dialog",enabled:p===0,element:D,onUpdate:(0,use_event/* useEvent */.z)((o,c)=>{c==="Dialog"&&(0,match/* match */.E)(o,{[stack_context_s.Add]:()=>f(d=>d+1),[stack_context_s.Remove]:()=>f(d=>d-1)})})},react.createElement(portal_force_root/* ForcePortalRoot */.O,{force:!0},react.createElement(portal/* Portal */.h,null,react.createElement(dialog_I.Provider,{value:De},react.createElement(portal/* Portal.Group */.h.Group,{target:D},react.createElement(portal_force_root/* ForcePortalRoot */.O,{force:!1},react.createElement(ce,{slot:X,name:"Dialog.Description"},react.createElement(focus_trap_de,{initialFocus:s,containers:w,features:S?(0,match/* match */.E)(ae,{parent:focus_trap_de.features.RestoreFocus,leaf:focus_trap_de.features.All&~focus_trap_de.features.FocusLock}):focus_trap_de.features.None},react.createElement(re,null,(0,render/* render */.sY)({ourProps:me,theirProps:m,slot:X,defaultTag:Ne,features:Ue,visible:p===0,name:"Dialog"}))))))))),react.createElement(le,null))}let $e="div";function Ye(t,e){let r=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-overlay-${r}`,...n}=t,[{dialogState:l,close:s}]=dialog_b("Dialog.Overlay"),a=(0,use_sync_refs/* useSyncRefs */.T)(e),T=(0,use_event/* useEvent */.z)(f=>{if(f.target===f.currentTarget){if((0,bugs/* isDisabledReactIssue7711 */.P)(f.currentTarget))return f.preventDefault();f.preventDefault(),f.stopPropagation(),s()}}),m=(0,react.useMemo)(()=>({open:l===0}),[l]);return (0,render/* render */.sY)({ourProps:{ref:a,id:i,"aria-hidden":!0,onClick:T},theirProps:n,slot:m,defaultTag:$e,name:"Dialog.Overlay"})}let je="div";function Je(t,e){let r=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-backdrop-${r}`,...n}=t,[{dialogState:l},s]=dialog_b("Dialog.Backdrop"),a=(0,use_sync_refs/* useSyncRefs */.T)(e);(0,react.useEffect)(()=>{if(s.panelRef.current===null)throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.")},[s.panelRef]);let T=(0,react.useMemo)(()=>({open:l===0}),[l]);return react.createElement(portal_force_root/* ForcePortalRoot */.O,{force:!0},react.createElement(portal/* Portal */.h,null,(0,render/* render */.sY)({ourProps:{ref:a,id:i,"aria-hidden":!0},theirProps:n,slot:T,defaultTag:je,name:"Dialog.Backdrop"})))}let Xe="div";function Ke(t,e){let r=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-panel-${r}`,...n}=t,[{dialogState:l},s]=dialog_b("Dialog.Panel"),a=(0,use_sync_refs/* useSyncRefs */.T)(e,s.panelRef),T=(0,react.useMemo)(()=>({open:l===0}),[l]),m=(0,use_event/* useEvent */.z)(f=>{f.stopPropagation()});return (0,render/* render */.sY)({ourProps:{ref:a,id:i,onClick:m},theirProps:n,slot:T,defaultTag:Xe,name:"Dialog.Panel"})}let Ve="h2";function qe(t,e){let r=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-title-${r}`,...n}=t,[{dialogState:l,setTitleId:s}]=dialog_b("Dialog.Title"),a=(0,use_sync_refs/* useSyncRefs */.T)(e);(0,react.useEffect)(()=>(s(i),()=>s(null)),[i,s]);let T=(0,react.useMemo)(()=>({open:l===0}),[l]);return (0,render/* render */.sY)({ourProps:{ref:a,id:i},theirProps:n,slot:T,defaultTag:Ve,name:"Dialog.Title"})}let ze=(0,render/* forwardRefWithAs */.yV)(We),Qe=(0,render/* forwardRefWithAs */.yV)(Je),Ze=(0,render/* forwardRefWithAs */.yV)(Ke),et=(0,render/* forwardRefWithAs */.yV)(Ye),tt=(0,render/* forwardRefWithAs */.yV)(qe),_t=Object.assign(ze,{Backdrop:Qe,Panel:Ze,Overlay:et,Title:tt,Description:G});

// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Close.js
var Close = __webpack_require__(2530);
var Close_default = /*#__PURE__*/__webpack_require__.n(Close);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
// EXTERNAL MODULE: ../../frontend/shared/src/Ui/IconButton/index.ts + 2 modules
var IconButton = __webpack_require__(8145);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Overlay/Overlay.styles.ts





var fadeIn = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{opacity:0;}100%{opacity:1;}");
var appear = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{opacity:0;transform:scale(.95);}100%{opacity:1;transform:scale(1);}");
var Backdrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e17yf85l0"
}, "target", "e17yf85l0"))("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1002;background-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.3, theme.color.secondary100);
}, ";cursor:pointer;animation:", fadeIn, " 0.3s ease-out;");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e17yf85l1"
}, "target", "e17yf85l1"))("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1002;display:flex;align-items:flex-start;justify-content:center;box-sizing:border-box;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{align-items:center;& > div{width:100%;max-width:", function(param) {
    var $width = param.$width;
    return $width === "wide" ? "810px" : "455px";
}, ";}}");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e17yf85l2"
}, "target", "e17yf85l2"))("display:flex;flex-direction:column;position:relative;z-index:1003;max-height:100vmax;max-height:100vh;overflow:hidden;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";box-sizing:border-box;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";box-shadow:", function(param) {
    var theme = param.theme;
    return theme.boxShadow.md;
}, ";max-height:calc(100vh - 2rem);animation:", appear, " 0.3s ease-out;animation-fill-mode:both;}");
var Footer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e17yf85l3"
}, "target", "e17yf85l3"))("padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";text-align:center;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural20;
}, ";");
var TitleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", (0,_define_property/* default */.Z)({
    target: "e17yf85l4"
}, "target", "e17yf85l4"))("display:flex;justify-content:", function(param) {
    var hasTitle = param.hasTitle;
    return hasTitle ? "space-between" : "flex-end";
}, ";gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{display:block;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";}");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,_define_property/* default */.Z)({
    target: "e17yf85l5"
}, "target", "e17yf85l5"))("margin:0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:normal;font-size:1.25rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";text-align:left;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1.5rem;text-align:center;}");
var ScrollableContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,_define_property/* default */.Z)({
    target: "e17yf85l6"
}, "target", "e17yf85l6"))("padding:0 ", function(param) {
    var theme = param.theme;
    return "".concat(theme.spacing[40], " ").concat(theme.spacing[40]);
}, ";max-height:100%;overflow-y:auto;box-sizing:border-box;background:linear-gradient(\n      ", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " 30%,rgb(255 255 255 / 0%)\n    ),linear-gradient(\n        rgb(255 255 255 / 0%),", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " 70%\n      )\n      0 100%,radial-gradient(farthest-side at 50% 0,rgb(0 0 0 / 20%),transparent),radial-gradient(farthest-side at 50% 100%,rgb(0 0 0 / 20%),transparent) 0\n      100%;background-attachment:local,local,scroll,scroll;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";background-repeat:no-repeat;background-size:100% 40px,100% 40px,100% 14px,100% 14px;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";}");
var StyledIconButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* IconButton */.h, (0,_define_property/* default */.Z)({
    target: "e17yf85l7"
}, "target", "e17yf85l7"))("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{position:absolute;top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";}");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Overlay/Overlay.tsx




var defaultProps = {
    width: "normal"
};
var Overlay = function Overlay(param) {
    var title = param.title, footerContent = param.footerContent, children = param.children, open = param.open, width = param.width, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_t, {
        onClose: onClose,
        open: open,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Backdrop, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
                $width: width,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_t.Panel, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleWrapper, {
                                hasTitle: !!title,
                                children: [
                                    title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_t.Title, {
                                        as: "div",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconButton, {
                                        icon: (Close_default()),
                                        title: "close" // @TODO: Add translation
                                        ,
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollableContent, {
                                children: children
                            }),
                            footerContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                                children: footerContent
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Overlay.defaultProps = defaultProps;


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Overlay/index.ts



/***/ }),

/***/ 2145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pG": function() { return /* reexport */ AppStoreLink; },
  "Ct": function() { return /* reexport */ Badge; },
  "Bc": function() { return /* reexport */ ErrorMessage/* ErrorMessage */.B; },
  "hU": function() { return /* reexport */ IconButton/* IconButton */.h; },
  "Ee": function() { return /* reexport */ ResponsiveImage; },
  "II": function() { return /* reexport */ Input_Input; },
  "TR": function() { return /* reexport */ Logo; },
  "Fz": function() { return /* reexport */ MaskedLink; },
  "v0": function() { return /* reexport */ Message; },
  "lB": function() { return /* reexport */ MessageRole; },
  "CE": function() { return /* reexport */ MessageSeverity; },
  "aV": function() { return /* reexport */ Overlay/* Overlay */.a; },
  "Ut": function() { return /* reexport */ PanelContentWrapper; },
  "Bh": function() { return /* reexport */ PhoneNumber; },
  "L_": function() { return /* reexport */ PlayStoreLink; },
  "J2": function() { return /* reexport */ Popover; },
  "Hi": function() { return /* reexport */ PopoverPanel; },
  "Ho": function() { return /* reexport */ RichText; },
  "J$": function() { return /* reexport */ rules_RichTextStyle; },
  "Y6": function() { return /* reexport */ TabButton_TabButton; },
  "LU": function() { return /* reexport */ TabNavigation_TabNavigation; },
  "hh": function() { return /* reexport */ TextLink; },
  "ZT": function() { return /* reexport */ Typography; },
  "iC": function() { return /* reexport */ Wave; }
});

// UNUSED EXPORTS: Dropdown, Tabs, WaveSets

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ../../node_modules/clsx/dist/clsx.mjs
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f)}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var dist_clsx = (clsx);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Typography/Typography.tsx





var defaultProps = {
    color: "default"
};
var Typography = function Typography(_param) {
    var children = _param.children, className = _param.className, as = _param.as, variant = _param.variant, color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "as",
        "variant",
        "color"
    ]);
    var style = variant !== null && variant !== void 0 ? variant : as === "h1" || as === "h2" || as === "h3" ? as : "default";
    var VARIANT_CLASSES = {
        none: "",
        h1: "lg:text-[2.5rem] lg:leading-[1.188em] font-quicksand font-bold text-[2.125rem] leading-[1.235em]",
        h2: "lg:text-[2.375rem] lg:leading-[1.25em] font-quicksand font-bold text-[1.688rem] leading-[1.259em]",
        h3: "lg:text-[1.75rem] lg:leading-[1.4em] font-quicksand font-bold text-[1.375rem] leading-[1.273em]",
        subtitle: "lg:text-[1.5rem] lg:leading-[1.3em] text-[1.313rem] leading-[1.238em] font-semibold",
        default: "lg:text-[1.125rem] lg:leading-[1.333em] text-[1.063rem] leading-[1.412em] font-semibold",
        body: "lg:text-[1.125rem] lg:leading-[1.778em] font-normal text-[1.063rem] leading-[1.588em]"
    }[style];
    var COLOR_CLASSES = {
        green: "text-color1",
        grey: "text-color7",
        default: "text-primary",
        white: "text-white",
        orange: "text-color3",
        error: "text-error",
        current: "text-current"
    }[color];
    var Component = as;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: dist_clsx(VARIANT_CLASSES, COLOR_CLASSES, className),
        children: children
    }));
};
Typography.defaultProps = defaultProps;


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
// EXTERNAL MODULE: ../../frontend/shared/src/Theme/index.ts + 8 modules
var Theme = __webpack_require__(6321);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Badge/Badge.styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: inline-flex;\n          flex-wrap: nowrap;\n          gap: 0.5rem;\n          align-items: center;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display: inline-block;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          padding: 0.125rem 0.25rem;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          padding: 0.25rem 1rem;\n          border-radius: 100px;\n          font-size: 1rem;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var textColorStylesBadge = {
    default: "dark",
    dark: "light",
    light: "dark",
    orange: "light",
    green: "light",
    "orange-gradient": "light",
    "green-gradient": "light"
};
var mapColor = function mapColor(theme) {
    var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    return ({
        default: (0,polished_esm/* darken */._j)(0.02, theme.color.natural10),
        dark: (0,polished_esm/* darken */._j)(0.599, theme.color.natural10),
        light: theme.color.natural0,
        orange: theme.color.natural70,
        green: theme.color.primary,
        "orange-gradient": theme.color.natural70,
        "green-gradient": theme.color.primary
    })[color];
};
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1u2lcnv0"
}, "target", "e1u2lcnv0"))(function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon ? (0,emotion_react_browser_esm/* css */.iv)(_templateObject()) : (0,emotion_react_browser_esm/* css */.iv)(_templateObject1());
}, ";", function(param) {
    var badgeSize = param.badgeSize;
    return badgeSize === "small" ? (0,emotion_react_browser_esm/* css */.iv)(_templateObject2()) : (0,emotion_react_browser_esm/* css */.iv)(_templateObject3());
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:600;text-align:center;text-transform:uppercase;white-space:nowrap;line-height:1.5;fill:currentcolor;color:", function(param) {
    var theme = param.theme, badgeType = param.badgeType;
    return mapColor(theme, textColorStylesBadge[badgeType]);
}, ";background-color:", function(param) {
    var theme = param.theme, badgeType = param.badgeType;
    return mapColor(theme, badgeType);
}, ";background-image:", function(param) {
    var theme = param.theme, badgeType = param.badgeType;
    switch(badgeType){
        case "orange-gradient":
            return (0,Theme.getLinearGradient)(theme.gradient.orange, "to left");
        case "green-gradient":
            return (0,Theme.getLinearGradient)(theme.gradient.green, "to left");
        default:
            return "";
    }
}, ";", function(param) {
    var theme = param.theme, badgeSize = param.badgeSize;
    return badgeSize !== "small" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject4(), theme.mq("lg"));
});


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Badge/Badge.tsx


var Badge_defaultProps = {
    type: "default",
    size: "default"
};
var Badge = function Badge(param) {
    var text = param.text, icon = param.icon, type = param.type, size = param.size, className = param.className;
    if (!text) {
        return null;
    }
    var hasIcon = !!icon;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        badgeType: type,
        badgeSize: size,
        hasIcon: hasIcon,
        className: className,
        children: hasIcon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    children: text
                }),
                icon
            ]
        }) : text
    });
};
Badge.defaultProps = Badge_defaultProps;


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Badge/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowDown.js
var ArrowDown = __webpack_require__(1143);
var ArrowDown_default = /*#__PURE__*/__webpack_require__.n(ArrowDown);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Dropdown/Dropdown.styles.tsx





var ScreenReaderOnly = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;");
var ScreenReaderOnlyDiv = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", _define_property({
    target: "e1pu54op0"
}, "target", "e1pu54op0"))(ScreenReaderOnly)));
var ScreenReaderOnlyLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,src_define_property/* default */.Z)({
    target: "e1pu54op1"
}, "target", "e1pu54op1"))(ScreenReaderOnly);
var SpanWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1pu54op2"
}, "target", "e1pu54op2"))("color:", function(param) {
    var disabled = param.disabled, theme = param.theme;
    return disabled ? (0,polished_esm/* lighten */.$n)(0.19, (0,polished_esm/* desaturate */.vG)(0.92, (0,polished_esm/* complement */.Cy)(theme.color.primary70))) : (0,polished_esm/* darken */._j)(0.46, (0,polished_esm/* desaturate */.vG)(0.32, theme.color.primaryHighlight));
}, ";position:relative;display:flex;align-items:center;justify-content:center;column-gap:0.25rem;");
var IconSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1pu54op3"
}, "target", "e1pu54op3"))("pointer-events:none;position:absolute;left:0.5rem;display:flex;height:1rem;width:1rem;overflow:hidden;fill:currentcolor;");
var Select = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("select", (0,src_define_property/* default */.Z)({
    target: "e1pu54op4"
}, "target", "e1pu54op4"))("width:100%;cursor:pointer;appearance:none;border-radius:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? theme.borderRadius.sm : theme.borderRadius.md;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";padding:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? theme.spacing[20] : theme.spacing[40];
}, ";padding-left:", function(param) {
    var icon = param.icon;
    return icon && "2rem";
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";border:", function(param) {
    var compact = param.compact, disabled = param.disabled, theme = param.theme;
    if (compact) {
        return 0;
    }
    var color = disabled ? theme.color.natural20 : theme.color.natural40;
    return "1px solid ".concat(color);
}, ";color:", function(param) {
    var disabled = param.disabled, theme = param.theme;
    return disabled ? theme.color.natural30 : "currentcolor";
}, ";&:focus{background-color:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight)) : "initial";
}, ";outline-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";border:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? "initial" : "2px solid ".concat(theme.color.primary70);
}, ";margin:", function(param) {
    var compact = param.compact;
    return compact ? "initial" : "-1px";
}, ";}&:hover{&:not([disabled]){background-color:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? (0,polished_esm/* lighten */.$n)(0.065, (0,polished_esm/* desaturate */.vG)(0.25, theme.color.primaryHighlight)) : "initial";
}, ";border:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? "initial" : "2px solid ".concat(theme.color.primary70);
}, ";margin:", function(param) {
    var compact = param.compact;
    return compact ? "initial" : "-1px";
}, ";}}");
var StyledArrowDown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowDown_default()), (0,src_define_property/* default */.Z)({
    target: "e1pu54op5"
}, "target", "e1pu54op5"))("height:0.75rem;width:0.75rem;pointer-events:none;position:absolute;right:0.5rem;right:8px;");
var StyledLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,src_define_property/* default */.Z)({
    target: "e1pu54op6"
}, "target", "e1pu54op6"))("position:absolute;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";display:block;left:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";top:-8px;font-size:0.75rem;line-height:1.5;margin:0;overflow:hidden;pointer-events:none;text-overflow:ellipsis;white-space:nowrap;z-index:2;padding:", function(param) {
    var theme = param.theme;
    return "0 ".concat(theme.spacing[20]);
}, ";&:empty ~ select{padding-top:0.1875rem;padding-bottom:0.1875rem;}");
var Hint = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1pu54op7"
}, "target", "e1pu54op7"))("padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[30];
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.xxs.size;
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Dropdown/Dropdown.tsx





var Dropdown_defaultProps = {
    defaultValue: -1
};
var Dropdown = function Dropdown(_param) {
    var label = _param.label, options = _param.options, icon = _param.icon, title = _param.title, name = _param.name, id = _param.id, disabled = _param.disabled, hint = _param.hint, _design = _param.design, design = _design === void 0 ? "default" : _design, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "options",
        "icon",
        "title",
        "name",
        "id",
        "disabled",
        "hint",
        "design"
    ]);
    // handle controlled vs. uncontrolled components when a `value` prop is set
    var additionalProps = (0,_object_spread/* default */.Z)({}, props);
    if (additionalProps.value && additionalProps.defaultValue) {
        delete additionalProps.defaultValue;
    }
    var compactDesign = design === "compact";
    var Label = compactDesign ? ScreenReaderOnlyLabel : StyledLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SpanWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                        htmlFor: id,
                        children: label
                    }),
                    icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconSpan, {
                        children: icon
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, additionalProps), {
                        name: name !== null && name !== void 0 ? name : id,
                        id: id,
                        disabled: disabled,
                        title: label,
                        icon: icon,
                        compact: compactDesign,
                        children: [
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                                disabled: true,
                                value: -1,
                                children: title
                            }, -1),
                            options.map(function(param) {
                                var text = param.label, value = param.value;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                                    id: "".concat(id !== null && id !== void 0 ? id : "dropdown", "_").concat(value),
                                    value: value,
                                    children: text
                                }, "".concat(id !== null && id !== void 0 ? id : "dropdown", "_").concat(value));
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrowDown, {})
                ]
            }),
            hint && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hint, {
                children: hint
            })
        ]
    });
};
Dropdown.defaultProps = Dropdown_defaultProps;


// EXTERNAL MODULE: ../../frontend/shared/src/Ui/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(3181);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Image/Image.styles.ts


function Image_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      img {\n        border-radius: 0.75rem;\n      }\n    "
    ]);
    Image_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eny20w90"
}, "target", "eny20w90"))(function(param) {
    var roundedBorder = param.roundedBorder;
    return roundedBorder && (0,emotion_react_browser_esm/* css */.iv)(Image_styles_templateObject());
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Image/Image.tsx





// Generic <Image /> component, preparation work for PAGES-70
var ResponsiveImage = function ResponsiveImage(_param) /*#__PURE__*/ {
    var roundedBorder = _param.roundedBorder, props = (0,_object_without_properties/* default */.Z)(_param, [
        "roundedBorder"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
        roundedBorder: roundedBorder,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,_object_spread/* default */.Z)({}, props))
    });
};


// EXTERNAL MODULE: ../../frontend/shared/src/Ui/IconButton/index.ts + 2 modules
var IconButton = __webpack_require__(8145);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Hide.js
var Hide = __webpack_require__(8364);
var Hide_default = /*#__PURE__*/__webpack_require__.n(Hide);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Show.js
var Show = __webpack_require__(7849);
var Show_default = /*#__PURE__*/__webpack_require__.n(Show);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Input/Input.styles.ts


function Input_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::-webkit-outer-spin-button,\n      &::-webkit-inner-spin-button {\n        margin: 0; /* apparently some margin are still there even though it's hidden */\n        /* stylelint-disable-next-line property-no-vendor-prefix */\n        -webkit-appearance: none; /* remove spinners on WebKit desktop browsers */\n      }\n    "
    ]);
    Input_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Input_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::-webkit-date-and-time-value {\n        text-align: left;\n      }\n    "
    ]);
    Input_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Input_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::-webkit-search-decoration,\n      &::-webkit-search-cancel-button,\n      &::-webkit-search-results-button,\n      &::-webkit-search-results-decoration {\n        display: none;\n      }\n    "
    ]);
    Input_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Input_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e3xq1hc0"
}, "target", "e3xq1hc0"))("position:relative;display:inline-block;width:100%;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.default;
}, ";text-align:left;");
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,src_define_property/* default */.Z)({
    target: "e3xq1hc1"
}, "target", "e3xq1hc1"))("position:absolute;top:-0.5625rem;left:0.75rem;clip:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "rect(0 0 0 0)" : "";
}, ";z-index:2;margin:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "-1px" : "";
}, ";padding:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "0" : "0 0.25rem";
}, ";width:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "1px" : "";
}, ";height:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "1px" : "";
}, ";color:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid, isDisabled = param.isDisabled;
    var color = theme.color.natural40;
    if (isDisabled) {
        color = theme.color.natural50;
    }
    if (isInvalid) {
        color = theme.color.error;
    }
    return color;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:0.75rem;line-height:1.5;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;opacity:", function(param) {
    var isFilled = param.isFilled;
    return isFilled ? "1" : "0";
}, ";transform:", function(param) {
    var isFilled = param.isFilled;
    return isFilled ? "translate3d(0, 0, 0)" : "translate3d(0, 0.375rem, 0)";
}, ";transition:transform 0.15s,opacity 0.1s,background-color 0.1s;pointer-events:none;");
var Input = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("input", (0,src_define_property/* default */.Z)({
    target: "e3xq1hc2"
}, "target", "e3xq1hc2"))("display:", function(param) {
    var type = param.type;
    return type === "date" ? "inline-flex" : "inline-block";
}, ";margin:0;padding:", function(param) {
    var iconPosition = param.iconPosition, type = param.type;
    switch(iconPosition){
        case "left":
            if (type === "password") {
                return "0.625rem 2.85rem";
            }
            return "0.625rem 1rem 0.625rem 2.85rem";
        case "right":
            if (type === "password") {
                return "0.625rem 5.5rem 0.625rem 1rem";
            }
            return "0.625rem 2.85rem 0.625rem 1rem";
        default:
            if (type === "password") {
                return "0.625rem 2.85rem 0.625rem 1rem";
            }
            return "0.625rem 1rem";
    }
}, ";border:1px solid\n    ", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";outline:0;width:100%;height:3.125rem;font-family:inherit;font-size:1rem;/* 16px size prevents focus zoom on iOS */\n  line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";background-clip:padding-box;/* removes inner shadow on iOS */\n  box-shadow:none;/* removes validation outlines in Firefox */\n  box-sizing:border-box;/* stylelint-disable-next-line property-no-vendor-prefix */\n  -moz-appearance:", function(param) {
    var type = param.type;
    return type === "number" && "textfield" /* remove spinners in Gecko browsers */ ;
}, ";appearance:", function(param) {
    var type = param.type;
    return type === "date" && "none" /* remove ugly iOS date input look */ ;
}, ";", function(p) {
    return (p.type === "number" || p.type === "date") && (0,emotion_react_browser_esm/* css */.iv)(Input_styles_templateObject());
}, " ", function(param) {
    var type = param.type;
    return type === "date" && (0,emotion_react_browser_esm/* css */.iv)(Input_styles_templateObject1());
}, " ", function(param) {
    var type = param.type;
    return type === "search" && (0,emotion_react_browser_esm/* css */.iv)(Input_styles_templateObject2());
}, "  &:hover,&:focus{border-color:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.natural30;
}, ";}&::placeholder{color:", function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.color.secondary100 : theme.color.natural40;
}, ";opacity:1;}&::-ms-clear{display:none;}&[readonly],&[disabled]{border-color:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.natural50;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";cursor:not-allowed;pointer-events:none;}& + svg{display:inline-flex;align-items:center;position:absolute;top:0.75rem;left:", function(param) {
    var iconPosition = param.iconPosition;
    return iconPosition === "left" ? "1rem" : "";
}, ";right:", function(param) {
    var iconPosition = param.iconPosition, type = param.type;
    if (iconPosition === "right") {
        if (type === "password") {
            return "3rem";
        }
        return "1rem";
    }
    return "";
}, ";width:1.6rem;height:1.6rem;fill:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid, isFilled = param.isFilled, isActive = param.isActive;
    var color = theme.color.natural50;
    if (isFilled || isActive) {
        color = theme.color.secondary100;
    }
    if (isInvalid) {
        color = theme.color.error;
    }
    return color;
}, ";}");
var ToggleButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e3xq1hc3"
}, "target", "e3xq1hc3"))("display:inline-flex;position:absolute;top:0.75rem;right:1rem;margin:0;padding:0;border:0;width:1.6rem;height:1.6rem;font:inherit;color:inherit;background:none;fill:", function(param) {
    var theme = param.theme, isInvalid = param.isInvalid;
    return isInvalid ? theme.color.error : theme.color.secondary100;
}, ";cursor:pointer;svg{width:100%;height:100%;}");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Input/Input.tsx









var Input_defaultProps = {
    iconPosition: "right"
};
var Input_Input = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var type = _param.type, label = _param.label, hiddenLabel = _param.hiddenLabel, forcedLabel = _param.forcedLabel, icon = _param.icon, iconPosition = _param.iconPosition, error = _param.error, id = _param.id, value = _param.value, placeholder = _param.placeholder, appearActive = _param.appearActive, disabled = _param.disabled, readOnly = _param.readOnly, required = _param.required, onChange = _param.onChange, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "type",
        "label",
        "hiddenLabel",
        "forcedLabel",
        "icon",
        "iconPosition",
        "error",
        "id",
        "value",
        "placeholder",
        "appearActive",
        "disabled",
        "readOnly",
        "required",
        "onChange",
        "className"
    ]);
    var _$ref = (0,react.useState)(!!value), isFilled = _$ref[0], setIsFilled = _$ref[1];
    var _$ref1 = (0,react.useState)(false), showValue = _$ref1[0], setShowValue = _$ref1[1];
    var isInvalid = !!error;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Input_styles_Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                htmlFor: id,
                isHidden: !!hiddenLabel,
                isFilled: isFilled || !!forcedLabel,
                isInvalid: isInvalid,
                isDisabled: disabled || readOnly,
                children: label
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                iconPosition: !!icon && iconPosition || undefined,
                type: showValue ? "text" : type
            }, props), {
                placeholder: placeholder || label,
                id: id,
                ref: ref,
                value: value,
                disabled: disabled,
                readOnly: readOnly,
                required: required,
                "aria-invalid": isInvalid ? "true" : undefined,
                "aria-required": required ? "true" : undefined,
                isInvalid: isInvalid,
                isFilled: isFilled,
                isActive: !!appearActive,
                onChange: function onChange1(event) {
                    setIsFilled(!!event.target.value);
                    if (typeof onChange === "function") {
                        onChange(event);
                    }
                }
            })),
            icon,
            type === "password" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleButton, {
                type: "button",
                isInvalid: isInvalid,
                "data-testid": "".concat(id, "-visibility-toggle"),
                "aria-label": showValue ? "Hide" : "Show",
                onClick: function onClick() {
                    setShowValue(!showValue);
                },
                children: showValue ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((Show_default()), {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((Hide_default()), {})
            }),
            isInvalid && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ErrorMessage/* ErrorMessage */.B, {
                children: [
                    " ",
                    error
                ]
            })
        ]
    });
});
Input_Input.defaultProps = Input_defaultProps;


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Input/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Logo/Logo.styles.ts


var StyledSvg = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", (0,src_define_property/* default */.Z)({
    target: "em8334i0"
}, "target", "em8334i0"))("display:block;");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Logo/Logo.tsx





var Logo = function Logo(_param) /*#__PURE__*/ {
    var width = _param.width, height = _param.height, viewBox = _param.viewBox, title = _param.title, children = _param.children, _responsive = _param.responsive, responsive = _responsive === void 0 ? false : _responsive, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height",
        "viewBox",
        "title",
        "children",
        "responsive"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        responsive: responsive,
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: viewBox,
        role: "img",
        "aria-label": title
    }, rest), {
        children: children
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/MaskedLink/MaskedLink.styles.ts


var MaskedLinkButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e8bs6yp0"
}, "target", "e8bs6yp0"))("background:none;border:none;padding:0;margin:0;cursor:pointer;color:inherit;text-decoration:inherit;display:inline;font-size:inherit;font-weight:inherit;");

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/MaskedLink/MaskedLink.tsx


var MaskedLink = function MaskedLink(param) {
    var body = param.body, href = param.href, target = param.target, title = param.title, className = param.className, onClick = param.onClick;
    if (!href) {
        return null;
    }
    var openLink = function openLink(event) {
        if (typeof onClick === "function") {
            onClick(event);
        }
        if (target && target !== "_self") {
            window.open(href, target);
        } else {
            window.location.href = href;
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaskedLinkButton, {
        type: "button",
        onClick: openLink,
        title: title,
        className: className,
        children: body
    });
};

// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Close.js
var Close = __webpack_require__(2530);
var Close_default = /*#__PURE__*/__webpack_require__.n(Close);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Checked.js
var Checked = __webpack_require__(1691);
var Checked_default = /*#__PURE__*/__webpack_require__.n(Checked);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Info.js
var Info = __webpack_require__(1647);
var Info_default = /*#__PURE__*/__webpack_require__.n(Info);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Tipp.js
var Tipp = __webpack_require__(6006);
var Tipp_default = /*#__PURE__*/__webpack_require__.n(Tipp);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Warning.js
var Warning = __webpack_require__(7551);
var Warning_default = /*#__PURE__*/__webpack_require__.n(Warning);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Message/Message.types.ts
var MessageSeverity;
(function(MessageSeverity) {
    MessageSeverity["TIP"] = "tip";
    MessageSeverity["INFO"] = "info";
    MessageSeverity["ERROR"] = "error";
    MessageSeverity["SUCCESS"] = "success";
})(MessageSeverity || (MessageSeverity = {}));
var MessageRole;
(function(MessageRole) {
    MessageRole["STATUS"] = "status";
    MessageRole["ALERT"] = "alert";
})(MessageRole || (MessageRole = {}));

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Message/Message.styles.ts









var getColorBySeverity = function getColorBySeverity(severity) {
    switch(severity){
        case MessageSeverity.SUCCESS:
            return "success";
        case MessageSeverity.ERROR:
            return "error";
        default:
            return "info";
    }
};
var Message_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ekyjnms0"
}, "target", "ekyjnms0"))("display:", function(param) {
    var visible = param.visible;
    return visible ? "flex" : "none";
}, ";margin:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, " 0;padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";border:", function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.color.natural20);
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";background:", function(param) {
    var theme = param.theme, severity = param.severity;
    return (0,polished_esm/* tint */.nV)(0.8, theme.color[getColorBySeverity(severity)]);
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.default;
}, ";font-size:1rem;line-height:1.5;");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ekyjnms1"
}, "target", "ekyjnms1"))("flex-grow:1;");
var Headline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ekyjnms2"
}, "target", "ekyjnms2"))("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";");
var IconStyles = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:0;width:1.5rem;height:1.5rem;");
var InfoIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Info_default()), (0,src_define_property/* default */.Z)({
    target: "ekyjnms3"
}, "target", "ekyjnms3"))(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";");
var TipIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Tipp_default()), (0,src_define_property/* default */.Z)({
    target: "ekyjnms4"
}, "target", "ekyjnms4"))(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";");
var ErrorIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Warning_default()), (0,src_define_property/* default */.Z)({
    target: "ekyjnms5"
}, "target", "ekyjnms5"))(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.error;
}, ";");
var SuccessIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((Checked_default()), (0,src_define_property/* default */.Z)({
    target: "ekyjnms6"
}, "target", "ekyjnms6"))(IconStyles, ";fill:", function(param) {
    var theme = param.theme;
    return theme.color.success;
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Message/Message.tsx







var Message_defaultProps = {
    severity: MessageSeverity.INFO,
    role: MessageRole.STATUS
};
var _obj;
var icons = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, MessageSeverity.TIP, TipIcon), (0,src_define_property/* default */.Z)(_obj, MessageSeverity.INFO, InfoIcon), (0,src_define_property/* default */.Z)(_obj, MessageSeverity.ERROR, ErrorIcon), (0,src_define_property/* default */.Z)(_obj, MessageSeverity.SUCCESS, SuccessIcon), _obj);
var Message = function Message(param) {
    var children = param.children, headline = param.headline, hasCloseButton = param.hasCloseButton, severity = param.severity, role = param.role;
    var ref = (0,react.useState)(true), visible = ref[0], setVisible = ref[1];
    var handleClose = function handleClose() {
        setVisible(false);
    };
    var Icon = icons[severity];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Message_styles_Wrapper, {
        role: role,
        "aria-live": role === MessageRole.STATUS ? "polite" : undefined,
        severity: severity,
        visible: visible,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                children: [
                    headline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline, {
                        children: headline
                    }),
                    children
                ]
            }),
            hasCloseButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* IconButton */.h, {
                icon: (Close_default()),
                title: "close" // @TODO: Add translation
                ,
                onClick: handleClose
            })
        ]
    });
};
Message.defaultProps = Message_defaultProps;


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Message/index.ts



// EXTERNAL MODULE: ../../frontend/shared/src/strings/index.ts + 5 modules
var strings = __webpack_require__(7263);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/PhoneNumber/PhoneNumber.styles.ts


var Anchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "e1fflh3v0"
}, "target", "e1fflh3v0"))("display:flex;flex-wrap:nowrap;align-items:center;color:inherit;text-decoration:inherit;");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/PhoneNumber/PhoneNumber.tsx



var PhoneNumber = function PhoneNumber(param) {
    var className = param.className, phoneNumber = param.phoneNumber, language = param.language, icon = param.icon;
    var pn = strings.parsePhoneNumber(phoneNumber, language);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Anchor, {
        className: className,
        href: pn.url,
        target: "_system",
        children: [
            icon,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: pn.national
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/portal/portal.js
var portal = __webpack_require__(5577);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(5559);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-event-listener.js
var use_event_listener = __webpack_require__(9410);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(586);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(8064);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(1742);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(2994);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-owner.js
var use_owner = __webpack_require__(592);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
function i(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return"button"}function use_resolve_button_type_T(t,e){let[n,u]=(0,react.useState)(()=>i(t));return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{u(i(t))},[t.type,t.as]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{n||e.current&&e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button")},[n,e]),n}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-root-containers.js
var use_root_containers = __webpack_require__(1638);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(3401);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction = __webpack_require__(859);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(6799);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(7215);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(5426);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(2929);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(3703);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(9833);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/render.js + 1 modules
var render = __webpack_require__(9206);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(9108);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/components/popover/popover.js
var he=(u=>(u[u.Open=0]="Open",u[u.Closed=1]="Closed",u))(he||{}),He=(e=>(e[e.TogglePopover=0]="TogglePopover",e[e.ClosePopover=1]="ClosePopover",e[e.SetButton=2]="SetButton",e[e.SetButtonId=3]="SetButtonId",e[e.SetPanel=4]="SetPanel",e[e.SetPanelId=5]="SetPanelId",e))(He||{});let Ge={[0]:t=>{let o={...t,popoverState:(0,match/* match */.E)(t.popoverState,{[0]:1,[1]:0})};return o.popoverState===0&&(o.__demoMode=!1),o},[1](t){return t.popoverState===1?t:{...t,popoverState:1}},[2](t,o){return t.button===o.button?t:{...t,button:o.button}},[3](t,o){return t.buttonId===o.buttonId?t:{...t,buttonId:o.buttonId}},[4](t,o){return t.panel===o.panel?t:{...t,panel:o.panel}},[5](t,o){return t.panelId===o.panelId?t:{...t,panelId:o.panelId}}},ue=(0,react.createContext)(null);ue.displayName="PopoverContext";function oe(t){let o=(0,react.useContext)(ue);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,oe),u}return o}let ie=(0,react.createContext)(null);ie.displayName="PopoverAPIContext";function fe(t){let o=(0,react.useContext)(ie);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,fe),u}return o}let Pe=(0,react.createContext)(null);Pe.displayName="PopoverGroupContext";function Ee(){return (0,react.useContext)(Pe)}let re=(0,react.createContext)(null);re.displayName="PopoverPanelContext";function Ne(){return (0,react.useContext)(re)}function ke(t,o){return (0,match/* match */.E)(o.type,Ge,t,o)}let we="div";function Ue(t,o){var B;let{__demoMode:u=!1,...M}=t,x=(0,react.useRef)(null),n=(0,use_sync_refs/* useSyncRefs */.T)(o,(0,use_sync_refs/* optionalRef */.h)(l=>{x.current=l})),e=(0,react.useRef)([]),c=(0,react.useReducer)(ke,{__demoMode:u,popoverState:u?0:1,buttons:e,button:null,buttonId:null,panel:null,panelId:null,beforePanelSentinel:(0,react.createRef)(),afterPanelSentinel:(0,react.createRef)()}),[{popoverState:f,button:s,buttonId:I,panel:a,panelId:v,beforePanelSentinel:y,afterPanelSentinel:A},P]=c,p=(0,use_owner/* useOwnerDocument */.i)((B=x.current)!=null?B:s),E=(0,react.useMemo)(()=>{if(!s||!a)return!1;for(let W of document.querySelectorAll("body > *"))if(Number(W==null?void 0:W.contains(s))^Number(W==null?void 0:W.contains(a)))return!0;let l=(0,focus_management/* getFocusableElements */.GO)(),S=l.indexOf(s),q=(S+l.length-1)%l.length,U=(S+1)%l.length,z=l[q],be=l[U];return!a.contains(z)&&!a.contains(be)},[s,a]),F=(0,use_latest_value/* useLatestValue */.E)(I),D=(0,use_latest_value/* useLatestValue */.E)(v),_=(0,react.useMemo)(()=>({buttonId:F,panelId:D,close:()=>P({type:1})}),[F,D,P]),O=Ee(),L=O==null?void 0:O.registerPopover,$=(0,use_event/* useEvent */.z)(()=>{var l;return(l=O==null?void 0:O.isFocusWithinPopoverGroup())!=null?l:(p==null?void 0:p.activeElement)&&((s==null?void 0:s.contains(p.activeElement))||(a==null?void 0:a.contains(p.activeElement)))});(0,react.useEffect)(()=>L==null?void 0:L(_),[L,_]);let[i,b]=(0,portal/* useNestedPortals */.k)(),T=(0,use_root_containers/* useRootContainers */.v)({mainTreeNodeRef:O==null?void 0:O.mainTreeNodeRef,portals:i,defaultContainers:[s,a]});(0,use_event_listener/* useEventListener */.O)(p==null?void 0:p.defaultView,"focus",l=>{var S,q,U,z;l.target!==window&&l.target instanceof HTMLElement&&f===0&&($()||s&&a&&(T.contains(l.target)||(q=(S=y.current)==null?void 0:S.contains)!=null&&q.call(S,l.target)||(z=(U=A.current)==null?void 0:U.contains)!=null&&z.call(U,l.target)||P({type:1})))},!0),(0,use_outside_click/* useOutsideClick */.O)(T.resolveContainers,(l,S)=>{P({type:1}),(0,focus_management/* isFocusableElement */.sP)(S,focus_management/* FocusableMode.Loose */.tJ.Loose)||(l.preventDefault(),s==null||s.focus())},f===0);let d=(0,use_event/* useEvent */.z)(l=>{P({type:1});let S=(()=>l?l instanceof HTMLElement?l:"current"in l&&l.current instanceof HTMLElement?l.current:s:s)();S==null||S.focus()}),r=(0,react.useMemo)(()=>({close:d,isPortalled:E}),[d,E]),m=(0,react.useMemo)(()=>({open:f===0,close:d}),[f,d]),g={ref:n};return react.createElement(re.Provider,{value:null},react.createElement(ue.Provider,{value:c},react.createElement(ie.Provider,{value:r},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(f,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},react.createElement(b,null,(0,render/* render */.sY)({ourProps:g,theirProps:M,slot:m,defaultTag:we,name:"Popover"}),react.createElement(T.MainTreeNode,null))))))}let We="button";function Ke(t,o){let u=(0,use_id/* useId */.M)(),{id:M=`headlessui-popover-button-${u}`,...x}=t,[n,e]=oe("Popover.Button"),{isPortalled:c}=fe("Popover.Button"),f=(0,react.useRef)(null),s=`headlessui-focus-sentinel-${(0,use_id/* useId */.M)()}`,I=Ee(),a=I==null?void 0:I.closeOthers,y=Ne()!==null;(0,react.useEffect)(()=>{if(!y)return e({type:3,buttonId:M}),()=>{e({type:3,buttonId:null})}},[y,M,e]);let[A]=(0,react.useState)(()=>Symbol()),P=(0,use_sync_refs/* useSyncRefs */.T)(f,o,y?null:r=>{if(r)n.buttons.current.push(A);else{let m=n.buttons.current.indexOf(A);m!==-1&&n.buttons.current.splice(m,1)}n.buttons.current.length>1&&console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."),r&&e({type:2,button:r})}),p=(0,use_sync_refs/* useSyncRefs */.T)(f,o),E=(0,use_owner/* useOwnerDocument */.i)(f),F=(0,use_event/* useEvent */.z)(r=>{var m,g,B;if(y){if(n.popoverState===1)return;switch(r.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:r.preventDefault(),(g=(m=r.target).click)==null||g.call(m),e({type:1}),(B=n.button)==null||B.focus();break}}else switch(r.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:r.preventDefault(),r.stopPropagation(),n.popoverState===1&&(a==null||a(n.buttonId)),e({type:0});break;case keyboard/* Keys.Escape */.R.Escape:if(n.popoverState!==0)return a==null?void 0:a(n.buttonId);if(!f.current||E!=null&&E.activeElement&&!f.current.contains(E.activeElement))return;r.preventDefault(),r.stopPropagation(),e({type:1});break}}),D=(0,use_event/* useEvent */.z)(r=>{y||r.key===keyboard/* Keys.Space */.R.Space&&r.preventDefault()}),_=(0,use_event/* useEvent */.z)(r=>{var m,g;(0,bugs/* isDisabledReactIssue7711 */.P)(r.currentTarget)||t.disabled||(y?(e({type:1}),(m=n.button)==null||m.focus()):(r.preventDefault(),r.stopPropagation(),n.popoverState===1&&(a==null||a(n.buttonId)),e({type:0}),(g=n.button)==null||g.focus()))}),O=(0,use_event/* useEvent */.z)(r=>{r.preventDefault(),r.stopPropagation()}),L=n.popoverState===0,$=(0,react.useMemo)(()=>({open:L}),[L]),i=use_resolve_button_type_T(t,f),b=y?{ref:p,type:i,onKeyDown:F,onClick:_}:{ref:P,id:n.buttonId,type:i,"aria-expanded":n.popoverState===0,"aria-controls":n.panel?n.panelId:void 0,onKeyDown:F,onKeyUp:D,onClick:_,onMouseDown:O},T=(0,use_tab_direction/* useTabDirection */.l)(),d=(0,use_event/* useEvent */.z)(()=>{let r=n.panel;if(!r)return;function m(){(0,match/* match */.E)(T.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>(0,focus_management/* focusIn */.jA)(r,focus_management/* Focus.First */.TO.First),[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>(0,focus_management/* focusIn */.jA)(r,focus_management/* Focus.Last */.TO.Last)})===focus_management/* FocusResult.Error */.fE.Error&&(0,focus_management/* focusIn */.jA)((0,focus_management/* getFocusableElements */.GO)().filter(B=>B.dataset.headlessuiFocusGuard!=="true"),(0,match/* match */.E)(T.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:focus_management/* Focus.Next */.TO.Next,[use_tab_direction/* Direction.Backwards */.N.Backwards]:focus_management/* Focus.Previous */.TO.Previous}),{relativeTo:n.button})}m()});return react.createElement(react.Fragment,null,(0,render/* render */.sY)({ourProps:b,theirProps:x,slot:$,defaultTag:We,name:"Popover.Button"}),L&&!y&&c&&react.createElement(internal_hidden/* Hidden */._,{id:s,features:internal_hidden/* Features.Focusable */.A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:d}))}let je="div",Ve=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function $e(t,o){let u=(0,use_id/* useId */.M)(),{id:M=`headlessui-popover-overlay-${u}`,...x}=t,[{popoverState:n},e]=oe("Popover.Overlay"),c=(0,use_sync_refs/* useSyncRefs */.T)(o),f=(0,open_closed/* useOpenClosed */.oJ)(),s=(()=>f!==null?(f&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open:n===0)(),I=(0,use_event/* useEvent */.z)(y=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(y.currentTarget))return y.preventDefault();e({type:1})}),a=(0,react.useMemo)(()=>({open:n===0}),[n]);return (0,render/* render */.sY)({ourProps:{ref:c,id:M,"aria-hidden":!0,onClick:I},theirProps:x,slot:a,defaultTag:je,features:Ve,visible:s,name:"Popover.Overlay"})}let Je="div",Xe=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function Ye(t,o){let u=(0,use_id/* useId */.M)(),{id:M=`headlessui-popover-panel-${u}`,focus:x=!1,...n}=t,[e,c]=oe("Popover.Panel"),{close:f,isPortalled:s}=fe("Popover.Panel"),I=`headlessui-focus-sentinel-before-${(0,use_id/* useId */.M)()}`,a=`headlessui-focus-sentinel-after-${(0,use_id/* useId */.M)()}`,v=(0,react.useRef)(null),y=(0,use_sync_refs/* useSyncRefs */.T)(v,o,i=>{c({type:4,panel:i})}),A=(0,use_owner/* useOwnerDocument */.i)(v),P=(0,render/* useMergeRefsFn */.Y2)();(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(c({type:5,panelId:M}),()=>{c({type:5,panelId:null})}),[M,c]);let p=(0,open_closed/* useOpenClosed */.oJ)(),E=(()=>p!==null?(p&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open:e.popoverState===0)(),F=(0,use_event/* useEvent */.z)(i=>{var b;switch(i.key){case keyboard/* Keys.Escape */.R.Escape:if(e.popoverState!==0||!v.current||A!=null&&A.activeElement&&!v.current.contains(A.activeElement))return;i.preventDefault(),i.stopPropagation(),c({type:1}),(b=e.button)==null||b.focus();break}});(0,react.useEffect)(()=>{var i;t.static||e.popoverState===1&&((i=t.unmount)==null||i)&&c({type:4,panel:null})},[e.popoverState,t.unmount,t.static,c]),(0,react.useEffect)(()=>{if(e.__demoMode||!x||e.popoverState!==0||!v.current)return;let i=A==null?void 0:A.activeElement;v.current.contains(i)||(0,focus_management/* focusIn */.jA)(v.current,focus_management/* Focus.First */.TO.First)},[e.__demoMode,x,v,e.popoverState]);let D=(0,react.useMemo)(()=>({open:e.popoverState===0,close:f}),[e,f]),_={ref:y,id:M,onKeyDown:F,onBlur:x&&e.popoverState===0?i=>{var T,d,r,m,g;let b=i.relatedTarget;b&&v.current&&((T=v.current)!=null&&T.contains(b)||(c({type:1}),((r=(d=e.beforePanelSentinel.current)==null?void 0:d.contains)!=null&&r.call(d,b)||(g=(m=e.afterPanelSentinel.current)==null?void 0:m.contains)!=null&&g.call(m,b))&&b.focus({preventScroll:!0})))}:void 0,tabIndex:-1},O=(0,use_tab_direction/* useTabDirection */.l)(),L=(0,use_event/* useEvent */.z)(()=>{let i=v.current;if(!i)return;function b(){(0,match/* match */.E)(O.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>{var d;(0,focus_management/* focusIn */.jA)(i,focus_management/* Focus.First */.TO.First)===focus_management/* FocusResult.Error */.fE.Error&&((d=e.afterPanelSentinel.current)==null||d.focus())},[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>{var T;(T=e.button)==null||T.focus({preventScroll:!0})}})}b()}),$=(0,use_event/* useEvent */.z)(()=>{let i=v.current;if(!i)return;function b(){(0,match/* match */.E)(O.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>{var B;if(!e.button)return;let T=(0,focus_management/* getFocusableElements */.GO)(),d=T.indexOf(e.button),r=T.slice(0,d+1),g=[...T.slice(d+1),...r];for(let l of g.slice())if(l.dataset.headlessuiFocusGuard==="true"||(B=e.panel)!=null&&B.contains(l)){let S=g.indexOf(l);S!==-1&&g.splice(S,1)}(0,focus_management/* focusIn */.jA)(g,focus_management/* Focus.First */.TO.First,{sorted:!1})},[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>{var d;(0,focus_management/* focusIn */.jA)(i,focus_management/* Focus.Previous */.TO.Previous)===focus_management/* FocusResult.Error */.fE.Error&&((d=e.button)==null||d.focus())}})}b()});return react.createElement(re.Provider,{value:M},E&&s&&react.createElement(internal_hidden/* Hidden */._,{id:I,ref:e.beforePanelSentinel,features:internal_hidden/* Features.Focusable */.A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:L}),(0,render/* render */.sY)({mergeRefs:P,ourProps:_,theirProps:n,slot:D,defaultTag:Je,features:Xe,visible:E,name:"Popover.Panel"}),E&&s&&react.createElement(internal_hidden/* Hidden */._,{id:a,ref:e.afterPanelSentinel,features:internal_hidden/* Features.Focusable */.A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:$}))}let qe="div";function ze(t,o){let u=(0,react.useRef)(null),M=(0,use_sync_refs/* useSyncRefs */.T)(u,o),[x,n]=(0,react.useState)([]),e=(0,use_root_containers/* useMainTreeNode */.H)(),c=(0,use_event/* useEvent */.z)(P=>{n(p=>{let E=p.indexOf(P);if(E!==-1){let F=p.slice();return F.splice(E,1),F}return p})}),f=(0,use_event/* useEvent */.z)(P=>(n(p=>[...p,P]),()=>c(P))),s=(0,use_event/* useEvent */.z)(()=>{var E;let P=(0,owner/* getOwnerDocument */.r)(u);if(!P)return!1;let p=P.activeElement;return(E=u.current)!=null&&E.contains(p)?!0:x.some(F=>{var D,_;return((D=P.getElementById(F.buttonId.current))==null?void 0:D.contains(p))||((_=P.getElementById(F.panelId.current))==null?void 0:_.contains(p))})}),I=(0,use_event/* useEvent */.z)(P=>{for(let p of x)p.buttonId.current!==P&&p.close()}),a=(0,react.useMemo)(()=>({registerPopover:f,unregisterPopover:c,isFocusWithinPopoverGroup:s,closeOthers:I,mainTreeNodeRef:e.mainTreeNodeRef}),[f,c,s,I,e.mainTreeNodeRef]),v=(0,react.useMemo)(()=>({}),[]),y=t,A={ref:M};return react.createElement(Pe.Provider,{value:a},(0,render/* render */.sY)({ourProps:A,theirProps:y,slot:v,defaultTag:qe,name:"Popover.Group"}),react.createElement(e.MainTreeNode,null))}let Qe=(0,render/* forwardRefWithAs */.yV)(Ue),Ze=(0,render/* forwardRefWithAs */.yV)(Ke),et=(0,render/* forwardRefWithAs */.yV)($e),tt=(0,render/* forwardRefWithAs */.yV)(Ye),ot=(0,render/* forwardRefWithAs */.yV)(ze),Ct=Object.assign(Qe,{Button:Ze,Overlay:et,Panel:tt,Group:ot});

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ../../node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(8435);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/usePopper.js





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
// EXTERNAL MODULE: ../../node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(6883);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useClickAway.js


var defaultEvents = ['mousedown', 'touchstart'];
var useClickAway = function (ref, onClickAway, events) {
    if (events === void 0) { events = defaultEvents; }
    var savedCallback = (0,react.useRef)(onClickAway);
    (0,react.useEffect)(function () {
        savedCallback.current = onClickAway;
    }, [onClickAway]);
    (0,react.useEffect)(function () {
        var handler = function (event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var eventName = events_1[_i];
            (0,util.on)(document, eventName, handler);
        }
        return function () {
            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
                var eventName = events_2[_i];
                (0,util/* off */.S1)(document, eventName, handler);
            }
        };
    }, [events, ref]);
};
/* harmony default export */ var esm_useClickAway = (useClickAway);

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Popover/Popover.styles.ts


function Popover_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        bottom: 15px;\n      "
    ]);
    Popover_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Popover_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        top: 15px;\n      "
    ]);
    Popover_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Popover_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        right: 15px;\n      "
    ]);
    Popover_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Popover_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        left: 15px;\n      "
    ]);
    Popover_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Popover_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        transform: rotate(225deg);\n      "
    ]);
    Popover_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        transform: rotate(135deg);\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        transform: rotate(315deg);\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        transform: rotate(45deg);\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var HUIPopoverWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ea5ng6x0"
}, "target", "ea5ng6x0"))("position:relative;z-index:20;width:100%;&:hover{/* make sure other popovers are beneath the current one */\n    z-index:30;}& > div[data-headlessui-state]{/* make sure the content box does not get larger then expected */\n    display:flex;}/** @TODO:Add transition using https://headlessui.com/react/transition */");
var PanelWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ea5ng6x1"
}, "target", "ea5ng6x1"))("margin:1.5rem;border-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* darken */._j)(0.01, theme.color.natural10);
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";border-width:3px;border-style:solid;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";box-shadow:0 0 rgb(0 0 0 / 0%),0 0 rgb(0 0 0 / 0%),", function(param) {
    var theme = param.theme;
    return theme.boxShadow.lg;
}, ";");
var PanelContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ea5ng6x2"
}, "target", "ea5ng6x2"))("position:relative;z-index:10;overflow:hidden;border-radius:0.75rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";width:", function(param) {
    var width = param.width;
    return width && width;
}, ";padding:", function(param) {
    var padding = param.padding;
    return padding && padding;
}, ";", (0,Theme.mq)("sm"), "{width:", function(param) {
    var widthMd = param.widthMd;
    return widthMd && widthMd;
}, ";}");
var ArrowPositioner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ea5ng6x3"
}, "target", "ea5ng6x3"))(function(param) {
    var position = param.position;
    if (position === "top") {
        return (0,emotion_react_browser_esm/* css */.iv)(Popover_styles_templateObject());
    }
    if (position === "bottom") {
        return (0,emotion_react_browser_esm/* css */.iv)(Popover_styles_templateObject1());
    }
    if (position === "left") {
        return (0,emotion_react_browser_esm/* css */.iv)(Popover_styles_templateObject2());
    }
    if (position === "right") {
        return (0,emotion_react_browser_esm/* css */.iv)(Popover_styles_templateObject3());
    }
    return "";
});
var Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ea5ng6x4"
}, "target", "ea5ng6x4"))("height:1.5rem;width:1.5rem;border-width:3px;border-top-style:solid;border-left-style:solid;border-color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* darken */._j)(0.01, theme.color.natural10);
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";box-shadow:0 0 rgb(0 0 0 / 0%),0 0 rgb(0 0 0 / 0%),0 6px 20px rgb(0 0 0 / 6%);clip-path:polygon(125% 0,0 0,0 125%);", function(param) {
    var position = param.position;
    if (position === "top") {
        return (0,emotion_react_browser_esm/* css */.iv)(Popover_styles_templateObject4());
    }
    if (position === "left") {
        return (0,emotion_react_browser_esm/* css */.iv)(_templateObject5());
    }
    if (position === "right") {
        return (0,emotion_react_browser_esm/* css */.iv)(_templateObject6());
    }
    if (position === "bottom") {
        return (0,emotion_react_browser_esm/* css */.iv)(_templateObject7());
    }
    return "";
});
var CloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* IconButton */.h, (0,src_define_property/* default */.Z)({
    target: "ea5ng6x5"
}, "target", "ea5ng6x5"))("color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";position:absolute;z-index:30;/* calculate 2x parent margin */\n  right:", function(param) {
    var theme = param.theme;
    return "calc(2*".concat(theme.spacing[50], ")");
}, ";top:", function(param) {
    var theme = param.theme;
    return "calc(2*".concat(theme.spacing[50], ")");
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Popover/ContentWrapper.tsx




var ContentWrapper = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        ref: ref,
        children: [
            onClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
                icon: (Close_default()),
                onClick: onClose
            }),
            children
        ]
    });
});

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Popover/useClickInside.ts

var useClickInside = function useClickInside(ref, callback) {
    var handleClick = function handleClick(e) {
        if (ref.current && ref.current.contains(e.target)) {
            callback(e.target);
        }
    };
    react.useEffect(function() {
        document.addEventListener("click", handleClick);
        return function() {
            document.removeEventListener("click", handleClick);
        };
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Popover/Popover.tsx










var Popover_defaultProps = {
    position: "bottom",
    triggerAction: "hover"
};
var Popover = function Popover(param) {
    var button = param.button, position = param.position, triggerAction = param.triggerAction, children = param.children;
    var ref = (0,react.useState)(null), referenceElement = ref[0], setReferenceElement = ref[1];
    var ref1 = (0,react.useState)(null), arrowElement = ref1[0], setArrowElement = ref1[1];
    var options = {
        placement: position,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            }
        ],
        strategy: "absolute"
    };
    var ref2 = (0,react.useState)(null), popperElement = ref2[0], setPopperElement = ref2[1];
    var ref3 = usePopper(referenceElement, popperElement, options), styles = ref3.styles, attributes = ref3.attributes;
    var ref4 = (0,react.useState)(false), showPopover = ref4[0], setShowPopover = ref4[1];
    var onMouseEnter = function onMouseEnter() {
        if (triggerAction === "hover") {
            setShowPopover(true);
        }
    };
    var onMouseLeave = function onMouseLeave() {
        if (triggerAction === "hover") {
            setShowPopover(false);
        }
    };
    var onClick = function onClick() {
        if (triggerAction === "click") {
            setShowPopover(!showPopover);
        }
    };
    var onCloseClick = function onCloseClick(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (referenceElement && !referenceElement.contains(event === null || event === void 0 ? void 0 : event.target)) {
            setShowPopover(false);
        }
    };
    var clickRef = (0,react.useRef)(null);
    esm_useClickAway(clickRef, onCloseClick, [
        "mouseup"
    ]);
    useClickInside(clickRef, function(target) {
        var ref, ref1;
        if (target && ((ref = target.tagName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "button" || ((ref1 = target.parentElement) === null || ref1 === void 0 ? void 0 : ref1.tagName.toLowerCase()) === "button") {
            setShowPopover(false);
        }
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HUIPopoverWrapper, {
        showing: showPopover,
        position: position,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ct, {
            onMouseEnter: function onMouseEnter1() {
                return onMouseEnter();
            },
            onMouseLeave: function onMouseLeave1() {
                return onMouseLeave();
            },
            children: function children1() {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ct.Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, button), {
                            ref: setReferenceElement,
                            onClick: function onClick1() {
                                return onClick();
                            }
                        })),
                        showPopover && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Ct.Panel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            static: true,
                            ref: setPopperElement,
                            style: styles.popper
                        }, attributes.popper), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
                                    ref: clickRef,
                                    onClose: triggerAction === "click" ? onCloseClick : undefined,
                                    children: children
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowPositioner, {
                                    ref: setArrowElement,
                                    style: styles.arrow,
                                    position: position,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
                                        position: position
                                    })
                                })
                            ]
                        }))
                    ]
                });
            }
        })
    });
};
Popover.defaultProps = Popover_defaultProps;


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Popover/PopoverPanel.tsx


var PopoverPanel = function PopoverPanel(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelWrapper, {
        children: children
    });
};


// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(204);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(2562);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/TextLink/TextLink.styles.ts


function TextLink_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin: 0;\n          padding: 0;\n          border: 0;\n          background: none;\n        "
    ]);
    TextLink_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", (0,src_define_property/* default */.Z)({
    target: "e1f73ny50"
}, "target", "e1f73ny50"))("display:inline-flex;align-items:center;column-gap:0.25rem;color:", function(param) {
    var theme = param.theme, variant = param.variant, blendIn = param.blendIn, $disabled = param.$disabled;
    if ($disabled) {
        return "#b6bfc1";
    }
    if (blendIn) {
        return "inherit";
    }
    return variant === "secondary" ? theme.color.natural70 : theme.color.primary;
}, ";font:inherit;text-decoration:", function(param) {
    var variant = param.variant, blendIn = param.blendIn, $disabled = param.$disabled;
    if ($disabled) {
        return "none";
    }
    return variant === "text" || blendIn ? "underline" : "none";
}, ";text-underline-offset:0.125rem;transition:text-underline-offset 0.2s linear;cursor:", function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "" : "pointer";
}, ";pointer-events:", function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "none" : "";
}, ";&:hover{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";text-decoration:", function(param) {
    var blendIn = param.blendIn;
    return blendIn ? "none" : "underline";
}, ";}&:focus-visible{border-radius:0.5rem;outline:0.125rem dashed ", function(param) {
    var theme = param.theme;
    return theme.color.natural70;
}, ";outline-offset:0.25rem;text-decoration:", function(param) {
    var blendIn = param.blendIn;
    return blendIn ? "none" : "underline";
}, ";}&:active{color:", function(param) {
    var theme = param.theme;
    return (0,polished_esm/* darken */._j)(0.08, theme === null || theme === void 0 ? void 0 : theme.color.primary);
}, ";text-decoration:", function(param) {
    var blendIn = param.blendIn;
    return blendIn ? "none" : "underline";
}, ";text-underline-offset:0.25rem;}", function(param) {
    var as = param.as;
    return as === "button" ? (0,emotion_react_browser_esm/* css */.iv)(TextLink_styles_templateObject()) : "";
});


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/TextLink/TextLink.tsx






var TextLink = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, text = _param.text, _as = _param.as, as = _as === void 0 ? "a" : _as, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _blendIn = _param.blendIn, blendIn = _blendIn === void 0 ? false : _blendIn, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "text",
        "as",
        "variant",
        "disabled",
        "blendIn"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        type: as === "button" ? "button" : undefined
    }, props), {
        href: as === "button" ? undefined : props.href,
        as: as,
        variant: variant,
        $disabled: disabled,
        disabled: disabled && as === "button" ? disabled : undefined,
        "aria-disabled": disabled ? "true" : undefined,
        blendIn: blendIn,
        children: children || text
    }));
});


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/TextLink/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/rules.ts
var rules_RichTextStyle;
(function(RichTextStyle) {
    RichTextStyle["Primary"] = "primary";
    RichTextStyle["Alternative"] = "alternative";
    RichTextStyle["Muted"] = "muted";
})(rules_RichTextStyle || (rules_RichTextStyle = {}));

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/ContentfulRichText/ContentfulRichText.styles.ts



var getTextStyleRules = function getTextStyleRules(rules) {
    var hasSpacedParagraphs = typeof (rules === null || rules === void 0 ? void 0 : rules.hasSpacedParagraphs) === "undefined" ? true : rules.hasSpacedParagraphs;
    var style = typeof (rules === null || rules === void 0 ? void 0 : rules.style) === "undefined" ? rules_RichTextStyle.Primary : rules.style;
    return {
        hasSpacedParagraphs: hasSpacedParagraphs,
        style: style
    };
};
var setColor = function setColor(rules) {
    var style = getTextStyleRules(rules).style;
    return style === rules_RichTextStyle.Muted ? "grey" : "";
};
var setTextColor = function setTextColor(rules) {
    var style = getTextStyleRules(rules).style;
    return style === rules_RichTextStyle.Alternative ? "white" : "";
};
var setMarginTop = function setMarginTop(rules) {
    var hasSpacedParagraphs = getTextStyleRules(rules).hasSpacedParagraphs;
    return hasSpacedParagraphs ? "1.5rem" : "";
};
var ContentfulRichTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("article", (0,src_define_property/* default */.Z)({
    target: "esk2qr00"
}, "target", "esk2qr00"))("font-size:1.063rem;font-weight:400;line-height:1.588em;& > p:not(:first-of-type){margin-top:", function(p) {
    return setMarginTop(p.textStyle);
}, ";}& > p,& > p > a,& > ol > li,& > ul > li{color:", function(p) {
    return setTextColor(p.textStyle);
}, ";}color:", function(p) {
    return setColor(p.textStyle);
}, ";a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";}ul{list-style-type:disc;padding-left:1.25rem;}ol{list-style-type:decimal;padding-left:1.25rem;}p{white-space:pre-wrap;}& > p + h2{margin-top:3rem;}& > table{width:100%;border:none;margin:1rem 0 3rem;padding:0;font-size:1rem;line-height:1.5rem;td{padding:0.625rem;border:none;}th{margin:0.375rem;padding:0.375rem;text-align:left;}tbody > tr:first-of-type td,tr th{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}thead + tbody > tr:first-of-type td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";}tr:nth-of-type(odd),tr:nth-of-type(odd) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, ";}tr:nth-of-type(even),tr:nth-of-type(even) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}}");
var BoldWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("strong", (0,src_define_property/* default */.Z)({
    target: "esk2qr01"
}, "target", "esk2qr01"))("font-weight:bold;");
var ItalicWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("i", (0,src_define_property/* default */.Z)({
    target: "esk2qr02"
}, "target", "esk2qr02"))("font-style:italic;");
var UnderlineWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "esk2qr03"
}, "target", "esk2qr03"))("text-decoration:underline;");


// EXTERNAL MODULE: ../../frontend/shared/src/Text/index.ts + 21 modules
var Text = __webpack_require__(2408);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/ContentfulRichText/options.tsx






var options_obj, _obj1;
var options = {
    renderMark: (options_obj = {}, (0,src_define_property/* default */.Z)(options_obj, dist.MARKS.BOLD, function(text) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoldWrapper, {
            children: text
        });
    }), (0,src_define_property/* default */.Z)(options_obj, dist.MARKS.ITALIC, function(text) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItalicWrapper, {
            children: text
        });
    }), (0,src_define_property/* default */.Z)(options_obj, dist.MARKS.UNDERLINE, function(text) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnderlineWrapper, {
            children: text
        });
    }), options_obj),
    renderNode: (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, dist.INLINES.HYPERLINK, function(param, children) {
        var data = param.data;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextLink, {
            href: data.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            variant: "text",
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_2, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Heading2 */.XJ, {
            textColor: "current",
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_3, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Heading3 */.aC, {
            textColor: "current",
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_4, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Heading4 */.k8, {
            textColor: "current",
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_5, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Heading5 */.by, {
            textColor: "current",
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.HEADING_6, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Heading6 */.Cd, {
            textColor: "current",
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.OL_LIST, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ol", {
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.UL_LIST, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.LIST_ITEM, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.TABLE, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("table", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                children: children
            })
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.TABLE_ROW, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.TABLE_CELL, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
            children: children
        });
    }), (0,src_define_property/* default */.Z)(_obj1, dist.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
            children: children
        });
    }), _obj1)
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/ContentfulRichText/ContentfulRichText.tsx




var ContentfulRichText = function ContentfulRichText(param) {
    var content = param.content, rules = param.rules;
    var document = content.text;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentfulRichTextWrapper, {
        textStyle: rules === null || rules === void 0 ? void 0 : rules.textStyle,
        children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(document, options)
    });
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/ContentfulRichText/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/MarkupRichText/MarkupRichText.styles.ts


var MarkupContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eolkwut0"
}, "target", "eolkwut0"))("box-sizing:border-box;p{font-size:0.875rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin-bottom:1rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1rem;}&:last-of-type{margin-bottom:0;}}ol{font-size:0.875rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin-bottom:1rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1rem;}}a{&:link,&:visited{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:underline;}&:hover,&:focus,&:active{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:none;}&:not([href]){&:hover,&:focus,&:active{color:inherit;text-decoration:inherit;}}}h1{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin:0 0 1.25rem;font-size:1.875rem;line-height:1.875rem;}h2{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin:0 0 1rem;font-size:1.375rem;font-weight:normal;line-height:1.125;}h3{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin:1.5rem 0 1rem;font-size:1.125rem;font-weight:normal;}ul{list-style-position:outside;list-style-type:disc;padding-left:1.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";line-height:1.5;&.three-row,&.two-row{overflow:hidden;}&.three-row li,&.two-row li{float:left;}&.three-row li{width:33.333%;}&.two-row li{width:50%;padding-left:0.625rem;}&.places-pin{list-style:none;}&.places-pin > li::before{content:'V';color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";font-family:bmfont,serif;font-size:1.125rem;margin-right:0.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1rem;}}/* native collapsibles using <details> / <summary> */\n  details{border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";&:last-of-type:not(:last-child){margin-bottom:1.25rem;border-bottom:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";}> summary:first-of-type{list-style-type:none;}summary{position:relative;margin-bottom:1.25rem;padding-right:2.225rem;min-height:1.6rem;/* if no content is provided,at least keep it the same height as the icon */\n      cursor:pointer;&:focus:not(:focus-visible){outline:0;}&::marker,&::-webkit-details-marker{display:none;}&::after{content:'';position:absolute;top:0;right:0;width:1.6rem;height:1.6rem;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAyNSI+PHBhdGggZD0iTTE5Ljg1OSA3Ljc1M2wtNy4zNiA3LjMxLTcuMzU4LTcuMzA5YS44NzEuODcxIDAgMCAwLTEuMjI2IDAgLjg1Ny44NTcgMCAwIDAgMCAxLjIxOEwxMi41IDE3LjVsNS4xMjgtNS4wOTMgMy40NTgtMy40MzVhLjg1OC44NTggMCAwIDAgMC0xLjIxOC44NjguODY4IDAgMCAwLTEuMjI3IDB6Ii8+PC9zdmc+Cg==');transition:0.2s linear transform;}}&[open] summary{&::after{transform:scaleY(-1);}}p{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin-bottom:0.625rem;}}.tip-box{display:inline-block;width:100%;font-size:1rem;line-height:1.5rem;& > strong{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";display:block;width:100%;padding:0.5rem 0.625rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";position:relative;}& > strong::after{content:'';position:absolute;top:100%;left:50%;margin-left:-10px;width:0;height:0;border-top:solid 10px ", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";border-left:solid 10px transparent;border-right:solid 10px transparent;}.content{padding:0.625rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-top:none;}}& table{width:100%;border:none !important;margin:0 !important;padding:0 !important;font-size:1rem;line-height:1.5rem;td{padding:0.625rem !important;border:none !important;}tbody > tr:first-of-type td,thead tr th{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, " !important;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " !important;border:none !important;}thead + tbody > tr:first-of-type td{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, " !important;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, " !important;}tr:nth-of-type(odd),tr:nth-of-type(odd) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, " !important;}tr:nth-of-type(even),tr:nth-of-type(even) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " !important;border:none !important;}}");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/MarkupRichText/MarkupRichText.tsx


var MarkupRichText = function MarkupRichText(param) {
    var content = param.content;
    if (!(content === null || content === void 0 ? void 0 : content.text)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarkupContainer, {
        dangerouslySetInnerHTML: {
            __html: content.text
        }
    });
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/MarkupRichText/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/RichText.tsx



var RichText = function RichText(param) {
    var content = param.content, rules = param.rules;
    if (!content) {
        return null;
    }
    if (content.type === "html-string") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarkupRichText, {
            content: content
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentfulRichText, {
        content: content,
        rules: rules
    });
};

;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/RichText/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/TabNavigation.styles.ts



var NavContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "evia81t0"
}, "target", "evia81t0"))("width:100%;");
var Nav = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", (0,src_define_property/* default */.Z)({
    target: "evia81t1"
}, "target", "evia81t1"))("border-bottom:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return "1px solid ".concat(textStyle === rules_RichTextStyle.Alternative ? theme.color.natural0 : theme.color.natural20);
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";scrollbar-width:none;overflow:auto clip;display:flex;");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/TabNavigation.tsx



var TabNavigation_TabNavigation = function TabNavigation(param) {
    var children = param.children, _textStyle = param.textStyle, textStyle = _textStyle === void 0 ? rules_RichTextStyle.Primary : _textStyle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav, {
            "aria-label": "Tabs",
            role: "tablist",
            textStyle: textStyle,
            children: children
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/TabButton.styles.ts



var styles = {
    active: {
        alternative: {
            color: "natural0",
            underlineColor: "natural0",
            underlineHoverColor: "primary70"
        },
        muted: {
            color: "secondary100",
            underlineColor: "primary70",
            underlineHoverColor: "primary70"
        },
        primary: {
            color: "secondary100",
            underlineColor: "primary70",
            underlineHoverColor: "primary70"
        }
    },
    inactive: {
        alternative: {
            color: "natural0",
            underlineColor: "natural0",
            underlineHoverColor: "natural0"
        },
        muted: {
            color: "natural30",
            underlineColor: "natural30",
            underlineHoverColor: "natural30"
        },
        primary: {
            color: "natural30",
            underlineColor: "natural30",
            underlineHoverColor: "natural30"
        }
    }
};
var ButtonBase = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e1sgs8xh0"
}, "target", "e1sgs8xh0"))("white-space:nowrap;padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";position:relative;cursor:pointer;border:0;background:transparent;&::after{background-color:", function(param) {
    var theme = param.theme, textStyle = param.textStyle;
    return theme.color[styles.active[textStyle].underlineColor];
}, ";border-top-left-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.xxs;
}, ";border-top-right-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.xxs;
}, ";content:'';transform:", function(param) {
    var theme = param.theme;
    return "translateY(".concat(theme.spacing[40], ")");
}, ";position:absolute;bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";left:0;height:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";width:100%;}");
var ActiveButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ButtonBase, (0,src_define_property/* default */.Z)({
    target: "e1sgs8xh1"
}, "target", "e1sgs8xh1"))(ButtonBase, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return theme.color[styles.active[textStyle].color];
}, ";");
var InactiveButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ButtonBase, (0,src_define_property/* default */.Z)({
    target: "e1sgs8xh2"
}, "target", "e1sgs8xh2"))(ButtonBase, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return theme.color[styles.inactive[textStyle].color];
}, ";&:hover{color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return theme.color[styles.active[textStyle].color];
}, ";&::after{display:initial;background-color:", function(param) {
    var theme = param.theme, textStyle = param.textStyle;
    return (0,polished_esm/* darken */._j)(0.1, theme.color[styles.inactive[textStyle].underlineHoverColor]);
}, ";}}&::after{display:none;}");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/TabButton.tsx




var TabButton_TabButton = function TabButton(param) {
    var onSelectTab = param.behavior.onSelectTab, _content = param.content, name = _content.name, position = _content.position, tabGroup = _content.tabGroup, rules = param.rules;
    var ref = rules || {}, activeTabName = ref.activeTabName, _textStyle = ref.textStyle, textStyle = _textStyle === void 0 ? rules_RichTextStyle.Primary : _textStyle;
    var isCurrentTab = activeTabName === name;
    var handleTabClick = function handleTabClick(ev) {
        ev.preventDefault();
        onSelectTab(name);
        ev.currentTarget.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center"
        });
    };
    var Button = isCurrentTab ? ActiveButton : InactiveButton;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
        "aria-selected": isCurrentTab,
        "aria-controls": "".concat(tabGroup, "-panel-").concat(position),
        id: "".concat(tabGroup, "-tab-").concat(position),
        onClick: handleTabClick,
        role: "tab",
        type: "button",
        textStyle: textStyle,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* InteractiveText */.G9, {
            inline: true,
            textColor: "current",
            children: name
        })
    }, name);
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/Tabs.styles.ts



var Tabs_styles_Section = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("section", _define_property({
    target: "e1yivaib0"
}, "target", "e1yivaib0"))("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";display:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "block";
}, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return textStyle === RichTextStyle.Alternative ? theme.color.natural0 : theme.color.secondary100;
}, ";")));


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/Tabs.tsx






var Tabs = function Tabs(param) {
    var _textStyle = param.textStyle, textStyle = _textStyle === void 0 ? RichTextStyle.Primary : _textStyle, tabs = param.tabs;
    var ref = useState(tabs[0].name), current = ref[0], setCurrent = ref[1];
    var tabGroup = "tabGroup-".concat(useId());
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TabNavigation, {
                children: tabs.map(function(param, tabIdx) {
                    var name = param.name;
                    return /*#__PURE__*/ _jsx(TabButton, {
                        behavior: {
                            onSelectTab: setCurrent
                        },
                        content: {
                            name: name,
                            position: tabIdx,
                            tabGroup: tabGroup
                        },
                        rules: {
                            activeTabName: current,
                            textStyle: textStyle
                        }
                    }, "".concat(tabGroup, "-tab-").concat(name));
                })
            }),
            tabs.map(function(param, tabIdx) {
                var name = param.name, content = param.content;
                return /*#__PURE__*/ _jsx(Section, {
                    id: "".concat(tabGroup, "-panel-").concat(tabIdx),
                    isHidden: current !== name,
                    "aria-labelledby": "".concat(tabGroup, "-tab-").concat(tabIdx),
                    role: "tabpanel",
                    tabIndex: 0,
                    textStyle: textStyle,
                    children: content
                }, "".concat(tabGroup, "-panel-").concat(name));
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Tabs/index.ts





// EXTERNAL MODULE: ../../frontend/shared/src/Ui/Overlay/index.ts + 23 modules
var Overlay = __webpack_require__(4786);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/StoreLink/Storelink.styles.ts


var Svg = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", (0,src_define_property/* default */.Z)({
    target: "eon3n9f0"
}, "target", "eon3n9f0"))("vertical-align:bottom;");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/StoreLink/AppStoreLink.tsx






var title = "App Store";
var StoreLogo = function StoreLogo() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg, {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 180 52",
        role: "img",
        "aria-label": title,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#000",
                d: "M179 46.003c0 2.771-2.291 5.016-5.126 5.016H6.132C3.3 51.019 1 48.774 1 46.003v-40C1 3.234 3.3.982 6.132.982h167.741c2.836 0 5.126 2.253 5.126 5.023l.001 40Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#a6a6a6",
                d: "M173.333 1.042c3.087 0 5.599 2.449 5.599 5.458v39c0 3.01-2.512 5.458-5.599 5.458H6.667c-3.087 0-5.599-2.448-5.599-5.458v-39c0-3.01 2.512-5.458 5.599-5.458h166.666Zm0-1.042H6.667C3.002 0 0 2.927 0 6.5v39C0 49.073 3.002 52 6.667 52h166.666c3.665 0 6.667-2.927 6.667-6.5v-39c0-3.573-3.002-6.5-6.667-6.5Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                d: "M40.17 25.72c-.038-4.19 3.52-6.23 3.682-6.324-2.015-2.864-5.137-3.255-6.235-3.286-2.622-.27-5.166 1.53-6.502 1.53-1.363 0-3.42-1.504-5.638-1.46-2.853.043-5.522 1.653-6.986 4.155-3.022 5.1-.768 12.594 2.126 16.716 1.448 2.02 3.14 4.273 5.355 4.194 2.167-.087 2.976-1.347 5.59-1.347 2.591 0 3.351 1.347 5.61 1.296 2.325-.036 3.79-2.028 5.187-4.065 1.673-2.314 2.345-4.593 2.372-4.71-.055-.018-4.516-1.678-4.56-6.7Zm-4.266-12.322c1.165-1.421 1.963-3.354 1.741-5.316-1.686.073-3.796 1.138-5.01 2.527-1.075 1.225-2.035 3.232-1.787 5.12 1.895.138 3.84-.932 5.056-2.331Zm29.496-.386c0 1.53-.47 2.682-1.41 3.455-.871.714-2.109 1.071-3.711 1.071-.795 0-1.475-.034-2.044-.101v-8.36A15.463 15.463 0 0 1 60.64 8.9c1.527 0 2.678.324 3.454.97.869.733 1.305 1.78 1.305 3.142Zm-1.473.037c0-.992-.27-1.752-.808-2.282-.539-.53-1.326-.795-2.362-.795-.44 0-.814.029-1.125.089v6.355c.172.026.487.038.944.038 1.07 0 1.895-.29 2.476-.87.581-.58.875-1.424.875-2.535Zm9.285 1.299c0 .943-.276 1.715-.828 2.32-.579.623-1.345.934-2.303.934-.922 0-1.657-.298-2.205-.896-.547-.596-.82-1.349-.82-2.256 0-.95.281-1.728.847-2.333.565-.604 1.325-.907 2.282-.907.923 0 1.664.298 2.226.894.533.58.8 1.329.8 2.244Zm-1.45.044c0-.565-.125-1.05-.374-1.454-.293-.49-.71-.734-1.253-.734-.562 0-.988.245-1.282.734-.25.404-.374.897-.374 1.48 0 .565.125 1.05.374 1.454.303.489.724.733 1.268.733.534 0 .952-.248 1.254-.746.258-.412.388-.901.388-1.467Zm11.925-3.057-1.967 6.128h-1.28l-.815-2.661a19.48 19.48 0 0 1-.505-1.98h-.025c-.122.673-.29 1.332-.506 1.98l-.865 2.66h-1.295l-1.849-6.127h1.436l.71 2.913c.173.689.314 1.346.427 1.967h.026c.104-.512.276-1.165.518-1.954l.892-2.925h1.139l.855 2.863c.206.698.374 1.37.504 2.017h.038c.095-.63.238-1.302.427-2.017l.763-2.863h1.372v-.001Zm7.243 6.128h-1.397v-3.51c0-1.082-.421-1.622-1.266-1.622-.415 0-.75.148-1.01.446a1.558 1.558 0 0 0-.388 1.05v3.635h-1.397v-4.376c0-.538-.017-1.122-.05-1.754h1.227l.066.958h.038a1.99 1.99 0 0 1 .724-.74 2.407 2.407 0 0 1 1.267-.344c.587 0 1.075.185 1.463.555.482.454.724 1.131.724 2.03v3.672Zm3.854 0h-1.396v-8.94h1.396v8.94Zm8.227-3.115c0 .943-.276 1.715-.828 2.32-.579.623-1.347.934-2.303.934-.924 0-1.659-.298-2.205-.896-.547-.596-.82-1.349-.82-2.256 0-.95.281-1.728.846-2.333.566-.604 1.326-.907 2.282-.907.924 0 1.664.298 2.226.894.534.58.802 1.329.802 2.244Zm-1.451.044c0-.565-.125-1.05-.375-1.454-.292-.49-.71-.734-1.252-.734-.562 0-.99.245-1.281.734-.25.404-.375.897-.375 1.48 0 .565.126 1.05.375 1.454.303.489.724.733 1.268.733.533 0 .951-.248 1.252-.746.26-.412.388-.901.388-1.467Zm8.213 3.071h-1.254l-.104-.706h-.039c-.429.563-1.041.845-1.836.845-.593 0-1.073-.186-1.435-.555-.328-.335-.492-.753-.492-1.248 0-.749.32-1.32.964-1.715.643-.395 1.547-.589 2.711-.58v-.114c0-.807-.435-1.21-1.305-1.21-.62 0-1.167.152-1.639.454l-.284-.895c.584-.352 1.305-.529 2.156-.529 1.643 0 2.467.845 2.467 2.535v2.257c0 .612.03 1.1.09 1.461Zm-1.45-2.106v-.945c-1.542-.026-2.312.386-2.312 1.235 0 .32.088.559.268.719a.99.99 0 0 0 .682.239c.307 0 .594-.095.855-.283a1.157 1.157 0 0 0 .507-.965Zm9.39 2.106h-1.24l-.065-.984h-.039c-.396.749-1.07 1.123-2.018 1.123-.758 0-1.388-.29-1.888-.87-.5-.58-.75-1.332-.75-2.256 0-.992.271-1.796.815-2.41.527-.571 1.172-.857 1.94-.857.844 0 1.435.277 1.771.832h.026V8.523h1.399v7.289c0 .597.016 1.147.049 1.65Zm-1.448-2.585v-1.021c0-.177-.013-.32-.038-.43a1.544 1.544 0 0 0-.506-.825 1.393 1.393 0 0 0-.934-.334c-.522 0-.93.202-1.23.606-.297.404-.448.92-.448 1.55 0 .607.143 1.098.43 1.476.302.403.71.605 1.221.605.459 0 .825-.168 1.104-.505.269-.31.401-.685.401-1.121Zm13.399-.53c0 .943-.276 1.715-.828 2.32-.579.623-1.344.934-2.303.934-.921 0-1.656-.298-2.205-.896-.547-.596-.82-1.349-.82-2.256 0-.95.281-1.728.847-2.333.565-.604 1.325-.907 2.284-.907.921 0 1.664.298 2.224.894.533.58.801 1.329.801 2.244Zm-1.448.044c0-.565-.125-1.05-.375-1.454-.294-.49-.71-.734-1.254-.734-.56 0-.987.245-1.282.734-.25.404-.374.897-.374 1.48 0 .565.125 1.05.374 1.454.303.489.724.733 1.268.733.534 0 .954-.248 1.255-.746.257-.412.388-.901.388-1.467Zm8.961 3.071h-1.396v-3.51c0-1.082-.421-1.622-1.268-1.622-.414 0-.749.148-1.008.446a1.555 1.555 0 0 0-.388 1.05v3.635h-1.398v-4.376c0-.538-.016-1.122-.05-1.754h1.227l.065.958H133c.164-.297.407-.543.724-.74a2.42 2.42 0 0 1 1.268-.344c.585 0 1.073.185 1.461.555.484.454.724 1.131.724 2.03v3.672Zm9.404-5.108h-1.538v2.977c0 .757.273 1.135.814 1.135.251 0 .459-.02.623-.064l.036 1.034c-.276.101-.639.152-1.085.152-.552 0-.982-.164-1.292-.491-.312-.328-.467-.88-.467-1.653v-3.09h-.919v-1.02h.919V10.21l1.369-.402v1.524h1.539v1.022h.001Zm7.398 5.108h-1.399v-3.484c0-1.099-.421-1.648-1.265-1.648-.648 0-1.091.318-1.334.955a1.684 1.684 0 0 0-.065.49v3.686h-1.396v-8.94h1.396v3.694h.027c.44-.672 1.07-1.007 1.888-1.007.578 0 1.057.184 1.437.555.473.461.711 1.148.711 2.055v3.644Zm7.63-3.354c0 .244-.018.45-.052.617h-4.19c.018.606.218 1.068.606 1.387.355.287.812.43 1.372.43.62 0 1.186-.097 1.695-.29l.219.946c-.596.252-1.298.378-2.11.378-.973 0-1.74-.28-2.294-.838-.558-.56-.834-1.31-.834-2.25 0-.925.258-1.694.776-2.308.542-.655 1.274-.983 2.198-.983.904 0 1.59.328 2.054.983.375.52.56 1.164.56 1.928Zm-1.333-.352c.011-.405-.081-.753-.271-1.047-.242-.378-.612-.568-1.112-.568-.456 0-.828.185-1.112.555a2.03 2.03 0 0 0-.414 1.06h2.909ZM71.527 40.955h-3.028l-1.659-5.081h-5.765l-1.58 5.081h-2.948l5.712-17.3h3.528l5.74 17.3Zm-5.187-7.213-1.5-4.518c-.159-.462-.456-1.548-.895-3.26h-.053a123.23 123.23 0 0 1-.843 3.26l-1.473 4.518h4.764Zm19.876.822c0 2.122-.588 3.799-1.764 5.03-1.053 1.096-2.361 1.643-3.923 1.643-1.685 0-2.896-.59-3.633-1.77h-.053v6.571H74v-13.45c0-1.335-.036-2.704-.105-4.108h2.5l.158 1.978h.054c.948-1.49 2.386-2.234 4.317-2.234 1.51 0 2.77.581 3.777 1.745 1.011 1.165 1.515 2.696 1.515 4.595Zm-2.896.102c0-1.214-.28-2.215-.843-3.003-.614-.822-1.44-1.233-2.474-1.233-.702 0-1.339.23-1.908.68a3.142 3.142 0 0 0-1.119 1.785 3.544 3.544 0 0 0-.132.845v2.08c0 .908.285 1.673.856 2.299.57.625 1.312.937 2.224.937 1.07 0 1.904-.403 2.5-1.206.597-.805.896-1.866.896-3.184Zm17.612-.102c0 2.122-.588 3.799-1.765 5.03-1.052 1.096-2.36 1.643-3.922 1.643-1.685 0-2.896-.59-3.632-1.77h-.053v6.571h-2.843v-13.45c0-1.335-.036-2.704-.105-4.108h2.5l.159 1.978h.053c.947-1.49 2.385-2.234 4.317-2.234 1.508 0 2.768.581 3.779 1.745 1.007 1.165 1.512 2.696 1.512 4.595Zm-2.896.102c0-1.214-.281-2.215-.844-3.003-.615-.822-1.437-1.233-2.473-1.233-.703 0-1.34.23-1.91.68a3.14 3.14 0 0 0-1.117 1.785 3.595 3.595 0 0 0-.132.845v2.08c0 .908.285 1.673.853 2.299.57.624 1.312.937 2.227.937 1.07 0 1.904-.403 2.5-1.206.597-.805.896-1.866.896-3.184Zm19.349 1.438c0 1.471-.524 2.669-1.576 3.593-1.156 1.01-2.765 1.514-4.833 1.514-1.909 0-3.44-.358-4.599-1.077l.659-2.31a7.95 7.95 0 0 0 4.109 1.105c1.071 0 1.904-.237 2.503-.708.596-.47.893-1.102.893-1.89 0-.702-.245-1.293-.737-1.773-.489-.48-1.307-.926-2.448-1.338-3.107-1.13-4.659-2.784-4.659-4.96 0-1.423.544-2.589 1.634-3.496 1.085-.909 2.533-1.363 4.344-1.363 1.614 0 2.956.275 4.026.822l-.71 2.26c-1-.531-2.131-.796-3.396-.796-1 0-1.782.24-2.342.719-.473.427-.71.949-.71 1.566 0 .684.27 1.25.814 1.694.474.41 1.334.855 2.582 1.335 1.526.6 2.648 1.3 3.369 2.104.719.8 1.077 1.803 1.077 2.999Zm9.399-5.544h-3.133v6.057c0 1.54.552 2.31 1.658 2.31.508 0 .93-.043 1.263-.129l.079 2.105c-.56.204-1.298.307-2.211.307-1.123 0-2-.334-2.633-1.001-.631-.668-.948-1.789-.948-3.363v-6.288h-1.867v-2.08h1.867v-2.284l2.792-.822v3.106h3.133v2.082Zm14.137 4.055c0 1.918-.562 3.492-1.685 4.723-1.177 1.267-2.74 1.9-4.688 1.9-1.877 0-3.372-.608-4.487-1.822-1.114-1.214-1.672-2.747-1.672-4.594 0-1.933.574-3.517 1.724-4.748 1.148-1.232 2.698-1.848 4.646-1.848 1.877 0 3.388.607 4.528 1.822 1.09 1.18 1.634 2.702 1.634 4.567Zm-2.949.09c0-1.15-.252-2.137-.763-2.96-.596-.996-1.448-1.493-2.552-1.493-1.142 0-2.01.498-2.606 1.493-.511.824-.763 1.826-.763 3.012 0 1.15.252 2.137.763 2.959.614.995 1.473 1.492 2.581 1.492 1.085 0 1.937-.507 2.552-1.518.524-.839.788-1.836.788-2.985Zm12.189-3.787a5.054 5.054 0 0 0-.896-.077c-1 0-1.773.368-2.317 1.105-.473.65-.711 1.472-.711 2.464v6.545h-2.841l.027-8.546c0-1.438-.036-2.747-.107-3.927h2.476l.104 2.387h.079c.3-.82.773-1.481 1.421-1.977a3.495 3.495 0 0 1 2.055-.668c.262 0 .5.018.71.051v2.643Zm12.714 3.21c0 .496-.034.915-.104 1.257h-8.528c.033 1.232.445 2.175 1.237 2.825.719.58 1.648.872 2.789.872 1.263 0 2.415-.196 3.451-.59l.445 1.924c-1.21.515-2.64.77-4.289.77-1.984 0-3.541-.569-4.675-1.706-1.13-1.138-1.697-2.665-1.697-4.581 0-1.882.527-3.448 1.581-4.697 1.104-1.334 2.596-2.001 4.474-2.001 1.844 0 3.24.667 4.188 2 .75 1.06 1.128 2.37 1.128 3.927Zm-2.711-.72c.019-.82-.167-1.53-.552-2.13-.492-.77-1.248-1.156-2.265-1.156-.93 0-1.686.376-2.263 1.13-.473.6-.755 1.318-.841 2.155h5.921v.002Z"
            })
        ]
    });
};
var AppStoreLink = function AppStoreLink(_param) {
    var masked = _param.masked, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "masked"
    ]);
    if (masked) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaskedLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            title: title,
            body: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoreLogo, {})
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        title: title,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoreLogo, {})
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/StoreLink/PlayStoreLink.tsx






var PlayStoreLink_title = "Google Play Store";
var PlayStoreLink_StoreLogo = function StoreLogo() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg, {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 180 52",
        role: "img",
        "aria-label": PlayStoreLink_title,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#000",
                d: "M173.333 52H6.667C3.002 52 0 49.073 0 45.5v-39C0 2.927 3.002 0 6.667 0h166.666C176.998 0 180 2.927 180 6.5v39c0 3.573-3.002 6.5-6.667 6.5Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#A6A6A6",
                d: "M173.333 1.042c3.087 0 5.599 2.449 5.599 5.458v39c0 3.01-2.512 5.458-5.599 5.458H6.667c-3.087 0-5.599-2.448-5.599-5.458v-39c0-3.01 2.512-5.458 5.599-5.458h166.666Zm0-1.042H6.667C3.002 0 0 2.927 0 6.5v39C0 49.073 3.002 52 6.667 52h166.666c3.665 0 6.667-2.927 6.667-6.5v-39c0-3.573-3.002-6.5-6.667-6.5Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "url(#android-app-a)",
                d: "M13.913 9.8c-.391.4-.618 1.022-.618 1.828v28.75c0 .806.227 1.428.618 1.828l.097.088L30.533 26.19v-.38L14.01 9.706l-.097.094Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "url(#android-app-b)",
                d: "m36.035 31.56-5.502-5.37v-.38l5.509-5.37.123.07 6.523 3.618c1.862 1.027 1.862 2.717 0 3.75l-6.523 3.613-.13.07Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "url(#android-app-c)",
                d: "M36.165 31.49 30.533 26l-16.62 16.206c.619.634 1.627.71 2.774.076l19.478-10.791Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "url(#android-app-d)",
                d: "M36.165 20.51 16.687 9.717c-1.147-.628-2.155-.551-2.774.082L30.533 26l5.632-5.49Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                stroke: "#fff",
                strokeMiterlimit: "10",
                strokeWidth: ".16",
                d: "M63.223 13.317c0 1.085-.333 1.955-.99 2.603-.755.769-1.738 1.156-2.943 1.156-1.152 0-2.135-.394-2.942-1.169-.808-.786-1.211-1.752-1.211-2.907s.403-2.12 1.211-2.9c.807-.782 1.79-1.175 2.942-1.175.573 0 1.12.115 1.642.33.52.215.943.508 1.25.869l-.697.685c-.535-.615-1.263-.92-2.195-.92-.84 0-1.568.287-2.187.864-.611.578-.918 1.327-.918 2.247 0 .92.307 1.675.918 2.254.619.57 1.347.863 2.187.863.892 0 1.642-.293 2.233-.87.39-.381.612-.908.67-1.58H59.29v-.94h3.873c.047.203.06.4.06.59Zm6.145-3.257H65.73v2.47h3.28v.94h-3.28v2.47h3.638v.957H64.7V9.103h4.668v.957Zm4.337 6.837h-1.03V10.06h-2.232v-.957h5.495v.957h-2.233v6.837Zm6.21 0V9.103h1.028v7.794h-1.028Zm5.586 0H84.48V10.06h-2.24v-.957h5.502v.957h-2.24v6.837Zm12.644-1.003c-.788.788-1.765 1.182-2.93 1.182-1.172 0-2.148-.394-2.937-1.182-.786-.786-1.178-1.752-1.178-2.894 0-1.142.392-2.108 1.178-2.894.789-.788 1.765-1.181 2.937-1.181 1.158 0 2.135.393 2.923 1.187.794.793 1.185 1.752 1.185 2.888 0 1.142-.391 2.108-1.178 2.894Zm-5.105-.653c.593.583 1.315.876 2.175.876.853 0 1.582-.293 2.168-.876.592-.583.892-1.333.892-2.241 0-.908-.3-1.658-.892-2.24-.586-.584-1.315-.877-2.168-.877-.86 0-1.582.293-2.175.876-.592.583-.892 1.333-.892 2.241 0 .908.3 1.658.892 2.24Zm7.728 1.656V9.103h1.25l3.887 6.062h.045l-.045-1.499V9.103h1.028v7.794h-1.073l-4.07-6.36h-.045l.045 1.504v4.856h-1.022Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                d: "M90.847 28.278c-3.132 0-5.69 2.324-5.69 5.53 0 3.18 2.558 5.528 5.69 5.528 3.138 0 5.696-2.348 5.696-5.528 0-3.206-2.558-5.53-5.696-5.53Zm0 8.88c-1.719 0-3.197-1.382-3.197-3.35 0-1.994 1.478-3.352 3.197-3.352 1.718 0 3.203 1.358 3.203 3.352 0 1.968-1.485 3.35-3.203 3.35Zm-12.415-8.88c-3.139 0-5.69 2.324-5.69 5.53 0 3.18 2.551 5.528 5.69 5.528 3.136 0 5.69-2.348 5.69-5.528 0-3.206-2.554-5.53-5.69-5.53Zm0 8.88c-1.72 0-3.204-1.382-3.204-3.35 0-1.994 1.484-3.352 3.204-3.352 1.718 0 3.196 1.358 3.196 3.352 0 1.968-1.478 3.35-3.196 3.35Zm-14.774-7.185v2.35h5.755c-.168 1.313-.618 2.278-1.308 2.95-.84.813-2.148 1.715-4.447 1.715-3.541 0-6.315-2.787-6.315-6.24 0-3.453 2.774-6.24 6.315-6.24 1.915 0 3.309.73 4.337 1.676l1.698-1.656c-1.438-1.34-3.351-2.368-6.035-2.368-4.856 0-8.938 3.853-8.938 8.588 0 4.735 4.082 8.588 8.938 8.588 2.625 0 4.597-.838 6.147-2.411 1.588-1.549 2.083-3.726 2.083-5.484a7.67 7.67 0 0 0-.13-1.468h-8.1Zm60.41 1.822c-.468-1.237-1.913-3.517-4.856-3.517-2.917 0-5.345 2.241-5.345 5.53 0 3.097 2.403 5.528 5.625 5.528a5.653 5.653 0 0 0 4.726-2.45l-1.933-1.256c-.645.92-1.523 1.529-2.793 1.529-1.262 0-2.167-.564-2.747-1.675l7.585-3.06-.262-.63Zm-7.733 1.84a3.068 3.068 0 0 1 2.962-3.223c.99 0 1.83.483 2.11 1.173l-5.072 2.05ZM110.17 39h2.493V22.75h-2.493V39Zm-4.083-9.49h-.084c-.56-.647-1.628-1.232-2.981-1.232-2.84 0-5.437 2.431-5.437 5.548 0 3.099 2.597 5.51 5.437 5.51 1.353 0 2.421-.59 2.981-1.256h.084v.793c0 2.114-1.159 3.25-3.027 3.25-1.523 0-2.468-1.072-2.858-1.974l-2.169.882c.625 1.466 2.28 3.27 5.027 3.27 2.923 0 5.39-1.677 5.39-5.758v-9.928h-2.363v.895Zm-2.852 7.649c-1.718 0-3.157-1.402-3.157-3.333 0-1.948 1.439-3.37 3.157-3.37 1.693 0 3.028 1.422 3.028 3.37 0 1.93-1.335 3.333-3.028 3.333Zm32.507-14.409h-5.964V39h2.487v-6.157h3.477c2.761 0 5.47-1.949 5.47-5.047s-2.715-5.046-5.47-5.046Zm.065 7.832h-3.542V25.01h3.542c1.856 0 2.916 1.503 2.916 2.786 0 1.257-1.06 2.787-2.916 2.787Zm15.371-2.335c-1.796 0-3.665.774-4.433 2.488l2.207.902c.475-.902 1.348-1.194 2.271-1.194 1.29 0 2.599.755 2.619 2.09v.17c-.45-.253-1.414-.629-2.599-.629-2.376 0-4.798 1.276-4.798 3.657 0 2.177 1.947 3.58 4.135 3.58 1.673 0 2.597-.737 3.177-1.593h.085v1.256h2.401v-6.233c0-2.882-2.206-4.494-5.065-4.494Zm-.3 8.905c-.813 0-1.946-.393-1.946-1.376 0-1.258 1.413-1.74 2.636-1.74 1.095 0 1.609.235 2.274.546-.195 1.504-1.524 2.57-2.964 2.57Zm14.115-8.549-2.858 7.045h-.085l-2.955-7.045h-2.682l4.44 9.844-2.533 5.478h2.598l6.842-15.322h-2.767ZM142.578 39h2.494V22.75h-2.494V39Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "android-app-a",
                        x1: "29.066",
                        x2: "7.256",
                        y1: "40.677",
                        y2: "18.308",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#00A0FF"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".007",
                                stopColor: "#00A1FF"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".26",
                                stopColor: "#00BEFF"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".512",
                                stopColor: "#00D2FF"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".76",
                                stopColor: "#00DFFF"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00E3FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "android-app-b",
                        x1: "45.112",
                        x2: "12.85",
                        y1: "25.998",
                        y2: "25.998",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#FFE000"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".409",
                                stopColor: "#FFBD00"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".775",
                                stopColor: "orange"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#FF9C00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "android-app-c",
                        x1: "33.103",
                        x2: "3.526",
                        y1: "23.015",
                        y2: "-7.32",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#FF3A44"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#C31162"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "android-app-d",
                        x1: "9.73",
                        x2: "22.937",
                        y1: "51.771",
                        y2: "38.225",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#32A071"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".069",
                                stopColor: "#2DA771"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".476",
                                stopColor: "#15CF74"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: ".801",
                                stopColor: "#06E775"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#00F076"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var PlayStoreLink = function PlayStoreLink(_param) {
    var masked = _param.masked, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "masked"
    ]);
    if (masked) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaskedLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            title: PlayStoreLink_title,
            body: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayStoreLink_StoreLogo, {})
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        title: PlayStoreLink_title,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayStoreLink_StoreLogo, {})
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/StoreLink/index.ts



// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/defaults.ts
var svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    "aria-hidden": true
};

// EXTERNAL MODULE: ../../frontend/shared/src/styles/index.ts + 1 modules
var src_styles = __webpack_require__(8847);
;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/Wave.styles.ts


function Wave_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: -3rem;\n      overflow: hidden;\n\n      ",
        " {\n        margin-top: -6rem;\n      }\n      ",
        " {\n        margin-top: -3rem;\n      }\n      ",
        " {\n        margin-top: -6rem;\n      }\n      ",
        "\n    "
    ]);
    Wave_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getBackground = function getBackground(theme, style) {
    return ({
        default: ";",
        gray: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", theme.color.natural10, ";padding-top:6rem;padding-bottom:6rem;"),
        green: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-image:", (0,Theme.getLinearGradient)(theme.gradient.green), ";"),
        mint: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-image:", (0,Theme.getLinearGradient)(theme.gradient.mint), ";"),
        orange: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-image:", (0,Theme.getLinearGradient)(theme.gradient.orange), ";")
    })[style];
};
var WaveSvg = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", (0,src_define_property/* default */.Z)({
    target: "eofxi4q0"
}, "target", "eofxi4q0"))("width:100%;height:auto;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var FixedWave = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eofxi4q1"
}, "target", "eofxi4q1"))("position:relative;");
var FixedWaveContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eofxi4q2"
}, "target", "eofxi4q2"))("position:relative;z-index:10;");
var FixedWaveWaves = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eofxi4q3"
}, "target", "eofxi4q3"))(src_styles/* Global.layoutContainerContent */.x.b1, ";", function(param) {
    var theme = param.theme, backgroundStyle = param.backgroundStyle;
    return backgroundStyle && getBackground(theme, backgroundStyle);
}, ";position:absolute;top:0;left:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-50vw + 50%)" : "0";
}, ";right:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-50vw + 50%)" : "";
}, ";z-index:0;display:flex;flex-direction:column;justify-content:space-between;width:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "" : "100%";
}, ";height:", function(param) {
    var height = param.height;
    return height ? "".concat(height, "px") : "";
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("xxl");
}, "{left:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-960px + 50%)" : "0";
}, ";right:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-960px + 50%)" : "";
}, ";}/* Fix for sub-pixel hairline showing on some systems due to scaled SVG. */\n  &::before{content:'';position:absolute;z-index:-1;width:100%;height:1px;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}");
var FixedWaveEnd = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eofxi4q4"
}, "target", "eofxi4q4"))("& > svg{margin-bottom:-6px;}");
var ScalableWaveSvg = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("& > svg{margin-left:calc(-50vw + 50%);margin-right:calc(-50vw + 50%);width:100vw;}");
var ScalableWave = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eofxi4q5"
}, "target", "eofxi4q5"))(src_styles/* Global.layoutContainerContent */.x.b1, ";", function(param) {
    var theme = param.theme, backgroundStyle = param.backgroundStyle;
    return backgroundStyle && getBackground(theme, backgroundStyle);
}, ";", function(param) {
    var isFullWidth = param.isFullWidth, theme = param.theme;
    if (!isFullWidth) return "";
    return (0,emotion_react_browser_esm/* css */.iv)(Wave_styles_templateObject(), theme.mq("md"), theme.mq("lg"), theme.mq("xl"), ScalableWaveSvg);
}, ";");
var ScalableWaveEnd = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eofxi4q6"
}, "target", "eofxi4q6"))("margin-bottom:-2rem;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{margin-bottom:-4.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-bottom:-1.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{margin-bottom:-2rem;}", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth && ScalableWaveSvg;
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Scalable1.tsx





var scalable1 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 0h375v52.916c-48 7.144-101.5 4.166-158.5-3.158s-101-9.553-213.285 0A68.175 68.175 0 0 1 0 50.782V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 0h1440v88.84c-148.5 19.626-318.5 9.198-573 .243S466.5 59.23 12.344 83.538c-4.16.628-8.275 1.2-12.344 1.718V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 60V8.028C203 25.5 143.5 23.5 0 0v60h375Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 100.307V13.686C796.5 82.188 527.5 66.9 0 .306v100h1440Z"
            })
        }))
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Scalable2.tsx





var scalable2 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 0H0v52.916c48 7.144 101.5 4.166 158.5-3.158s101-9.553 213.285 0c1.084.374 2.155.715 3.215 1.024V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 0H0v88.84c148.5 19.626 318.5 9.198 573 .243s400.5-29.853 854.66-5.545c4.16.628 8.27 1.2 12.34 1.718V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 60",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 60V30.329C177.5 40.062 152.5-7.791 0 1.109V60h375Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 100.692V51.088C791 131.91 529-15.817 0 2.238v98.454h1440Z"
            })
        }))
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Scalable3.tsx





var scalable3 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 0h375v52.916c-48 7.144-101.5 4.166-158.5-3.158s-101-9.553-213.285 0A68.175 68.175 0 0 1 0 50.782V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 .219h1440V53.41c-178.5-27.293-283.5-25.42-573 6.315C577.5 91.46 450.5 130.139 0 64.054V.218Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 60",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 60V30.329c197.5 9.733 222.5-38.12 375-29.22V60H0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 100V16.126C498 100 908-20.617 1440 3.17V100H0Z"
            })
        }))
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Scalable4.tsx





var scalable4 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 0h375v52.916c-48 7.144-101.5 4.166-158.5-3.158s-101-9.553-213.285 0A68.175 68.175 0 0 1 0 50.782V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 0H0v53.192C178.5 25.9 283.5 27.773 573 59.507s416.5 70.413 867 4.328V0Z"
            })
        }))
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Scalable5.tsx





var scalable5 = {
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 60",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 60V30.329c197.5 9.733 222.5-38.12 375-29.22V60H0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 100V16.126C498 100 908-20.617 1440 3.17V100H0Z"
            })
        }))
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Fixed1.tsx





var fixed1 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 34",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 0H0v15.385c81.391 32.491 172.951 15.514 250.717 1.094C299.568 7.42 342.976-.628 375 5.229V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 136",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 0H0v61.539c312.543 129.966 664.132 62.056 962.752 4.377 187.588-36.234 354.278-68.43 477.248-45V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 31",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 29.213V31h375V0c-.371.381-.728.596-1.071.63-40.742 4.11-84.426 3.748-129.173 3.378C162.89 3.33 77.466 2.623 0 29.214Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 151",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 142.298V151h1440V0c-1.42 1.857-2.8 2.9-4.11 3.07-156.45 20.017-324.2 18.255-496.027 16.45h-.001C625.496 16.22 297.473 12.776 0 142.299Z"
            })
        }))
    },
    height: {
        small: 580,
        large: 870
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Fixed2.tsx





var fixed2 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 44",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 0H0v2.737c12.513 4.253 24.677 9.16 36.855 14.07C82.515 35.221 128.37 53.713 193.5 38.191 261.527 21.98 296-4.949 375 9.404V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 116",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 19.191V0H0v39.033c417.248 128.799 705.691 68.518 956.992 16C1125.48 19.82 1277.28-11.904 1440 19.19Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 105",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 0v105h375V89.841c-57-54.673-128.5-4.898-229.5-14.482S2.5 28 0 0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 223",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 223h1440v-9.204c-48.05-14.301-94.76-30.796-141.52-47.31-175.34-61.914-351.417-124.092-601.518-71.901C435.737 149.097 229.241 106.227 0 0v223Z"
            })
        }))
    },
    height: {
        small: 526,
        large: 526
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Fixed3.tsx





var fixed3 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 17",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 0H0v14.197a108.7 108.7 0 0 1 6.66-2.078c30.232-8.38 72.47-5.322 127.758-1.319 62.83 4.55 142.514 10.319 240.582 1.908V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 36",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 0H0v30.065a683.03 683.03 0 0 1 25.573-4.402c116.092-17.745 278.287-11.27 490.592-2.792C757.434 32.504 1063.42 44.72 1440 26.91V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 87",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 9.941V87h375V76.681C349.07 66.14 112.99-27.65 6.66 8.072A66.575 66.575 0 0 1 0 9.941Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 133",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 15.197V133h1440v-15.775C1340.43 101.109 433.883-42.27 25.573 12.341A583.752 583.752 0 0 1 0 15.197Z"
            })
        }))
    },
    height: {
        small: 680,
        large: 520
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Fixed4.tsx





var fixed4 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 44",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 0H0v2.737c12.513 4.253 24.677 9.16 36.855 14.07C82.515 35.221 128.37 53.713 193.5 38.191 261.527 21.98 296-4.949 375 9.404V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 169",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 0H0v36s370 146.5 632 86 577.5-42.5 808 47V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 87",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 9.941V87H0V76.681C25.93 66.14 262.01-27.65 368.34 8.072A66.565 66.565 0 0 0 375 9.941Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 206",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 185.961v19.207h1440V47.538c-448-109.09-722.5 1.05-839.5 25.522C475 99.31 242 205.168 0 185.96Z"
            })
        }))
    },
    height: {
        small: 701,
        large: 676
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/Fixed5.tsx





var fixed5 = {
    start: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 24",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M375 0H0v6.036c33.107 23.561 91.287 17.98 152.172 12.14L154 18c71.588-6.864 149-18 221 5V0Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 78",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1440 0H0v20.47c131 32.51 331.216 54.093 566.062 23.28C836.471 8.27 1149.35-32.781 1440 78V0Z"
            })
        }))
    },
    end: {
        small: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 375 41",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 4.892V41h375V0c-27.142 28.107-122.411 24.119-179 16C128.157 6.267 116.384.36 26.719 3.866 18.521 4.186 9.65 4.533 0 4.892Z"
            })
        })),
        large: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WaveSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, svgProps), {
            viewBox: "0 0 1440 125",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M0 14.915V125h1440V0c-104.22 85.69-415.21 141.681-708.823 65.187C481.111.04 446.915 1.1 102.6 11.787h-.003C71.123 12.762 37.058 13.82 0 14.914Z"
            })
        }))
    },
    height: {
        small: 580,
        large: 700
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/WaveSets/index.ts










var WaveSets = {
    scalable1: scalable1,
    scalable2: scalable2,
    scalable3: scalable3,
    scalable4: scalable4,
    scalable5: scalable5,
    fixed1: fixed1,
    fixed2: fixed2,
    fixed3: fixed3,
    fixed4: fixed4,
    fixed5: fixed5
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/Wave/Wave.tsx




var Wave = function Wave(param) {
    var type = param.type, children = param.children, fullWidth = param.fullWidth, backgroundStyle = param.backgroundStyle;
    var isLargeViewport = (0,useMedia/* default */.Z)("(min-width: 992px)", false);
    var size = isLargeViewport ? "large" : "small";
    var _type = WaveSets[type], start = _type.start, end = _type.end, height = _type.height;
    var startWave = start === null || start === void 0 ? void 0 : start[size];
    var endWave = end === null || end === void 0 ? void 0 : end[size];
    var heightWave = height === null || height === void 0 ? void 0 : height[size];
    // Fixed waves have a fixed height and are positioned underneath the content
    // (basically a background that does not get cut off).
    var isFixedWave = type.startsWith("fixed");
    if (isFixedWave) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FixedWave, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FixedWaveWaves, {
                    isFullWidth: fullWidth,
                    height: heightWave,
                    backgroundStyle: backgroundStyle,
                    "aria-hidden": "true",
                    children: [
                        startWave,
                        endWave && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FixedWaveEnd, {
                            children: endWave
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FixedWaveContent, {
                    children: children
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ScalableWave, {
        isFullWidth: fullWidth,
        backgroundStyle: backgroundStyle,
        children: [
            startWave,
            children,
            endWave && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScalableWaveEnd, {
                isFullWidth: fullWidth,
                children: endWave
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Ui/index.ts






















/***/ }),

/***/ 6646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2903);

var viewBox = "0 0 615 63";
var logoColor = "#00977d";
var BmLogo = function BmLogo() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        viewBox: viewBox,
        role: "img",
        "aria-label": "billiger-mietwagen.de",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M19.5 37.26c.33.43.04 1.1-.53 1.1h-8.72a1.1 1.1 0 0 1-1-.63C4.03 23.51 12.55 8.71 29.2 8.66h28.23A8.66 8.66 0 0 0 48.8.56H8.67A8.66 8.66 0 0 0 0 9.23V41.8h27.97c12.26 0 15.62-12.5 9.91-20.45-.33-.43-.04-1.1.53-1.1h8.71c.43 0 .82.24 1.01.62 5.22 14.23-3.3 29.03-19.97 29.08H.03a8.66 8.66 0 0 0 8.65 8.1H48.8a8.67 8.67 0 0 0 8.67-8.67V16.8H29.4c-12.26 0-15.61 12.5-9.91 20.46Z",
                fill: logoColor
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M264.75 10.18h-.01c0 4.52-2.26 7.31-5.75 8.75l4.4 5.33c.61.78 1.02 1.44 1.02 2.42a2.95 2.95 0 0 1-3 2.92c-1.44 0-2.38-.7-3.12-1.64l-6.02-7.62a.5.5 0 0 0-.38-.19h-4.33a.48.48 0 0 0-.48.49v5.8A3.1 3.1 0 0 1 244 29.6c-1.8.05-3.25-1.52-3.25-3.31V9.61c0-.35.28-.64.64-.64h5.05c.35 0 .64.29.64.64v4.48c0 .27.22.48.48.48h5.93c3.07 0 4.84-1.64 4.84-4.06v-.09c0-2.71-1.88-4.1-4.96-4.1l-33.59.15a.49.49 0 0 0-.48.48v4.9c0 .28.22.5.5.5l10.56-.2a2.86 2.86 0 0 1 2.85 2.87 2.83 2.83 0 0 1-2.85 2.81l-10.58.19a.48.48 0 0 0-.48.48v4.93c0 .27.22.49.48.49h12.65c1.66 0 3 1.42 2.84 3.12a2.9 2.9 0 0 1-2.93 2.55h-16.18a3.2 3.2 0 0 1-3.2-3.2V3.8a3.2 3.2 0 0 1 3.2-3.18h37.74c3.66 0 6.49 1.02 8.38 2.91 1.6 1.61 2.46 3.87 2.46 6.58v.08ZM102.4 3.44c0-1.79 1.41-3.2 3.2-3.2a3.16 3.16 0 0 1 3.18 3.2v23.1c0 1.78-1.4 3.2-3.19 3.2a3.18 3.18 0 0 1-3.19-3.2V3.44Zm12.01 0a3.17 3.17 0 0 1 3.1-3.2c1.73-.05 3.28 1.54 3.28 3.35V23.2c0 .26.21.48.48.48h11.18c1.64 0 3.08 1.34 3.04 2.97a2.88 2.88 0 0 1-2.9 2.83H117.6a3.2 3.2 0 0 1-3.19-3.2V3.45Zm26.42 0a3.17 3.17 0 0 1 3.1-3.2c1.8-.04 3.27 1.54 3.27 3.35V23.2c0 .26.22.48.49.48h11.18c1.64 0 3.08 1.34 3.04 2.97a2.88 2.88 0 0 1-2.9 2.83h-14.99a3.2 3.2 0 0 1-3.19-3.2V3.45Zm26.5 0c0-1.79 1.4-3.2 3.18-3.2 1.79 0 3.2 1.41 3.2 3.2v23.1c0 1.78-1.41 3.2-3.2 3.2a3.18 3.18 0 0 1-3.19-3.2V3.44Zm11.71 11.63v-.08c0-8.24 6.42-14.99 15.2-14.99 4.39 0 7.29 1 9.9 2.82.65.47 1.39 1.4 1.32 2.73a3.2 3.2 0 0 1-3.34 2.98 3.11 3.11 0 0 1-1.74-.66 10.19 10.19 0 0 0-6.34-1.99c-4.64 0-8.32 4.1-8.32 9.03V15c0 5.3 3.65 9.2 8.78 9.2 2.22 0 4.21-.53 5.79-1.6a.48.48 0 0 0 .2-.4v-3.4a.49.49 0 0 0-.47-.49h-3.76a2.8 2.8 0 0 1-2.83-2.49 2.77 2.77 0 0 1 2.76-3.02h7.29a3.2 3.2 0 0 1 3.19 3.2v7.03a4.3 4.3 0 0 1-2.24 4.06 19.28 19.28 0 0 1-10.14 2.9c-9.03 0-15.24-6.34-15.24-14.91h-.01Zm90.93 2.44a2.96 2.96 0 0 1 2.95-2.94h12.35a2.96 2.96 0 0 1 2.95 2.94 2.96 2.96 0 0 1-2.95 2.95h-12.35a2.96 2.96 0 0 1-2.95-2.95ZM72.3.95c0-.26.22-.48.49-.48h13.04c3.33 0 5.95.91 7.61 2.58a6.68 6.68 0 0 1 2 4.95v.08a6.7 6.7 0 0 1-3.54 6.12c-.11.07-.1.24.03.3 3.19 1.29 5.14 3.24 5.14 7.03v.08c0 5.33-4.33 7.99-10.9 7.99H72.79a.49.49 0 0 1-.48-.49V.95Zm13.86 23.03c2.83 0 4.54-1 4.54-3.17v-.08c0-1.95-1.46-3.16-4.74-3.16h-6.93a.49.49 0 0 0-.48.48v5.44c0 .27.22.49.48.49h7.13Zm-1.7-11.73c2.82 0 4.61-.91 4.61-3.08v-.09c0-1.9-1.5-3-4.2-3h-5.85a.49.49 0 0 0-.48.5v5.19c0 .27.22.48.48.48h5.43Z",
                fill: logoColor,
                className: "logo-bm-part-1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M293.08 3.64a3.2 3.2 0 0 1 3.19-3.2h.7a3.3 3.3 0 0 1 2.9 1.66l7.52 12.24c.08.14.28.14.37 0l7.56-12.28a3.12 3.12 0 0 1 2.86-1.61h.7a3.2 3.2 0 0 1 3.2 3.19v22.91c0 1.5-1 2.88-2.47 3.22a3.17 3.17 0 0 1-3.88-3.11V12.4c0-.05-.07-.08-.1-.03l-5.49 8.45c-.66 1-1.49 1.61-2.65 1.61-1.17 0-1.99-.62-2.66-1.61l-5.4-8.32c-.03-.05-.1-.03-.1.03v14.02c0 1.78-1.46 3.34-3.23 3.3a3.03 3.03 0 0 1-3.03-3.1V3.63Zm34.47-.09a3.17 3.17 0 0 1 3.2-3.19c1.77 0 3.18 1.4 3.18 3.2v23.1c0 1.78-1.4 3.19-3.19 3.19a3.17 3.17 0 0 1-3.19-3.2V3.56Zm11.72 22.87V3.8a3.2 3.2 0 0 1 3.19-3.19h15.93c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.08H346.1a.48.48 0 0 0-.49.48v4.92c0 .26.22.48.49.48h10.45c1.5 0 2.83 1.11 2.96 2.6a2.83 2.83 0 0 1-2.84 3.08h-10.58a.49.49 0 0 0-.48.48v5.12c0 .27.22.49.49.49h12.51c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.07h-16.27a3.2 3.2 0 0 1-3.2-3.2Zm35.6-20.13h-5.54a3 3 0 0 1-2.97-2.28 2.95 2.95 0 0 1 2.86-3.6h18.54a3 3 0 0 1 2.96 2.28 2.95 2.95 0 0 1-2.86 3.6h-5.65a.48.48 0 0 0-.48.49V26.3c0 1.8-1.48 3.39-3.28 3.34a3.12 3.12 0 0 1-3.1-3.19V6.78a.49.49 0 0 0-.48-.49Zm81.08 8.9v-.09c0-8.24 6.42-14.98 15.2-14.98 4.39 0 7.29.99 9.9 2.81.65.48 1.39 1.4 1.32 2.74a3.16 3.16 0 0 1-5.1 2.32A10.15 10.15 0 0 0 470.94 6c-4.64 0-8.32 4.1-8.32 9.03v.08c0 5.3 3.65 9.2 8.78 9.2 2.21 0 4.2-.54 5.79-1.6a.48.48 0 0 0 .2-.4v-3.4a.48.48 0 0 0-.48-.5h-3.75a2.8 2.8 0 0 1-2.83-2.48 2.77 2.77 0 0 1 2.76-3.02h7.29a3.2 3.2 0 0 1 3.19 3.19v7.03c0 1.87-.71 3.15-2.24 4.06a19.27 19.27 0 0 1-10.14 2.9c-9.03 0-15.24-6.33-15.24-14.9Zm33.77 11.23V3.8A3.2 3.2 0 0 1 492.9.61h15.93c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.08h-12.43a.48.48 0 0 0-.49.48v4.92c0 .26.22.48.49.48h10.45c1.5 0 2.83 1.11 2.96 2.6a2.83 2.83 0 0 1-2.84 3.08h-10.57a.48.48 0 0 0-.49.48v5.12c0 .27.22.49.49.49h12.51c1.5 0 2.85 1.1 2.98 2.6a2.82 2.82 0 0 1-2.85 3.07H492.9a3.2 3.2 0 0 1-3.2-3.2Zm27.76-22.78a3.2 3.2 0 0 1 3.19-3.2h.66c1.53 0 2.44.76 3.31 1.87l11.43 15.01c.28.37.87.17.87-.29V3.64c0-1.65 1.2-3.1 2.84-3.27a3.14 3.14 0 0 1 3.45 3.14v23.07a3.2 3.2 0 0 1-3.2 3.19h-.2c-1.53 0-2.44-.75-3.3-1.87l-11.9-15.6a.48.48 0 0 0-.86.3v13.97c0 1.64-1.2 3.1-2.84 3.26a3.15 3.15 0 0 1-3.46-3.13V3.64Zm35.57 18.97c2.07 0 3.6 1.53 3.6 3.52v.09a3.5 3.5 0 0 1-3.6 3.52 3.49 3.49 0 0 1-3.6-3.52v-.09a3.49 3.49 0 0 1 3.6-3.52Zm7.54-18.94c0-1.78 1.41-3.2 3.2-3.2h8.12c9.12 0 15.42 6.27 15.42 14.44v.08c0 8.16-6.3 14.51-15.42 14.51h-8.13a3.16 3.16 0 0 1-3.19-3.19V3.67Zm11.32 20.06c5.22 0 8.75-3.52 8.75-8.67v-.08c0-5.14-3.53-8.75-8.75-8.75h-4.45a.48.48 0 0 0-.48.49v16.53c0 .26.21.48.48.48h4.45Zm20.76 2.57V3.67a3.2 3.2 0 0 1 3.2-3.2h15.95c1.5 0 2.84 1.12 2.97 2.61a2.83 2.83 0 0 1-2.85 3.08h-12.45a.48.48 0 0 0-.48.48v4.93c0 .26.21.48.48.48h10.46c1.5 0 2.84 1.1 2.97 2.6a2.83 2.83 0 0 1-2.85 3.08h-10.59a.48.48 0 0 0-.48.48v5.13c0 .27.22.49.48.49h12.53c1.5 0 2.85 1.1 2.98 2.6a2.83 2.83 0 0 1-2.85 3.08h-16.3a3.2 3.2 0 0 1-3.19-3.2h.02Zm-140.45-.11.01.01c.45 1.44-.21 3.07-1.61 3.63a2.88 2.88 0 0 1-3.84-1.8l-.63-2.04a719.6 719.6 0 0 0-1.66-5.3.49.49 0 0 0-.47-.35h-9.33a.47.47 0 0 1-.44-.66l1.25-4.26c.1-.32.39-.55.73-.55h5.72c.33 0 .56-.32.46-.63-1.17-3.52-2.19-6.38-2.62-7.1-.58-.87-2-.87-2-.87-.02 0-1.5 0-2.18.96-.5.81-1.66 4.8-2.76 8.67-.95 3.3-2.13 7.39-3.54 11.8-.42 1.34-1.86 2.42-3.23 2.34l-.28.02h-.66c-1.53 0-2.7-.95-3.27-2.61l-5.52-16.02a.21.21 0 0 0-.4 0l-5.5 16.02c-.6 1.66-1.75 2.6-3.28 2.6h-.66c-1.53 0-2.74-1-3.32-2.6l-8.11-22.78a3.94 3.94 0 0 1-.25-1.2c0-1.78 1.49-3.1 3.27-3.1a3.2 3.2 0 0 1 3.1 2.28l5.68 17.52c.02.07.13.07.15 0l5.72-17.36c.5-1.49 1.62-2.52 3.23-2.52h.5c1.62 0 2.73.99 3.23 2.52l5.71 17.35c.02.07.14.08.16 0 .28-.95 1.31-4.36 1.74-5.85 1.78-6.21 2.62-9.02 3.6-10.41 2.31-3.23 6.13-3.4 6.87-3.4 2.17 0 5.1.9 6.8 3.45 1.14 1.73 3.25 8.05 7.05 20.32l.6 1.9Z",
                fill: logoColor,
                className: "logo-bm-part-2"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M78.23 43.92A5.39 5.39 0 0 1 82.69 46c.51.65.9 1.4 1.14 2.25.26.85.39 1.75.39 2.7 0 1.3-.24 2.48-.68 3.55a5.9 5.9 0 0 1-2.01 2.54 5.5 5.5 0 0 1-3.3.95h-4.9a1 1 0 0 1-1.03-1.03V44.94a1 1 0 0 1 1.03-1.03h4.9Zm-3.81 1.92v10.2h3.61v.01c.93 0 1.7-.23 2.3-.7a4 4 0 0 0 1.3-1.85 7.9 7.9 0 0 0 .18-4.48 5.07 5.07 0 0 0-.72-1.64 3.51 3.51 0 0 0-3.06-1.54h-3.61Zm13.94 7.4c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15a4.22 4.22 0 0 0 1.37-.8c.2-.12.4-.18.59-.18a.83.83 0 0 1 .86.84c0 .3-.15.57-.44.8-.36.35-.86.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.18.24-2.18.72-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.87.81 5.13 5.13 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.43.25-.7.25h-6.98Zm.06-1.7h5.8v-.15a2.2 2.2 0 0 0-.48-1.22 2.98 2.98 0 0 0-2.34-1.12c-.4 0-.79.06-1.16.19-.36.13-.69.33-.98.6a3.6 3.6 0 0 0-.84 1.69Zm18.4-4.13a1.02 1.02 0 0 1 1 1.03v5.29c0 1.4-.39 2.48-1.16 3.26a4.44 4.44 0 0 1-3.3 1.18c-1.43 0-2.52-.4-3.3-1.18a4.46 4.46 0 0 1-1.15-3.26v-5.29a1 1 0 0 1 1.03-1.03c.3 0 .52.1.71.3.2.2.3.44.3.73v5.29c0 .87.2 1.52.6 1.95.42.43 1.02.64 1.8.64.8 0 1.41-.21 1.82-.64.41-.43.61-1.08.61-1.95v-5.29a1 1 0 0 1 1.03-1.03Zm5.05 2h-1.1a.91.91 0 0 1-.67-.27.91.91 0 0 1-.27-.68c0-.26.08-.49.27-.66a.9.9 0 0 1 .67-.26h1.1v-1.6c0-.29.1-.53.3-.73a1 1 0 0 1 .72-.3v.01c.28 0 .53.1.71.3.2.2.28.44.28.73v1.59h1.61c.27 0 .5.08.68.27.18.18.27.4.27.67a.9.9 0 0 1-.27.67.93.93 0 0 1-.68.26h-1.6v5.87c0 .24.03.43.11.58.09.15.2.25.34.3.14.06.28.09.43.09a.9.9 0 0 0 .4-.09.96.96 0 0 1 .41-.08c.17 0 .3.08.44.22.14.15.2.35.2.6 0 .33-.17.59-.52.79-.34.2-.72.3-1.12.3-.23 0-.5-.02-.8-.06-.3-.05-.6-.15-.9-.3a1.91 1.91 0 0 1-.71-.78c-.2-.35-.3-.86-.3-1.5v-5.94Zm6.88 6.93c-.12-.19-.18-.4-.16-.65.01-.25.15-.46.42-.64a.9.9 0 0 1 .6-.15c.2.03.4.13.58.32a3.63 3.63 0 0 0 3.76 1.22c.29-.08.53-.22.73-.4.2-.2.3-.48.3-.86 0-.34-.11-.6-.32-.8-.22-.2-.5-.36-.85-.49a9.03 9.03 0 0 0-1.14-.36c-.43-.12-.86-.25-1.29-.4a5.4 5.4 0 0 1-1.17-.57 2.68 2.68 0 0 1-.86-.92 2.71 2.71 0 0 1-.32-1.38c0-.64.18-1.17.52-1.63.35-.45.81-.8 1.4-1.07a4.36 4.36 0 0 1 1.84-.38 5.37 5.37 0 0 1 2.5.62c.4.22.74.5 1.04.84.14.18.21.39.23.63.02.24-.09.46-.33.67a.76.76 0 0 1-.59.17.92.92 0 0 1-.56-.23 2.46 2.46 0 0 0-.99-.75 3.47 3.47 0 0 0-2.16-.15c-.27.07-.5.2-.7.38-.18.19-.27.46-.27.82 0 .34.1.6.33.8.22.21.51.37.88.5.36.14.75.26 1.18.37.42.1.83.23 1.24.38.4.15.78.34 1.1.57a2.65 2.65 0 0 1 1.13 2.3c0 .66-.2 1.22-.58 1.68a3.6 3.6 0 0 1-1.45 1.06c-.58.23-1.2.36-1.83.36-.76 0-1.53-.14-2.28-.42a4.25 4.25 0 0 1-1.92-1.43v-.01Zm15.22-9.16c.72 0 1.37.07 1.93.23.57.15 1 .36 1.32.64.32.27.47.59.47.95 0 .23-.06.44-.2.63-.14.2-.33.3-.6.3-.21 0-.37-.03-.5-.1a1.36 1.36 0 0 1-.34-.23c-.1-.1-.23-.2-.4-.27-.14-.1-.36-.17-.66-.22a4.9 4.9 0 0 0-.76-.06 3.3 3.3 0 0 0-3.04 1.78 3.94 3.94 0 0 0-.44 1.86c0 .69.15 1.32.44 1.87a3.21 3.21 0 0 0 2.95 1.79 3.86 3.86 0 0 0 1.62-.32c.22-.12.4-.25.53-.38.14-.13.34-.19.6-.19.29 0 .51.1.67.28a1 1 0 0 1 .23.67c0 .3-.18.58-.53.86-.36.27-.83.5-1.42.67-.59.18-1.24.26-1.97.26a4.86 4.86 0 0 1-4.49-2.7 6.13 6.13 0 0 1-.63-2.81c0-1.05.22-2 .66-2.83a5.09 5.09 0 0 1 1.84-1.96c.78-.48 1.7-.72 2.72-.72Zm8.06 1.91.1-.16a4.18 4.18 0 0 1 3.21-1.69c.93 0 1.65.2 2.16.59.5.4.87.92 1.07 1.6.21.67.32 1.4.32 2.2v5.34a1 1 0 0 1-1.01 1.02 1 1 0 0 1-1.03-1.02v-5.33a4 4 0 0 0-.19-1.28 1.93 1.93 0 0 0-.65-.93c-.3-.23-.74-.35-1.3-.35-.53 0-1 .12-1.4.35a2.48 2.48 0 0 0-1.28 2.2v5.34a1 1 0 0 1-1 1.02 1 1 0 0 1-1.04-1.02V44.14a1 1 0 0 1 1.03-1.03c.3 0 .52.1.71.3.2.2.3.43.3.73v4.95Zm12.12 7.88a1 1 0 0 1-1 1.02.97.97 0 0 1-.72-.29.97.97 0 0 1-.3-.73V44.14a1 1 0 0 1 .3-.73 1 1 0 0 1 .73-.3c.28 0 .53.1.71.3a1 1 0 0 1 .28.73v12.83Zm10.96-.4c-.18.24-.4.47-.67.68a4.7 4.7 0 0 1-1.18.68 4.48 4.48 0 0 1-3.96-.44 5.04 5.04 0 0 1-1.75-1.97 6.1 6.1 0 0 1-.65-2.83c0-1.06.22-2.04.65-2.87.43-.82 1-1.47 1.74-1.94.73-.47 1.54-.7 2.42-.7a4.5 4.5 0 0 1 3.4 1.5v-.4c0-.28.1-.53.27-.72.2-.2.43-.3.73-.3.29 0 .53.1.72.29.19.2.28.44.28.73v8.69c0 .29-.1.53-.28.73-.2.2-.43.3-.72.3a.99.99 0 0 1-1-1.03v-.4Zm-3.1-.23c.63 0 1.18-.16 1.66-.48.48-.32.86-.76 1.12-1.32.27-.56.4-1.18.4-1.86 0-.68-.13-1.3-.4-1.86a3 3 0 0 0-2.79-1.78 2.9 2.9 0 0 0-1.64.48c-.47.3-.85.74-1.12 1.3a4.17 4.17 0 0 0-.41 1.87c0 .7.13 1.3.41 1.85.27.56.65 1 1.12 1.32.48.32 1.02.49 1.64.49v-.01Zm10.23-7.3.13-.17a4.55 4.55 0 0 1 1.98-1.47 3.6 3.6 0 0 1 1.32-.23c.96 0 1.7.2 2.22.6.52.4.89.92 1.1 1.58.2.66.3 1.4.3 2.22v5.39a1 1 0 0 1-1 1.03 1 1 0 0 1-1.03-1.03v-5.37c0-.48-.06-.91-.2-1.3a1.84 1.84 0 0 0-.68-.91 2.36 2.36 0 0 0-1.37-.34 3 3 0 0 0-1.45.34 2.47 2.47 0 0 0-1.33 2.21v5.37a1 1 0 0 1-1 1.03c-.29 0-.54-.1-.74-.3a.97.97 0 0 1-.29-.73v-8.53a1 1 0 0 1 1.03-1.02 1 1 0 0 1 1 1.03v.6Zm17.82 7.52a4.36 4.36 0 0 1-5.81.92 5.02 5.02 0 0 1-1.75-1.96 6.07 6.07 0 0 1-.65-2.84 6 6 0 0 1 .65-2.84c.43-.83 1-1.48 1.74-1.96a4.5 4.5 0 0 1 5.82.78v-4.53c0-.3.09-.54.27-.74.19-.2.43-.29.72-.29v.01c.3 0 .54.1.73.3a1 1 0 0 1 .27.73v12.83c0 .29-.09.53-.27.73-.2.2-.43.3-.73.3a1 1 0 0 1-1-1.03v-.41Zm-3.1-.22c.64 0 1.2-.16 1.67-.48a3.3 3.3 0 0 0 1.12-1.3c.26-.56.4-1.18.4-1.88s-.14-1.32-.4-1.87a3 3 0 0 0-2.79-1.77 2.9 2.9 0 0 0-1.64.47c-.48.31-.85.75-1.12 1.3a4.16 4.16 0 0 0-.42 1.87c0 .7.14 1.32.42 1.87.27.55.64.99 1.12 1.3.47.33 1.02.49 1.63.49h.01Zm7.6 0c-.13-.19-.18-.4-.17-.65.01-.25.16-.46.42-.64a.9.9 0 0 1 .6-.15c.2.03.4.13.59.32a3.63 3.63 0 0 0 3.76 1.22c.28-.08.52-.22.72-.4.2-.2.3-.48.3-.86 0-.34-.11-.6-.32-.8-.22-.2-.5-.36-.85-.49a9.03 9.03 0 0 0-1.14-.36c-.43-.12-.86-.25-1.28-.4a5.4 5.4 0 0 1-1.18-.57 2.69 2.69 0 0 1-.86-.92 2.71 2.71 0 0 1-.32-1.38c0-.64.18-1.17.53-1.63.34-.45.8-.8 1.38-1.07.58-.26 1.2-.38 1.85-.38a5.37 5.37 0 0 1 2.5.62c.4.22.74.5 1.04.84.14.18.21.39.23.63.02.24-.08.46-.33.67a.77.77 0 0 1-.58.17.93.93 0 0 1-.57-.23 2.46 2.46 0 0 0-.99-.75 3.47 3.47 0 0 0-2.16-.15c-.27.07-.5.2-.7.38-.18.19-.27.46-.27.82 0 .34.1.6.33.8.22.21.51.37.88.5.36.14.75.26 1.18.37.42.1.83.23 1.24.38.4.15.78.34 1.1.57a2.65 2.65 0 0 1 1.13 2.3c0 .66-.2 1.22-.58 1.68a3.6 3.6 0 0 1-1.45 1.06c-.58.23-1.2.36-1.83.36-.76 0-1.53-.14-2.28-.42a4.25 4.25 0 0 1-1.92-1.43v-.01Zm24.33 0-.16.25a3.95 3.95 0 0 1-1.96 1.38 4.73 4.73 0 0 1-3.9-.48 5.01 5.01 0 0 1-1.78-1.95 5.98 5.98 0 0 1-.66-2.85c0-1.07.22-2.02.66-2.84a5.08 5.08 0 0 1 1.77-1.95 4.58 4.58 0 0 1 2.51-.72 4.34 4.34 0 0 1 2.83.99c.28.22.51.46.7.7v-.6c0-.27.1-.52.28-.71.19-.2.42-.3.72-.3.29 0 .53.1.72.29.19.2.28.44.28.73v8.89c0 1.12-.24 2.05-.72 2.76a4.26 4.26 0 0 1-1.92 1.58 6.75 6.75 0 0 1-3.81.38c-.46-.1-.87-.2-1.26-.32a2.6 2.6 0 0 1-.8-.36c-.3-.16-.5-.34-.61-.56a.74.74 0 0 1 0-.65c.12-.3.3-.48.52-.54.24-.07.5-.05.8.06l.61.22c.29.11.6.2.95.3.35.08.68.12 1 .12 1.05 0 1.86-.24 2.4-.74.56-.5.83-1.16.83-2v-1.07Zm-3.21-7.3a3.16 3.16 0 0 0-2.9 1.78 4.08 4.08 0 0 0-.41 1.87c0 .7.14 1.32.42 1.87a3.13 3.13 0 0 0 2.9 1.79 3.11 3.11 0 0 0 2.86-1.78c.28-.56.42-1.18.42-1.88s-.14-1.32-.42-1.87a3.14 3.14 0 0 0-2.87-1.77Zm10.33.24c.09-.17.18-.34.29-.5a3.75 3.75 0 0 1 3.03-1.62c.34 0 .64.1.9.28.25.2.38.42.38.7 0 .36-.1.63-.28.8a.9.9 0 0 1-.62.25c-.2 0-.4-.04-.59-.13-.19-.09-.4-.13-.67-.13s-.57.08-.86.23a3.02 3.02 0 0 0-1.37 1.66c-.15.39-.21.83-.21 1.3v4.83a1 1 0 0 1-1.01 1.03 1 1 0 0 1-1.02-1.02v-8.53a1 1 0 0 1 1.03-1.02 1 1 0 0 1 1 1.03v.84Zm16.82 3.42c0 1.08-.23 2.02-.7 2.84a5.13 5.13 0 0 1-4.63 2.64 5.27 5.27 0 0 1-5.34-5.48 5.33 5.33 0 0 1 2.63-4.82c.8-.47 1.7-.71 2.71-.71a5.22 5.22 0 0 1 4.63 2.67c.47.82.7 1.77.7 2.86Zm-2 0a4 4 0 0 0-.45-1.92c-.29-.54-.7-.96-1.2-1.28a3.11 3.11 0 0 0-1.68-.46 3.2 3.2 0 0 0-2.89 1.74 4 4 0 0 0-.44 1.92 4 4 0 0 0 .44 1.9 3.22 3.22 0 0 0 2.9 1.74 3.18 3.18 0 0 0 2.87-1.75c.3-.55.44-1.18.44-1.89Zm-5.3-6.82c-.35 0-.63-.07-.8-.21-.17-.15-.25-.4-.25-.73v-.3c0-.33.1-.57.28-.72.19-.15.45-.22.8-.22.4 0 .69.07.86.21.18.14.26.39.26.73v.3c0 .36-.09.62-.27.75-.19.13-.47.2-.87.2Zm3.84 0c-.37 0-.64-.07-.81-.21-.17-.15-.25-.4-.25-.73v-.3c0-.34.1-.59.28-.73.19-.14.45-.21.8-.21.39 0 .67.07.84.22.18.15.26.4.26.72v.3c0 .36-.09.62-.27.75-.19.13-.46.2-.86.2h.01Zm6.9 4.05h-.66c-.28 0-.52-.1-.72-.28a.9.9 0 0 1-.29-.68.99.99 0 0 1 1-.97h.67v-.06c0-.66.1-1.27.3-1.85a3.96 3.96 0 0 1 2.31-2.5 5.2 5.2 0 0 1 1.96-.36c.87 0 1.6.14 2.2.44a2.98 2.98 0 0 1 1.84 2.8c0 .4-.1.78-.3 1.13a3 3 0 0 1-.77.94c-.3.24-.62.45-.98.62.56.19 1.08.46 1.58.82a4.24 4.24 0 0 1 1.83 3.64c0 .88-.19 1.67-.56 2.36a4.11 4.11 0 0 1-3.7 2.2c-.64 0-1.16-.08-1.58-.25a2.4 2.4 0 0 1-.96-.65.92.92 0 0 1-.2-.61c0-.25.14-.47.4-.66a.9.9 0 0 1 .6-.18 1 1 0 0 1 .6.3 1.91 1.91 0 0 0 1.2.42c.47 0 .85-.12 1.17-.35.32-.23.58-.56.75-.97.17-.4.25-.86.25-1.35 0-.7-.13-1.28-.39-1.72-.26-.45-.6-.8-1.03-1.07a4.78 4.78 0 0 0-1.4-.57 1.6 1.6 0 0 1-.62-.37.77.77 0 0 1-.2-.54c0-.22.04-.42.14-.57.1-.16.22-.27.38-.35.36-.15.67-.33.95-.53.26-.22.47-.44.6-.7.15-.25.22-.53.22-.82 0-.5-.2-.89-.59-1.16a2.68 2.68 0 0 0-1.56-.41 2.22 2.22 0 0 0-1.82.8 2.5 2.5 0 0 0-.47.88c-.11.34-.17.7-.17 1.11l-.02 9.09c0 .29-.1.53-.28.73-.19.2-.42.3-.72.3l.02.01a.98.98 0 0 1-.72-.29.99.99 0 0 1-.28-.73l.02-7.04Zm13.4-.52h-1.1a.91.91 0 0 1-.67-.27.91.91 0 0 1-.28-.68c0-.26.1-.49.28-.66a.9.9 0 0 1 .67-.26h1.1v-1.6c0-.29.1-.53.3-.73a1 1 0 0 1 .72-.3l-.01.01c.29 0 .53.1.72.3.19.2.28.44.28.73v1.59h1.61c.27 0 .49.08.67.27.19.18.28.4.28.67s-.1.5-.28.67a.93.93 0 0 1-.67.26h-1.61v5.87c0 .24.04.43.12.58.08.15.2.25.33.3.15.06.29.09.44.09a.9.9 0 0 0 .4-.09.97.97 0 0 1 .4-.08c.17 0 .32.08.45.22.14.15.2.35.2.6 0 .33-.17.59-.52.79-.35.2-.72.3-1.12.3-.23 0-.5-.02-.8-.06a2.98 2.98 0 0 1-.9-.3 1.9 1.9 0 0 1-.72-.78 3.1 3.1 0 0 1-.29-1.5v-5.94Zm8.43 3.83c.06.51.2.97.43 1.38a3.32 3.32 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15a4.22 4.22 0 0 0 1.37-.8c.2-.12.4-.18.59-.18a.83.83 0 0 1 .86.84c0 .3-.15.57-.44.8-.36.35-.86.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.72-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.87.81 5.15 5.15 0 0 1 1.52 3.67.94.94 0 0 1-.32.67c-.2.17-.43.25-.7.25h-6.98Zm.06-1.7h5.8v-.15a2.2 2.2 0 0 0-.48-1.22 2.98 2.98 0 0 0-2.34-1.12c-.4 0-.79.06-1.15.19-.37.13-.7.33-1 .6a3.6 3.6 0 0 0-.84 1.69Zm12.53-2.26a3.84 3.84 0 0 1 1.08-1.35 3.54 3.54 0 0 1 2.23-.77c.35 0 .65.1.9.28.26.2.39.42.39.7 0 .36-.1.63-.28.8-.2.17-.4.25-.63.25-.2 0-.4-.04-.58-.13-.2-.09-.41-.13-.67-.13a2.35 2.35 0 0 0-1.66.88c-.24.28-.44.62-.58 1.01-.14.39-.2.83-.2 1.3v4.83a1 1 0 0 1-.3.74c-.2.2-.43.29-.72.29h.01a1 1 0 0 1-1.03-1.02v-8.53a1 1 0 0 1 1.03-1.02 1 1 0 0 1 1 1.03v.84Zm14.73-1.5v9.2a1 1 0 0 1-.27.73.9.9 0 0 1-.71.29.9.9 0 0 1-.7-.3 1 1 0 0 1-.27-.73V44.93c0-.26.1-.5.31-.71a1 1 0 0 1 .74-.32h.01c.17 0 .33.04.5.13.18.08.31.2.4.33l4.67 7.1 4.78-7.1a1 1 0 0 1 .83-.46c.26 0 .5.1.7.29.22.2.32.44.32.73v12.05a1 1 0 0 1-1.05 1.02c-.3 0-.55-.1-.75-.29a.98.98 0 0 1-.3-.73v-9.08l-3.78 5.76c-.1.13-.21.23-.37.32a.92.92 0 0 1-.45.13.93.93 0 0 1-.45-.13c-.16-.1-.28-.2-.38-.32l-3.78-5.88ZM310.93 46c-.38 0-.66-.07-.84-.2-.17-.15-.26-.39-.26-.72v-.32c0-.34.1-.57.28-.7.2-.14.47-.2.85-.2.4 0 .69.06.86.2.18.15.26.38.26.7v.32c0 .34-.09.59-.27.72-.19.13-.48.2-.87.2h-.01Zm1.03 10.96c0 .29-.1.53-.28.73-.2.2-.43.3-.72.3-.3 0-.54-.1-.72-.3a1 1 0 0 1-.28-.73v-8.6a1 1 0 0 1 1-1.03c.3 0 .54.1.72.3.2.19.3.43.3.73v8.6h-.02Zm4.44-3.73c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15.31-.1.58-.23.8-.38.22-.15.42-.28.57-.42.2-.12.4-.18.59-.18.25 0 .46.08.63.25.16.17.23.37.23.6 0 .28-.15.56-.44.8-.36.34-.86.65-1.5.92a5.78 5.78 0 0 1-4.9-.3 4.84 4.84 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.72-3.03a5.14 5.14 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.87.81 5.15 5.15 0 0 1 1.52 3.67.94.94 0 0 1-.32.67c-.2.17-.43.25-.7.25h-6.98Zm.06-1.7h5.8v-.15c-.04-.47-.2-.87-.49-1.22a3.04 3.04 0 0 0-2.33-1.12c-.4 0-.79.06-1.15.19a2.67 2.67 0 0 0-1.67 1.73 3.6 3.6 0 0 0-.16.57Zm11.46-2.13h-1.09a.91.91 0 0 1-.67-.27.91.91 0 0 1-.28-.68.93.93 0 0 1 .94-.92h1.1v-1.6c0-.29.1-.53.3-.73a1 1 0 0 1 .72-.3v.01c.3 0 .54.1.72.3.18.2.28.44.28.73v1.59h1.61c.27 0 .5.08.68.27.18.18.27.4.27.67a.9.9 0 0 1-.27.67.93.93 0 0 1-.68.26h-1.61v5.87c0 .24.04.43.12.58.08.15.2.25.34.3.14.06.28.09.43.09a.9.9 0 0 0 .4-.09.96.96 0 0 1 .41-.08c.16 0 .3.08.44.22.14.15.2.35.2.6 0 .33-.18.59-.52.79-.35.2-.73.3-1.13.3-.22 0-.5-.02-.8-.06-.3-.05-.6-.15-.9-.3a1.9 1.9 0 0 1-.72-.78c-.2-.35-.3-.86-.3-1.5V49.4Zm14.12 2.58-1.87 5.36c-.2.4-.48.62-.87.65a.96.96 0 0 1-.61-.13.92.92 0 0 1-.44-.5l-3.11-8.6a1.36 1.36 0 0 1-.06-.4c0-.26.09-.5.27-.72a.92.92 0 0 1 .73-.32 1 1 0 0 1 .58.17c.17.1.28.26.35.48l2.34 6.6 1.86-4.87a.92.92 0 0 1 .92-.63c.24 0 .43.06.57.16.13.11.24.26.32.47l1.84 4.77 2.31-6.5c.15-.43.47-.65.97-.65v-.01c.27 0 .5.1.7.3.2.19.29.43.29.75a1.08 1.08 0 0 1-.08.4l-3.08 8.6a.9.9 0 0 1-.42.5 1 1 0 0 1-.64.13c-.38-.03-.67-.24-.87-.65l-2-5.36Zm17.18 4.59a4.08 4.08 0 0 1-1.85 1.35 4.48 4.48 0 0 1-3.96-.44 5.04 5.04 0 0 1-1.75-1.97 6.09 6.09 0 0 1-.64-2.83c0-1.06.22-2.04.64-2.87a4.98 4.98 0 0 1 1.75-1.94c.72-.47 1.53-.7 2.42-.7a4.5 4.5 0 0 1 3.4 1.5v-.4c0-.28.09-.53.27-.72.2-.2.43-.3.72-.3a.97.97 0 0 1 1 1.02v8.69c0 .29-.1.53-.28.73-.19.2-.42.3-.72.3a.99.99 0 0 1-1-1.03v-.4Zm-3.1-.24a2.97 2.97 0 0 0 2.79-1.8c.26-.56.4-1.18.4-1.86 0-.68-.14-1.3-.4-1.86a3 3 0 0 0-2.79-1.78 2.9 2.9 0 0 0-1.64.48c-.48.3-.85.74-1.12 1.3a4.17 4.17 0 0 0-.42 1.87c0 .7.14 1.3.42 1.85.27.56.64 1 1.12 1.32.48.32 1.02.49 1.64.49v-.01Zm16.13 0-.16.25a3.95 3.95 0 0 1-1.96 1.38 4.73 4.73 0 0 1-3.9-.48 5.02 5.02 0 0 1-1.79-1.95 5.99 5.99 0 0 1-.65-2.85 6 6 0 0 1 .65-2.84 5.05 5.05 0 0 1 1.78-1.95 4.57 4.57 0 0 1 2.51-.72h.01a4.34 4.34 0 0 1 2.82.99c.28.22.51.46.7.7v-.6c0-.27.1-.52.28-.71.19-.2.43-.3.72-.3a.97.97 0 0 1 1 1.02v8.89c0 1.12-.24 2.05-.72 2.76a4.27 4.27 0 0 1-1.92 1.58 6.75 6.75 0 0 1-3.81.38c-.46-.1-.88-.2-1.26-.32a2.6 2.6 0 0 1-.8-.36c-.3-.16-.5-.34-.6-.56a.75.75 0 0 1-.01-.65c.12-.3.3-.48.53-.54.23-.07.5-.05.8.06l.6.22c.29.11.61.2.96.3.34.08.67.12.98.12 1.07 0 1.87-.24 2.42-.74.55-.5.82-1.16.82-2v-1.09Zm-3.2-7.3a3.16 3.16 0 0 0-2.9 1.78 4.08 4.08 0 0 0-.42 1.87c0 .7.14 1.32.42 1.87a3.13 3.13 0 0 0 2.9 1.79 3.1 3.1 0 0 0 2.86-1.78c.28-.56.42-1.18.42-1.88s-.14-1.32-.42-1.87a3.14 3.14 0 0 0-2.87-1.77Zm9.34 4.2c.06.51.2.97.43 1.38a3.32 3.32 0 0 0 2.98 1.73 3.3 3.3 0 0 0 2.02-.53c.22-.15.41-.28.57-.42.2-.12.4-.18.59-.18a.83.83 0 0 1 .86.84c0 .3-.15.57-.44.8-.36.35-.87.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.15 5.15 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15a2.2 2.2 0 0 0-.49-1.22 3.05 3.05 0 0 0-3.49-.93 2.67 2.67 0 0 0-1.67 1.73 3.6 3.6 0 0 0-.15.57Zm12.5-2.5.13-.17a4.55 4.55 0 0 1 1.98-1.47c.42-.16.86-.23 1.33-.23h.01c.95 0 1.69.2 2.21.6.53.4.9.92 1.1 1.58.2.66.31 1.4.31 2.22v5.39a1 1 0 0 1-1 1.03 1 1 0 0 1-1.03-1.03v-5.37c0-.48-.07-.91-.2-1.3a1.81 1.81 0 0 0-.7-.91 2.36 2.36 0 0 0-1.36-.34 3 3 0 0 0-1.45.34 2.47 2.47 0 0 0-1.33 2.21v5.37a1 1 0 0 1-1 1.03 1 1 0 0 1-1.03-1.03v-8.53a1 1 0 0 1 1.03-1.02c.3 0 .51.1.71.29.19.2.3.44.3.73v.62Zm10.83 3.74a.99.99 0 0 1-.72-.3.93.93 0 0 1-.3-.7c0-.3.1-.54.3-.72.2-.18.44-.27.72-.27h3.78c.28 0 .52.1.72.3.2.19.3.43.3.73 0 .29-.1.5-.3.69-.2.18-.44.27-.72.27h-3.78Zm9.73-.13v4.3a1 1 0 0 1-.27.74c-.18.2-.42.3-.71.3a.9.9 0 0 1-.7-.3 1.01 1.01 0 0 1-.27-.73V44.94a1 1 0 0 1 1.03-1.03h4.64c.7 0 1.37.2 1.97.58.6.38 1.09.9 1.45 1.56.36.66.55 1.4.55 2.23a4.44 4.44 0 0 1-2 3.78c-.6.4-1.26.6-1.97.6h-3.72Zm0-6.8v4.9h3.71v-.02c.35 0 .67-.11.96-.34a2.7 2.7 0 0 0 .97-2.11 2.65 2.65 0 0 0-.97-2.1c-.29-.22-.6-.33-.95-.33h-3.72Zm12.22 3.43a3.62 3.62 0 0 1 2.12-1.91c.38-.14.78-.2 1.2-.2.34 0 .64.09.9.27.26.2.38.42.38.7 0 .36-.1.63-.28.8a.9.9 0 0 1-.62.25c-.2 0-.4-.04-.59-.13a1.5 1.5 0 0 0-.66-.13c-.28 0-.58.08-.87.23-.3.15-.56.36-.8.65a3.42 3.42 0 0 0-.78 2.32v4.82a1 1 0 0 1-.3.74c-.2.2-.43.29-.71.29a1 1 0 0 1-1.02-1.02v-8.53a1 1 0 0 1 1.03-1.02c.3 0 .51.1.71.29.2.2.3.44.3.73v.85Zm7.67 3.96c.06.51.21.97.44 1.38a3.3 3.3 0 0 0 2.97 1.73c.5 0 .9-.05 1.22-.15.31-.1.58-.23.8-.38.22-.15.42-.28.57-.42.2-.12.4-.18.59-.18.25 0 .46.08.62.25a.8.8 0 0 1 .24.6c0 .28-.15.56-.44.8-.36.34-.87.65-1.5.92a5.78 5.78 0 0 1-4.9-.3 4.84 4.84 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.14 5.14 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.15 5.15 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15a2.2 2.2 0 0 0-.49-1.22 3.05 3.05 0 0 0-3.49-.93 2.67 2.67 0 0 0-1.66 1.73 3.6 3.6 0 0 0-.16.57ZM442.85 46c-.38 0-.67-.07-.84-.2-.18-.15-.26-.39-.26-.72v-.32c0-.34.1-.57.28-.7.2-.14.47-.2.85-.2.4 0 .68.06.86.2.18.15.26.38.26.7v.32c0 .34-.08.59-.27.72-.18.13-.47.2-.88.2Zm1.03 10.96c0 .29-.1.53-.28.73-.19.2-.43.3-.72.3-.3 0-.54-.1-.72-.3a1 1 0 0 1-.28-.73v-8.6a1 1 0 0 1 1-1.03c.3 0 .55.1.73.3.19.19.28.43.28.73v8.6Zm2.39-.63c-.12-.19-.18-.4-.16-.65.01-.25.15-.46.42-.64a.9.9 0 0 1 .59-.15c.2.03.4.13.6.32a3.63 3.63 0 0 0 3.76 1.22c.27-.08.52-.22.72-.4.2-.2.3-.48.3-.86 0-.34-.11-.6-.32-.8-.22-.2-.5-.36-.85-.49-.34-.13-.73-.25-1.14-.36a23.2 23.2 0 0 1-1.29-.4 5.38 5.38 0 0 1-1.17-.57 2.67 2.67 0 0 1-.86-.92 2.79 2.79 0 0 1-.32-1.38c0-.63.18-1.17.52-1.63.35-.45.81-.8 1.4-1.07a4.47 4.47 0 0 1 1.84-.38 5.36 5.36 0 0 1 2.5.62c.4.22.74.5 1.04.85.13.17.21.38.23.62.02.24-.09.46-.33.67a.76.76 0 0 1-.59.17.93.93 0 0 1-.56-.23 2.5 2.5 0 0 0-.99-.75 3.36 3.36 0 0 0-2.16-.15c-.27.07-.5.2-.7.38-.19.19-.28.46-.28.82 0 .34.11.6.34.8.22.21.5.37.87.5.37.15.76.26 1.19.37.41.1.83.23 1.24.38.4.15.77.34 1.1.57a2.67 2.67 0 0 1 1.12 2.3c0 .66-.19 1.22-.57 1.68a3.6 3.6 0 0 1-1.45 1.06c-.58.23-1.2.36-1.84.36-.76 0-1.52-.14-2.28-.42a4.2 4.2 0 0 1-1.91-1.43l-.01-.01Zm14.75-1.43 2.97-6.92c.19-.45.49-.66.9-.65.27 0 .5.09.68.26.18.17.27.39.27.64 0 .08-.02.17-.04.26a.94.94 0 0 1-.1.23l-3.82 8.6c-.18.4-.46.62-.87.65a.94.94 0 0 1-.6-.13.97.97 0 0 1-.44-.51l-3.8-8.59a3 3 0 0 1-.08-.23.9.9 0 0 1 .23-.92c.18-.2.42-.3.73-.3v.02c.2 0 .4.05.57.16.18.11.31.27.4.49l3 6.94Zm8.48-1.67c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.98 1.73c.5 0 .9-.05 1.21-.15a5.17 5.17 0 0 0 1.38-.8c.2-.12.4-.18.58-.18a.83.83 0 0 1 .87.84c0 .3-.15.57-.44.8a5.17 5.17 0 0 1-3.5 1.33 5.71 5.71 0 0 1-2.9-.7 4.85 4.85 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.13 5.13 0 0 1 1.52 3.67.94.94 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15c-.05-.47-.2-.87-.5-1.22a3.03 3.03 0 0 0-2.32-1.12c-.4 0-.8.06-1.16.19a2.66 2.66 0 0 0-1.67 1.73 3.6 3.6 0 0 0-.15.57Zm12.52-2.26a3.62 3.62 0 0 1 2.12-1.91c.38-.14.78-.2 1.2-.2.34 0 .64.09.9.27.26.2.38.42.38.7 0 .36-.1.63-.28.8a.91.91 0 0 1-.62.25c-.2 0-.4-.04-.59-.13-.19-.09-.4-.13-.67-.13s-.57.08-.86.23c-.3.15-.56.36-.8.65a3.4 3.4 0 0 0-.57 1.01c-.15.39-.22.83-.22 1.3v4.83a1 1 0 0 1-1 1.03 1 1 0 0 1-1.02-1.02v-8.53a1 1 0 0 1 1.02-1.02c.3 0 .52.1.72.29.19.2.3.44.3.73v.85Zm14.3 7.05a3.05 3.05 0 0 1-.98 1.05 4.31 4.31 0 0 1-2.47.82c-.96 0-1.8-.23-2.57-.71a5.01 5.01 0 0 1-1.79-1.95 5.99 5.99 0 0 1-.65-2.85 6 6 0 0 1 .65-2.84 5.05 5.05 0 0 1 1.79-1.95 4.57 4.57 0 0 1 2.5-.72h.01a4.34 4.34 0 0 1 2.83.99c.27.22.5.46.69.7v-.6c0-.27.1-.52.28-.71.19-.2.43-.3.72-.3a.97.97 0 0 1 1 1.02v8.89c0 1.12-.24 2.05-.72 2.76a4.27 4.27 0 0 1-1.92 1.58 6.75 6.75 0 0 1-3.81.38c-.46-.1-.88-.2-1.26-.32a2.6 2.6 0 0 1-.8-.36c-.3-.16-.5-.34-.6-.56a.75.75 0 0 1-.01-.65c.12-.3.3-.48.53-.54.23-.07.5-.05.8.06l.6.22c.3.11.61.2.96.3.34.08.67.12.98.12 1.07 0 1.87-.24 2.42-.74.55-.5.82-1.16.82-2v-1.09Zm-3.2-7.28a3.16 3.16 0 0 0-2.9 1.77 4.08 4.08 0 0 0-.42 1.87c0 .7.14 1.32.42 1.87a3.13 3.13 0 0 0 2.9 1.79 3.1 3.1 0 0 0 2.86-1.78c.28-.56.42-1.18.42-1.88s-.14-1.32-.42-1.87a3.14 3.14 0 0 0-2.87-1.77Zm10.49 7.92a1 1 0 0 1-1 1.02.96.96 0 0 1-.72-.29.98.98 0 0 1-.3-.73V44.14c0-.3.1-.54.3-.73a1 1 0 0 1 .73-.3c.28 0 .53.1.71.3.18.2.27.43.27.73v12.83h.01Zm4.52-3.73c.06.51.2.97.43 1.38a3.3 3.3 0 0 0 2.98 1.73c.5 0 .9-.05 1.21-.15.32-.1.59-.23.8-.38.22-.15.42-.28.58-.42.2-.12.4-.18.58-.18a.83.83 0 0 1 .87.84c0 .3-.15.57-.44.8-.36.35-.87.66-1.5.93a5.78 5.78 0 0 1-4.9-.3 4.84 4.84 0 0 1-1.9-1.9 5.66 5.66 0 0 1-.67-2.79c0-1.17.24-2.18.71-3.03a5.13 5.13 0 0 1 1.86-1.93 4.7 4.7 0 0 1 5.88.81 5.13 5.13 0 0 1 1.52 3.67.93.93 0 0 1-.32.67c-.2.17-.44.25-.7.25h-6.99Zm.07-1.7h5.8v-.15c-.05-.47-.2-.87-.5-1.22a3.05 3.05 0 0 0-3.48-.93 2.67 2.67 0 0 0-1.67 1.73c-.06.17-.11.36-.15.57ZM519.63 46c-.38 0-.67-.07-.84-.2-.18-.15-.26-.39-.26-.72v-.32c0-.34.1-.57.28-.7.2-.14.47-.2.85-.2.4 0 .68.06.86.2.18.15.26.38.26.7v.32c0 .34-.08.59-.27.72-.18.13-.47.2-.88.2Zm1.03 10.96c0 .29-.1.53-.28.73-.19.2-.43.3-.72.3-.3 0-.54-.1-.72-.3a1 1 0 0 1-.28-.73v-8.6a1 1 0 0 1 1-1.03c.3 0 .55.1.73.3.19.19.28.43.28.73v8.6Zm7.7-9.8c.73 0 1.37.08 1.94.24.56.15 1 .36 1.3.64.32.27.48.59.48.95 0 .23-.07.44-.2.63a.7.7 0 0 1-.61.3c-.2 0-.37-.03-.5-.1a1.48 1.48 0 0 1-.33-.23c-.1-.1-.23-.2-.4-.27a1.8 1.8 0 0 0-.66-.22 4.9 4.9 0 0 0-.76-.06 3.3 3.3 0 0 0-3.04 1.78 3.93 3.93 0 0 0-.43 1.86 4 4 0 0 0 .42 1.87 3.2 3.2 0 0 0 2.95 1.79 3.8 3.8 0 0 0 1.63-.32c.2-.12.4-.25.53-.38.14-.13.34-.19.59-.19.3 0 .52.1.67.28a1 1 0 0 1 .23.67c0 .3-.17.58-.53.86-.35.27-.83.5-1.41.67a6.8 6.8 0 0 1-1.97.26 4.87 4.87 0 0 1-4.5-2.7 6.15 6.15 0 0 1-.63-2.81c0-1.05.22-2 .66-2.83a5.1 5.1 0 0 1 1.84-1.96c.78-.48 1.7-.72 2.72-.72h.01Zm8.06 1.92a4.14 4.14 0 0 1 2.03-1.61c.4-.16.83-.24 1.28-.24.94 0 1.65.2 2.16.59.51.4.87.92 1.07 1.6.2.67.32 1.4.32 2.2v5.34a1 1 0 0 1-1.01 1.02 1 1 0 0 1-1.03-1.02v-5.33c0-.47-.06-.9-.19-1.28a1.93 1.93 0 0 0-.65-.93c-.3-.23-.74-.35-1.3-.35-.53 0-1 .12-1.4.35a2.47 2.47 0 0 0-1.28 2.2v5.34a1 1 0 0 1-1 1.02 1 1 0 0 1-1.04-1.02V44.14a1 1 0 0 1 1.03-1.03 1.01 1.01 0 0 1 1 1.03v4.95Z",
                fill: logoColor,
                className: "logo-claim"
            })
        ]
    });
};
// eslint-disable-next-line import/no-default-export
/* harmony default export */ __webpack_exports__["default"] = (BmLogo);


/***/ }),

/***/ 670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2903);

var viewBox = "0 0 616 111";
var logoColor = "#00977d";
var CgLogo = function CgLogo() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        viewBox: viewBox,
        role: "img",
        "aria-label": "CARIGAMI",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M35.73 67.25c.61.79.09 2.02-.97 2.02H18.78c-.79 0-1.49-.44-1.84-1.14C7.37 42.06 23 14.93 53.55 14.84h51.74A15.87 15.87 0 0 0 89.45 0H15.89A15.88 15.88 0 0 0 0 15.89v59.7h51.27c22.47 0 28.62-22.91 18.17-37.49-.61-.79-.09-2.02.97-2.02h15.98c.79 0 1.49.44 1.84 1.14 9.57 26.07-6.06 53.2-36.61 53.29H.05a15.87 15.87 0 0 0 15.84 14.84h73.57c8.78 0 15.89-7.11 15.89-15.89v-59.7H53.9c-22.47 0-28.62 22.91-18.17 37.49Z",
                fill: logoColor
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M336.2 8.6a7.53 7.53 0 0 1 8.28-7.54c3.95.34 6.86 3.9 6.86 7.87v54.19c0 3.97-2.91 7.53-6.86 7.87a7.52 7.52 0 0 1-8.28-7.54V8.6Zm28.31 27.62v-.2c0-19.56 15.24-35.59 36.08-35.59 10.42 0 17.3 2.36 23.5 6.69a7.57 7.57 0 0 1 3.14 6.38 7.64 7.64 0 0 1-8.48 7.12c-1.6-.2-2.7-.85-3.6-1.51-4.13-2.95-8.55-4.72-15.04-4.72-11.01 0-19.76 9.73-19.76 21.43v.2c0 12.58 8.65 21.82 20.84 21.82 5.5 0 10.42-1.38 14.25-4.13v-9.83h-9.97c-3.26 0-6.28-2.25-6.76-5.47a6.6 6.6 0 0 1 6.51-7.61h17.3a7.57 7.57 0 0 1 7.57 7.57v16.71c0 4.43-1.67 7.47-5.31 9.63a45.77 45.77 0 0 1-24.09 6.88c-21.42 0-36.17-15.03-36.18-35.37ZM517.45 8.79a7.57 7.57 0 0 1 7.57-7.57h1.67a7.76 7.76 0 0 1 6.88 3.93l18.29 29.78 18.38-29.88a7.4 7.4 0 0 1 6.78-3.83h1.67a7.57 7.57 0 0 1 7.57 7.57v54.26c0 3.51-2.2 6.81-5.59 7.7a7.53 7.53 0 0 1-9.45-7.31V29.13l-13.27 20.45c-1.57 2.36-3.54 3.83-6.29 3.83s-4.72-1.48-6.29-3.83l-13.08-20.16V63.2c0 3.74-2.6 7.18-6.3 7.71a7.32 7.32 0 0 1-8.54-7.29V8.79Zm83.06-.19a7.53 7.53 0 0 1 8.28-7.54c3.95.34 6.86 3.9 6.86 7.87v54.19c0 3.97-2.91 7.53-6.86 7.87a7.52 7.52 0 0 1-8.28-7.54V8.6Zm-92.4 53.15h-.02c1.1 3.55-.61 7.49-4.09 8.8a6.97 6.97 0 0 1-9.14-4.45l-1.53-4.93-3.84-12.36a.72.72 0 0 0-.68-.5h-22.8c-.82 0-1.38-.85-1.06-1.61l3.02-10.34c.23-.79.95-1.33 1.77-1.33h14.42a.7.7 0 0 0 .67-.93c-2.86-8.8-5.36-16-6.46-17.81-1.4-2.1-4.82-2.12-4.86-2.12-.04 0-3.61.03-5.26 2.35-1.23 1.95-4.01 11.64-6.71 21.01-2.3 7.98-5.15 17.91-8.56 28.62a6.98 6.98 0 0 1-13.28-4.22c3.35-10.52 6.18-20.35 8.45-28.24 4.33-15.06 6.35-21.85 8.75-25.23C462.45.65 471.72.25 473.52.25c5.27 0 12.37 2.19 16.48 8.36 2.8 4.19 7.44 18.67 16.65 48.44l1.46 4.7ZM310.75 45.16l.01-.01a.57.57 0 0 0-.22.88l10.04 12.2c1.48 1.87 2.46 3.44 2.46 5.8 0 4.23-3.54 6.98-7.18 6.98-3.44 0-5.7-1.67-7.47-3.93l-14.53-18.41a.72.72 0 0 0-.56-.27h-11.04a.71.71 0 0 0-.71.71v14.33a7.53 7.53 0 0 1-8.37 7.53c-3.9-.38-6.77-3.88-6.77-7.81V49.01a.71.71 0 0 0-.71-.71h-14.8a.7.7 0 0 0-.68.91l2.46 7.94 1.49 4.82a6.98 6.98 0 0 1-13.32 4.13l-1.49-4.82-3.87-12.47a.72.72 0 0 0-.68-.5h-23.43c-.95 0-1.59-.85-1.22-1.61l3.45-10.34c.26-.79 1.08-1.33 2.02-1.33h14.52a.7.7 0 0 0 .67-.93c-2.86-8.8-5.35-16-6.46-17.81-1.28-2.14-4.82-2.12-4.86-2.12-.29-.04-3.69.01-5.14 2.18-1.83 2.74-2.67 5.89-3.84 10.25-1.18 4.41-2.65 9.91-5.68 16.8-6.09 13.83-16 27.9-42.01 27.9-21.62 0-35.9-15.63-35.9-35.39v-.2c0-19.57 14.74-35.59 35.88-35.59 10.32 0 17.3 2.75 23 6.98a7.59 7.59 0 0 1 2.9 6.88c-.39 3.49-3.85 6.47-7.37 6.49a7.98 7.98 0 0 1-4.57-1.48c-4.23-3.14-8.66-4.91-14.06-4.91-11.6 0-20.55 9.52-20.55 21.31v.64c0 11.22 8.38 21.29 20.67 21.35 17.61.12 25.16-10.3 29.25-19.59A94.26 94.26 0 0 0 197.06 23c1.34-5 2.6-9.72 5.71-14.38C207.95.86 216.78.24 219.45.24h.05c5.27 0 12.37 2.19 16.48 8.36 1.98 2.96 4.87 11.03 9.62 25.94.1.29.37.5.68.5h50.6c7.37 0 11.6-3.93 11.6-9.73v-.2c0-6.48-4.52-9.83-11.89-9.83h-11.52a3.52 3.52 0 0 0-3.52 3.52v9.25c0 .64-.52 1.16-1.16 1.16h-12.83c-.64 0-1.16-.52-1.16-1.16V15.82a14.2 14.2 0 0 1 14.21-14.21h17.25c8.75 0 15.54 2.46 20.06 6.98 3.83 3.84 5.9 9.24 5.9 15.73v.2c0 10.51-5.11 17.12-13.07 20.64Z",
                fill: logoColor,
                className: "logo-cg-title"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M143.02 86.81c.41.2.65.52.71.95.06.43-.05.82-.35 1.17-.2.3-.46.46-.78.49-.32.03-.64-.04-.98-.21a8.16 8.16 0 0 0-1.69-.67 7.44 7.44 0 0 0-4.74.28 6.32 6.32 0 0 0-3.6 3.74 8.13 8.13 0 0 0-.49 2.9c0 1.17.18 2.21.53 3.11.35.9.84 1.66 1.46 2.29a5.77 5.77 0 0 0 2.2 1.39 7.88 7.88 0 0 0 6.3-.43c.33-.17.66-.23.98-.18.32.05.59.21.81.49.3.39.41.79.33 1.2-.07.41-.31.71-.7.89a11.53 11.53 0 0 1-3.23 1.13 10.66 10.66 0 0 1-5.56-.52 9.71 9.71 0 0 1-3.18-1.95 9.37 9.37 0 0 1-2.19-3.15 10.66 10.66 0 0 1-.81-4.27c0-1.43.25-2.75.75-3.96a9.46 9.46 0 0 1 5.26-5.23 10.45 10.45 0 0 1 6.57-.41 9.8 9.8 0 0 1 2.36.95h.04Zm18.03 11.06a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm18.2-4.52a6.35 6.35 0 0 1 2.8-2.57 5.02 5.02 0 0 1 2.2-.49c1.28 0 2.28.27 2.98.82.71.55 1.2 1.28 1.48 2.2.28.92.42 1.95.42 3.08v7.39c0 .41-.13.75-.39 1.02s-.6.4-1 .4-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-7.36c0-.65-.09-1.25-.26-1.78a2.6 2.6 0 0 0-.92-1.3 2.94 2.94 0 0 0-1.8-.49 3.63 3.63 0 0 0-3.26 1.79 3.41 3.41 0 0 0-.47 1.78v7.36c0 .41-.13.75-.39 1.02s-.6.4-1 .4-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-7.39c0-.65-.09-1.24-.26-1.77a2.59 2.59 0 0 0-.91-1.28 2.92 2.92 0 0 0-1.78-.49 3.58 3.58 0 0 0-3.68 3.54v7.39c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v.86a5.08 5.08 0 0 1 1.24-1.33 6.1 6.1 0 0 1 1.52-.86 4.9 4.9 0 0 1 1.81-.33l-.03-.01c1.38 0 2.43.34 3.18 1.02a4.65 4.65 0 0 1 1.3 2.04Zm16.97 9.96v6.06c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02V91.92c0-.39.13-.72.4-1s.61-.42 1.02-.42c.41 0 .72.14.99.42.27.28.4.61.4 1v.67l.08-.1a6.22 6.22 0 0 1 2.69-1.88c.59-.2 1.19-.31 1.83-.31l.01-.01c1.3 0 2.46.33 3.47.98a6.97 6.97 0 0 1 2.41 2.66c.6 1.12.89 2.43.89 3.92 0 1.49-.3 2.8-.89 3.94a6.9 6.9 0 0 1-2.4 2.69c-1 .65-2.14.98-3.4.98a6.05 6.05 0 0 1-4.69-2.15Zm4.3-10.46a4.18 4.18 0 0 0-3.88 2.42c-.37.74-.56 1.6-.56 2.56s.19 1.81.56 2.58a4.08 4.08 0 0 0 3.88 2.46 4.03 4.03 0 0 0 3.82-2.46c.37-.77.56-1.63.56-2.58 0-.95-.19-1.8-.56-2.55a4.44 4.44 0 0 0-1.53-1.78 3.97 3.97 0 0 0-2.29-.65Zm21.27 10.4a5.75 5.75 0 0 1-2.55 1.85 6.27 6.27 0 0 1-5.49-.61 6.95 6.95 0 0 1-2.42-2.72 8.49 8.49 0 0 1-.89-3.93c0-1.47.3-2.83.89-3.97a6.91 6.91 0 0 1 2.41-2.69 6.08 6.08 0 0 1 3.36-.98 6.17 6.17 0 0 1 4.72 2.1v-.57c0-.39.13-.72.39-1a1.3 1.3 0 0 1 1-.42l-.03.01c.41 0 .74.13 1 .4s.39.61.39 1.02v12.04c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.53Zm-4.3-.33c.87 0 1.64-.22 2.31-.67a4.44 4.44 0 0 0 1.56-1.83c.37-.77.56-1.63.56-2.58 0-.95-.19-1.81-.56-2.58a4.19 4.19 0 0 0-3.87-2.46c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.81.57 2.58.38.77.9 1.38 1.56 1.83.66.45 1.42.67 2.27.67Zm14.18-9.78a5.1 5.1 0 0 1 4.6-2.94c.48 0 .9.13 1.25.39s.53.59.53.98c0 .5-.13.87-.39 1.1-.26.23-.55.35-.86.35-.28 0-.55-.06-.81-.18a2.19 2.19 0 0 0-.92-.18c-.39 0-.79.1-1.2.31a3.5 3.5 0 0 0-1.11.91c-.33.4-.6.87-.79 1.41a5.41 5.41 0 0 0-.29 1.81v6.69c0 .41-.13.75-.4 1.02s-.6.4-.99.4l-.01-.01c-.41 0-.75-.13-1.02-.4s-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v1.18Zm19.58 10.11a5.75 5.75 0 0 1-2.55 1.85 6.27 6.27 0 0 1-5.49-.61 6.95 6.95 0 0 1-2.42-2.72 8.49 8.49 0 0 1-.89-3.93c0-1.47.3-2.83.89-3.97a6.91 6.91 0 0 1 2.41-2.69 6.08 6.08 0 0 1 3.36-.98 6.17 6.17 0 0 1 4.72 2.1v-.57c0-.39.13-.72.39-1a1.3 1.3 0 0 1 1-.42l-.03.01c.41 0 .74.13 1 .4s.39.61.39 1.02v12.04c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.53Zm-4.3-.33c.87 0 1.64-.22 2.31-.67a4.44 4.44 0 0 0 1.56-1.83c.37-.77.56-1.63.56-2.58 0-.95-.19-1.81-.56-2.58a4.19 4.19 0 0 0-3.87-2.46c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.81.57 2.58.38.77.9 1.38 1.56 1.83.66.45 1.42.67 2.27.67Zm12.72-9.62h-1.52c-.37 0-.68-.13-.93-.38a1.27 1.27 0 0 1-.38-.93c0-.37.13-.68.38-.92s.56-.36.93-.36h1.52v-2.18c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4l-.01-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v2.2h2.23c.37 0 .68.13.93.38s.38.56.38.93-.13.68-.38.92a1.3 1.3 0 0 1-.93.36h-2.23v8.14c0 .33.06.6.17.81.11.21.26.34.46.42.2.07.39.11.6.11.21 0 .39-.04.54-.11.16-.07.35-.11.57-.11.22 0 .43.1.61.31.18.2.28.48.28.84 0 .45-.24.81-.72 1.09s-1 .42-1.56.42c-.32 0-.69-.03-1.11-.08-.42-.05-.84-.2-1.24-.42a2.6 2.6 0 0 1-1-1.07 4.36 4.36 0 0 1-.4-2.08V93.3Zm11.69 5.32c.08.7.28 1.33.59 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.09-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.21.8Zm25.5-5.71c.39 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.93-.54 3.44-1.62 4.53-1.08 1.09-2.6 1.63-4.57 1.63-1.97 0-3.49-.54-4.56-1.63-1.07-1.09-1.6-2.6-1.6-4.53v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.21.28 2.11.85 2.7.57.59 1.4.89 2.49.89 1.09 0 1.96-.3 2.52-.89.56-.59.85-1.5.85-2.7v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4h.02Zm8.47 2.6a5.1 5.1 0 0 1 4.6-2.94c.48 0 .9.13 1.25.39s.53.59.53.98c0 .5-.13.87-.39 1.1-.26.23-.55.35-.86.35-.28 0-.55-.06-.81-.18a2.19 2.19 0 0 0-.92-.18c-.39 0-.79.1-1.2.31a3.5 3.5 0 0 0-1.11.91c-.33.4-.6.87-.79 1.41a5.41 5.41 0 0 0-.29 1.81v6.69c0 .41-.13.75-.4 1.02s-.6.4-.99.4l-.01-.01c-.41 0-.75-.13-1.02-.4s-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v1.18Zm28.08 10.1a5.67 5.67 0 0 1-2.55 1.87 6.27 6.27 0 0 1-5.49-.61 6.96 6.96 0 0 1-2.42-2.7 8.47 8.47 0 0 1-.89-3.94c0-1.48.3-2.8.89-3.94a7.01 7.01 0 0 1 2.41-2.7 6.01 6.01 0 0 1 3.36-.99 6.17 6.17 0 0 1 4.72 2.1v-6.31c0-.41.13-.75.39-1.02s.59-.4 1-.4l-.03-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v17.78c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.55Zm-4.29-.32a4 4 0 0 0 2.32-.67 4.65 4.65 0 0 0 1.55-1.81c.38-.76.56-1.63.56-2.59s-.19-1.83-.56-2.59a4.1 4.1 0 0 0-3.87-2.45c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.83.57 2.59.38.76.9 1.37 1.56 1.81.66.44 1.41.67 2.26.67h.01Zm13.36-4.3c.08.7.28 1.33.59 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.09-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.21.8Zm25.76 7.53c0 .41-.14.75-.4 1.02-.27.27-.6.4-.99.4s-.72-.13-.99-.4-.4-.61-.4-1.02V86c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4s.74.13.99.4.38.61.38 1.02v17.78h-.01Zm18.33-5.91a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm12.86-7.66c1 0 1.9.11 2.68.32a4.6 4.6 0 0 1 1.83.89c.44.38.65.82.65 1.32 0 .32-.09.61-.28.88-.19.27-.46.4-.84.4a1.47 1.47 0 0 1-1.15-.46 2.07 2.07 0 0 0-.54-.38 2.43 2.43 0 0 0-.92-.29c-.41-.07-.76-.1-1.06-.1a4.6 4.6 0 0 0-4.22 2.47 5.4 5.4 0 0 0-.6 2.58c0 .97.2 1.83.6 2.59a4.4 4.4 0 0 0 4.08 2.48c.54 0 .99-.04 1.35-.13.36-.08.66-.19.91-.32.3-.17.54-.34.74-.52.2-.18.47-.27.82-.27.41 0 .72.13.93.38.21.25.32.56.32.93 0 .41-.25.8-.74 1.19-.49.38-1.15.69-1.97.93a9.7 9.7 0 0 1-2.73.36 6.91 6.91 0 0 1-3.75-1 6.74 6.74 0 0 1-2.48-2.73 8.54 8.54 0 0 1-.88-3.9c0-1.45.31-2.77.92-3.92a7.02 7.02 0 0 1 2.55-2.72c1.09-.67 2.35-1 3.78-1v.02Zm19.01 13.04a5.75 5.75 0 0 1-2.55 1.85 6.27 6.27 0 0 1-5.49-.61 6.95 6.95 0 0 1-2.42-2.72 8.49 8.49 0 0 1-.89-3.93c0-1.47.3-2.83.89-3.97a6.91 6.91 0 0 1 2.41-2.69 6.08 6.08 0 0 1 3.36-.98 6.17 6.17 0 0 1 4.72 2.1v-.57c0-.39.13-.72.39-1a1.3 1.3 0 0 1 1-.42l-.03.01c.41 0 .74.13 1 .4s.39.61.39 1.02v12.04c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.53Zm-4.3-.33c.87 0 1.64-.22 2.31-.67a4.44 4.44 0 0 0 1.56-1.83c.37-.77.56-1.63.56-2.58 0-.95-.19-1.81-.56-2.58a4.19 4.19 0 0 0-3.87-2.46c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.81.57 2.58.38.77.9 1.38 1.56 1.83.66.45 1.42.67 2.27.67Zm12.72-9.62h-1.52c-.37 0-.68-.13-.93-.38a1.27 1.27 0 0 1-.38-.93c0-.37.13-.68.38-.92s.56-.36.93-.36h1.52v-2.18c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4l-.01-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v2.2h2.23c.37 0 .68.13.93.38s.38.56.38.93-.13.68-.38.92a1.3 1.3 0 0 1-.93.36h-2.23v8.14c0 .33.06.6.17.81.11.21.26.34.46.42.2.07.39.11.6.11.21 0 .39-.04.54-.11.16-.07.35-.11.57-.11.22 0 .43.1.61.31.18.2.28.48.28.84 0 .45-.24.81-.72 1.09s-1 .42-1.56.42c-.32 0-.69-.03-1.11-.08-.42-.05-.84-.2-1.24-.42a2.6 2.6 0 0 1-1-1.07 4.36 4.36 0 0 1-.4-2.08V93.3Zm11.05-4.71c-.54 0-.93-.1-1.17-.29-.24-.19-.36-.53-.36-.99v-.45c0-.46.13-.79.39-.98.26-.19.65-.28 1.17-.28.56 0 .96.1 1.2.29.24.19.36.52.36.96v.45c0 .48-.13.82-.38 1-.25.18-.65.28-1.21.28v.01Zm1.42 15.19c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02V91.85c0-.41.13-.75.4-1.02s.6-.4.99-.4a1.35 1.35 0 0 1 1.39 1.42v11.93Zm18.23-5.91a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm9.14-5.06.18-.25a6.54 6.54 0 0 1 2.74-2.03 5.35 5.35 0 0 1 1.84-.32h.01a5 5 0 0 1 3.07.82 4.33 4.33 0 0 1 1.52 2.2c.29.92.43 1.95.43 3.08v7.47c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02v-7.44c0-.67-.09-1.27-.28-1.8-.19-.53-.5-.95-.95-1.27a3.24 3.24 0 0 0-1.9-.47 4.2 4.2 0 0 0-2.01.47c-.58.32-1.03.74-1.35 1.27a3.33 3.33 0 0 0-.49 1.8v7.44c0 .41-.13.75-.4 1.02s-.6.4-.99.4-.75-.13-1.02-.4-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v.85Zm32.87 10.42a5.67 5.67 0 0 1-2.55 1.88 6.27 6.27 0 0 1-5.49-.61 6.96 6.96 0 0 1-2.42-2.7 8.47 8.47 0 0 1-.89-3.94c0-1.48.3-2.8.89-3.94a7.01 7.01 0 0 1 2.41-2.7 6.01 6.01 0 0 1 3.36-.99 6.17 6.17 0 0 1 4.72 2.1v-6.31c0-.41.13-.75.39-1.02s.59-.4 1-.4l-.03-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v17.78c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02v-.55Zm-4.29-.31a4 4 0 0 0 2.32-.67 4.65 4.65 0 0 0 1.55-1.81c.38-.76.56-1.63.56-2.59s-.19-1.83-.56-2.59a4.1 4.1 0 0 0-3.87-2.45c-.87 0-1.61.22-2.27.65a4.5 4.5 0 0 0-1.56 1.8 5.73 5.73 0 0 0-.57 2.59c0 .96.19 1.83.57 2.59.38.76.9 1.37 1.56 1.81.66.44 1.41.67 2.26.67h.01Zm13.36-4.3c.08.7.28 1.33.59 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.09-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.22.8Zm28.58 4.67 4.11-9.6c.26-.61.68-.91 1.25-.89.37 0 .68.12.93.36a1.2 1.2 0 0 1 .32 1.25c-.04.13-.08.24-.14.33l-5.3 11.93c-.24.56-.64.85-1.2.89a1.3 1.3 0 0 1-.84-.18 1.38 1.38 0 0 1-.61-.71l-5.27-11.9-.11-.32a1.35 1.35 0 0 1-.06-.43c0-.28.13-.56.38-.84a1.3 1.3 0 0 1 1.02-.42l.02.01c.28 0 .54.07.79.22s.43.37.54.67l4.17 9.63Zm23.85-3.05a7.8 7.8 0 0 1-.98 3.94 7.13 7.13 0 0 1-6.41 3.67 7.32 7.32 0 0 1-6.42-3.67 7.74 7.74 0 0 1-.99-3.94 7.4 7.4 0 0 1 3.65-6.67 7.23 7.23 0 0 1 3.76-.99 7.23 7.23 0 0 1 6.41 3.69 7.9 7.9 0 0 1 .98 3.97Zm-2.79 0c0-1.02-.2-1.91-.61-2.66a4.64 4.64 0 0 0-1.66-1.77 4.34 4.34 0 0 0-2.33-.64c-.86 0-1.64.21-2.34.64a4.59 4.59 0 0 0-1.67 1.77 5.47 5.47 0 0 0-.61 2.66c0 1.02.2 1.86.61 2.62a4.55 4.55 0 0 0 4.01 2.42c.85 0 1.63-.21 2.33-.64a4.6 4.6 0 0 0 1.66-1.78c.41-.76.61-1.64.61-2.62Zm7.56-9.28c-.54 0-.93-.1-1.17-.29-.24-.19-.36-.53-.36-.99v-.45c0-.46.13-.79.39-.98.26-.19.65-.28 1.17-.28.56 0 .96.1 1.2.29.24.19.36.52.36.96v.45c0 .48-.13.82-.38 1-.25.18-.65.28-1.21.28v.01Zm1.42 15.19c0 .41-.13.75-.39 1.02s-.59.4-1 .4c-.41 0-.74-.13-1-.4a1.41 1.41 0 0 1-.39-1.02V91.85c0-.41.13-.75.4-1.02s.6-.4.99-.4a1.35 1.35 0 0 1 1.39 1.42v11.93Zm5.5-10.48h-1.52c-.37 0-.68-.13-.93-.38a1.27 1.27 0 0 1-.38-.93c0-.37.13-.68.38-.92s.56-.36.93-.36h1.52v-2.18c0-.41.14-.75.42-1.02.28-.27.61-.4 1-.4l-.01-.02c.41 0 .74.13 1 .4s.39.61.39 1.02v2.2h2.23c.37 0 .68.13.93.38s.38.56.38.93-.13.68-.38.92a1.3 1.3 0 0 1-.93.36h-2.23v8.14c0 .33.06.6.17.81.11.21.26.34.46.42.2.07.39.11.6.11.21 0 .39-.04.54-.11.16-.07.35-.11.57-.11.22 0 .43.1.61.31.18.2.28.48.28.84 0 .45-.24.81-.72 1.09s-1 .42-1.56.42c-.32 0-.69-.03-1.11-.08-.42-.05-.84-.2-1.24-.42a2.6 2.6 0 0 1-1-1.07 4.36 4.36 0 0 1-.4-2.08V93.3Zm20.78-2.76c.39 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.93-.54 3.44-1.62 4.53-1.08 1.09-2.6 1.63-4.57 1.63-1.97 0-3.49-.54-4.56-1.63-1.07-1.09-1.6-2.6-1.6-4.53v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v7.33c0 1.21.28 2.11.85 2.7.57.59 1.4.89 2.49.89 1.09 0 1.96-.3 2.52-.89.56-.59.85-1.5.85-2.7v-7.33c0-.41.13-.75.4-1.02s.61-.4 1.02-.4h.02Zm8.47 2.6a5.1 5.1 0 0 1 4.6-2.94c.48 0 .9.13 1.25.39s.53.59.53.98c0 .5-.13.87-.39 1.1-.26.23-.55.35-.86.35-.28 0-.55-.06-.81-.18a2.19 2.19 0 0 0-.92-.18c-.39 0-.79.1-1.2.31a3.5 3.5 0 0 0-1.11.91c-.33.4-.6.87-.79 1.41a5.41 5.41 0 0 0-.29 1.81v6.69c0 .41-.13.75-.4 1.02s-.6.4-.99.4l-.01-.01c-.41 0-.75-.13-1.02-.4s-.4-.61-.4-1.02V91.96c0-.41.13-.75.4-1.02s.61-.4 1.02-.4c.41 0 .72.13.99.4s.4.61.4 1.02v1.18Zm10.63 5.48c.09.7.28 1.33.6 1.89a4.6 4.6 0 0 0 4.13 2.4c.69 0 1.25-.07 1.69-.21a4.4 4.4 0 0 0 1.11-.51c.31-.2.57-.4.79-.59.28-.17.55-.25.81-.25a1.16 1.16 0 0 1 1.19 1.17c0 .41-.2.78-.61 1.11-.5.48-1.19.91-2.08 1.28a7.1 7.1 0 0 1-2.77.56l.01.01a8.01 8.01 0 0 1-4.01-.96 6.7 6.7 0 0 1-2.63-2.65 7.85 7.85 0 0 1-.93-3.86c0-1.63.33-3.03.99-4.19a7.15 7.15 0 0 1 2.58-2.68 6.56 6.56 0 0 1 8.15 1.11 7.08 7.08 0 0 1 1.52 2.26c.37.87.57 1.81.59 2.83-.02.37-.17.68-.45.92s-.6.36-.98.36h-9.7Zm.1-2.37h8.04v-.2a3.08 3.08 0 0 0-.67-1.7 4.24 4.24 0 0 0-3.24-1.56c-.56 0-1.09.09-1.6.26a3.7 3.7 0 0 0-2.32 2.4c-.09.24-.16.51-.22.8Z",
                fill: logoColor,
                className: "logo-claim"
            })
        ]
    });
};
// eslint-disable-next-line import/no-default-export
/* harmony default export */ __webpack_exports__["default"] = (CgLogo);


/***/ }),

/***/ 5356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2903);

var viewBox = "0 0 515.6 144.2";
var width = "175px";
var height = "30px";
var primaryLogoColor = "#005e34";
var Floyt = function Floyt() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        viewBox: viewBox,
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fill: primaryLogoColor,
                d: "M505.8,22.8c0-6.7-5.5-12.2-12.2-12.2h-99.9c-3.8,0-7.3,1.7-9.7,4.7c-1.1,1.1-30.2,42-30.2,42 c-1,1.4-3,1.7-4.4,0.7c-0.3-0.2-0.5-0.4-0.7-0.7c0,0-28.6-39.7-29.3-40.5c-2.6-3.8-6-6.2-10.5-6.2h-70.5c-60.6,0-75,55.3-60.4,86.8 c0.5,1.2,1.7,1.9,2.9,1.9h25.8c1.1,0,2-0.9,2-2c0-0.5-0.2-0.9-0.5-1.3c-16.4-16.3-11.1-61,27.3-61h61.1c1.5,0,2.9,0.7,3.8,1.9 l36.1,47.6c0.8,1,1.2,2.3,1.2,3.6v31.6c0,7.4,6,13.4,13.4,13.5l0,0c7.4,0,13.5-6,13.5-13.4c0,0,0,0,0,0V88 c-0.2-1.3,0.2-2.5,0.9-3.6c0.1-0.2,35.3-47.5,35.3-47.5c0.9-1.2,2.3-1.9,3.8-1.9h32.8c1.8,0,3.2,1.4,3.2,3.2l0,81.3 c0,7.4,5.9,13.5,13.4,13.6l0.1-0.1c7.4,0,13.5-6,13.5-13.4l-0.1-81.3c0-1.8,1.4-3.2,3.2-3.2h0h23.1C500.3,35,505.8,29.5,505.8,22.8 C505.8,22.8,505.8,22.8,505.8,22.8L505.8,22.8z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fill: primaryLogoColor,
                d: "M290.4,44.9h-25.9c-1.1,0-2,0.9-2,2c0,0.4,0.2,0.9,0.4,1.2c16.8,23.6,6.8,60.8-29.6,60.8h-96.3 c-1.8,0-3.2-1.4-3.2-3.2c0,0,0,0,0,0V24.1c0-4.1-1.8-8-5-10.5c-2.2-1.9-5.1-2.9-8-2.9H19.4C12,10.7,6,16.7,6,24.1v95.5 c0,7.4,6,13.5,13.5,13.5c0,0,0,0,0,0l0,0c7.4,0,13.4-6,13.4-13.5V88.8c0-1.8,1.4-3.2,3.2-3.2l0,0h28.8c6.7,0,12.2-5.5,12.2-12.2 c0,0,0,0,0,0l0,0c0-6.8-5.5-12.2-12.2-12.2c0,0,0,0,0,0H36.1c-1.7,0-3.2-1.4-3.2-3.2V38.3c0-1.8,1.4-3.2,3.2-3.2l0,0h67.4 c1.8,0,3.2,1.4,3.2,3.2l0,0v81.2c0,7.4,6,13.5,13.4,13.5c0,0,0,0,0,0c0,0,113.5,0,113.8-0.1c49.6,0,74.9-43.9,59.3-86.1 C292.8,45.7,291.7,44.9,290.4,44.9z"
            })
        ]
    });
};
// eslint-disable-next-line import/no-default-export
/* harmony default export */ __webpack_exports__["default"] = (Floyt);


/***/ }),

/***/ 6522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_y": function() { return /* reexport */ src/* Context */._y; },
  "P7": function() { return /* reexport */ I18n_namespaceObject; },
  "CE": function() { return /* reexport */ OptimizationLegacy_namespaceObject; },
  "Ld": function() { return /* reexport */ src/* String */.Ld; },
  "AK": function() { return /* reexport */ StyleLegacy_namespaceObject; },
  "Q2": function() { return /* reexport */ src/* Theme */.Q2; },
  "ws": function() { return /* reexport */ UiLegacy_namespaceObject; }
});

// UNUSED EXPORTS: BodyBoldText, BodyText, Button, DataInterop, Heading1, Heading2, Heading3, Heading4, Heading5, Heading6, ImageWithFocalPoint, InteractiveText, Links, MediaLegacy, SecondaryText, Session, Styles, Subtitle, TertiaryText, Type, Ui, api, bodyBold, datetime, http, interactiveText, jwt, secondaryText

// NAMESPACE OBJECT: ../../frontend/shared/src/_legacy/I18n/index.ts
var I18n_namespaceObject = {};
__webpack_require__.r(I18n_namespaceObject);
__webpack_require__.d(I18n_namespaceObject, {
  "important": function() { return important; },
  "useLocale": function() { return useLocale; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/_legacy/OptimizationLegacy/index.ts
var OptimizationLegacy_namespaceObject = {};
__webpack_require__.r(OptimizationLegacy_namespaceObject);
__webpack_require__.d(OptimizationLegacy_namespaceObject, {
  "t": function() { return ResponsiveImage; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/_legacy/UiLegacy/index.ts
var UiLegacy_namespaceObject = {};
__webpack_require__.r(UiLegacy_namespaceObject);
__webpack_require__.d(UiLegacy_namespaceObject, {
  "ActivityIndicator": function() { return ActivityIndicator; },
  "BulletList": function() { return BulletList; },
  "Button": function() { return Button; },
  "CalloutText": function() { return CalloutText; },
  "Card": function() { return Card; },
  "Checkbox": function() { return Checkbox; },
  "DateRangePicker": function() { return DateRangePicker; },
  "Dropdown": function() { return Dropdown; },
  "ForegroundLayer": function() { return ForegroundLayer; },
  "ImageSVG": function() { return ImageSVG; },
  "LinkButton": function() { return LinkButton; },
  "Markup": function() { return Markup; },
  "PixelIcon": function() { return PixelIcon; },
  "PlainText": function() { return PlainText; },
  "PrimaryTitle": function() { return PrimaryTitle; },
  "Quote": function() { return Quote; },
  "Rating": function() { return Rating; },
  "SectionTitle": function() { return SectionTitle; },
  "SmallText": function() { return SmallText; },
  "SvgIcon": function() { return SvgIcon; },
  "TinyText": function() { return TinyText; },
  "Tooltip": function() { return Tooltip; },
  "useForegroundLayer": function() { return useForegroundLayer; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/_legacy/StyleLegacy/index.ts
var StyleLegacy_namespaceObject = {};
__webpack_require__.r(StyleLegacy_namespaceObject);
__webpack_require__.d(StyleLegacy_namespaceObject, {
  "m": function() { return CSSReset; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/I18n/transformations/important.tsx

/** @todo: If necessary, provide styles for the "b" tag */ var important = function important(content) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
        children: content
    });
};


// EXTERNAL MODULE: ../../frontend/shared/src/Context/index.ts + 7 modules
var Context = __webpack_require__(6729);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/I18n/useLocale.ts

// have to do this because type assertion functions have some stupid restrictions
var hasContext = Context.guardContext;
var useLocale = function useLocale() {
    var context = (0,Context.useClientContext)("locale");
    hasContext("locale", context);
    var _value = context.value, locale = _value.locale, language = _value.language, market = _value.market;
    return {
        locale: locale,
        language: language,
        market: market
    };
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/I18n/index.ts



// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/MediaLegacy/PictureWithModilePixel.styles.ts


var PictureWithModilePixel_styles_Picture = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("picture", _define_property({
    target: "e1u6nqb10"
}, "target", "e1u6nqb10"))("display:none;height:100%;width:100%;right:0;@media (min-width:calc(36rem + 1px)){display:block;}")));
var PictureWithModilePixel_styles_Image = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("img", _define_property({
    target: "e1u6nqb11"
}, "target", "e1u6nqb11"))("height:100%;")));


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/MediaLegacy/PictureWithMobilePixel.tsx



var PictureWithMobilePixel = function PictureWithMobilePixel(props) {
    return /*#__PURE__*/ _jsxs(Picture, {
        children: [
            /*#__PURE__*/ _jsx("source", {
                srcSet: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                media: "(max-width: 36rem)"
            }),
            /*#__PURE__*/ _jsx(Image, _object_spread({}, props))
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/MediaLegacy/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/OptimizationLegacy/ResponsiveImage.tsx



var ResponsiveImage = function ResponsiveImage(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), (0,src_object_spread/* default */.Z)({
        layout: "fill",
        objectFit: "cover"
    }, props));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/OptimizationLegacy/index.ts


// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var src = __webpack_require__(2775);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ActivityIndicator/ActivityIndicator.styles.ts




var loading = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{left:50%;width:0;z-index:100;}33.3333%{left:0;width:100%;z-index:10;}100%{left:0;width:100%;z-index:1;}");
var LoadingIndicator = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1x0lb530"
}, "target", "e1x0lb530"))("text-align:center;position:absolute;display:inline;width:0;top:0;height:2px;left:50%;background-color:", src/* Theme.Color.primary */.Q2.Color.primary, ";animation-name:", loading, ";animation-duration:2s;animation-timing-function:ease-in;animation-iteration-count:infinite;animation-delay:0.1s;&:first-of-type,&:last-child{background-color:", src/* Theme.Color.natural70 */.Q2.Color.natural70, ";}&.loading-indicator-top{top:0;}&.loading-indicator-bottom{bottom:0;}");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1x0lb531"
}, "target", "e1x0lb531"))("width:100%;background-color:", src/* Theme.Color.primary100 */.Q2.Color.primary100, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ActivityIndicator/ActivityIndicator.tsx



var ActivityIndicator = function ActivityIndicator() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingIndicator, {})
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ActivityIndicator/index.ts


// EXTERNAL MODULE: ../../frontend/shared/src/Theme/index.ts + 8 modules
var Theme = __webpack_require__(6321);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Card/Card.styles.ts



var CardContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1liycvl0"
}, "target", "e1liycvl0"))("&:empty{display:none;}&:not(:empty){border:", function(param) {
    var hasBorder = param.hasBorder;
    return hasBorder ? "1px solid ".concat(Theme.Color.natural50) : 0;
}, ";border-radius:1px;container-type:inline-size;}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Card/Card.tsx


var Card = function Card(param) {
    var children = param.children, _hasBorder = param.hasBorder, hasBorder = _hasBorder === void 0 ? false : _hasBorder, id = param.id;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContainer, {
        id: id,
        hasBorder: hasBorder,
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Card/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/PixelIcon.styles.ts


var ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e4ozkux0"
}, "target", "e4ozkux0"))("position:relative;min-width:", function(param) {
    var _w = param.w, w = _w === void 0 ? "19px" : _w;
    return w;
}, ";height:", function(param) {
    var _h = param.h, h = _h === void 0 ? "19px" : _h;
    return h;
}, ";margin-right:", function(props) {
    return props.hasMarginRight ? "0.3125rem" : 0;
}, ";margin-top:0.25rem;");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/pixelIconDefinitions.tsx
/**
 * All Pixel icons are defined in this file.
 * Steps to add more icons:
 *   - Export icon as PNG in 19x19px (or larger if needed)
 *   - Convert image to base64
 *   - Copy base64 content to src below
 */ var iconDefinitions = {
    garantie: {
        src: "data:image/png;base64,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",
        width: 90,
        height: 90
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/PixelIcon.tsx



var PixelIcon = function PixelIcon(param) {
    var hasMarginRight = param.hasMarginRight, height = param.height, name = param.name, label = param.label, width = param.width;
    var iconDefinition = iconDefinitions[name];
    return iconDefinition && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
        hasMarginRight: hasMarginRight,
        w: width,
        h: height,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: iconDefinition.src,
            alt: label || "",
            width: iconDefinition.width,
            height: iconDefinition.height
        })
    });
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/SvgIcon.styles.ts



var selectSizeValue = function selectSizeValue(size) {
    switch(size){
        case "tiny":
            return 0.5;
        case "large":
            return 1.25;
        case "small":
        default:
            return 1;
    }
};
var setSize = function setSize(param) {
    var size = param.size;
    if (!size) {
        return null;
    }
    var sizeValue = selectSizeValue(size);
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", sizeValue, "rem;height:", sizeValue, "rem;");
};
var StyledSvg = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", (0,src_define_property/* default */.Z)({
    target: "e1jy89gv0"
}, "target", "e1jy89gv0"))("width:100%;height:100%;", setSize);


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/svgIconDefinitions.tsx
/**
 * All SVG icons are defined in this file.
 * Steps to add more icons:
 *   - Export icon as SVG in largest size
 *   - Open file and copy ONLY the contents below <svg> to the "svg" prop of a new object
 *       - also put the prettier-ignore directive before the "svg" prop, otherwise all SVG props will be on separate lines
 *   - Replace all colors with "currentColor" to allow parent CSS color to change the SVG color
 *   - Run an ESLint fix to replace attributes with a dash (like "stroke-width") with their JSX counterparts
 *   - Add the viewBox values from the exported file to the "viewBox" prop of your new object
 */ 
var svgIconDefinitions_iconDefinitions = {
    arrowUp: {
        viewBox: "0 0 512 512",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M-2 354l60 60 196-196 196 196 60-60L254 98-2 354z"
        })
    },
    checkCircle: {
        viewBox: "0 0 16 16",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M8 .2C3.7.2.2 3.7.2 8s3.5 7.8 7.8 7.8 7.8-3.5 7.8-7.8S12.3.2 8 .2zm5.2 5.5L6.8 12c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1L2.8 8.5c-.1-.1-.1-.4 0-.5L4 6.8c.1-.1.4-.1.5 0l2.1 2.1L11.5 4c.1-.1.4-.1.5 0l1.2 1.2c.1.1.1.2.1.3 0 0 0 .1-.1.2z"
        })
    },
    check: {
        viewBox: "0 0 16 13",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            d: "M15.842 1.942L14.058.158a.54.54 0 0 0-.764 0L5.865 7.587l-3.16-3.16a.54.54 0 0 0-.763 0L.158 6.212a.54.54 0 0 0 0 .764L5.483 12.3a.539.539 0 0 0 .765 0l9.594-9.594a.54.54 0 0 0 0-.764z"
        })
    },
    error: {
        viewBox: "0 0 25 25",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M12.55 2C18.376 2 23.1 6.724 23.1 12.55c0 5.825-4.725 10.55-10.55 10.55C6.724 23.1 2 18.376 2 12.55 2 6.724 6.724 2 12.55 2zm0 1.918a8.632 8.632 0 100 17.264 8.632 8.632 0 000-17.264zm4.246 4.303c.455.455.394 1.257-.138 1.788l-2.457 2.457 2.457 2.458c.532.531.594 1.333.138 1.789-.455.455-1.257.394-1.789-.138l-2.457-2.458-2.457 2.458c-.533.533-1.334.593-1.789.138-.456-.456-.395-1.257.138-1.79l2.457-2.457-2.457-2.457c-.533-.532-.593-1.333-.138-1.788.456-.456 1.256-.395 1.789.137l2.457 2.457 2.457-2.457c.532-.532 1.333-.593 1.789-.137z"
        })
    },
    info: {
        viewBox: "0 0 25 25",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M1.5 12.5c0-6.075 4.925-11 11-11 6.074 0 11 4.925 11 11 0 6.074-4.926 11-11 11-6.075 0-11-4.926-11-11zm2 0a9 9 0 0 0 18 0 9 9 0 0 0-18 0zm10.217 4.754c0 .785-.546 1.42-1.217 1.42-.672 0-1.217-.635-1.217-1.42v-5.682c0-.784.545-1.42 1.217-1.42.67 0 1.217.636 1.217 1.42v5.682zM12.5 9.3a1.4 1.4 0 1 1 .001-2.801A1.4 1.4 0 0 1 12.5 9.3z"
        })
    },
    mapMarkerBox: {
        viewBox: "0 0 60 60",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M52.525.987c1.632 0 2.975 1.358 2.975 3.008v38.6c0 1.65-1.343 3.008-2.975 3.008l-15.32-.001-6.65 13.385L23.9 45.602H7.475c-1.632 0-2.975-1.358-2.975-3.008v-38.6C4.5 2.345 5.843.988 7.475.988h45.05Z"
        })
    },
    nav: {
        viewBox: "0 0 25 25",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M4.4 11.313h16.2c.497 0 .9.425.9.95 0 .525-.403.95-.9.95H4.4c-.497 0-.9-.425-.9-.95 0-.525.403-.95.9-.95zm0-5.513h16.2c.497 0 .9.425.9.95 0 .525-.403.95-.9.95H4.4c-.497 0-.9-.425-.9-.95 0-.525.403-.95.9-.95zm0 11.026h16.2c.497 0 .9.425.9.95 0 .524-.403.95-.9.95H4.4c-.497 0-.9-.426-.9-.95 0-.525.403-.95.9-.95z"
        })
    },
    phone: {
        viewBox: "0 0 25 25",
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M15.145 15.809l.875-.9a2.058 2.058 0 0 1 3.1-.042l2.73 2.822a2.394 2.394 0 0 1-.043 3.315 10.4 10.4 0 0 1-1.1 1 5.689 5.689 0 0 1-3.508.979 10.411 10.411 0 0 1-2.242-.484 17.468 17.468 0 0 1-6.94-4.659c-3.873-3.999-5.351-7.054-4.955-10.441A5.889 5.889 0 0 1 3.4 6.008a5.57 5.57 0 0 1 .809-1.44l.767-.84a2.312 2.312 0 0 1 3.33-.04l2.726 2.821a2.242 2.242 0 0 1-.161 3.184l-.924.953a12.44 12.44 0 0 0 2.216 2.944 13.259 13.259 0 0 0 2.982 2.22zm2.066.181l-1.044 1.094a1.459 1.459 0 0 1-1.8.249 12.939 12.939 0 0 1-3.417-2.52 12.884 12.884 0 0 1-2.5-3.55 1.553 1.553 0 0 1 .268-1.753l.517-.545.485-.5a.662.662 0 0 0 .04-.895Q8.738 6.312 8.227 5.785A17.2 17.2 0 0 0 6.838 4.55a.49.49 0 0 0-.708.022 5.063 5.063 0 0 0-1.23 1.46 4.035 4.035 0 0 0-.408 1.9c.143 2.985.864 4.945 4.646 8.855 2.3 2.37 5 4.707 8.506 4.764a3.607 3.607 0 0 0 1.905-.55 8.129 8.129 0 0 0 1.264-1.14.668.668 0 0 0 .04-.9q-.843-1.076-1.314-1.563-.5-.518-1.6-1.452a.5.5 0 0 0-.73.041z"
        })
    },
    starEmpty: {
        viewBox: "0 0 24 24",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "#ffa800",
            d: "M11.4621 2.00133C11.8023 1.83908 12.1977 1.83908 12.538 2.00133C12.8223 2.13689 12.9853 2.37532 13.0782 2.52708C13.1735 2.68276 13.273 2.88441 13.3769 3.09499L15.5766 7.55132C15.5807 7.55965 15.5846 7.56748 15.5882 7.57486C15.5964 7.57605 15.605 7.57731 15.6142 7.57866L20.5346 8.29784C20.7668 8.33176 20.9893 8.36425 21.1667 8.40691C21.3397 8.44851 21.6167 8.53001 21.8332 8.75862C22.0925 9.03226 22.2144 9.40827 22.1651 9.78197C22.1238 10.0942 21.9474 10.3227 21.8317 10.4579C21.7131 10.5965 21.552 10.7534 21.3839 10.9171L17.8248 14.3837C17.8181 14.3902 17.8118 14.3963 17.8059 14.402C17.8073 14.4102 17.8088 14.4188 17.8104 14.428L18.6501 19.3243C18.6899 19.5558 18.7279 19.7775 18.7423 19.9595C18.7564 20.1369 18.7647 20.4256 18.6144 20.7025C18.4344 21.0338 18.1145 21.2662 17.7438 21.3349C17.434 21.3923 17.162 21.2951 16.9976 21.2269C16.829 21.157 16.6299 21.0522 16.422 20.9429L12.0233 18.6296C12.0151 18.6253 12.0073 18.6212 12 18.6174C11.9927 18.6212 11.985 18.6253 11.9768 18.6296L7.57801 20.9429C7.37012 21.0523 7.17107 21.157 7.00242 21.2269C6.83805 21.2951 6.56603 21.3923 6.25627 21.3349C5.88555 21.2662 5.56565 21.0338 5.38569 20.7025C5.23532 20.4256 5.24366 20.1369 5.25771 19.9595C5.27212 19.7775 5.31016 19.5558 5.3499 19.3243L6.18968 14.428C6.19126 14.4188 6.19274 14.4102 6.19413 14.402C6.18822 14.3963 6.18196 14.3902 6.17529 14.3837L2.63727 10.9376C2.63024 10.9308 2.62322 10.924 2.61621 10.9171C2.44804 10.7534 2.28698 10.5966 2.16834 10.4579C2.05267 10.3227 1.87622 10.0942 1.83499 9.78197C1.78564 9.40827 1.90756 9.03226 2.1668 8.75862C2.38338 8.53001 2.66036 8.44851 2.83334 8.40691C3.01078 8.36425 3.23321 8.33176 3.46548 8.29784C3.47516 8.29643 3.48486 8.29501 3.49458 8.29359L8.38585 7.57866C8.39505 7.57731 8.40368 7.57605 8.41182 7.57486C8.41547 7.56748 8.41933 7.55965 8.42345 7.55132L10.6231 3.09499C10.727 2.88441 10.8266 2.68276 10.9219 2.52708C11.0148 2.37532 11.1777 2.13689 11.4621 2.00133ZM12 3.69458C11.9859 3.72307 11.971 3.75326 11.9552 3.78528L9.76851 8.21525C9.7641 8.22419 9.75937 8.23391 9.75431 8.24432C9.70452 8.34669 9.62243 8.51545 9.49364 8.65407C9.38358 8.77253 9.25159 8.86851 9.10497 8.93669C8.9334 9.01647 8.74755 9.04253 8.63482 9.05834C8.62335 9.05995 8.61265 9.06145 8.60279 9.06289L3.71152 9.77782C3.6762 9.78298 3.6429 9.78786 3.61145 9.7925C3.63419 9.81471 3.6583 9.83821 3.68386 9.86311L7.22189 13.3091C7.22904 13.3161 7.23684 13.3236 7.24519 13.3317C7.32732 13.4107 7.46271 13.5411 7.55489 13.7066C7.63365 13.8481 7.68418 14.0035 7.70367 14.1642C7.72648 14.3523 7.69363 14.5374 7.6737 14.6496C7.67168 14.661 7.66979 14.6717 7.6681 14.6815L6.83329 19.5489C6.82725 19.5841 6.82157 19.6173 6.81623 19.6487C6.8444 19.6339 6.87423 19.6182 6.90584 19.6016L11.2786 17.302C11.2874 17.2974 11.297 17.2923 11.3072 17.2868C11.4078 17.2332 11.5736 17.1448 11.7595 17.1083C11.9183 17.0771 12.0817 17.0771 12.2406 17.1083C12.4265 17.1448 12.5923 17.2332 12.6929 17.2868C12.7031 17.2923 12.7126 17.2974 12.7215 17.302L17.0942 19.6016C17.1258 19.6182 17.1556 19.6339 17.1838 19.6487C17.1785 19.6173 17.1728 19.5841 17.1668 19.5489L16.3319 14.6815C16.3303 14.6717 16.3284 14.661 16.3263 14.6496C16.3064 14.5374 16.2736 14.3523 16.2964 14.1642C16.3159 14.0035 16.3664 13.8481 16.4452 13.7066C16.5373 13.5411 16.6727 13.4107 16.7549 13.3317C16.7632 13.3236 16.771 13.3161 16.7782 13.3091L20.3162 9.86311C20.3417 9.83821 20.3659 9.81471 20.3886 9.7925C20.3571 9.78786 20.3238 9.78298 20.2885 9.77782L15.3973 9.06289C15.3874 9.06145 15.3767 9.05995 15.3652 9.05834C15.2525 9.04253 15.0666 9.01647 14.8951 8.93669C14.7485 8.86851 14.6165 8.77253 14.5064 8.65407C14.3776 8.51545 14.2955 8.34669 14.2457 8.24432C14.2407 8.23391 14.2359 8.22419 14.2315 8.21525L12.0449 3.78528C12.0291 3.75326 12.0141 3.72307 12 3.69458Z"
        })
    },
    starFull: {
        viewBox: "0 0 24 24",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "#ffa800",
            d: "M11.4621 2.00133C11.8023 1.83908 12.1977 1.83908 12.538 2.00133C12.8223 2.13689 12.9853 2.37532 13.0782 2.52708C13.1735 2.68276 13.273 2.88441 13.3769 3.09499L15.5766 7.55132L15.5882 7.57486L15.6142 7.57866L20.5346 8.29784L20.5346 8.29784C20.7668 8.33176 20.9893 8.36425 21.1667 8.40691C21.3397 8.44851 21.6167 8.53001 21.8332 8.75862C22.0925 9.03226 22.2144 9.40827 22.1651 9.78197C22.1238 10.0942 21.9474 10.3227 21.8317 10.4579C21.7131 10.5965 21.552 10.7534 21.3839 10.9171L17.8248 14.3837L17.8059 14.402L17.8104 14.428L18.6501 19.3243C18.6899 19.5558 18.7279 19.7775 18.7423 19.9595C18.7564 20.1369 18.7647 20.4256 18.6144 20.7025C18.4344 21.0338 18.1145 21.2662 17.7438 21.3349C17.434 21.3923 17.162 21.2951 16.9976 21.2269C16.829 21.157 16.6299 21.0523 16.4221 20.9429L16.422 20.9429L12.0233 18.6296L12 18.6174L11.9768 18.6296L7.57801 20.9429L7.57797 20.9429C7.37009 21.0523 7.17105 21.157 7.00242 21.2269C6.83805 21.2951 6.56603 21.3923 6.25627 21.3349C5.88555 21.2662 5.56565 21.0338 5.38569 20.7025C5.23532 20.4256 5.24366 20.1369 5.25771 19.9595C5.27212 19.7775 5.31016 19.5558 5.3499 19.3243L6.18968 14.428L6.19413 14.402L6.17529 14.3837L2.63727 10.9376L2.61621 10.9171L2.61618 10.9171C2.44802 10.7534 2.28697 10.5965 2.16834 10.4579C2.05267 10.3227 1.87622 10.0942 1.83499 9.78197C1.78564 9.40827 1.90756 9.03226 2.1668 8.75862C2.38338 8.53001 2.66036 8.44851 2.83334 8.40691C3.01078 8.36425 3.23321 8.33176 3.46548 8.29784L3.49458 8.29359L8.38585 7.57866L8.41182 7.57486L8.42345 7.55132L10.6231 3.09499L10.6231 3.09497C10.7271 2.8844 10.8266 2.68276 10.9219 2.52708C11.0148 2.37532 11.1777 2.13689 11.4621 2.00133Z"
        })
    },
    starHalf: {
        viewBox: "0 0 24 24",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "#ffa800",
            fillRule: "evenodd",
            d: "M12.5336 2.00169C12.1933 1.83944 11.798 1.83944 11.4577 2.00169C11.1733 2.13725 11.0104 2.37569 10.9175 2.52744C10.8222 2.68312 10.7227 2.88477 10.6187 3.09534L10.6187 3.09535L10.6057 3.12171L8.41905 7.55168L8.40743 7.57522L8.38145 7.57903L3.49018 8.29396L3.46109 8.29821C3.22882 8.33213 3.00639 8.36461 2.82895 8.40728C2.65596 8.44888 2.37899 8.53038 2.1624 8.75899C1.90316 9.03263 1.78124 9.40864 1.83059 9.78233C1.87182 10.0945 2.04828 10.3231 2.16394 10.4582C2.28258 10.5969 2.44361 10.7537 2.61177 10.9175L2.61182 10.9175L2.63287 10.938L6.1709 14.3841L6.18973 14.4024L6.18529 14.4283L5.35048 19.2957L5.3455 19.3247C5.30577 19.5562 5.26772 19.7779 5.25331 19.9599C5.23927 20.1373 5.23093 20.426 5.38129 20.7028C5.56126 21.0342 5.88115 21.2666 6.25188 21.3353C6.56164 21.3927 6.83366 21.2955 6.99803 21.2273C7.16666 21.1573 7.3657 21.0526 7.57357 20.9433L7.57362 20.9433L7.59962 20.9296L11.9724 18.63L11.9956 18.6178L12.0189 18.63L16.3916 20.9296L16.4176 20.9432L16.4177 20.9433C16.6256 21.0526 16.8246 21.1573 16.9932 21.2273C17.1576 21.2955 17.4296 21.3927 17.7394 21.3353C18.1101 21.2666 18.43 21.0342 18.61 20.7028C18.7603 20.426 18.752 20.1373 18.7379 19.9599C18.7235 19.7779 18.6855 19.5562 18.6458 19.3247L18.6408 19.2957L17.806 14.4283L17.8015 14.4024L17.8204 14.3841L21.3584 10.938L21.3795 10.9175C21.5476 10.7537 21.7087 10.5969 21.8273 10.4582C21.943 10.3231 22.1194 10.0945 22.1607 9.78233C22.21 9.40864 22.0881 9.03262 21.8289 8.75899C21.6123 8.53038 21.3353 8.44888 21.1623 8.40728C20.9849 8.36461 20.7625 8.33213 20.5302 8.29821L20.5302 8.29821L20.5011 8.29396L15.6098 7.57903L15.5838 7.57522L15.5722 7.55168L13.3855 3.12171L13.3725 3.09535C13.2686 2.88478 13.1691 2.68313 13.0738 2.52744C12.9809 2.37569 12.8179 2.13725 12.5336 2.00169ZM12 17.0853C12.0791 17.0856 12.1582 17.0934 12.2362 17.1087C12.4221 17.1451 12.5879 17.2336 12.6885 17.2872L12.7171 17.3024L17.0898 19.602L17.1794 19.649L17.1624 19.5493L16.3276 14.6819L16.3219 14.65L16.3219 14.65C16.302 14.5377 16.2692 14.3527 16.292 14.1646C16.3115 14.0039 16.362 13.8484 16.4408 13.707C16.5329 13.5414 16.6683 13.4111 16.7505 13.332L16.7738 13.3095L20.3118 9.86348L20.3842 9.79287L20.2841 9.77819L15.3929 9.06325L15.3608 9.0587L15.3608 9.0587C15.2481 9.0429 15.0622 9.01683 14.8907 8.93705C14.7441 8.86887 14.6121 8.77289 14.502 8.65444C14.3732 8.51582 14.2911 8.34705 14.2413 8.24469L14.2271 8.21562L12.0405 3.78565L12 3.7038V17.0853Z"
        })
    },
    warning: {
        viewBox: "0 0 25 25",
        // prettier-ignore
        svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M23.715 19.33c.4.708.377 1.57-.06 2.254a2.337 2.337 0 0 1-1.976 1.067H3.319c-.8 0-1.55-.4-1.976-1.067a2.184 2.184 0 0 1-.056-2.258l9.2-16.164A2.332 2.332 0 0 1 12.523 2c.842 0 1.624.443 2.033 1.165l9.16 16.165zm-10.9-15.18c-.05-.086-.162-.15-.293-.15-.134 0-.246.063-.296.151l-9.2 16.162a.183.183 0 0 0 .003.196.345.345 0 0 0 .29.142h18.36a.34.34 0 0 0 .29-.142.18.18 0 0 0 .006-.194l-9.16-16.164zM12.5 19.3a1.15 1.15 0 1 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm1-4.467c0 .646-.449 1.167-1 1.167-.552 0-1-.522-1-1.167v-4.666c0-.644.448-1.167 1-1.167.551 0 1 .523 1 1.167v4.666z"
        })
    }
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/SvgIcon.tsx






var SvgIcon = function SvgIcon(_param) {
    var name = _param.name, _size = _param.size, size = _size === void 0 ? "small" : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "size"
    ]);
    var iconDefinition = svgIconDefinitions_iconDefinitions[name];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSvg, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: iconDefinition === null || iconDefinition === void 0 ? void 0 : iconDefinition.viewBox,
        role: "img",
        size: size
    }, props), {
        children: iconDefinition === null || iconDefinition === void 0 ? void 0 : iconDefinition.svg
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Icon/index.ts



// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ImageSVG/assets/bm.tsx
var bm = __webpack_require__(6646);
// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ImageSVG/assets/cg.tsx
var cg = __webpack_require__(670);
// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ImageSVG/assets/floyt.tsx
var floyt = __webpack_require__(5356);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ImageSVG/ImageSVG.tsx




// These logos should never be lazy-loaded
var LogoMapping = {
    bm: bm["default"],
    cg: cg["default"],
    floyt: floyt["default"]
};
var providers = (/* unused pure expression or super */ null && ([
    "bmInverted",
    "cgInverted",
    "topdeal",
    "trustpilot",
    "alamo",
    "avis",
    "budget",
    "enterprise",
    "europcar",
    "hertz",
    "rentalcars", 
]));
var ImageSVG = function ImageSVG(param) {
    var name = param.name, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var ImageComponent = LogoMapping[name] || react.Fragment;
    if (loading === "eager") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageComponent, {});
    }
    var DynamicImageComponent = dynamic_default()(function() {
        return __webpack_require__(634)("./".concat(name)).catch(function(_err) {
            return null;
        });
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicImageComponent, {});
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ImageSVG/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Button/Button.styles.ts



var StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e1kp21ke0"
}, "target", "e1kp21ke0"))("position:relative;margin:1.25rem 0 0.625rem;padding:0.9375rem 1.375rem;border:0;background-color:", Theme.Color.primary, ";color:", Theme.Color.natural0, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;width:100%;cursor:pointer;&:hover{background-color:", Theme.Color.primary70, ";}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Button/Button.tsx






var Button = function Button(_param) /*#__PURE__*/ {
    var children = _param.children, loading = _param.loading, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "loading"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledButton, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: [
            loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivityIndicator, {}),
            children
        ]
    }));
};
var LinkButtonStyle = StyledButton.withComponent("a");
var LinkButton = function LinkButton(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkButtonStyle, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: children
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Button/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Checkbox/Checkbox.styles.ts



var StyledLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,src_define_property/* default */.Z)({
    target: "eri46a40"
}, "target", "eri46a40"))("display:inline-flex;column-gap:0.5rem;cursor:pointer;user-select:none;");
// screen reader only
var StyledCheckbox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("input", (0,src_define_property/* default */.Z)({
    target: "eri46a41"
}, "target", "eri46a41"))("position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;");
var CheckboxWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "eri46a42"
}, "target", "eri46a42"))("display:inline-flex;align-items:center;justify-content:center;background-color:", Theme.Color.natural0, ";border:1px solid\n    ", function(props) {
    return props.isChecked ? Theme.Color.primary : Theme.Color.natural50;
}, ";width:1.25rem;height:1.25rem;padding:0.1875rem;outline:0;svg{fill:", function(props) {
    return props.isChecked ? Theme.Color.primary : "inherit";
}, ";}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Checkbox/Checkbox.tsx







var Checkbox = function Checkbox(_param) {
    var label = _param.label, _checked = _param.checked, checked = _checked === void 0 ? false : _checked, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "checked",
        "onChange"
    ]);
    var ref = (0,react.useState)(checked), isChecked = ref[0], setIsChecked = ref[1];
    (0,react.useEffect)(function() {
        setIsChecked(checked);
    }, [
        checked
    ]);
    var handleChange = function handleChange(event) {
        setIsChecked(event.target.checked);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLabel, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCheckbox, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                type: "checkbox",
                onChange: handleChange
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxWrapper, {
                isChecked: isChecked,
                children: isChecked && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon, {
                    name: "check"
                })
            }),
            label
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Checkbox/index.ts


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(2174);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMonths.mjs
var addMonths = __webpack_require__(7617);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 6 modules
var format = __webpack_require__(6569);
// EXTERNAL MODULE: ../../node_modules/date-fns/setMinutes.mjs
var setMinutes = __webpack_require__(5465);
// EXTERNAL MODULE: ../../node_modules/date-fns/setHours.mjs
var setHours = __webpack_require__(6930);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/de.mjs + 5 modules
var de = __webpack_require__(1466);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/fr.mjs + 5 modules
var fr = __webpack_require__(3005);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/es.mjs + 5 modules
var es = __webpack_require__(596);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/it.mjs + 6 modules
var it = __webpack_require__(5455);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/nl.mjs + 5 modules
var nl = __webpack_require__(5460);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/en-US.mjs + 5 modules
var en_US = __webpack_require__(6198);
// EXTERNAL MODULE: ../../frontend/shared/src/strings/index.ts + 5 modules
var strings = __webpack_require__(7263);
// EXTERNAL MODULE: ../../frontend/shared/src/Ui/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(3181);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Calendar.js
var Calendar = __webpack_require__(5241);
var Calendar_default = /*#__PURE__*/__webpack_require__.n(Calendar);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/DatePickerButton.styles.ts


var ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eanu830"
}, "target", "eanu830"))("position:relative;cursor:pointer;");
var DatePickerButton_styles_StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "eanu831"
}, "target", "eanu831"))("display:inline-block;margin:0;padding:0.625rem 1rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";width:100%;height:", function(param) {
    var size = param.size;
    return size === "small" ? "2.5rem" : "3.125rem";
}, ";font-size:", function(param) {
    var size = param.size;
    return size === "small" ? "0.75rem" : "1rem";
}, ";line-height:", function(param) {
    var size = param.size;
    return size === "small" ? 1 : 1.5;
}, ";text-transform:capitalize;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";cursor:pointer;&:hover,&:focus{border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";}& + svg{position:absolute;right:1rem;top:", function(param) {
    var size = param.size;
    return size === "small" ? "0.5rem" : "0.75rem";
}, ";width:1.6rem;height:1.6rem;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";align-items:center;display:inline-flex;cursor:pointer;pointer-events:none;}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/useFormattedDate.ts










var useFormattedDate = function useFormattedDate(date) {
    var language = useLocale().language;
    var dateLocale = {
        de: de.de,
        fr: fr.fr,
        es: es.es,
        it: it.it,
        nl: nl.nl,
        en: en_US/* enUS */._
    }[language];
    var localDateFormats = strings.dateFormats[language];
    var ref = (0,react.useState)(""), formattedDate = ref[0], setFormattedDate = ref[1];
    (0,react.useEffect)(function() {
        if (date) {
            var localDate = (0,format/* format */.WU)(date, localDateFormats.dayDateLongYear, {
                locale: dateLocale
            });
            setFormattedDate(localDate);
        }
    }, [
        date,
        dateLocale,
        localDateFormats.dayDateLongYear
    ]);
    return formattedDate;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/DatePickerButton.tsx




var DatePickerButton = function DatePickerButton(param) {
    var title = param.title, from = param.from, to = param.to, size = param.size, onClick = param.onClick;
    var fromDate = useFormattedDate(from);
    var toDate = useFormattedDate(to);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePickerButton_styles_StyledButton, {
                type: "button",
                id: "datepicker",
                "aria-haspopup": "true",
                title: title,
                size: size,
                onClick: onClick,
                children: fromDate && toDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    id: "datepickerValue",
                    children: "".concat(fromDate, " - ").concat(toDate)
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((Calendar_default()), {
                id: "datepicker-cal-icon"
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js + 1 modules
var emotion_element_43c6fea0_browser_esm = __webpack_require__(7216);
// EXTERNAL MODULE: ../../node_modules/react-day-picker/dist/index.esm.js + 20 modules
var index_esm = __webpack_require__(3412);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(1502);
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(1461);
// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/Close.js
var Close = __webpack_require__(2530);
var Close_default = /*#__PURE__*/__webpack_require__.n(Close);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(6182);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/CustomMonths.tsx




var CustomMonthsContext = /*#__PURE__*/ (0,react.createContext)({
    onScrollToBottom: undefined,
    vertical: false
});
var CustomMonths = function CustomMonths(param) {
    var children = param.children;
    var bottomRef = (0,react.useRef)(null);
    var ref = (0,react.useContext)(CustomMonthsContext), onScrollToBottom = ref.onScrollToBottom, vertical = ref.vertical;
    var intersection = (0,useIntersection/* default */.Z)(bottomRef, {
        root: null,
        threshold: 0.5
    });
    (0,react.useEffect)(function() {
        // Only call the callback after rendering has finished
        if ((intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting) && vertical) {
            onScrollToBottom === null || onScrollToBottom === void 0 ? void 0 : onScrollToBottom();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting,
        vertical
    ]);
    var ref1 = (0,index_esm/* useDayPicker */.kD)(), classNames = ref1.classNames, styles = ref1.styles;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: classNames.months,
        style: styles.months,
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                ref: bottomRef
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowNext.js
var ArrowNext = __webpack_require__(5403);
var ArrowNext_default = /*#__PURE__*/__webpack_require__.n(ArrowNext);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/DatePicker.styles.ts





/**
 * These global styles are required by
 * [`react-day-picker`](https://react-day-picker.js.org/).
 * They are applied to the date picker on both search forms for
 * BM and CG, but also to the widgets under `/widget_search`.
 *
 * @TODO: Consolidate these global styles with the FLOYT date picker
 * styles and move them to the `entities` layer as this is too
 * sophisticated for the `shared` layer.
 */ var GlobalStyles = function GlobalStyles(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("/* stylelint-disable selector-class-pattern */\n  .rdp{position:relative;outline:0;background-color:", theme === null || theme === void 0 ? void 0 : theme.color.natural0, ";color:", theme === null || theme === void 0 ? void 0 : theme.color.secondary100, ";user-select:none;}.rdp-button_reset{margin:0;padding:0;border:0;font:inherit;background:none;appearance:none;}.rdp-months{display:flex;flex-wrap:wrap;justify-content:center;}.rdp-month{margin:1.5rem auto 0;}.rdp-nav_button{position:absolute;top:1.125rem;width:36px;height:36px;outline:0;color:inherit;-webkit-tap-highlight-color:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;&:disabled{color:#dce0e0;cursor:not-allowed;}}.rdp-nav_button.rdp-nav_button_previous{left:0.75rem;}.rdp-nav_button.rdp-nav_button_next{right:0.75rem;}.rdp-caption_label{margin:0.25rem 0;font-size:1.125rem;font-weight:600;text-align:center;text-transform:capitalize;}.rdp-table{border-spacing:0;border-collapse:collapse;}.rdp-head_cell{display:table-cell;padding:8px 0;color:#b6bfc1;font-size:0.938rem;font-weight:600;text-align:center;}.rdp-cell{padding:8px 0 0;}.rdp-day{outline:0;width:32px;height:32px;font-size:1.125rem;text-align:center;vertical-align:middle;cursor:pointer;color:", theme === null || theme === void 0 ? void 0 : theme.color.secondary100, ";}.rdp-day.rdp-day_outside{color:#6ec2b7;cursor:default;}.rdp-day.rdp-day_disabled{color:#dce0e0;cursor:default;}/* selected pick-up/drop-off dates */\n  .rdp-day.rdp-day_selected:not(.rdp-day_disabled,.rdp-day_outside){position:relative;color:", theme === null || theme === void 0 ? void 0 : theme.color.natural0, ";}.rdp-day.rdp-day_range_start.rdp-day_selected:not(\n      .rdp-day_disabled,.rdp-day_outside\n    ){background-image:radial-gradient(\n        circle at center,", theme === null || theme === void 0 ? void 0 : theme.color.primary, ",", theme === null || theme === void 0 ? void 0 : theme.color.primary, " 60%,transparent 65%\n      ),linear-gradient(to right,transparent,transparent 49%,#c5e7e2 50%);}.rdp-day.rdp-day_range_end.rdp-day_selected:not(\n      .rdp-day_disabled,.rdp-day_outside\n    ){background-image:radial-gradient(\n        circle at center,", theme === null || theme === void 0 ? void 0 : theme.color.primary, ",", theme === null || theme === void 0 ? void 0 : theme.color.primary, " 60%,transparent 65%\n      ),linear-gradient(to left,transparent,transparent 49%,#c5e7e2 50%);}.rdp-day.rdp-day_range_start.rdp-day_range_end.rdp-day_selected:not(\n      .rdp-day_disabled,.rdp-day_outside\n    ){background-image:radial-gradient(\n      circle at center,", theme === null || theme === void 0 ? void 0 : theme.color.primary, ",", theme === null || theme === void 0 ? void 0 : theme.color.primary, " 62%,transparent 63%\n    );}/* range between pick-up and drop-off */\n  .rdp-day.rdp-day_selected:not(\n      .rdp-day_range_start,.rdp-day_range_end,.rdp-day_outside\n    ){color:", theme === null || theme === void 0 ? void 0 : theme.color.secondary100, ";background-color:#c5e7e2;}/* today but not selected */\n  .rdp-day.rdp-day_today:not(.rdp-day_selected){margin:0;width:32px;border:1px solid ", theme === null || theme === void 0 ? void 0 : theme.color.natural40, ";border-radius:100%;}.rdp-vhidden{position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);}@media screen and (min-width:300px){.rdp-day{width:40px;}.rdp-day.rdp-day_today:not(.rdp-day_selected){margin-left:4px;margin-right:4px;}.rdp-month{margin-left:1rem;margin-right:1rem;}}/* large widgets only */\n  @media screen and ((width:800px) or (width:970px)) and (height:250px){.rdp-month{margin-top:0.125rem;}.rdp-nav_button{top:-0.125rem;}.rdp-head_cell{padding-top:4px;padding-bottom:4px;}.rdp-cell{padding-top:4px;}}@media screen and (min-width:1280px){.rdp-months{justify-content:space-around;}}/* stylelint-enable selector-class-pattern */");
};
var DayPickerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "efspag90"
}, "target", "efspag90"))("@media screen and (max-width:36rem){position:fixed;left:0;right:0;top:0;bottom:0;width:100vw;display:flex;flex-direction:column;justify-content:space-between;.rdp{position:fixed;top:55px;width:100%;height:calc(100% - 55px - 80px);overflow-y:scroll;background:linear-gradient(\n          ", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " 30%,rgb(255 255 255 / 0%)\n        ),linear-gradient(\n            rgb(255 255 255 / 0%),", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " 70%\n          )\n          0 100%,radial-gradient(farthest-side at 50% 0,rgb(0 0 0 / 20%),transparent),radial-gradient(\n            farthest-side at 50% 100%,rgb(0 0 0 / 20%),transparent\n          )\n          0 100%;background-attachment:local,local,scroll,scroll;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";background-repeat:no-repeat;background-size:100% 40px,100% 40px,100% 14px,100% 14px;@media screen and (max-height:320px){position:static;top:0;height:100%;}}}/* large widgets */\n  @media screen and ((width:800px) or (width:970px)) and (height:250px){.rdp{position:fixed;top:0.25rem;right:calc(300px + 0.875rem);bottom:0.25rem;overflow:hidden;}}");
var DayPickerHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "efspag91"
}, "target", "efspag91"))("display:none;@media screen and (max-width:36rem){display:flex;height:55px;padding:0 1rem;align-items:center;justify-content:space-between;border-bottom:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";box-shadow:0 0 3px rgb(0 0 0 / 30%);background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}@media screen and (max-height:320px){display:none;}");
var DayPickerFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "efspag92"
}, "target", "efspag92"))("display:none;padding:1rem;border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";width:100%;height:80px;overflow:hidden;background:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";@media screen and (max-width:36rem){display:flex;}@media screen and (max-height:320px){padding-top:0.5rem;padding-bottom:0.5rem;height:49px;}");
var Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowNext_default()), (0,src_define_property/* default */.Z)({
    target: "efspag93"
}, "target", "efspag93"))("width:1rem;height:1rem;fill:currentcolor;");
var DatePicker_styles_StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Button */.zx, (0,src_define_property/* default */.Z)({
    target: "efspag94"
}, "target", "efspag94"))("@media screen and (max-height:320px){padding-top:0.25rem;padding-bottom:0.25rem;}");


// EXTERNAL MODULE: ../../frontend/shared/src/Ui/index.ts + 124 modules
var Ui = __webpack_require__(2145);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/DatePicker.tsx














var DatePicker = function DatePicker(_param) {
    var from = _param.from, to = _param.to, dayCountText = _param.dayCountText, _scrollToSelectedMonth = _param.scrollToSelectedMonth, scrollToSelectedMonth = _scrollToSelectedMonth === void 0 ? false : _scrollToSelectedMonth, onDatesChange = _param.onDatesChange, onClose = _param.onClose, locale = _param.locale, dateFormat = _param.dateFormat, size = _param.size, onScrollToBottom = _param.onScrollToBottom, vertical = _param.vertical, props = (0,_object_without_properties/* default */.Z)(_param, [
        "from",
        "to",
        "dayCountText",
        "scrollToSelectedMonth",
        "onDatesChange",
        "onClose",
        "locale",
        "dateFormat",
        "size",
        "onScrollToBottom",
        "vertical"
    ]);
    var theme = (0,emotion_element_43c6fea0_browser_esm.u)();
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if (!scrollToSelectedMonth) {
            return;
        }
        var selectedDay = document.querySelector(".rdp-day_selected");
        var selectedMonthElm = selectedDay === null || selectedDay === void 0 ? void 0 : (ref = selectedDay.parentElement) === null || ref === void 0 ? void 0 : (ref1 = ref.parentElement) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.parentElement) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.parentElement) === null || ref3 === void 0 ? void 0 : ref3.parentElement;
        if (selectedMonthElm) {
            selectedMonthElm.scrollIntoView();
        }
    }, [
        scrollToSelectedMonth
    ]);
    var ref = (0,react.useState)(from || null), selectedFrom = ref[0], setFrom = ref[1];
    var ref1 = (0,react.useState)(to || null), selectedTo = ref1[0], setTo = ref1[1];
    var ref2 = (0,react.useState)(undefined), hoveredTo = ref2[0], setHoveredTo = ref2[1];
    var isSelectingFirstDay = function isSelectingFirstDay(date) {
        var isBeforeFirstDay = selectedFrom && (0,isBefore/* isBefore */.R)(date, selectedFrom);
        var isRangeSelected = selectedFrom && selectedTo;
        return !selectedFrom || isBeforeFirstDay || isRangeSelected;
    };
    var handleOnDayClick = function handleOnDayClick(date, modifiers) {
        if (modifiers.disabled) {
            return;
        }
        if (isSelectingFirstDay(date)) {
            setFrom(date);
            setTo(null);
            setHoveredTo(undefined);
        } else {
            setTo(date);
            setHoveredTo(date);
            if (typeof onDatesChange !== "undefined") {
                onDatesChange({
                    from: selectedFrom,
                    to: date
                });
            }
        }
    };
    var getHighlightedDays = function getHighlightedDays() {
        var highlightRules = [
            function(day) {
                if (selectedFrom && selectedTo) {
                    return (0,isAfter/* isAfter */.A)(day, selectedFrom) && (0,isBefore/* isBefore */.R)(day, selectedTo);
                }
                return false;
            }, 
        ];
        if (selectedFrom) {
            highlightRules.push(selectedFrom);
        }
        if (selectedFrom && hoveredTo) {
            highlightRules.push({
                from: selectedFrom,
                to: hoveredTo
            });
        }
        if (selectedFrom && selectedTo) {
            highlightRules.push({
                from: selectedFrom,
                to: selectedTo
            });
        }
        return highlightRules;
    };
    var getModifiers = function getModifiers() {
        var modifiers = {};
        if (selectedFrom) {
            modifiers = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, modifiers), {
                from: [
                    selectedFrom
                ]
            });
        }
        if (hoveredTo) {
            modifiers = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, modifiers), {
                to: hoveredTo
            });
        } else if (selectedTo) {
            modifiers = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, modifiers), {
                to: selectedTo
            });
        }
        return modifiers;
    };
    var handleDayMouseEnter = function handleDayMouseEnter(day) {
        if (from && (0,isBefore/* isBefore */.R)(day, from) || isSelectingFirstDay(day)) {
            return;
        }
        setHoveredTo(day);
    };
    var context = (0,react.useMemo)(function() {
        return {
            onScrollToBottom: onScrollToBottom,
            vertical: vertical
        };
    }, [
        onScrollToBottom,
        vertical
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomMonthsContext.Provider, {
        value: context,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
                styles: [
                    GlobalStyles({
                        theme: theme
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DayPickerWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DayPickerHeader, {
                        children: [
                            from ? (0,format/* format */.WU)(from, dateFormat, {
                                locale: locale
                            }) : "---",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {}),
                            to ? (0,format/* format */.WU)(to, dateFormat, {
                                locale: locale
                            }) : "---",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ui/* IconButton */.hU, {
                                icon: (Close_default()),
                                title: "close" // @TODO: Add translation
                                ,
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* DayPicker */._W, (0,src_object_spread/* default */.Z)({
                        components: {
                            Months: CustomMonths
                        },
                        onDayClick: handleOnDayClick,
                        onDayMouseEnter: handleDayMouseEnter,
                        selected: getHighlightedDays(),
                        modifiers: getModifiers(),
                        disabled: {
                            before: new Date()
                        },
                        locale: locale,
                        modifiersClassNames: {
                            outside: "rdp-day_outside",
                            disabled: "rdp-day_disabled",
                            today: "rdp-day_today",
                            from: "rdp-day_range_start",
                            to: "rdp-day_range_end"
                        }
                    }, props)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DayPickerFooter, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePicker_styles_StyledButton, {
                            size: size,
                            fullWidth: true,
                            onClick: onClose,
                            children: dayCountText
                        })
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DatePicker/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/TimePicker/TimePicker.tsx


var generateTimeRange = function generateTimeRange() {
    var options = [];
    for(var m = 0; m < 1440; m += 15){
        var time = "".concat(Math.floor(m / 60).toString().padStart(2, "0"), ":").concat((m % 60).toString().padStart(2, "0"));
        options.push({
            label: time,
            value: time
        });
    }
    return options;
};
var TimePicker = function TimePicker(param) {
    var id = param.id, type = param.type, label = param.label, value = param.value, onChange = param.onChange;
    var timeOptions = generateTimeRange();
    var handleChange = function handleChange(event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value, type);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
        id: id,
        label: label,
        value: value,
        options: timeOptions,
        onChange: handleChange,
        style: {
            cursor: "pointer"
        }
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/TimePicker/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DateRangePicker.styles.ts



var Backdrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1wqwqc80"
}, "target", "e1wqwqc80"))("position:fixed;top:0;right:0;bottom:0;left:0;background-color:transparent;user-select:none;");
var TimeRange = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1wqwqc81"
}, "target", "e1wqwqc81"))("display:flex;justify-content:space-between;column-gap:1rem;> *{width:100%;}");
var DatePickerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e1wqwqc82"
}, "target", "e1wqwqc82"))("display:flex;position:absolute;z-index:101;border:1px solid ", Theme.Color.natural50, ";border-radius:0.75rem;flex-direction:column;width:688px;margin-top:-1px;overflow:hidden;");
var StyledSubmitButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,src_define_property/* default */.Z)({
    target: "e1wqwqc83"
}, "target", "e1wqwqc83"))("color:", Theme.Color.secondary100, ";background-color:", Theme.Color.natural0, ";border:0;padding:1rem;text-align:right;");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/DateRangePicker.tsx


















/**
 * @todo: When this component moves layers, these imports shoud be updated
 * to their package aliases (i.e. '@silvertours/front-legacy-shared').
 */ 





var HOUR_IN_MS = 1000 * 60 * 60;
var INITIAL_MONTHS_MOBILE_CALENDAR = 6;
var MAXIMUM_MONTHS_IN_CALENDAR = 24;
var addTimeToDate = function addTimeToDate(date, hours, minutes) {
    return (0,setMinutes/* setMinutes */.H)((0,setHours/* setHours */.B)(date, hours), minutes);
};
/** @todo: Move to /entities layer - this is too sophisticated for /shared */ var DateRangePicker = function DateRangePicker(param) {
    var from = param.from, to = param.to, _open = param.open, open = _open === void 0 ? false : _open, _vertical = param.vertical, vertical = _vertical === void 0 ? false : _vertical, size = param.size, error = param.error, onDatesChange = param.onDatesChange;
    /**
   * @todo:
   * The translation key should be aligned with the current layer/slice (i.e.
   * 'entities.dateLegacy.dateRangePicker' - once the component has been moved
   * to the /entities layer)
   * */ var t = (0,next_intl_cjs_production_min.useTranslations)("features.stageLegacy.stage.searchForm");
    var language = useLocale().language;
    var dateLocale = {
        de: de.de,
        fr: fr.fr,
        es: es.es,
        it: it.it,
        nl: nl.nl,
        en: en_US/* enUS */._
    }[language];
    var ref = (0,react.useState)(open), isCalendarVisible = ref[0], setCalendarVisibility = ref[1];
    var ref1 = (0,react.useState)({
        from: from,
        to: to
    }), selectedDates = ref1[0], setSelectedDates = ref1[1];
    var isMobileTouchDevice = src/* Theme.useIsMobileTouchDevice */.Q2.useIsMobileTouchDevice();
    (0,react.useEffect)(function() {
        setSelectedDates({
            from: from,
            to: to
        });
    }, [
        from,
        to
    ]);
    var localDateFormats = strings.dateFormats[language];
    var handleBackdropClick = function handleBackdropClick(event) {
        event.stopPropagation();
        setCalendarVisibility(false);
    };
    var handleOnDatesChange = function handleOnDatesChange(dateRange) {
        var newDateRange = {
            from: new Date(),
            to: new Date()
        };
        if (dateRange.from && dateRange.to && selectedDates.from && selectedDates.to) {
            newDateRange = {
                from: addTimeToDate(dateRange.from, selectedDates.from.getHours(), selectedDates.from.getMinutes()),
                to: addTimeToDate(dateRange.to, selectedDates.to.getHours(), selectedDates.to.getMinutes())
            };
            if ((0,format/* format */.WU)(dateRange.from, strings.isoDateTime).split("T")[0] === (0,format/* format */.WU)(dateRange.to, strings.isoDateTime).split("T")[0]) {
                newDateRange = {
                    from: addTimeToDate(dateRange.from, 10, 0),
                    to: addTimeToDate(dateRange.to, 17, 0)
                };
            }
            if (typeof onDatesChange !== "undefined") {
                onDatesChange(newDateRange);
            }
            setSelectedDates(newDateRange);
            // keep datepicker on mobile visible after date selection
            setCalendarVisibility(isMobileTouchDevice);
        }
    };
    var handleOnTimeChange = function handleOnTimeChange(time, type) {
        var ref = (0,_sliced_to_array/* default */.Z)(time.split(":"), 2), hours = ref[0], minutes = ref[1];
        if (selectedDates[type]) {
            var dateWithTime = addTimeToDate(selectedDates[type], Number(hours), Number(minutes));
            var newDateRange = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, selectedDates), (0,src_define_property/* default */.Z)({}, type, dateWithTime));
            if (typeof onDatesChange !== "undefined") {
                onDatesChange(newDateRange);
            }
            setSelectedDates(newDateRange);
        }
    };
    var getDays = function getDays() {
        if (selectedDates.from && selectedDates.to) {
            // Inspired by https://youmightnotneed.com/date-fns#differenceInDays,
            // because differenceInHours() from date-fns always rounds which is not what we want
            var days = (selectedDates.to - selectedDates.from) / HOUR_IN_MS / 24;
            return Number.isInteger(days) ? days : Math.ceil(days);
        }
        return 1;
    };
    var getDefaultMonth = function getDefaultMonth() {
        if (vertical || !selectedDates.from) {
            return undefined;
        }
        return selectedDates.from;
    };
    var getInitialNumberOfMonths = function getInitialNumberOfMonths() {
        if (vertical) {
            return INITIAL_MONTHS_MOBILE_CALENDAR;
        }
        return size === "small" ? 1 : 2;
    };
    var ref2 = (0,react.useState)(getInitialNumberOfMonths()), numberOfMonths = ref2[0], setNumberOfMonths = ref2[1];
    var addMoreMonths = (0,react.useCallback)(function() {
        setNumberOfMonths(Math.min(numberOfMonths + 4, MAXIMUM_MONTHS_IN_CALENDAR));
    }, [
        numberOfMonths
    ]);
    (0,react.useEffect)(function() {
        // Reset months on viewport change
        setNumberOfMonths(getInitialNumberOfMonths());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        vertical,
        size
    ]);
    var now = new Date();
    var calendarRange = {
        start: now,
        end: (0,addMonths/* addMonths */.z)(now, MAXIMUM_MONTHS_IN_CALENDAR)
    };
    var dayCountText = t("dayCount", {
        days: getDays()
    });
    var handleButtonClick = (0,react.useCallback)(function() {
        setCalendarVisibility(!isCalendarVisible);
    }, [
        isCalendarVisible
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isCalendarVisible && // OnKeyDown is necessary for accessibility reasons
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Backdrop, {
                onClick: handleBackdropClick
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePickerButton, {
                title: t("datePicker"),
                from: from,
                to: to,
                size: size,
                onClick: handleButtonClick
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorMessage/* ErrorMessage */.B, {
                children: error
            }),
            isCalendarVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DatePickerWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePicker, {
                        onDatesChange: handleOnDatesChange,
                        onClose: function onClose() {
                            setCalendarVisibility(false);
                        },
                        dayCountText: dayCountText,
                        disabled: {
                            before: new Date()
                        },
                        numberOfMonths: numberOfMonths,
                        fromMonth: calendarRange.start,
                        toMonth: calendarRange.end,
                        from: selectedDates.from ? selectedDates.from : undefined,
                        to: selectedDates.to ? selectedDates.to : undefined,
                        locale: dateLocale,
                        defaultMonth: getDefaultMonth(),
                        scrollToSelectedMonth: vertical,
                        dateFormat: vertical ? localDateFormats.dayDateLongYear : localDateFormats.dayDate,
                        size: size,
                        onScrollToBottom: addMoreMonths,
                        vertical: vertical
                    }),
                    size !== "small" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubmitButton, {
                        type: "button",
                        onClick: function onClick() {
                            return setCalendarVisibility(false);
                        },
                        children: dayCountText
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TimeRange, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimePicker, {
                        id: "depTime",
                        type: "from",
                        label: t("depTime.label"),
                        value: selectedDates.from ? (0,format/* format */.WU)(selectedDates.from, localDateFormats.timeGeneric) : undefined,
                        onChange: handleOnTimeChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimePicker, {
                        id: "destTime",
                        type: "to",
                        label: t("destTime.label"),
                        value: selectedDates.to ? (0,format/* format */.WU)(selectedDates.to, localDateFormats.timeGeneric) : undefined,
                        onChange: handleOnTimeChange
                    })
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/DateRangePicker/index.ts


// EXTERNAL MODULE: ../../node_modules/@engineering/icons/dist/ArrowDown.js
var ArrowDown = __webpack_require__(1143);
var ArrowDown_default = /*#__PURE__*/__webpack_require__.n(ArrowDown);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Dropdown/Dropdown.styles.ts



var DropdownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e17jk6lj0"
}, "target", "e17jk6lj0"))("position:relative;display:flex;align-items:center;justify-content:center;");
var ArrowIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((ArrowDown_default()), (0,src_define_property/* default */.Z)({
    target: "e17jk6lj1"
}, "target", "e17jk6lj1"))("position:absolute;right:0.9375rem;top:50%;transform:translateY(-50%);fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";width:1.6rem;height:1.6rem;pointer-events:none;");
var Hint = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "e17jk6lj2"
}, "target", "e17jk6lj2"))("padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[30];
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.xxs.size;
}, ";");
var Dropdown_styles_StyledLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", (0,src_define_property/* default */.Z)({
    target: "e17jk6lj3"
}, "target", "e17jk6lj3"))("position:absolute;top:-0.5625rem;left:0.75rem;z-index:2;margin:0;padding:0 0.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:0.75rem;line-height:1.5;overflow:hidden;pointer-events:none;text-overflow:ellipsis;white-space:nowrap;&:empty ~ select{padding-top:0.1875rem;padding-bottom:0.1875rem;}");
var StyledSelect = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("select", (0,src_define_property/* default */.Z)({
    target: "e17jk6lj4"
}, "target", "e17jk6lj4"))("display:inline-block;position:relative;margin:0;padding:0.625rem 2rem 0.625rem 1rem;border:1px solid ", function(p) {
    return p.disabled ? "#e8e8e8" : "#c4c4c4";
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";outline:0;width:100%;height:3.125rem;font-size:1rem;line-height:1.5;color:", function(param) {
    var theme = param.theme, disabled = param.disabled;
    return disabled ? theme.color.natural30 : theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";appearance:none;&:hover{border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Dropdown/Dropdown.tsx





var Dropdown = function Dropdown(_param) /*#__PURE__*/ {
    var label = _param.label, value = _param.value, _options = _param.options, options = _options === void 0 ? [] : _options, title = _param.title, hint = _param.hint, id = _param.id, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "value",
        "options",
        "title",
        "hint",
        "id",
        "onChange"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropdownWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown_styles_StyledLabel, {
                        htmlFor: id,
                        children: label
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSelect, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                        id: id,
                        value: value,
                        onChange: onChange,
                        children: [
                            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                                disabled: true,
                                value: -1,
                                children: title
                            }, -1),
                            options.map(function(param) {
                                var itemText = param.label, itemValue = param.value;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
                                    value: itemValue,
                                    children: itemText
                                }, itemValue);
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowIcon, {})
                ]
            }),
            hint && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hint, {
                children: hint
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Dropdown/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/List/List.styles.ts


var BulletItemContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", (0,src_define_property/* default */.Z)({
    target: "e1f5aua90"
}, "target", "e1f5aua90"))("display:flex;flex-direction:row;align-items:flex-start;margin-bottom:0.5rem;gap:0.375rem;svg{flex-shrink:0;margin-top:0.333em;fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";}");
var BulletItemContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "e1f5aua91"
}, "target", "e1f5aua91"))("font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.sm.size;
}, ";line-height:", function(param) {
    var theme = param.theme;
    return theme.fontSize.sm.lineHeight;
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/List/Item/BulletItem.tsx



// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BulletItem = function BulletItem(param) {
    var item = param.item, _type = param.type;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BulletItemContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon, {
                name: "check"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulletItemContent, {
                children: item
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/List/Item/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/List/BulletList.tsx


var BulletList = function BulletList(param) {
    var items = param.items, type = param.type;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulletItem, {
                item: item,
                type: type || "checkmark"
            }, "bullet-item-".concat(index));
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/List/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Markup/Markup.styles.ts


var MarkupContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "ea4otdk0"
}, "target", "ea4otdk0"))("box-sizing:border-box;p{font-size:0.875rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin-bottom:1rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1rem;}&:last-of-type{margin-bottom:0;}}ol{font-size:0.875rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin-bottom:1rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1rem;}}a{&:link,&:visited{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:underline;}&:hover,&:focus,&:active{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:none;}&:not([href]){&:hover,&:focus,&:active{color:inherit;text-decoration:inherit;}}}h1{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin:0 0 1.25rem;font-size:1.875rem;line-height:1.875rem;}h2{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin:0 0 1rem;font-size:1.375rem;font-weight:normal;line-height:1.125;}h3{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin:1.5rem 0 1rem;font-size:1.125rem;font-weight:normal;}ul{list-style-position:outside;list-style-type:disc;padding-left:1.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";line-height:1.5;&.three-row,&.two-row{overflow:hidden;}&.three-row li,&.two-row li{float:left;}&.three-row li{width:33.333%;}&.two-row li{width:50%;padding-left:0.625rem;}&.places-pin{list-style:none;}&.places-pin > li::before{content:'V';color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";font-family:bmfont,serif;font-size:1.125rem;margin-right:0.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1rem;}}/* native collapsibles using <details> / <summary> */\n  details{border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";&:last-of-type:not(:last-child){margin-bottom:1.25rem;border-bottom:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";}> summary:first-of-type{list-style-type:none;}summary{position:relative;margin-bottom:1.25rem;padding-right:2.225rem;min-height:1.6rem;/* if no content is provided,at least keep it the same height as the icon */\n      cursor:pointer;&:focus:not(:focus-visible){outline:0;}&::marker,&::-webkit-details-marker{display:none;}&::after{content:'';position:absolute;top:0;right:0;width:1.6rem;height:1.6rem;background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAyNSI+PHBhdGggZD0iTTE5Ljg1OSA3Ljc1M2wtNy4zNiA3LjMxLTcuMzU4LTcuMzA5YS44NzEuODcxIDAgMCAwLTEuMjI2IDAgLjg1Ny44NTcgMCAwIDAgMCAxLjIxOEwxMi41IDE3LjVsNS4xMjgtNS4wOTMgMy40NTgtMy40MzVhLjg1OC44NTggMCAwIDAgMC0xLjIxOC44NjguODY4IDAgMCAwLTEuMjI3IDB6Ii8+PC9zdmc+Cg==');transition:0.2s linear transform;}}&[open] summary{&::after{transform:scaleY(-1);}}p{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";margin-bottom:0.625rem;}}.tip-box{display:inline-block;width:100%;font-size:1rem;line-height:1.5rem;& > strong{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";display:block;width:100%;padding:0.5rem 0.625rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";position:relative;}& > strong::after{content:'';position:absolute;top:100%;left:50%;margin-left:-10px;width:0;height:0;border-top:solid 10px ", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";border-left:solid 10px transparent;border-right:solid 10px transparent;}.content{padding:0.625rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-top:none;}}& table{width:100%;border:none !important;margin:0 !important;padding:0 !important;font-size:1rem;line-height:1.5rem;td{padding:0.625rem !important;border:none !important;}tbody > tr:first-of-type td,thead tr th{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, " !important;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " !important;border:none !important;}thead + tbody > tr:first-of-type td{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, " !important;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, " !important;}tr:nth-of-type(odd),tr:nth-of-type(odd) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, " !important;}tr:nth-of-type(even),tr:nth-of-type(even) td{background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " !important;border:none !important;}}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Markup/Markup.tsx


var Markup = function Markup(param) {
    var content = param.content, isHidden = param.isHidden, element = param.element;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarkupContainer, {
        hidden: isHidden || false,
        dangerouslySetInnerHTML: {
            __html: content
        },
        as: element
    });
};
Markup.displayName = "raw";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Markup/index.ts


// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ForegroundLayer/ClientOnlyPortal.tsx


var ClientOnlyPortal = function ClientOnlyPortal(param) {
    var children = param.children, selector = param.selector;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    (0,react.useEffect)(function() {
        ref.current = document.querySelector(selector);
        setMounted(true);
    }, [
        selector
    ]);
    return mounted && ref.current ? /*#__PURE__*/ (0,react_dom.createPortal)(children, ref.current) : null;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ForegroundLayer/ForegroundLayer.styles.ts



var CloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(src/* Ui.IconButton */.Ui.hU, (0,src_define_property/* default */.Z)({
    target: "eky19wk0"
}, "target", "eky19wk0"))("position:fixed;right:0.75rem;top:0.75rem;width:1.25rem;height:1.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";z-index:1;cursor:pointer;");
var ForegroundLayerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "eky19wk1"
}, "target", "eky19wk1"))("max-width:500px;display:flex;flex-direction:column;left:50%;margin:0 auto;position:fixed;bottom:0;transform:translateX(-50%);width:100%;z-index:11;");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ForegroundLayer/ForegroundLayer.tsx





var ForegroundLayer = function ForegroundLayer(param) {
    var id = param.id, isShowing = param.isShowing, children = param.children, _onClose = param.onClose, onClose = _onClose === void 0 ? function onClose() {
        return null;
    } : _onClose;
    return isShowing ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClientOnlyPortal, {
        selector: "#fglayer",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ForegroundLayerWrapper, {
            id: id,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
                    id: "".concat(id ? "".concat(id, "-close-button") : ""),
                    icon: (Close_default()),
                    title: "close" // @TODO: Add translation
                    ,
                    onClick: onClose
                }),
                children
            ]
        })
    }) : null;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ForegroundLayer/useForegroundLayer.ts

var useForegroundLayer = function useForegroundLayer() {
    var toggle = function toggle() {
        setIsShowing(!isShowing);
    };
    var ref = (0,react.useState)(false), isShowing = ref[0], setIsShowing = ref[1];
    return {
        isShowing: isShowing,
        toggle: toggle
    };
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/ForegroundLayer/index.ts



;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Quote/Quote.styles.ts



var StyledQuote = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("q", (0,src_define_property/* default */.Z)({
    target: "e1hp7ewh0"
}, "target", "e1hp7ewh0"))("quotes:'„ ' ' “' '\xbb' '\xab';color:", Theme.Color.secondary100, ";font-style:italic;font-size:0.75rem;margin-bottom:0.625rem;");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Quote/Quote.tsx


var Quote = function Quote(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledQuote, {
        children: children
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Quote/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Rating/Rating.styles.ts


var RatingContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", (0,src_define_property/* default */.Z)({
    target: "eu0b8lc0"
}, "target", "eu0b8lc0"))("display:inline-flex;column-gap:1px;");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Rating/RatingStar.tsx




var RatingStarAppearance;
(function(RatingStarAppearance) {
    RatingStarAppearance["Full"] = "full";
    RatingStarAppearance["Half"] = "half";
    RatingStarAppearance["Empty"] = "empty";
})(RatingStarAppearance || (RatingStarAppearance = {}));
var RatingStar = function RatingStar(_param) {
    var _appearence = _param.appearence, appearence = _appearence === void 0 ? RatingStarAppearance.Empty : _appearence, props = (0,_object_without_properties/* default */.Z)(_param, [
        "appearence"
    ]);
    switch(appearence){
        case RatingStarAppearance.Empty:
            {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon, (0,src_object_spread/* default */.Z)({
                    name: "starEmpty"
                }, props));
            }
        case RatingStarAppearance.Full:
            {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon, (0,src_object_spread/* default */.Z)({
                    name: "starFull"
                }, props));
            }
        case RatingStarAppearance.Half:
            {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon, (0,src_object_spread/* default */.Z)({
                    name: "starHalf"
                }, props));
            }
        default:
    }
    return null;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Rating/Rating.tsx



var Rating = function Rating(param) {
    var value = param.value, _maxStars = param.maxStars, maxStars = _maxStars === void 0 ? 5 : _maxStars, starSize = param.starSize;
    if (!value) {
        return null;
    }
    var stars = new Array(maxStars).fill(null).map(function(_, index) {
        return index + 1;
    });
    var halfStarsValue = Math.round(value * 2);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingContainer, {
        role: "img",
        "aria-label": "Rating: ".concat(value, " out of ").concat(maxStars, " stars"),
        children: stars.map(function(i) {
            var appearance = RatingStarAppearance.Empty;
            if (halfStarsValue >= i * 2) {
                appearance = RatingStarAppearance.Full;
            } else if (halfStarsValue >= i * 2 - 1) {
                appearance = RatingStarAppearance.Half;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingStar, {
                appearence: appearance,
                "aria-hidden": true,
                size: starSize
            }, i);
        })
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Rating/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/Text.tsx

var withText = function withText(TextComponent) {
    return function(param) {
        var children = param.children, id = param.id;
        if (!children) {
            return null;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextComponent, {
            id: id,
            children: children
        });
    };
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/Text.styles.ts



var H1Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", (0,src_define_property/* default */.Z)({
    target: "e1j9vtgx0"
}, "target", "e1j9vtgx0"))("color:", Theme.Color.secondary100, ";margin:0.625rem 0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.875rem;font-weight:normal;line-height:1.875rem;");
var H2Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", (0,src_define_property/* default */.Z)({
    target: "e1j9vtgx1"
}, "target", "e1j9vtgx1"))("color:", Theme.Color.secondary100, ";margin:0 0 1rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;font-weight:normal;line-height:1.125;");
var Plain = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1j9vtgx2"
}, "target", "e1j9vtgx2"))("line-height:1.5;color:", Theme.Color.secondary100, ";");
var Callout = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1j9vtgx3"
}, "target", "e1j9vtgx3"))("font-size:1.125rem;line-height:1.5;color:", Theme.Color.secondary100, ";margin-bottom:1rem;");
var Small = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1j9vtgx4"
}, "target", "e1j9vtgx4"))("font-size:0.75rem;line-height:1.5;color:", Theme.Color.secondary100, ";");
var Tiny = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", (0,src_define_property/* default */.Z)({
    target: "e1j9vtgx5"
}, "target", "e1j9vtgx5"))("font-size:0.625rem;line-height:1.5;color:", Theme.Color.secondary100, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/CalloutText.tsx


var CalloutText = withText(Callout);
CalloutText.displayName = "CalloutText";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/PlainText.tsx


var PlainText = withText(Plain);
PlainText.displayName = "PlainText";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/PrimaryTitle.tsx


var PrimaryTitle = withText(H1Title);
PrimaryTitle.displayName = "PrimaryTitle";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/SectionTitle.tsx


var SectionTitle = withText(H2Title);
SectionTitle.displayName = "SectionTitle";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/SmallText.tsx


var SmallText = withText(Small);
SmallText.displayName = "SmallText";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/TinyText.tsx


var TinyText = withText(Tiny);
TinyText.displayName = "TinyText";


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Text/index.ts







// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ../../frontend/shared/src/Ui/Overlay/index.ts + 23 modules
var Overlay = __webpack_require__(4786);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Tooltip/Tooltip.styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &:hover {\n        > [role='tooltip'] {\n          display: block;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TooltipWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "evwxd90"
}, "target", "evwxd90"))("position:relative;", function(param) {
    var hover = param.hover;
    return hover && (0,emotion_react_browser_esm/* css */.iv)(_templateObject());
});
var TooltipContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", (0,src_define_property/* default */.Z)({
    target: "evwxd91"
}, "target", "evwxd91"))("min-width:", function(param) {
    var $width = param.$width;
    return $width === "wide" ? "31.25rem" : "20rem";
}, ";max-width:31.25rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";padding:1rem;border:2px solid ", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";border-radius:0.75rem;position:absolute;font-weight:normal;font-size:0.875rem;z-index:100;transform:", function(param) {
    var $offset = param.$offset;
    return "translate(calc(-50% + ".concat($offset, "px), 15px)");
}, ";display:", function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, ";a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";}&::before{content:'';position:absolute;width:100%;left:0;top:-20px;height:20px;}&::after{content:'';position:absolute;width:20px;height:20px;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";margin-bottom:-9px;margin-left:-10px;bottom:100%;left:50%;transform:rotate(-135deg);border-width:0 2px 2px 0;border-style:solid;border-color:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";border-image:none;border-top:0;border-left:0;}");


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Tooltip/Tooltip.tsx






var Tooltip = function Tooltip(param) {
    var content = param.content, trigger = param.trigger, title = param.title, _width = param.width, width = _width === void 0 ? "default" : _width;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var id = "tooltip-content-".concat((0,react.useId)());
    var ref1 = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(0), offset = ref2[0], setOffset = ref2[1];
    var isMobile = (0,useMedia/* default */.Z)("(max-width: ".concat((0,Theme.getBreakpoint)("lg"), "px)"), false);
    (0,react.useEffect)(function() {
        var ref;
        var value = ((ref = ref1.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
        setOffset(Math.round(value / 2));
    }, []);
    var handleShowModal = (0,react.useCallback)(function(event) {
        event.stopPropagation();
        if (isMobile) {
            setShowModal(true);
        }
    }, [
        isMobile
    ]);
    var handleHideModal = function handleHideModal() {
        setShowModal(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TooltipWrapper, {
        "aria-describedby": id,
        hover: !isMobile,
        onClick: handleShowModal,
        ref: ref1,
        children: [
            trigger,
            showModal ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay/* Overlay */.a, {
                open: showModal,
                title: title,
                onClose: handleHideModal,
                children: content
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TooltipContent, {
                role: "tooltip",
                id: id,
                $width: width,
                $offset: offset,
                children: content
            })
        ]
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/Tooltip/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/components/index.ts
















;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/UiLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/StyleLegacy/CSSReset.tsx


var CSSReset = function CSSReset(param) {
    var theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
        styles: [
            (0,emotion_react_browser_esm/* css */.iv)("*{box-sizing:border-box;font-family:", theme.fontFamily.default, ";}body{margin:0;padding:0;font-size:", theme.fontSize.xs.size, ";line-height:1.25rem;& > div{overflow-x:hidden;}}p{margin:0;}select{-webkit-appearance:none;-moz-appearance:none;&::-ms-expand{display:none;}&:-moz-focusring{color:transparent;text-shadow:0 0 0 #000;}&:focus{outline:0;}}ul{list-style-type:none;padding:0;margin:0;}table{border-collapse:collapse;border-spacing:0;}// For styling Google Maps InfoWindow component,which doesn't allow for custom styling\n      // Component @ frontend/entities/src/Map/CustomMarker/CustomMarker.tsx\n      .gm-style-iw.gm-style-iw-c{background-color:transparent;padding:0;box-shadow:none;& > button{top:10px !important;right:18px !important;transform:scale(1.5);}}.gm-style-iw-t > .gm-style-iw-tc{top:-5px;}.gm-style-iw-d{height:77px;background-color:transparent;overflow:hidden !important;& > div{height:77px;}}")
        ]
    });
};

;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/StyleLegacy/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/_legacy/index.ts













/***/ }),

/***/ 2775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wy": function() { return /* reexport */ Text/* BodyBoldText */.wy; },
  "Ac": function() { return /* reexport */ Text/* BodyText */.Ac; },
  "zx": function() { return /* reexport */ Button; },
  "_y": function() { return /* reexport */ Context; },
  "Ku": function() { return /* reexport */ DataInterop_namespaceObject; },
  "nL": function() { return /* reexport */ Text/* Heading1 */.nL; },
  "XJ": function() { return /* reexport */ Text/* Heading2 */.XJ; },
  "aC": function() { return /* reexport */ Text/* Heading3 */.aC; },
  "k8": function() { return /* reexport */ Text/* Heading4 */.k8; },
  "by": function() { return /* reexport */ Text/* Heading5 */.by; },
  "Cd": function() { return /* reexport */ Text/* Heading6 */.Cd; },
  "rk": function() { return /* reexport */ ImageWithFocalPoint; },
  "G9": function() { return /* reexport */ Text/* InteractiveText */.G9; },
  "yX": function() { return /* reexport */ Links_namespaceObject; },
  "MQ": function() { return /* reexport */ Text/* SecondaryText */.MQ; },
  "z_": function() { return /* reexport */ session_namespaceObject; },
  "Ld": function() { return /* reexport */ strings; },
  "z0": function() { return /* reexport */ styles; },
  "QE": function() { return /* reexport */ Text/* Subtitle */.QE; },
  "Q1": function() { return /* reexport */ Text/* TertiaryText */.Q1; },
  "Q2": function() { return /* reexport */ Theme; },
  "Ui": function() { return /* reexport */ Ui; },
  "hi": function() { return /* reexport */ api_namespaceObject; },
  "Hp": function() { return /* reexport */ Text/* bodyBold */.Hp; },
  "t2": function() { return /* reexport */ src_datetime_namespaceObject; },
  "dJ": function() { return /* reexport */ http_namespaceObject; },
  "Tp": function() { return /* reexport */ Text/* interactiveText */.Tp; },
  "wz": function() { return /* reexport */ Text/* secondaryText */.wz; }
});

// UNUSED EXPORTS: Type, jwt

// NAMESPACE OBJECT: ../../frontend/shared/src/jwt/base64-browser.ts
var base64_browser_namespaceObject = {};
__webpack_require__.r(base64_browser_namespaceObject);
__webpack_require__.d(base64_browser_namespaceObject, {
  "decode": function() { return decode; },
  "encode": function() { return encode; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/api/index.ts
var api_namespaceObject = {};
__webpack_require__.r(api_namespaceObject);
__webpack_require__.d(api_namespaceObject, {
  "mT": function() { return LegacyHTTPService; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/http/index.ts
var http_namespaceObject = {};
__webpack_require__.r(http_namespaceObject);
__webpack_require__.d(http_namespaceObject, {
  "API": function() { return API; },
  "AxiosError": function() { return node_modules_axios/* AxiosError */.d7; },
  "axiosInstance": function() { return axiosInstance; },
  "getApi": function() { return getApi; },
  "useClientSideRequest": function() { return useClientSideRequest; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/DataInterop/index.ts
var DataInterop_namespaceObject = {};
__webpack_require__.r(DataInterop_namespaceObject);
__webpack_require__.d(DataInterop_namespaceObject, {
  "J": function() { return StructuredData; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/datetime/index.ts
var src_datetime_namespaceObject = {};
__webpack_require__.r(src_datetime_namespaceObject);
__webpack_require__.d(src_datetime_namespaceObject, {
  "Z": function() { return dateLocales; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/Links/index.ts
var Links_namespaceObject = {};
__webpack_require__.r(Links_namespaceObject);
__webpack_require__.d(Links_namespaceObject, {
  "makeLinkTypeMapper": function() { return makeLinkTypeMapper; }
});

// NAMESPACE OBJECT: ../../frontend/shared/src/session/index.ts
var session_namespaceObject = {};
__webpack_require__.r(session_namespaceObject);
__webpack_require__.d(session_namespaceObject, {
  "h": function() { return SessionStorageManager; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../frontend/shared/src/Text/index.ts + 21 modules
var Text = __webpack_require__(2408);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(8730);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ../../frontend/shared/src/Control/Button/Button.styles.ts




var getPrimaryStyles = function getPrimaryStyles(defaultColor, highlightColor, theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", theme.color.natural0, ";background-color:", defaultColor, ";transition:background 1s;&:hover,&:focus-visible{background-color:", highlightColor, ";background-image:radial-gradient(\n      circle,transparent 1%,", highlightColor, " 1%\n    );background-position:center;background-size:15000%;}&:active{background-color:", (0,polished_esm/* tint */.nV)(0.15, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getPrimaryDisabledStyles = function getPrimaryDisabledStyles(theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", theme.color.natural50, ";background-color:", theme.color.natural10, ";");
};
var getSecondaryStyles = function getSecondaryStyles(defaultColor, highlightColor, isSmallButton, theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:", isSmallButton ? "0.5rem 0.75rem" : "0.875rem 1.875rem", ";border:2px solid currentcolor;color:", defaultColor, ";background-color:", theme.color.natural0, ";transition-property:color,background,border-color;transition-duration:1s;&:hover,&:focus-visible{color:", highlightColor, ";background-color:", theme.color.natural0, ";background-image:radial-gradient(\n      circle,transparent 1%,", theme.color.natural0, " 1%\n    );background-position:center;background-size:15000%;}&:active{color:", highlightColor, ";background-color:", (0,polished_esm/* tint */.nV)(0.8, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getSecondaryDisabledStyles = function getSecondaryDisabledStyles(isSmallButton, theme) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:", isSmallButton ? "0.5rem 0.875rem" : "0.875rem 1.875rem", ";border:2px solid ", theme.color.natural20, ";color:", theme.color.natural50, ";background-color:", theme.color.natural0, ";");
};
var ButtonComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", (0,_define_property/* default */.Z)({
    target: "e1b1kfqx0"
}, "target", "e1b1kfqx0"))("display:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "flex" : "inline-flex";
}, ";flex-direction:", function(param) {
    var iconAlignment = param.iconAlignment;
    return iconAlignment === "right" ? "row-reverse" : "";
}, ";justify-content:center;align-items:center;gap:0.5rem;margin:0;padding:", function(param) {
    var isSmallButton = param.isSmallButton;
    return isSmallButton ? "0.625rem 1rem" : "1rem 2rem";
}, ";border:0;outline:0;border-radius:0.5rem;overflow:visible;box-sizing:border-box;width:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "100%" : "";
}, ";max-width:100%;white-space:nowrap;text-decoration:none;text-transform:none;fill:currentcolor;background-position:center;-webkit-tap-highlight-color:transparent;cursor:", function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "not-allowed" : "pointer";
}, ";user-select:none;appearance:none;", function(param) {
    var theme = param.theme, isSecondaryButton = param.isSecondaryButton, isSmallButton = param.isSmallButton, isDisabled = param.isDisabled;
    var defaultColor = theme.color.primary;
    var highlightColor = (0,polished_esm/* lighten */.$n)(0.3, (0,polished_esm/* desaturate */.vG)(0.6, defaultColor));
    if (isSecondaryButton) {
        if (isDisabled) {
            return getSecondaryDisabledStyles(isSmallButton, theme);
        }
        return getSecondaryStyles(defaultColor, highlightColor, isSmallButton, theme);
    }
    if (isDisabled) {
        return getPrimaryDisabledStyles(theme);
    }
    return getPrimaryStyles(defaultColor, highlightColor, theme);
}, ";");


;// CONCATENATED MODULE: ../../frontend/shared/src/Control/Button/Button.tsx






var defaultProps = {
    type: "button",
    iconAlignment: "left",
    size: "large",
    variant: "primary",
    fullWidth: false,
    loading: false,
    disabled: false
};
/** Renders a button or a link looking like a button. */ var Button = function Button(_param) {
    var children = _param.children, icon = _param.icon, iconAlignment = _param.iconAlignment, size = _param.size, variant = _param.variant, fullWidth = _param.fullWidth, loading = _param.loading, disabled = _param.disabled, className = _param.className, textId = _param.textId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "icon",
        "iconAlignment",
        "size",
        "variant",
        "fullWidth",
        "loading",
        "disabled",
        "className",
        "textId"
    ]);
    var isDisabled = disabled === true;
    var isSmallButton = size === "small";
    var isSecondaryButton = variant === "secondary";
    var isFullWidth = fullWidth === true;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: props.href ? "a" : undefined
    }, props), {
        type: props.href ? undefined : props.type,
        disabled: props.href ? undefined : disabled,
        iconAlignment: iconAlignment,
        isDisabled: isDisabled,
        isSmallButton: isSmallButton,
        isSecondaryButton: isSecondaryButton,
        isFullWidth: isFullWidth,
        "aria-busy": loading ? "true" : undefined,
        "aria-disabled": props.href && isDisabled ? "true" : undefined,
        className: className,
        children: [
            icon,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* InteractiveText */.G9, {
                id: textId,
                inline: true,
                textColor: "current",
                size: isSmallButton ? "small" : "normal",
                children: children
            })
        ]
    }));
};
Button.defaultProps = defaultProps;


;// CONCATENATED MODULE: ../../frontend/shared/src/Control/Button/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Control/index.ts


// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../frontend/shared/src/ImageWithFocalPoint/ImageWithFocalPoint.tsx


var ImageWithFocalPoint = function ImageWithFocalPoint(param) {
    var className = param.className, src = param.src, alt = param.alt, width = param.width, height = param.height, focalPoint = param.focalPoint;
    var xPercentage = focalPoint && width ? focalPoint.x * 100 / width : undefined;
    var yPercentage = focalPoint && height ? focalPoint.y * 100 / height : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        className: className,
        src: src,
        alt: alt,
        height: height,
        width: width,
        layout: "fill",
        objectFit: "cover",
        objectPosition: xPercentage && yPercentage ? "".concat(xPercentage, "% ").concat(yPercentage, "%") : ""
    });
};

;// CONCATENATED MODULE: ../../frontend/shared/src/ImageWithFocalPoint/index.ts


// EXTERNAL MODULE: ../../node_modules/nookies/dist/index.js
var dist = __webpack_require__(8344);
;// CONCATENATED MODULE: ../../frontend/shared/src/jwt/base64-browser.ts
function encode(value) {
    return btoa(value);
}
function decode(value) {
    return atob(value);
}

;// CONCATENATED MODULE: ../../frontend/shared/src/jwt/base64-server.ts
/* provided dependency */ var Buffer = __webpack_require__(8834)["lW"];
function base64_server_encode(value) {
    return Buffer.from(value, "utf-8").toString("base64");
}
function base64_server_decode(value) {
    return Buffer.from(value, "base64").toString("utf-8");
}

;// CONCATENATED MODULE: ../../frontend/shared/src/jwt/index.ts


var nextBase64 =  false ? 0 : base64_browser_namespaceObject;
var decodeBase64 = nextBase64.decode;
var encodeBase64 = nextBase64.encode;
var decodeToken = function decodeToken(token) {
    if (!token) {
        return null;
    }
    var base64Url = token.split(".")[1];
    if (!base64Url) {
        return null;
    }
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var decoded = decodeBase64(base64);
    try {
        return JSON.parse(decoded);
    } catch (err) {
        return null;
    }
};
var validToken = function validToken(token) {
    var ref;
    if (!token) {
        return false;
    }
    var exp = (ref = decodeToken(token)) === null || ref === void 0 ? void 0 : ref.exp;
    return exp ? exp * 1000 > Date.now() : false;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/api/config.ts
// Map locales to Whitelabels
var whitelabels = {
    "de-DE": "DE_billiger-mietwagen",
    "fr-FR": "FR_carigami",
    "es-ES": "ES_floyt",
    "it-IT": "IT_floyt",
    "nl-NL": "NL_floyt"
};
var config_getWhitelabel = function getWhitelabel() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "de-DE";
    return whitelabels[locale];
};
var config_DEFAULT_TIMEOUT = 4000;


;// CONCATENATED MODULE: ../../frontend/shared/src/api/HTTPService.ts







var HTTPService = function HTTPService(apiHostConfig, path, nextRequest, nextResponse, locale, accessToken, refreshToken, idToken) {
    "use strict";
    var _this = this;
    _class_call_check(this, HTTPService);
    var ref;
    // Request interceptor for API calls
    this.initializeRequestInterceptor = function() {
        _this.instance.interceptors.request.use(function() {
            var _ref = _async_to_generator(function(config) {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        config
                    ];
                });
            });
            return function(config) {
                return _ref.apply(this, arguments);
            };
        }(), function(err) {
            Promise.reject(err);
        });
    };
    this.initializeResponseInterceptor = function() {
        _this.instance.interceptors.response.use(function(res) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            res.config.headers["x-access-token"] = _this.accessToken || "";
            res.config.headers["x-refresh-token"] = _this.refreshToken || "";
            res.config.headers["x-id-token"] = _this.idToken || "";
            return res;
        }, _this.handleError);
    };
    var _this1 = this;
    this.handleError = function() {
        var _ref = _async_to_generator(function(err) {
            var ref, originalRequest, refreshTokenUrl, ref1, ref2, ref3, ref4, ref5, userId, res;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        originalRequest = err.config;
                        refreshTokenUrl = _this1.hostConfig.refreshTokenUrl;
                        if (!(((ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 401 && !originalRequest.retry && refreshTokenUrl)) return [
                            3,
                            2
                        ];
                        originalRequest.retry = true;
                        userId = (ref1 = jwt.decodeToken(_this1.idToken)) === null || ref1 === void 0 ? void 0 : ref1.user_id;
                        return [
                            4,
                            axios.post(refreshTokenUrl, {
                                user_id: userId,
                                refresh_token: _this1.refreshToken
                            }, {
                                headers: originalRequest.headers,
                                withCredentials: true
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        // @ts-ignore
                        originalRequest.headers.Authorization = "Bearer ".concat((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.access_token);
                        _this1.accessToken = (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.access_token;
                        _this1.idToken = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.id_token;
                        setCookie({
                            res: _this1.nextResponse
                        }, "access_token", (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.access_token, {
                            httpOnly: true,
                            secure: "production" === "production",
                            sameSite: "strict",
                            path: "/",
                            maxAge: 60 * 60
                        });
                        return [
                            2,
                            _this1.instance(originalRequest)
                        ];
                    case 2:
                        return [
                            2,
                            Promise.reject(err)
                        ];
                }
            });
        });
        return function(err) {
            return _ref.apply(this, arguments);
        };
    }();
    this.hostConfig = apiHostConfig;
    this.path = path;
    this.ssrMode = "object" === "undefined";
    if (nextRequest) {
        this.nextRequest = nextRequest;
    }
    if (nextResponse) {
        this.nextResponse = nextResponse;
    }
    if (this.ssrMode && (nextRequest === null || nextRequest === void 0 ? void 0 : nextRequest.cookies)) {
        var ref1, ref2, ref3;
        this.accessToken = nextRequest === null || nextRequest === void 0 ? void 0 : (ref1 = nextRequest.cookies) === null || ref1 === void 0 ? void 0 : ref1.access_token;
        this.refreshToken = nextRequest === null || nextRequest === void 0 ? void 0 : (ref2 = nextRequest.cookies) === null || ref2 === void 0 ? void 0 : ref2.refresh_token;
        this.idToken = nextRequest === null || nextRequest === void 0 ? void 0 : (ref3 = nextRequest.cookies) === null || ref3 === void 0 ? void 0 : ref3.id_token;
    }
    if (accessToken) {
        this.accessToken = accessToken;
    }
    if (refreshToken) {
        this.refreshToken = refreshToken;
    }
    if (idToken) {
        this.idToken = idToken;
    }
    this.locale = locale || (nextRequest === null || nextRequest === void 0 ? void 0 : (ref = nextRequest.headers) === null || ref === void 0 ? void 0 : ref.locale) || "de-DE";
    this.instance = axios.create({
        baseURL: "".concat(apiHostConfig.baseUrl).concat(path),
        timeout: DEFAULT_TIMEOUT,
        headers: {
            "X-Whitelabel": getWhitelabel(this.locale),
            Authorization: "Bearer ".concat(this.accessToken)
        },
        withCredentials: true
    });
    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(581);
// EXTERNAL MODULE: ../../node_modules/axios/lib/axios.js + 42 modules
var lib_axios = __webpack_require__(162);
;// CONCATENATED MODULE: ../../frontend/shared/src/api/LegacyHTTPService.ts


var BASE_URL = "https://api.billiger-mietwagen.de/v1";
var LegacyHTTPService = function LegacyHTTPService() {
    "use strict";
    (0,src_class_call_check/* default */.Z)(this, LegacyHTTPService);
    this.instance = lib_axios/* default.create */.Z.create({
        baseURL: BASE_URL,
        timeout: 8000
    });
};

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../frontend/shared/src/api/useHttpClient.tsx





var useHttpClient = function useHttpClient(param) {
    var url = param.url, _method = param.method, method = _method === void 0 ? "get" : _method, _payload = param.payload, payload = _payload === void 0 ? {} : _payload;
    var ref = useState(null), data = ref[0], setData = ref[1];
    var ref1 = useState(""), error = ref1[0], setError = ref1[1];
    var ref2 = useState(false), loaded = ref2[0], setLoaded = ref2[1];
    var router = useRouter();
    // FIXME: potentially error with Node v14
    // const controllerRef = useRef(new AbortController());
    // const cancel = () => {
    //   controllerRef.current.abort();
    // };
    useEffect(function() {
        _async_to_generator(function() {
            var res, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            axios.request({
                                data: payload,
                                // signal: controllerRef.current.signal,
                                method: method,
                                url: url,
                                headers: {
                                    locale: router.locale
                                },
                                withCredentials: true
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        setData(res.data);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        setError(err === null || err === void 0 ? void 0 : err.message);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoaded(true);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url
    ]);
    return {
        data: data,
        error: error,
        loaded: loaded
    };
};


;// CONCATENATED MODULE: ../../frontend/shared/src/api/index.ts
/** @deprecated Use `http` module */ 



// EXTERNAL MODULE: ../../node_modules/axios/index.js
var node_modules_axios = __webpack_require__(613);
;// CONCATENATED MODULE: ../../frontend/shared/src/http/axios.ts



var baseConfig = {
    timeout: 8000,
    withCredentials: true,
    headers: {
        "client-id": "web"
    }
};
var axiosInstance = lib_axios/* default.create */.Z.create(baseConfig);
var getApi = function getApi(host, config) {
    var version = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "v1", protocol = arguments.length > 3 ? arguments[3] : void 0;
    var baseURL = "".concat(protocol || "https", "://").concat(host, "/").concat(version);
    return lib_axios/* default.create */.Z.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        baseURL: baseURL
    }, baseConfig, config), {
        headers: (0,_object_spread/* default */.Z)({}, baseConfig.headers, config === null || config === void 0 ? void 0 : config.headers)
    }));
};
var API;
(function(API) {
    API["accountLogin"] = "/auth/v1/login";
    API["accountResendConfirmUser"] = "/user-profile/v1/resend-confirm-user";
    API["accountSession"] = "/user_account/session.php";
    API["openingHours"] = "/infoline/times";
    API["siteSettings"] = "/site/settings";
    API["searchCars"] = "/quotes";
})(API || (API = {}));


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5680);
;// CONCATENATED MODULE: ../../frontend/shared/src/http/useClientSideRequest.ts





var useClientSideRequest = function useClientSideRequest(apiHost, apiRoute) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        withCredentials: true
    };
    var ref = (0,react.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var api = getApi(apiHost, (0,_object_spread/* default */.Z)({}, options));
    return {
        request: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(method, params) {
                var result, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                api.request({
                                    method: method,
                                    url: apiRoute,
                                    params: params
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            setData(result === null || result === void 0 ? void 0 : result.data);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            setError(e.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(method, params) {
                return _ref.apply(this, arguments);
            };
        }(),
        data: data,
        error: error
    };
};

;// CONCATENATED MODULE: ../../frontend/shared/src/http/index.ts



// EXTERNAL MODULE: ../../frontend/shared/src/Context/index.ts + 7 modules
var Context = __webpack_require__(6729);
;// CONCATENATED MODULE: ../../frontend/shared/src/DataInterop/components/StructuredData.tsx
/* eslint-disable react/no-danger */ 

var CONTEXT = {
    "@context": "https://schema.org"
};
var StructuredData = function StructuredData(param) {
    var type = param.type, data = param.data, _includeContext = param.includeContext, includeContext = _includeContext === void 0 ? false : _includeContext;
    var context = includeContext ? CONTEXT : {};
    var structuredData = (0,_object_spread/* default */.Z)({
        "@type": type
    }, data, context);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
        id: "jsonid-".concat(type.toLowerCase()),
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(structuredData)
        }
    });
};


;// CONCATENATED MODULE: ../../frontend/shared/src/DataInterop/components/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/DataInterop/index.ts


// EXTERNAL MODULE: ../../node_modules/date-fns/locale/de.mjs + 5 modules
var de = __webpack_require__(1466);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/fr.mjs + 5 modules
var fr = __webpack_require__(3005);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/es.mjs + 5 modules
var es = __webpack_require__(596);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/it.mjs + 6 modules
var it = __webpack_require__(5455);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/nl.mjs + 5 modules
var nl = __webpack_require__(5460);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/en-US.mjs + 5 modules
var en_US = __webpack_require__(6198);
;// CONCATENATED MODULE: ../../frontend/shared/src/datetime/datetime.ts








var dateLocales = {
    de: de.de,
    fr: fr.fr,
    es: es.es,
    it: it.it,
    nl: nl.nl,
    en: en_US/* enUS */._
};
var addTimeToDate = function addTimeToDate(date, hours, minutes) {
    return setMinutes(setHours(date, hours), minutes);
};

;// CONCATENATED MODULE: ../../frontend/shared/src/datetime/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/Links/makeLinkTypeMapper.ts



var _weight, _weight1;
var makeLinkTypeMapper = function makeLinkTypeMapper(staticLinks) {
    return function(type) {
        return staticLinks.filter(function(link) {
            return link.type === type;
        }).sort(function(a, b) {
            return ((_weight = b.weight) !== null && _weight !== void 0 ? _weight : 0) - ((_weight1 = a.weight) !== null && _weight1 !== void 0 ? _weight1 : 0);
        }).map(function(_param) {
            var title = _param.title, link = (0,_object_without_properties/* default */.Z)(_param, [
                "title"
            ]);
            if (!title) {
                return link;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                title: title
            });
        });
    };
};


;// CONCATENATED MODULE: ../../frontend/shared/src/Links/index.ts


;// CONCATENATED MODULE: ../../frontend/shared/src/session/SessionStorageManager.ts

var SessionStorageManager = /*#__PURE__*/ function() {
    "use strict";
    function SessionStorageManager() {
        (0,src_class_call_check/* default */.Z)(this, SessionStorageManager);
    }
    SessionStorageManager.getData = function getData(key) {
        try {
            var data = sessionStorage.getItem(key);
            if (data) {
                return JSON.parse(data);
            }
        } catch (error) {
        // TODO: error handling (if necessary?)
        }
        return undefined;
    };
    SessionStorageManager.setData = function setData(key, data) {
        try {
            sessionStorage.setItem(key, JSON.stringify(data));
        } catch (error) {
        // TODO: error handling (if necessary?)
        }
    };
    SessionStorageManager.removeData = function removeData(key) {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
        // TODO: error handling (if necessary?)
        }
    };
    return SessionStorageManager;
}();


;// CONCATENATED MODULE: ../../frontend/shared/src/session/index.ts


// EXTERNAL MODULE: ../../frontend/shared/src/strings/index.ts + 5 modules
var strings = __webpack_require__(7263);
// EXTERNAL MODULE: ../../frontend/shared/src/styles/index.ts + 1 modules
var styles = __webpack_require__(8847);
// EXTERNAL MODULE: ../../frontend/shared/src/Theme/index.ts + 8 modules
var Theme = __webpack_require__(6321);
// EXTERNAL MODULE: ../../frontend/shared/src/Ui/index.ts + 124 modules
var Ui = __webpack_require__(2145);
;// CONCATENATED MODULE: ../../frontend/shared/src/index.ts































/***/ }),

/***/ 7263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dateFormats": function() { return /* reexport */ dateFormats; },
  "formatDate": function() { return /* reexport */ formatDate; },
  "formatPrice": function() { return /* reexport */ formatPrice; },
  "isoDate": function() { return /* reexport */ isoDate; },
  "isoDateTime": function() { return /* reexport */ isoDateTime; },
  "isoDateTimeWithSeconds": function() { return /* reexport */ isoDateTimeWithSeconds; },
  "parsePhoneNumber": function() { return /* reexport */ parsePhoneNumber; },
  "useRelativeDate": function() { return /* reexport */ useRelativeDate; }
});

;// CONCATENATED MODULE: ../../frontend/shared/src/strings/formatDate.ts
// helper for international date format, results from a provided string timestamp
var formatDate = function formatDate(timestamp, locale) {
    if (!timestamp) return "";
    var date = new Date(timestamp);
    return new Intl.DateTimeFormat(locale, {
        dateStyle: "full",
        timeStyle: "short"
    }).format(date);
};


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
;// CONCATENATED MODULE: ../../frontend/shared/src/strings/format-price.ts
// helper for international price format

var formatPrice = function formatPrice(number, currency, locale, options) {
    if (Number.isNaN(number) || currency === "") {
        return undefined;
    }
    return new Intl.NumberFormat(locale, (0,_object_spread/* default */.Z)({
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }, options)).format(number);
};


;// CONCATENATED MODULE: ../../frontend/shared/src/strings/phone-number.ts
var countryCodes = {
    de: "+49",
    fr: "+33",
    es: "+34",
    it: "+39",
    nl: "+31",
    en: "+44"
};
var formats = [
    "national",
    "international",
    "url"
];
var formatPhoneNumber = function formatPhoneNumber(phoneNumber, language, format) {
    if (format === "national") {
        if (!phoneNumber.startsWith("+")) {
            // is already national
            return phoneNumber;
        }
        return phoneNumber.replace(/^\+\d+\s/, "0");
    }
    var internationalPhoneNumber = phoneNumber.startsWith("+") ? phoneNumber : phoneNumber.replace("-", "").replace(/\s+/, " ").replace(/^0+/, "".concat(countryCodes[language], " "));
    if (format === "url") {
        return "tel:+".concat(internationalPhoneNumber.replace(/\D/g, ""));
    }
    return internationalPhoneNumber;
};
/**
 * Parses a phone number and returns different formats.
 * This is by no means a fully implemented phone number formatter, but
 * it covers the needs of FLOYT and all current phone numbers
 * provided by the Site Settings v1 API.
 */ var parsePhoneNumber = function parsePhoneNumber(phoneNumber, language) {
    return Object.fromEntries(formats.map(function(f) {
        return [
            f,
            formatPhoneNumber(phoneNumber, language, f)
        ];
    }));
};


;// CONCATENATED MODULE: ../../frontend/shared/src/strings/format-date.ts
// These are date formats originally defined in the booking funnel (CarSPA),
// being re-used in this Next.js project.
var isoDate = "yyyy-MM-dd";
var isoDateTime = "yyyy-MM-dd'T'HH:mm";
var isoDateTimeWithSeconds = "yyyy-MM-dd'T'HH:mm:ss";
var de = {
    date: "dd.MM.yy",
    dateLong: "dd.MM.yyyy",
    dateGeneric: "dd.MM.yyyy",
    isoDate: isoDate,
    isoDateTime: isoDateTime,
    dateTime: "eeeeee, dd.MM.yy, HH:mm",
    dayDate: "eeeeee, dd.MM.yy",
    dayDateLong: "eeee, dd.MM.yyyy",
    dayDateLongYear: "eeeeee, dd.MM.yyyy",
    dayTimeLong: "EEEEEE, dd.MM.yyyy - HH:mm",
    dayTimeShort: "EEEEEE, dd.MM.yy - HH:mm",
    time: "HH:mm",
    timeGeneric: "HH:mm",
    dayOfMonth: "dd",
    dayOfWeek: "eeee",
    monthYear: "MMM yyyy"
};
var fr = {
    date: "dd/MM/yy",
    dateLong: "dd/MM/yyyy",
    dateGeneric: "dd.MM.yyyy",
    isoDate: isoDate,
    isoDateTime: isoDateTime,
    dateTime: "eeeeee, dd/MM/yy, HH'h'mm",
    dayDate: "eeeeee, dd/MM/yy",
    dayDateLong: "eeee, dd/MM/yyyy",
    dayDateLongYear: "eeeeee, dd/MM/yyyy",
    dayTimeLong: "EEEEEE, dd/MM/yyyy - HH:mm",
    dayTimeShort: "EEEEEE, dd/MM/yy - HH:mm",
    time: "HH'h'mm",
    timeGeneric: "HH:mm",
    dayOfMonth: "dd",
    dayOfWeek: "eeee",
    monthYear: "MMM yyyy"
};
var es = {
    date: "dd/MM/yy",
    dateLong: "dd/MM/yyyy",
    dateGeneric: "dd.MM.yyyy",
    isoDate: isoDate,
    isoDateTime: isoDateTime,
    dateTime: "eeeeee, dd/MM/yy, HH:mm",
    dayDate: "eeeeee, dd/MM/yy",
    dayDateLong: "eeee, dd/MM/yyyy",
    dayDateLongYear: "eeeeee, dd/MM/yyyy",
    dayTimeLong: "EEEEEE, dd/MM/yyyy - HH:mm",
    dayTimeShort: "EEEEEE, dd/MM/yy - HH:mm",
    time: "HH:mm",
    timeGeneric: "HH:mm",
    dayOfMonth: "dd",
    dayOfWeek: "eeee",
    monthYear: "MMM yyyy"
};
var it = {
    date: "dd/MM/yy",
    dateLong: "dd/MM/yyyy",
    dateGeneric: "dd.MM.yyyy",
    isoDate: isoDate,
    isoDateTime: isoDateTime,
    dateTime: "eeeeee dd/MM/yy, HH:mm",
    dayDate: "eeeeee dd/MM/yy",
    dayDateLong: "eeee dd/MM/yyyy",
    dayDateLongYear: "eeeeee dd/MM/yyyy",
    dayTimeLong: "EEEEEE dd/MM/yyyy - HH:mm",
    dayTimeShort: "EEEEEE dd/MM/yy - HH:mm",
    time: "HH:mm",
    timeGeneric: "HH:mm",
    dayOfMonth: "dd",
    dayOfWeek: "eeee",
    monthYear: "MMM yyyy"
};
var nl = {
    date: "dd-MM-yy",
    dateLong: "dd-MM-yyyy",
    dateGeneric: "dd.MM.yyyy",
    isoDate: isoDate,
    isoDateTime: isoDateTime,
    dateTime: "eeeeee dd-MM-yy, HH:mm",
    dayDate: "eeeeee dd-MM-yy",
    dayDateLong: "eeee dd-MM-yyyy",
    dayDateLongYear: "eeeeee dd-MM-yyyy",
    dayTimeLong: "EEEEEE dd-MM-yyyy - HH:mm",
    dayTimeShort: "EEEEEE dd-MM-yy - HH:mm",
    time: "HH:mm",
    timeGeneric: "HH:mm",
    dayOfMonth: "dd",
    dayOfWeek: "eeee",
    monthYear: "MMM yyyy"
};
var en = {
    date: "yy-MM-dd",
    dateLong: "yyyy-MM-dd",
    dateGeneric: "yyyy-MM-dd",
    isoDate: isoDate,
    isoDateTime: isoDateTime,
    dateTime: "eeeeee, yy-MM-dd, HH:mm",
    dayDate: "eeeeee, yy-MM-dd",
    dayDateLong: "eeee, yyyy-MM-dd",
    dayDateLongYear: "eeeeee, yyyy-MM-dd",
    dayTimeLong: "EEEEEE, yyyy-MM-dd - HH:mm",
    dayTimeShort: "EEEEEE, yy-MM-dd - HH:mm",
    time: "HH:mm",
    timeGeneric: "HH:mm",
    dayOfMonth: "dd",
    dayOfWeek: "eeee",
    monthYear: "MMM yyyy"
};
var dateFormats = {
    de: de,
    fr: fr,
    es: es,
    it: it,
    nl: nl,
    en: en
};


// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(5790);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInCalendarDays.mjs
var differenceInCalendarDays = __webpack_require__(9219);
// EXTERNAL MODULE: ../../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(2174);
;// CONCATENATED MODULE: ../../frontend/shared/src/strings/useRelativeDate.tsx





var important = function important(content) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
        suppressHydrationWarning: true,
        children: content
    });
};
var timeFormatOptions = {
    hour: "numeric",
    minute: "numeric"
};
var dateTimeFormatOptions = {
    dateStyle: "medium",
    timeStyle: "medium"
};
var useRelativeDate = function useRelativeDate(date) {
    var format = (0,next_intl_cjs_production_min.useFormatter)();
    var t = (0,next_intl_cjs_production_min.useTranslations)("shared.stringsLegacy.dates");
    var translationsMap = (0,react.useMemo)(function() {
        var dateValue = (0,parseISO/* parseISO */.D)(date);
        return {
            dateToday: t.rich("dateToday", {
                important: important,
                date: format.dateTime(dateValue, timeFormatOptions)
            }),
            dateYesterday: t.rich("dateYesterday", {
                important: important,
                date: format.dateTime(dateValue, timeFormatOptions)
            }),
            dateLabel: t.rich("dateLabel", {
                important: important,
                date: format.dateTime(dateValue, dateTimeFormatOptions)
            })
        };
    }, [
        date,
        format,
        t
    ]);
    var ref = (0,react.useState)(translationsMap.dateLabel), dateLabel = ref[0], setDateLabel = ref[1];
    // Do not render relative dates in SSR to avoid hydration errors
    (0,react.useEffect)(function() {
        var daysDifference = (0,differenceInCalendarDays/* differenceInCalendarDays */.w)((0,parseISO/* parseISO */.D)(date), new Date());
        if (daysDifference === 0) {
            setDateLabel(translationsMap.dateToday);
        }
        if (daysDifference === -1) {
            setDateLabel(translationsMap.dateYesterday);
        }
    }, [
        date,
        translationsMap
    ]);
    return dateLabel;
};


;// CONCATENATED MODULE: ../../frontend/shared/src/strings/index.ts







/***/ }),

/***/ 8847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ Global_styles_namespaceObject; }
});

// UNUSED EXPORTS: CLASS_MAP

// NAMESPACE OBJECT: ../../frontend/shared/src/styles/Global.styles.ts
var Global_styles_namespaceObject = {};
__webpack_require__.r(Global_styles_namespaceObject);
__webpack_require__.d(Global_styles_namespaceObject, {
  "Rq": function() { return fonts; },
  "b1": function() { return layoutContainerContent; },
  "rS": function() { return layoutContentOnlyPadding; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../frontend/shared/src/Theme/index.ts + 8 modules
var Theme = __webpack_require__(6321);
;// CONCATENATED MODULE: ../../frontend/shared/src/styles/Global.styles.ts


var fonts = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("@font-face{src:local(''),url('../imgs/fonts/quicksand-bold.woff2') format('woff2'),url('../imgs/fonts/quicksand-bold.woff') format('woff'),url('../imgs/fonts/quicksand-bold.ttf') format('truetype');font-family:Quicksand;font-weight:700;font-style:normal;font-display:swap;}@font-face{src:local(''),url('../imgs/fonts/sourcesanspro-regular.woff2') format('woff2'),url('../imgs/fonts/sourcesanspro-regular.woff') format('woff'),url('../imgs/fonts/sourcesanspro-regular.ttf') format('truetype');font-family:'Source Sans Pro';font-weight:400;font-style:normal;font-display:swap;}@font-face{src:local(''),url('../imgs/fonts/sourcesanspro-semibold.woff2') format('woff2'),url('../imgs/fonts/sourcesanspro-semibold.woff') format('woff'),url('../imgs/fonts/sourcesanspro-semibold.ttf') format('truetype');font-family:'Source Sans Pro';font-weight:600;font-style:normal;font-display:swap;}");
var layoutContentOnlyPadding = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:1rem;padding-right:1rem;", (0,Theme.mq)("sm"), "{padding-left:2rem;padding-right:2rem;}", (0,Theme.mq)("xl"), "{padding-left:clamp(2rem,calc((100vw - 1220px) / 2),22rem);padding-right:clamp(2rem,calc((100vw - 1220px) / 2),22rem);}", (0,Theme.mq)("xxl"), "{padding-left:clamp(2rem,350px,22rem);padding-right:clamp(2rem,350px,22rem);}");
var layoutContentOnlyMargin = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:1rem;margin-right:1rem;", (0,Theme.mq)("sm"), "{margin-left:2rem;margin-right:2rem;}", (0,Theme.mq)("xl"), "{margin-left:clamp(2rem,calc((100vw - 1220px) / 2),22rem);margin-right:clamp(2rem,calc((100vw - 1220px) / 2),22rem);}", (0,Theme.mq)("xxl"), "{margin-left:clamp(2rem,350px,22rem);margin-right:clamp(2rem,350px,22rem);}");
var layoutContainerContent = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(layoutContentOnlyPadding, ";margin-left:-1rem;margin-right:-1rem;", (0,Theme.mq)("sm"), "{margin-left:-2rem;margin-right:-2rem;}", (0,Theme.mq)("xl"), "{margin-left:calc(max(2rem,min(calc((100vw - 1220px) / 2),22rem)) * -1);margin-right:calc(max(2rem,min(calc((100vw - 1220px) / 2),22rem)) * -1);}", (0,Theme.mq)("xxl"), "{margin-left:calc(max(2rem,min(350px,22rem)) * -1);margin-right:calc(max(2rem,min(350px,22rem)) * -1);}");


;// CONCATENATED MODULE: ../../frontend/shared/src/styles/index.ts
/* eslint-disable import/prefer-default-export */ 

var CLASS_MAP = {
    LAYOUT_CONTAINER: "layout-container",
    LAYOUT_CONTAINER_CONTENT: "layout-container-content",
    LAYOUT_CONTENT_ONLY_PADDING: "layout-content-only-padding",
    LAYOUT_CONTENT_ONLY_MARGIN: "layout-content-only-margin"
};


/***/ }),

/***/ 5253:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 3718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(195)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(4566)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(9788)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(199)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(5154)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(2784));
var _head = _interop_require_default(__webpack_require__(5913));
var _imageConfig = __webpack_require__(8113);
var _useIntersection = __webpack_require__(2030);
var _imageConfigContext = __webpack_require__(1);
var _utils = __webpack_require__(4750);
var _normalizeTrailingSlash = __webpack_require__(583);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 9296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4566)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(9178)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(5154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(9918);
var _addLocale = __webpack_require__(4400);
var _routerContext = __webpack_require__(3220);
var _appRouterContext = __webpack_require__(4069);
var _useIntersection = __webpack_require__(2030);
var _getDomainLocale = __webpack_require__(5253);
var _addBasePath = __webpack_require__(3952);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 2030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4566)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(9071);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 4069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 5805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(2060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 2060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(6941);
var useSyncExternalStore = ( true ? __webpack_require__(2784) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 7218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/error.js
var error = __webpack_require__(689);
// EXTERNAL MODULE: ../../node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(2174);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-43c6fea0.browser.esm.js + 1 modules
var emotion_element_43c6fea0_browser_esm = __webpack_require__(7216);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8165);
// EXTERNAL MODULE: ../../frontend/features/src/index.ts + 225 modules
var src = __webpack_require__(9484);
// EXTERNAL MODULE: ../../frontend/pages/src/index.ts + 57 modules
var pages_src = __webpack_require__(1269);
// EXTERNAL MODULE: ../../frontend/entities/src/index.ts + 176 modules
var entities_src = __webpack_require__(3631);
// EXTERNAL MODULE: ../../frontend/shared/src/index.ts + 26 modules
var shared_src = __webpack_require__(2775);
// EXTERNAL MODULE: ../../frontend/shared/src/_legacy/index.ts + 80 modules
var _legacy = __webpack_require__(6522);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
;// CONCATENATED MODULE: ./app/Context/clientContext.ts




var prependProtocol = function(url, protocol) {
    return "".concat(protocol || "https", "://").concat(url);
};
var makeBmClientContext = function(locale, document, param, brand) {
    var api = param.api, media = param.media, host = param.host;
    var path = (document === null || document === void 0 ? void 0 : document.path) || {
        current: "",
        alternatives: []
    };
    var ref = (0,_sliced_to_array/* default */.Z)(locale.split("-"), 2), languageFromLocale = ref[0], marketFromLocale = ref[1];
    return {
        host: {
            baseImageUrl: prependProtocol(media.imageHost.current),
            baseUrl: {
                current: prependProtocol(host.baseUrl.current),
                alternatives: Object.entries(host.baseUrl.alternatives).reduce(function(accumulated, param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _locale = _param[0], url = _param[1];
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulated), (0,_define_property/* default */.Z)({}, _locale, prependProtocol(url)));
                }, {})
            }
        },
        locale: {
            locale: locale,
            language: languageFromLocale,
            market: marketFromLocale !== null && marketFromLocale !== void 0 ? marketFromLocale : languageFromLocale.toUpperCase()
        },
        path: path,
        search: {
            baseUrl: prependProtocol(api.mietwagen.host)
        },
        infoline: {
            baseUrl: prependProtocol(api.mietwagen.host)
        },
        newsletter: {
            baseUrl: prependProtocol(api.mietwagen.host)
        },
        runtime: {
            account: {
                apiBaseUrl: prependProtocol(api.consumer.host, api.consumer.protocol),
                sessionBaseUrl: prependProtocol(host.baseUrl.current)
            },
            apiConfig: {
                host: api.mietwagen.host
            },
            brand: {
                brandName: brand.brandName,
                siteGroup: brand.siteGroup
            },
            consumerApiSettings: api.consumer,
            host: {
                hostName: host.baseUrl.current,
                imageHost: media.imageHost.current
            },
            language: languageFromLocale,
            locale: locale,
            market: marketFromLocale !== null && marketFromLocale !== void 0 ? marketFromLocale : languageFromLocale.toUpperCase(),
            page: {
                path: path.current
            }
        }
    };
};


// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(3102);
;// CONCATENATED MODULE: ./styles/themes/theme.ts


var theme = {
    color: {
        // brand colours
        primary: "#00977d",
        primary70: (0,polished_esm/* lighten */.$n)(0.04, "#00977d"),
        primary100: "#006e5b",
        primaryHighlight: "#cceae5",
        secondary100: "#222",
        secondaryHighlight: "#79b7ac",
        // natural colours
        natural100: "#000",
        natural70: "#ff4b19",
        natural50: "#cecece",
        natural40: "#666666",
        natural30: "#747474",
        natural20: "#eee",
        natural10: "#f8f8f8",
        natural0: "#fff",
        // notification colours
        info: "#3694ba",
        warning: "#ffa800",
        error: "#d63f24",
        success: "#75b21b"
    },
    gradient: {
        green: {
            from: "#0D8C76",
            to: "#06705F"
        },
        orange: {
            from: "#FF4B19",
            to: "#FF8664"
        },
        mint: {
            from: "#6EC2B7",
            to: "#4FBBAD"
        },
        brand: {
            from: "#FF4B19",
            via: "#E4A5A3",
            to: "#6CC2B6"
        }
    },
    fontFamily: {
        default: "'Source Sans Pro', ui-sans-serif, system-ui, sans-serif",
        alternate: "Quicksand, Bryant, 'Proxima Nova Soft', Arial Rounded MT Bold, sans-serif"
    },
    fontWeight: {
        body: "normal",
        heading: "bold"
    },
    fontSize: {
        xl: {
            size: "1.875rem",
            lineHeight: "1.2"
        },
        lg: {
            size: "1.375rem",
            lineHeight: "1.2"
        },
        md: {
            size: "1.125rem",
            lineHeight: "1.2"
        },
        sm: {
            size: "1rem",
            lineHeight: "1.5"
        },
        xs: {
            size: "0.875rem",
            lineHeight: "1.2"
        },
        xxs: {
            size: "0.625rem",
            lineHeight: "1.2"
        }
    },
    baseSize: "11px",
    spacing: {
        0: "0",
        5: "0.125rem",
        10: "0.25rem",
        20: "0.5rem",
        30: "0.75rem",
        40: "1rem",
        50: "1.5rem",
        60: "2rem",
        70: "2.5rem",
        80: "3rem",
        90: "4rem",
        100: "4.5rem",
        110: "6rem",
        120: "7rem",
        130: "8rem",
        140: "9rem",
        150: "10rem"
    },
    borderRadius: {
        none: "0",
        xxs: "0.125rem",
        xs: "0.25rem",
        sm: "0.5rem",
        md: "0.75rem",
        lg: "1.5rem"
    },
    boxShadow: {
        sm: "0 0.375rem 1.25rem rgb(0 0 0 / 6%)",
        md: "0 0.625rem 1.5rem rgb(0 0 0 / 8%)",
        lg: "0 0.625rem 2rem rgb(0 0 0 / 14%)"
    },
    backgroundImage: {
        // @see https://www.scien.cx/2021/11/10/adding-radial-gradients-to-tailwind-css/
        none: "none"
    },
    mq: shared_src/* Theme.mq */.Q2.mq
};


;// CONCATENATED MODULE: ./styles/themes/index.ts


;// CONCATENATED MODULE: ./pages/_app.tsx














var LandingPageApp = function(param) {
    var pageProps = param.pageProps, Component = param.Component;
    var props = pageProps;
    var brand = props.brand, document = props.document, i18n = props.i18n, locale = props.locale, page = props.page, products = props.products, settings = props.settings;
    if (props.error) {
        var ref, ref1;
        // eslint-disable-next-line no-console
        console.error("Something went wrong while rendering the page:", (ref = props.error.data.error) === null || ref === void 0 ? void 0 : ref.message);
        var ref2;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(error["default"], {
            statusCode: (ref2 = (ref1 = props.error.response) === null || ref1 === void 0 ? void 0 : ref1.status) !== null && ref2 !== void 0 ? ref2 : 400,
            title: props.error.message
        });
    }
    var onIntlError = function(error) {
        // prevent displaying `MISSING_MESSAGE` errors
        // for more info: https://github.com/amannn/next-intl/issues/32
        if (error.code !== next_intl_cjs_production_min.IntlErrorCode.MISSING_MESSAGE) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };
    var context = makeBmClientContext(locale, document.content, settings, brand);
    var defaultTimeZone = "Europe/Paris";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_intl_cjs_production_min.NextIntlProvider, {
        locale: locale,
        timeZone: defaultTimeZone,
        messages: i18n,
        onError: onIntlError,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* Context.ClientContextProvider */._y.ClientContextProvider, {
            value: context,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* SiteInfoProvider */.rq, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* LoginProvider */.md, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* DocumentLegacy.Head */.Xt.Fb, {
                            headComponent: (head_default()),
                            document: document.content
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(entities_src/* analytics.gtm.Script */.co.gtm.Script, {
                            id: settings.analytics.gtmId
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_element_43c6fea0_browser_esm.a, {
                            theme: theme,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
                                    styles: [
                                        shared_src/* Styles.Global.fonts */.z0.x.Rq
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_legacy/* StyleLegacy.CSSReset */.AK.m, {
                                    theme: theme
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pages_src/* SiteLegacy.BilligerMietwagenSite */.Z.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,_object_spread/* default */.Z)({}, page))
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* StructuredDataWidget */.Du, {
                            products: products,
                            page: page
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var _app = (LandingPageApp);


/***/ }),

/***/ 8398:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(176)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 176:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={815:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},577:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(815);e.encode=e.stringify=__nccwpck_require__(577)}();module.exports=n})();

/***/ }),

/***/ 5237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5805)


/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2918)


/***/ }),

/***/ 7729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5913)


/***/ }),

/***/ 6577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3718)


/***/ }),

/***/ 9097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9296)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3642)


/***/ }),

/***/ 5847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(747)


/***/ }),

/***/ 8344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(3421);
var setCookieParser = __webpack_require__(3897);
var utils_1 = __webpack_require__(3496);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3496:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 3102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cy": function() { return /* binding */ complement; },
  "_j": function() { return /* binding */ curriedDarken$1; },
  "vG": function() { return /* binding */ curriedDesaturate$1; },
  "$n": function() { return /* binding */ curriedLighten$1; },
  "p_": function() { return /* binding */ curriedSaturate$1; },
  "nV": function() { return /* binding */ curriedTint$1; },
  "DZ": function() { return /* binding */ curriedTransparentize$1; }
});

// UNUSED EXPORTS: adjustHue, animation, backgroundImages, backgrounds, between, border, borderColor, borderRadius, borderStyle, borderWidth, buttons, clearFix, cover, cssVar, directionalProperty, easeIn, easeInOut, easeOut, ellipsis, em, fluidRange, fontFace, getContrast, getLuminance, getValueAndUnit, grayscale, hiDPI, hideText, hideVisually, hsl, hslToColorString, hsla, important, invert, linearGradient, margin, math, meetsContrastGuidelines, mix, modularScale, normalize, opacify, padding, parseToHsl, parseToRgb, position, radialGradient, readableColor, rem, remToPx, retinaImage, rgb, rgbToColorString, rgba, setHue, setLightness, setSaturation, shade, size, stripUnit, textInputs, timingFunctions, toColorString, transitions, triangle, wordWrap

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ../../node_modules/polished/dist/polished.esm.js






function last() {
  var _ref;
  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function negation(a) {
  return -a;
}
function addition(a, b) {
  return a + b;
}
function subtraction(a, b) {
  return a - b;
}
function multiplication(a, b) {
  return a * b;
}
function division(a, b) {
  return a / b;
}
function max() {
  return Math.max.apply(Math, arguments);
}
function min() {
  return Math.min.apply(Math, arguments);
}
function comma() {
  return Array.of.apply(Array, arguments);
}
var defaultSymbols = {
  symbols: {
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    }
  }
};
var defaultSymbolMap = (/* unused pure expression or super */ null && (defaultSymbols));

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};

/**
 * super basic version of sprintf
 * @private
 */
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */
var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);
  function PolishedError(code) {
    var _this;
    if (true) {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else { var _len2, args, _key2; }
    return _assertThisInitialized(_this);
  }
  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;

// Merges additional math functionality into the defaults.
function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? _extends({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : _extends({}, defaultSymbolMap.symbols);
  return symbolMap;
}
function exec(operators, values) {
  var _ref;
  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}
function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp( // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" +
  // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  })
  // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  })
  // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;
  do {
    match = pattern.exec(expression);
    var _ref2 = match || [')', undefined],
      token = _ref2[0],
      bad = _ref2[1];
    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;

    // Check for syntax errors:
    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }
    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;
      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
        // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function
      afterValue = curr.notation === 'postfix';
      if (curr.symbol !== ')') {
        operators.push(curr);
        // Postfix always has precedence over any operator that follows after it
        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);
      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);
        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);
  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}
function reverseString(str) {
  return str.split('').reverse().join('');
}

/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */
function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp);

  // Check that all units are the same
  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }
  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}

var cssVariableRegex = /--[\S]*/g;

/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */
function cssVar(cssVariable, defaultValue) {
  if (!cssVariable || !cssVariable.match(cssVariableRegex)) {
    throw new PolishedError(73);
  }
  var variableValue;

  /* eslint-disable */
  /* istanbul ignore next */
  if (typeof document !== 'undefined' && document.documentElement !== null) {
    variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
  }
  /* eslint-enable */

  if (variableValue) {
    return variableValue.trim();
  } else if (defaultValue) {
    return defaultValue;
  }
  throw new PolishedError(74);
}

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap$1 = (/* unused pure expression or super */ null && (['Top', 'Right', 'Bottom', 'Left']));
function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}
function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap$1[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  //  prettier-ignore
  var firstValue = values[0],
    _values$ = values[1],
    secondValue = _values$ === void 0 ? firstValue : _values$,
    _values$2 = values[2],
    thirdValue = _values$2 === void 0 ? firstValue : _values$2,
    _values$3 = values[3],
    fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

/**
 * Check if a string ends with something
 * @private
 */
function endsWith(string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

var cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value) {
  if (typeof value !== 'string') return value;
  var matchedValue = value.match(cssRegex$1);
  return matchedValue ? parseFloat(value) : value;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }
    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }
      newPxval = stripUnit(pxval);
    }
    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }
      newBase = stripUnit(base);
    }
    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }
    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }
    return "" + newPxval / newBase + to;
  };
};
var pixelsto = pxtoFactory;

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */
var em = pixelsto('em');
var em$1 = (/* unused pure expression or super */ null && (em));

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */
function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */
function important(styleBlock, rules) {
  if (typeof styleBlock !== 'object' || styleBlock === null) {
    throw new PolishedError(75, typeof styleBlock);
  }
  var newStyleBlock = {};
  Object.keys(styleBlock).forEach(function (key) {
    if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) {
      newStyleBlock[key] = important(styleBlock[key], rules);
    } else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) {
      newStyleBlock[key] = styleBlock[key] + " !important";
    } else {
      newStyleBlock[key] = styleBlock[key];
    }
  });
  return newStyleBlock;
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};
function getRatio(ratioName) {
  return ratioNames[ratioName];
}

/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */
function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }
  if (ratio === void 0) {
    ratio = 1.333;
  }
  if (typeof steps !== 'number') {
    throw new PolishedError(42);
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new PolishedError(43);
  }
  var _ref = typeof base === 'string' ? getValueAndUnit(base) : [base, ''],
    realBase = _ref[0],
    unit = _ref[1];
  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;
  if (typeof realBase === 'string') {
    throw new PolishedError(44, base);
  }
  return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */
var rem = pixelsto('rem');
var rem$1 = (/* unused pure expression or super */ null && (rem));

var defaultFontSize = 16;
function convertBase(base) {
  var deconstructedValue = getValueAndUnit(base);
  if (deconstructedValue[1] === 'px') {
    return parseFloat(base);
  }
  if (deconstructedValue[1] === '%') {
    return parseFloat(base) / 100 * defaultFontSize;
  }
  throw new PolishedError(78, deconstructedValue[1]);
}
function getBaseFromDoc() {
  /* eslint-disable */
  /* istanbul ignore next */
  if (typeof document !== 'undefined' && document.documentElement !== null) {
    var rootFontSize = getComputedStyle(document.documentElement).fontSize;
    return rootFontSize ? convertBase(rootFontSize) : defaultFontSize;
  }
  /* eslint-enable */
  /* istanbul ignore next */
  return defaultFontSize;
}

/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */
function remToPx(value, base) {
  var deconstructedValue = getValueAndUnit(value);
  if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') {
    throw new PolishedError(77, deconstructedValue[1]);
  }
  var newBase = base ? convertBase(base) : getBaseFromDoc();
  return deconstructedValue[0] * newBase + "px";
}

var functionsMap$3 = {
  back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};

/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */
function easeIn(functionName) {
  return functionsMap$3[functionName.toLowerCase().trim()];
}

var functionsMap$2 = {
  back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};

/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */
function easeInOut(functionName) {
  return functionsMap$2[functionName.toLowerCase().trim()];
}

var functionsMap$1 = {
  back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};

/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */
function easeOut(functionName) {
  return functionsMap$1[functionName.toLowerCase().trim()];
}

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */
function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }
  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }
  var _getValueAndUnit = getValueAndUnit(fromSize),
    unitlessFromSize = _getValueAndUnit[0],
    fromSizeUnit = _getValueAndUnit[1];
  var _getValueAndUnit2 = getValueAndUnit(toSize),
    unitlessToSize = _getValueAndUnit2[0],
    toSizeUnit = _getValueAndUnit2[1];
  var _getValueAndUnit3 = getValueAndUnit(minScreen),
    unitlessMinScreen = _getValueAndUnit3[0],
    minScreenUnit = _getValueAndUnit3[1];
  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
    unitlessMaxScreen = _getValueAndUnit4[0],
    maxScreenUnit = _getValueAndUnit4[1];
  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new PolishedError(47);
  }
  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) {
    throw new PolishedError(48);
  }
  if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) {
    throw new PolishedError(76);
  }
  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;
  if (parent === void 0) {
    parent = '&';
  }
  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }
  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width, lines) {
  if (lines === void 0) {
    lines = 1;
  }
  var styles = {
    display: 'inline-block',
    maxWidth: width || '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
  return lines > 1 ? _extends({}, styles, {
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    display: '-webkit-box',
    whiteSpace: 'normal'
  }) : styles;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }
  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }
  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new PolishedError(49);
  }
  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};
    for (var _iterator = _createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;) {
      var _extends2, _extends3;
      var obj = _step.value;
      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new PolishedError(50);
      }
      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }
    return _extends({}, fallbacks, mediaQueries);
  } else {
    var _ref, _ref2, _ref3;
    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new PolishedError(51);
    }
    return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
  }
}

var dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var formatHintMap = {
  woff: 'woff',
  woff2: 'woff2',
  ttf: 'truetype',
  otf: 'opentype',
  eot: 'embedded-opentype',
  svg: 'svg',
  svgz: 'svg'
};
function generateFormatHint(format, formatHint) {
  if (!formatHint) return '';
  return " format(\"" + formatHintMap[format] + "\")";
}
function isDataURI(fontFilePath) {
  return !!fontFilePath.replace(/\s+/g, ' ').match(dataURIRegex);
}
function generateFileReferences(fontFilePath, fileFormats, formatHint) {
  if (isDataURI(fontFilePath)) {
    return "url(\"" + fontFilePath + "\")" + generateFormatHint(fileFormats[0], formatHint);
  }
  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")" + generateFormatHint(format, formatHint);
  });
  return fileFontReferences.join(', ');
}
function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}
function generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats, formatHint));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */

function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
    fontFilePath = _ref.fontFilePath,
    fontStretch = _ref.fontStretch,
    fontStyle = _ref.fontStyle,
    fontVariant = _ref.fontVariant,
    fontWeight = _ref.fontWeight,
    _ref$fileFormats = _ref.fileFormats,
    fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
    _ref$formatHint = _ref.formatHint,
    formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint,
    _ref$localFonts = _ref.localFonts,
    localFonts = _ref$localFonts === void 0 ? [fontFamily] : _ref$localFonts,
    unicodeRange = _ref.unicodeRange,
    fontDisplay = _ref.fontDisplay,
    fontVariationSettings = _ref.fontVariationSettings,
    fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new PolishedError(55);
  if (!fontFilePath && !localFonts) {
    throw new PolishedError(52);
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new PolishedError(53);
  }
  if (!Array.isArray(fileFormats)) {
    throw new PolishedError(54);
  }
  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats, formatHint),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    }
  };

  // Removes undefined fields for cleaner css object.
  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }
  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

function constructGradientValue(literals) {
  var template = '';
  for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    substitutions[_key - 1] = arguments[_key];
  }
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    if (i === substitutions.length - 1 && substitutions[i]) {
      var definedValues = substitutions.filter(function (substitute) {
        return !!substitute;
      });
      // Adds leading coma if properties preceed color-stops
      if (definedValues.length > 1) {
        template = template.slice(0, -1);
        template += ", " + substitutions[i];
        // No trailing space if color-stops is the only param provided
      } else if (definedValues.length === 1) {
        template += "" + substitutions[i];
      }
    } else if (substitutions[i]) {
      template += substitutions[i] + " ";
    }
  }
  return template.trim();
}

var _templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function linearGradient(_ref) {
  var colorStops = _ref.colorStops,
    fallback = _ref.fallback,
    _ref$toDirection = _ref.toDirection,
    toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(56);
  }
  return {
    backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
    backgroundImage: constructGradientValue(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["linear-gradient(", "", ")"])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
  };
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;
  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    main: {
      display: 'block'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

var _templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
    _ref$extent = _ref.extent,
    extent = _ref$extent === void 0 ? '' : _ref$extent,
    fallback = _ref.fallback,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? '' : _ref$position,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? '' : _ref$shape;
  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(57);
  }
  return {
    backgroundColor: fallback || colorStops[0].split(' ')[0],
    backgroundImage: constructGradientValue(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["radial-gradient(", "", "", "", ")"])), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;
  if (extension === void 0) {
    extension = 'png';
  }
  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }
  if (!filename) {
    throw new PolishedError(58);
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = _extends({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}

/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */

function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  var fullWidth = "" + width[0] + (width[1] || '');
  var halfWidth = "" + width[0] / 2 + (width[1] || '');
  var fullHeight = "" + height[0] + (height[1] || '');
  var halfHeight = "" + height[0] / 2 + (height[1] || '');
  switch (pointingDirection) {
    case 'top':
      return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
    case 'topLeft':
      return fullWidth + " " + fullHeight + " 0 0";
    case 'left':
      return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
    case 'bottomLeft':
      return fullWidth + " 0 0 " + fullHeight;
    case 'bottom':
      return fullHeight + " " + halfWidth + " 0 " + halfWidth;
    case 'bottomRight':
      return "0 0 " + fullWidth + " " + fullHeight;
    case 'right':
      return halfHeight + " 0 " + halfHeight + " " + fullWidth;
    case 'topRight':
    default:
      return "0 " + fullWidth + " " + fullHeight + " 0";
  }
};
var getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
  switch (pointingDirection) {
    case 'top':
    case 'bottomRight':
      return {
        borderBottomColor: foregroundColor
      };
    case 'right':
    case 'bottomLeft':
      return {
        borderLeftColor: foregroundColor
      };
    case 'bottom':
    case 'topLeft':
      return {
        borderTopColor: foregroundColor
      };
    case 'left':
    case 'topRight':
      return {
        borderRightColor: foregroundColor
      };
    default:
      throw new PolishedError(59);
  }
};

/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */
function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
    height = _ref.height,
    width = _ref.width,
    foregroundColor = _ref.foregroundColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = getValueAndUnit(width);
  var heightAndUnit = getValueAndUnit(height);
  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new PolishedError(60);
  }
  return _extends({
    width: '0',
    height: '0',
    borderColor: backgroundColor
  }, getBorderColor(pointingDirection, foregroundColor), {
    borderStyle: 'solid',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
  });
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }
  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};

/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */
function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    hue: hslColor.hue + parseFloat(degree)
  }));
}

// prettier-ignore
var curriedAdjustHue = curry /* ::<number | string, string, string> */(adjustHue);
var curriedAdjustHue$1 = (/* unused pure expression or super */ null && (curriedAdjustHue));

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}

// prettier-ignore
var curriedDarken = curry /* ::<number | string, string, string> */(darken);
var curriedDarken$1 = curriedDarken;

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
}

// prettier-ignore
var curriedDesaturate = curry /* ::<number | string, string, string> */(desaturate);
var curriedDesaturate$1 = curriedDesaturate;

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  if (color === 'transparent') return 0;
  var rgbColor = parseToRgb(color);
  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
      var channel = rgbColor[key] / 255;
      return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }),
    r = _Object$keys$map[0],
    g = _Object$keys$map[1],
    b = _Object$keys$map[2];
  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */
function getContrast(color1, color2) {
  var luminance1 = getLuminance(color1);
  var luminance2 = getLuminance(color2);
  return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */
function hslToColorString(color) {
  if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
    if (color.alpha && typeof color.alpha === 'number') {
      return hsla({
        hue: color.hue,
        saturation: color.saturation,
        lightness: color.lightness,
        alpha: color.alpha
      });
    }
    return hsl({
      hue: color.hue,
      saturation: color.saturation,
      lightness: color.lightness
    });
  }
  throw new PolishedError(45);
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  if (color === 'transparent') return color;
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}

// prettier-ignore
var curriedLighten = curry /* ::<number | string, string, string> */(lighten);
var curriedLighten$1 = curriedLighten;

/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */
function meetsContrastGuidelines(color1, color2) {
  var contrastRatio = getContrast(color1, color2);
  return {
    AA: contrastRatio >= 4.5,
    AALarge: contrastRatio >= 3,
    AAA: contrastRatio >= 7,
    AAALarge: contrastRatio >= 4.5
  };
}

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);
  var color1 = (0,esm_extends/* default */.Z)({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });
  var parsedColor2 = parseToRgb(otherColor);
  var color2 = (0,esm_extends/* default */.Z)({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  });

  // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
}

// prettier-ignore
var curriedMix = curry /* ::<number | string, string, string, string> */(mix);
var mix$1 = curriedMix;

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = (0,esm_extends/* default */.Z)({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

// prettier-ignore
var curriedOpacify = curry /* ::<number | string, string, string> */(opacify);
var curriedOpacify$1 = (/* unused pure expression or super */ null && (curriedOpacify));

var defaultReturnIfLightColor = '#000';
var defaultReturnIfDarkColor = '#fff';

/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */
function readableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
  if (returnIfLightColor === void 0) {
    returnIfLightColor = defaultReturnIfLightColor;
  }
  if (returnIfDarkColor === void 0) {
    returnIfDarkColor = defaultReturnIfDarkColor;
  }
  if (strict === void 0) {
    strict = true;
  }
  var isColorLight = getLuminance(color) > 0.179;
  var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
  if (!strict || getContrast(color, preferredReturnColor) >= 4.5) {
    return preferredReturnColor;
  }
  return isColorLight ? defaultReturnIfLightColor : defaultReturnIfDarkColor;
}

/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */
function rgbToColorString(color) {
  if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
    if (typeof color.alpha === 'number') {
      return rgba({
        red: color.red,
        green: color.green,
        blue: color.blue,
        alpha: color.alpha
      });
    }
    return rgb({
      red: color.red,
      green: color.green,
      blue: color.blue
    });
  }
  throw new PolishedError(46);
}

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
}

// prettier-ignore
var curriedSaturate = curry /* ::<number | string, string, string> */(saturate);
var curriedSaturate$1 = curriedSaturate;

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  if (color === 'transparent') return color;
  return toColorString((0,esm_extends/* default */.Z)({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
}

// prettier-ignore
var curriedSetHue = curry /* ::<number | string, string, string> */(setHue);
var curriedSetHue$1 = (/* unused pure expression or super */ null && (curriedSetHue));

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  if (color === 'transparent') return color;
  return toColorString((0,esm_extends/* default */.Z)({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
}

// prettier-ignore
var curriedSetLightness = curry /* ::<number | string, string, string> */(setLightness);
var curriedSetLightness$1 = (/* unused pure expression or super */ null && (curriedSetLightness));

/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  if (color === 'transparent') return color;
  return toColorString((0,esm_extends/* default */.Z)({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
}

// prettier-ignore
var curriedSetSaturation = curry /* ::<number | string, string, string> */(setSaturation);
var curriedSetSaturation$1 = (/* unused pure expression or super */ null && (curriedSetSaturation));

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}

// prettier-ignore
var curriedShade = curry /* ::<number | string, string, string> */(shade);
var curriedShade$1 = (/* unused pure expression or super */ null && (curriedShade));

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}

// prettier-ignore
var curriedTint = curry /* ::<number | string, string, string> */(tint);
var curriedTint$1 = curriedTint;

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = (0,esm_extends/* default */.Z)({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
}

// prettier-ignore
var curriedTransparentize = curry /* ::<number | string, string, string> */(transparentize);
var curriedTransparentize$1 = curriedTransparentize;

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new PolishedError(64);
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new PolishedError(65);
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new PolishedError(66);
    }
    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }
  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }
  return {
    background: properties.join(', ')
  };
}

var sideMap = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));

/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;
    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new PolishedError(62);
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;
    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }
  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;
    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }
  throw new PolishedError(63);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */
function statefulSelectors(states, template, stateMap) {
  if (!template) throw new PolishedError(67);
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new PolishedError(68);
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

var stateMap$1 = (/* unused pure expression or super */ null && ([undefined, null, 'active', 'focus', 'hover']));
function template$1(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */
function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }
  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap = (/* unused pure expression or super */ null && (['absolute', 'fixed', 'relative', 'static', 'sticky']));

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */
function position(firstValue) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  if (positionMap.indexOf(firstValue) >= 0 && firstValue) {
    return _extends({}, directionalProperty.apply(void 0, [''].concat(values)), {
      position: firstValue
    });
  } else {
    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }
  return {
    height: height,
    width: width
  };
}

var stateMap = (/* unused pure expression or super */ null && ([undefined, null, 'active', 'focus', 'hover']));
function template(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */
function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }
  return statefulSelectors(states, template, stateMap);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */
function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }
  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];
    if (typeof value !== 'string') {
      throw new PolishedError(61);
    }
    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}




/***/ }),

/***/ 4406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 3412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_W": function() { return /* binding */ DayPicker; },
  "kD": function() { return /* binding */ useDayPicker; }
});

// UNUSED EXPORTS: Button, Caption, CaptionDropdowns, CaptionLabel, CaptionNavigation, Day, DayContent, DayPickerContext, DayPickerProvider, Dropdown, FocusContext, FocusProvider, Footer, Head, HeadRow, IconDropdown, IconLeft, IconRight, InternalModifier, Months, NavigationContext, NavigationProvider, RootProvider, Row, SelectMultipleContext, SelectMultipleProvider, SelectMultipleProviderInternal, SelectRangeContext, SelectRangeProvider, SelectRangeProviderInternal, SelectSingleContext, SelectSingleProvider, SelectSingleProviderInternal, WeekNumber, addToRange, isDateAfterType, isDateBeforeType, isDateInterval, isDateRange, isDayOfWeekType, isDayPickerDefault, isDayPickerMultiple, isDayPickerRange, isDayPickerSingle, isMatch, useActiveModifiers, useDayRender, useFocusContext, useInput, useNavigation, useSelectMultiple, useSelectRange, useSelectSingle

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 6 modules
var date_fns_format = __webpack_require__(6569);
// EXTERNAL MODULE: ../../node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(729);
;// CONCATENATED MODULE: ../../node_modules/date-fns/startOfMonth.mjs


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfMonth = ((/* unused pure expression or super */ null && (startOfMonth)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/endOfMonth.mjs


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_endOfMonth = ((/* unused pure expression or super */ null && (endOfMonth)));

// EXTERNAL MODULE: ../../node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(8106);
;// CONCATENATED MODULE: ../../node_modules/date-fns/isSameYear.mjs


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dateLeft, dateRight) {
  const _dateLeft = (0,toDate/* toDate */.Q)(dateLeft);
  const _dateRight = (0,toDate/* toDate */.Q)(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameYear = ((/* unused pure expression or super */ null && (isSameYear)));

// EXTERNAL MODULE: ../../node_modules/date-fns/constructFrom.mjs
var constructFrom = __webpack_require__(5873);
;// CONCATENATED MODULE: ../../node_modules/date-fns/getDaysInMonth.mjs



/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = (0,constructFrom/* constructFrom */.L)(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getDaysInMonth = ((/* unused pure expression or super */ null && (getDaysInMonth)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/setMonth.mjs




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month of the new date
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const dateWithDesiredMonth = (0,constructFrom/* constructFrom */.L)(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_setMonth = ((/* unused pure expression or super */ null && (setMonth)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/setYear.mjs



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year) {
  const _date = (0,toDate/* toDate */.Q)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0,constructFrom/* constructFrom */.L)(date, NaN);
  }

  _date.setFullYear(year);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_setYear = ((/* unused pure expression or super */ null && (setYear)));

// EXTERNAL MODULE: ../../node_modules/date-fns/startOfYear.mjs
var startOfYear = __webpack_require__(2978);
;// CONCATENATED MODULE: ../../node_modules/date-fns/differenceInCalendarMonths.mjs


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = (0,toDate/* toDate */.Q)(dateLeft);
  const _dateRight = (0,toDate/* toDate */.Q)(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();

  return yearDiff * 12 + monthDiff;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_differenceInCalendarMonths = ((/* unused pure expression or super */ null && (differenceInCalendarMonths)));

// EXTERNAL MODULE: ../../node_modules/date-fns/addMonths.mjs
var addMonths = __webpack_require__(7617);
;// CONCATENATED MODULE: ../../node_modules/date-fns/isSameMonth.mjs


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = (0,toDate/* toDate */.Q)(dateLeft);
  const _dateRight = (0,toDate/* toDate */.Q)(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameMonth = ((/* unused pure expression or super */ null && (isSameMonth)));

// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(1502);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfISOWeek.mjs
var startOfISOWeek = __webpack_require__(9001);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfWeek.mjs
var startOfWeek = __webpack_require__(2014);
// EXTERNAL MODULE: ../../node_modules/date-fns/addDays.mjs
var addDays = __webpack_require__(8016);
;// CONCATENATED MODULE: ../../node_modules/date-fns/isSameDay.mjs


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = (0,startOfDay/* startOfDay */.b)(dateLeft);
  const dateRightStartOfDay = (0,startOfDay/* startOfDay */.b)(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameDay = ((/* unused pure expression or super */ null && (isSameDay)));

// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(1461);
;// CONCATENATED MODULE: ../../node_modules/date-fns/subDays.mjs


/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return (0,addDays/* addDays */.E)(date, -amount);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_subDays = ((/* unused pure expression or super */ null && (subDays)));

// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInCalendarDays.mjs
var date_fns_differenceInCalendarDays = __webpack_require__(9219);
// EXTERNAL MODULE: ../../node_modules/date-fns/isDate.mjs
var isDate = __webpack_require__(5890);
;// CONCATENATED MODULE: ../../node_modules/date-fns/addWeeks.mjs


/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return (0,addDays/* addDays */.E)(date, days);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addWeeks = ((/* unused pure expression or super */ null && (addWeeks)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/addYears.mjs


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return (0,addMonths/* addMonths */.z)(date, amount * 12);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_addYears = ((/* unused pure expression or super */ null && (addYears)));

// EXTERNAL MODULE: ../../node_modules/date-fns/_lib/defaultOptions.mjs
var _lib_defaultOptions = __webpack_require__(3066);
;// CONCATENATED MODULE: ../../node_modules/date-fns/endOfWeek.mjs



/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0,toDate/* toDate */.Q)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_endOfWeek = ((/* unused pure expression or super */ null && (endOfWeek)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/endOfISOWeek.mjs


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(date) {
  return endOfWeek(date, { weekStartsOn: 1 });
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_endOfISOWeek = ((/* unused pure expression or super */ null && (endOfISOWeek)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/max.mjs


/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dates) {
  let result;
  dates.forEach(function (dirtyDate) {
    const currentDate = (0,toDate/* toDate */.Q)(dirtyDate);

    if (
      result === undefined ||
      result < currentDate ||
      isNaN(Number(currentDate))
    ) {
      result = currentDate;
    }
  });

  return result || new Date(NaN);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_max = ((/* unused pure expression or super */ null && (max)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/min.mjs


/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dates) {
  let result;

  dates.forEach((dirtyDate) => {
    const date = (0,toDate/* toDate */.Q)(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });

  return result || new Date(NaN);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_min = ((/* unused pure expression or super */ null && (min)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/getUnixTime.mjs


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(date) {
  return Math.trunc(+(0,toDate/* toDate */.Q)(date) / 1000);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getUnixTime = ((/* unused pure expression or super */ null && (getUnixTime)));

// EXTERNAL MODULE: ../../node_modules/date-fns/getISOWeek.mjs + 1 modules
var getISOWeek = __webpack_require__(8105);
// EXTERNAL MODULE: ../../node_modules/date-fns/getWeek.mjs + 1 modules
var getWeek = __webpack_require__(8766);
// EXTERNAL MODULE: ../../node_modules/date-fns/constants.mjs
var constants = __webpack_require__(1418);
// EXTERNAL MODULE: ../../node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.mjs
var getTimezoneOffsetInMilliseconds = __webpack_require__(7796);
;// CONCATENATED MODULE: ../../node_modules/date-fns/differenceInCalendarWeeks.mjs




/**
 * The {@link differenceInCalendarWeeks} function options.
 */

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
  const startOfWeekLeft = (0,startOfWeek/* startOfWeek */.z)(dateLeft, options);
  const startOfWeekRight = (0,startOfWeek/* startOfWeek */.z)(dateRight, options);

  const timestampLeft =
    +startOfWeekLeft - (0,getTimezoneOffsetInMilliseconds/* getTimezoneOffsetInMilliseconds */.D)(startOfWeekLeft);
  const timestampRight =
    +startOfWeekRight - (0,getTimezoneOffsetInMilliseconds/* getTimezoneOffsetInMilliseconds */.D)(startOfWeekRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a days is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / constants/* millisecondsInWeek */.jE);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_differenceInCalendarWeeks = ((/* unused pure expression or super */ null && (differenceInCalendarWeeks)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/lastDayOfMonth.mjs


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_lastDayOfMonth = ((/* unused pure expression or super */ null && (lastDayOfMonth)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/getWeeksInMonth.mjs




/**
 * The {@link getWeeksInMonth} function options.
 */

/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  return (
    differenceInCalendarWeeks(
      lastDayOfMonth(date),
      startOfMonth(date),
      options,
    ) + 1
  );
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeeksInMonth = ((/* unused pure expression or super */ null && (getWeeksInMonth)));

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/en-US.mjs + 5 modules
var en_US = __webpack_require__(6198);
;// CONCATENATED MODULE: ../../node_modules/react-day-picker/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (false) {}
	return reactJsxRuntime_development;
}

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=react,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

if (true) {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {}

var jsxRuntimeExports = jsxRuntime.exports;

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return (0,date_fns_format/* format */.WU)(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return (0,date_fns_format/* format */.WU)(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return (0,date_fns_format/* format */.WU)(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return (0,date_fns_format/* format */.WU)(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return (0,date_fns_format/* format */.WU)(year, 'yyyy', options);
}

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return (0,date_fns_format/* format */.WU)(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return (0,date_fns_format/* format */.WU)(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = en_US/* enUS */._;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? (0,startOfDay/* startOfDay */.b)(fromDate) : undefined,
        toDate: toDate ? (0,startOfDay/* startOfDay */.b)(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = (0,react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (jsxRuntimeExports.jsx(DayPickerContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = (0,react.useContext)(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (jsxRuntimeExports.jsx("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id, children: formatCaption(props.displayMonth, { locale: locale }) }));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (jsxRuntimeExports.jsxs("div", { className: className, style: style, children: [jsxRuntimeExports.jsx("span", { className: dayPicker.classNames.vhidden, children: props['aria-label'] }), jsxRuntimeExports.jsx("select", { name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange, children: children }), jsxRuntimeExports.jsxs("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true", children: [caption, jsxRuntimeExports.jsx(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon })] })] }));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    if (!toDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    var dropdownMonths = [];
    if (isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntimeExports.jsx(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }), children: dropdownMonths.map(function (m) { return (jsxRuntimeExports.jsx("option", { value: m.getMonth(), children: formatMonthCaption(m, { locale: locale }) }, m.getMonth())); }) }));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    if (!toDate)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(setYear((0,startOfYear/* startOfYear */.e)(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = setYear(startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntimeExports.jsx(DropdownComponent, { name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }), children: years.map(function (year) { return (jsxRuntimeExports.jsx("option", { value: year.getFullYear(), children: formatYearCaption(year, { locale: locale }) }, year.getFullYear())); }) }));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = (0,react.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0,addMonths/* addMonths */.z)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = startOfMonth(month);
    var end = startOfMonth((0,addMonths/* addMonths */.z)(start, numberOfMonths));
    var monthsDiff = differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = (0,addMonths/* addMonths */.z)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!toDate) {
        return (0,addMonths/* addMonths */.z)(month, offset);
    }
    var monthsDiff = differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return (0,addMonths/* addMonths */.z)(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!fromDate) {
        return (0,addMonths/* addMonths */.z)(month, -offset);
    }
    var monthsDiff = differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return (0,addMonths/* addMonths */.z)(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && (0,isBefore/* isBefore */.R)(date, refDate)) {
            goToMonth((0,addMonths/* addMonths */.z)(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (jsxRuntimeExports.jsx(NavigationContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = (0,react.useContext)(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth((0,addMonths/* addMonths */.z)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (jsxRuntimeExports.jsxs("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns, children: [jsxRuntimeExports.jsx("div", { className: classNames.vhidden, children: captionLabel }), jsxRuntimeExports.jsx(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }), jsxRuntimeExports.jsx(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })] }));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (jsxRuntimeExports.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntimeExports.jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) })));
}

/** Render a button HTML element applying the reset class name. */
var Button = (0,react.forwardRef)(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (jsxRuntimeExports.jsx("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (jsxRuntimeExports.jsxs("div", { className: classNames.nav, style: styles.nav, children: [!props.hidePrevious && (jsxRuntimeExports.jsx(Button, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick, children: dir === 'rtl' ? (jsxRuntimeExports.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntimeExports.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) })), !props.hideNext && (jsxRuntimeExports.jsx(Button, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick, children: dir === 'rtl' ? (jsxRuntimeExports.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntimeExports.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) }))] }));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (jsxRuntimeExports.jsx(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (jsxRuntimeExports.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id }), jsxRuntimeExports.jsx(CaptionNavigation, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id })] }));
    }
    else {
        caption = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntimeExports.jsx(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })] }));
    }
    return (jsxRuntimeExports.jsx("div", { className: classNames.caption, style: styles.caption, children: caption }));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    return (jsxRuntimeExports.jsx("tfoot", { className: tfoot, style: styles.tfoot, children: jsxRuntimeExports.jsx("tr", { children: jsxRuntimeExports.jsx("td", { colSpan: 8, children: footer }) }) }));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? (0,startOfISOWeek/* startOfISOWeek */.T)(new Date())
        : (0,startOfWeek/* startOfWeek */.z)(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = (0,addDays/* addDays */.E)(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (jsxRuntimeExports.jsxs("tr", { style: styles.head_row, className: classNames.head_row, children: [showWeekNumber && (jsxRuntimeExports.jsx("td", { style: styles.head_cell, className: classNames.head_cell })), weekdays.map(function (weekday, i) { return (jsxRuntimeExports.jsx("th", { scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }), children: formatWeekdayName(weekday, { locale: locale }) }, i)); })] }));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (jsxRuntimeExports.jsx("thead", { style: styles.head, className: classNames.head, children: jsxRuntimeExports.jsx(HeadRowComponent, {}) }));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: formatDay(props.date, { locale: locale }) });
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (jsxRuntimeExports.jsx(SelectMultipleContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntimeExports.jsx(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (jsxRuntimeExports.jsx(SelectMultipleContext.Provider, { value: contextValue, children: children }));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = (0,react.useContext)(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if (isSameDay(to, day) && isSameDay(from, day)) {
            return undefined;
        }
        if (isSameDay(to, day)) {
            return { from: to, to: undefined };
        }
        if (isSameDay(from, day)) {
            return undefined;
        }
        if ((0,isAfter/* isAfter */.A)(from, day)) {
            return { from: day, to: to };
        }
        return { from: from, to: day };
    }
    if (to) {
        if ((0,isAfter/* isAfter */.A)(day, to)) {
            return { from: to, to: day };
        }
        return { from: day, to: to };
    }
    if (from) {
        if ((0,isBefore/* isBefore */.R)(day, from)) {
            return { from: day, to: from };
        }
        return { from: from, to: day };
    }
    return { from: day, to: undefined };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (jsxRuntimeExports.jsx(SelectRangeContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntimeExports.jsx(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    else if (selectedTo) {
        modifiers.range_start = [selectedTo];
        modifiers.range_end = [selectedTo];
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedFrom, min - 1),
                before: (0,addDays/* addDays */.E)(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: (0,addDays/* addDays */.E)(selectedFrom, min - 1)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: subDays(selectedTo, min - 1),
                before: (0,addDays/* addDays */.E)(selectedTo, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0,addDays/* addDays */.E)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0,addDays/* addDays */.E)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: subDays(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0,addDays/* addDays */.E)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0,addDays/* addDays */.E)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0,addDays/* addDays */.E)(selectedTo, max - 1)
            });
        }
    }
    return (jsxRuntimeExports.jsx(SelectRangeContext.Provider, { value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers }, children: children }));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = (0,react.useContext)(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
var InternalModifier;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));

var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = (0,react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (jsxRuntimeExports.jsx(ModifiersContext.Provider, { value: modifiers, children: props.children }));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = (0,react.useContext)(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(to, from) < 0;
        if (isRangeInverted) {
            _a = [to, from], from = _a[0], to = _a[1];
        }
        var isInRange = (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(date, from) >= 0 &&
            (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(to, date) >= 0;
        return isInRange;
    }
    if (to) {
        return isSameDay(to, date);
    }
    if (from) {
        return isSameDay(from, date);
    }
    return false;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return (0,isDate/* isDate */.J)(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate/* isDate */.J);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(matcher.before, day);
            var diffAfter = (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0,isAfter/* isAfter */.A)(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = startOfMonth(displayMonths[0]);
    var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0,addDays/* addDays */.E)(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = (0,addDays/* addDays */.E)(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: addDays/* addDays */.E,
        week: addWeeks,
        month: addMonths/* addMonths */.z,
        year: addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? (0,startOfISOWeek/* startOfISOWeek */.T)(date)
                : (0,startOfWeek/* startOfWeek */.z)(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? endOfISOWeek(date)
                : endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = (0,react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = (0,react.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0,react.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (jsxRuntimeExports.jsx(FocusContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = (0,react.useContext)(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (jsxRuntimeExports.jsx(SelectSingleContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntimeExports.jsx(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (jsxRuntimeExports.jsx(SelectSingleContext.Provider, { value: contextValue, children: children }));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = (0,react.useContext)(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    (0,react.useEffect)(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (jsxRuntimeExports.jsx(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = (0,react.useRef)(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return jsxRuntimeExports.jsx("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return jsxRuntimeExports.jsx("div", __assign({}, dayRender.divProps));
    }
    return jsxRuntimeExports.jsx(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (jsxRuntimeExports.jsx("span", { className: classNames.weeknumber, style: styles.weeknumber, children: content }));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (jsxRuntimeExports.jsx(Button, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick, children: content }));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (jsxRuntimeExports.jsx("td", { className: classNames.cell, style: styles.cell, children: jsxRuntimeExports.jsx(WeeknumberComponent, { number: props.weekNumber, dates: props.dates }) }));
    }
    return (jsxRuntimeExports.jsxs("tr", { className: classNames.row, style: styles.row, children: [weekNumberCell, props.dates.map(function (date) { return (jsxRuntimeExports.jsx("td", { className: classNames.cell, style: styles.cell, role: "presentation", children: jsxRuntimeExports.jsx(DayComponent, { displayMonth: props.displayMonth, date: date }) }, getUnixTime(date))); })] }));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? endOfISOWeek(toDate)
        : endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? (0,startOfISOWeek/* startOfISOWeek */.T)(fromDate)
        : (0,startOfWeek/* startOfWeek */.z)(fromDate, options);
    var nOfDays = (0,date_fns_differenceInCalendarDays/* differenceInCalendarDays */.w)(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push((0,addDays/* addDays */.E)(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? (0,getISOWeek/* getISOWeek */.l)(date)
            : (0,getWeek/* getWeek */.Q)(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (jsxRuntimeExports.jsxs("table", { id: props.id, className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'], children: [!hideHead && jsxRuntimeExports.jsx(HeadComponent, {}), jsxRuntimeExports.jsx("tbody", { className: classNames.tbody, style: styles.tbody, children: weeks.map(function (week) { return (jsxRuntimeExports.jsx(RowComponent, { displayMonth: props.displayMonth, dates: week.dates, weekNumber: week.weekNumber }, week.weekNumber)); }) }), jsxRuntimeExports.jsx(FooterComponent, { displayMonth: props.displayMonth })] }));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM() ? react.useLayoutEffect : react.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = (0,react.useState)(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id
        ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex)
        : undefined;
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (jsxRuntimeExports.jsxs("div", { className: className.join(' '), style: style, children: [jsxRuntimeExports.jsx(CaptionComponent, { id: captionId, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntimeExports.jsx(Table, { id: tableId, "aria-labelledby": captionId, displayMonth: props.displayMonth })] }, props.displayIndex));
}

/**
 * Render the wrapper for the month grids.
 */
function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (jsxRuntimeExports.jsx("div", { className: classNames.months, style: styles.months, children: props.children }));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _d = (0,react.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0,react.useEffect)(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id, nonce: initialProps.nonce, title: initialProps.title, lang: initialProps.lang }, dataAttributes, { children: jsxRuntimeExports.jsx(MonthsComponent, { children: navigation.displayMonths.map(function (month, i) { return (jsxRuntimeExports.jsx(Month, { displayIndex: i, displayMonth: month }, i)); }) }) })));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (jsxRuntimeExports.jsx(DayPickerProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(NavigationProvider, { children: jsxRuntimeExports.jsx(SelectSingleProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(SelectMultipleProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(SelectRangeProvider, { initialProps: initialProps, children: jsxRuntimeExports.jsx(ModifiersProvider, { children: jsxRuntimeExports.jsx(FocusProvider, { children: children }) }) }) }) }) }) }));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function DayPicker(props) {
    return (jsxRuntimeExports.jsx(RootProvider, __assign({}, props, { children: jsxRuntimeExports.jsx(Root, { initialProps: props }) })));
}

/** @private */
function isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale = _a === void 0 ? enUS : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return parse(value, format$1, today, { locale: locale }); };
    // Initialize states
    var _e = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? format(defaultSelected, format$1, { locale: locale })
        : '';
    var _g = useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? format(date, format$1, { locale: locale }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? format(day, format$1, { locale: locale }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && differenceInCalendarDays(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: format(new Date(), format$1, { locale: locale })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 8435:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 6866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 8570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(6866);
} else {}


/***/ }),

/***/ 6883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S1": function() { return /* binding */ off; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; },
/* harmony export */   "on": function() { return /* binding */ on; }
/* harmony export */ });
/* unused harmony export isNavigator */
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';


/***/ }),

/***/ 6182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ }),

/***/ 6917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6883);


var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia = function (query, defaultState) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addEventListener('change', onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [query]);
    return state;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMedia);


/***/ }),

/***/ 3897:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);

  var nameValuePairStr = parts.shift();
  var parsed = parseNameValuePair(nameValuePairStr);
  var name = parsed.name;
  var value = parsed.value;

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name,
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parseNameValuePair(nameValuePairStr) {
  // Parses name-value-pair according to rfc6265bis draft

  var name = "";
  var value = "";
  var nameValueArr = nameValuePairStr.split("=");
  if (nameValueArr.length > 1) {
    name = nameValueArr.shift();
    value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
  } else {
    value = nameValuePairStr;
  }

  return { name: name, value: value };
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 5965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IntlError": function() { return /* reexport */ IntlError; },
  "IntlErrorCode": function() { return /* reexport */ IntlErrorCode; },
  "IntlProvider": function() { return /* reexport */ IntlProvider; },
  "createFormatter": function() { return /* reexport */ createFormatter; },
  "createIntl": function() { return /* reexport */ createIntl; },
  "createTranslator": function() { return /* reexport */ createTranslator; },
  "useFormatter": function() { return /* reexport */ useFormatter; },
  "useIntl": function() { return /* reexport */ useIntl; },
  "useLocale": function() { return /* reexport */ useLocale; },
  "useMessages": function() { return /* reexport */ useMessages; },
  "useNow": function() { return /* reexport */ useNow; },
  "useTimeZone": function() { return /* reexport */ useTimeZone; },
  "useTranslations": function() { return /* reexport */ useTranslations; }
});

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/_virtual/use-intl.esm.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}


//# sourceMappingURL=use-intl.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm.js


var IntlErrorCode;
(function (IntlErrorCode) {
  IntlErrorCode["MISSING_MESSAGE"] = "MISSING_MESSAGE";
  IntlErrorCode["MISSING_FORMAT"] = "MISSING_FORMAT";
  IntlErrorCode["ENVIRONMENT_FALLBACK"] = "ENVIRONMENT_FALLBACK";
  IntlErrorCode["INSUFFICIENT_PATH"] = "INSUFFICIENT_PATH";
  IntlErrorCode["INVALID_MESSAGE"] = "INVALID_MESSAGE";
  IntlErrorCode["INVALID_KEY"] = "INVALID_KEY";
  IntlErrorCode["FORMATTING_ERROR"] = "FORMATTING_ERROR";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(IntlError, _Error);
  function IntlError(code, originalMessage) {
    var _this;
    var message = code;
    if (originalMessage) {
      message += ': ' + originalMessage;
    }
    _this = _Error.call(this, message) || this;
    _this.code = void 0;
    _this.originalMessage = void 0;
    _this.code = code;
    if (originalMessage) {
      _this.originalMessage = originalMessage;
    }
    return _this;
  }
  return IntlError;
}( /*#__PURE__*/_wrapNativeSuper(Error));


//# sourceMappingURL=use-intl.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/intl-messageformat/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_es6_extendStatics = function(d, b) {
    tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_es6_extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_es6_createBinding(o, m, p);
}

function tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_es6_await(v) {
    return this instanceof tslib_es6_await ? (this.v = v, this) : new tslib_es6_await(v);
}

function tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_es6_createBinding(result, mod, k);
    tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-skeleton-parser/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_tslib_es6_extendStatics = function(d, b) {
    tslib_tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_tslib_es6_extendStatics(d, b);
};

function tslib_tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_tslib_es6_assign = function() {
    tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_tslib_es6_assign.apply(this, arguments);
}

function tslib_tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_tslib_es6_createBinding(o, m, p);
}

function tslib_tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_tslib_es6_await(v) {
    return this instanceof tslib_tslib_es6_await ? (this.v = v, this) : new tslib_tslib_es6_await(v);
}

function tslib_tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_tslib_es6_values === "function" ? tslib_tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_tslib_es6_createBinding(result, mod, k);
    tslib_tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = tslib_tslib_es6_assign(tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = tslib_tslib_es6_assign(tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = tslib_tslib_es6_assign(tslib_tslib_es6_assign({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, tslib_es6_assign({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ../../node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = tslib_es6_assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}


;// CONCATENATED MODULE: ../../node_modules/@formatjs/fast-memoize/lib/index.js
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

;// CONCATENATED MODULE: ../../node_modules/intl-messageformat/lib/src/error.js

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    __extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    __extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    __extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));


;// CONCATENATED MODULE: ../../node_modules/intl-messageformat/lib/src/formatters.js


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

;// CONCATENATED MODULE: ../../node_modules/intl-messageformat/lib/src/core.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, __assign({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: _this.resolvedLocale.toString(),
        }); };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());


;// CONCATENATED MODULE: ../../node_modules/intl-messageformat/lib/index.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




/* harmony default export */ var lib = (IntlMessageFormat);

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm10.js



function setTimeZoneInFormats(formats, timeZone) {
  if (!formats) return formats;
  // The only way to set a time zone with `intl-messageformat` is to merge it into the formats
  // https://github.com/formatjs/formatjs/blob/8256c5271505cf2606e48e3c97ecdd16ede4f1b5/packages/intl/src/message.ts#L15
  return Object.keys(formats).reduce(function (acc, key) {
    acc[key] = _extends({
      timeZone: timeZone
    }, formats[key]);
    return acc;
  }, {});
}
/**
 * `intl-messageformat` uses separate keys for `date` and `time`, but there's
 * only one native API: `Intl.DateTimeFormat`. Additionally you might want to
 * include both a time and a date in a value, therefore the separation doesn't
 * seem so useful. We offer a single `dateTime` namespace instead, but we have
 * to convert the format before `intl-messageformat` can be used.
 */
function convertFormatsToIntlMessageFormat(formats, timeZone) {
  var formatsWithTimeZone = timeZone ? _extends({}, formats, {
    dateTime: setTimeZoneInFormats(formats.dateTime, timeZone)
  }) : formats;
  var mfDateDefaults = lib.formats.date;
  var defaultDateFormats = timeZone ? setTimeZoneInFormats(mfDateDefaults, timeZone) : mfDateDefaults;
  var mfTimeDefaults = lib.formats.time;
  var defaultTimeFormats = timeZone ? setTimeZoneInFormats(mfTimeDefaults, timeZone) : mfTimeDefaults;
  return _extends({}, formatsWithTimeZone, {
    date: _extends({}, defaultDateFormats, formatsWithTimeZone == null ? void 0 : formatsWithTimeZone.dateTime),
    time: _extends({}, defaultTimeFormats, formatsWithTimeZone == null ? void 0 : formatsWithTimeZone.dateTime)
  });
}


//# sourceMappingURL=use-intl.esm10.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm6.js
/**
 * Contains defaults that are used for all entry points into the core.
 * See also `InitializedIntlConfiguration`.
 */
function defaultGetMessageFallback(props) {
  return [props.namespace, props.key].filter(function (part) {
    return part != null;
  }).join('.');
}
function defaultOnError(error) {
  console.error(error);
}


//# sourceMappingURL=use-intl.esm6.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm7.js







function resolvePath(messages, key, namespace) {
  if (!messages) {
    throw new Error( false ? 0 : undefined);
  }
  var message = messages;
  key.split('.').forEach(function (part) {
    var next = message[part];
    if (part == null || next == null) {
      throw new Error( false ? 0 : undefined);
    }
    message = next;
  });
  return message;
}
function prepareTranslationValues(values) {
  if (Object.keys(values).length === 0) return undefined;
  // Workaround for https://github.com/formatjs/formatjs/issues/1467
  var transformedValues = {};
  Object.keys(values).forEach(function (key) {
    var index = 0;
    var value = values[key];
    var transformed;
    if (typeof value === 'function') {
      transformed = function transformed(chunks) {
        var result = value(chunks);
        return (0,react.isValidElement)(result) ? (0,react.cloneElement)(result, {
          key: key + index++
        }) : result;
      };
    } else {
      transformed = value;
    }
    transformedValues[key] = transformed;
  });
  return transformedValues;
}
function getMessagesOrError(_ref) {
  var messages = _ref.messages,
    namespace = _ref.namespace,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? defaultOnError : _ref$onError;
  try {
    if (!messages) {
      throw new Error( false ? 0 : undefined);
    }
    var retrievedMessages = namespace ? resolvePath(messages, namespace) : messages;
    if (!retrievedMessages) {
      throw new Error( false ? 0 : undefined);
    }
    return retrievedMessages;
  } catch (error) {
    var intlError = new IntlError(IntlErrorCode.MISSING_MESSAGE, error.message);
    onError(intlError);
    return intlError;
  }
}
function getPlainMessage(candidate, values) {
  if (values) return undefined;
  var unescapedMessage = candidate.replace(/'([{}])/gi, '$1');
  // Placeholders can be in the message if there are default values,
  // or if the user has forgotten to provide values. In the latter
  // case we need to compile the message to receive an error.
  var hasPlaceholders = /<|{/.test(unescapedMessage);
  if (!hasPlaceholders) {
    return unescapedMessage;
  }
  return undefined;
}
function createBaseTranslator(_ref2) {
  var defaultTranslationValues = _ref2.defaultTranslationValues,
    globalFormats = _ref2.formats,
    _ref2$getMessageFallb = _ref2.getMessageFallback,
    getMessageFallback = _ref2$getMessageFallb === void 0 ? defaultGetMessageFallback : _ref2$getMessageFallb,
    locale = _ref2.locale,
    messageFormatCache = _ref2.messageFormatCache,
    messagesOrError = _ref2.messagesOrError,
    namespace = _ref2.namespace,
    onError = _ref2.onError,
    timeZone = _ref2.timeZone;
  function getFallbackFromErrorAndNotify(key, code, message) {
    var error = new IntlError(code, message);
    onError(error);
    return getMessageFallback({
      error: error,
      key: key,
      namespace: namespace
    });
  }
  function translateBaseFn( /** Use a dot to indicate a level of nesting (e.g. `namespace.nestedLabel`). */
  key, /** Key value pairs for values to interpolate into the message. */
  values, /** Provide custom formats for numbers, dates and times. */
  formats) {
    if (messagesOrError instanceof IntlError) {
      // We have already warned about this during render
      return getMessageFallback({
        error: messagesOrError,
        key: key,
        namespace: namespace
      });
    }
    var messages = messagesOrError;
    var message;
    try {
      message = resolvePath(messages, key, namespace);
    } catch (error) {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.MISSING_MESSAGE, error.message);
    }
    function joinPath(parts) {
      return parts.filter(function (part) {
        return part != null;
      }).join('.');
    }
    var cacheKey = joinPath([locale, namespace, key, String(message)]);
    var messageFormat;
    if (messageFormatCache != null && messageFormatCache.has(cacheKey)) {
      messageFormat = messageFormatCache.get(cacheKey);
    } else {
      if (typeof message === 'object') {
        var code, errorMessage;
        if (Array.isArray(message)) {
          code = IntlErrorCode.INVALID_MESSAGE;
          if (false) {}
        } else {
          code = IntlErrorCode.INSUFFICIENT_PATH;
          if (false) {}
        }
        return getFallbackFromErrorAndNotify(key, code, errorMessage);
      }
      // Hot path that avoids creating an `IntlMessageFormat` instance
      var plainMessage = getPlainMessage(message, values);
      if (plainMessage) return plainMessage;
      try {
        messageFormat = new lib(message, locale, convertFormatsToIntlMessageFormat(_extends({}, globalFormats, formats), timeZone));
      } catch (error) {
        return getFallbackFromErrorAndNotify(key, IntlErrorCode.INVALID_MESSAGE, error.message);
      }
      messageFormatCache == null || messageFormatCache.set(cacheKey, messageFormat);
    }
    try {
      var formattedMessage = messageFormat.format(
      // @ts-ignore `intl-messageformat` expects a different format
      // for rich text elements since a recent minor update. This
      // needs to be evaluated in detail, possibly also in regards
      // to be able to format to parts.
      prepareTranslationValues(_extends({}, defaultTranslationValues, values)));
      if (formattedMessage == null) {
        throw new Error( false ? 0 : undefined);
      }
      // Limit the function signature to return strings or React elements
      return (0,react.isValidElement)(formattedMessage) ||
      // Arrays of React elements
      Array.isArray(formattedMessage) || typeof formattedMessage === 'string' ? formattedMessage : String(formattedMessage);
    } catch (error) {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.FORMATTING_ERROR, error.message);
    }
  }
  function translateFn( /** Use a dot to indicate a level of nesting (e.g. `namespace.nestedLabel`). */
  key, /** Key value pairs for values to interpolate into the message. */
  values, /** Provide custom formats for numbers, dates and times. */
  formats) {
    var result = translateBaseFn(key, values, formats);
    if (typeof result !== 'string') {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.INVALID_MESSAGE,  false ? 0 : undefined);
    }
    return result;
  }
  translateFn.rich = translateBaseFn;
  translateFn.raw = function ( /** Use a dot to indicate a level of nesting (e.g. `namespace.nestedLabel`). */
  key) {
    if (messagesOrError instanceof IntlError) {
      // We have already warned about this during render
      return getMessageFallback({
        error: messagesOrError,
        key: key,
        namespace: namespace
      });
    }
    var messages = messagesOrError;
    try {
      return resolvePath(messages, key, namespace);
    } catch (error) {
      return getFallbackFromErrorAndNotify(key, IntlErrorCode.MISSING_MESSAGE, error.message);
    }
  };
  return translateFn;
}


//# sourceMappingURL=use-intl.esm7.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm8.js
/**
 * For the strictly typed messages to work we have to wrap the namespace into
 * a mandatory prefix. See https://stackoverflow.com/a/71529575/343045
 */
function resolveNamespace(namespace, namespacePrefix) {
  return namespace === namespacePrefix ? undefined : namespace.slice((namespacePrefix + '.').length);
}


//# sourceMappingURL=use-intl.esm8.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm5.js





var _excluded = ["getMessageFallback", "messages", "namespace", "onError"];
function createTranslatorImpl(_ref, namespacePrefix) {
  var getMessageFallback = _ref.getMessageFallback,
    messages = _ref.messages,
    namespace = _ref.namespace,
    onError = _ref.onError,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  // The `namespacePrefix` is part of the type system.
  // See the comment in the function invocation.
  messages = messages[namespacePrefix];
  namespace = resolveNamespace(namespace, namespacePrefix);
  var translator = createBaseTranslator(_extends({}, rest, {
    onError: onError,
    getMessageFallback: getMessageFallback,
    messagesOrError: getMessagesOrError({
      messages: messages,
      namespace: namespace,
      onError: onError
    })
  }));
  var originalRich = translator.rich;
  function base() {
    return translator.apply(void 0, arguments);
  }
  // Augment `t.rich` to return plain strings
  base.rich = function (key, /** Key value pairs for values to interpolate into the message. */
  values, formats) {
    // `chunks` is returned as a string when no React element
    // is used, therefore it's safe to cast this type.
    var result = originalRich(key, values, formats);
    // When only string chunks are provided to the parser, only strings should be returned here.
    if (typeof result !== 'string') {
      var error = new IntlError(IntlErrorCode.FORMATTING_ERROR,  false ? 0 : undefined);
      onError(error);
      return getMessageFallback({
        error: error,
        key: key,
        namespace: namespace
      });
    }
    return result;
  };
  base.raw = translator.raw;
  return base;
}


//# sourceMappingURL=use-intl.esm5.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm2.js




var use_intl_esm2_excluded = ["getMessageFallback", "messages", "namespace", "onError"];
/**
 * Translates messages from the given namespace by using the ICU syntax.
 * See https://formatjs.io/docs/core-concepts/icu-syntax.
 *
 * If no namespace is provided, all available messages are returned.
 * The namespace can also indicate nesting by using a dot
 * (e.g. `namespace.Component`).
 */
function createTranslator(_ref) {
  var _ref$getMessageFallba = _ref.getMessageFallback,
    getMessageFallback = _ref$getMessageFallba === void 0 ? defaultGetMessageFallback : _ref$getMessageFallba,
    messages = _ref.messages,
    namespace = _ref.namespace,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? defaultOnError : _ref$onError,
    rest = _objectWithoutPropertiesLoose(_ref, use_intl_esm2_excluded);
  // We have to wrap the actual function so the type inference for the optional
  // namespace works correctly. See https://stackoverflow.com/a/71529575/343045
  // The prefix ("!") is arbitrary.
  return createTranslatorImpl(_extends({}, rest, {
    onError: onError,
    getMessageFallback: getMessageFallback,
    messages: {
      '!': messages
    },
    namespace: namespace ? "!." + namespace : '!'
  }), '!');
}


//# sourceMappingURL=use-intl.esm2.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm3.js




var SECOND = 1;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var WEEK = DAY * 7;
var MONTH = DAY * (365 / 12); // Approximation
var QUARTER = MONTH * 3;
var YEAR = DAY * 365;
var UNIT_SECONDS = {
  second: SECOND,
  seconds: SECOND,
  minute: MINUTE,
  minutes: MINUTE,
  hour: HOUR,
  hours: HOUR,
  day: DAY,
  days: DAY,
  week: WEEK,
  weeks: WEEK,
  month: MONTH,
  months: MONTH,
  quarter: QUARTER,
  quarters: QUARTER,
  year: YEAR,
  years: YEAR
};
function resolveRelativeTimeUnit(seconds) {
  var absValue = Math.abs(seconds);
  if (absValue < MINUTE) {
    return 'second';
  } else if (absValue < HOUR) {
    return 'minute';
  } else if (absValue < DAY) {
    return 'hour';
  } else if (absValue < WEEK) {
    return 'day';
  } else if (absValue < MONTH) {
    return 'week';
  } else if (absValue < YEAR) {
    return 'month';
  }
  return 'year';
}
function calculateRelativeTimeValue(seconds, unit) {
  // We have to round the resulting values, as `Intl.RelativeTimeFormat`
  // will include fractions like '2.1 hours ago'.
  return Math.round(seconds / UNIT_SECONDS[unit]);
}
function createFormatter(_ref) {
  var formats = _ref.formats,
    locale = _ref.locale,
    globalNow = _ref.now,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? defaultOnError : _ref$onError,
    globalTimeZone = _ref.timeZone;
  function resolveFormatOrOptions(typeFormats, formatOrOptions) {
    var options;
    if (typeof formatOrOptions === 'string') {
      var formatName = formatOrOptions;
      options = typeFormats == null ? void 0 : typeFormats[formatName];
      if (!options) {
        var error = new IntlError(IntlErrorCode.MISSING_FORMAT,  false ? 0 : undefined);
        onError(error);
        throw error;
      }
    } else {
      options = formatOrOptions;
    }
    return options;
  }
  function getFormattedValue(value, formatOrOptions, typeFormats, formatter) {
    var options;
    try {
      options = resolveFormatOrOptions(typeFormats, formatOrOptions);
    } catch (error) {
      return String(value);
    }
    try {
      return formatter(options);
    } catch (error) {
      onError(new IntlError(IntlErrorCode.FORMATTING_ERROR, error.message));
      return String(value);
    }
  }
  function dateTime( /** If a number is supplied, this is interpreted as a UTC timestamp. */
  value,
  /** If a time zone is supplied, the `value` is converted to that time zone.
   * Otherwise the user time zone will be used. */
  formatOrOptions) {
    return getFormattedValue(value, formatOrOptions, formats == null ? void 0 : formats.dateTime, function (options) {
      var _options;
      if (!((_options = options) != null && _options.timeZone)) {
        if (globalTimeZone) {
          options = _extends({}, options, {
            timeZone: globalTimeZone
          });
        } else {
          onError(new IntlError(IntlErrorCode.ENVIRONMENT_FALLBACK,  false ? 0 : undefined));
        }
      }
      return new Intl.DateTimeFormat(locale, options).format(value);
    });
  }
  function number(value, formatOrOptions) {
    return getFormattedValue(value, formatOrOptions, formats == null ? void 0 : formats.number, function (options) {
      return new Intl.NumberFormat(locale, options).format(value);
    });
  }
  function getGlobalNow() {
    if (globalNow) {
      return globalNow;
    } else {
      onError(new IntlError(IntlErrorCode.ENVIRONMENT_FALLBACK,  false ? 0 : undefined));
      return new Date();
    }
  }
  function extractNowDate(nowOrOptions) {
    if (nowOrOptions instanceof Date || typeof nowOrOptions === 'number') {
      return new Date(nowOrOptions);
    }
    if ((nowOrOptions == null ? void 0 : nowOrOptions.now) !== undefined) {
      return new Date(nowOrOptions.now);
    }
    return getGlobalNow();
  }
  function relativeTime( /** The date time that needs to be formatted. */
  date, /** The reference point in time to which `date` will be formatted in relation to.  */
  nowOrOptions) {
    try {
      var dateDate = new Date(date);
      var nowDate = extractNowDate(nowOrOptions);
      var seconds = (dateDate.getTime() - nowDate.getTime()) / 1000;
      var unit = typeof nowOrOptions === 'number' || nowOrOptions instanceof Date || (nowOrOptions == null ? void 0 : nowOrOptions.unit) === undefined ? resolveRelativeTimeUnit(seconds) : nowOrOptions.unit;
      var value = calculateRelativeTimeValue(seconds, unit);
      return new Intl.RelativeTimeFormat(locale, {
        numeric: 'auto'
      }).format(value, unit);
    } catch (error) {
      onError(new IntlError(IntlErrorCode.FORMATTING_ERROR, error.message));
      return String(date);
    }
  }
  function list(value, formatOrOptions) {
    return getFormattedValue(value, formatOrOptions, formats == null ? void 0 : formats.list, function (options) {
      return new Intl.ListFormat(locale, options).format(value);
    });
  }
  return {
    dateTime: dateTime,
    number: number,
    relativeTime: relativeTime,
    list: list
  };
}


//# sourceMappingURL=use-intl.esm3.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/core/use-intl.esm4.js


/** @deprecated Switch to `createFormatter` */
function createIntl() {
  var formatter = createFormatter.apply(void 0, arguments);
  return {
    formatDateTime: formatter.dateTime,
    formatNumber: formatter.number,
    formatRelativeTime: formatter.relativeTime
  };
}


//# sourceMappingURL=use-intl.esm4.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm9.js


var IntlContext = /*#__PURE__*/(0,react.createContext)(undefined);


//# sourceMappingURL=use-intl.esm9.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm10.js




var use_intl_esm10_excluded = ["getMessageFallback", "messages", "onError"];
/**
 * Enhances the incoming props with defaults.
 */
function getInitializedConfig(_ref) {
  var getMessageFallback = _ref.getMessageFallback,
    messages = _ref.messages,
    onError = _ref.onError,
    rest = _objectWithoutPropertiesLoose(_ref, use_intl_esm10_excluded);
  var finalOnError = onError || defaultOnError;
  var finalGetMessageFallback = getMessageFallback || defaultGetMessageFallback;
  if (false) {}
  return _extends({}, rest, {
    messages: messages,
    onError: finalOnError,
    getMessageFallback: finalGetMessageFallback
  });
}


//# sourceMappingURL=use-intl.esm10.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm.js





var use_intl_esm_excluded = ["children"];
function IntlProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, use_intl_esm_excluded);
  var _useState = (0,react.useState)(function () {
      return new Map();
    }),
    messageFormatCache = _useState[0];
  return react.createElement(IntlContext.Provider, {
    value: _extends({}, getInitializedConfig(props), {
      messageFormatCache: messageFormatCache
    })
  }, children);
}


//# sourceMappingURL=use-intl.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm11.js



function useIntlContext() {
  var context = (0,react.useContext)(IntlContext);
  if (!context) {
    throw new Error( false ? 0 : undefined);
  }
  return context;
}


//# sourceMappingURL=use-intl.esm11.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm12.js





function useTranslationsImpl(allMessages, namespace, namespacePrefix) {
  var _useIntlContext = useIntlContext(),
    defaultTranslationValues = _useIntlContext.defaultTranslationValues,
    globalFormats = _useIntlContext.formats,
    getMessageFallback = _useIntlContext.getMessageFallback,
    locale = _useIntlContext.locale,
    messageFormatCache = _useIntlContext.messageFormatCache,
    onError = _useIntlContext.onError,
    timeZone = _useIntlContext.timeZone;
  // The `namespacePrefix` is part of the type system.
  // See the comment in the hook invocation.
  allMessages = allMessages[namespacePrefix];
  namespace = resolveNamespace(namespace, namespacePrefix);
  var messagesOrError = (0,react.useMemo)(function () {
    return getMessagesOrError({
      messages: allMessages,
      namespace: namespace,
      onError: onError
    });
  }, [allMessages, namespace, onError]);
  var translate = (0,react.useMemo)(function () {
    return createBaseTranslator({
      messageFormatCache: messageFormatCache,
      getMessageFallback: getMessageFallback,
      messagesOrError: messagesOrError,
      defaultTranslationValues: defaultTranslationValues,
      namespace: namespace,
      onError: onError,
      formats: globalFormats,
      locale: locale,
      timeZone: timeZone
    });
  }, [messageFormatCache, getMessageFallback, messagesOrError, defaultTranslationValues, namespace, onError, globalFormats, locale, timeZone]);
  return translate;
}


//# sourceMappingURL=use-intl.esm12.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm2.js



/**
 * Translates messages from the given namespace by using the ICU syntax.
 * See https://formatjs.io/docs/core-concepts/icu-syntax.
 *
 * If no namespace is provided, all available messages are returned.
 * The namespace can also indicate nesting by using a dot
 * (e.g. `namespace.Component`).
 */
function useTranslations(namespace) {
  var context = useIntlContext();
  var messages = context.messages;
  // We have to wrap the actual hook so the type inference for the optional
  // namespace works correctly. See https://stackoverflow.com/a/71529575/343045
  // The prefix ("!") is arbitrary.
  return useTranslationsImpl({
    '!': messages
  },
  // @ts-expect-error
  namespace ? "!." + namespace : '!', '!');
}


//# sourceMappingURL=use-intl.esm2.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm3.js


function useLocale() {
  return useIntlContext().locale;
}


//# sourceMappingURL=use-intl.esm3.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm4.js



function getNow() {
  return new Date();
}
/**
 * Reading the current date via `new Date()` in components should be avoided, as
 * it causes components to be impure and can lead to flaky tests. Instead, this
 * hook can be used.
 *
 * By default, it returns the time when the component mounts. If `updateInterval`
 * is specified, the value will be updated based on the interval.
 *
 * You can however also return a static value from this hook, if you
 * configure the `now` parameter on the context provider. Note however,
 * that if `updateInterval` is configured in this case, the component
 * will initialize with the global value, but will afterwards update
 * continuously based on the interval.
 *
 * For unit tests, this can be mocked to a constant value. For end-to-end
 * testing, an environment parameter can be passed to the `now` parameter
 * of the provider to mock this to a static value.
 */
function useNow(options) {
  var updateInterval = options == null ? void 0 : options.updateInterval;
  var _useIntlContext = useIntlContext(),
    globalNow = _useIntlContext.now;
  var _useState = (0,react.useState)(globalNow || getNow()),
    now = _useState[0],
    setNow = _useState[1];
  (0,react.useEffect)(function () {
    if (!updateInterval) return;
    var intervalId = setInterval(function () {
      setNow(getNow());
    }, updateInterval);
    return function () {
      clearInterval(intervalId);
    };
  }, [globalNow, updateInterval]);
  return now;
}


//# sourceMappingURL=use-intl.esm4.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm5.js


function useTimeZone() {
  return useIntlContext().timeZone;
}


//# sourceMappingURL=use-intl.esm5.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm6.js


function useMessages() {
  return useIntlContext().messages;
}


//# sourceMappingURL=use-intl.esm6.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm7.js




function useFormatter() {
  var _useIntlContext = useIntlContext(),
    formats = _useIntlContext.formats,
    locale = _useIntlContext.locale,
    globalNow = _useIntlContext.now,
    onError = _useIntlContext.onError,
    timeZone = _useIntlContext.timeZone;
  return (0,react.useMemo)(function () {
    return createFormatter({
      formats: formats,
      locale: locale,
      now: globalNow,
      onError: onError,
      timeZone: timeZone
    });
  }, [formats, globalNow, locale, onError, timeZone]);
}


//# sourceMappingURL=use-intl.esm7.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/react/use-intl.esm8.js




var hasWarned = false;
/** @deprecated Switch to `useFormatter` instead. */
function useIntl() {
  var _useIntlContext = useIntlContext(),
    formats = _useIntlContext.formats,
    locale = _useIntlContext.locale,
    globalNow = _useIntlContext.now,
    onError = _useIntlContext.onError,
    timeZone = _useIntlContext.timeZone;
  if (!hasWarned) {
    hasWarned = true;
    console.warn('`useIntl()` is deprecated and will be removed in the next major version. Please switch to `useFormatter()`.');
  }
  return (0,react.useMemo)(function () {
    return createIntl({
      formats: formats,
      locale: locale,
      now: globalNow,
      onError: onError,
      timeZone: timeZone
    });
  }, [formats, globalNow, locale, onError, timeZone]);
}


//# sourceMappingURL=use-intl.esm8.js.map

;// CONCATENATED MODULE: ../../node_modules/use-intl/dist/use-intl.esm.js












//# sourceMappingURL=use-intl.esm.js.map


/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 9108:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ o; }
/* harmony export */ });
var o=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(o||{});


/***/ }),

/***/ 5577:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ te; },
/* harmony export */   "k": function() { return /* binding */ ee; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8316);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5559);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8064);
/* harmony import */ var _hooks_use_on_unmount_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1385);
/* harmony import */ var _hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(592);
/* harmony import */ var _hooks_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6460);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3401);
/* harmony import */ var _internal_portal_force_root_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6137);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4727);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9206);
function F(p){let n=(0,_internal_portal_force_root_js__WEBPACK_IMPORTED_MODULE_2__/* .usePortalRoot */ .n)(),l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_),e=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)(p),[a,o]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{if(!n&&l!==null||_utils_env_js__WEBPACK_IMPORTED_MODULE_4__/* .env.isServer */ .O.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r)});return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{a!==null&&(e!=null&&e.body.contains(a)||e==null||e.body.appendChild(a))},[a,e]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n||l!==null&&o(l.current)},[l,o,n]),a}let U=react__WEBPACK_IMPORTED_MODULE_0__.Fragment;function N(p,n){let l=p,e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__/* .useSyncRefs */ .T)((0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__/* .optionalRef */ .h)(u=>{e.current=u}),n),o=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)(e),t=F(e),[r]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{var u;return _utils_env_js__WEBPACK_IMPORTED_MODULE_4__/* .env.isServer */ .O.isServer?null:(u=o==null?void 0:o.createElement("div"))!=null?u:null}),i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(f),v=(0,_hooks_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_6__/* .useServerHandoffComplete */ .H)();return (0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>{!t||!r||t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r))},[t,r]),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>{if(r&&i)return i.register(r)},[i,r]),(0,_hooks_use_on_unmount_js__WEBPACK_IMPORTED_MODULE_8__/* .useOnUnmount */ .L)(()=>{var u;!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((u=t.parentElement)==null||u.removeChild(t)))}),v?!t||!r?null:(0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)((0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .render */ .sY)({ourProps:{ref:a},theirProps:l,defaultTag:U,name:"Portal"}),r):null}let S=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,_=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);function j(p,n){let{target:l,...e}=p,o={ref:(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__/* .useSyncRefs */ .T)(n)};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_.Provider,{value:l},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .render */ .sY)({ourProps:o,theirProps:e,defaultTag:S,name:"Popover.Group"}))}let f=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);function ee(){let p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(f),n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]),l=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_10__/* .useEvent */ .z)(o=>(n.current.push(o),p&&p.register(o),()=>e(o))),e=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_10__/* .useEvent */ .z)(o=>{let t=n.current.indexOf(o);t!==-1&&n.current.splice(t,1),p&&p.unregister(o)}),a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({register:l,unregister:e,portals:n}),[l,e,n]);return[n,(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function({children:t}){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(f.Provider,{value:a},t)},[a])]}let D=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .forwardRefWithAs */ .yV)(N),I=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .forwardRefWithAs */ .yV)(j),te=Object.assign(D,{Group:I});


/***/ }),

/***/ 9410:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1742);
function E(n,e,a,t){let i=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(a);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}


/***/ }),

/***/ 5559:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1742);
let o=function(t){let e=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(t);return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...r)=>e.current(...r),[e])};


/***/ }),

/***/ 586:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ I; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4727);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8064);
/* harmony import */ var _use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6460);
var o;let I=(o=react__WEBPACK_IMPORTED_MODULE_0__.useId)!=null?o:function(){let n=(0,_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_1__/* .useServerHandoffComplete */ .H)(),[e,u]=react__WEBPACK_IMPORTED_MODULE_0__.useState(n?()=>_utils_env_js__WEBPACK_IMPORTED_MODULE_2__/* .env.nextId */ .O.nextId():null);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .useIsoMorphicEffect */ .e)(()=>{e===null&&u(_utils_env_js__WEBPACK_IMPORTED_MODULE_2__/* .env.nextId */ .O.nextId())},[e]),e!=null?""+e:void 0};


/***/ }),

/***/ 8064:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4727);
let l=(e,f)=>{_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.isServer */ .O.isServer?(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(e,f):(0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(e,f)};


/***/ }),

/***/ 1742:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8064);
function s(e){let r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{r.current=e},[e]),r}


/***/ }),

/***/ 1385:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_micro_task_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1554);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5559);
function c(t){let r=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(t),e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(e.current=!1,()=>{e.current=!0,(0,_utils_micro_task_js__WEBPACK_IMPORTED_MODULE_2__/* .microTask */ .Y)(()=>{e.current&&r()})}),[r])}


/***/ }),

/***/ 2994:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ y; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(2929);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/platform.js
var platform = __webpack_require__(5371);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(1742);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-document-event.js
function d(e,r,n){let o=(0,use_latest_value/* useLatestValue */.E)(r);(0,react.useEffect)(()=>{function t(u){o.current(u)}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n)},[e,n])}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-window-event.js
var use_window_event = __webpack_require__(6902);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/hooks/use-outside-click.js
function y(s,m,a=!0){let i=(0,react.useRef)(!1);(0,react.useEffect)(()=>{requestAnimationFrame(()=>{i.current=a})},[a]);function c(e,r){if(!i.current||e.defaultPrevented)return;let t=r(e);if(t===null||!t.getRootNode().contains(t)||!t.isConnected)return;let E=function u(n){return typeof n=="function"?u(n()):Array.isArray(n)||n instanceof Set?n:[n]}(s);for(let u of E){if(u===null)continue;let n=u instanceof HTMLElement?u:u.current;if(n!=null&&n.contains(t)||e.composed&&e.composedPath().includes(n))return}return!(0,focus_management/* isFocusableElement */.sP)(t,focus_management/* FocusableMode.Loose */.tJ.Loose)&&t.tabIndex!==-1&&e.preventDefault(),m(e,t)}let o=(0,react.useRef)(null);d("pointerdown",e=>{var r,t;i.current&&(o.current=((t=(r=e.composedPath)==null?void 0:r.call(e))==null?void 0:t[0])||e.target)},!0),d("mousedown",e=>{var r,t;i.current&&(o.current=((t=(r=e.composedPath)==null?void 0:r.call(e))==null?void 0:t[0])||e.target)},!0),d("click",e=>{(0,platform/* isMobile */.tq)()||o.current&&(c(e,()=>o.current),o.current=null)},!0),d("touchend",e=>c(e,()=>e.target instanceof HTMLElement?e.target:null),!0),(0,use_window_event/* useWindowEvent */.s)("blur",e=>c(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0)}


/***/ }),

/***/ 592:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9833);
function n(...e){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_1__/* .getOwnerDocument */ .r)(...e),[...e])}


/***/ }),

/***/ 1638:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ y; },
/* harmony export */   "v": function() { return /* binding */ N; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6799);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5559);
/* harmony import */ var _use_owner_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(592);
function N({defaultContainers:o=[],portals:r,mainTreeNodeRef:u}={}){var f;let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((f=u==null?void 0:u.current)!=null?f:null),l=(0,_use_owner_js__WEBPACK_IMPORTED_MODULE_1__/* .useOwnerDocument */ .i)(t),c=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_2__/* .useEvent */ .z)(()=>{var i,s,a;let n=[];for(let e of o)e!==null&&(e instanceof HTMLElement?n.push(e):"current"in e&&e.current instanceof HTMLElement&&n.push(e.current));if(r!=null&&r.current)for(let e of r.current)n.push(e);for(let e of(i=l==null?void 0:l.querySelectorAll("html > *, body > *"))!=null?i:[])e!==document.body&&e!==document.head&&e instanceof HTMLElement&&e.id!=="headlessui-portal-root"&&(e.contains(t.current)||e.contains((a=(s=t.current)==null?void 0:s.getRootNode())==null?void 0:a.host)||n.some(L=>e.contains(L))||n.push(e));return n});return{resolveContainers:c,contains:(0,_use_event_js__WEBPACK_IMPORTED_MODULE_2__/* .useEvent */ .z)(n=>c().some(i=>i.contains(n))),mainTreeNodeRef:t,MainTreeNode:(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function(){return u!=null?null:react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__/* .Hidden */ ._,{features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__/* .Features.Hidden */ .A.Hidden,ref:t})},[t,u])}}function y(){let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);return{mainTreeNodeRef:o,MainTreeNode:(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__/* .Hidden */ ._,{features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__/* .Features.Hidden */ .A.Hidden,ref:o})},[o])}}


/***/ }),

/***/ 6460:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4727);
function s(){let r=typeof document=="undefined";return true?(o=>o.useSyncExternalStore)(/*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2))))(()=>()=>{},()=>!1,()=>!r):!1}function l(){let r=s(),[e,n]=react__WEBPACK_IMPORTED_MODULE_0__.useState(_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.isHandoffComplete */ .O.isHandoffComplete);return e&&_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.isHandoffComplete */ .O.isHandoffComplete===!1&&n(!1),react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{e!==!0&&n(!0)},[e]),react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.handoff */ .O.handoff(),[]),r?!1:e}


/***/ }),

/***/ 3401:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ y; },
/* harmony export */   "h": function() { return /* binding */ T; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5559);
let u=Symbol();function T(t,n=!0){return Object.assign(t,{[u]:n})}function y(...t){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n.current=t},[t]);let c=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e)});return t.every(e=>e==null||(e==null?void 0:e[u]))?void 0:c}


/***/ }),

/***/ 859:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ s; },
/* harmony export */   "l": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6902);
var s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(s||{});function n(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}


/***/ }),

/***/ 6902:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1742);
function s(e,r,n){let o=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(r);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{function t(i){o.current(i)}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n])}


/***/ }),

/***/ 6799:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ s; },
/* harmony export */   "_": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9206);
let p="div";var s=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(s||{});function l(d,o){var n;let{features:t=1,...e}=d,r={ref:o,"aria-hidden":(t&2)===2?!0:(n=e["aria-hidden"])!=null?n:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(t&4)===4&&(t&2)!==2&&{display:"none"}}};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .render */ .sY)({ourProps:r,theirProps:e,slot:{},defaultTag:p,name:"Hidden"})}let f=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .forwardRefWithAs */ .yV)(l);


/***/ }),

/***/ 7215:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZM": function() { return /* binding */ d; },
/* harmony export */   "oJ": function() { return /* binding */ u; },
/* harmony export */   "up": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);n.displayName="OpenClosedContext";var d=(e=>(e[e.Open=1]="Open",e[e.Closed=2]="Closed",e[e.Closing=4]="Closing",e[e.Opening=8]="Opening",e))(d||{});function u(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(n)}function s({value:o,children:r}){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(n.Provider,{value:o},r)}


/***/ }),

/***/ 6137:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ l; },
/* harmony export */   "n": function() { return /* binding */ a; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(!1);function a(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(e)}function l(o){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Provider,{value:o.force},o.children)}


/***/ }),

/***/ 5426:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ r; }
/* harmony export */ });
function r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&i(l)?!1:t}function i(n){if(!n)return!1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return!1;e=e.previousElementSibling}return!0}


/***/ }),

/***/ 4727:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ s; }
/* harmony export */ });
var i=Object.defineProperty;var d=(t,e,n)=>e in t?i(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n;var r=(t,e,n)=>(d(t,typeof e!="symbol"?e+"":e,n),n);class o{constructor(){r(this,"current",this.detect());r(this,"handoffState","pending");r(this,"currentId",0)}set(e){this.current!==e&&(this.handoffState="pending",this.currentId=0,this.current=e)}reset(){this.set(this.detect())}nextId(){return++this.currentId}get isServer(){return this.current==="server"}get isClient(){return this.current==="client"}detect(){return typeof window=="undefined"||typeof document=="undefined"?"server":"client"}handoff(){this.handoffState==="pending"&&(this.handoffState="complete")}get isHandoffComplete(){return this.handoffState==="complete"}}let s=new o;


/***/ }),

/***/ 2929:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ y; },
/* harmony export */   "GO": function() { return /* binding */ f; },
/* harmony export */   "TO": function() { return /* binding */ M; },
/* harmony export */   "fE": function() { return /* binding */ N; },
/* harmony export */   "jA": function() { return /* binding */ O; },
/* harmony export */   "sP": function() { return /* binding */ h; },
/* harmony export */   "tJ": function() { return /* binding */ T; }
/* harmony export */ });
/* unused harmony exports focusFrom, restoreFocusIfNecessary, sortByDomNode */
/* harmony import */ var _match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3703);
/* harmony import */ var _owner_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9833);
let c=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var M=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(M||{}),N=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(N||{}),F=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(F||{});function f(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(c)).sort((r,t)=>Math.sign((r.tabIndex||Number.MAX_SAFE_INTEGER)-(t.tabIndex||Number.MAX_SAFE_INTEGER)))}var T=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(T||{});function h(e,r=0){var t;return e===((t=(0,_owner_js__WEBPACK_IMPORTED_MODULE_0__/* .getOwnerDocument */ .r)(e))==null?void 0:t.body)?!1:(0,_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(r,{[0](){return e.matches(c)},[1](){let l=e;for(;l!==null;){if(l.matches(c))return!0;l=l.parentElement}return!1}})}function D(e){let r=m(e);b().nextFrame(()=>{r&&!h(r.activeElement,0)&&y(e)})}var w=(t=>(t[t.Keyboard=0]="Keyboard",t[t.Mouse=1]="Mouse",t))(w||{});typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("keydown",e=>{e.metaKey||e.altKey||e.ctrlKey||(document.documentElement.dataset.headlessuiFocusVisible="")},!0),document.addEventListener("click",e=>{e.detail===1?delete document.documentElement.dataset.headlessuiFocusVisible:e.detail===0&&(document.documentElement.dataset.headlessuiFocusVisible="")},!0));function y(e){e==null||e.focus({preventScroll:!0})}let S=["textarea","input"].join(",");function H(e){var r,t;return(t=(r=e==null?void 0:e.matches)==null?void 0:r.call(e,S))!=null?t:!1}function I(e,r=t=>t){return e.slice().sort((t,l)=>{let o=r(t),i=r(l);if(o===null||i===null)return 0;let n=o.compareDocumentPosition(i);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function _(e,r){return O(f(),r,{relativeTo:e})}function O(e,r,{sorted:t=!0,relativeTo:l=null,skipElements:o=[]}={}){let i=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,n=Array.isArray(e)?t?I(e):e:f(e);o.length>0&&n.length>1&&(n=n.filter(s=>!o.includes(s))),l=l!=null?l:i.activeElement;let E=(()=>{if(r&5)return 1;if(r&10)return-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),x=(()=>{if(r&1)return 0;if(r&2)return Math.max(0,n.indexOf(l))-1;if(r&4)return Math.max(0,n.indexOf(l))+1;if(r&8)return n.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),p=r&32?{preventScroll:!0}:{},d=0,a=n.length,u;do{if(d>=a||d+a<=0)return 0;let s=x+d;if(r&16)s=(s+a)%a;else{if(s<0)return 3;if(s>=a)return 1}u=n[s],u==null||u.focus(p),d+=E}while(u!==i.activeElement);return r&6&&H(u)&&u.select(),2}


/***/ }),

/***/ 3703:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ u; }
/* harmony export */ });
function u(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,u),t}


/***/ }),

/***/ 1554:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ t; }
/* harmony export */ });
function t(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}))}


/***/ }),

/***/ 9833:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4727);
function o(r){return _env_js__WEBPACK_IMPORTED_MODULE_0__/* .env.isServer */ .O.isServer?null:r instanceof Node?r.ownerDocument:r!=null&&r.hasOwnProperty("current")&&r.current instanceof Node?r.current.ownerDocument:document}


/***/ }),

/***/ 5371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gn": function() { return /* binding */ t; },
/* harmony export */   "tq": function() { return /* binding */ n; }
/* harmony export */ });
/* unused harmony export isAndroid */
function t(){return/iPhone/gi.test(window.navigator.platform)||/Mac/gi.test(window.navigator.platform)&&window.navigator.maxTouchPoints>0}function i(){return/Android/gi.test(window.navigator.userAgent)}function n(){return t()||i()}


/***/ }),

/***/ 9206:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AN": function() { return /* binding */ O; },
  "yV": function() { return /* binding */ U; },
  "sY": function() { return /* binding */ C; },
  "Y2": function() { return /* binding */ I; }
});

// UNUSED EXPORTS: RenderStrategy, compact

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/class-names.js
function class_names_t(...r){return Array.from(new Set(r.flatMap(n=>typeof n=="string"?n.split(" "):[]))).filter(Boolean).join(" ")}

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(3703);
;// CONCATENATED MODULE: ../../node_modules/@headlessui/react/dist/utils/render.js
var O=(n=>(n[n.None=0]="None",n[n.RenderStrategy=1]="RenderStrategy",n[n.Static=2]="Static",n))(O||{}),v=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(v||{});function C({ourProps:r,theirProps:t,slot:e,defaultTag:n,features:o,visible:a=!0,name:f,mergeRefs:l}){l=l!=null?l:k;let s=R(t,r);if(a)return m(s,e,n,f,l);let y=o!=null?o:0;if(y&2){let{static:u=!1,...d}=s;if(u)return m(d,e,n,f,l)}if(y&1){let{unmount:u=!0,...d}=s;return (0,match/* match */.E)(u?0:1,{[0](){return null},[1](){return m({...d,hidden:!0,style:{display:"none"}},e,n,f,l)}})}return m(s,e,n,f,l)}function m(r,t={},e,n,o){let{as:a=e,children:f,refName:l="ref",...s}=F(r,["unmount","static"]),y=r.ref!==void 0?{[l]:r.ref}:{},u=typeof f=="function"?f(t):f;"className"in s&&s.className&&typeof s.className=="function"&&(s.className=s.className(t));let d={};if(t){let i=!1,c=[];for(let[T,p]of Object.entries(t))typeof p=="boolean"&&(i=!0),p===!0&&c.push(T);i&&(d["data-headlessui-state"]=c.join(" "))}if(a===react.Fragment&&Object.keys(x(s)).length>0){if(!(0,react.isValidElement)(u)||Array.isArray(u)&&u.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${n} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(s).map(p=>`  - ${p}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(p=>`  - ${p}`).join(`
`)].join(`
`));let i=u.props,c=typeof(i==null?void 0:i.className)=="function"?(...p)=>class_names_t(i==null?void 0:i.className(...p),s.className):class_names_t(i==null?void 0:i.className,s.className),T=c?{className:c}:{};return (0,react.cloneElement)(u,Object.assign({},R(u.props,x(F(s,["ref"]))),d,y,{ref:o(u.ref,y.ref)},T))}return (0,react.createElement)(a,Object.assign({},F(s,["ref"]),a!==react.Fragment&&y,a!==react.Fragment&&d),u)}function I(){let r=(0,react.useRef)([]),t=(0,react.useCallback)(e=>{for(let n of r.current)n!=null&&(typeof n=="function"?n(e):n.current=e)},[]);return(...e)=>{if(!e.every(n=>n==null))return r.current=e,t}}function k(...r){return r.every(t=>t==null)?void 0:t=>{for(let e of r)e!=null&&(typeof e=="function"?e(t):e.current=t)}}function R(...r){var n;if(r.length===0)return{};if(r.length===1)return r[0];let t={},e={};for(let o of r)for(let a in o)a.startsWith("on")&&typeof o[a]=="function"?((n=e[a])!=null||(e[a]=[]),e[a].push(o[a])):t[a]=o[a];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(o=>[o,void 0])));for(let o in e)Object.assign(t,{[o](a,...f){let l=e[o];for(let s of l){if((a instanceof Event||(a==null?void 0:a.nativeEvent)instanceof Event)&&a.defaultPrevented)return;s(a,...f)}}});return t}function U(r){var t;return Object.assign((0,react.forwardRef)(r),{displayName:(t=r.displayName)!=null?t:r.name})}function x(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function F(r,t=[]){let e=Object.assign({},r);for(let n of t)n in e&&delete e[n];return e}


/***/ }),

/***/ 630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 8788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 581:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 6270:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(1899);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 7842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 4297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 3579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 6670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 6297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 6383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(5459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 2228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 1899:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 5459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 613:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IZ": function() { return /* binding */ isAxiosError; },
/* harmony export */   "d7": function() { return /* binding */ AxiosError; }
/* harmony export */ });
/* unused harmony exports Axios, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig */
/* harmony import */ var _lib_axios_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(162);


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = _lib_axios_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;




/***/ }),

/***/ 162:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

// NAMESPACE OBJECT: ../../node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; }
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(8834)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ../../node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/env/data.js
const VERSION = "1.6.8";
;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../../node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';

        if (!err.stack) {
          err.stack = stack;
          // match without the 2 top stack lines
        } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
          err.stack += '\n' + stack
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../../node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../../node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 8935:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ addLeadingZeros; }
/* harmony export */ });
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}


/***/ }),

/***/ 3066:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
let defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}

function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


/***/ }),

/***/ 7796:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}


/***/ }),

/***/ 8016:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);
/* harmony import */ var _constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5873);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  if (isNaN(amount)) return (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__/* .constructFrom */ .L)(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (addDays)));


/***/ }),

/***/ 7617:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);
/* harmony import */ var _constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5873);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  if (isNaN(amount)) return (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__/* .constructFrom */ .L)(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__/* .constructFrom */ .L)(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (addMonths)));


/***/ }),

/***/ 1418:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dP": function() { return /* binding */ millisecondsInDay; },
/* harmony export */   "jE": function() { return /* binding */ millisecondsInWeek; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, millisecondsInSecond, minutesInYear, minutesInMonth, minutesInDay, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
const daysInWeek = 7;

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = 365.2425;

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "./constants/date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "./constants/date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
const minTime = -maxTime;

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = 3600000;

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = 1000;

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
const minutesInYear = 525600;

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
const minutesInMonth = 43200;

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
const minutesInDay = 1440;

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
const minutesInHour = 60;

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
const monthsInQuarter = 3;

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
const monthsInYear = 12;

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
const quartersInYear = 4;

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = 3600;

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
const secondsInMinute = 60;

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = secondsInHour * 24;

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
const secondsInWeek = secondsInDay * 7;

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = secondsInDay * daysInYear;

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = secondsInYear / 12;

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
const secondsInQuarter = secondsInMonth * 3;


/***/ }),

/***/ 5873:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ constructFrom; }
/* harmony export */ });
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (constructFrom)));


/***/ }),

/***/ 9219:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1418);
/* harmony import */ var _startOfDay_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8106);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7796);




/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = (0,_startOfDay_mjs__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b)(dateLeft);
  const startOfDayRight = (0,_startOfDay_mjs__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b)(dateRight);

  const timestampLeft =
    +startOfDayLeft - (0,_lib_getTimezoneOffsetInMilliseconds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getTimezoneOffsetInMilliseconds */ .D)(startOfDayLeft);
  const timestampRight =
    +startOfDayRight - (0,_lib_getTimezoneOffsetInMilliseconds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getTimezoneOffsetInMilliseconds */ .D)(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / _constants_mjs__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInDay */ .dP);
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (differenceInCalendarDays)));


/***/ }),

/***/ 6569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WU": function() { return /* binding */ format; }
});

// UNUSED EXPORTS: default, formatDate, formatters, longFormatters

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/en-US.mjs + 5 modules
var en_US = __webpack_require__(6198);
// EXTERNAL MODULE: ../../node_modules/date-fns/_lib/defaultOptions.mjs
var _lib_defaultOptions = __webpack_require__(3066);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInCalendarDays.mjs
var differenceInCalendarDays = __webpack_require__(9219);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfYear.mjs
var startOfYear = __webpack_require__(2978);
// EXTERNAL MODULE: ../../node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(729);
;// CONCATENATED MODULE: ../../node_modules/date-fns/getDayOfYear.mjs




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = (0,differenceInCalendarDays/* differenceInCalendarDays */.w)(_date, (0,startOfYear/* startOfYear */.e)(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getDayOfYear = ((/* unused pure expression or super */ null && (getDayOfYear)));

// EXTERNAL MODULE: ../../node_modules/date-fns/getISOWeek.mjs + 1 modules
var getISOWeek = __webpack_require__(8105);
// EXTERNAL MODULE: ../../node_modules/date-fns/getISOWeekYear.mjs
var getISOWeekYear = __webpack_require__(9449);
// EXTERNAL MODULE: ../../node_modules/date-fns/getWeek.mjs + 1 modules
var getWeek = __webpack_require__(8766);
// EXTERNAL MODULE: ../../node_modules/date-fns/getWeekYear.mjs
var getWeekYear = __webpack_require__(3361);
// EXTERNAL MODULE: ../../node_modules/date-fns/_lib/addLeadingZeros.mjs
var addLeadingZeros = __webpack_require__(8935);
;// CONCATENATED MODULE: ../../node_modules/date-fns/_lib/format/lightFormatters.mjs


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0,addLeadingZeros/* addLeadingZeros */.r)(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : (0,addLeadingZeros/* addLeadingZeros */.r)(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return (0,addLeadingZeros/* addLeadingZeros */.r)(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return (0,addLeadingZeros/* addLeadingZeros */.r)(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return (0,addLeadingZeros/* addLeadingZeros */.r)(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return (0,addLeadingZeros/* addLeadingZeros */.r)(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return (0,addLeadingZeros/* addLeadingZeros */.r)(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return (0,addLeadingZeros/* addLeadingZeros */.r)(fractionalSeconds, token.length);
  },
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/_lib/format/formatters.mjs








const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = (0,getWeekYear/* getWeekYear */.c)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return (0,addLeadingZeros/* addLeadingZeros */.r)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return (0,addLeadingZeros/* addLeadingZeros */.r)(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = (0,getISOWeekYear/* getISOWeekYear */.L)(date);

    // Padding
    return (0,addLeadingZeros/* addLeadingZeros */.r)(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return (0,addLeadingZeros/* addLeadingZeros */.r)(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return (0,addLeadingZeros/* addLeadingZeros */.r)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return (0,addLeadingZeros/* addLeadingZeros */.r)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return (0,addLeadingZeros/* addLeadingZeros */.r)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = (0,getWeek/* getWeek */.Q)(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return (0,addLeadingZeros/* addLeadingZeros */.r)(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = (0,getISOWeek/* getISOWeek */.l)(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return (0,addLeadingZeros/* addLeadingZeros */.r)(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return (0,addLeadingZeros/* addLeadingZeros */.r)(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return (0,addLeadingZeros/* addLeadingZeros */.r)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return (0,addLeadingZeros/* addLeadingZeros */.r)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return (0,addLeadingZeros/* addLeadingZeros */.r)(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0,addLeadingZeros/* addLeadingZeros */.r)(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0,addLeadingZeros/* addLeadingZeros */.r)(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return (0,addLeadingZeros/* addLeadingZeros */.r)(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return (0,addLeadingZeros/* addLeadingZeros */.r)(timestamp, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + (0,addLeadingZeros/* addLeadingZeros */.r)(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + (0,addLeadingZeros/* addLeadingZeros */.r)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = (0,addLeadingZeros/* addLeadingZeros */.r)(Math.trunc(absOffset / 60), 2);
  const minutes = (0,addLeadingZeros/* addLeadingZeros */.r)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

;// CONCATENATED MODULE: ../../node_modules/date-fns/_lib/format/longFormatters.mjs
const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/_lib/protectedTokens.mjs
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// EXTERNAL MODULE: ../../node_modules/date-fns/isDate.mjs
var isDate = __webpack_require__(5890);
;// CONCATENATED MODULE: ../../node_modules/date-fns/isValid.mjs



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!(0,isDate/* isDate */.J)(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0,toDate/* toDate */.Q)(date);
  return !isNaN(Number(_date));
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isValid = ((/* unused pure expression or super */ null && (isValid)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/format.mjs








// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874


// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;



/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const locale = options?.locale ?? defaultOptions.locale ?? en_US/* enUS */._;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = (0,toDate/* toDate */.Q)(date);

  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          isProtectedWeekYearToken(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_format = ((/* unused pure expression or super */ null && (format)));


/***/ }),

/***/ 8105:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ getISOWeek; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/date-fns/constants.mjs
var constants = __webpack_require__(1418);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfISOWeek.mjs
var startOfISOWeek = __webpack_require__(9001);
// EXTERNAL MODULE: ../../node_modules/date-fns/getISOWeekYear.mjs
var getISOWeekYear = __webpack_require__(9449);
// EXTERNAL MODULE: ../../node_modules/date-fns/constructFrom.mjs
var constructFrom = __webpack_require__(5873);
;// CONCATENATED MODULE: ../../node_modules/date-fns/startOfISOWeekYear.mjs




/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = (0,getISOWeekYear/* getISOWeekYear */.L)(date);
  const fourthOfJanuary = (0,constructFrom/* constructFrom */.L)(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return (0,startOfISOWeek/* startOfISOWeek */.T)(fourthOfJanuary);
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfISOWeekYear = ((/* unused pure expression or super */ null && (startOfISOWeekYear)));

// EXTERNAL MODULE: ../../node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(729);
;// CONCATENATED MODULE: ../../node_modules/date-fns/getISOWeek.mjs





/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = +(0,startOfISOWeek/* startOfISOWeek */.T)(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / constants/* millisecondsInWeek */.jE) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getISOWeek = ((/* unused pure expression or super */ null && (getISOWeek)));


/***/ }),

/***/ 9449:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5873);
/* harmony import */ var _startOfISOWeek_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9001);
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);




/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__/* .constructFrom */ .L)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0,_startOfISOWeek_mjs__WEBPACK_IMPORTED_MODULE_2__/* .startOfISOWeek */ .T)(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__/* .constructFrom */ .L)(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0,_startOfISOWeek_mjs__WEBPACK_IMPORTED_MODULE_2__/* .startOfISOWeek */ .T)(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getISOWeekYear)));


/***/ }),

/***/ 8766:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ getWeek; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/date-fns/constants.mjs
var constants = __webpack_require__(1418);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfWeek.mjs
var startOfWeek = __webpack_require__(2014);
// EXTERNAL MODULE: ../../node_modules/date-fns/constructFrom.mjs
var constructFrom = __webpack_require__(5873);
// EXTERNAL MODULE: ../../node_modules/date-fns/getWeekYear.mjs
var getWeekYear = __webpack_require__(3361);
// EXTERNAL MODULE: ../../node_modules/date-fns/_lib/defaultOptions.mjs
var _lib_defaultOptions = __webpack_require__(3066);
;// CONCATENATED MODULE: ../../node_modules/date-fns/startOfWeekYear.mjs





/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = (0,getWeekYear/* getWeekYear */.c)(date, options);
  const firstWeek = (0,constructFrom/* constructFrom */.L)(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = (0,startOfWeek/* startOfWeek */.z)(firstWeek, options);
  return _date;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_startOfWeekYear = ((/* unused pure expression or super */ null && (startOfWeekYear)));

// EXTERNAL MODULE: ../../node_modules/date-fns/toDate.mjs
var toDate = __webpack_require__(729);
;// CONCATENATED MODULE: ../../node_modules/date-fns/getWeek.mjs





/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = (0,toDate/* toDate */.Q)(date);
  const diff = +(0,startOfWeek/* startOfWeek */.z)(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / constants/* millisecondsInWeek */.jE) + 1;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_getWeek = ((/* unused pure expression or super */ null && (getWeek)));


/***/ }),

/***/ 3361:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getWeekYear; }
/* harmony export */ });
/* harmony import */ var _constructFrom_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5873);
/* harmony import */ var _startOfWeek_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2014);
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);
/* harmony import */ var _lib_defaultOptions_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3066);





/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const year = _date.getFullYear();

  const defaultOptions = (0,_lib_defaultOptions_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_2__/* .constructFrom */ .L)(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0,_startOfWeek_mjs__WEBPACK_IMPORTED_MODULE_3__/* .startOfWeek */ .z)(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_2__/* .constructFrom */ .L)(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0,_startOfWeek_mjs__WEBPACK_IMPORTED_MODULE_3__/* .startOfWeek */ .z)(firstWeekOfThisYear, options);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getWeekYear)));


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const _dateToCompare = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (isAfter)));


/***/ }),

/***/ 1502:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isBefore; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const _dateToCompare = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(dateToCompare);
  return +_date < +_dateToCompare;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (isBefore)));


/***/ }),

/***/ 5890:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ isDate; }
/* harmony export */ });
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (isDate)));


/***/ }),

/***/ 2456:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ buildFormatLongFn; }
/* harmony export */ });
function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}


/***/ }),

/***/ 8056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ buildLocalizeFn; }
/* harmony export */ });
/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}


/***/ }),

/***/ 7894:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ buildMatchFn; }
/* harmony export */ });
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}


/***/ }),

/***/ 1685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ buildMatchPatternFn; }
/* harmony export */ });
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}


/***/ }),

/***/ 1466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "de": function() { return /* binding */ de; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/de/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden",
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden",
    },
  },

  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden",
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden",
    },
  },

  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute",
  },

  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten",
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten",
    },
  },

  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten",
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten",
    },
  },

  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden",
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden",
    },
  },

  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden",
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden",
    },
  },

  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage",
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen",
    },
  },

  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen",
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen",
    },
  },

  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen",
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen",
    },
  },

  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate",
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten",
    },
  },

  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate",
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten",
    },
  },

  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre",
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren",
    },
  },

  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre",
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren",
    },
  },

  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre",
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren",
    },
  },

  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre",
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren",
    },
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = options?.addSuffix
    ? formatDistanceLocale[token].withPreposition
    : formatDistanceLocale[token].standalone;
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return "vor " + result;
    }
  }

  return result;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(2456);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/de/_lib/formatLong.mjs


// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const dateFormats = {
  full: "EEEE, do MMMM y", // Montag, 7. Januar 2018
  long: "do MMMM y", // 7. Januar 2018
  medium: "do MMM y", // 7. Jan. 2018
  short: "dd.MM.y", // 07.01.2018
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/de/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(8056);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/de/_lib/localize.mjs


const eraValues = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"],
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],

  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const formattingMonthValues = {
  narrow: monthValues.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez.",
  ],

  wide: monthValues.wide,
};

const dayValues = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const dayPeriodValues = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
};
const formattingDayPeriodValues = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
};

const ordinalNumber = (dirtyNumber) => {
  const number = Number(dirtyNumber);

  return number + ".";
};

const localize = {
  ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    formattingValues: formattingMonthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(7894);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(1685);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/de/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i,
};
const parseEraPatterns = {
  any: [/^v/i, /^n/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i,
};
const parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated:
    /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i, // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i, // will never be matched. Night is matched by `pm`
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value),
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/de.mjs






/**
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Asia [@asia-t](https://github.com/asia-t)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author RomanErnst [@pex](https://github.com/pex)
 * @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
 */
const de = {
  code: "de",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var locale_de = ((/* unused pure expression or super */ null && (de)));


/***/ }),

/***/ 6198:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ enUS; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/en-US/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(2456);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/en-US/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/en-US/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(8056);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/en-US/_lib/localize.mjs


const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize = {
  ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(7894);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(1685);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/en-US/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/en-US.mjs






/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var en_US = ((/* unused pure expression or super */ null && (enUS)));


/***/ }),

/***/ 596:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "es": function() { return /* binding */ es; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/es/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos",
  },

  halfAMinute: "medio minuto",

  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos",
  },

  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} horas",
  },

  xDays: {
    one: "1 día",
    other: "{{count}} días",
  },

  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas",
  },

  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas",
  },

  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses",
  },

  xMonths: {
    one: "1 mes",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años",
  },

  xYears: {
    one: "1 año",
    other: "{{count}} años",
  },

  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años",
  },

  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result;
    } else {
      return "hace " + result;
    }
  }

  return result;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(2456);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/es/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/es/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P",
};

const formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P",
};

const formatRelative = (token, date, _baseDate, _options) => {
  if (date.getHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return formatRelativeLocale[token];
  }
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(8056);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/es/_lib/localize.mjs


const eraValues = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ],

  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
};

const dayValues = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "º";
};

const localize = {
  ordinalNumber: ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(1685);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(7894);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/es/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i,
};
const parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i,
  ],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i,
};
const parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i,
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/es.mjs






/**
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto](https://github.com/juanangosto)
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Fernando Agüero [@fjaguero](https://github.com/fjaguero)
 * @author Gastón Haro [@harogaston](https://github.com/harogaston)
 * @author Yago Carballo [@YagoCarballo](https://github.com/YagoCarballo)
 */
const es = {
  code: "es",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var locale_es = ((/* unused pure expression or super */ null && (es)));


/***/ }),

/***/ 3005:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fr": function() { return /* binding */ fr; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/fr/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes",
  },

  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes",
  },

  halfAMinute: "30 secondes",

  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures",
  },

  xHours: {
    one: "1 heure",
    other: "{{count}} heures",
  },

  xDays: {
    one: "1 jour",
    other: "{{count}} jours",
  },

  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines",
  },

  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines",
  },

  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois",
  },

  xMonths: {
    one: "1 mois",
    other: "{{count}} mois",
  },

  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans",
  },

  xYears: {
    one: "1 an",
    other: "{{count}} ans",
  },

  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans",
  },

  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans",
  },
};

const formatDistance = (token, count, options) => {
  let result;
  const form = formatDistanceLocale[token];
  if (typeof form === "string") {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dans " + result;
    } else {
      return "il y a " + result;
    }
  }

  return result;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(2456);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/fr/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/fr/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(8056);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/fr/_lib/localize.mjs


const eraValues = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"],
};

const quarterValues = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"],
};

const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc.",
  ],

  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ],
};

const dayValues = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],

  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat.",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin",
  },
};

const ordinalNumber = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;

  if (number === 0) return "0";

  const feminineUnits = ["year", "week", "hour", "minute", "second"];
  let suffix;

  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? "ère" : "er";
  } else {
    suffix = "ème";
  }

  return number + suffix;
};

const LONG_MONTHS_TOKENS = ["MMM", "MMMM"];

const localize = {
  preprocessor: (date, parts) => {
    // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
    // Use case "do MMMM" => 1er août, 29 août
    // see https://github.com/date-fns/date-fns/issues/1391

    if (date.getDate() === 1) return parts;

    const hasLongMonthToken = parts.some(
      (part) => part.isToken && LONG_MONTHS_TOKENS.includes(part.value),
    );

    if (!hasLongMonthToken) return parts;

    return parts.map((part) =>
      part.isToken && part.value === "do"
        ? { isToken: true, value: "d" }
        : part,
    );
  },

  ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(7894);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(1685);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/fr/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i,
};
const parseEraPatterns = {
  any: [/^av/i, /^ap/i],
};

const matchQuarterPatterns = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i,
};
const parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i,
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value),
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/fr.mjs






/**
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 */
const fr = {
  code: "fr",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var locale_fr = ((/* unused pure expression or super */ null && (fr)));


/***/ }),

/***/ 5455:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "it": function() { return /* binding */ it; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/it/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi",
  },

  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi",
  },

  halfAMinute: "alcuni secondi",

  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti",
  },

  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti",
  },

  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore",
  },

  xHours: {
    one: "un'ora",
    other: "{{count}} ore",
  },

  xDays: {
    one: "un giorno",
    other: "{{count}} giorni",
  },

  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane",
  },

  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane",
  },

  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi",
  },

  xMonths: {
    one: "un mese",
    other: "{{count}} mesi",
  },

  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni",
  },

  xYears: {
    one: "un anno",
    other: "{{count}} anni",
  },

  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni",
  },

  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "tra " + result;
    } else {
      return result + " fa";
    }
  }

  return result;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(2456);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/it/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/startOfWeek.mjs
var startOfWeek = __webpack_require__(2014);
;// CONCATENATED MODULE: ../../node_modules/date-fns/isSameWeek.mjs


/**
 * The {@link isSameWeek} function options.
 */

/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = (0,startOfWeek/* startOfWeek */.z)(dateLeft, options);
  const dateRightStartOfWeek = (0,startOfWeek/* startOfWeek */.z)(dateRight, options);

  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

// Fallback for modularized imports:
/* harmony default export */ var date_fns_isSameWeek = ((/* unused pure expression or super */ null && (isSameWeek)));

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/it/_lib/formatRelative.mjs


const weekdays = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato",
];

function lastWeek(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + weekdays[day] + " scorso alle' p";
  }
}

function thisWeek(day) {
  return "'" + weekdays[day] + " alle' p";
}

function nextWeek(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + weekdays[day] + " prossimo alle' p";
  }
}

const formatRelativeLocale = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if (isSameWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return lastWeek(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if (isSameWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return nextWeek(day);
    }
  },
  other: "P",
};

const formatRelative = (token, date, baseDate, options) => {
  const format = formatRelativeLocale[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(8056);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/it/_lib/localize.mjs


const eraValues = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic",
  ],

  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre",
  ],
};

const dayValues = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return String(number);
};

const localize = {
  ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(7894);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(1685);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/it/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i,
};
const parseEraPatterns = {
  any: [/^a/i, /^(d|e)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i,
};
const parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i],
};

const matchDayPeriodPatterns = {
  narrow:
    /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i,
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/it.mjs






/**
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo](https://github.com/albertorestifo)
 * @author Giovanni Polimeni [@giofilo](https://github.com/giofilo)
 * @author Vincenzo Carrese [@vin-car](https://github.com/vin-car)
 */
const it = {
  code: "it",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var locale_it = ((/* unused pure expression or super */ null && (it)));


/***/ }),

/***/ 5460:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nl": function() { return /* binding */ nl; }
});

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/nl/_lib/formatDistance.mjs
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden",
  },

  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden",
  },

  halfAMinute: "een halve minuut",

  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten",
  },

  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten",
  },

  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur",
  },

  xHours: {
    one: "1 uur",
    other: "{{count}} uur",
  },

  xDays: {
    one: "1 dag",
    other: "{{count}} dagen",
  },

  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weken",
  },

  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden",
  },

  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden",
  },

  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar",
  },

  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar",
  },

  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar",
  },

  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "over " + result;
    } else {
      return result + " geleden";
    }
  }

  return result;
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.mjs
var buildFormatLongFn = __webpack_require__(2456);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/nl/_lib/formatLong.mjs


const dateFormats = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y",
};

const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong = {
  date: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0,buildFormatLongFn/* buildFormatLongFn */.l)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/nl/_lib/formatRelative.mjs
const formatRelativeLocale = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.mjs
var buildLocalizeFn = __webpack_require__(8056);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/nl/_lib/localize.mjs


const eraValues = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"],
};

const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ],
};

const dayValues = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts",
  },
};

const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "e";
};

const localize = {
  ordinalNumber,

  era: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0,buildLocalizeFn/* buildLocalizeFn */.Y)({
    values: dayPeriodValues,
    defaultWidth: "wide",
  }),
};

// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchFn.mjs
var buildMatchFn = __webpack_require__(7894);
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.mjs
var buildMatchPatternFn = __webpack_require__(1685);
;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/nl/_lib/match.mjs



const matchOrdinalNumberPattern = /^(\d+)e?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/,
};
const parseEraPatterns = {
  any: [/^v/, /^n/],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i,
};
const parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i],
};

const matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i,
  },
};

const match = {
  ordinalNumber: (0,buildMatchPatternFn/* buildMatchPatternFn */.y)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0,buildMatchFn/* buildMatchFn */.t)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

;// CONCATENATED MODULE: ../../node_modules/date-fns/locale/nl.mjs






/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Edo Rivai [@edorivai](https://github.com/edorivai)
 * @author Niels Keurentjes [@curry684](https://github.com/curry684)
 * @author Stefan Vermaas [@stefanvermaas](https://github.com/stefanvermaas)
 */
const nl = {
  code: "nl",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
};

// Fallback for modularized imports:
/* harmony default export */ var locale_nl = ((/* unused pure expression or super */ null && (nl)));


/***/ }),

/***/ 5790:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1418);


/**
 * The {@link parseISO} function options.
 */

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);

  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const timestamp = date.getTime();
  let time = 0;
  let offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    // JS parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    const result = new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate(),
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}

const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};

const dateRegex =
  /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex =
  /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length,
      );
    }
  }

  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" +
      (4 + additionalDigits) +
      "})|(\\d{2}|[+-]\\d{" +
      (2 + additionalDigits) +
      "})$)",
  );

  const captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return { year: NaN, restDateString: "" };

  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);

  const captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);

  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (
      !validateDate(year, month, day) ||
      !validateDayOfYearDate(year, dayOfYear)
    ) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return (
    hours * _constants_mjs__WEBPACK_IMPORTED_MODULE_0__/* .millisecondsInHour */ .vh + minutes * _constants_mjs__WEBPACK_IMPORTED_MODULE_0__/* .millisecondsInMinute */ .yJ + seconds * 1000
  );
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(",", "."))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;

  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;

  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * _constants_mjs__WEBPACK_IMPORTED_MODULE_0__/* .millisecondsInHour */ .vh + minutes * _constants_mjs__WEBPACK_IMPORTED_MODULE_0__/* .millisecondsInMinute */ .yJ);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return (
    month >= 0 &&
    month <= 11 &&
    date >= 1 &&
    date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28))
  );
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return (
    seconds >= 0 &&
    seconds < 60 &&
    minutes >= 0 &&
    minutes < 60 &&
    hours >= 0 &&
    hours < 25
  );
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (parseISO)));


/***/ }),

/***/ 6930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ setHours; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);


/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(date, hours) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  _date.setHours(hours);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (setHours)));


/***/ }),

/***/ 5465:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ setMinutes; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);


/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(date, minutes) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  _date.setMinutes(minutes);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (setMinutes)));


/***/ }),

/***/ 8106:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (startOfDay)));


/***/ }),

/***/ 9001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ startOfISOWeek; }
/* harmony export */ });
/* harmony import */ var _startOfWeek_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2014);


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return (0,_startOfWeek_mjs__WEBPACK_IMPORTED_MODULE_0__/* .startOfWeek */ .z)(date, { weekStartsOn: 1 });
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (startOfISOWeek)));


/***/ }),

/***/ 2014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ startOfWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(729);
/* harmony import */ var _lib_defaultOptions_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3066);



/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = (0,_lib_defaultOptions_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultOptions */ .j)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_1__/* .toDate */ .Q)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (startOfWeek)));


/***/ }),

/***/ 2978:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ startOfYear; }
/* harmony export */ });
/* harmony import */ var _toDate_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(729);
/* harmony import */ var _constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5873);



/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = (0,_toDate_mjs__WEBPACK_IMPORTED_MODULE_0__/* .toDate */ .Q)(date);
  const _date = (0,_constructFrom_mjs__WEBPACK_IMPORTED_MODULE_1__/* .constructFrom */ .L)(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (startOfYear)));


/***/ }),

/***/ 729:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ toDate; }
/* harmony export */ });
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

// Fallback for modularized imports:
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (toDate)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6570), __webpack_exec__(3642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);